import VueCompositionApi, { defineComponent, computed, onMounted, onUnmounted, ref, h, nextTick, watch, reactive, onBeforeUnmount, onBeforeMount } from "@vue/composition-api";
import Vue from "vue";
const Alert = Object.freeze({
  Sizes: {
    DENSE: "dense",
    NORMAL: "normal",
    LARGE: "large"
  },
  Variants: {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    ERROR: "error",
    WARNING: "warning",
    ERROR_INVERTED: "error-inverted",
    WARNING_INVERTED: "warning-inverted"
  }
});
const LegacySizes = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  GIANT: "giant"
};
const Sizes$d = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  HUGE: "huge"
};
const LegacyVariants = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary",
  INVERTED_PRIMARY: "inverted-primary",
  INVERTED_SECONDARY: "inverted-secondary",
  INVERTED_TERTIARY: "inverted-tertiary",
  WHITE: "white"
};
const ButtonTypes = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary"
};
const Levels = {
  ONE: "1",
  TWO: "2",
  THREE: "3",
  FOUR: "4"
};
const Button = Object.freeze({
  Sizes: {
    ...LegacySizes,
    ...Sizes$d
  },
  Variants: LegacyVariants
});
const Form = Object.freeze({
  Variants: {
    STANDARD: "standard",
    RAISED: "raised"
  },
  Sizes: {
    DENSE: "dense",
    NORMAL: "normal",
    LARGE: "large"
  },
  LabelPositions: {
    LEFT: "left",
    RIGHT: "right"
  }
});
const InputMasks = Object.freeze({
  CURRENCY: {
    prefix: "$ ",
    numeral: true,
    numeralThousandsGroupStyle: "thousand",
    noImmediatePrefix: true
  },
  FEIN: {
    delimiters: ["-"],
    blocks: [2, 7],
    numericOnly: true
  },
  PHONE: {
    delimiters: ["(", ") ", "-"],
    blocks: [0, 3, 3, 4],
    numericOnly: true
  },
  YEAR: {
    blocks: [4],
    numericOnly: true
  },
  ZIP_CODE: {
    blocks: [5],
    numericOnly: true
  }
});
const Modal = Object.freeze({
  ActionAlignments: {
    CENTER: "center",
    JUSTIFY: "justify",
    RIGHT: "right"
  },
  Alerts: {
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error"
  },
  Headers: {
    TRANSPARENT: "transparent",
    PRIMARY: "primary",
    SECONDARY: "secondary",
    WARNING: "warning",
    ERROR: "error",
    PRIMARY_ORNATE: "primary-ornate",
    WARNING_ORNATE: "warning-ornate",
    ERROR_ORNATE: "error-ornate"
  },
  Overlays: {
    PRIMARY: "primary",
    DARK: "dark",
    LIGHT: "light"
  },
  Sizes: {
    TINY: "tiny",
    SMALL: "small",
    REGULAR: "regular",
    MEDIUM: "medium",
    LARGE: "large",
    GIANT: "giant"
  }
});
const Notification = Object.freeze({
  Positions: {
    BOTTOM_CENTER: "bottom-center",
    BOTTOM_RIGHT: "bottom-right",
    TOP_CENTER: "top-center",
    TOP_RIGHT: "top-right"
  },
  Variants: {
    DEFAULT: "default",
    SECONDARY: "secondary",
    ERROR: "error"
  }
});
const ProgressBar$1 = Object.freeze({
  Sizes: {
    SMALL: "small",
    LARGE: "large"
  },
  Variants: {
    PRIMARY: "primary",
    SECONDARY: "secondary"
  }
});
const Typography = Object.freeze({
  Body: {
    LEGAL: "legal",
    CAPTION: "caption",
    SMALL: "small",
    TEXT: "text",
    MEDIUM: "medium",
    LARGE: "large",
    TEXT_LARGE: "text-large",
    TEXT_LARGE_TIGHT: "text-large-tight",
    TEXT_MEDIUM: "text-medium",
    TEXT_MEDIUM_TIGHT: "text-medium-tight",
    TEXT_SMALL: "text-small",
    TEXT_SMALL_TIGHT: "text-small-tight",
    TEXT_X_SMALL: "text-x-small",
    TEXT_X_SMALL_TIGHT: "text-x-small-tight",
    TEXT_TINY: "text-tiny",
    TEXT_TINY_TIGHT: "text-tiny-tight",
    TEXT_X_TINY: "text-x-tiny",
    TEXT_X_TINY_TIGHT: "text-x-tiny-tight",
    LINK_LARGE: "link-large",
    LINK_LARGE_TIGHT: "link-large-tight",
    LINK_MEDIUM: "link-medium",
    LINK_MEDIUM_TIGHT: "link-medium-tight",
    LINK_SMALL: "link-small",
    LINK_SMALL_TIGHT: "link-small-tight",
    LINK_X_SMALL: "link-x-small",
    LINK_X_SMALL_TIGHT: "link-x-small-tight",
    LINK_TINY: "link-tiny",
    LINK_TINY_TIGHT: "link-tiny-tight",
    LINK_X_TINY: "link-x-tiny",
    LINK_X_TINY_TIGHT: "link-x-tiny-tight"
  },
  Overline: {
    LARGE: "large",
    LARGE_TIGHT: "large-tight",
    MEDIUM: "medium",
    MEDIUM_TIGHT: "medium-tight",
    SMALL: "small",
    SMALL_TIGHT: "small-tight",
    X_SMALL: "x-small",
    X_SMALL_TIGHT: "x-small-tight",
    TINY: "tiny",
    TINY_TIGHT: "tiny-tight",
    X_TINY: "x-tiny",
    X_TINY_TIGHT: "x-tiny-tight"
  },
  Heading: {
    SUBTITLE: "subtitle",
    TITLE: "title",
    HEADLINE: "headline"
  },
  Display: {
    MEGA: "mega",
    GIGA: "giga",
    TERA: "tera",
    PETA: "peta",
    GIANT: "giant",
    HUGE: "huge",
    LARGE: "large",
    MEDIUM: "medium",
    SMALL: "small",
    X_SMALL: "x-small",
    TINY: "tiny"
  },
  Weights: {
    REGULAR: "regular",
    MEDIUM: "medium",
    STRONG: "strong",
    VERY_STRONG: "very-strong"
  }
});
const pixelFonts = [
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  23,
  24,
  28,
  32,
  33,
  40,
  48,
  56,
  72
];
const fontSize = pixelFonts.reduce(
  (obj, val) => ({
    ...obj,
    [`${val}`]: `${val / 16}rem`
  }),
  {}
);
const spacingSizes = [
  0,
  0.5,
  1,
  1.5,
  2,
  3,
  4,
  5,
  6,
  8,
  10,
  12,
  14,
  16,
  18,
  20,
  22,
  24,
  26,
  28,
  30
];
const spacing = spacingSizes.reduce((acc, val) => {
  acc[`${val}`] = `${val / 4}rem`;
  return acc;
}, {});
const timingDurations = {
  0: "0",
  lazy: "640ms",
  light: "440ms",
  ridiculous: "240ms",
  ludicrous: "160ms"
};
const extendedPalette = {
  geyser: "#CDE0DF",
  tuberose: "#F7F2DC",
  gingerrr: "#FFAA00",
  rose: "#E25959",
  tangerine: "#BF4228",
  maroon: "#680021",
  puce: "#7E245C",
  inevitable: "#481D72",
  virginia: "#002855",
  mosaic: "#006880",
  eastern: "#1991A9",
  caribbean: "#16A7A7",
  evergreen: "#004851",
  premium: "#EEDDBD"
};
const primaryColors = {
  900: "#0E0722",
  800: "#1A0C37",
  700: "#28104C",
  600: "#3A1561",
  500: "#4E1976",
  400: "#8326B5",
  300: "#B44EDA",
  200: "#F68EE7",
  100: "#F0CDF4",
  50: "#FAF5FD"
};
const secondaryColors = {
  900: "#001B1B",
  800: "#003F3E",
  700: "#006361",
  600: "#008685",
  500: "#00AAA8",
  400: "#00F1EF",
  300: "#3AFFFD",
  200: "#81FFFE",
  100: "#C5FAF9",
  50: "#EAFFFF"
};
const warningColors = {
  900: "#1E0F00",
  800: "#562D00",
  700: "#8E4A00",
  600: "#C66700",
  500: "#FE8400",
  400: "#FF9F37",
  300: "#FFBA6F",
  200: "#FFDA7",
  100: "#FFF0DF",
  50: "#FFFDFB"
};
const errorColors = {
  900: "#1E0009",
  800: "#460015",
  700: "#6F0121",
  600: "#97012E",
  500: "#C0013A",
  400: "#FE0650",
  300: "#FE487E",
  200: "#FE8AAC",
  100: "#FFCBDB",
  50: "#FFECF2"
};
const baseColors = {
  900: "#14142b",
  800: "#262338",
  700: "#4e4b66",
  600: "#6e7191",
  500: "#A0A3bd",
  400: "#d9dbe9",
  300: "#Eff0f7",
  200: "#f7f7fc",
  100: "#fcfcfc"
};
var theme = {
  backgroundImage: {
    "purple-gradient": "linear-gradient(103.15deg, #6B4392 0%, #3D1266 100%)",
    "secondary-gradient": "linear-gradient(103.15deg, #26D0D0 0%, #16A7A7 100%)",
    "gray-gradient": "linear-gradient(90deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.2) 48.55%, rgba(255, 255, 255, 0.1) 100%)"
  },
  boxShadow: {
    1: "0px 1px 2px rgba(0, 0, 0, 0.12)",
    2: "0px 1px 2px rgba(0, 0, 0, 0.07), 0px 2px 4px rgba(0, 0, 0, 0.07)",
    3: "0px 1px 2px rgba(0, 0, 0, 0.06), 0px 2px 4px rgba(0, 0, 0, 0.06), 0px 4px 8px rgba(0, 0, 0, 0.06)",
    4: "0px 1px 2px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 4px 8px rgba(0, 0, 0, 0.05), 0px 8px 16px rgba(0, 0, 0, 0.05)",
    5: "0px 1px 2px rgba(0, 0, 0, 0.04), 0px 2px 4px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.04), 0px 16px 32px rgba(0, 0, 0, 0.04)",
    6: "0px 1px 2px rgba(0, 0, 0, 0.04), 0px 2px 4px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.04), 0px 16px 32px rgba(0, 0, 0, 0.04), 0px 32px 64px rgba(0, 0, 0, 0.04)",
    inner: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)",
    outline: "0 0 0 2px rgba(72, 29, 114, 0.5)",
    "outline-secondary": "0 0 0 2px #91E7E7",
    "outline-tertiary": "0 0 0 2px #e35b76",
    "outline-gray": "0 0 0 2px #C2C2C2",
    none: "none"
  },
  colors: {
    primary: {
      strong: primaryColors[800],
      700: primaryColors[700],
      600: primaryColors[600],
      default: primaryColors[500],
      light: primaryColors[400],
      300: primaryColors[300],
      200: primaryColors[200],
      lighter: primaryColors[100],
      weak: primaryColors[50]
    },
    secondary: {
      strong: secondaryColors[800],
      700: secondaryColors[700],
      600: secondaryColors[600],
      default: secondaryColors[500],
      light: secondaryColors[400],
      300: secondaryColors[300],
      200: secondaryColors[200],
      lighter: secondaryColors[100],
      weak: secondaryColors[50]
    },
    success: {
      strong: secondaryColors[800],
      700: secondaryColors[700],
      600: secondaryColors[600],
      default: secondaryColors[500],
      light: secondaryColors[400],
      300: secondaryColors[300],
      200: secondaryColors[200],
      lighter: secondaryColors[100],
      weak: secondaryColors[50]
    },
    warning: {
      strong: warningColors[800],
      700: warningColors[700],
      600: warningColors[600],
      default: warningColors[500],
      light: warningColors[400],
      300: warningColors[300],
      200: warningColors[200],
      lighter: warningColors[100],
      weak: warningColors[50]
    },
    error: {
      strong: errorColors[800],
      700: errorColors[700],
      600: errorColors[600],
      default: errorColors[500],
      light: errorColors[400],
      300: errorColors[300],
      200: errorColors[200],
      lighter: errorColors[100],
      weak: errorColors[50]
    },
    black: "#121212",
    base: {
      ...baseColors
    },
    white: "#fff",
    transparent: "transparent",
    info: "#0988B0",
    "info-light": "#EFF9FC",
    ...extendedPalette,
    intercom: "#276EFA",
    facebook: "#3B5998",
    twitter: "#1DA1F2",
    google: "#4285F4",
    linkedin: "#0077B5",
    trustpilot: "#007F4E",
    youtube: "#FF0000"
  },
  fontFamily: {
    sans: "'proxima-nova', 'proxima-soft', 'system-ui', sans-serif",
    serif: "'p22-mackinac-pro', serif",
    poppins: "Poppins",
    "proxima-nova": "Proxima Nova"
  },
  fontSize,
  fontWeight: {
    normal: "400",
    medium: "500",
    semibold: "600",
    bold: "700",
    "extra-bold": "800"
  },
  inset: {
    "1/2": "50%"
  },
  letterSpacing: {
    tight: "-0.025em",
    normal: "0",
    "semi-wide": "0.006em",
    wide: "0.01em",
    extended: "0.013em",
    wider: "0.075em",
    widest: "0.1em",
    roomy: "0.188em"
  },
  lineHeight: {
    5: "1.25rem",
    none: "1",
    tight: "1.125",
    normal: "1.5",
    loose: "2",
    sm: {
      0: "0.75rem",
      1: "1rem",
      2: "1.25rem"
    },
    md: {
      0: "1.375rem",
      1: "1.5rem",
      2: "1.75rem"
    },
    lg: {
      0: "2rem",
      1: "2.25rem",
      2: "2.5rem",
      3: "2.75rem"
    },
    xl: {
      0: "3rem",
      1: "3.5rem",
      2: "4rem",
      3: "4.5rem"
    }
  },
  opacity: {
    0: "0",
    10: ".1",
    20: ".2",
    30: ".3",
    40: ".4",
    50: ".5",
    60: ".6",
    70: ".7",
    80: ".8",
    90: ".9",
    100: "1"
  },
  screens: {
    xs: "30rem",
    sm: "40rem",
    md: "48rem",
    lg: "64rem",
    xl: "80rem",
    "2xl": "90rem"
  },
  ...spacing,
  borderRadius: {
    xs: "0.125rem",
    sm: "0.25rem",
    md: "0.375rem",
    default: "0.5rem",
    lg: "0.75rem",
    rd: "1rem"
  },
  container: {
    xs: "30rem",
    sm: "40rem",
    md: "48rem",
    lg: "64rem",
    xl: "80rem",
    "2xl": "90rem"
  },
  transitionDelay: timingDurations,
  transitionDuration: timingDurations,
  transitionTimingFunction: {
    linear: "linear",
    out: "cubic-bezier(0, 0.55, 0.45, 1)",
    in: "cubic-bezier(0.55, 0, 1, 0.45)",
    "in-out": "cubic-bezier(0.85, 0, 0.15, 1)"
  }
};
var commonjsGlobal$2 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var lib = { exports: {} };
var seed = 1;
function getNextValue() {
  seed = (seed * 9301 + 49297) % 233280;
  return seed / 233280;
}
function setSeed$1(_seed_) {
  seed = _seed_;
}
var randomFromSeed$1 = {
  nextValue: getNextValue,
  seed: setSeed$1
};
var randomFromSeed = randomFromSeed$1;
var ORIGINAL = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-";
var alphabet$2;
var previousSeed;
var shuffled;
function reset() {
  shuffled = false;
}
function setCharacters(_alphabet_) {
  if (!_alphabet_) {
    if (alphabet$2 !== ORIGINAL) {
      alphabet$2 = ORIGINAL;
      reset();
    }
    return;
  }
  if (_alphabet_ === alphabet$2) {
    return;
  }
  if (_alphabet_.length !== ORIGINAL.length) {
    throw new Error("Custom alphabet for shortid must be " + ORIGINAL.length + " unique characters. You submitted " + _alphabet_.length + " characters: " + _alphabet_);
  }
  var unique = _alphabet_.split("").filter(function(item, ind, arr) {
    return ind !== arr.lastIndexOf(item);
  });
  if (unique.length) {
    throw new Error("Custom alphabet for shortid must be " + ORIGINAL.length + " unique characters. These characters were not unique: " + unique.join(", "));
  }
  alphabet$2 = _alphabet_;
  reset();
}
function characters(_alphabet_) {
  setCharacters(_alphabet_);
  return alphabet$2;
}
function setSeed(seed2) {
  randomFromSeed.seed(seed2);
  if (previousSeed !== seed2) {
    reset();
    previousSeed = seed2;
  }
}
function shuffle() {
  if (!alphabet$2) {
    setCharacters(ORIGINAL);
  }
  var sourceArray = alphabet$2.split("");
  var targetArray = [];
  var r = randomFromSeed.nextValue();
  var characterIndex;
  while (sourceArray.length > 0) {
    r = randomFromSeed.nextValue();
    characterIndex = Math.floor(r * sourceArray.length);
    targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
  }
  return targetArray.join("");
}
function getShuffled() {
  if (shuffled) {
    return shuffled;
  }
  shuffled = shuffle();
  return shuffled;
}
function lookup(index) {
  var alphabetShuffled = getShuffled();
  return alphabetShuffled[index];
}
function get$1() {
  return alphabet$2 || ORIGINAL;
}
var alphabet_1 = {
  get: get$1,
  characters,
  seed: setSeed,
  lookup,
  shuffled: getShuffled
};
var crypto = typeof window === "object" && (window.crypto || window.msCrypto);
var randomByte;
if (!crypto || !crypto.getRandomValues) {
  randomByte = function(size) {
    var bytes = [];
    for (var i = 0; i < size; i++) {
      bytes.push(Math.floor(Math.random() * 256));
    }
    return bytes;
  };
} else {
  randomByte = function(size) {
    return crypto.getRandomValues(new Uint8Array(size));
  };
}
var randomByteBrowser = randomByte;
var format_browser = function(random2, alphabet2, size) {
  var mask = (2 << Math.log(alphabet2.length - 1) / Math.LN2) - 1;
  var step = -~(1.6 * mask * size / alphabet2.length);
  var id = "";
  while (true) {
    var bytes = random2(step);
    var i = step;
    while (i--) {
      id += alphabet2[bytes[i] & mask] || "";
      if (id.length === +size)
        return id;
    }
  }
};
var alphabet$1 = alphabet_1;
var random = randomByteBrowser;
var format$1 = format_browser;
function generate$1(number) {
  var loopCounter = 0;
  var done;
  var str = "";
  while (!done) {
    str = str + format$1(random, alphabet$1.get(), 1);
    done = number < Math.pow(16, loopCounter + 1);
    loopCounter++;
  }
  return str;
}
var generate_1 = generate$1;
var generate = generate_1;
var REDUCE_TIME = 1567752802062;
var version = 7;
var counter;
var previousSeconds;
function build$1(clusterWorkerId) {
  var str = "";
  var seconds = Math.floor((Date.now() - REDUCE_TIME) * 1e-3);
  if (seconds === previousSeconds) {
    counter++;
  } else {
    counter = 0;
    previousSeconds = seconds;
  }
  str = str + generate(version);
  str = str + generate(clusterWorkerId);
  if (counter > 0) {
    str = str + generate(counter);
  }
  str = str + generate(seconds);
  return str;
}
var build_1 = build$1;
var alphabet = alphabet_1;
function isShortId(id) {
  if (!id || typeof id !== "string" || id.length < 6) {
    return false;
  }
  var nonAlphabetic = new RegExp("[^" + alphabet.get().replace(/[|\\{}()[\]^$+*?.-]/g, "\\$&") + "]");
  return !nonAlphabetic.test(id);
}
var isValid = isShortId;
(function(module) {
  var alphabet2 = alphabet_1;
  var build3 = build_1;
  var isValid$1 = isValid;
  var clusterWorkerId = 0;
  function seed2(seedValue) {
    alphabet2.seed(seedValue);
    return module.exports;
  }
  function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
  }
  function characters2(newCharacters) {
    if (newCharacters !== void 0) {
      alphabet2.characters(newCharacters);
    }
    return alphabet2.shuffled();
  }
  function generate2() {
    return build3(clusterWorkerId);
  }
  module.exports = generate2;
  module.exports.generate = generate2;
  module.exports.seed = seed2;
  module.exports.worker = worker;
  module.exports.characters = characters2;
  module.exports.isValid = isValid$1;
})(lib);
var shortid = lib.exports;
var freeGlobal$1 = typeof commonjsGlobal$2 == "object" && commonjsGlobal$2 && commonjsGlobal$2.Object === Object && commonjsGlobal$2;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$a = freeGlobal || freeSelf || Function("return this")();
var _root = root$a;
var root$9 = _root;
var Symbol$7 = root$9.Symbol;
var _Symbol = Symbol$7;
function arrayMap$2(array, iteratee) {
  var index = -1, length = array == null ? 0 : array.length, result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}
var _arrayMap = arrayMap$2;
var isArray$b = Array.isArray;
var isArray_1 = isArray$b;
var Symbol$6 = _Symbol;
var objectProto$e = Object.prototype;
var hasOwnProperty$b = objectProto$e.hasOwnProperty;
var nativeObjectToString$1 = objectProto$e.toString;
var symToStringTag$1 = Symbol$6 ? Symbol$6.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$b.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;
var objectProto$d = Object.prototype;
var nativeObjectToString = objectProto$d.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$5 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$5 ? Symbol$5.toStringTag : void 0;
function baseGetTag$7(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$7;
function isObjectLike$b(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$b;
var baseGetTag$6 = _baseGetTag, isObjectLike$a = isObjectLike_1;
var symbolTag$3 = "[object Symbol]";
function isSymbol$4(value) {
  return typeof value == "symbol" || isObjectLike$a(value) && baseGetTag$6(value) == symbolTag$3;
}
var isSymbol_1 = isSymbol$4;
var Symbol$4 = _Symbol, arrayMap$1 = _arrayMap, isArray$a = isArray_1, isSymbol$3 = isSymbol_1;
var INFINITY$2 = 1 / 0;
var symbolProto$2 = Symbol$4 ? Symbol$4.prototype : void 0, symbolToString = symbolProto$2 ? symbolProto$2.toString : void 0;
function baseToString$2(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$a(value)) {
    return arrayMap$1(value, baseToString$2) + "";
  }
  if (isSymbol$3(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$2 ? "-0" : result;
}
var _baseToString = baseToString$2;
var baseToString$1 = _baseToString;
function toString$6(value) {
  return value == null ? "" : baseToString$1(value);
}
var toString_1 = toString$6;
function baseSlice$1(array, start2, end2) {
  var index = -1, length = array.length;
  if (start2 < 0) {
    start2 = -start2 > length ? 0 : length + start2;
  }
  end2 = end2 > length ? length : end2;
  if (end2 < 0) {
    end2 += length;
  }
  length = start2 > end2 ? 0 : end2 - start2 >>> 0;
  start2 >>>= 0;
  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start2];
  }
  return result;
}
var _baseSlice = baseSlice$1;
var baseSlice = _baseSlice;
function castSlice$1(array, start2, end2) {
  var length = array.length;
  end2 = end2 === void 0 ? length : end2;
  return !start2 && end2 >= length ? array : baseSlice(array, start2, end2);
}
var _castSlice = castSlice$1;
var rsAstralRange$2 = "\\ud800-\\udfff", rsComboMarksRange$3 = "\\u0300-\\u036f", reComboHalfMarksRange$3 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$3 = "\\u20d0-\\u20ff", rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3, rsVarRange$2 = "\\ufe0e\\ufe0f";
var rsZWJ$2 = "\\u200d";
var reHasUnicode = RegExp("[" + rsZWJ$2 + rsAstralRange$2 + rsComboRange$3 + rsVarRange$2 + "]");
function hasUnicode$2(string) {
  return reHasUnicode.test(string);
}
var _hasUnicode = hasUnicode$2;
function asciiToArray$1(string) {
  return string.split("");
}
var _asciiToArray = asciiToArray$1;
var rsAstralRange$1 = "\\ud800-\\udfff", rsComboMarksRange$2 = "\\u0300-\\u036f", reComboHalfMarksRange$2 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$2 = "\\u20d0-\\u20ff", rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2, rsVarRange$1 = "\\ufe0e\\ufe0f";
var rsAstral = "[" + rsAstralRange$1 + "]", rsCombo$2 = "[" + rsComboRange$2 + "]", rsFitz$1 = "\\ud83c[\\udffb-\\udfff]", rsModifier$1 = "(?:" + rsCombo$2 + "|" + rsFitz$1 + ")", rsNonAstral$1 = "[^" + rsAstralRange$1 + "]", rsRegional$1 = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair$1 = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsZWJ$1 = "\\u200d";
var reOptMod$1 = rsModifier$1 + "?", rsOptVar$1 = "[" + rsVarRange$1 + "]?", rsOptJoin$1 = "(?:" + rsZWJ$1 + "(?:" + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join("|") + ")" + rsOptVar$1 + reOptMod$1 + ")*", rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1, rsSymbol = "(?:" + [rsNonAstral$1 + rsCombo$2 + "?", rsCombo$2, rsRegional$1, rsSurrPair$1, rsAstral].join("|") + ")";
var reUnicode = RegExp(rsFitz$1 + "(?=" + rsFitz$1 + ")|" + rsSymbol + rsSeq$1, "g");
function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}
var _unicodeToArray = unicodeToArray$1;
var asciiToArray = _asciiToArray, hasUnicode$1 = _hasUnicode, unicodeToArray = _unicodeToArray;
function stringToArray$1(string) {
  return hasUnicode$1(string) ? unicodeToArray(string) : asciiToArray(string);
}
var _stringToArray = stringToArray$1;
var castSlice = _castSlice, hasUnicode = _hasUnicode, stringToArray = _stringToArray, toString$5 = toString_1;
function createCaseFirst$1(methodName) {
  return function(string) {
    string = toString$5(string);
    var strSymbols = hasUnicode(string) ? stringToArray(string) : void 0;
    var chr = strSymbols ? strSymbols[0] : string.charAt(0);
    var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
    return chr[methodName]() + trailing;
  };
}
var _createCaseFirst = createCaseFirst$1;
var createCaseFirst = _createCaseFirst;
var upperFirst$1 = createCaseFirst("toUpperCase");
var upperFirst_1 = upperFirst$1;
var toString$4 = toString_1, upperFirst = upperFirst_1;
function capitalize$1(string) {
  return upperFirst(toString$4(string).toLowerCase());
}
var capitalize_1 = capitalize$1;
function arrayReduce$1(array, iteratee, accumulator, initAccum) {
  var index = -1, length = array == null ? 0 : array.length;
  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}
var _arrayReduce = arrayReduce$1;
function basePropertyOf$1(object) {
  return function(key) {
    return object == null ? void 0 : object[key];
  };
}
var _basePropertyOf = basePropertyOf$1;
var basePropertyOf = _basePropertyOf;
var deburredLetters = {
  "\xC0": "A",
  "\xC1": "A",
  "\xC2": "A",
  "\xC3": "A",
  "\xC4": "A",
  "\xC5": "A",
  "\xE0": "a",
  "\xE1": "a",
  "\xE2": "a",
  "\xE3": "a",
  "\xE4": "a",
  "\xE5": "a",
  "\xC7": "C",
  "\xE7": "c",
  "\xD0": "D",
  "\xF0": "d",
  "\xC8": "E",
  "\xC9": "E",
  "\xCA": "E",
  "\xCB": "E",
  "\xE8": "e",
  "\xE9": "e",
  "\xEA": "e",
  "\xEB": "e",
  "\xCC": "I",
  "\xCD": "I",
  "\xCE": "I",
  "\xCF": "I",
  "\xEC": "i",
  "\xED": "i",
  "\xEE": "i",
  "\xEF": "i",
  "\xD1": "N",
  "\xF1": "n",
  "\xD2": "O",
  "\xD3": "O",
  "\xD4": "O",
  "\xD5": "O",
  "\xD6": "O",
  "\xD8": "O",
  "\xF2": "o",
  "\xF3": "o",
  "\xF4": "o",
  "\xF5": "o",
  "\xF6": "o",
  "\xF8": "o",
  "\xD9": "U",
  "\xDA": "U",
  "\xDB": "U",
  "\xDC": "U",
  "\xF9": "u",
  "\xFA": "u",
  "\xFB": "u",
  "\xFC": "u",
  "\xDD": "Y",
  "\xFD": "y",
  "\xFF": "y",
  "\xC6": "Ae",
  "\xE6": "ae",
  "\xDE": "Th",
  "\xFE": "th",
  "\xDF": "ss",
  "\u0100": "A",
  "\u0102": "A",
  "\u0104": "A",
  "\u0101": "a",
  "\u0103": "a",
  "\u0105": "a",
  "\u0106": "C",
  "\u0108": "C",
  "\u010A": "C",
  "\u010C": "C",
  "\u0107": "c",
  "\u0109": "c",
  "\u010B": "c",
  "\u010D": "c",
  "\u010E": "D",
  "\u0110": "D",
  "\u010F": "d",
  "\u0111": "d",
  "\u0112": "E",
  "\u0114": "E",
  "\u0116": "E",
  "\u0118": "E",
  "\u011A": "E",
  "\u0113": "e",
  "\u0115": "e",
  "\u0117": "e",
  "\u0119": "e",
  "\u011B": "e",
  "\u011C": "G",
  "\u011E": "G",
  "\u0120": "G",
  "\u0122": "G",
  "\u011D": "g",
  "\u011F": "g",
  "\u0121": "g",
  "\u0123": "g",
  "\u0124": "H",
  "\u0126": "H",
  "\u0125": "h",
  "\u0127": "h",
  "\u0128": "I",
  "\u012A": "I",
  "\u012C": "I",
  "\u012E": "I",
  "\u0130": "I",
  "\u0129": "i",
  "\u012B": "i",
  "\u012D": "i",
  "\u012F": "i",
  "\u0131": "i",
  "\u0134": "J",
  "\u0135": "j",
  "\u0136": "K",
  "\u0137": "k",
  "\u0138": "k",
  "\u0139": "L",
  "\u013B": "L",
  "\u013D": "L",
  "\u013F": "L",
  "\u0141": "L",
  "\u013A": "l",
  "\u013C": "l",
  "\u013E": "l",
  "\u0140": "l",
  "\u0142": "l",
  "\u0143": "N",
  "\u0145": "N",
  "\u0147": "N",
  "\u014A": "N",
  "\u0144": "n",
  "\u0146": "n",
  "\u0148": "n",
  "\u014B": "n",
  "\u014C": "O",
  "\u014E": "O",
  "\u0150": "O",
  "\u014D": "o",
  "\u014F": "o",
  "\u0151": "o",
  "\u0154": "R",
  "\u0156": "R",
  "\u0158": "R",
  "\u0155": "r",
  "\u0157": "r",
  "\u0159": "r",
  "\u015A": "S",
  "\u015C": "S",
  "\u015E": "S",
  "\u0160": "S",
  "\u015B": "s",
  "\u015D": "s",
  "\u015F": "s",
  "\u0161": "s",
  "\u0162": "T",
  "\u0164": "T",
  "\u0166": "T",
  "\u0163": "t",
  "\u0165": "t",
  "\u0167": "t",
  "\u0168": "U",
  "\u016A": "U",
  "\u016C": "U",
  "\u016E": "U",
  "\u0170": "U",
  "\u0172": "U",
  "\u0169": "u",
  "\u016B": "u",
  "\u016D": "u",
  "\u016F": "u",
  "\u0171": "u",
  "\u0173": "u",
  "\u0174": "W",
  "\u0175": "w",
  "\u0176": "Y",
  "\u0177": "y",
  "\u0178": "Y",
  "\u0179": "Z",
  "\u017B": "Z",
  "\u017D": "Z",
  "\u017A": "z",
  "\u017C": "z",
  "\u017E": "z",
  "\u0132": "IJ",
  "\u0133": "ij",
  "\u0152": "Oe",
  "\u0153": "oe",
  "\u0149": "'n",
  "\u017F": "s"
};
var deburrLetter$1 = basePropertyOf(deburredLetters);
var _deburrLetter = deburrLetter$1;
var deburrLetter = _deburrLetter, toString$3 = toString_1;
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
var rsComboMarksRange$1 = "\\u0300-\\u036f", reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$1 = "\\u20d0-\\u20ff", rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
var rsCombo$1 = "[" + rsComboRange$1 + "]";
var reComboMark = RegExp(rsCombo$1, "g");
function deburr$1(string) {
  string = toString$3(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
}
var deburr_1 = deburr$1;
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function asciiWords$1(string) {
  return string.match(reAsciiWord) || [];
}
var _asciiWords = asciiWords$1;
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function hasUnicodeWord$1(string) {
  return reHasUnicodeWord.test(string);
}
var _hasUnicodeWord = hasUnicodeWord$1;
var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
var rsApos$1 = "['\u2019]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos$1 + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos$1 + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq;
var reUnicodeWord = RegExp([
  rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
  rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
  rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
  rsUpper + "+" + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join("|"), "g");
function unicodeWords$1(string) {
  return string.match(reUnicodeWord) || [];
}
var _unicodeWords = unicodeWords$1;
var asciiWords = _asciiWords, hasUnicodeWord = _hasUnicodeWord, toString$2 = toString_1, unicodeWords = _unicodeWords;
function words$1(string, pattern, guard) {
  string = toString$2(string);
  pattern = guard ? void 0 : pattern;
  if (pattern === void 0) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}
var words_1 = words$1;
var arrayReduce = _arrayReduce, deburr = deburr_1, words = words_1;
var rsApos = "['\u2019]";
var reApos = RegExp(rsApos, "g");
function createCompounder$3(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
  };
}
var _createCompounder = createCompounder$3;
var capitalize = capitalize_1, createCompounder$2 = _createCompounder;
var camelCase = createCompounder$2(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});
var camelCase_1 = camelCase;
var createCompounder$1 = _createCompounder;
var snakeCase = createCompounder$1(function(result, word, index) {
  return result + (index ? "_" : "") + word.toLowerCase();
});
var snakeCase_1 = snakeCase;
function _typeof$1(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof$1 = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof$1(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props2) {
  for (var i = 0; i < props2.length; i++) {
    var descriptor = props2[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    });
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = void 0;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
var noop = function noop2() {
};
var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};
try {
  if (typeof window !== "undefined")
    _WINDOW = window;
  if (typeof document !== "undefined")
    _DOCUMENT = document;
  if (typeof MutationObserver !== "undefined")
    _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== "undefined")
    _PERFORMANCE = performance;
} catch (e) {
}
var _ref = _WINDOW.navigator || {}, _ref$userAgent = _ref.userAgent, userAgent = _ref$userAgent === void 0 ? "" : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var PERFORMANCE = _PERFORMANCE;
!!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === "function" && typeof DOCUMENT.createElement === "function";
~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/");
var NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var DEFAULT_FAMILY_PREFIX = "fa";
var DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var DATA_FA_I2SVG = "data-fa-i2svg";
(function() {
  try {
    return true;
  } catch (e) {
    return false;
  }
})();
var DUOTONE_CLASSES = {
  GROUP: "group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
};
var initial = WINDOW.FontAwesomeConfig || {};
function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector("script[" + attr + "]");
  if (element) {
    return element.getAttribute(attr);
  }
}
function coerce(val) {
  if (val === "")
    return true;
  if (val === "false")
    return false;
  if (val === "true")
    return true;
  return val;
}
if (DOCUMENT && typeof DOCUMENT.querySelector === "function") {
  var attrs = [["data-family-prefix", "familyPrefix"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  attrs.forEach(function(_ref2) {
    var _ref22 = _slicedToArray(_ref2, 2), attr = _ref22[0], key = _ref22[1];
    var val = coerce(getAttrConfig(attr));
    if (val !== void 0 && val !== null) {
      initial[key] = val;
    }
  });
}
var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: "async",
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};
var _config = _objectSpread({}, _default, initial);
if (!_config.autoReplaceSvg)
  _config.observeMutations = false;
var config = _objectSpread({}, _config);
WINDOW.FontAwesomeConfig = config;
var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER])
  w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles)
  w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks)
  w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims)
  w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];
var functions = [];
var listener = function listener2() {
  DOCUMENT.removeEventListener("DOMContentLoaded", listener2);
  loaded = 1;
  functions.map(function(fn2) {
    return fn2();
  });
};
var loaded = false;
if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded)
    DOCUMENT.addEventListener("DOMContentLoaded", listener);
}
var PENDING = "pending";
var SETTLED = "settled";
var FULFILLED = "fulfilled";
var REJECTED = "rejected";
var NOOP = function NOOP2() {
};
var isNode = typeof global !== "undefined" && typeof global.process !== "undefined" && typeof global.process.emit === "function";
var asyncSetTimer = typeof setImmediate === "undefined" ? setTimeout : setImmediate;
var asyncQueue = [];
var asyncTimer;
function asyncFlush() {
  for (var i = 0; i < asyncQueue.length; i++) {
    asyncQueue[i][0](asyncQueue[i][1]);
  }
  asyncQueue = [];
  asyncTimer = false;
}
function asyncCall(callback, arg) {
  asyncQueue.push([callback, arg]);
  if (!asyncTimer) {
    asyncTimer = true;
    asyncSetTimer(asyncFlush, 0);
  }
}
function invokeResolver(resolver, promise) {
  function resolvePromise(value) {
    resolve(promise, value);
  }
  function rejectPromise(reason) {
    reject(promise, reason);
  }
  try {
    resolver(resolvePromise, rejectPromise);
  } catch (e) {
    rejectPromise(e);
  }
}
function invokeCallback(subscriber) {
  var owner = subscriber.owner;
  var settled = owner._state;
  var value = owner._data;
  var callback = subscriber[settled];
  var promise = subscriber.then;
  if (typeof callback === "function") {
    settled = FULFILLED;
    try {
      value = callback(value);
    } catch (e) {
      reject(promise, e);
    }
  }
  if (!handleThenable(promise, value)) {
    if (settled === FULFILLED) {
      resolve(promise, value);
    }
    if (settled === REJECTED) {
      reject(promise, value);
    }
  }
}
function handleThenable(promise, value) {
  var resolved;
  try {
    if (promise === value) {
      throw new TypeError("A promises callback cannot return that same promise.");
    }
    if (value && (typeof value === "function" || _typeof$1(value) === "object")) {
      var then2 = value.then;
      if (typeof then2 === "function") {
        then2.call(value, function(val) {
          if (!resolved) {
            resolved = true;
            if (value === val) {
              fulfill(promise, val);
            } else {
              resolve(promise, val);
            }
          }
        }, function(reason) {
          if (!resolved) {
            resolved = true;
            reject(promise, reason);
          }
        });
        return true;
      }
    }
  } catch (e) {
    if (!resolved) {
      reject(promise, e);
    }
    return true;
  }
  return false;
}
function resolve(promise, value) {
  if (promise === value || !handleThenable(promise, value)) {
    fulfill(promise, value);
  }
}
function fulfill(promise, value) {
  if (promise._state === PENDING) {
    promise._state = SETTLED;
    promise._data = value;
    asyncCall(publishFulfillment, promise);
  }
}
function reject(promise, reason) {
  if (promise._state === PENDING) {
    promise._state = SETTLED;
    promise._data = reason;
    asyncCall(publishRejection, promise);
  }
}
function publish(promise) {
  promise._then = promise._then.forEach(invokeCallback);
}
function publishFulfillment(promise) {
  promise._state = FULFILLED;
  publish(promise);
}
function publishRejection(promise) {
  promise._state = REJECTED;
  publish(promise);
  if (!promise._handled && isNode) {
    global.process.emit("unhandledRejection", promise._data, promise);
  }
}
function notifyRejectionHandled(promise) {
  global.process.emit("rejectionHandled", promise);
}
function P(resolver) {
  if (typeof resolver !== "function") {
    throw new TypeError("Promise resolver " + resolver + " is not a function");
  }
  if (this instanceof P === false) {
    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
  }
  this._then = [];
  invokeResolver(resolver, this);
}
P.prototype = {
  constructor: P,
  _state: PENDING,
  _then: null,
  _data: void 0,
  _handled: false,
  then: function then(onFulfillment, onRejection) {
    var subscriber = {
      owner: this,
      then: new this.constructor(NOOP),
      fulfilled: onFulfillment,
      rejected: onRejection
    };
    if ((onRejection || onFulfillment) && !this._handled) {
      this._handled = true;
      if (this._state === REJECTED && isNode) {
        asyncCall(notifyRejectionHandled, this);
      }
    }
    if (this._state === FULFILLED || this._state === REJECTED) {
      asyncCall(invokeCallback, subscriber);
    } else {
      this._then.push(subscriber);
    }
    return subscriber.then;
  },
  catch: function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};
P.all = function(promises) {
  if (!Array.isArray(promises)) {
    throw new TypeError("You must pass an array to Promise.all().");
  }
  return new P(function(resolve2, reject2) {
    var results = [];
    var remaining = 0;
    function resolver(index) {
      remaining++;
      return function(value) {
        results[index] = value;
        if (!--remaining) {
          resolve2(results);
        }
      };
    }
    for (var i = 0, promise; i < promises.length; i++) {
      promise = promises[i];
      if (promise && typeof promise.then === "function") {
        promise.then(resolver(i), reject2);
      } else {
        results[i] = promise;
      }
    }
    if (!remaining) {
      resolve2(results);
    }
  });
};
P.race = function(promises) {
  if (!Array.isArray(promises)) {
    throw new TypeError("You must pass an array to Promise.race().");
  }
  return new P(function(resolve2, reject2) {
    for (var i = 0, promise; i < promises.length; i++) {
      promise = promises[i];
      if (promise && typeof promise.then === "function") {
        promise.then(resolve2, reject2);
      } else {
        resolve2(promise);
      }
    }
  });
};
P.resolve = function(value) {
  if (value && _typeof$1(value) === "object" && value.constructor === P) {
    return value;
  }
  return new P(function(resolve2) {
    resolve2(value);
  });
};
P.reject = function(reason) {
  return new P(function(resolve2, reject2) {
    reject2(reason);
  });
};
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css2) {
  if (!css2 || !IS_DOM) {
    return;
  }
  var style = DOCUMENT.createElement("style");
  style.setAttribute("type", "text/css");
  style.innerHTML = css2;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;
  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || "").toUpperCase();
    if (["STYLE", "LINK"].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }
  DOCUMENT.head.insertBefore(style, beforeChild);
  return css2;
}
var idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function nextUniqueId() {
  var size = 12;
  var id = "";
  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }
  return id;
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
    return acc + "".concat(attributeName, '="').concat(htmlEscape(attributes[attributeName]), '" ');
  }, "").trim();
}
function joinStyles(styles2) {
  return Object.keys(styles2 || {}).reduce(function(acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles2[styleName], ";");
  }, "");
}
function transformIsMeaningful(transform2) {
  return transform2.size !== meaninglessTransform.size || transform2.x !== meaninglessTransform.x || transform2.y !== meaninglessTransform.y || transform2.rotate !== meaninglessTransform.rotate || transform2.flipX || transform2.flipY;
}
function transformForSvg(_ref2) {
  var transform2 = _ref2.transform, containerWidth = _ref2.containerWidth, iconWidth = _ref2.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform2.x * 32, ", ").concat(transform2.y * 32, ") ");
  var innerScale = "scale(".concat(transform2.size / 16 * (transform2.flipX ? -1 : 1), ", ").concat(transform2.size / 16 * (transform2.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform2.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer,
    inner,
    path
  };
}
var ALL_SPACE = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = "black";
  }
  return abstract;
}
function deGroup(abstract) {
  if (abstract.tag === "g") {
    return abstract.children;
  } else {
    return [abstract];
  }
}
function makeIconMasking(_ref2) {
  var children = _ref2.children, attributes = _ref2.attributes, main2 = _ref2.main, mask = _ref2.mask, explicitMaskId = _ref2.maskId, transform2 = _ref2.transform;
  var mainWidth = main2.width, mainPath = main2.icon;
  var maskWidth = mask.width, maskPath = mask.icon;
  var trans = transformForSvg({
    transform: transform2,
    containerWidth: maskWidth,
    iconWidth: mainWidth
  });
  var maskRect = {
    tag: "rect",
    attributes: _objectSpread({}, ALL_SPACE, {
      fill: "white"
    })
  };
  var maskInnerGroupChildrenMixin = mainPath.children ? {
    children: mainPath.children.map(fillBlack)
  } : {};
  var maskInnerGroup = {
    tag: "g",
    attributes: _objectSpread({}, trans.inner),
    children: [fillBlack(_objectSpread({
      tag: mainPath.tag,
      attributes: _objectSpread({}, mainPath.attributes, trans.path)
    }, maskInnerGroupChildrenMixin))]
  };
  var maskOuterGroup = {
    tag: "g",
    attributes: _objectSpread({}, trans.outer),
    children: [maskInnerGroup]
  };
  var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
  var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
  var maskTag = {
    tag: "mask",
    attributes: _objectSpread({}, ALL_SPACE, {
      id: maskId,
      maskUnits: "userSpaceOnUse",
      maskContentUnits: "userSpaceOnUse"
    }),
    children: [maskRect, maskOuterGroup]
  };
  var defs = {
    tag: "defs",
    children: [{
      tag: "clipPath",
      attributes: {
        id: clipId
      },
      children: deGroup(maskPath)
    }, maskTag]
  };
  children.push(defs, {
    tag: "rect",
    attributes: _objectSpread({
      fill: "currentColor",
      "clip-path": "url(#".concat(clipId, ")"),
      mask: "url(#".concat(maskId, ")")
    }, ALL_SPACE)
  });
  return {
    children,
    attributes
  };
}
function makeIconStandard(_ref2) {
  var children = _ref2.children, attributes = _ref2.attributes, main2 = _ref2.main, transform2 = _ref2.transform, styles2 = _ref2.styles;
  var styleString = joinStyles(styles2);
  if (styleString.length > 0) {
    attributes["style"] = styleString;
  }
  if (transformIsMeaningful(transform2)) {
    var trans = transformForSvg({
      transform: transform2,
      containerWidth: main2.width,
      iconWidth: main2.width
    });
    children.push({
      tag: "g",
      attributes: _objectSpread({}, trans.outer),
      children: [{
        tag: "g",
        attributes: _objectSpread({}, trans.inner),
        children: [{
          tag: main2.icon.tag,
          children: main2.icon.children,
          attributes: _objectSpread({}, main2.icon.attributes, trans.path)
        }]
      }]
    });
  } else {
    children.push(main2.icon);
  }
  return {
    children,
    attributes
  };
}
function asIcon(_ref2) {
  var children = _ref2.children, main2 = _ref2.main, mask = _ref2.mask, attributes = _ref2.attributes, styles2 = _ref2.styles, transform2 = _ref2.transform;
  if (transformIsMeaningful(transform2) && main2.found && !mask.found) {
    var width = main2.width, height = main2.height;
    var offset2 = {
      x: width / height / 2,
      y: 0.5
    };
    attributes["style"] = joinStyles(_objectSpread({}, styles2, {
      "transform-origin": "".concat(offset2.x + transform2.x / 16, "em ").concat(offset2.y + transform2.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes,
    children
  }];
}
function asSymbol(_ref2) {
  var prefix = _ref2.prefix, iconName = _ref2.iconName, children = _ref2.children, attributes = _ref2.attributes, symbol = _ref2.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: _objectSpread({}, attributes, {
        id
      }),
      children
    }]
  }];
}
function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons, main2 = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform2 = params.transform, symbol = params.symbol, title2 = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
  var _ref2 = mask.found ? mask : main2, width = _ref2.width, height = _ref2.height;
  var widthClass = "fa-w-".concat(Math.ceil(width / height * 16));
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : "", widthClass].filter(function(c) {
    return extra.classes.indexOf(c) === -1;
  }).concat(extra.classes).join(" ");
  var content = {
    children: [],
    attributes: _objectSpread({}, extra.attributes, {
      "data-prefix": prefix,
      "data-icon": iconName,
      "class": attrClass,
      "role": extra.attributes.role || "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 ".concat(width, " ").concat(height)
    })
  };
  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = "";
  }
  if (title2)
    content.children.push({
      tag: "title",
      attributes: {
        id: content.attributes["aria-labelledby"] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title2]
    });
  var args = _objectSpread({}, content, {
    prefix,
    iconName,
    main: main2,
    mask,
    maskId,
    transform: transform2,
    symbol,
    styles: extra.styles
  });
  var _ref22 = mask.found && main2.found ? makeIconMasking(args) : makeIconStandard(args), children = _ref22.children, attributes = _ref22.attributes;
  args.children = children;
  args.attributes = attributes;
  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
var noop$1 = function noop3() {
};
config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
var bindInternal4 = function bindInternal42(func, thisContext) {
  return function(a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};
var reduce = function fastReduceObject(subject, fn2, initialValue, thisContext) {
  var keys2 = Object.keys(subject), length = keys2.length, iterator = thisContext !== void 0 ? bindInternal4(fn2, thisContext) : fn2, i, key, result;
  if (initialValue === void 0) {
    i = 1;
    result = subject[keys2[0]];
  } else {
    i = 0;
    result = initialValue;
  }
  for (; i < length; i++) {
    key = keys2[i];
    result = iterator(result, subject[key], key, subject);
  }
  return result;
};
function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = Object.keys(icons).reduce(function(acc, iconName) {
    var icon2 = icons[iconName];
    var expanded = !!icon2.icon;
    if (expanded) {
      acc[icon2.iconName] = icon2.icon;
    } else {
      acc[iconName] = icon2;
    }
    return acc;
  }, {});
  if (typeof namespace.hooks.addPack === "function" && !skipHooks) {
    namespace.hooks.addPack(prefix, normalized);
  } else {
    namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
  }
  if (prefix === "fas") {
    defineIcons("fa", icons);
  }
}
var styles = namespace.styles, shims = namespace.shims;
var build = function build2() {
  var lookup2 = function lookup3(reducer) {
    return reduce(styles, function(o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };
  lookup2(function(acc, icon2, iconName) {
    if (icon2[3]) {
      acc[icon2[3]] = iconName;
    }
    return acc;
  });
  lookup2(function(acc, icon2, iconName) {
    var ligatures = icon2[2];
    acc[iconName] = iconName;
    ligatures.forEach(function(ligature) {
      acc[ligature] = iconName;
    });
    return acc;
  });
  var hasRegular = "far" in styles;
  reduce(shims, function(acc, shim) {
    var oldName = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];
    if (prefix === "far" && !hasRegular) {
      prefix = "fas";
    }
    acc[oldName] = {
      prefix,
      iconName
    };
    return acc;
  }, {});
};
build();
namespace.styles;
function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix,
      iconName,
      icon: mapping[prefix][iconName]
    };
  }
}
function toHtml(abstractNodes) {
  var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
  if (typeof abstractNodes === "string") {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(""), "</").concat(tag, ">");
  }
}
var parseTransformString = function parseTransformString2(transformString) {
  var transform2 = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  if (!transformString) {
    return transform2;
  } else {
    return transformString.toLowerCase().split(" ").reduce(function(acc, n) {
      var parts = n.toLowerCase().split("-");
      var first = parts[0];
      var rest = parts.slice(1).join("-");
      if (first && rest === "h") {
        acc.flipX = true;
        return acc;
      }
      if (first && rest === "v") {
        acc.flipY = true;
        return acc;
      }
      rest = parseFloat(rest);
      if (isNaN(rest)) {
        return acc;
      }
      switch (first) {
        case "grow":
          acc.size = acc.size + rest;
          break;
        case "shrink":
          acc.size = acc.size - rest;
          break;
        case "left":
          acc.x = acc.x - rest;
          break;
        case "right":
          acc.x = acc.x + rest;
          break;
        case "up":
          acc.y = acc.y - rest;
          break;
        case "down":
          acc.y = acc.y + rest;
          break;
        case "rotate":
          acc.rotate = acc.rotate + rest;
          break;
      }
      return acc;
    }, transform2);
  }
};
function MissingIcon(error) {
  this.name = "MissingIcon";
  this.message = error || "Icon unavailable";
  this.stack = new Error().stack;
}
MissingIcon.prototype = Object.create(Error.prototype);
MissingIcon.prototype.constructor = MissingIcon;
var FILL = {
  fill: "currentColor"
};
var ANIMATION_BASE = {
  attributeType: "XML",
  repeatCount: "indefinite",
  dur: "2s"
};
({
  tag: "path",
  attributes: _objectSpread({}, FILL, {
    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
  })
});
var OPACITY_ANIMATE = _objectSpread({}, ANIMATION_BASE, {
  attributeName: "opacity"
});
({
  tag: "circle",
  attributes: _objectSpread({}, FILL, {
    cx: "256",
    cy: "364",
    r: "28"
  }),
  children: [{
    tag: "animate",
    attributes: _objectSpread({}, ANIMATION_BASE, {
      attributeName: "r",
      values: "28;14;28;28;14;28;"
    })
  }, {
    tag: "animate",
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: "1;0;1;1;0;1;"
    })
  }]
});
({
  tag: "path",
  attributes: _objectSpread({}, FILL, {
    opacity: "1",
    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
  }),
  children: [{
    tag: "animate",
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: "1;0;0;0;0;1;"
    })
  }]
});
({
  tag: "path",
  attributes: _objectSpread({}, FILL, {
    opacity: "0",
    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
  }),
  children: [{
    tag: "animate",
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: "0;0;1;1;0;0;"
    })
  }]
});
namespace.styles;
function asFoundIcon(icon2) {
  var width = icon2[0];
  var height = icon2[1];
  var _icon$slice = icon2.slice(4), _icon$slice2 = _slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
  var element = null;
  if (Array.isArray(vectorData)) {
    element = {
      tag: "g",
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: "path",
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: "currentColor",
          d: vectorData[0]
        }
      }, {
        tag: "path",
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: "currentColor",
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: "path",
      attributes: {
        fill: "currentColor",
        d: vectorData
      }
    };
  }
  return {
    found: true,
    width,
    height,
    icon: element
  };
}
namespace.styles;
var baseStyles = 'svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}';
function css() {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;
  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), "g");
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), "g");
    var rPatt = new RegExp("\\.".concat(drc), "g");
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }
  return s;
}
var Library = /* @__PURE__ */ function() {
  function Library2() {
    _classCallCheck(this, Library2);
    this.definitions = {};
  }
  _createClass(Library2, [{
    key: "add",
    value: function add() {
      var _this = this;
      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }
      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function(key) {
        _this.definitions[key] = _objectSpread({}, _this.definitions[key] || {}, additions[key]);
        defineIcons(key, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset2() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function(key) {
        var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon2 = _normalized$key.icon;
        if (!additions[prefix])
          additions[prefix] = {};
        additions[prefix][iconName] = icon2;
      });
      return additions;
    }
  }]);
  return Library2;
}();
function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}
function apiObject(val, abstractCreator) {
  Object.defineProperty(val, "abstract", {
    get: abstractCreator
  });
  Object.defineProperty(val, "html", {
    get: function get2() {
      return val.abstract.map(function(a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, "node", {
    get: function get2() {
      if (!IS_DOM)
        return;
      var container = DOCUMENT.createElement("div");
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}
function findIconDefinition(iconLookup) {
  var _iconLookup$prefix = iconLookup.prefix, prefix = _iconLookup$prefix === void 0 ? "fa" : _iconLookup$prefix, iconName = iconLookup.iconName;
  if (!iconName)
    return;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
function resolveIcons(next) {
  return function(maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;
    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }
    return next(iconDefinition, _objectSpread({}, params, {
      mask
    }));
  };
}
var library = new Library();
var _cssInserted = false;
var parse$1 = {
  transform: function transform(transformString) {
    return parseTransformString(transformString);
  }
};
var icon = resolveIcons(function(iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _params$transform = params.transform, transform2 = _params$transform === void 0 ? meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title2 = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles2 = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition)
    return;
  var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon2 = iconDefinition.icon;
  return apiObject(_objectSpread({
    type: "icon"
  }, iconDefinition), function() {
    ensureCss();
    if (config.autoA11y) {
      if (title2) {
        attributes["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes["aria-hidden"] = "true";
        attributes["focusable"] = "false";
      }
    }
    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon2),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix,
      iconName,
      transform: _objectSpread({}, meaninglessTransform, transform2),
      symbol,
      title: title2,
      maskId,
      titleId,
      extra: {
        attributes,
        styles: styles2,
        classes
      }
    });
  });
});
var commonjsGlobal$1 = typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function createCommonjsModule(fn2, module) {
  return module = { exports: {} }, fn2(module, module.exports), module.exports;
}
var humps = createCommonjsModule(function(module) {
  (function(global2) {
    var _processKeys = function(convert2, obj, options) {
      if (!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
        return obj;
      }
      var output, i = 0, l = 0;
      if (_isArray(obj)) {
        output = [];
        for (l = obj.length; i < l; i++) {
          output.push(_processKeys(convert2, obj[i], options));
        }
      } else {
        output = {};
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            output[convert2(key, options)] = _processKeys(convert2, obj[key], options);
          }
        }
      }
      return output;
    };
    var separateWords = function(string, options) {
      options = options || {};
      var separator = options.separator || "_";
      var split = options.split || /(?=[A-Z])/;
      return string.split(split).join(separator);
    };
    var camelize = function(string) {
      if (_isNumerical(string)) {
        return string;
      }
      string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : "";
      });
      return string.substr(0, 1).toLowerCase() + string.substr(1);
    };
    var pascalize = function(string) {
      var camelized = camelize(string);
      return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
    };
    var decamelize = function(string, options) {
      return separateWords(string, options).toLowerCase();
    };
    var toString2 = Object.prototype.toString;
    var _isFunction = function(obj) {
      return typeof obj === "function";
    };
    var _isObject = function(obj) {
      return obj === Object(obj);
    };
    var _isArray = function(obj) {
      return toString2.call(obj) == "[object Array]";
    };
    var _isDate = function(obj) {
      return toString2.call(obj) == "[object Date]";
    };
    var _isRegExp = function(obj) {
      return toString2.call(obj) == "[object RegExp]";
    };
    var _isBoolean = function(obj) {
      return toString2.call(obj) == "[object Boolean]";
    };
    var _isNumerical = function(obj) {
      obj = obj - 0;
      return obj === obj;
    };
    var _processor = function(convert2, options) {
      var callback = options && "process" in options ? options.process : options;
      if (typeof callback !== "function") {
        return convert2;
      }
      return function(string, options2) {
        return callback(string, convert2, options2);
      };
    };
    var humps2 = {
      camelize,
      decamelize,
      pascalize,
      depascalize: decamelize,
      camelizeKeys: function(object, options) {
        return _processKeys(_processor(camelize, options), object);
      },
      decamelizeKeys: function(object, options) {
        return _processKeys(_processor(decamelize, options), object, options);
      },
      pascalizeKeys: function(object, options) {
        return _processKeys(_processor(pascalize, options), object);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    if (module.exports) {
      module.exports = humps2;
    } else {
      global2.humps = humps2;
    }
  })(commonjsGlobal$1);
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var defineProperty$3 = function(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
};
var _extends = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var objectWithoutProperties$2 = function(obj, keys2) {
  var target = {};
  for (var i in obj) {
    if (keys2.indexOf(i) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i))
      continue;
    target[i] = obj[i];
  }
  return target;
};
function styleToObject(style) {
  return style.split(";").map(function(s) {
    return s.trim();
  }).filter(function(s) {
    return s;
  }).reduce(function(acc, pair) {
    var i = pair.indexOf(":");
    var prop = humps.camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    acc[prop] = value;
    return acc;
  }, {});
}
function classToObject(cls) {
  return cls.split(/\s+/).reduce(function(acc, c) {
    acc[c] = true;
    return acc;
  }, {});
}
function combineClassObjects() {
  for (var _len = arguments.length, objs = Array(_len), _key = 0; _key < _len; _key++) {
    objs[_key] = arguments[_key];
  }
  return objs.reduce(function(acc, obj) {
    if (Array.isArray(obj)) {
      acc = acc.concat(obj);
    } else {
      acc.push(obj);
    }
    return acc;
  }, []);
}
function convert(h2, element) {
  var props2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var data = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var children = (element.children || []).map(convert.bind(null, h2));
  var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
    var val = element.attributes[key];
    switch (key) {
      case "class":
        acc["class"] = classToObject(val);
        break;
      case "style":
        acc["style"] = styleToObject(val);
        break;
      default:
        acc.attrs[key] = val;
    }
    return acc;
  }, { "class": {}, style: {}, attrs: {} });
  var _data$class = data.class, dClass = _data$class === void 0 ? {} : _data$class, _data$style = data.style, dStyle = _data$style === void 0 ? {} : _data$style, _data$attrs = data.attrs, dAttrs = _data$attrs === void 0 ? {} : _data$attrs, remainingData = objectWithoutProperties$2(data, ["class", "style", "attrs"]);
  if (typeof element === "string") {
    return element;
  } else {
    return h2(element.tag, _extends({
      class: combineClassObjects(mixins.class, dClass),
      style: _extends({}, mixins.style, dStyle),
      attrs: _extends({}, mixins.attrs, dAttrs)
    }, remainingData, {
      props: props2
    }), children);
  }
}
var PRODUCTION = false;
try {
  PRODUCTION = true;
} catch (e) {
}
function log() {
  if (!PRODUCTION && console && typeof console.error === "function") {
    var _console;
    (_console = console).error.apply(_console, arguments);
  }
}
function objectWithKey(key, value) {
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? defineProperty$3({}, key, value) : {};
}
function classList(props2) {
  var _classes;
  var classes = (_classes = {
    "fa-spin": props2.spin,
    "fa-pulse": props2.pulse,
    "fa-fw": props2.fixedWidth,
    "fa-border": props2.border,
    "fa-li": props2.listItem,
    "fa-inverse": props2.inverse,
    "fa-flip-horizontal": props2.flip === "horizontal" || props2.flip === "both",
    "fa-flip-vertical": props2.flip === "vertical" || props2.flip === "both"
  }, defineProperty$3(_classes, "fa-" + props2.size, props2.size !== null), defineProperty$3(_classes, "fa-rotate-" + props2.rotation, props2.rotation !== null), defineProperty$3(_classes, "fa-pull-" + props2.pull, props2.pull !== null), defineProperty$3(_classes, "fa-swap-opacity", props2.swapOpacity), _classes);
  return Object.keys(classes).map(function(key) {
    return classes[key] ? key : null;
  }).filter(function(key) {
    return key;
  });
}
function normalizeIconArgs(icon$$1) {
  if (icon$$1 === null) {
    return null;
  }
  if ((typeof icon$$1 === "undefined" ? "undefined" : _typeof(icon$$1)) === "object" && icon$$1.prefix && icon$$1.iconName) {
    return icon$$1;
  }
  if (Array.isArray(icon$$1) && icon$$1.length === 2) {
    return { prefix: icon$$1[0], iconName: icon$$1[1] };
  }
  if (typeof icon$$1 === "string") {
    return { prefix: "fas", iconName: icon$$1 };
  }
}
var FontAwesomeIcon = {
  name: "FontAwesomeIcon",
  functional: true,
  props: {
    border: {
      type: Boolean,
      default: false
    },
    fixedWidth: {
      type: Boolean,
      default: false
    },
    flip: {
      type: String,
      default: null,
      validator: function validator(value) {
        return ["horizontal", "vertical", "both"].indexOf(value) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: true
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    listItem: {
      type: Boolean,
      default: false
    },
    pull: {
      type: String,
      default: null,
      validator: function validator2(value) {
        return ["right", "left"].indexOf(value) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: false
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function validator3(value) {
        return [90, 180, 270].indexOf(parseInt(value, 10)) > -1;
      }
    },
    swapOpacity: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: null,
      validator: function validator4(value) {
        return ["lg", "xs", "sm", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"].indexOf(value) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: false
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: false
    },
    title: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  render: function render(createElement, context) {
    var props2 = context.props;
    var iconArgs = props2.icon, maskArgs = props2.mask, symbol = props2.symbol, title2 = props2.title;
    var icon$$1 = normalizeIconArgs(iconArgs);
    var classes = objectWithKey("classes", classList(props2));
    var transform2 = objectWithKey("transform", typeof props2.transform === "string" ? parse$1.transform(props2.transform) : props2.transform);
    var mask = objectWithKey("mask", normalizeIconArgs(maskArgs));
    var renderedIcon = icon(icon$$1, _extends({}, classes, transform2, mask, { symbol, title: title2 }));
    if (!renderedIcon) {
      return log("Could not find one or more icon(s)", icon$$1, mask);
    }
    var abstract = renderedIcon.abstract;
    var convertCurry = convert.bind(null, createElement);
    return convertCurry(abstract[0], {}, context.data);
  }
};
var faAnalytics$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "analytics";
  var width = 576;
  var height = 512;
  var ligatures = [];
  var unicode = "f643";
  var svgPathData = "M510.62 92.63C516.03 94.74 521.85 96 528 96c26.51 0 48-21.49 48-48S554.51 0 528 0s-48 21.49-48 48c0 2.43.37 4.76.71 7.09l-95.34 76.27c-5.4-2.11-11.23-3.37-17.38-3.37s-11.97 1.26-17.38 3.37L255.29 55.1c.35-2.33.71-4.67.71-7.1 0-26.51-21.49-48-48-48s-48 21.49-48 48c0 4.27.74 8.34 1.78 12.28l-101.5 101.5C56.34 160.74 52.27 160 48 160c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-4.27-.74-8.34-1.78-12.28l101.5-101.5C199.66 95.26 203.73 96 208 96c6.15 0 11.97-1.26 17.38-3.37l95.34 76.27c-.35 2.33-.71 4.67-.71 7.1 0 26.51 21.49 48 48 48s48-21.49 48-48c0-2.43-.37-4.76-.71-7.09l95.32-76.28zM400 320h-64c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V336c0-8.84-7.16-16-16-16zm160-128h-64c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm-320 0h-64c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zM80 352H16c-8.84 0-16 7.16-16 16v128c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V368c0-8.84-7.16-16-16-16z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faAnalytics = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faAnalytics$1);
var faBadgeDollar = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "badge-dollar";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f645";
  var svgPathData = "M512 256c0-37.7-23.7-69.9-57.1-82.4 14.7-32.4 8.8-71.9-17.9-98.6-26.7-26.7-66.2-32.6-98.6-17.9C325.9 23.7 293.7 0 256 0s-69.9 23.7-82.4 57.1c-32.4-14.7-72-8.8-98.6 17.9-26.7 26.7-32.6 66.2-17.9 98.6C23.7 186.1 0 218.3 0 256s23.7 69.9 57.1 82.4c-14.7 32.4-8.8 72 17.9 98.6 26.6 26.6 66.1 32.7 98.6 17.9 12.5 33.3 44.7 57.1 82.4 57.1s69.9-23.7 82.4-57.1c32.6 14.8 72 8.7 98.6-17.9 26.7-26.7 32.6-66.2 17.9-98.6 33.4-12.5 57.1-44.7 57.1-82.4zm-232 94.44V368c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V144c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faBadgeDollar = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faBadgeDollar);
var faBallotCheck$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "ballot-check";
  var width = 384;
  var height = 512;
  var ligatures = [];
  var unicode = "f733";
  var svgPathData = "M360 0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24zM64 112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32zm1.6 129.4l12.7-12.6c2.1-2.1 5.5-2.1 7.6 0l20.6 20.8 47.6-47.2c2.1-2.1 5.5-2.1 7.6 0l12.6 12.7c2.1 2.1 2.1 5.5 0 7.6l-64.2 63.6c-2.1 2.1-5.5 2.1-7.6 0L65.6 249c-2.1-2.1-2.1-5.5 0-7.6zM128 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zm192-8c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-128c0 4.4-4.3 8-9.6 8H170.2s29.2-30.2 30.4-32h109.7c5.3 0 9.6 3.6 9.6 8v16zm0-128c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faBallotCheck = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faBallotCheck$1);
var faClipboardCheck$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "clipboard-check";
  var width = 384;
  var height = 512;
  var ligatures = [];
  var unicode = "f46c";
  var svgPathData = "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faClipboardCheck = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faClipboardCheck$1);
var faCreditCard$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "credit-card";
  var width = 576;
  var height = 512;
  var ligatures = [];
  var unicode = "f09d";
  var svgPathData = "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faCreditCard = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faCreditCard$1);
var faDoorOpen = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "door-open";
  var width = 640;
  var height = 512;
  var ligatures = [];
  var unicode = "f52b";
  var svgPathData = "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faDoorOpen = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faDoorOpen);
var faEar = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "ear";
  var width = 384;
  var height = 512;
  var ligatures = [];
  var unicode = "f5f0";
  var svgPathData = "M192 0C85.96 0 0 85.96 0 192v176c0 79.53 64.47 144 144 144s144-64.47 144-144v-9.9c57.33-33.21 96-95.08 96-166.1C384 85.96 298.04 0 192 0zm128 200c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-8c0-52.94-43.06-96-96-96s-96 43.06-96 96c0 17.64 14.36 32 32 32h32c35.3 0 64 28.7 64 64s-28.7 64-64 64h-8c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h8c17.64 0 32-14.36 32-32s-14.36-32-32-32h-32c-35.3 0-64-28.7-64-64 0-70.58 57.42-128 128-128s128 57.42 128 128v8z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faEar = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faEar);
var faTachometer$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "tachometer";
  var width = 576;
  var height = 512;
  var ligatures = [];
  var unicode = "f0e4";
  var svgPathData = "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm102.77 119.59l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faTachometer = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faTachometer$1);
var faUser$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "user";
  var width = 448;
  var height = 512;
  var ligatures = [];
  var unicode = "f007";
  var svgPathData = "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faUser = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faUser$1);
var faArrowLeft = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "arrow-left";
  var width = 448;
  var height = 512;
  var ligatures = [];
  var unicode = "f060";
  var svgPathData = "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faArrowLeft = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faArrowLeft);
var faArrowRight = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "arrow-right";
  var width = 448;
  var height = 512;
  var ligatures = [];
  var unicode = "f061";
  var svgPathData = "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faArrowRight = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faArrowRight);
var faBan = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "ban";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f05e";
  var svgPathData = "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faBan = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faBan);
var faBell = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "bell";
  var width = 448;
  var height = 512;
  var ligatures = [];
  var unicode = "f0f3";
  var svgPathData = "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faBell = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faBell);
var faBriefcase = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "briefcase";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f0b1";
  var svgPathData = "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faBriefcase = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faBriefcase);
var faBuilding = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "building";
  var width = 448;
  var height = 512;
  var ligatures = [];
  var unicode = "f1ad";
  var svgPathData = "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faBuilding = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faBuilding);
var faCabinetFiling$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "cabinet-filing";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f64b";
  var svgPathData = "M480 0H32C14.33 0 0 14.33 0 32v192h512V32c0-17.67-14.33-32-32-32zM352 152c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24H192v24c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40c0-8.84 7.16-16 16-16h160c8.84 0 16 7.16 16 16v40zM0 480c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V256H0v224zm160-112c0-8.84 7.16-16 16-16h160c8.84 0 16 7.16 16 16v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24H192v24c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faCabinetFiling = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faCabinetFiling$1);
var faCalendar = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "calendar";
  var width = 448;
  var height = 512;
  var ligatures = [];
  var unicode = "f133";
  var svgPathData = "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faCalendar = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faCalendar);
var faCheckCircle$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "check-circle";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f058";
  var svgPathData = "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faCheckCircle = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faCheckCircle$1);
var faClock = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "clock";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f017";
  var svgPathData = "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faClock = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faClock);
var faCloudUploadAlt = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "cloud-upload-alt";
  var width = 640;
  var height = 512;
  var ligatures = [];
  var unicode = "f382";
  var svgPathData = "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faCloudUploadAlt = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faCloudUploadAlt);
var faCogs$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "cogs";
  var width = 640;
  var height = 512;
  var ligatures = [];
  var unicode = "f085";
  var svgPathData = "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faCogs = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faCogs$1);
var faComment$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "comment";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f075";
  var svgPathData = "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faComment = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faComment$1);
var faExclamation = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "exclamation";
  var width = 192;
  var height = 512;
  var ligatures = [];
  var unicode = "f12a";
  var svgPathData = "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faExclamation = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faExclamation);
var faExclamationCircle = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "exclamation-circle";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f06a";
  var svgPathData = "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faExclamationCircle = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faExclamationCircle);
var faExclamationTriangle = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "exclamation-triangle";
  var width = 576;
  var height = 512;
  var ligatures = [];
  var unicode = "f071";
  var svgPathData = "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faExclamationTriangle = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faExclamationTriangle);
var faGift$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "gift";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f06b";
  var svgPathData = "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faGift = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faGift$1);
var faHandshakeAlt = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "handshake-alt";
  var width = 640;
  var height = 512;
  var ligatures = [];
  var unicode = "f4c6";
  var svgPathData = "M483.9 338.7L334.6 217.5l-30 27.5c-40.6 37.1-86.8 11.9-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128H16c-8.8 0-16 7.2-16 16v191.9c0 8.8 7.2 16 16 16h130.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1zM624 128H512l-54.6-54.6c-6-6-14.1-9.4-22.6-9.4h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.7 15.7-16.3 40.6-2.1 56 9.6 10.5 35 21.6 56.1 2.7.1-.1.3-.1.4-.2l53-48.5 27-24.7c6.5-5.9 16.6-5.5 22.6 1s5.5 16.6-1 22.6l-26.1 23.9 145.6 118.2c12.2 9.9 19.5 23.5 22.2 37.9H624c8.8 0 16-7.2 16-16V143.9c0-8.8-7.2-15.9-16-15.9z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faHandshakeAlt = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faHandshakeAlt);
var faIdCardAlt = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "id-card-alt";
  var width = 576;
  var height = 512;
  var ligatures = [];
  var unicode = "f47f";
  var svgPathData = "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faIdCardAlt = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faIdCardAlt);
var faInfoCircle = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "info-circle";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f05a";
  var svgPathData = "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faInfoCircle = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faInfoCircle);
var faLaptopMedical = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "laptop-medical";
  var width = 640;
  var height = 512;
  var ligatures = [];
  var unicode = "f812";
  var svgPathData = "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faLaptopMedical = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faLaptopMedical);
var faLightbulb$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "lightbulb";
  var width = 352;
  var height = 512;
  var ligatures = [];
  var unicode = "f0eb";
  var svgPathData = "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faLightbulb = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faLightbulb$1);
var faLock = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "lock";
  var width = 448;
  var height = 512;
  var ligatures = [];
  var unicode = "f023";
  var svgPathData = "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faLock = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faLock);
var faMicrophoneAlt = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "microphone-alt";
  var width = 352;
  var height = 512;
  var ligatures = [];
  var unicode = "f3c9";
  var svgPathData = "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faMicrophoneAlt = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faMicrophoneAlt);
var faPen = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "pen";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f304";
  var svgPathData = "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faPen = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faPen);
var faPhoneAlt = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "phone-alt";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f879";
  var svgPathData = "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faPhoneAlt = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faPhoneAlt);
var faCameraAlt = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "camera-alt";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f332";
  var svgPathData = "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88zm-120 0c0-17.6 14.4-32 32-32 8.8 0 16-7.2 16-16s-7.2-16-16-16c-35.3 0-64 28.7-64 64 0 8.8 7.2 16 16 16s16-7.2 16-16z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faCameraAlt = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faCameraAlt);
var faCamcorder = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "camcorder";
  var width = 576;
  var height = 512;
  var ligatures = [];
  var unicode = "f8a8";
  var svgPathData = "M525.59 165.7L416 241.3v157.4l109.59 75.5c21.21 14.6 50.41-.29 50.41-25.79V191.5c0-25.41-29.09-40.41-50.41-25.8zM336.2 160H96v-32a32 32 0 0 1 32-32h176a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H128a96 96 0 0 0-96 96v34.89A47.66 47.66 0 0 0 0 207.8v224.4A47.81 47.81 0 0 0 47.8 480h288.4a47.81 47.81 0 0 0 47.8-47.8V207.8a47.81 47.81 0 0 0-47.8-47.8zM320 249.6a6.41 6.41 0 0 1-6.4 6.4H70.4a6.41 6.41 0 0 1-6.4-6.4v-19.2a6.41 6.41 0 0 1 6.4-6.4h243.2a6.41 6.41 0 0 1 6.4 6.4z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faCamcorder = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faCamcorder);
var faPrint = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "print";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f02f";
  var svgPathData = "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faPrint = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faPrint);
var faQuestion = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "question";
  var width = 384;
  var height = 512;
  var ligatures = [];
  var unicode = "f128";
  var svgPathData = "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faQuestion = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faQuestion);
var faQuestionCircle = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "question-circle";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f059";
  var svgPathData = "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faQuestionCircle = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faQuestionCircle);
var faQuestionSquare = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "question-square";
  var width = 448;
  var height = 512;
  var ligatures = [];
  var unicode = "f2fd";
  var svgPathData = "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 430c-25.365 0-46-20.636-46-46 0-25.365 20.635-46 46-46s46 20.635 46 46c0 25.364-20.635 46-46 46zm40-131.333V300c0 6.627-5.373 12-12 12h-56c-6.627 0-12-5.373-12-12v-4c0-41.059 31.128-57.472 54.652-70.66 20.171-11.309 32.534-19 32.534-33.976 0-19.81-25.269-32.958-45.698-32.958-27.19 0-39.438 13.139-57.303 35.797-4.045 5.13-11.46 6.069-16.665 2.122l-34.699-26.31c-5.068-3.843-6.251-10.972-2.715-16.258C141.4 112.957 176.158 90 230.655 90c56.366 0 116.531 43.998 116.531 102 0 77.02-83.186 78.205-83.186 106.667z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faQuestionSquare = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faQuestionSquare);
var faEnvelopeOpenText = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "envelope-open-text";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f658";
  var svgPathData = "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faEnvelopeOpenText = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faEnvelopeOpenText);
var faShieldCheck = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "shield-check";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f2f7";
  var svgPathData = "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zm-47.2 114.2l-184 184c-6.2 6.2-16.4 6.2-22.6 0l-104-104c-6.2-6.2-6.2-16.4 0-22.6l22.6-22.6c6.2-6.2 16.4-6.2 22.6 0l70.1 70.1 150.1-150.1c6.2-6.2 16.4-6.2 22.6 0l22.6 22.6c6.3 6.3 6.3 16.4 0 22.6z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faShieldCheck = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faShieldCheck);
var faSignOutAlt$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "sign-out-alt";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f2f5";
  var svgPathData = "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faSignOutAlt = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faSignOutAlt$1);
var faUmbrella$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "umbrella";
  var width = 576;
  var height = 512;
  var ligatures = [];
  var unicode = "f0e9";
  var svgPathData = "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faUmbrella = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faUmbrella$1);
var faTimesHexagon = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "times-hexagon";
  var width = 576;
  var height = 512;
  var ligatures = [];
  var unicode = "f2ee";
  var svgPathData = "M553.5 231.8c8.7 14.9 8.7 33.4 0 48.4l-112 192c-8.6 14.7-24.4 23.8-41.5 23.8H176c-17.1 0-32.9-9.1-41.5-23.8l-112-192c-8.7-14.9-8.7-33.4 0-48.4l112-192C143.1 25.1 158.9 16 176 16h224c17.1 0 32.9 9.1 41.5 23.8l112 192zM409.6 338c4.7-4.7 4.7-12.3 0-17l-65-65 65.1-65.1c4.7-4.7 4.7-12.3 0-17L370 134.4c-4.7-4.7-12.3-4.7-17 0l-65 65-65.1-65.1c-4.7-4.7-12.3-4.7-17 0L166.4 174c-4.7 4.7-4.7 12.3 0 17l65.1 65.1-65.1 65.1c-4.7 4.7-4.7 12.3 0 17l39.6 39.6c4.7 4.7 12.3 4.7 17 0l65.1-65.1 65.1 65.1c4.7 4.7 12.3 4.7 17 0l39.4-39.8z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faTimesHexagon = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faTimesHexagon);
var faUsers$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "users";
  var width = 640;
  var height = 512;
  var ligatures = [];
  var unicode = "f0c0";
  var svgPathData = "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faUsers = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faUsers$1);
var faUsersClass$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "users-class";
  var width = 640;
  var height = 512;
  var ligatures = [];
  var unicode = "f63d";
  var svgPathData = "M256 288c0 35.35 28.66 64 64 64 35.35 0 64-28.65 64-64s-28.65-64-64-64c-35.34 0-64 28.65-64 64zm224 0c0 35.35 28.66 64 64 64 35.35 0 64-28.65 64-64s-28.65-64-64-64c-35.34 0-64 28.65-64 64zM96 352c35.35 0 64-28.65 64-64s-28.65-64-64-64c-35.34 0-64 28.65-64 64s28.66 64 64 64zm480 32h-64c-35.34 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32v-32c0-35.35-28.66-64-64-64zm-224 0h-64c-35.34 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32v-32c0-35.35-28.66-64-64-64zm-224 0H64c-35.34 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32v-32c0-35.35-28.66-64-64-64zM96 64h448v128c24.68 0 46.98 9.62 64 24.97V49.59C608 22.25 586.47 0 560 0H80C53.53 0 32 22.25 32 49.59v167.38C49.02 201.62 71.33 192 96 192V64z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faUsersClass = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faUsersClass$1);
var faTrash = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "trash";
  var width = 448;
  var height = 512;
  var ligatures = [];
  var unicode = "f1f8";
  var svgPathData = "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faTrash = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faTrash);
var faVirus$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "virus";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "e074";
  var svgPathData = "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faVirus = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faVirus$1);
var faWrench = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "wrench";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f0ad";
  var svgPathData = "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faWrench = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faWrench);
var faFileAlt = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "file-alt";
  var width = 384;
  var height = 512;
  var ligatures = [];
  var unicode = "f15c";
  var svgPathData = "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faFileAlt = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faFileAlt);
var faMoneyBillWave = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fas";
  var iconName = "money-bill-wave";
  var width = 640;
  var height = 512;
  var ligatures = [];
  var unicode = "f53a";
  var svgPathData = "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faMoneyBillWave = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faMoneyBillWave);
var faCheckCircle = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "far";
  var iconName = "check-circle";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f058";
  var svgPathData = "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faCheckCircle = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faCheckCircle);
var faFolder = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "far";
  var iconName = "folder";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f07b";
  var svgPathData = "M464 128H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 272H48V112h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H464v224z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faFolder = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faFolder);
var faSearch = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "far";
  var iconName = "search";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f002";
  var svgPathData = "M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faSearch = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faSearch);
var faAnalytics = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "analytics";
  var width = 576;
  var height = 512;
  var ligatures = [];
  var unicode = "f643";
  var svgPathData = "M80 352H16c-8.84 0-16 7.16-16 16v128c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V368c0-8.84-7.16-16-16-16zM64 480H32v-96h32v96zm496-288h-64c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm-16 288h-32V224h32v256zM502.77 88.68C510.12 93.24 518.71 96 528 96c26.51 0 48-21.49 48-48S554.51 0 528 0s-48 21.49-48 48c0 5.51 1.12 10.71 2.83 15.64l-89.6 71.68c-7.35-4.57-15.94-7.33-25.23-7.33s-17.88 2.76-25.23 7.33l-89.6-71.68C254.88 58.72 256 53.51 256 48c0-26.51-21.49-48-48-48s-48 21.49-48 48c0 7.4 1.81 14.32 4.8 20.58L68.58 164.8C62.32 161.81 55.4 160 48 160c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-7.4-1.81-14.32-4.8-20.58l96.22-96.22C193.68 94.19 200.6 96 208 96c9.29 0 17.88-2.76 25.23-7.33l89.6 71.68c-1.71 4.93-2.83 10.14-2.83 15.65 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.51-1.12-10.72-2.83-15.65l89.6-71.67zM528 32c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 224c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zM208 64c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zm160 128c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zm-128 0h-64c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm-16 288h-32V224h32v256zm176-160h-64c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V336c0-8.84-7.16-16-16-16zm-16 160h-32V352h32v128z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faAnalytics = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faAnalytics);
var faBallotCheck = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "ballot-check";
  var width = 448;
  var height = 512;
  var ligatures = [];
  var unicode = "f733";
  var svgPathData = "M112 432h32c17.7 0 32-14.4 32-32v-32c0-17.6-14.3-32-32-32h-32c-17.7 0-32 14.4-32 32v32c0 17.6 14.3 32 32 32zm0-64h32v32h-32v-32zm0-192h32c17.7 0 32-14.4 32-32v-32c0-17.6-14.3-32-32-32h-32c-17.7 0-32 14.4-32 32v32c0 17.6 14.3 32 32 32zm0-64h32v32h-32v-32zM416 0H32C14.3 0 0 14.4 0 32v448c0 17.6 14.3 32 32 32h384c17.7 0 32-14.4 32-32V32c0-17.6-14.3-32-32-32zm0 480H32V32h384v448zM216 144h128c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0 128h128c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0 128h128c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm-97.4-113.6c2.1 2.1 5.5 2.1 7.6 0l64.2-63.6c2.1-2.1 2.1-5.5 0-7.6l-12.6-12.7c-2.1-2.1-5.5-2.1-7.6 0l-47.6 47.2-20.6-20.9c-2.1-2.1-5.5-2.1-7.6 0l-12.7 12.6c-2.1 2.1-2.1 5.5 0 7.6l36.9 37.4z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faBallotCheck = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faBallotCheck);
var faCabinetFiling = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "cabinet-filing";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f64b";
  var svgPathData = "M464 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zm16 464c0 8.82-7.18 16-16 16H48c-8.82 0-16-7.18-16-16V272h448v192zm0-224H32V48c0-8.82 7.18-16 16-16h416c8.82 0 16 7.18 16 16v192zM336 96H176c-8.84 0-16 7.16-16 16v40c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-24h128v24c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-40c0-8.84-7.16-16-16-16zM168 416h16c4.42 0 8-3.58 8-8v-24h128v24c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-40c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v40c0 4.42 3.58 8 8 8z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faCabinetFiling = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faCabinetFiling);
var faCheck = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "check";
  var width = 448;
  var height = 512;
  var ligatures = [];
  var unicode = "f00c";
  var svgPathData = "M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faCheck = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faCheck);
var faChevronLeft = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "chevron-left";
  var width = 256;
  var height = 512;
  var ligatures = [];
  var unicode = "f053";
  var svgPathData = "M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faChevronLeft = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faChevronLeft);
var faChevronRight = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "chevron-right";
  var width = 256;
  var height = 512;
  var ligatures = [];
  var unicode = "f054";
  var svgPathData = "M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faChevronRight = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faChevronRight);
var faChevronDown = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "chevron-down";
  var width = 448;
  var height = 512;
  var ligatures = [];
  var unicode = "f078";
  var svgPathData = "M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faChevronDown = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faChevronDown);
var faChevronUp = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "chevron-up";
  var width = 448;
  var height = 512;
  var ligatures = [];
  var unicode = "f077";
  var svgPathData = "M4.465 366.475l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L224 178.053l195.494 195.493c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-211.05-211.051c-4.686-4.686-12.284-4.686-16.971 0L4.465 349.505c-4.687 4.686-4.687 12.284 0 16.97z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faChevronUp = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faChevronUp);
var faCircle = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "circle";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f111";
  var svgPathData = "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faCircle = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faCircle);
var faClipboardCheck = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "clipboard-check";
  var width = 384;
  var height = 512;
  var ligatures = [];
  var unicode = "f46c";
  var svgPathData = "M336 64h-88.6c.4-2.6.6-5.3.6-8 0-30.9-25.1-56-56-56s-56 25.1-56 56c0 2.7.2 5.4.6 8H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 32c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm160 432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h48v20c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V96h48c8.8 0 16 7.2 16 16v352zm-58.9-236.4c-4.7-4.7-12.3-4.7-17-.1L158.4 344.3 108 293.7c-4.7-4.7-12.3-4.7-17 0l-8.5 8.5c-4.7 4.7-4.7 12.3 0 17l67.4 67.6c4.7 4.7 12.3 4.7 17 0l134.8-133.7c4.7-4.7 4.7-12.3.1-17l-8.7-8.5z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faClipboardCheck = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faClipboardCheck);
var faCogs = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "cogs";
  var width = 640;
  var height = 512;
  var ligatures = [];
  var unicode = "f085";
  var svgPathData = "M538.6 196.4l-2.5-3.9c-4.1.3-8.1.3-12.2 0l-2.5 4c-5.8 9.2-17.1 13.4-27.5 10.1-13.8-4.3-23-8.8-34.3-18.1-9-7.4-11.2-20.3-5.4-30.4l2.5-4.3c-2.3-3.4-4.3-6.9-6.1-10.6h-9.1c-11.6 0-21.4-8.2-23.6-19.6-2.6-13.7-2.7-24.2.1-38.5 2.1-11.3 12.1-19.5 23.6-19.5h9c1.8-3.7 3.8-7.2 6.1-10.6l-2.6-4.5c-5.8-10-3.6-22.7 5.2-30.3 10.6-9.1 19.7-14.3 33.5-19 10.8-3.7 22.7.7 28.5 10.6l2.6 4.4c4.1-.3 8.1-.3 12.2 0l2.6-4.4c5.8-9.9 17.7-14.3 28.6-10.5 13.3 4.5 22.3 9.6 33.5 19.1 8.8 7.5 10.9 20.2 5.1 30.2l-2.6 4.4c2.3 3.4 4.3 6.9 6.1 10.6h5.1c11.6 0 21.4 8.2 23.6 19.6 2.6 13.7 2.7 24.2-.1 38.5-2.1 11.3-12.1 19.5-23.6 19.5h-5c-1.8 3.7-3.8 7.2-6.1 10.6l2.5 4.3c5.9 10.2 3.5 23.1-5.5 30.5-10.7 8.8-19.9 13.4-34 17.9-10.5 3.3-21.9-.8-27.7-10.1zm12.2-34.5l10.6 18.3c6.7-2.8 12.9-6.4 18.7-10.8l-10.6-18.3 6.4-7.5c4.8-5.7 8.6-12.1 11-19.1l3.3-9.3h21.1c.9-7.1.9-14.4 0-21.5h-21.1l-3.3-9.3c-2.5-7-6.2-13.4-11-19.1l-6.4-7.5L580 39.4c-5.7-4.4-12-8-18.7-10.8l-10.6 18.3-9.7-1.8c-7.3-1.4-14.8-1.4-22.1 0l-9.7 1.8-10.6-18.3C492 31.3 485.7 35 480 39.4l10.6 18.3-6.4 7.5c-4.8 5.7-8.6 12.1-11 19.1l-3.3 9.3h-21.1c-.9 7.1-.9 14.4 0 21.5h21.1l3.3 9.3c2.5 7 6.2 13.4 11 19.1l6.4 7.5-10.6 18.4c5.7 4.4 12 8 18.7 10.8l10.6-18.3 9.7 1.8c7.3 1.4 14.8 1.4 22.1 0l9.7-1.8zM145.3 454.4v-31.6c-12.9-5.5-25.1-12.6-36.4-21.1l-27.5 15.9c-9.8 5.6-22.1 3.7-29.7-4.6-24.2-26.3-38.5-49.5-50.6-88.1-3.4-10.7 1.1-22.3 10.8-28L39.2 281c-1.7-14-1.7-28.1 0-42.1l-27.3-15.8c-9.7-5.6-14.2-17.3-10.8-28 12.1-38.4 26.2-61.6 50.6-88.1 7.6-8.3 20-10.2 29.7-4.6l27.4 15.9c11.3-8.5 23.5-15.5 36.4-21.1V65.6c0-11.3 7.8-21 18.8-23.4 34.7-7.8 62-8.7 101.7 0 11 2.4 18.9 12.2 18.9 23.4v31.6c12.9 5.5 25.1 12.6 36.4 21l27.4-15.8c9.8-5.6 22.2-3.7 29.8 4.6 26.9 29.6 41.5 55.9 52.1 88.5 3.4 10.5-.8 21.9-10.2 27.7l-25 15.8c1.7 14 1.7 28.1 0 42.1l28.1 17.5c8.6 5.4 13 15.6 10.8 25.5-6.9 31.3-33 64.6-55.9 89.2-7.6 8.2-19.9 10-29.6 4.4L321 401.8c-11.3 8.5-23.5 15.5-36.4 21.1v31.6c0 11.2-7.8 21-18.8 23.4-37.5 8.3-64.9 8.2-101.9 0-10.8-2.5-18.6-12.3-18.6-23.5zm32-6.2c24.8 5 50.5 5 75.3 0v-47.7l10.7-3.8c16.8-5.9 32.3-14.9 45.9-26.5l8.6-7.4 41.4 23.9c16.8-19.1 34-41.3 42.1-65.2l-41.4-23.9 2.1-11.1c3.2-17.6 3.2-35.5 0-53.1l-2.1-11.1 41.4-23.9c-8.1-23.9-25.3-46.2-42.1-65.2l-41.4 23.9-8.6-7.4c-13.6-11.7-29-20.6-45.9-26.5l-10.7-3.8V71.8c-24.8-5-50.5-5-75.3 0v47.7l-10.7 3.8c-16.8 5.9-32.3 14.9-45.9 26.5l-8.6 7.4-41.4-23.9A192.19 192.19 0 0 0 33 198.5l41.4 23.9-2.1 11.1c-3.2 17.6-3.2 35.5 0 53.1l2.1 11.1L33 321.6c8.1 23.9 20.9 46.2 37.7 65.2l41.4-23.9 8.6 7.4c13.6 11.7 29 20.6 45.9 26.5l10.7 3.8v47.6zm38.4-105.3c-45.7 0-82.9-37.2-82.9-82.9s37.2-82.9 82.9-82.9 82.9 37.2 82.9 82.9-37.2 82.9-82.9 82.9zm0-133.8c-28 0-50.9 22.8-50.9 50.9s22.8 50.9 50.9 50.9c28 0 50.9-22.8 50.9-50.9s-22.8-50.9-50.9-50.9zm322.9 291.7l-2.5-3.9c-4.1.3-8.1.3-12.2 0l-2.5 4c-5.8 9.2-17.1 13.4-27.5 10.1-13.8-4.3-23-8.8-34.3-18.1-9-7.4-11.2-20.3-5.4-30.4l2.5-4.3c-2.3-3.4-4.3-6.9-6.1-10.6h-9.1c-11.6 0-21.4-8.2-23.6-19.6-2.6-13.7-2.7-24.2.1-38.5 2.1-11.3 12.1-19.5 23.6-19.5h9c1.8-3.7 3.8-7.2 6.1-10.6l-2.6-4.5c-5.8-10-3.6-22.7 5.2-30.3 10.6-9.1 19.7-14.3 33.5-19 10.8-3.7 22.7.7 28.5 10.6l2.6 4.4c4.1-.3 8.1-.3 12.2 0l2.6-4.4c5.8-9.9 17.7-14.3 28.6-10.5 13.3 4.5 22.3 9.6 33.5 19.1 8.8 7.5 10.9 20.2 5.1 30.2l-2.6 4.4c2.3 3.4 4.3 6.9 6.1 10.6h5.1c11.6 0 21.4 8.2 23.6 19.6 2.6 13.7 2.7 24.2-.1 38.5-2.1 11.3-12.1 19.5-23.6 19.5h-5c-1.8 3.7-3.8 7.2-6.1 10.6l2.5 4.3c5.9 10.2 3.5 23.1-5.5 30.5-10.7 8.8-19.9 13.4-34 17.9-10.5 3.2-21.9-.9-27.7-10.1zm12.2-34.6l10.6 18.3c6.7-2.8 12.9-6.4 18.7-10.8l-10.6-18.3 6.4-7.5c4.8-5.7 8.6-12.1 11-19.1l3.3-9.3h21.1c.9-7.1.9-14.4 0-21.5h-21.1l-3.3-9.3c-2.5-7-6.2-13.4-11-19.1l-6.4-7.5 10.6-18.3c-5.7-4.4-12-8-18.7-10.8l-10.6 18.3-9.7-1.8c-7.3-1.4-14.8-1.4-22.1 0l-9.7 1.8-10.6-18.3c-6.7 2.8-12.9 6.4-18.7 10.8l10.6 18.3-6.4 7.5c-4.8 5.7-8.6 12.1-11 19.1l-3.3 9.3h-21.1c-.9 7.1-.9 14.4 0 21.5h21.1l3.3 9.3c2.5 7 6.2 13.4 11 19.1l6.4 7.5-10.6 18.3c5.7 4.4 12 8 18.7 10.8l10.6-18.3 9.7 1.8c7.3 1.4 14.8 1.4 22.1 0l9.7-1.8zM560 408c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm0-304.3c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.4 32-32z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faCogs = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faCogs);
var faComment = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "comment";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f075";
  var svgPathData = "M256 64c123.5 0 224 79 224 176S379.5 416 256 416c-28.3 0-56.3-4.3-83.2-12.8l-15.2-4.8-13 9.2c-23 16.3-58.5 35.3-102.6 39.6 12-15.1 29.8-40.4 40.8-69.6l7.1-18.7-13.7-14.6C47.3 313.7 32 277.6 32 240c0-97 100.5-176 224-176m0-32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26 3.8 8.8 12.4 14.5 22 14.5 61.5 0 110-25.7 139.1-46.3 29 9.1 60.2 14.3 93 14.3 141.4 0 256-93.1 256-208S397.4 32 256 32z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faComment = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faComment);
var faCreditCard = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "credit-card";
  var width = 576;
  var height = 512;
  var ligatures = [];
  var unicode = "f09d";
  var svgPathData = "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM48 64h480c8.8 0 16 7.2 16 16v48H32V80c0-8.8 7.2-16 16-16zm480 384H48c-8.8 0-16-7.2-16-16V224h512v208c0 8.8-7.2 16-16 16zm-336-84v8c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v8c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faCreditCard = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faCreditCard);
var faEllipsisV = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "ellipsis-v";
  var width = 64;
  var height = 512;
  var ligatures = [];
  var unicode = "f142";
  var svgPathData = "M32 224c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM0 136c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm0 240c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faEllipsisV = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faEllipsisV);
var faGift = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "gift";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f06b";
  var svgPathData = "M464 144h-39.3c9.5-13.4 15.3-29.9 15.3-48 0-44.1-33.4-80-74.5-80-42.3 0-66.8 25.4-109.5 95.8C213.3 41.4 188.8 16 146.5 16 105.4 16 72 51.9 72 96c0 18.1 5.8 34.6 15.3 48H48c-26.5 0-48 21.5-48 48v96c0 8.8 7.2 16 16 16h16v144c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304h16c8.8 0 16-7.2 16-16v-96c0-26.5-21.5-48-48-48zm-187.8-3.6c49.5-83.3 66-92.4 89.3-92.4 23.4 0 42.5 21.5 42.5 48s-19.1 48-42.5 48H274l2.2-3.6zM146.5 48c23.4 0 39.8 9.1 89.3 92.4l2.1 3.6h-91.5c-23.4 0-42.5-21.5-42.5-48 .1-26.5 19.2-48 42.6-48zM192 464H80c-8.8 0-16-7.2-16-16V304h128v160zm0-192H32v-80c0-8.8 7.2-16 16-16h144v96zm96 192h-64V176h64v288zm160-16c0 8.8-7.2 16-16 16H320V304h128v144zm32-176H320v-96h144c8.8 0 16 7.2 16 16v80z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faGift = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faGift);
var faLightbulb = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "lightbulb";
  var width = 352;
  var height = 512;
  var ligatures = [];
  var unicode = "f0eb";
  var svgPathData = "M176 0C73.05 0-.12 83.54 0 176.24c.06 44.28 16.5 84.67 43.56 115.54C69.21 321.03 93.85 368.68 96 384l.06 75.18c0 3.15.94 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84L256 384c2.26-15.72 26.99-63.19 52.44-92.22C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0zm47.94 454.31L206.85 480h-61.71l-17.09-25.69-.01-6.31h95.9v6.31zm.04-38.31h-95.97l-.07-32h96.08l-.04 32zm60.4-145.32c-13.99 15.96-36.33 48.1-50.58 81.31H118.21c-14.26-33.22-36.59-65.35-50.58-81.31C44.5 244.3 32.13 210.85 32.05 176 31.87 99.01 92.43 32 176 32c79.4 0 144 64.6 144 144 0 34.85-12.65 68.48-35.62 94.68zM176 64c-61.75 0-112 50.25-112 112 0 8.84 7.16 16 16 16s16-7.16 16-16c0-44.11 35.88-80 80-80 8.84 0 16-7.16 16-16s-7.16-16-16-16z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faLightbulb = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faLightbulb);
var faPlus = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "plus";
  var width = 384;
  var height = 512;
  var ligatures = [];
  var unicode = "f067";
  var svgPathData = "M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faPlus = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faPlus);
var faMinus = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "minus";
  var width = 384;
  var height = 512;
  var ligatures = [];
  var unicode = "f068";
  var svgPathData = "M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faMinus = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faMinus);
var faSignOutAlt = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "sign-out-alt";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f2f5";
  var svgPathData = "M160 217.1c0-8.8 7.2-16 16-16h144v-93.9c0-7.1 8.6-10.7 13.6-5.7l141.6 143.1c6.3 6.3 6.3 16.4 0 22.7L333.6 410.4c-5 5-13.6 1.5-13.6-5.7v-93.9H176c-8.8 0-16-7.2-16-16v-77.7m-32 0v77.7c0 26.5 21.5 48 48 48h112v61.9c0 35.5 43 53.5 68.2 28.3l141.7-143c18.8-18.8 18.8-49.2 0-68L356.2 78.9c-25.1-25.1-68.2-7.3-68.2 28.3v61.9H176c-26.5 0-48 21.6-48 48zM0 112v288c0 26.5 21.5 48 48 48h132c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h132c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H48C21.5 64 0 85.5 0 112z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faSignOutAlt = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faSignOutAlt);
var faTimes = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "times";
  var width = 320;
  var height = 512;
  var ligatures = [];
  var unicode = "f00d";
  var svgPathData = "M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faTimes = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faTimes);
var faTimesCircle = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "times-circle";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "f057";
  var svgPathData = "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faTimesCircle = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faTimesCircle);
var faTachometer = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "tachometer";
  var width = 576;
  var height = 512;
  var ligatures = [];
  var unicode = "f0e4";
  var svgPathData = "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm221.5 416l-442.8.68C44 409.75 32 365.26 32 320 32 178.84 146.84 64 288 64s256 114.84 256 256c0 45.26-12 89.75-34.5 128zM365.22 128.88c-8.19-2.78-17.44 1.55-20.34 9.89l-51.83 149.74c-1.69-.13-3.31-.51-5.04-.51-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64c0-22.25-11.38-41.82-28.62-53.29l51.74-149.48c2.87-8.34-1.54-17.46-9.91-20.35zM288 384c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faTachometer = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faTachometer);
var faUmbrella = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "umbrella";
  var width = 576;
  var height = 512;
  var ligatures = [];
  var unicode = "f0e9";
  var svgPathData = "M575.2 253.8C545.9 130.8 430.5 54.5 304 48.4V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v32.4C146 54.4 30.9 129.9.8 253.7c-6 23.9 22.8 44.1 44.1 25.1 49.5-46.1 89.9-27.7 125.4 27.7 11.4 17.8 34.8 16.9 45.6 0 15.2-23.5 31.2-45 56.2-51.5v193.1c0 17.7-14.3 32-32 32-13.6 0-25.7-8.6-30.2-21.3-3-8.3-12.1-12.7-20.4-9.8-8.3 2.9-12.7 12.1-9.7 20.4 9 25.5 33.3 42.7 60.4 42.7 35.3 0 64-28.7 64-64V255.2c30.1 8.3 44.6 33.3 56.2 51.2 10.8 17 34.3 17.7 45.6 0 36.2-55.9 76.6-73 125.4-27.7 20.9 18.9 49.7-1 43.8-24.9zm-191.9 28.7C359 242.8 325.4 221 288 221c-44.5 0-71.6 27-94.7 61.5-41.6-67.8-107.5-77.5-156.1-39.3C72.1 138.7 178.8 80 288 80c109.3 0 217 59.3 251.2 163.7-58.3-43.9-114.1-21.9-155.9 38.8z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faUmbrella = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faUmbrella);
var faUsersClass = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "users-class";
  var width = 640;
  var height = 512;
  var ligatures = [];
  var unicode = "f63d";
  var svgPathData = "M544 224c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm-304-48c0 44.2 35.8 80 80 80s80-35.8 80-80-35.8-80-80-80-80 35.8-80 80zm128 0c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48zM96 384c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm468 160h-40c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zm-448 0H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zm224 0h-40c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM64 48c0-8.83 7.19-16 16-16h480c8.81 0 16 7.17 16 16v149.22c11.51 3.46 22.37 8.36 32 15.11V48c0-26.47-21.53-48-48-48H80C53.53 0 32 21.53 32 48v164.33c9.63-6.75 20.49-11.64 32-15.11V48z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faUsersClass = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faUsersClass);
var faUser = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "user";
  var width = 448;
  var height = 512;
  var ligatures = [];
  var unicode = "f007";
  var svgPathData = "M313.6 288c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zM416 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-41.6C32 365.9 77.9 320 134.4 320c19.6 0 39.1 16 89.6 16 50.4 0 70-16 89.6-16 56.5 0 102.4 45.9 102.4 102.4V464zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faUser = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faUser);
var faUsers = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "users";
  var width = 640;
  var height = 512;
  var ligatures = [];
  var unicode = "f0c0";
  var svgPathData = "M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM320 256c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-192c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80zm244 192h-40c-15.2 0-29.3 4.8-41.1 12.9 9.4 6.4 17.9 13.9 25.4 22.4 4.9-2.1 10.2-3.3 15.7-3.3h40c24.2 0 44 21.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.1-34.1-80-76-80zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-128c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm304.1 180c-33.4 0-41.7 12-80.1 12-38.4 0-46.7-12-80.1-12-36.3 0-71.6 16.2-92.3 46.9-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c0-23.8-7.2-45.9-19.6-64.3-20.7-30.7-56-46.9-92.3-46.9zM480 432c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-44.8c0-16.6 4.9-32.7 14.1-46.4 13.8-20.5 38.4-32.8 65.7-32.8 27.4 0 37.2 12 80.2 12s52.8-12 80.1-12c27.3 0 51.9 12.3 65.7 32.8 9.2 13.7 14.1 29.8 14.1 46.4V432zM157.1 268.9c-11.9-8.1-26-12.9-41.1-12.9H76c-41.9 0-76 35.9-76 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 19.8-48 44-48h40c5.5 0 10.8 1.2 15.7 3.3 7.5-8.5 16.1-16 25.4-22.4z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faUsers = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faUsers);
var faVirus = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var prefix = "fal";
  var iconName = "virus";
  var width = 512;
  var height = 512;
  var ligatures = [];
  var unicode = "e074";
  var svgPathData = "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22A55.74,55.74,0,0,1,341.74,107c-29.24,0-57.29-22.7-57.29-57V28.44a28.45,28.45,0,0,0-56.9,0V50c0,34.29-28.05,57-57.29,57a55.7,55.7,0,0,1-39.82-16.77L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25A55.7,55.7,0,0,1,170.25,405c29.25,0,57.3,22.7,57.3,57v21.54a28.45,28.45,0,0,0,56.9,0V462c0-34.29,28.05-57,57.3-57a55.7,55.7,0,0,1,39.81,16.77L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM379.88,307.32c-10.64,25.71-8.94,53.3,3.84,76.44a86.92,86.92,0,0,0-42-10.75A89.42,89.42,0,0,0,256,437.11,89.42,89.42,0,0,0,170.25,373a86.92,86.92,0,0,0-42,10.75c12.78-23.14,14.48-50.73,3.84-76.44s-31.33-44-56.69-51.32c25.36-7.34,46.05-25.63,56.69-51.32s8.94-53.3-3.84-76.44a87,87,0,0,0,42,10.75A89.42,89.42,0,0,0,256,74.88,89.42,89.42,0,0,0,341.74,139a87,87,0,0,0,42-10.75c-12.78,23.14-14.48,50.73-3.84,76.44s31.33,44,56.69,51.32C411.21,263.33,390.52,281.63,379.88,307.32ZM224,176a48,48,0,1,0,48,48A48,48,0,0,0,224,176Zm0,64a16,16,0,1,1,16-16A16,16,0,0,1,224,240Zm80,48a16,16,0,1,0,16,16A16,16,0,0,0,304,288Z";
  exports.definition = {
    prefix,
    iconName,
    icon: [
      width,
      height,
      ligatures,
      unicode,
      svgPathData
    ]
  };
  exports.faVirus = exports.definition;
  exports.prefix = prefix;
  exports.iconName = iconName;
  exports.width = width;
  exports.height = height;
  exports.ligatures = ligatures;
  exports.unicode = unicode;
  exports.svgPathData = svgPathData;
})(faVirus);
var render$3y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 20 20", "fill": "currentColor", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666ZM0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10Zm10-5c.46 0 .833.373.833.833V10a.833.833 0 0 1-1.666 0V5.833c0-.46.373-.833.833-.833Zm0 7.5c.46 0 .833.373.833.833v.417a.833.833 0 0 1-1.666 0v-.417c0-.46.373-.833.833-.833Z" } })]);
};
var alertCircleLight = {
  render: render$3y
};
var render$3x = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 23", "fill": "currentColor", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "m15.351.988-.313.74A11.74 11.74 0 0 0 5.029 4.693a11.266 11.266 0 0 0-1.922 2.354.783.783 0 0 0 .323 1.116.81.81 0 0 0 1.043-.288c2.057-3.376 5.978-5.2 9.928-4.655l-.256.605a.384.384 0 0 0 .371.53l3.839-.098a.382.382 0 0 0 .275-.645L15.997.872a.394.394 0 0 0-.646.116ZM20.811 6.662a.77.77 0 0 0-.265 1.031 9.591 9.591 0 0 1-.851 10.755l-.407-.52a.394.394 0 0 0-.652.05l-1.833 3.307c-.16.292.106.63.432.555l3.74-.865a.38.38 0 0 0 .22-.605l-.496-.637a11.175 11.175 0 0 0 1.263-12.789.82.82 0 0 0-1.151-.282ZM1.824 11.543.721 15.146a.385.385 0 0 0 .425.49l.81-.104c1.273 3.445 4.148 6.015 7.625 7.012a11.83 11.83 0 0 0 3.045.455.8.8 0 0 0 .825-.834.79.79 0 0 0-.777-.74c-4.011-.06-7.587-2.473-9.078-6.1l.663-.085c.281-.034.431-.344.281-.58l-2.005-3.206c-.18-.286-.615-.23-.71.088Z" } })]);
};
var arrowCircle = {
  render: render$3x
};
var render$3w = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "currentColor", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M3.853 8.582c-.187 0-.375-.043-.544-.126a1.192 1.192 0 0 1-.613-.723 1.178 1.178 0 0 1 .125-.944 11.527 11.527 0 0 1 1.952-2.387 11.81 11.81 0 0 1 8.098-3.184c.573 0 1.145.042 1.714.122l.181-.426a.81.81 0 0 1 1.32-.236l2.573 2.679a.762.762 0 0 1 .157.836.786.786 0 0 1-.716.481l-3.753.095h-.022a.802.802 0 0 1-.662-.35.763.763 0 0 1-.072-.735l.037-.088a9.069 9.069 0 0 0-.763-.031c-3.258 0-6.32 1.704-7.99 4.443a1.195 1.195 0 0 1-1.022.574ZM16.902 21.878a.807.807 0 0 1-.685-.383.767.767 0 0 1-.016-.772l1.792-3.233a.807.807 0 0 1 1.338-.104l.06.076a8.946 8.946 0 0 0 .475-9.634 1.162 1.162 0 0 1 .394-1.548c.003 0 .003-.003.006-.003a1.218 1.218 0 0 1 1.71.423c.507.895.889 1.854 1.136 2.85a11.358 11.358 0 0 1-2.205 9.858l.285.365c.166.212.21.487.119.739a.788.788 0 0 1-.57.5l-3.655.845a.76.76 0 0 1-.184.021ZM12.5 23h-.023a11.95 11.95 0 0 1-3.086-.46c-3.465-.996-6.288-3.524-7.61-6.8l-.467.058a.807.807 0 0 1-.744-.31.765.765 0 0 1-.125-.692l1.079-3.524a.793.793 0 0 1 .766-.558c.278 0 .534.141.678.374l1.96 3.135c.142.227.157.506.042.748a.792.792 0 0 1-.62.438l-.097.012c1.51 3.139 4.703 5.17 8.277 5.222a1.19 1.19 0 0 1 1.17 1.11 1.16 1.16 0 0 1-.325.876c-.222.236-.544.371-.876.371Z" } })]);
};
var arrowCircleSolid = {
  render: render$3w
};
var render$3v = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("g", { attrs: { "clip-path": "url(#clip0)", "fill": "currentColor" } }, [_c("path", { attrs: { "d": "M9.75 1.511a3 3 0 0 0-3 3 .75.75 0 0 1-.75.75H2.25a.75.75 0 0 0-.75.75v15.75a.75.75 0 0 0 .75.75h7.5a.75.75 0 0 1 0 1.5h-7.5A2.25 2.25 0 0 1 0 21.761V6.011a2.25 2.25 0 0 1 2.25-2.25h3.063a4.5 4.5 0 0 1 8.874 0h3.063a2.25 2.25 0 0 1 2.25 2.25v2.25a.75.75 0 0 1-1.5 0v-2.25a.75.75 0 0 0-.75-.75H13.5a.75.75 0 0 1-.75-.75 3 3 0 0 0-3-3Z" } }), _c("path", { attrs: { "d": "M5.25 9.761a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M14.204 10.968a6 6 0 0 1 7.036 9.222l2.54 2.54a.75.75 0 0 1-1.06 1.061l-2.541-2.54a6.002 6.002 0 0 1-9.679-4.74 6 6 0 0 1 3.704-5.543Zm6.453 7.265A4.501 4.501 0 0 1 12 16.511a4.5 4.5 0 1 1 8.657 1.722Z" } }), _c("path", { attrs: { "d": "M4.5 14.261a.75.75 0 0 1 .75-.75H7.5a.75.75 0 0 1 0 1.5H5.25a.75.75 0 0 1-.75-.75ZM5.25 17.261a.75.75 0 0 0 0 1.5H7.5a.75.75 0 0 0 0-1.5H5.25ZM8.954 3.34a1.125 1.125 0 1 1 1.591 1.591 1.125 1.125 0 0 1-1.59-1.59Z" } })])]);
};
var audit = {
  render: render$3v
};
var render$3u = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 23", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "m22.059 13.435-2.6-6.488a.52.52 0 0 0-.11-.168L17.93 5.355l-1.462-3.9a.516.516 0 0 0-.114-.178 2.881 2.881 0 0 0-3.708 0 .5.5 0 0 0-.146.354v4.987a10.81 10.81 0 0 0-1-.051c-.17 0-.335.008-.5.016v-4.95a.5.5 0 0 0-.146-.354 2.881 2.881 0 0 0-3.708 0 .517.517 0 0 0-.114.178L5.57 5.355 4.15 6.779a.52.52 0 0 0-.11.168l-2.599 6.488a5.5 5.5 0 1 0 9.559 3.7v-5.54c.155-.015.319-.025.5-.025.336-.002.67.03 1 .094v5.469a5.5 5.5 0 1 0 9.559-3.7v.002ZM9 17.133a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm9 3.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z", "fill": "currentColor" } })]);
};
var binoculars = {
  render: render$3u
};
var render$3t = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M2.5 16.5h7.069a7.28 7.28 0 0 0 0 2H2a2 2 0 0 1-2-2V3a1 1 0 0 1 1-1h2.25a.5.5 0 0 1 .5.5v2a.75.75 0 0 0 1.5 0V.75a.75.75 0 0 1 1.5 0v1A.25.25 0 0 0 7 2h4.25a.5.5 0 0 1 .5.5v2a.75.75 0 1 0 1.5 0V.75a.75.75 0 1 1 1.5 0v1A.25.25 0 0 0 15 2h2.5a1 1 0 0 1 1 1v6.57a7.28 7.28 0 0 0-2 0V7.5A.5.5 0 0 0 16 7H2.5a.5.5 0 0 0-.5.5V16a.5.5 0 0 0 .5.5Z", "fill": "currentColor" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M13.889 12.095A6.5 6.5 0 0 1 17.5 11a6.508 6.508 0 0 1 6.5 6.5 6.5 6.5 0 1 1-10.111-5.405ZM16 21.25h.75v.5a.75.75 0 1 0 1.5 0v-.522a2.085 2.085 0 0 0 .56-4.012l-2.063-.825a.593.593 0 0 1 .22-1.141H19a.75.75 0 1 0 0-1.5h-.75v-.5a.75.75 0 1 0-1.5 0v.522a2.085 2.085 0 0 0-.56 4.012l2.063.825a.593.593 0 0 1-.22 1.141H16a.75.75 0 1 0 0 1.5Z", "fill": "currentColor" } })]);
};
var calendarMoney = {
  render: render$3t
};
var render$3s = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M8 1a1 1 0 0 1 1 1v1h6V2a1 1 0 1 1 2 0v1.002c.476.003.891.013 1.252.042.562.046 1.079.145 1.564.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564C22 7.29 22 7.954 22 8.758v8.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H7.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C2 18.71 2 18.046 2 17.242V8.758c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.485-.247 1.002-.346 1.564-.392.361-.03.777-.04 1.252-.042V2a1 1 0 0 1 1-1ZM7 5.002c-.446.003-.795.012-1.089.036-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C4 7.361 4 7.943 4 8.8V9h16v-.2c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18A15.155 15.155 0 0 0 17 5.002V6a1 1 0 1 1-2 0V5H9v1a1 1 0 1 1-2 0v-.998ZM20 11H4v6.2c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C6.361 21 6.943 21 7.8 21h8.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V11Z", "fill": "currentColor" } })]);
};
var calendarOutline = {
  render: render$3s
};
var render$3r = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ staticStyle: { "enable-background": "new 0 0 32 32" }, attrs: { "xmlns": "http://www.w3.org/2000/svg", "viewBox": "0 0 32 32", "xml:space": "preserve", "fill": "currentColor" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M13 14.2H1.5c-.6 0-1-.5-1-1V1.7c0-.6.5-1 1-1H13c.6 0 1 .5 1 1v11.4c0 .6-.4 1.1-1 1.1zM30.4 14.2H19c-.6 0-1-.5-1-1V1.7c0-.6.5-1 1-1h11.4c.6 0 1 .5 1 1v11.4c.1.6-.4 1.1-1 1.1zM13 31.4H1.5c-.6 0-1-.5-1-1V18.9c0-.6.5-1 1-1H13c.6 0 1 .5 1 1v11.4c0 .6-.4 1.1-1 1.1zM30.4 31.4H19c-.6 0-1-.5-1-1V18.9c0-.6.5-1 1-1h11.4c.6 0 1 .5 1 1v11.4c.1.6-.4 1.1-1 1.1z" } })]);
};
var cardLayout = {
  render: render$3r
};
var render$3q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M9.414 10c-.89 0-1.337 1.077-.707 1.707l2.586 2.586a1 1 0 0 0 1.414 0l2.586-2.586c.63-.63.184-1.707-.707-1.707H9.414Z", "fill": "currentColor" } })]);
};
var caretDown = {
  render: render$3q
};
var render$3p = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("g", { attrs: { "clip-path": "url(#clip0_556:26873)", "fill": "currentColor" } }, [_c("path", { attrs: { "d": "M20 1.767A1.667 1.667 0 0 0 18.333.1H1.667A1.667 1.667 0 0 0 0 1.767V13.85a1.667 1.667 0 0 0 1.667 1.667h2.916a.833.833 0 1 0 0-1.667H1.875a.209.209 0 0 1-.208-.208V5.567l3.8-3.8h12.658a.208.208 0 0 1 .208.208V10a.242.242 0 0 1-.058.15l-3.333 3.292a.642.642 0 0 0-.184.441v.834a.833.833 0 0 0 .834.833h2.741A1.666 1.666 0 0 0 20 13.883V1.767Z" } }), _c("path", { attrs: { "d": "M10 8.242a4.167 4.167 0 0 0-2.5 7.441v3.792a.425.425 0 0 0 .275.4.4.4 0 0 0 .458-.133L10 17.633l1.767 2.109a.416.416 0 0 0 .458.133.425.425 0 0 0 .275-.4v-3.792A4.166 4.166 0 0 0 10 8.242Zm0 1.666a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z" } }), _c("path", { attrs: { "d": "M10 13.625a1.233 1.233 0 1 0 0-2.467 1.233 1.233 0 0 0 0 2.467ZM12.083 4.475a.625.625 0 0 0 0-1.25H7.916a.625.625 0 0 0 0 1.25h4.167ZM14.167 5.533H5.833a.625.625 0 0 0 0 1.25h8.334a.625.625 0 1 0 0-1.25Z" } })])]);
};
var certificate = {
  render: render$3p
};
var render$3o = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("g", { attrs: { "clip-path": "url(#clip0)", "fill": "currentColor" } }, [_c("path", { attrs: { "d": "M22.968 8.461a2.5 2.5 0 0 0-4.392 2.157.499.499 0 0 0 .486.381h.513a.248.248 0 0 1 .194.092.252.252 0 0 1 .052.207l-.409 2.044a1.516 1.516 0 0 1-.927 1.035.249.249 0 0 1-.295-.085 1.463 1.463 0 0 0-.718-.533A17.658 17.658 0 0 0 12 13c-1.853-.035-3.7.221-5.472.76-.29.098-.54.285-.718.533a.249.249 0 0 1-.295.085 1.516 1.516 0 0 1-.927-1.035L4.179 11.3a.252.252 0 0 1 .246-.3h.513a.5.5 0 0 0 .486-.381 2.5 2.5 0 1 0-4.848 0 .5.5 0 0 0 .486.381h.608a.5.5 0 0 1 .491.4l.466 2.333a3.545 3.545 0 0 0 2.814 2.7.252.252 0 0 1 .186.148A1.494 1.494 0 0 0 7 17.5h3.75a.25.25 0 0 1 .25.25v.6a.25.25 0 0 1-.217.248A7.245 7.245 0 0 0 6.2 20.9a.248.248 0 0 1-.2.1 1.5 1.5 0 1 0 1.5 1.56c0-.056.02-.11.055-.155L7.8 22.1a4.974 4.974 0 0 1 2.905-1.486.247.247 0 0 1 .271.14c.016.033.024.07.024.106v.531a1.501 1.501 0 1 0 2 0v-.533a.247.247 0 0 1 .09-.191.243.243 0 0 1 .2-.055c1.11.155 2.135.68 2.91 1.488l.243.3a.249.249 0 0 1 .056.159A1.5 1.5 0 1 0 18 21a.25.25 0 0 1-.2-.1v-.006a7.245 7.245 0 0 0-4.583-2.3.248.248 0 0 1-.217-.246v-.6a.25.25 0 0 1 .25-.25H17a1.494 1.494 0 0 0 1.373-.914.252.252 0 0 1 .186-.148 3.545 3.545 0 0 0 2.814-2.7l.466-2.333a.5.5 0 0 1 .491-.4h.608a.5.5 0 0 0 .486-.381 2.5 2.5 0 0 0-.456-2.161Z" } }), _c("path", { attrs: { "d": "M7.182 11.565a.5.5 0 0 0 .571.327 23.232 23.232 0 0 1 8.494 0 .5.5 0 0 0 .572-.327A28.539 28.539 0 0 0 18.5 5.5 5.9 5.9 0 0 0 13.092.048a12.445 12.445 0 0 0-2.184 0A5.9 5.9 0 0 0 5.5 5.5c.335 2.077.9 4.112 1.682 6.065Z" } })])]);
};
var chair = {
  render: render$3o
};
var render$3n = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("g", { attrs: { "clip-path": "url(#a)" } }, [_c("path", { attrs: { "d": "M18.914 15.79h-.685V4.82a.914.914 0 0 0-.915-.915H2.686a.914.914 0 0 0-.915.914V15.79h-.685a.229.229 0 0 0-.229.23v.456c0 .127.102.229.229.229h17.828a.229.229 0 0 0 .229-.229v-.457a.229.229 0 0 0-.229-.228Zm-9.828 0v-1.828h5.486v1.829H9.085Zm6.4 0v-1.828a.914.914 0 0 0-.915-.914H9.087a.914.914 0 0 0-.915.914v1.829H2.686V4.819h14.628V15.79h-1.828Z", "fill": "currentColor" } })]), _c("defs", [_c("clipPath", { attrs: { "id": "a" } }, [_c("path", { attrs: { "fill": "#fff", "transform": "translate(.857 .857)", "d": "M0 0h18.286v18.286H0z" } })])])]);
};
var chalkboard = {
  render: render$3n
};
var render$3m = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M20.877 4.577 13.834.474c-1.083-.631-2.78-.631-3.862 0L2.929 4.577C1.847 5.207 1 6.684 1 7.939v8.126c0 1.255.851 2.726 1.939 3.35l7.028 4.027c.543.311 1.24.467 1.936.467.697 0 1.393-.156 1.936-.467l7.028-4.028c1.087-.623 1.939-2.094 1.939-3.35V7.938c0-1.255-.848-2.73-1.93-3.36Zm-3.901 3.6.848.853a.606.606 0 0 1 0 .854l-6.9 6.94a.597.597 0 0 1-.848 0l-3.9-3.923a.606.606 0 0 1 0-.854l.848-.853a.597.597 0 0 1 .849 0l2.627 2.642 5.627-5.66a.598.598 0 0 1 .849 0Z", "fill": "currentColor" } })]);
};
var checkHexagonSolid = {
  render: render$3m
};
var render$3l = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 18 14", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "m5.75 10.536 9.392-9.391a1.25 1.25 0 0 1 1.767 1.767L6.082 13.74a.467.467 0 0 1-.663 0L1.09 9.412a1.25 1.25 0 1 1 1.768-1.768l2.891 2.892Z", "fill": "currentColor" } })]);
};
var checkThick = {
  render: render$3l
};
var render$3k = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M9 2a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-1v1.052c4.777.5 8.5 4.539 8.5 9.448a9.5 9.5 0 0 1-19 0c0-4.909 3.723-8.948 8.5-9.448V3h-1a1 1 0 0 1-1-1ZM5.878 3.385a1 1 0 0 1 0 1.414l-.75.75-.75.75a1 1 0 0 1-1.414-1.414l.75-.75.75-.75a1 1 0 0 1 1.414 0Zm12.244 0a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1-1.414 1.414l-1.5-1.5a1 1 0 0 1 0-1.414ZM12 6a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm0 2.5a1 1 0 0 1 1 1v3.434l2.014 1.209a1 1 0 0 1-1.028 1.714l-2.5-1.5A1 1 0 0 1 11 13.5v-4a1 1 0 0 1 1-1Z", "fill": "currentColor" } })]);
};
var clockLine = {
  render: render$3k
};
var render$3j = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M6 2h13a2 2 0 0 1 2 2v18h-2v-4a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v4H4V4a2 2 0 0 1 2-2Zm10 22H4a2 2 0 0 1-2-2V4a4 4 0 0 1 4-4h13a4 4 0 0 1 4 4v18a2 2 0 0 1-2 2h-5ZM6 6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V6Zm1 5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H7Zm9 1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1Zm1-7a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-1ZM6 18a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-1Zm6-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1Z", "fill": "currentColor" } })]);
};
var company = {
  render: render$3j
};
var render$3i = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M6 0a3 3 0 0 0-3 3v20a1 1 0 0 0 1 1h12v-6a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v6h2a1 1 0 0 0 1-1V3a3 3 0 0 0-3-3H6Zm0 6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V6Zm1 5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H7Zm9 1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1Zm1-7a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-1ZM6 18a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-1Zm6-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1Z", "fill": "currentColor" } })]);
};
var companySolid = {
  render: render$3i
};
var render$3h = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M20 21V8h-3a3 3 0 0 1-3-3V2H5a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1Zm-.3-15H17a1 1 0 0 1-1-1V2.366L19.7 6ZM5 0a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V6.713a3 3 0 0 0-.898-2.14L17.32.859A3 3 0 0 0 15.218 0H5Zm6.5 18c.88 0 1.702-.253 2.396-.69l1.418 1.418a1 1 0 0 0 1.414-1.414l-1.418-1.418A4.5 4.5 0 1 0 11.5 18Zm0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", "fill": "currentColor" } })]);
};
var documentDetails = {
  render: render$3h
};
var render$3g = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M2 3a3 3 0 0 1 3-3h10.218a3 3 0 0 1 2.102.86l3.782 3.713A3 3 0 0 1 22 6.713V21a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V3Zm13-.793a.5.5 0 0 1 .854-.353l4.292 4.292a.5.5 0 0 1-.353.854H17a2 2 0 0 1-2-2V2.207ZM11.5 18c.88 0 1.702-.253 2.396-.69l1.418 1.418a1 1 0 0 0 1.414-1.414l-1.418-1.418A4.5 4.5 0 1 0 11.5 18Zm0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", "fill": "currentColor" } })]);
};
var documentDetailsSolid = {
  render: render$3g
};
var render$3f = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8.75 10.17 5.29 6.71 3.52 8.48l4.715 4.745-.005.005L10 15l6.48-6.52-1.77-1.73-3.46 3.46V0h-2.5v10.17Z", "fill": "currentColor" } }), _c("path", { attrs: { "d": "M17.5 16.25V14H20v3a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-3h2.5v2.25a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25Z", "fill": "currentColor" } })]);
};
var download = {
  render: render$3f
};
var render$3e = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M22.935 12.262a.763.763 0 0 0-1.156-.997c-.086.1-1.199 1.364-2.96 2.602-1.769 1.243-4.165 2.44-6.82 2.44-2.655 0-5.05-1.197-6.818-2.44-1.764-1.239-2.877-2.505-2.962-2.601a.764.764 0 0 0-1.15 1.003c.076.088.555.632 1.35 1.346l-1.042 1.041a.636.636 0 1 0 .9.9l1.118-1.117a19.814 19.814 0 0 0 1.66 1.18l-.882 1.26a.636.636 0 0 0 1.043.73l.943-1.348c.64.34 1.33.653 2.066.909l-.823 1.763a.636.636 0 0 0 1.153.538l.863-1.851a.642.642 0 0 0 .035-.09c.606.143 1.236.243 1.885.284v2.134a.636.636 0 0 0 1.273 0v-2.131a11.198 11.198 0 0 0 1.92-.285c.01.047.026.094.047.139l.842 1.805a.636.636 0 0 0 1.153-.537l-.821-1.762c.73-.252 1.416-.56 2.052-.897l.93 1.327a.636.636 0 0 0 1.041-.73l-.866-1.236a19.816 19.816 0 0 0 1.836-1.315l1.232 1.231a.636.636 0 0 0 .9-.9l-1.164-1.163a15.879 15.879 0 0 0 1.222-1.232Z", "fill": "currentColor" } })]);
};
var eyeClosed = {
  render: render$3e
};
var render$3d = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M12.001 6C8.928 6 6.205 7.378 4.252 8.747l-3.31 2.906a.93.93 0 0 0 .001 1.22l.001.002c.112.128 1.35 1.53 3.308 2.903 1.953 1.37 4.676 2.748 7.75 2.748 3.071 0 5.794-1.378 7.746-2.748 1.955-1.371 3.192-2.772 3.31-2.908a.93.93 0 0 0 0-1.218c-.113-.132-1.35-1.533-3.308-2.906C17.798 7.378 15.074 6 12 6ZM3.29 11.934C4.903 10.44 8.248 7.864 12 7.864c3.746 0 7.091 2.577 8.709 4.07a.443.443 0 0 1 0 .66c-1.614 1.494-4.957 4.068-8.709 4.068-3.749 0-7.095-2.578-8.71-4.071a.442.442 0 0 1-.001-.657Zm6.536.369a2.174 2.174 0 1 1 4.348 0 2.174 2.174 0 0 1-4.348 0Z", "fill": "currentColor" } })]);
};
var eyeOpen = {
  render: render$3d
};
var render$3c = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M13 1.6H3a.4.4 0 0 0-.4.4v16c0 .22.18.4.4.4h14a.4.4 0 0 0 .4-.4V6H19v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h10v1.6Z", "fill": "currentColor" } }), _c("path", { attrs: { "d": "m13 0 6 6h-5a1 1 0 0 1-1-1V0Z", "fill": "currentColor" } }), _c("rect", { attrs: { "x": "5", "y": "14", "width": "10", "height": "1.6", "rx": ".8", "fill": "currentColor" } }), _c("rect", { attrs: { "x": "5", "y": "10", "width": "10", "height": "1.6", "rx": ".8", "fill": "currentColor" } })]);
};
var fileLinesOutline = {
  render: render$3c
};
var render$3b = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M.659 2.159A2.25 2.25 0 0 1 2.25 1.5h19.5A2.25 2.25 0 0 1 24 3.75v3a.75.75 0 0 1-.75.75H.75A.75.75 0 0 1 0 6.75v-3c0-.597.237-1.169.659-1.591ZM2.25 3a.75.75 0 0 0-.75.75V6h21V3.75a.75.75 0 0 0-.75-.75H2.25Zm0 6a.75.75 0 0 1 .75.75v9A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75v-9a.75.75 0 0 1 1.5 0v9a3.75 3.75 0 0 1-3.75 3.75H5.25a3.75 3.75 0 0 1-3.75-3.75v-9A.75.75 0 0 1 2.25 9Zm7.72 1.72a.75.75 0 0 1 .53-.22h3a.75.75 0 1 1 0 1.5h-3a.75.75 0 0 1-.53-1.28ZM10.5 9a2.25 2.25 0 1 0 0 4.5h3a2.25 2.25 0 0 0 0-4.5h-3Z", "fill": "currentColor" } })]);
};
var files = {
  render: render$3b
};
var render$3a = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 40 40", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("g", { attrs: { "stroke": "currentColor", "stroke-width": "2.5", "stroke-linecap": "round", "stroke-linejoin": "round" } }, [_c("path", { attrs: { "d": "M28.75 38.75c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10ZM28.75 33.75v-10M28.75 23.75 25 27.5M28.75 23.75l3.75 3.75" } }), _c("path", { attrs: { "d": "M13.75 33.75h-10a2.5 2.5 0 0 1-2.5-2.5V3.75a2.5 2.5 0 0 1 2.5-2.5h17.715a2.5 2.5 0 0 1 1.767.732l4.786 4.786a2.5 2.5 0 0 1 .732 1.767v5.215" } })])]);
};
var fileUpload = {
  render: render$3a
};
var render$39 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M1.875 10h16.25a.627.627 0 0 0 .625-.625v-1.25a.627.627 0 0 0-.625-.625h-.738a7.495 7.495 0 0 0-6.137-6.137V.625A.627.627 0 0 0 10.625 0h-1.25a.627.627 0 0 0-.625.625v.738c-3.137.528-5.61 3-6.137 6.137h-.738a.627.627 0 0 0-.625.625v1.25c0 .344.281.625.625.625Zm17.5 7.5h-.625v-.625a.627.627 0 0 0-.625-.625H17.5v-5H15v5h-3.75v-5h-2.5v5H5v-5H2.5v5h-.625a.627.627 0 0 0-.625.625v.625H.625a.627.627 0 0 0-.625.625v1.25c0 .344.281.625.625.625h18.75a.627.627 0 0 0 .625-.625v-1.25a.627.627 0 0 0-.625-.625Z", "fill": "currentColor" } })]);
};
var govtBuilding = {
  render: render$39
};
var render$38 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M24 14a4.5 4.5 0 0 0-3-4.24V9A9 9 0 1 0 3 9v.76a4.5 4.5 0 0 0 0 8.48 1.54 1.54 0 0 0 1.37-.18A1.53 1.53 0 0 0 5 16.83V9a7 7 0 1 1 14 0v7.83a1.49 1.49 0 0 0 .5 1.1v.57c0 1.48-1.29 2-2.5 2h-1.78a2 2 0 1 0 0 2H17c2.65 0 4.5-1.64 4.5-4V18a4.5 4.5 0 0 0 2.5-4Zm-12 4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm-1.616-7.866A1.25 1.25 0 0 1 8.25 9.25a3.75 3.75 0 1 1 5.25 3.44.42.42 0 0 0-.25.38v.56a1.25 1.25 0 0 1-2.5 0v-.56a2.91 2.91 0 0 1 1.75-2.67 1.25 1.25 0 1 0-1.75-1.15c0 .332-.132.65-.366.884Z", "fill": "currentColor" } })]);
};
var headset = {
  render: render$38
};
var render$37 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 22", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M21.67 1.94c-2.554-2.176-6.375-1.815-8.747.632L12 3.528l-.924-.951C9.165.599 5.306-.592 2.33 1.939-.614 4.452-.77 8.961 1.866 11.68l9.07 9.366c.29.3.675.454 1.06.454.384 0 .768-.15 1.059-.454l9.07-9.366c2.644-2.719 2.489-7.228-.455-9.74Zm-.614 8.7-9.037 9.365-9.075-9.366c-1.8-1.856-2.175-5.395.36-7.556 2.57-2.194 5.588-.605 6.694.54L12 5.688l2.002-2.067c1.087-1.125 4.134-2.719 6.693-.539 2.532 2.156 2.161 5.695.361 7.556Z", "fill": "currentColor" } })]);
};
var heart = {
  render: render$37
};
var render$36 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 22", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M21.67 1.934c-2.569-2.189-6.389-1.795-8.747.638L12 3.523l-.924-.951C8.723.139 4.898-.255 2.33 1.934-.614 4.447-.77 8.956 1.866 11.68l9.07 9.365a1.47 1.47 0 0 0 2.123 0l9.07-9.365c2.64-2.724 2.485-7.233-.459-9.746Z", "fill": "currentColor" } })]);
};
var heartSolid = {
  render: render$36
};
var render$35 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 19 19", "fill": "currentColor", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("g", { attrs: { "clip-path": "url(#a)" } }, [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM.833 10a9.167 9.167 0 1 1 18.334 0A9.167 9.167 0 0 1 .833 10Zm8.334-3.333c0-.46.373-.834.833-.834h.008a.833.833 0 0 1 0 1.667H10a.833.833 0 0 1-.833-.833Zm.833 2.5c.46 0 .834.373.834.833v3.333a.833.833 0 0 1-1.667 0V10c0-.46.373-.833.833-.833Z" } })]), _c("defs", [_c("clipPath", { attrs: { "id": "a" } }, [_c("path", { attrs: { "fill": "#fff", "d": "M0 0h30v30H0z" } })])])]);
};
var infoCircleLight = {
  render: render$35
};
var render$34 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 18 18", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M9.833.667h7.5V2.75h-7.5V.667Z", "fill": "currentColor" } }), _c("path", { attrs: { "d": "M17.333.667v7.5H15.25v-7.5h2.083Z", "fill": "currentColor" } }), _c("path", { attrs: { "d": "M15.513 1.014 7.43 9.097l1.473 1.473 8.184-8.184-1.574-1.372Z", "fill": "currentColor" } }), _c("path", { attrs: { "d": "M7.333 4.417H4c-.69 0-1.25.56-1.25 1.25V14c0 .69.56 1.25 1.25 1.25h8.333c.69 0 1.25-.56 1.25-1.25v-3.333h2.084V14a3.333 3.333 0 0 1-3.334 3.333H4A3.333 3.333 0 0 1 .667 14V5.667A3.333 3.333 0 0 1 4 2.333h3.333v2.084Z", "fill": "currentColor" } })]);
};
var linkOut = {
  render: render$34
};
var render$33 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 22 22", "fill": "currentColor", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M6 8a6 6 0 0 1 11.88-1.199 1 1 0 1 1-1.96.398A4.002 4.002 0 0 0 8 8v2.002C8.238 10 8.49 10 8.759 10h6.482c.805 0 1.47 0 2.01.044.563.046 1.08.145 1.565.392a4 4 0 0 1 1.748 1.748c.247.485.346 1.002.392 1.564.044.541.044 1.206.044 2.01v.483c0 .805 0 1.47-.044 2.01-.046.563-.145 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.247-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.01-.044-.563-.046-1.08-.145-1.565-.392a4 4 0 0 1-1.748-1.748c-.247-.485-.346-1.002-.392-1.564C3 17.71 3 17.046 3 16.242v-.483c0-.805 0-1.47.044-2.01.046-.563.145-1.08.392-1.565a4 4 0 0 1 1.748-1.748c.262-.134.533-.224.816-.286V8Zm.911 4.038c-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819C5 14.361 5 14.943 5 15.8v.4c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C7.361 20 7.943 20 8.8 20h6.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889v-.4c0-.857 0-1.439-.038-1.889-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18C16.639 12 16.057 12 15.2 12H8.8c-.857 0-1.439 0-1.889.038Z" } })]);
};
var lockUnlocked = {
  render: render$33
};
var render$32 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("g", { attrs: { "clip-path": "url(#clip0)", "fill-rule": "evenodd", "clip-rule": "evenodd", "fill": "currentColor" } }, [_c("path", { attrs: { "d": "M20.606 2.137a2.571 2.571 0 0 1 2.312.335l.002.001A2.572 2.572 0 0 1 24 4.556V18.673a2.571 2.571 0 0 1-1.077 2.08 2.572 2.572 0 0 1-2.311.359l-.003-.001-13.166-4.389a.857.857 0 0 1-.586-.813V7.337c0-.368.236-.696.586-.813l13.163-4.387Zm.95 1.586a.858.858 0 0 0-.4.037l-.005.002-12.58 4.193v7.336l12.577 4.192a.86.86 0 0 0 .772-.12l.006-.004a.857.857 0 0 0 .36-.692V4.563a.858.858 0 0 0-.36-.692.857.857 0 0 0-.37-.148Z" } }), _c("path", { attrs: { "d": "M3.175 6.872a5.143 5.143 0 0 1 1.968-.392h2.571c.474 0 .857.384.857.857v8.572a.857.857 0 0 1-.857.857H5.143a5.143 5.143 0 0 1-1.968-9.894Zm1.968 1.323a3.429 3.429 0 0 0 0 6.857h1.714V8.195H5.143Z" } }), _c("path", { attrs: { "d": "M5.143 15.052c.473 0 .857.383.857.857v1.714a3.43 3.43 0 0 0 3.429 3.429.857.857 0 0 1 0 1.714 5.142 5.142 0 0 1-5.143-5.143V15.91c0-.474.384-.857.857-.857Z" } })])]);
};
var megaphone = {
  render: render$32
};
var render$31 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("g", { attrs: { "clip-path": "url(#clip0)", "fill-rule": "evenodd", "clip-rule": "evenodd", "fill": "currentColor" } }, [_c("path", { attrs: { "d": "M20.606 2.137a2.571 2.571 0 0 1 2.312.335l.002.001A2.572 2.572 0 0 1 24 4.556V18.673a2.571 2.571 0 0 1-1.077 2.08 2.572 2.572 0 0 1-2.311.359l-.003-.001-13.166-4.389a.857.857 0 0 1-.586-.813V7.337c0-.368.236-.696.586-.813l13.163-4.387Z" } }), _c("path", { attrs: { "d": "M3.175 6.872a5.143 5.143 0 0 1 1.968-.392h2.571c.474 0 .857.384.857.857v8.572a.857.857 0 0 1-.857.857H5.143a5.143 5.143 0 0 1-1.968-9.894Z" } }), _c("path", { attrs: { "d": "M5.143 15.052c.473 0 .857.383.857.857v1.714a3.43 3.43 0 0 0 3.429 3.429.857.857 0 0 1 0 1.714 5.142 5.142 0 0 1-5.143-5.143V15.91c0-.474.383-.857.857-.857Z" } })])]);
};
var megaphoneSolid = {
  render: render$31
};
var render$30 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 17", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M4.593 3.333a1.26 1.26 0 1 0 0 2.519 1.26 1.26 0 0 0 0-2.519ZM19.407 10.74a1.259 1.259 0 1 0 0 2.519 1.259 1.259 0 0 0 0-2.518ZM12 4.444a3.852 3.852 0 1 0 0 7.704 3.852 3.852 0 0 0 0-7.704ZM10.533 6.83a2.074 2.074 0 1 1 2.934 2.933 2.074 2.074 0 0 1-2.934-2.933Z", "fill": "currentColor" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M0 .889C0 .398.398 0 .889 0H23.11c.491 0 .889.398.889.889v14.815c0 .49-.398.889-.889.889H.89a.889.889 0 0 1-.889-.89V.89Zm1.778.889v13.037h20.444V1.778H1.778Z", "fill": "currentColor" } })]);
};
var money = {
  render: render$30
};
var render$2$ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M17.187 9.211h-2.438a.75.75 0 1 0 0 1.5h.625a.25.25 0 0 1 .25.25v.22a.75.75 0 1 0 1.5 0v-.407a.063.063 0 0 1 .063-.063 1.45 1.45 0 0 0 1.561-1.562c0-.93-.95-1.57-1.955-2.247a9.315 9.315 0 0 1-1.24-.925.21.21 0 0 1-.053-.14h2.498a.75.75 0 1 0 0-1.5h-.624a.25.25 0 0 1-.25-.25V3.87a.75.75 0 1 0-1.5 0v.406a.063.063 0 0 1-.063.062 1.416 1.416 0 0 0-1.562 1.56c0 .93.95 1.57 1.956 2.246.442.276.86.589 1.249.936.03.036.045.081.043.127l-.06.005Z", "fill": "currentColor" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M16.425 15.149A7.574 7.574 0 1 0 8.85 7.575a7.581 7.581 0 0 0 7.574 7.574Zm0-13.148a5.575 5.575 0 1 1-3.941 1.632 5.58 5.58 0 0 1 3.94-1.636V2Z", "fill": "currentColor" } }), _c("path", { attrs: { "d": "M19.993 17.646h.01a2.48 2.48 0 0 1 2.403.47.518.518 0 0 1-.085.867c-6.006 3.039-7.848 4.449-9.784 4.59-1.685.124-3.441-.715-8.08-2.278a1.018 1.018 0 0 0-.857.1L.382 23.414A.25.25 0 0 1 0 23.202v-5.4a.25.25 0 0 1 .138-.223l3.018-1.508a3.99 3.99 0 0 1 1.788-.422h2.055a7.12 7.12 0 0 1 4 1.5h3.5a1 1 0 1 1 0 2h-4a.5.5 0 0 0 0 1h4a2 2 0 0 0 1.82-1.193.255.255 0 0 1 .154-.142l3.52-1.168Z", "fill": "currentColor" } })]);
};
var moneyHand = {
  render: render$2$
};
var render$2_ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 16", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M22.956 0H1.043A1.043 1.043 0 0 0 0 1.043V14.61a1.043 1.043 0 0 0 1.043 1.043h21.913A1.044 1.044 0 0 0 24 14.61V1.043A1.043 1.043 0 0 0 22.956 0ZM3.13 4.174a1.044 1.044 0 1 1 0-2.087 1.044 1.044 0 0 1 0 2.087ZM12 10.956a3.13 3.13 0 1 1 0-6.26 3.13 3.13 0 0 1 0 6.26Zm8.87 2.61a1.044 1.044 0 1 1 0-2.089 1.044 1.044 0 0 1 0 2.088Z", "fill": "currentColor" } })]);
};
var moneySolid = {
  render: render$2_
};
var render$2Z = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("g", { attrs: { "clip-path": "url(#a)" } }, [_c("path", { attrs: { "d": "M10 7.105c-1.515 0-2.743 1.432-2.743 3.2 0 1.767 1.228 3.2 2.743 3.2 1.514 0 2.743-1.433 2.743-3.2 0-1.768-1.228-3.2-2.743-3.2Zm0 5.486c-1.008 0-1.829-1.026-1.829-2.286S8.991 8.019 10 8.019c1.008 0 1.829 1.025 1.829 2.286 0 1.26-.82 2.286-1.829 2.286Zm8.605-8.044c-1.109-.465-2.218-.642-3.326-.642-3.52 0-7.038 1.78-10.558 1.78-1.854 0-2.524-.437-2.942-.437a.91.91 0 0 0-.922.909v9.064c0 .36.207.703.538.842 1.109.465 2.218.642 3.326.642 3.52 0 7.038-1.782 10.558-1.782 1.854 0 2.524.439 2.942.439a.91.91 0 0 0 .922-.909V5.39a.91.91 0 0 0-.538-.843ZM1.799 6.168c.577.184 1.172.301 1.79.369a1.828 1.828 0 0 1-1.797 1.726L1.8 6.17Zm-.028 9.052.004-1.215c.96.002 1.74.751 1.811 1.698a7.026 7.026 0 0 1-1.815-.483Zm16.43-.78a9.16 9.16 0 0 0-1.784-.369 1.827 1.827 0 0 1 1.79-1.671l-.006 2.04Zm.01-2.96c-1.43.01-2.589 1.124-2.703 2.532-2.02-.04-3.92.452-5.731.91-2.145.544-3.616.893-5.27.854a2.748 2.748 0 0 0-2.73-2.69l.012-3.904c1.448-.01 2.621-1.152 2.708-2.586 2.016.04 3.915-.453 5.726-.91 2.137-.542 3.614-.893 5.264-.855a2.75 2.75 0 0 0 2.735 2.745l-.012 3.905Zm.014-4.822a1.83 1.83 0 0 1-1.817-1.754c.644.087 1.251.242 1.82.483l-.003 1.271Z", "fill": "currentColor" } })]), _c("defs", [_c("clipPath", { attrs: { "id": "a" } }, [_c("path", { attrs: { "fill": "#fff", "transform": "translate(.857 .857)", "d": "M0 0h18.286v18.286H0z" } })])])]);
};
var moneyWaveLight = {
  render: render$2Z
};
var render$2Y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M7.617 12.361h1.349l1.977 1.977v1.35a.95.95 0 1 1-1.9 0v-1.426H7.616a.95.95 0 0 1 0-1.9Z", "fill": "currentColor" } }), _c("path", { attrs: { "d": "M7.617 12.361h1.349l1.977 1.977v1.35a.95.95 0 1 1-1.9 0v-1.426H7.616a.95.95 0 0 1 0-1.9Z", "fill": "currentColor" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M4.444 1.685A10 10 0 0 1 10 0a10.036 10.036 0 0 1 10 10A10 10 0 1 1 4.444 1.685Zm9.576 15.65c.3-.166.588-.352.864-.555a.205.205 0 0 0 .024-.31L3.531 5.093a.204.204 0 0 0-.31.024 7.98 7.98 0 0 0-.554.864A8.363 8.363 0 0 0 14.02 17.335Zm2.33-1.93a.207.207 0 0 0 .067-.05A8.354 8.354 0 0 0 4.646 3.582a.202.202 0 0 0-.073.15.207.207 0 0 0 .06.154L7.277 6.53a2.391 2.391 0 0 1 1.765-.794V4.284a.95.95 0 1 1 1.9 0v1.425h1.426a.95.95 0 0 1 0 1.9H9.518c-.131 0-.692.016-.885.275l.86.86c.307.141.627.269.852.359 1.326.53 2.974 1.19 2.974 2.783.026.22.017.442-.025.658l2.821 2.823a.204.204 0 0 0 .235.039Z", "fill": "currentColor" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M4.444 1.685A10 10 0 0 1 10 0a10.036 10.036 0 0 1 10 10A10 10 0 1 1 4.444 1.685Zm9.576 15.65c.3-.166.588-.352.864-.555a.205.205 0 0 0 .024-.31L3.531 5.093a.204.204 0 0 0-.31.024 7.98 7.98 0 0 0-.554.864A8.363 8.363 0 0 0 14.02 17.335Zm2.33-1.93a.207.207 0 0 0 .067-.05A8.354 8.354 0 0 0 4.646 3.582a.202.202 0 0 0-.073.15.207.207 0 0 0 .06.154L7.277 6.53a2.391 2.391 0 0 1 1.765-.794V4.284a.95.95 0 1 1 1.9 0v1.425h1.426a.95.95 0 0 1 0 1.9H9.518c-.131 0-.692.016-.885.275l.86.86c.307.141.627.269.852.359 1.326.53 2.974 1.19 2.974 2.783.026.22.017.442-.025.658l2.821 2.823a.204.204 0 0 0 .235.039Z", "fill": "currentColor" } })]);
};
var noHidden = {
  render: render$2Y
};
var render$2X = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 25 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M22.882.809a.81.81 0 1 0 1.62 0 .81.81 0 0 0-1.62 0ZM13.443 6.953a.75.75 0 0 1-.53-1.28 3.084 3.084 0 0 0 0-4.353.75.75 0 0 1 1.06-1.06 4.583 4.583 0 0 1 0 6.473.745.745 0 0 1-.53.22ZM23.423 11.75a.747.747 0 0 0 .979-.407.751.751 0 0 0-.162-.817 4.579 4.579 0 0 0-6.473 0 .75.75 0 0 0 1.061 1.061 3.152 3.152 0 0 1 4.352 0c.07.07.152.125.243.163ZM20.692 15.135a.809.809 0 1 1 1.144-1.144.809.809 0 0 1-1.144 1.144ZM9.365 3.808a.809.809 0 1 1 1.144-1.144.809.809 0 0 1-1.144 1.144ZM22.849 7.044A.81.81 0 1 1 23.993 5.9a.81.81 0 0 1-1.144 1.144ZM16.679 8.571a.75.75 0 0 1-.53-1.28l5.124-5.124a.75.75 0 0 1 1.06 1.061l-5.124 5.124a.747.747 0 0 1-.53.219Z", "fill": "currentColor" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M7.586 7.966c1.608-1.606 4.703-.203 6.93 2.013 2.22 2.231 3.624 5.321 2.022 6.923-.16.168-.352.304-.564.4l-12 6.417a2.363 2.363 0 0 1-3.194-3.2S7.191 8.514 7.228 8.451a1.9 1.9 0 0 1 .358-.485Zm7.422 7.422.003-.003c.23-.23-.12-1.972-2.02-3.885a6.312 6.312 0 0 0-3.625-2.08.371.371 0 0 0-.248.062c-.345.346.51 2.348 2.028 3.868 1.014 1.017 2.706 2.1 3.614 2.1.18.009.23-.043.248-.062Z", "fill": "currentColor" } })]);
};
var party = {
  render: render$2X
};
var render$2W = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("g", { attrs: { "clip-path": "url(#clip0)", "fill": "currentColor" } }, [_c("path", { attrs: { "d": "M14.779 5.67a1.471 1.471 0 0 0-.682-.14h-.023l-.012.001c-.422 0-.776.13-1.008.303-.231.173-.304.356-.304.494 0 .139.073.321.304.495.232.174.586.303 1.008.303.716 0 1.392.217 1.907.603.514.387.902.978.902 1.693 0 .716-.39 1.307-.904 1.694-.33.247-.725.425-1.155.52V12a.75.75 0 0 1-1.5 0v-.353a2.972 2.972 0 0 1-1.709-1.099.75.75 0 1 1 1.194-.908 1.475 1.475 0 0 0 1.231.58h.018l.012-.001c.423 0 .777-.13 1.009-.303.231-.174.304-.356.304-.494 0-.139-.073-.32-.303-.494-.23-.173-.584-.302-1.006-.302-.716 0-1.393-.217-1.908-.604-.515-.386-.904-.978-.904-1.694 0-.717.389-1.308.904-1.694.33-.248.727-.426 1.158-.521V3.75a.75.75 0 0 1 1.5 0v.353a2.972 2.972 0 0 1 1.705 1.1.75.75 0 0 1-1.194.907 1.472 1.472 0 0 0-.544-.44ZM7.5 3.75a.75.75 0 0 0 0 1.5H9a.75.75 0 0 0 0-1.5H7.5ZM6.75 7.5a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 0 1.5H7.5a.75.75 0 0 1-.75-.75ZM7.5 9.75a.75.75 0 0 0 0 1.5H9a.75.75 0 0 0 0-1.5H7.5Z" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M6 0a2.25 2.25 0 0 0-2.25 2.25v9.078l-.568-.45A1.5 1.5 0 0 0 .75 12.05v9.701A2.25 2.25 0 0 0 3 24.002h18a2.25 2.25 0 0 0 2.25-2.25v-9.7a1.501 1.501 0 0 0-2.432-1.175l-.568.45V2.25A2.25 2.25 0 0 0 18 0H6Zm10.934 15.873 2.346 2.347a.75.75 0 1 1-1.06 1.06l-2.47-2.469-1.43 1.136-.004.002a3.75 3.75 0 0 1-4.632 0l-.003-.002-1.432-1.136-2.469 2.47a.75.75 0 0 1-1.06-1.061l2.346-2.347-4.816-3.82v9.699a.75.75 0 0 0 .75.75h18a.75.75 0 0 0 .75-.75v-9.7l-4.816 3.82Zm-8.258-.638a.801.801 0 0 0-.037-.03L5.25 12.519V2.25A.75.75 0 0 1 6 1.5h12a.75.75 0 0 1 .75.75v10.268l-3.389 2.688a.711.711 0 0 0-.036.029l-1.935 1.534-.002.001a2.25 2.25 0 0 1-2.776 0h-.002l-1.934-1.535Z" } })])]);
};
var payroll = {
  render: render$2W
};
var render$2V = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 15 15", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M10.362 1.529a2.552 2.552 0 1 1 3.61 3.61l-1.999 1.998-.002.001-.001.002-6.803 6.803-.033.033a3.126 3.126 0 0 1-.478.42 2 2 0 0 1-.485.233c-.195.064-.398.086-.628.111l-.046.005-2.257.251a.667.667 0 0 1-.736-.736l.25-2.256a41.5 41.5 0 0 0 .006-.047c.025-.23.048-.432.11-.627a2 2 0 0 1 .234-.485c.113-.171.257-.316.42-.479l.034-.033 8.804-8.804ZM8.833 4.943l-6.332 6.333c-.215.215-.255.26-.284.303a.669.669 0 0 0-.078.161c-.016.05-.025.109-.059.41l-.159 1.429 1.428-.159c.302-.033.361-.043.41-.06a.665.665 0 0 0 .163-.077c.043-.028.087-.068.302-.283l6.333-6.333-1.724-1.724Zm2.667.781L9.776 4l1.529-1.528a1.219 1.219 0 1 1 1.724 1.723L11.5 5.725Z", "fill": "currentColor" } })]);
};
var penLine = {
  render: render$2V
};
var render$2U = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M5.754 3.052a.833.833 0 0 0-.752 0c-.09.045-.2.141-.69.63l-.13.132c-.467.466-.593.601-.694.78a2.003 2.003 0 0 0-.213.822c0 .212.031.34.17.824a15.032 15.032 0 0 0 3.848 6.542 15.031 15.031 0 0 0 6.541 3.849c.486.137.613.168.825.17.238 0 .614-.098.821-.214.18-.101.314-.227.781-.694l.131-.131c.49-.49.586-.6.63-.69a.833.833 0 0 0 0-.751c-.044-.09-.14-.2-.63-.69l.59-.588-.59.589-.162-.163c-.321-.321-.394-.387-.448-.422a.833.833 0 0 0-.909 0c-.055.035-.127.1-.448.422l-.02.02c-.075.075-.17.17-.283.251l-.485-.677.485.677c-.406.291-.957.385-1.437.245a2.065 2.065 0 0 1-.329-.133l-.02-.01a13.002 13.002 0 0 1-3.57-2.533 13.001 13.001 0 0 1-2.534-3.57l-.01-.02a2.072 2.072 0 0 1-.133-.33l.8-.233-.8.233c-.14-.479-.045-1.03.245-1.436a2.26 2.26 0 0 1 .252-.283l.02-.02c.32-.321.387-.394.422-.448a.833.833 0 0 0 0-.909c-.035-.055-.101-.127-.423-.448l-.162-.163c-.49-.489-.6-.585-.689-.63ZM4.25 1.565a2.5 2.5 0 0 1 2.256 0c.36.182.674.496 1.036.859l.08.08.162.162.053.053c.238.238.444.444.589.666l-.7.454.7-.454a2.5 2.5 0 0 1 0 2.725c-.145.222-.35.427-.59.666l-.052.053a5.21 5.21 0 0 0-.09.095l-.001.005a1.79 1.79 0 0 0 .042.088 11.336 11.336 0 0 0 2.21 3.113c.934.934 1.988 1.67 3.113 2.21l-.361.751.36-.75.064.03.025.011h.005a5.232 5.232 0 0 0 .148-.143c.238-.24.444-.446.666-.59a2.5 2.5 0 0 1 2.725 0c.222.145.428.35.666.59l.053.052-.59.59.59-.59.162.162.08.08c.363.362.677.675.859 1.036a2.5 2.5 0 0 1 0 2.256c-.182.36-.496.674-.86 1.036l-.079.08-.131.13-.057.057c-.387.388-.685.686-1.086.912a3.638 3.638 0 0 1-1.643.427c-.46-.002-.795-.097-1.228-.22l-.047-.013a16.7 16.7 0 0 1-7.265-4.274 16.7 16.7 0 0 1-4.273-7.265c-.005-.015-.01-.031-.013-.047-.123-.432-.219-.767-.22-1.227a3.638 3.638 0 0 1 .427-1.643c.226-.401.523-.699.911-1.087.02-.018.038-.037.057-.056l.131-.131.08-.08c.362-.363.675-.677 1.036-.86l.371.736-.371-.735Z", "fill": "currentColor" } })]);
};
var phoneOutline = {
  render: render$2U
};
var render$2T = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("g", { attrs: { "clip-path": "url(#clip0)", "fill": "currentColor" } }, [_c("path", { attrs: { "d": "M9.75 1.511a3 3 0 0 0-3 3 .75.75 0 0 1-.75.75H2.25a.75.75 0 0 0-.75.75v15.75a.75.75 0 0 0 .75.75h7.5a.75.75 0 0 1 0 1.5h-7.5A2.25 2.25 0 0 1 0 21.761V6.011a2.25 2.25 0 0 1 2.25-2.25h3.063a4.5 4.5 0 0 1 8.874 0h3.063a2.25 2.25 0 0 1 2.25 2.25v2.25a.75.75 0 0 1-1.5 0v-2.25a.75.75 0 0 0-.75-.75H13.5a.75.75 0 0 1-.75-.75 3 3 0 0 0-3-3Z" } }), _c("path", { attrs: { "d": "M4.5 10.511a.75.75 0 0 1 .75-.75h5.25a.75.75 0 0 1 0 1.5H5.25a.75.75 0 0 1-.75-.75ZM4.5 14.261a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM5.25 17.261a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3ZM8.954 3.34a1.125 1.125 0 1 1 1.592 1.591 1.125 1.125 0 0 1-1.591-1.59ZM20.524 15.966a.75.75 0 1 0-1.2-.9l-2.904 3.873h-.002l-1.5-1.5a.75.75 0 0 0-1.06 1.061l1.5 1.5a1.501 1.501 0 0 0 2.26-.16l2.906-3.874Z" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M12.477 12.488a6.75 6.75 0 1 1 9.546 9.546 6.75 6.75 0 0 1-9.546-9.546Zm4.773-.477a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5Z" } })])]);
};
var policy = {
  render: render$2T
};
var render$2S = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("g", { attrs: { "clip-path": "url(#a)", "fill-rule": "evenodd", "clip-rule": "evenodd", "fill": "currentColor" } }, [_c("path", { attrs: { "d": "M3.607 3.45a.156.156 0 0 0-.157.157v12.5a.156.156 0 0 0 .157.156h8.125a.469.469 0 0 1 0 .938H3.607a1.094 1.094 0 0 1-1.094-1.094v-12.5a1.094 1.094 0 0 1 1.094-1.094h10.937a.469.469 0 1 1 0 .938H3.607Z" } }), _c("path", { attrs: { "d": "M4.701 10.795h5.929v.937H4.7v-.937ZM4.701 13.347h5.18v.937h-5.18v-.937ZM4.139 5.357c0-.259.21-.469.469-.469h3.75c.259 0 .468.21.468.47v3c0 .258-.21.468-.468.468h-3.75a.469.469 0 0 1-.47-.469v-3Zm.937.469v2.062H7.89V5.826H5.076ZM14.544 5.95a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM12.357 7.2a2.188 2.188 0 1 1 4.375.001 2.188 2.188 0 0 1-4.375 0Z" } }), _c("path", { attrs: { "d": "M12.666 9.854a2.656 2.656 0 0 1 4.534 1.878v1.875c0 .26-.21.469-.468.469h-.558l-.225 2.695a.469.469 0 0 1-.467.43h-1.875a.469.469 0 0 1-.467-.43l-.225-2.695h-.558a.469.469 0 0 1-.47-.469v-1.875c0-.704.28-1.38.779-1.878Zm1.878.16a1.719 1.719 0 0 0-1.719 1.718v1.406h.521c.244 0 .447.187.467.43l.225 2.695h1.012l.225-2.695a.469.469 0 0 1 .467-.43h.52v-1.406a1.719 1.719 0 0 0-1.718-1.719Z" } })]), _c("defs", [_c("clipPath", { attrs: { "id": "a" } }, [_c("path", { attrs: { "fill": "#fff", "transform": "translate(2.357 2.357)", "d": "M0 0h15v15H0z" } })])])]);
};
var recruiting = {
  render: render$2S
};
var render$2R = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("g", { attrs: { "clip-path": "url(#clip0)" } }, [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M3.75 1.511a2.25 2.25 0 0 0-2.25 2.25v16.5a2.25 2.25 0 0 0 2.25 2.25H15v-3.75a3.75 3.75 0 0 1 3.75-3.75h3.75V3.761a2.25 2.25 0 0 0-2.25-2.25H3.75Zm18.376 15H18.75a2.25 2.25 0 0 0-2.25 2.25v3.376c.125-.082.242-.178.349-.284l4.992-4.993.534.534-.534-.534c.107-.108.202-.224.285-.349Zm.775 1.41A3.75 3.75 0 0 0 24 15.268V3.761a3.75 3.75 0 0 0-3.75-3.75H3.75A3.75 3.75 0 0 0 0 3.761v16.5a3.75 3.75 0 0 0 3.75 3.75h11.507a3.75 3.75 0 0 0 2.652-1.098l4.992-4.993ZM16.843 7.15a.75.75 0 0 1 0 1.06l-5.592 5.593a1.57 1.57 0 0 1-2.218 0l-1.875-1.872a.75.75 0 1 1 1.06-1.062l1.875 1.872a.07.07 0 0 0 .098 0l5.592-5.591a.75.75 0 0 1 1.06 0Z", "fill": "currentColor" } })])]);
};
var reportCard = {
  render: render$2R
};
var render$2Q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 16 16", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M14.5 12.5h-7l-4 3v-3h-2a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1Z", "stroke": "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M9.597 4.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0v0Z", "stroke": "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M13.695 8A3 3 0 0 0 8.5 8M3.75 4.75a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0v0ZM2.5 10a3 3 0 1 1 6 0", "stroke": "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var request = {
  render: render$2Q
};
var render$2P = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("g", { attrs: { "clip-path": "url(#a)" } }, [_c("path", { attrs: { "d": "M17.517 3.847 10.66.989a1.72 1.72 0 0 0-1.318 0L2.485 3.847c-.64.264-1.057.889-1.057 1.582 0 7.089 4.09 11.989 7.91 13.582a1.72 1.72 0 0 0 1.319 0c3.06-1.275 7.914-5.679 7.914-13.582 0-.693-.418-1.318-1.054-1.582Zm-7.296 14.11a.585.585 0 0 1-.44 0c-3.496-1.386-7.21-6.243-7.21-12.528 0-.232.14-.44.35-.529l6.857-2.857a.568.568 0 0 1 .44 0L17.073 4.9c.215.09.35.297.35.529.004 6.285-3.71 11.143-7.203 12.528Z", "fill": "currentColor" } })]), _c("defs", [_c("clipPath", { attrs: { "id": "a" } }, [_c("path", { attrs: { "fill": "#fff", "transform": "translate(.857 .857)", "d": "M0 0h18.286v18.286H0z" } })])])]);
};
var shield = {
  render: render$2P
};
var render$2O = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M11.5 10.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5S10 12.83 10 12s.67-1.5 1.5-1.5ZM10 6.375c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5-1.5.67-1.5 1.5Zm0 11.25c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5-1.5.67-1.5 1.5Z", "fill": "currentColor" } })]);
};
var threeDotVert = {
  render: render$2O
};
var render$2N = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 16 16", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M15 .5H1a1 1 0 0 0-1 1v1.667a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V1.5a1 1 0 0 0-1-1ZM15 6.167H1a1 1 0 0 0-1 1v1.667a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7.167a1 1 0 0 0-1-1ZM15 11.833H1a1 1 0 0 0-1 1V14.5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.667a1 1 0 0 0-1-1Z", "fill": "currentColor" } })]);
};
var threeStack = {
  render: render$2N
};
var render$2M = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 16 16", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M3.441 2h9.118c.352 0 .655 0 .904.02.264.022.526.07.778.198a2 2 0 0 1 .874.874c.129.252.176.514.198.778.02.25.02.553.02.904v.893a.667.667 0 0 1-.666.666 1.667 1.667 0 0 0 0 3.334c.368 0 .666.298.666.666v.893c0 .351 0 .654-.02.904a2.035 2.035 0 0 1-.198.778 2 2 0 0 1-.874.874 2.036 2.036 0 0 1-.778.198c-.25.02-.552.02-.904.02H3.441c-.351 0-.655 0-.904-.02a2.036 2.036 0 0 1-.778-.198 2 2 0 0 1-.874-.874 2.037 2.037 0 0 1-.198-.778c-.02-.25-.02-.553-.02-.904v-.893c0-.368.298-.666.666-.666a1.667 1.667 0 0 0 0-3.334.667.667 0 0 1-.666-.666v-.893c0-.351 0-.654.02-.904.022-.264.07-.526.198-.778a2 2 0 0 1 .874-.874c.252-.129.514-.176.778-.198C2.787 2 3.09 2 3.44 2Zm-.796 1.35c-.18.014-.248.04-.28.056a.667.667 0 0 0-.292.291c-.017.033-.042.1-.057.282C2.001 4.167 2 4.416 2 4.8v.274a3.001 3.001 0 0 1 0 5.852v.274c0 .384 0 .633.016.821.015.182.04.249.057.282a.667.667 0 0 0 .291.291c.033.017.1.042.281.057.19.015.437.016.822.016h9.066c.385 0 .633 0 .822-.016.181-.015.248-.04.281-.057a.667.667 0 0 0 .291-.291c.017-.033.042-.1.057-.282.016-.188.016-.437.016-.821v-.274a3.001 3.001 0 0 1 0-5.852V4.8c0-.384 0-.633-.016-.821-.015-.182-.04-.249-.057-.282a.667.667 0 0 0-.29-.291c-.034-.017-.101-.042-.282-.057a11.332 11.332 0 0 0-.822-.016H3.467c-.385 0-.633 0-.822.016ZM6.667 4c.368 0 .666.298.666.667v.666a.667.667 0 0 1-1.333 0v-.666C6 4.298 6.3 4 6.667 4Zm0 3c.368 0 .666.298.666.667v.666a.667.667 0 0 1-1.333 0v-.666C6 7.298 6.3 7 6.667 7Zm0 3c.368 0 .666.299.666.667v.666a.667.667 0 1 1-1.333 0v-.666c0-.368.299-.667.667-.667Z", "fill": "currentColor" } })]);
};
var ticket$1 = {
  render: render$2M
};
var render$2L = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M5.25 0a3.75 3.75 0 1 0 0 7.5A5.25 5.25 0 0 0 0 12.75v3c0 .414.336.75.75.75h.821l.683 6.825A.75.75 0 0 0 3 24h4.5a.75.75 0 0 0 .746-.675L8.93 16.5h.821a.75.75 0 0 0 .75-.75v-3A5.25 5.25 0 0 0 5.25 7.5a3.75 3.75 0 0 0 0-7.5ZM4.5 14.25V9.076a3.75 3.75 0 0 0-3 3.674V15h.75a.75.75 0 0 1 .746.675L3.68 22.5H6.82l.683-6.825A.75.75 0 0 1 8.25 15H9v-2.25a3.75 3.75 0 0 0-3-3.674v5.174a.75.75 0 0 1-1.5 0ZM3.659 2.159a2.25 2.25 0 1 1 3.182 3.182 2.25 2.25 0 0 1-3.182-3.182Z", "fill": "currentColor" } }), _c("path", { attrs: { "d": "M11.25 0a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 1 .75.75V15a.75.75 0 0 1-.75.75h-9a.75.75 0 0 0 0 1.5h9A2.25 2.25 0 0 0 24 15V2.25A2.25 2.25 0 0 0 21.75 0h-10.5Z", "fill": "currentColor" } })]);
};
var training = {
  render: render$2L
};
var render$2K = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("rect", { attrs: { "fill": "#fff" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M4 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h12v-2H8a5 5 0 0 0-5-5v-2a5 5 0 0 0 5-5h8a5 5 0 0 0 5 5v3h2V7a3 3 0 0 0-3-3H4Zm17 5V7a1 1 0 0 0-1-1h-2a3 3 0 0 0 3 3ZM3 15a3 3 0 0 1 3 3H4a1 1 0 0 1-1-1v-2Zm3-9H4a1 1 0 0 0-1 1v2a3 3 0 0 0 3-3Z", "fill": "currentColor" } }), _c("path", { attrs: { "d": "M12 16c1.657 0 3-1.79 3-4s-1.343-4-3-4-3 1.79-3 4 1.343 4 3 4ZM19.647 20.924l-1.262 1.058c-.698.585-.385 2.018.44 2.018h4.35c.825 0 1.138-1.433.44-2.018l-1.262-1.058c-.511-.429-.511-1.42 0-1.848l1.262-1.058c.698-.585.385-2.018-.44-2.018h-4.35c-.825 0-1.138 1.433-.44 2.018l1.262 1.058c.511.429.511 1.42 0 1.848Z", "fill": "currentColor" } })]);
};
var transactionProcessing = {
  render: render$2K
};
var render$2J = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M5 4H4a3 3 0 0 0-3 3v1h1a3 3 0 0 0 3-3V4Z", "fill": "currentColor" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M1 10h1a5 5 0 0 0 5-5V4h10v1a5 5 0 0 0 5 5h1v4h-4a3 3 0 0 0-3 3v3H7v-1a5 5 0 0 0-5-5H1v-4Zm14 2c0 2.21-1.343 4-3 4s-3-1.79-3-4 1.343-4 3-4 3 1.79 3 4Z", "fill": "currentColor" } }), _c("path", { attrs: { "d": "M1 16v1a3 3 0 0 0 3 3h1v-1a3 3 0 0 0-3-3H1ZM23 8V7a3 3 0 0 0-3-3h-1v1a3 3 0 0 0 3 3h1ZM19.647 19.076c.511.429.511 1.42 0 1.848l-1.262 1.058c-.698.585-.385 2.018.44 2.018h4.35c.825 0 1.138-1.433.44-2.018l-1.262-1.058c-.511-.429-.511-1.42 0-1.848l1.262-1.058c.698-.585.385-2.018-.44-2.018h-4.35c-.825 0-1.138 1.433-.44 2.018l1.262 1.058Z", "fill": "currentColor" } })]);
};
var transactionProcessingSolid = {
  render: render$2J
};
var render$2I = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 16 14", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M15 .333H1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1ZM15 7.666H1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Z", "fill": "currentColor" } })]);
};
var twoStack = {
  render: render$2I
};
var render$2H = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 8 12", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { staticClass: "up-down__down", attrs: { "d": "M4.39 11.512a.5.5 0 0 1-.78 0l-2.96-3.7A.5.5 0 0 1 1.04 7h5.92a.5.5 0 0 1 .39.812l-2.96 3.7Z", "fill": "currentColor" } }), _c("path", { staticClass: "up-down__up", attrs: { "d": "M4.39.488a.5.5 0 0 0-.78 0l-2.96 3.7A.5.5 0 0 0 1.04 5h5.92a.5.5 0 0 0 .39-.812L4.39.488Z", "fill": "currentColor" } })]);
};
var upDown = {
  render: render$2H
};
var render$2G = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 22 22", "fill": "currentColor", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("rect", { attrs: { "x": "1.5", "y": "1.5", "width": "19", "height": "19", "rx": "9.5" } }), _c("rect", { attrs: { "x": "1.5", "y": "1.5", "width": "19", "height": "19", "rx": "9.5", "stroke": "currentColor", "stroke-width": "3" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M11 5a6 6 0 0 0-3 11.198.667.667 0 1 1-.667 1.154 7.333 7.333 0 1 1 7.055.154l-.03.015c-.216.112-.455.238-.728.309-.306.08-.616.085-.988.034-.342-.046-.714-.22-1.004-.396-.29-.176-.616-.425-.815-.707-.49-.694-.49-1.357-.49-2.198v-4.62L8.805 11.47a.667.667 0 1 1-.943-.943l2.667-2.666a.667.667 0 0 1 .943 0l2.666 2.666a.667.667 0 0 1-.943.943l-1.528-1.528v4.524c0 .967.02 1.207.244 1.524.045.064.192.2.418.337.227.137.415.204.492.215.258.035.383.02.473-.004.111-.029.221-.082.477-.216A6 6 0 0 0 11 5Z", "fill": "#fff" } })]);
};
var upgrade = {
  render: render$2G
};
var render$2F = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 16 18", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "fill-rule": "evenodd", "fill": "currentColor", "clip-rule": "evenodd", "d": "M7.821.157c-.133.027-.26.096-.512.234L.732 3.995c-.267.146-.4.22-.497.323a.874.874 0 0 0-.19.319C0 4.77 0 4.92 0 5.22v7.116c0 .3 0 .45.045.585.04.118.105.227.19.319.097.103.23.176.497.322l6.577 3.604c.253.138.379.207.512.234.118.024.24.024.358 0 .134-.027.26-.096.512-.234l6.578-3.604c.266-.146.399-.219.496-.322.086-.092.15-.201.19-.32.045-.133.045-.284.045-.584V5.221c0-.3 0-.45-.045-.584a.875.875 0 0 0-.19-.32c-.097-.103-.23-.176-.496-.322L8.69.391C8.439.253 8.313.184 8.179.157a.901.901 0 0 0-.358 0Zm-.418 1.367L1.713 4.64c-.23.126-.345.189-.428.279a.756.756 0 0 0-.165.276c-.039.116-.039.245-.039.505v6.154c0 .26 0 .39.039.506.034.102.09.197.165.276.083.09.199.153.429.279l5.689 3.117c.218.12.327.18.443.203a.78.78 0 0 0 .31 0c.115-.024.224-.084.442-.203l5.689-3.117c.23-.126.345-.19.43-.279a.757.757 0 0 0 .164-.276c.039-.116.039-.246.039-.506V5.701c0-.26 0-.39-.04-.505a.757.757 0 0 0-.164-.276c-.084-.09-.199-.153-.43-.28L8.599 1.525c-.218-.12-.327-.18-.443-.203a.78.78 0 0 0-.31 0c-.115.024-.224.083-.442.203Z" } })]);
};
var logoHex = {
  render: render$2F
};
var render$2E = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.getComponent(_vm.icon), _vm._g(_vm._b({ tag: "component", staticClass: "base-icon", attrs: { "icon": _vm.getIcon(_vm.icon) } }, "component", _vm.$attrs, false), _vm.$listeners));
};
var staticRenderFns$1s = [];
var BaseIcon_vue_vue_type_style_index_0_lang = "";
function normalizeComponent(scriptExports, render3, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render3) {
    options.render = render3;
    options.staticRenderFns = staticRenderFns2;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(
        this,
        (options.functional ? this.parent : this).$root.$options.shadowRoot
      );
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h2, context) {
        hook.call(context);
        return originalRender(h2, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const FAIcons = Object.freeze({
  alert: faExclamation.faExclamation,
  alertCircle: faExclamationCircle.faExclamationCircle,
  alertTriangle: faExclamationTriangle.faExclamationTriangle,
  analytics: faAnalytics.faAnalytics,
  analyticsSolid: faAnalytics$1.faAnalytics,
  arrowLeft: faArrowLeft.faArrowLeft,
  arrowRight: faArrowRight.faArrowRight,
  badgeDollarSolid: faBadgeDollar.faBadgeDollar,
  ballotCheck: faBallotCheck.faBallotCheck,
  ballotCheckSolid: faBallotCheck$1.faBallotCheck,
  ban: faBan.faBan,
  bell: faBell.faBell,
  briefcaseSolid: faBriefcase.faBriefcase,
  building: faBuilding.faBuilding,
  cabinetFiling: faCabinetFiling.faCabinetFiling,
  cabinetFilingSolid: faCabinetFiling$1.faCabinetFiling,
  calendar: faCalendar.faCalendar,
  camera: faCameraAlt.faCameraAlt,
  check: faCheck.faCheck,
  checkCircle: faCheckCircle.faCheckCircle,
  checkCircleSolid: faCheckCircle$1.faCheckCircle,
  chevronLeft: faChevronLeft.faChevronLeft,
  chevronRight: faChevronRight.faChevronRight,
  chevronDown: faChevronDown.faChevronDown,
  chevronUp: faChevronUp.faChevronUp,
  circle: faCircle.faCircle,
  clipboardCheck: faClipboardCheck.faClipboardCheck,
  clipboardCheckSolid: faClipboardCheck$1.faClipboardCheck,
  clock: faClock.faClock,
  close: faTimes.faTimes,
  closeCircle: faTimesCircle.faTimesCircle,
  closeHexagonSolid: faTimesHexagon.faTimesHexagon,
  cogs: faCogs.faCogs,
  cogsSolid: faCogs$1.faCogs,
  comment: faComment.faComment,
  commentSolid: faComment$1.faComment,
  creditCard: faCreditCard.faCreditCard,
  creditCardSolid: faCreditCard$1.faCreditCard,
  doorOpenSolid: faDoorOpen.faDoorOpen,
  ear: faEar.faEar,
  ellipsisV: faEllipsisV.faEllipsisV,
  envelopeOpenText: faEnvelopeOpenText.faEnvelopeOpenText,
  fileLines: faFileAlt.faFileAlt,
  folder: faFolder.faFolder,
  gift: faGift.faGift,
  giftSolid: faGift$1.faGift,
  handShakeSolid: faHandshakeAlt.faHandshakeAlt,
  infoCircleSolid: faInfoCircle.faInfoCircle,
  idCardSolid: faIdCardAlt.faIdCardAlt,
  laptopMedical: faLaptopMedical.faLaptopMedical,
  lightbulb: faLightbulb.faLightbulb,
  lightbulbSolid: faLightbulb$1.faLightbulb,
  lock: faLock.faLock,
  microphoneSolid: faMicrophoneAlt.faMicrophoneAlt,
  minus: faMinus.faMinus,
  moneyWave: faMoneyBillWave.faMoneyBillWave,
  pen: faPen.faPen,
  phone: faPhoneAlt.faPhoneAlt,
  plus: faPlus.faPlus,
  print: faPrint.faPrint,
  question: faQuestion.faQuestion,
  questionCircle: faQuestionCircle.faQuestionCircle,
  questionSquareSolid: faQuestionSquare.faQuestionSquare,
  search: faSearch.faSearch,
  shieldCheckSolid: faShieldCheck.faShieldCheck,
  signOut: faSignOutAlt.faSignOutAlt,
  signOutSolid: faSignOutAlt$1.faSignOutAlt,
  tachometer: faTachometer.faTachometer,
  tachometerSolid: faTachometer$1.faTachometer,
  trash: faTrash.faTrash,
  umbrella: faUmbrella.faUmbrella,
  umbrellaSolid: faUmbrella$1.faUmbrella,
  upload: faCloudUploadAlt.faCloudUploadAlt,
  user: faUser.faUser,
  userSolid: faUser$1.faUser,
  users: faUsers.faUsers,
  usersClass: faUsersClass.faUsersClass,
  usersClassSolid: faUsersClass$1.faUsersClass,
  usersSolid: faUsers$1.faUsers,
  videoCamera: faCamcorder.faCamcorder,
  virus: faVirus.faVirus,
  virusSolid: faVirus$1.faVirus,
  wrench: faWrench.faWrench
});
Object.values(FAIcons).forEach((icon2) => {
  library.add(icon2);
});
const CustomIcons = Object.freeze({
  alertCircleLight,
  arrowCircle,
  arrowCircleSolid,
  audit,
  binoculars,
  calendarMoney,
  calendarOutline,
  cardLayout,
  caretDown,
  certificate,
  chair,
  chalkboard,
  checkThick,
  checkHexagonSolid,
  clockLine,
  company,
  companySolid,
  documentDetails,
  documentDetailsSolid,
  download,
  eyeClosed,
  eyeOpen,
  files,
  fileLinesOutline,
  fileUpload,
  govtBuilding,
  headset,
  heart,
  heartSolid,
  infoCircleLight,
  linkOut,
  lockUnlocked,
  megaphone,
  megaphoneSolid,
  money,
  moneyHand,
  moneySolid,
  moneyWaveLight,
  noHidden,
  party,
  payroll,
  penLine,
  phoneOutline,
  policy,
  recruiting,
  request,
  reportCard,
  shield,
  ticket: ticket$1,
  threeDotVert,
  threeStack,
  twoStack,
  training,
  transactionProcessing,
  transactionProcessingSolid,
  upDown,
  upgrade,
  logoHex
});
const Icons$1 = Object.freeze(
  [...Object.keys(FAIcons), ...Object.keys(CustomIcons)].sort().reduce(
    (obj, val) => ({
      ...obj,
      [snakeCase_1(val).toUpperCase()]: val
    }),
    {}
  )
);
const isValidIcon$1 = (value) => Object.values(Icons$1).includes(camelCase_1(value));
const isCustomIcon = (iconName) => Object.keys(CustomIcons).includes(iconName);
const getComponent$1 = (iconName) => isCustomIcon(iconName) ? CustomIcons[iconName] : FontAwesomeIcon;
const getIcon = (icon2) => FAIcons[camelCase_1(icon2)] || null;
const __vue2_script$1t = {
  props: {
    icon: {
      type: String,
      required: true,
      validator: isValidIcon$1
    }
  },
  setup() {
    return {
      getComponent: getComponent$1,
      getIcon
    };
  }
};
const __cssModules$1t = {};
var __component__$1t = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1t,
  render$2E,
  staticRenderFns$1s,
  false,
  __vue2_injectStyles$1t,
  null,
  null,
  null
);
function __vue2_injectStyles$1t(context) {
  for (let o in __cssModules$1t) {
    this[o] = __cssModules$1t[o];
  }
}
var BaseIcon = /* @__PURE__ */ function() {
  return __component__$1t.exports;
}();
var dist = { exports: {} };
(function(module, exports) {
  (function webpackUniversalModuleDefinition(root2, factory2) {
    module.exports = factory2();
  })(commonjsGlobal$2, function() {
    return function(modules) {
      var installedModules = {};
      function __webpack_require__(moduleId) {
        if (installedModules[moduleId]) {
          return installedModules[moduleId].exports;
        }
        var module2 = installedModules[moduleId] = {
          i: moduleId,
          l: false,
          exports: {}
        };
        modules[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__);
        module2.l = true;
        return module2.exports;
      }
      __webpack_require__.m = modules;
      __webpack_require__.c = installedModules;
      __webpack_require__.i = function(value) {
        return value;
      };
      __webpack_require__.d = function(exports2, name, getter) {
        if (!__webpack_require__.o(exports2, name)) {
          Object.defineProperty(exports2, name, {
            configurable: false,
            enumerable: true,
            get: getter
          });
        }
      };
      __webpack_require__.n = function(module2) {
        var getter = module2 && module2.__esModule ? function getDefault() {
          return module2["default"];
        } : function getModuleExports() {
          return module2;
        };
        __webpack_require__.d(getter, "a", getter);
        return getter;
      };
      __webpack_require__.o = function(object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      __webpack_require__.p = "";
      return __webpack_require__(__webpack_require__.s = 6);
    }([
      function(module2, __webpack_exports__, __webpack_require__) {
        __webpack_require__.d(__webpack_exports__, "a", function() {
          return toArray;
        });
        __webpack_require__.d(__webpack_exports__, "b", function() {
          return arrayFind;
        });
        var toArray = function toArray2(a) {
          var ret = Array(a.length);
          for (var i = 0; i < a.length; ++i) {
            ret[i] = a[i];
          }
          return ret;
        };
        var arrayFind = function arrayFind2(array, search2) {
          return array.filter(function(a) {
            return a === search2;
          })[0];
        };
      },
      function(module2, __webpack_exports__, __webpack_require__) {
        Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
        __webpack_require__.d(__webpack_exports__, "FOCUS_GROUP", function() {
          return FOCUS_GROUP;
        });
        __webpack_require__.d(__webpack_exports__, "FOCUS_DISABLED", function() {
          return FOCUS_DISABLED;
        });
        __webpack_require__.d(__webpack_exports__, "FOCUS_ALLOW", function() {
          return FOCUS_ALLOW;
        });
        __webpack_require__.d(__webpack_exports__, "FOCUS_AUTO", function() {
          return FOCUS_AUTO;
        });
        var FOCUS_GROUP = "data-focus-lock";
        var FOCUS_DISABLED = "data-focus-lock-disabled";
        var FOCUS_ALLOW = "data-no-focus-lock";
        var FOCUS_AUTO = "data-autofocus-inside";
      },
      function(module2, __webpack_exports__, __webpack_require__) {
        var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(1);
        var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(0);
        var filterNested = function filterNested2(nodes) {
          var l = nodes.length;
          var i = void 0;
          var j = void 0;
          for (i = 0; i < l; i += 1) {
            for (j = 0; j < l; j += 1) {
              if (i !== j) {
                if (nodes[i].contains(nodes[j])) {
                  return filterNested2(nodes.filter(function(x) {
                    return x !== nodes[j];
                  }));
                }
              }
            }
          }
          return nodes;
        };
        var getTopParent = function getTopParent2(node) {
          return node.parentNode ? getTopParent2(node.parentNode) : node;
        };
        var getAllAffectedNodes = function getAllAffectedNodes2(node) {
          var group = node.getAttribute(__WEBPACK_IMPORTED_MODULE_0__constants__["FOCUS_GROUP"]);
          if (group) {
            return filterNested(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__array__["a"])(getTopParent(node).querySelectorAll("[" + __WEBPACK_IMPORTED_MODULE_0__constants__["FOCUS_GROUP"] + '="' + group + '"]:not([' + __WEBPACK_IMPORTED_MODULE_0__constants__["FOCUS_DISABLED"] + '="disabled"])')));
          }
          return [node];
        };
        __webpack_exports__["a"] = getAllAffectedNodes;
      },
      function(module2, __webpack_exports__, __webpack_require__) {
        var __WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__ = __webpack_require__(12);
        var __WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__ = __webpack_require__(13);
        var __WEBPACK_IMPORTED_MODULE_2__utils_all_affected__ = __webpack_require__(2);
        var findAutoFocused = function findAutoFocused2(autoFocusables) {
          return function(node) {
            return !!node.autofocus || node.dataset && !!node.dataset.autofocus || autoFocusables.indexOf(node) >= 0;
          };
        };
        var newFocus = function newFocus2(innerNodes, outerNodes, activeElement, lastNode, autoFocused) {
          var cnt = innerNodes.length;
          var firstFocus = innerNodes[0];
          var lastFocus = innerNodes[cnt - 1];
          if (innerNodes.indexOf(activeElement) >= 0) {
            return void 0;
          }
          var activeIndex = outerNodes.indexOf(activeElement);
          var lastIndex = outerNodes.indexOf(lastNode || activeIndex);
          var lastNodeInside = innerNodes.indexOf(lastNode);
          var indexDiff = activeIndex - lastIndex;
          var firstNodeIndex = outerNodes.indexOf(firstFocus);
          var lastNodeIndex = outerNodes.indexOf(lastFocus);
          if (activeIndex === -1 || lastNodeInside === -1) {
            return innerNodes.indexOf(autoFocused.length ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__["a"])(autoFocused) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_firstFocus__["a"])(innerNodes));
          }
          if (!indexDiff && lastNodeInside >= 0) {
            return lastNodeInside;
          }
          if (indexDiff && Math.abs(indexDiff) > 1) {
            return lastNodeInside;
          }
          if (activeIndex <= firstNodeIndex) {
            return cnt - 1;
          }
          if (activeIndex > lastNodeIndex) {
            return 0;
          }
          if (indexDiff) {
            if (Math.abs(indexDiff) > 1) {
              return lastNodeInside;
            }
            return (cnt + lastNodeInside + indexDiff) % cnt;
          }
          return void 0;
        };
        var getTopCommonParent = function getTopCommonParent2(activeElement, entry, entries) {
          var topCommon = entry;
          entries.forEach(function(subEntry) {
            var common = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["a"])(activeElement, subEntry);
            if (common) {
              if (common.contains(topCommon)) {
                topCommon = common;
              } else {
                topCommon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["a"])(common, topCommon);
              }
            }
          });
          return topCommon;
        };
        var allParentAutofocusables = function allParentAutofocusables2(entries) {
          return entries.reduce(function(acc, node) {
            return acc.concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["b"])(node));
          }, []);
        };
        var notAGuard = function notAGuard2(node) {
          return !(node.dataset && node.dataset.focusGuard);
        };
        var getFocusMerge = function getFocusMerge2(topNode, lastNode) {
          var activeElement = document && document.activeElement;
          var entries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_all_affected__["a"])(topNode).filter(notAGuard);
          var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
          var innerElements = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["c"])(entries).filter(function(_ref2) {
            var node = _ref2.node;
            return notAGuard(node);
          });
          if (!innerElements[0]) {
            innerElements = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["d"])(entries).filter(function(_ref2) {
              var node = _ref2.node;
              return notAGuard(node);
            });
            if (!innerElements[0]) {
              return void 0;
            }
          }
          var innerNodes = innerElements.map(function(_ref3) {
            var node = _ref3.node;
            return node;
          });
          var outerNodes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_DOMutils__["c"])([commonParent]).map(function(_ref4) {
            var node = _ref4.node;
            return node;
          });
          var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode, innerNodes.filter(findAutoFocused(allParentAutofocusables(entries))));
          if (newId === void 0) {
            return newId;
          }
          return innerElements[newId];
        };
        __webpack_exports__["a"] = getFocusMerge;
      },
      function(module2, exports2, __webpack_require__) {
        var Component = __webpack_require__(17)(
          __webpack_require__(5),
          __webpack_require__(18),
          null,
          null
        );
        Component.options.__file = "/Users/akorzunov/dev/Z/mellis/github/focus/vue-focus-lock/src/Lock.vue";
        if (Component.esModule && Object.keys(Component.esModule).some(function(key) {
          return key !== "default" && key !== "__esModule";
        })) {
          console.error("named exports are not supported in *.vue files.");
        }
        if (Component.options.functional) {
          console.error("[vue-loader] Lock.vue: functional components are not supported with templates, they should use render functions.");
        }
        module2.exports = Component.exports;
      },
      function(module2, exports2, __webpack_require__) {
        Object.defineProperty(exports2, "__esModule", {
          value: true
        });
        var _focusLock = __webpack_require__(9);
        var _focusLock2 = _interopRequireDefault(_focusLock);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        function _defineProperty2(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function deferAction(action) {
          var setImmediate2 = window.setImmediate;
          if (typeof setImmediate2 !== "undefined") {
            setImmediate2(action);
          } else {
            setTimeout(action, 1);
          }
        }
        var lastActiveTrap = 0;
        var lastActiveFocus = null;
        var focusWasOutsideWindow = false;
        var focusOnBody = function focusOnBody2() {
          return document && document.activeElement === document.body;
        };
        var isFreeFocus = function isFreeFocus2() {
          return focusOnBody() || (0, _focusLock.focusIsHidden)();
        };
        var activateTrap = function activateTrap2() {
          var result = false;
          if (lastActiveTrap) {
            var _lastActiveTrap = lastActiveTrap, observed = _lastActiveTrap.observed, onActivation = _lastActiveTrap.onActivation;
            if (focusWasOutsideWindow || !isFreeFocus() || !lastActiveFocus) {
              if (observed && !(0, _focusLock.focusInside)(observed)) {
                onActivation();
                result = (0, _focusLock2.default)(observed, lastActiveFocus);
              }
              focusWasOutsideWindow = false;
              lastActiveFocus = document && document.activeElement;
            }
          }
          return result;
        };
        var reducePropsToState = function reducePropsToState2(propsList) {
          return propsList.filter(function(_ref2) {
            var disabled = _ref2.disabled;
            return !disabled;
          }).slice(-1)[0];
        };
        var handleStateChangeOnClient = function handleStateChangeOnClient2(trap) {
          if (lastActiveTrap !== trap) {
            lastActiveTrap = null;
          }
          lastActiveTrap = trap;
          if (trap) {
            activateTrap();
            deferAction(activateTrap);
          }
        };
        var instances = [];
        var emitChange = function emitChange2() {
          handleStateChangeOnClient(reducePropsToState(instances));
        };
        var onTrap = function onTrap2(event) {
          if (activateTrap() && event) {
            event.stopPropagation();
            event.preventDefault();
          }
        };
        var onBlur = function onBlur2() {
          deferAction(activateTrap);
        };
        var onWindowBlur = function onWindowBlur2() {
          focusWasOutsideWindow = true;
        };
        var attachHandler = function attachHandler2() {
          document.addEventListener("focusin", onTrap, true);
          document.addEventListener("focusout", onBlur);
          window.addEventListener("blur", onWindowBlur);
        };
        var detachHandler = function detachHandler2() {
          document.removeEventListener("focusin", onTrap, true);
          document.removeEventListener("focusout", onBlur);
          window.removeEventListener("blur", onWindowBlur);
        };
        exports2.default = {
          name: "Lock",
          props: {
            returnFocus: {
              type: Boolean
            },
            disabled: {
              type: Boolean
            },
            noFocusGuards: {
              type: [Boolean, String],
              default: false
            },
            group: {
              type: String
            }
          },
          data: function data() {
            return {
              data: {},
              hidden: ""
            };
          },
          computed: {
            groupAttr: function groupAttr() {
              return _defineProperty2({}, _focusLock.constants.FOCUS_GROUP, this.group);
            },
            hasLeadingGuards: function hasLeadingGuards() {
              return this.noFocusGuards !== true;
            },
            hasTailingGuards: function hasTailingGuards() {
              return this.hasLeadingGuards && this.noFocusGuards !== "tail";
            }
          },
          watch: {
            disabled: function disabled() {
              this.data.disabled = this.disabled;
              emitChange();
            }
          },
          methods: {
            onBlur: function onBlur2() {
              deferAction(emitChange);
            }
          },
          mounted: function mounted() {
            var _this = this;
            this.data.vue = this;
            this.data.observed = this.$el.querySelector("[data-lock]");
            this.data.disabled = this.disabled;
            this.data.onActivation = function() {
              _this.originalFocusedElement = _this.originalFocusedElement || document && document.activeElement;
            };
            if (!instances.length) {
              attachHandler();
            }
            instances.push(this.data);
            emitChange();
          },
          destroyed: function destroyed() {
            var _this2 = this;
            instances = instances.filter(function(_ref3) {
              var vue = _ref3.vue;
              return vue !== _this2;
            });
            if (!instances.length) {
              detachHandler();
            }
            if (this.returnFocus && this.originalFocusedElement && this.originalFocusedElement.focus) {
              this.originalFocusedElement.focus();
            }
            emitChange();
          }
        };
      },
      function(module2, exports2, __webpack_require__) {
        Object.defineProperty(exports2, "__esModule", {
          value: true
        });
        var _Lock = __webpack_require__(4);
        var _Lock2 = _interopRequireDefault(_Lock);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports2.default = _Lock2.default;
      },
      function(module2, __webpack_exports__, __webpack_require__) {
        var __WEBPACK_IMPORTED_MODULE_0__utils_all_affected__ = __webpack_require__(2);
        var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(0);
        var focusInFrame = function focusInFrame2(frame) {
          return frame === document.activeElement;
        };
        var focusInsideIframe = function focusInsideIframe2(topNode) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_all_affected__["a"])(topNode).reduce(function(result, node) {
            return result || !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["b"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a"])(node.querySelectorAll("iframe")), focusInFrame);
          }, false);
        };
        var focusInside = function focusInside2(topNode) {
          var activeElement = document && document.activeElement;
          if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
            return false;
          }
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_all_affected__["a"])(topNode).reduce(function(result, node) {
            return result || node.contains(activeElement) || focusInsideIframe(topNode);
          }, false);
        };
        __webpack_exports__["a"] = focusInside;
      },
      function(module2, __webpack_exports__, __webpack_require__) {
        var __WEBPACK_IMPORTED_MODULE_0__utils_array__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(1);
        var focusIsHidden = function focusIsHidden2() {
          return document && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_array__["a"])(document.querySelectorAll("[" + __WEBPACK_IMPORTED_MODULE_1__constants__["FOCUS_ALLOW"] + "]")).some(function(node) {
            return node.contains(document.activeElement);
          });
        };
        __webpack_exports__["a"] = focusIsHidden;
      },
      function(module2, __webpack_exports__, __webpack_require__) {
        Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
        var __WEBPACK_IMPORTED_MODULE_0__tabHook__ = __webpack_require__(11);
        var __WEBPACK_IMPORTED_MODULE_1__focusMerge__ = __webpack_require__(3);
        var __WEBPACK_IMPORTED_MODULE_2__focusInside__ = __webpack_require__(7);
        var __WEBPACK_IMPORTED_MODULE_3__focusIsHidden__ = __webpack_require__(8);
        var __WEBPACK_IMPORTED_MODULE_4__setFocus__ = __webpack_require__(10);
        var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(1);
        var __WEBPACK_IMPORTED_MODULE_6__utils_all_affected__ = __webpack_require__(2);
        __webpack_require__.d(__webpack_exports__, "tabHook", function() {
          return __WEBPACK_IMPORTED_MODULE_0__tabHook__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "focusInside", function() {
          return __WEBPACK_IMPORTED_MODULE_2__focusInside__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "focusIsHidden", function() {
          return __WEBPACK_IMPORTED_MODULE_3__focusIsHidden__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "focusMerge", function() {
          return __WEBPACK_IMPORTED_MODULE_1__focusMerge__["a"];
        });
        __webpack_require__.d(__webpack_exports__, "constants", function() {
          return __WEBPACK_IMPORTED_MODULE_5__constants__;
        });
        __webpack_require__.d(__webpack_exports__, "getAllAffectedNodes", function() {
          return __WEBPACK_IMPORTED_MODULE_6__utils_all_affected__["a"];
        });
        __webpack_exports__["default"] = __WEBPACK_IMPORTED_MODULE_4__setFocus__["a"];
      },
      function(module2, __webpack_exports__, __webpack_require__) {
        var __WEBPACK_IMPORTED_MODULE_0__focusMerge__ = __webpack_require__(3);
        var focusOn = function focusOn2(target) {
          target.focus();
          if (target.contentWindow) {
            target.contentWindow.focus();
          }
        };
        var guardCount = 0;
        __webpack_exports__["a"] = function(topNode, lastNode) {
          var focusable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__focusMerge__["a"])(topNode, lastNode);
          if (focusable) {
            if (guardCount > 2) {
              return;
            }
            guardCount++;
            focusOn(focusable.node);
            guardCount--;
          }
        };
      },
      function(module2, __webpack_exports__, __webpack_require__) {
        __webpack_exports__["a"] = {
          attach: function attach(node, enabled) {
          },
          detach: function detach() {
          }
        };
      },
      function(module2, __webpack_exports__, __webpack_require__) {
        __webpack_require__.d(__webpack_exports__, "a", function() {
          return getCommonParent;
        });
        __webpack_require__.d(__webpack_exports__, "c", function() {
          return getTabbableNodes;
        });
        __webpack_require__.d(__webpack_exports__, "d", function() {
          return getAllTabbableNodes;
        });
        __webpack_require__.d(__webpack_exports__, "b", function() {
          return parentAutofocusables;
        });
        var __WEBPACK_IMPORTED_MODULE_0__tabOrder__ = __webpack_require__(14);
        var __WEBPACK_IMPORTED_MODULE_1__tabUtils__ = __webpack_require__(15);
        var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(0);
        var isElementHidden = function isElementHidden2(computedStyle) {
          if (!computedStyle || !computedStyle.getPropertyValue) {
            return false;
          }
          return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
        };
        var isVisible = function isVisible2(node) {
          return !node || node === document || !isElementHidden(window.getComputedStyle(node, null)) && isVisible2(node.parentNode);
        };
        var notHiddenInput = function notHiddenInput2(node) {
          return !((node.tagName === "INPUT" || node.tagName === "BUTTON") && (node.type === "hidden" || node.disabled));
        };
        var getParents = function getParents2(node) {
          var parents = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
          parents.push(node);
          if (node.parentNode) {
            getParents2(node.parentNode, parents);
          }
          return parents;
        };
        var getCommonParent = function getCommonParent2(nodea, nodeb) {
          var parentsA = getParents(nodea);
          var parentsB = getParents(nodeb);
          for (var i = 0; i < parentsA.length; i += 1) {
            var currentParent = parentsA[i];
            if (parentsB.indexOf(currentParent) >= 0) {
              return currentParent;
            }
          }
          return false;
        };
        var filterFocusable = function filterFocusable2(nodes) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__array__["a"])(nodes).filter(function(node) {
            return isVisible(node);
          }).filter(function(node) {
            return notHiddenInput(node);
          });
        };
        var getTabbableNodes = function getTabbableNodes2(topNodes) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tabOrder__["a"])(filterFocusable(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tabUtils__["a"])(topNodes)), true);
        };
        var getAllTabbableNodes = function getAllTabbableNodes2(topNodes) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tabOrder__["a"])(filterFocusable(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tabUtils__["a"])(topNodes)), false);
        };
        var parentAutofocusables = function parentAutofocusables2(topNode) {
          return filterFocusable(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tabUtils__["b"])(topNode));
        };
      },
      function(module2, __webpack_exports__, __webpack_require__) {
        var isRadio = function isRadio2(node) {
          return node.tagName === "INPUT" && node.type === "radio";
        };
        var findSelectedRadio = function findSelectedRadio2(node, nodes) {
          return nodes.filter(isRadio).filter(function(el) {
            return el.name === node.name;
          }).filter(function(el) {
            return el.checked;
          })[0] || node;
        };
        var pickFirstFocus = function pickFirstFocus2(nodes) {
          if (nodes[0] && nodes.length > 1) {
            if (isRadio(nodes[0]) && nodes[0].name) {
              return findSelectedRadio(nodes[0], nodes);
            }
          }
          return nodes[0];
        };
        __webpack_exports__["a"] = pickFirstFocus;
      },
      function(module2, __webpack_exports__, __webpack_require__) {
        __webpack_require__.d(__webpack_exports__, "a", function() {
          return orderByTabIndex;
        });
        var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(0);
        var tabSort = function tabSort2(a, b) {
          var tabDiff = a.tabIndex - b.tabIndex;
          var indexDiff = a.index - b.index;
          if (tabDiff) {
            if (!a.tabIndex)
              return 1;
            if (!b.tabIndex)
              return -1;
          }
          return tabDiff || indexDiff;
        };
        var orderByTabIndex = function orderByTabIndex2(nodes, filterNegative) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__array__["a"])(nodes).map(function(node, index) {
            return {
              node,
              index,
              tabIndex: node.tabIndex
            };
          }).filter(function(data) {
            return !filterNegative || data.tabIndex >= 0;
          }).sort(tabSort);
        };
      },
      function(module2, __webpack_exports__, __webpack_require__) {
        __webpack_require__.d(__webpack_exports__, "a", function() {
          return getFocusables;
        });
        __webpack_require__.d(__webpack_exports__, "b", function() {
          return getParentAutofocusables;
        });
        var __WEBPACK_IMPORTED_MODULE_0__tabbables__ = __webpack_require__(16);
        var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(0);
        var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1);
        var getFocusables = function getFocusables2(parents) {
          return parents.reduce(function(acc, parent) {
            return acc.concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__array__["a"])(parent.querySelectorAll(__WEBPACK_IMPORTED_MODULE_0__tabbables__["a"].join(","))));
          }, []);
        };
        var getParentAutofocusables = function getParentAutofocusables2(parent) {
          var parentFocus = parent.querySelectorAll("[" + __WEBPACK_IMPORTED_MODULE_2__constants__["FOCUS_AUTO"] + "]");
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__array__["a"])(parentFocus).map(function(node) {
            return getFocusables([node]);
          }).reduce(function(acc, nodes) {
            return acc.concat(nodes);
          }, []);
        };
      },
      function(module2, __webpack_exports__, __webpack_require__) {
        __webpack_exports__["a"] = ["button:enabled:not([readonly])", "select:enabled:not([readonly])", "textarea:enabled:not([readonly])", "input:enabled:not([readonly])", "a[href]", "area[href]", "iframe", "object", "embed", "[tabindex]", "[contenteditable]", "[autofocus]"];
      },
      function(module2, exports2) {
        module2.exports = function normalizeComponent2(rawScriptExports, compiledTemplate, scopeId, cssModules) {
          var esModule;
          var scriptExports = rawScriptExports = rawScriptExports || {};
          var type = typeof rawScriptExports.default;
          if (type === "object" || type === "function") {
            esModule = rawScriptExports;
            scriptExports = rawScriptExports.default;
          }
          var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
          if (compiledTemplate) {
            options.render = compiledTemplate.render;
            options.staticRenderFns = compiledTemplate.staticRenderFns;
          }
          if (scopeId) {
            options._scopeId = scopeId;
          }
          if (cssModules) {
            var computed2 = Object.create(options.computed || null);
            Object.keys(cssModules).forEach(function(key) {
              var module3 = cssModules[key];
              computed2[key] = function() {
                return module3;
              };
            });
            options.computed = computed2;
          }
          return {
            esModule,
            exports: scriptExports,
            options
          };
        };
      },
      function(module2, exports2, __webpack_require__) {
        module2.exports = { render: function() {
          var _vm = this;
          var _h = _vm.$createElement;
          var _c = _vm._self._c || _h;
          return _c("div", [_vm.hasLeadingGuards ? _c("div", {
            style: _vm.hidden,
            attrs: {
              "tabIndex": _vm.disabled ? -1 : 0,
              "aria-hidden": "true"
            }
          }) : _vm._e(), _vm._v(" "), _vm.hasLeadingGuards ? _c("div", {
            style: _vm.hidden,
            attrs: {
              "tabIndex": _vm.disabled ? -1 : 1,
              "aria-hidden": "true"
            }
          }) : _vm._e(), _vm._v(" "), _c("div", _vm._b({
            attrs: {
              "data-lock": ""
            },
            on: {
              "focusout": _vm.onBlur
            }
          }, "div", _vm.groupAttr, false), [_vm._t("default")], 2), _vm._v(" "), _vm.hasTailingGuards ? _c("div", {
            style: _vm.hidden,
            attrs: {
              "tabIndex": _vm.disabled ? -1 : 0,
              "aria-hidden": "true"
            }
          }) : _vm._e()]);
        }, staticRenderFns: [] };
        module2.exports.render._withStripped = true;
      }
    ]);
  });
})(dist);
var FocusLock = /* @__PURE__ */ getDefaultExportFromCjs(dist.exports);
const baseClass = "base-button";
var __vue2_script$1s = defineComponent({
  components: { BaseIcon },
  props: {
    block: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String
    },
    label: {
      type: String,
      default: ""
    },
    postIcon: {
      type: String,
      default: "",
      validator: (value) => !value || isValidIcon$1(value)
    },
    preIcon: {
      type: String,
      default: "",
      validator: (value) => !value || isValidIcon$1(value)
    },
    size: {
      type: String,
      default: Button.Sizes.MEDIUM,
      validator: (value) => Object.values(Sizes$d).includes(value) || Object.values(LegacySizes).includes(value)
    },
    tag: {
      type: String,
      default: "button"
    },
    buttonType: {
      type: String,
      default: ButtonTypes.PRIMARY
    },
    level: {
      type: [String, Number],
      default: Levels.ONE
    },
    darkContrast: {
      type: Boolean,
      default: false
    }
  },
  setup(props2) {
    const buttonType = computed(() => {
      switch (props2.variant) {
        case LegacyVariants.PRIMARY:
        case LegacyVariants.INVERTED_PRIMARY:
        case LegacyVariants.WHITE:
          return ButtonTypes.PRIMARY;
        case LegacyVariants.SECONDARY:
        case LegacyVariants.INVERTED_SECONDARY:
          return ButtonTypes.SECONDARY;
        case LegacyVariants.TERTIARY:
        case LegacyVariants.INVERTED_TERTIARY:
          return ButtonTypes.TERTIARY;
        default:
          return props2.buttonType;
      }
    });
    const level = computed(() => {
      if (props2.flat) {
        return Levels.THREE;
      }
      switch (props2.variant) {
        case LegacyVariants.INVERTED_PRIMARY:
        case LegacyVariants.INVERTED_SECONDARY:
        case LegacyVariants.INVERTED_TERTIARY:
          return Levels.TWO;
        default:
          return `${props2.level}`;
      }
    });
    const darkContrast = computed(() => {
      return props2.variant === LegacyVariants.WHITE || props2.darkContrast;
    });
    const size = computed(() => {
      if (props2.size === LegacySizes.GIANT) {
        return Sizes$d.HUGE;
      }
      return props2.size;
    });
    const classList2 = computed(() => [
      baseClass,
      `${baseClass}--${buttonType.value}`,
      `${baseClass}--level-${level.value}`,
      `${baseClass}--${size.value}`,
      darkContrast.value && `${baseClass}--dark-contrast`
    ]);
    return {
      classList: classList2
    };
  }
});
var render$2D = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tag, _vm._g(_vm._b({ tag: "component", class: _vm.classList }, "component", _vm.$attrs, false), _vm.$listeners), [_c("div", { staticClass: "base-button__inner" }, [_vm._t("pre-icon", [_vm.preIcon ? _c("div", { staticClass: "base-button__icon" }, [_c("BaseIcon", { attrs: { "icon": _vm.preIcon } })], 1) : _vm._e()]), _c("span", [_vm._t("default", [_vm._v(" " + _vm._s(_vm.label) + " ")])], 2), _vm._t("post-icon", [_vm.postIcon ? _c("BaseIcon", { attrs: { "icon": _vm.postIcon } }) : _vm._e()])], 2)]);
};
var staticRenderFns$1r = [];
var BaseButton_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$1s = {};
var __component__$1s = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1s,
  render$2D,
  staticRenderFns$1r,
  false,
  __vue2_injectStyles$1s,
  "d8c45b72",
  null,
  null
);
function __vue2_injectStyles$1s(context) {
  for (let o in __cssModules$1s) {
    this[o] = __cssModules$1s[o];
  }
}
var BaseButton = /* @__PURE__ */ function() {
  return __component__$1s.exports;
}();
var render$2C = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "modal-actions", class: "modal-actions--" + _vm.computedAlignment }, [_vm.primaryAction ? _c("BaseButton", _vm._b({ staticClass: "modal-actions__action modal-actions__action--primary", on: { "click": function() {
    _vm.primaryAction.handler && _vm.primaryAction.handler();
    _vm.$emit("primary");
  } } }, "BaseButton", _vm.getProps(_vm.primaryAction), false)) : _vm._e(), _vm.secondaryAction ? _c("BaseButton", _vm._b({ staticClass: "modal-actions__action modal-actions__action--secondary", attrs: { "flat": "", "variant": _vm.$options.Button.Variants.SECONDARY }, on: { "click": function() {
    _vm.secondaryAction.handler && _vm.secondaryAction.handler();
    _vm.$emit("secondary");
  } } }, "BaseButton", _vm.getProps(_vm.secondaryAction), false)) : _vm._e(), _vm.tertiaryAction ? _c("BaseButton", _vm._b({ staticClass: "modal-actions__action modal-actions__action--tertiary", attrs: { "flat": "", "variant": _vm.$options.Button.Variants.TERTIARY }, on: { "click": function() {
    _vm.tertiaryAction.handler && _vm.tertiaryAction.handler();
    _vm.$emit("tertiary");
  } } }, "BaseButton", _vm.getProps(_vm.tertiaryAction), false)) : _vm._e()], 1);
};
var staticRenderFns$1q = [];
var ModalActions_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$1r = {
  Button,
  components: { BaseButton },
  props: {
    alignment: {
      type: String,
      default: Modal.ActionAlignments.CENTER,
      validator: (value) => Object.values(Modal.ActionAlignments).includes(value)
    },
    primaryAction: {
      type: Object,
      default: null
    },
    secondaryAction: {
      type: Object,
      default: null
    },
    tertiaryAction: {
      type: Object,
      default: null
    }
  },
  computed: {
    computedAlignment() {
      return this.tertiaryAction ? Modal.ActionAlignments.JUSTIFY : this.alignment;
    }
  },
  methods: {
    getProps(action) {
      const { handler, ...rest } = action;
      return { type: "button", ...rest };
    }
  }
};
const __cssModules$1r = {};
var __component__$1r = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1r,
  render$2C,
  staticRenderFns$1q,
  false,
  __vue2_injectStyles$1r,
  "ed1d57ec",
  null,
  null
);
function __vue2_injectStyles$1r(context) {
  for (let o in __cssModules$1r) {
    this[o] = __cssModules$1r[o];
  }
}
var ModalActions = /* @__PURE__ */ function() {
  return __component__$1r.exports;
}();
var render$2B = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("button", _vm._g({ staticClass: "modal-close", class: "modal-close--" + _vm.variantType, attrs: { "type": "button", "title": "Close" } }, _vm.$listeners), [_c("BaseIcon", { attrs: { "icon": _vm.Icons.CLOSE_CIRCLE } }), _c("div", { staticClass: "modal-close__visible-label", attrs: { "aria-hidden": "" } }, [_vm._v(" Esc ")]), _c("div", { staticClass: "modal-close__accessible-label" }, [_vm._v(" Click or press escape to close ")])], 1);
};
var staticRenderFns$1p = [];
var ModalClose_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$1q = defineComponent({
  name: "ModalClose",
  components: {
    BaseIcon
  },
  props: {
    variant: {
      type: String,
      default: Modal.Overlays.PRIMARY,
      validator: (value) => Object.values(Modal.Overlays).includes(value)
    }
  },
  setup(props2) {
    const variantType = computed(
      () => props2.variant === Modal.Overlays.LIGHT ? "dark" : "light"
    );
    return {
      variantType,
      Icons: Icons$1
    };
  }
});
const __cssModules$1q = {};
var __component__$1q = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1q,
  render$2B,
  staticRenderFns$1p,
  false,
  __vue2_injectStyles$1q,
  "248c6860",
  null,
  null
);
function __vue2_injectStyles$1q(context) {
  for (let o in __cssModules$1q) {
    this[o] = __cssModules$1q[o];
  }
}
var ModalClose = /* @__PURE__ */ function() {
  return __component__$1q.exports;
}();
var render$2A = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", _vm._b({ staticClass: "modal-header", class: "modal-header--" + _vm.variant }, "div", _vm.$attrs, false), [_vm.hasOrnate ? [_c("LeftSplotch", { staticClass: "modal-header__splotch modal-header__splotch--left", attrs: { "aria-hidden": "" } }), _vm._t("default"), _c("RightSplotch", { staticClass: "modal-header__splotch modal-header__splotch--right", attrs: { "aria-hidden": "" } })] : _vm._e(), !_vm.hasOrnate ? [_vm._t("default")] : _vm._e()], 2);
};
var staticRenderFns$1o = [];
var ModalHeader_vue_vue_type_style_index_0_scoped_true_lang = "";
const LeftSplotch = {
  template: `<svg width="102" height="56" viewBox="0 0 102 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M81.3142 16.7088C90.3984 20.2736 100.092 25.254 101.738 31.9119C103.384 38.5699 96.9829 46.9578 90.3984 52.41C83.8138 57.9146 76.9855 60.4834 71.0716 61.3746C65.2187 62.2658 60.2193 61.5319 54.1226 62.8949C47.9648 64.2579 40.7097 67.8228 35.0397 66.8268C29.4306 65.8307 25.4677 60.3785 25.041 54.8739C24.6142 49.4218 27.6626 44.022 27.6626 35.7913C27.7235 27.5607 24.6142 16.5515 28.76 11.6236C32.8448 6.64322 44.0629 7.74414 53.9397 9.3693C63.7555 10.9945 72.23 13.1439 81.3142 16.7088Z" fill="currentColor"/>
<path d="M44.3068 1.61404C50.0125 3.46353 56.0779 7.21387 56.9004 12.0944C57.7228 16.975 53.3022 22.9858 49.19 27.0958C45.0779 31.1544 41.2741 33.3635 37.7273 40.1449C34.1806 46.9778 30.9422 58.4343 25.6478 61.2599C20.302 64.0855 12.9514 58.3315 7.09158 52.2693C1.23172 46.2071 -3.08607 39.8881 -7.14685 32.2846C-11.259 24.6812 -15.0628 15.7934 -11.7217 10.5018C-8.3805 5.15889 2.20836 3.36078 9.97011 2.23054C17.7318 1.04892 22.7179 0.483803 27.9095 0.175556C33.1525 -0.132691 38.5498 -0.235441 44.3068 1.61404Z" fill="white" fill-opacity="0.1"/>
</svg>`
};
const RightSplotch = {
  template: `<svg width="97" height="72" viewBox="0 0 97 72" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M90.701 -8.42997C99.0327 -0.156342 108.528 9.41389 107.977 18.6137C107.364 27.8134 96.766 36.581 85.4936 40.9031C74.16 45.1634 62.2138 44.9781 50.3901 40.6561C38.6276 36.3958 26.9877 27.9987 26.0688 18.6137C25.0886 9.22866 34.7681 -1.08249 43.5287 -9.47961C52.2892 -17.8767 60.1921 -24.298 67.6662 -23.9893C75.2015 -23.6806 82.3692 -16.7036 90.701 -8.42997Z" fill="currentColor"/>
<path d="M61.4061 20.3765C68.364 22.1578 75.3847 27.1199 78.6443 34.1815C81.9039 41.1794 81.2771 50.1495 79.7726 60.0739C78.2682 69.9982 75.8235 80.8132 69.1789 84.8211C62.4717 88.8926 51.5646 86.0935 40.9709 85.6481C30.3145 85.2664 20.0342 87.2386 15.1448 82.5945C10.1927 78.014 10.7569 66.8173 8.06145 57.0202C5.36601 47.2231 -0.526342 38.8256 0.037819 31.1915C0.664665 23.621 7.81071 16.8139 15.6463 15.3507C23.4819 13.8239 32.0697 17.7045 39.7799 18.9133C47.5528 20.0584 54.3854 18.5952 61.4061 20.3765Z" fill="white" fill-opacity="0.1"/>
</svg>`
};
const __vue2_script$1p = {
  name: "ModalHeader",
  components: { LeftSplotch, RightSplotch },
  props: {
    variant: {
      type: String,
      default: Modal.Headers.TRANSPARENT,
      validator: (value) => Object.values(Modal.Headers).includes(value)
    }
  },
  setup(props2) {
    const hasOrnate = computed(
      () => [
        Modal.Headers.PRIMARY_ORNATE,
        Modal.Headers.WARNING_ORNATE,
        Modal.Headers.ERROR_ORNATE
      ].includes(props2.variant)
    );
    return {
      hasOrnate
    };
  }
};
const __cssModules$1p = {};
var __component__$1p = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1p,
  render$2A,
  staticRenderFns$1o,
  false,
  __vue2_injectStyles$1p,
  "21fde42d",
  null,
  null
);
function __vue2_injectStyles$1p(context) {
  for (let o in __cssModules$1p) {
    this[o] = __cssModules$1p[o];
  }
}
var ModalHeader = /* @__PURE__ */ function() {
  return __component__$1p.exports;
}();
var render$2z = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", _vm._g({ staticClass: "modal-overlay", class: "modal-overlay--" + _vm.variant }, _vm.$listeners));
};
var staticRenderFns$1n = [];
var ModalOverlay_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$1o = {
  props: {
    variant: {
      type: String,
      default: Modal.Overlays.PRIMARY,
      validator: (value) => Object.values(Modal.Overlays).includes(value)
    }
  }
};
const __cssModules$1o = {};
var __component__$1o = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1o,
  render$2z,
  staticRenderFns$1n,
  false,
  __vue2_injectStyles$1o,
  "37404d30",
  null,
  null
);
function __vue2_injectStyles$1o(context) {
  for (let o in __cssModules$1o) {
    this[o] = __cssModules$1o[o];
  }
}
var ModalOverlay = /* @__PURE__ */ function() {
  return __component__$1o.exports;
}();
var render$2y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "modal-subfooter" }, [_vm._t("default")], 2);
};
var staticRenderFns$1m = [];
var ModalSubfooter_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$1n = {};
const __cssModules$1n = {};
var __component__$1n = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1n,
  render$2y,
  staticRenderFns$1m,
  false,
  __vue2_injectStyles$1n,
  "6bbd8352",
  null,
  null
);
function __vue2_injectStyles$1n(context) {
  for (let o in __cssModules$1n) {
    this[o] = __cssModules$1n[o];
  }
}
var ModalSubfooter = /* @__PURE__ */ function() {
  return __component__$1n.exports;
}();
var render$2x = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "modal-window", class: [
    "modal-window--" + _vm.size,
    { "modal-window--full-bleed": _vm.fullBleed }
  ], attrs: { "id": _vm.id, "role": "dialog", "aria-labelledby": _vm.id + "-header", "aria-describedby": _vm.id + "-body" } }, [_vm._t("default")], 2);
};
var staticRenderFns$1l = [];
var ModalWindow_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$1m = {
  props: {
    id: {
      type: String,
      required: true
    },
    fullBleed: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Modal.Sizes.REGULAR,
      validator: (value) => Object.values(Modal.Sizes).includes(value)
    }
  }
};
const __cssModules$1m = {};
var __component__$1m = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1m,
  render$2x,
  staticRenderFns$1l,
  false,
  __vue2_injectStyles$1m,
  "4819b359",
  null,
  null
);
function __vue2_injectStyles$1m(context) {
  for (let o in __cssModules$1m) {
    this[o] = __cssModules$1m[o];
  }
}
var ModalWindow = /* @__PURE__ */ function() {
  return __component__$1m.exports;
}();
var render$2w = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("FocusLock", { staticClass: "modal-dialog" }, [_c("ModalWindow", { attrs: { "id": _vm.id, "size": _vm.size, "full-bleed": _vm.fullBleed } }, [!!_vm.$slots.header ? _c("ModalHeader", { attrs: { "id": _vm.id + "-header", "variant": _vm.header } }, [_vm._t("header")], 2) : _vm._e(), _c("div", { staticClass: "modal-dialog__body", attrs: { "id": _vm.id + "-body" } }, [_vm._t("default")], 2), _vm.actions ? _c("ModalActions", { attrs: { "alignment": _vm.actionAlignment, "primary-action": _vm.actions.primary, "secondary-action": _vm.actions.secondary, "tertiary-action": _vm.actions.tertiary }, on: { "primary": function($event) {
    return _vm.$emit("primary");
  }, "secondary": function($event) {
    return _vm.$emit("secondary");
  }, "tertiary": function($event) {
    return _vm.$emit("tertiary");
  } } }) : _vm._e(), !!_vm.$slots.subfooter ? _c("ModalSubfooter", { staticClass: "modal-dialog__subfooter" }, [_vm._t("subfooter")], 2) : _vm._e()], 1), _vm.escapeButton ? _c("ModalClose", { attrs: { "variant": _vm.overlay }, on: { "click": _vm.close } }) : _vm._e(), _c("ModalOverlay", { attrs: { "variant": _vm.overlay }, on: { "click": _vm.handleOverlayClick } })], 1);
};
var staticRenderFns$1k = [];
var ModalDialog_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$1l = defineComponent({
  name: "ModalDialog",
  components: {
    FocusLock,
    ModalActions,
    ModalClose,
    ModalHeader,
    ModalOverlay,
    ModalSubfooter,
    ModalWindow
  },
  props: {
    actionAlignment: {
      type: String,
      default: Modal.ActionAlignments.CENTER,
      validator: (value) => Object.values(Modal.ActionAlignments).includes(value)
    },
    actions: {
      type: Object,
      default: null
    },
    escapeButton: {
      type: Boolean,
      default: true
    },
    fullBleed: {
      type: Boolean,
      default: false
    },
    header: {
      type: String,
      default: Modal.Headers.TRANSPARENT,
      validator: (value) => Object.values(Modal.Headers).includes(value)
    },
    id: {
      type: String,
      default: shortid.generate
    },
    overlay: {
      type: String,
      default: Modal.Overlays.PRIMARY,
      validator: (value) => Object.values(Modal.Overlays).includes(value)
    },
    overlayClose: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: Modal.Sizes.REGULAR,
      validator: (value) => Object.values(Modal.Sizes).includes(value)
    }
  },
  setup(props2, { emit }) {
    const close = () => emit("close");
    const handleOverlayClick = () => {
      if (props2.overlayClose) {
        close();
      }
    };
    const handleKeyup = (e) => {
      if (e.keyCode !== 27) {
        return;
      }
      close();
    };
    onMounted(() => {
      document.addEventListener("keyup", handleKeyup);
      document.body.classList.add("overflow-hidden");
    });
    onUnmounted(() => {
      document.removeEventListener("keyup", handleKeyup);
      document.body.classList.remove("overflow-hidden");
    });
    return {
      close,
      handleOverlayClick
    };
  }
});
const __cssModules$1l = {};
var __component__$1l = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1l,
  render$2w,
  staticRenderFns$1k,
  false,
  __vue2_injectStyles$1l,
  "f99faf74",
  null,
  null
);
function __vue2_injectStyles$1l(context) {
  for (let o in __cssModules$1l) {
    this[o] = __cssModules$1l[o];
  }
}
var ModalDialog = /* @__PURE__ */ function() {
  return __component__$1l.exports;
}();
var render$2v = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ModalDialog", _vm._b({ staticClass: "alert-modal", class: "alert-modal--" + _vm.normalizeVariant, attrs: { "id": _vm.id, "actions": _vm.actions }, on: { "close": function($event) {
    return _vm.$emit("close");
  } }, scopedSlots: _vm._u([{ key: "header", fn: function() {
    return [_c("BaseIcon", { staticClass: "alert-modal__icon", attrs: { "icon": _vm.headerIcon } }), _vm._t("header", [_vm._v(" " + _vm._s(_vm.title) + " ")])];
  }, proxy: true }], null, true) }, "ModalDialog", _vm.dialogProps, false), [_vm._t("default", [_vm._v(" " + _vm._s(_vm.message) + " ")])], 2);
};
var staticRenderFns$1j = [];
var AlertModal_vue_vue_type_style_index_0_scoped_true_lang = "";
const SUCCESS_DEFAULT = "success-default";
const __vue2_script$1k = {
  components: { BaseIcon, ModalDialog },
  inheritAttrs: false,
  props: {
    cancelLabel: {
      type: String,
      default: "Cancel"
    },
    confirmLabel: {
      type: String,
      default: "Continue"
    },
    id: {
      type: String,
      default: shortid.generate
    },
    message: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: Modal.Alerts.SUCCESS,
      validator: (value) => Object.values(Modal.Alerts).includes(value)
    }
  },
  setup(props2, { emit, attrs }) {
    const actions = computed(() => {
      return {
        primary: {
          label: props2.confirmLabel,
          handler: () => {
            emit("confirm");
          }
        },
        secondary: {
          label: props2.cancelLabel,
          handler: () => {
            emit("cancel");
          }
        }
      };
    });
    console.log(Modal.Alerts);
    const normalizeVariant = computed(() => {
      switch (props2.variant) {
        case Modal.Alerts.WARNING:
          return Modal.Alerts.WARNING;
        case Modal.Alerts.ERROR:
          return Modal.Alerts.ERROR;
        case Modal.Alerts.SUCCESS:
        default:
          return SUCCESS_DEFAULT;
      }
    });
    const dialogProps = computed(() => {
      return {
        actionAlignment: Modal.ActionAlignments.CENTER,
        header: Modal.Headers.TRANSPARENT,
        size: Modal.Sizes.SMALL,
        ...attrs
      };
    });
    const headerIcon = computed(() => {
      switch (props2.variant) {
        case Modal.Alerts.WARNING:
          return Icons$1.ALERT_TRIANGLE;
        case Modal.Alerts.ERROR:
          return Icons$1.ALERT_CIRCLE;
        case Modal.Alerts.SUCCESS:
        default:
          return Icons$1.CHECK_CIRCLE_SOLID;
      }
    });
    return {
      actions,
      dialogProps,
      headerIcon,
      normalizeVariant
    };
  }
};
const __cssModules$1k = {};
var __component__$1k = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1k,
  render$2v,
  staticRenderFns$1j,
  false,
  __vue2_injectStyles$1k,
  "972cf8a4",
  null,
  null
);
function __vue2_injectStyles$1k(context) {
  for (let o in __cssModules$1k) {
    this[o] = __cssModules$1k[o];
  }
}
var AlertModal = /* @__PURE__ */ function() {
  return __component__$1k.exports;
}();
var render$2u = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", _vm._g(_vm._b({ staticClass: "annular-throbber", class: "annular-throbber--" + _vm.size }, "div", _vm.$attrs, false), _vm.$listeners));
};
var staticRenderFns$1i = [];
var AnnularThrobber_vue_vue_type_style_index_0_scoped_true_lang = "";
const Sizes$c = Object.freeze({
  SM: "sm",
  MD: "md",
  LG: "lg",
  XL: "xl"
});
const __vue2_script$1j = {
  props: {
    size: {
      type: String,
      default: Sizes$c.MD,
      validator: (value) => Object.values(Sizes$c).includes(value)
    }
  }
};
const __cssModules$1j = {};
var __component__$1j = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1j,
  render$2u,
  staticRenderFns$1i,
  false,
  __vue2_injectStyles$1j,
  "14503b8a",
  null,
  null
);
function __vue2_injectStyles$1j(context) {
  for (let o in __cssModules$1j) {
    this[o] = __cssModules$1j[o];
  }
}
var AnnularThrobber = /* @__PURE__ */ function() {
  return __component__$1j.exports;
}();
var DEFAULT_USER_IMAGE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAENSURBVHgB7ZXbTsMwDIadI03HIrH3f8EJTUysR3IosWEXaLQzg4mL7ZeiyImdz7UtVWy3zxNcURKurDvg/wGa6+hcRWsqM9f3PQzDyIpjAVarmtZRxqxBCFFAw9lYVomq6uHkzDkHHLEAUl7eKlbkd6UYxz/sQdO01Ny6rsjuuh7atuOE8gBa6/JgCyG8kR1CLGcKYkznY5cfVuC9B6Uk7HYvNKY5TwUQYLN5gpQS7PevtM9psQferwmCI4k7Zp5zLmNq6F4pTOARLvoCnBwszVHWmmKbEz+EoS+CfwQoSX91LI8boz/hAriaBaSUaTyttWRjObD+H3BJ96gY42z2iwDU4dDAb3X/H9wA4B03clxW/4/smQAAAABJRU5ErkJggg==";
function getNameInitials(name) {
  const names = (name || "").split(" ");
  const firstInitial = names[0].charAt(0);
  return names.length > 1 ? firstInitial + names[names.length - 1].charAt(0) : firstInitial;
}
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : void 0;
}
var last_1 = last;
const FS_BASE_URL = "https://cdn.filestackcontent.com";
function resizeFilestackImage(url, options = {}) {
  if (url.indexOf(FS_BASE_URL) !== 0) {
    return url;
  }
  const params = Object.entries(options).map((entry) => entry.join(":")).join(",");
  if (!params) {
    return url;
  }
  const imageId = last_1(url.split("/"));
  return [FS_BASE_URL, `resize=${params}`, imageId].join("/");
}
var render$2t = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", _vm._g(_vm._b({ staticClass: "avatar-image", class: {
    "avatar-image--rounded": !_vm.square,
    "avatar-image--bordered": _vm.border
  }, style: _vm.styles }, "div", _vm.$attrs, false), _vm.$listeners), [_vm.renderedInitials && !_vm.image ? _c("div", { staticClass: "avatar-image__initials" }, [_vm._v(" " + _vm._s(_vm.renderedInitials) + " ")]) : _vm._e()]);
};
var staticRenderFns$1h = [];
var AvatarImage_vue_vue_type_style_index_0_scoped_true_lang = "";
const pxToRem = (val) => `${parseInt(val, 10) / 16}rem`;
const getStyles = (props2) => {
  const { size, image, initials, name } = props2;
  let backgroundImage = null;
  if (image) {
    backgroundImage = `url(${resizeFilestackImage(image, {
      width: size,
      height: size
    })})`;
  } else if (!(initials || name)) {
    backgroundImage = `url(${DEFAULT_USER_IMAGE})`;
  }
  return {
    backgroundImage,
    fontSize: pxToRem(size * 0.44),
    height: pxToRem(size),
    width: pxToRem(size)
  };
};
const __vue2_script$1i = {
  props: {
    border: {
      type: Boolean,
      default: false
    },
    image: {
      type: String,
      default: null
    },
    initials: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    size: {
      type: Number,
      default: 40
    },
    square: {
      type: Boolean,
      default: false
    }
  },
  setup(props2) {
    const styles2 = computed(() => getStyles(props2));
    const renderedInitials = computed(
      () => props2.name ? getNameInitials(props2.name) : props2.initials
    );
    return {
      renderedInitials,
      styles: styles2
    };
  }
};
const __cssModules$1i = {};
var __component__$1i = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1i,
  render$2t,
  staticRenderFns$1h,
  false,
  __vue2_injectStyles$1i,
  "5493a3c8",
  null,
  null
);
function __vue2_injectStyles$1i(context) {
  for (let o in __cssModules$1i) {
    this[o] = __cssModules$1i[o];
  }
}
var AvatarImage = /* @__PURE__ */ function() {
  return __component__$1i.exports;
}();
const CONFIRMATION = Object.freeze({
  key: "confirmation",
  icon: Icons$1.CHECK_CIRCLE
});
const ERROR = Object.freeze({
  key: "error",
  icon: Icons$1.CLOSE_CIRCLE
});
const EXPLAINER = Object.freeze({
  key: "explainer",
  icon: Icons$1.INFO_CIRCLE_LIGHT
});
const PASSIVE = Object.freeze({
  key: "passive",
  icon: Icons$1.INFO_CIRCLE_LIGHT
});
const WARNING = Object.freeze({
  key: "warning",
  icon: Icons$1.ALERT_CIRCLE_LIGHT
});
const Banner = Object.freeze({
  Variants: {
    CONFIRMATION,
    ERROR,
    EXPLAINER,
    PASSIVE,
    WARNING
  }
});
var render$2s = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tag, _vm._g(_vm._b({ tag: "component", class: _vm.classList, attrs: { "title": _vm.title } }, "component", _vm.$attrs, false), _vm.$listeners), [_c("div", { staticClass: "icon-button" }, [_c("BaseIcon", { staticClass: "icon-button__icon", attrs: { "icon": _vm.icon } })], 1), _vm.title ? _c("span", { staticClass: "icon-button__title" }, [_vm._v(_vm._s(_vm.title))]) : _vm._e()]);
};
var staticRenderFns$1g = [];
var IconButton_vue_vue_type_style_index_0_scoped_true_lang = "";
const { Sizes: Sizes$b, Variants: Variants$5 } = Button;
const __vue2_script$1h = defineComponent({
  name: "IconButton",
  components: { BaseIcon },
  props: {
    flat: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      required: true,
      validator: (value) => Object.values(Icons$1).includes(value)
    },
    size: {
      type: String,
      default: Sizes$b.MEDIUM,
      validator: (value) => Object.values(Sizes$b).includes(value)
    },
    tag: {
      type: String,
      default: "button"
    },
    title: {
      type: String,
      default: ""
    },
    variant: {
      type: String,
      default: Variants$5.PRIMARY,
      validator: (value) => {
        return Object.values(Variants$5).includes(value);
      }
    }
  },
  setup(props2) {
    const baseClass2 = "icon-button";
    const classList2 = computed(() => [
      baseClass2,
      `${baseClass2}--${props2.size}`,
      `${baseClass2}--${props2.variant}`,
      {
        [`${baseClass2}--flat`]: props2.flat,
        [`${baseClass2}--regular`]: !props2.flat
      }
    ]);
    return {
      classList: classList2
    };
  }
});
const __cssModules$1h = {};
var __component__$1h = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1h,
  render$2s,
  staticRenderFns$1g,
  false,
  __vue2_injectStyles$1h,
  "6f6ccc86",
  null,
  null
);
function __vue2_injectStyles$1h(context) {
  for (let o in __cssModules$1h) {
    this[o] = __cssModules$1h[o];
  }
}
var IconButton = /* @__PURE__ */ function() {
  return __component__$1h.exports;
}();
var render$2r = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "banner", class: [
    _vm.dark ? "banner-dark banner-dark--" + _vm.variant : "banner--" + _vm.variant
  ] }, [_c("div", { staticClass: "banner__icon-container" }, [_vm.showIcon ? _c("BaseIcon", { staticClass: "banner__icon", attrs: { "icon": _vm.computedIcon } }) : _vm._e()], 1), _c("div", { staticClass: "banner__message" }, [_vm._t("default", [_vm._v(_vm._s(_vm.message))])], 2), _c("div", { staticClass: "banner__actions-container" }, [_c("div", { staticClass: "banner__actions" }, [_vm._t("actions"), _vm.showClose ? _c("IconButton", _vm._b({ staticClass: "banner__close", attrs: { "title": "Close", "flat": true }, on: { "click": function($event) {
    return _vm.$emit("close");
  } } }, "IconButton", _vm.actionProps, false)) : _vm._e()], 2)]), _c("div", { staticClass: "banner__description-container" }, [_vm._t("description", [_vm.description ? _c("div", { staticClass: "banner__description" }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e()])], 2)]);
};
var staticRenderFns$1f = [];
var BaseBanner_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$1g = {
  name: "BaseBanner",
  components: { BaseIcon, IconButton },
  props: {
    description: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null,
      validator: (value) => !value || isValidIcon$1(value)
    },
    message: {
      type: String,
      default: null
    },
    showClose: {
      type: Boolean,
      default: true
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    dark: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: Banner.Variants.PASSIVE.key,
      validator: (value) => Object.keys(Banner.Variants).map((variant) => Banner.Variants[variant].key).includes(value)
    }
  },
  setup(props2) {
    const actionProps = computed(() => ({
      size: Button.Sizes.SMALL,
      icon: Icons$1.CLOSE
    }));
    const computedIcon = computed(
      () => props2.icon || Banner.Variants[props2.variant.toUpperCase()].icon
    );
    return {
      actionProps,
      computedIcon
    };
  }
};
const __cssModules$1g = {};
var __component__$1g = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1g,
  render$2r,
  staticRenderFns$1f,
  false,
  __vue2_injectStyles$1g,
  "5ddf868e",
  null,
  null
);
function __vue2_injectStyles$1g(context) {
  for (let o in __cssModules$1g) {
    this[o] = __cssModules$1g[o];
  }
}
var BaseBanner = /* @__PURE__ */ function() {
  return __component__$1g.exports;
}();
var render$2q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", _vm._g(_vm._b({ class: _vm.classList }, "div", _vm.$attrs, false), _vm.$listeners), [_c("BaseIcon", { attrs: { "icon": _vm.isIndeterminate } })], 1);
};
var staticRenderFns$1e = [];
var CheckboxIndicator_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$1f = defineComponent({
  name: "CheckboxIndicator",
  components: {
    BaseIcon
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    focused: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => Object.values(Form.Sizes).includes(value)
    }
  },
  setup(props2) {
    const classList2 = computed(() => [
      "checkbox-indicator",
      `checkbox-indicator--${props2.size}`,
      props2.checked && "checkbox-indicator--checked",
      props2.disabled && "checkbox-indicator--disabled",
      props2.focused && "checkbox-indicator--focused",
      props2.invalid && "checkbox-indicator--invalid"
    ]);
    const isIndeterminate = computed(
      () => props2.indeterminate ? Icons$1.MINUS : Icons$1.CHECK
    );
    return { classList: classList2, isIndeterminate };
  }
});
const __cssModules$1f = {};
var __component__$1f = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1f,
  render$2q,
  staticRenderFns$1e,
  false,
  __vue2_injectStyles$1f,
  "63909fc3",
  null,
  null
);
function __vue2_injectStyles$1f(context) {
  for (let o in __cssModules$1f) {
    this[o] = __cssModules$1f[o];
  }
}
var CheckboxIndicator = /* @__PURE__ */ function() {
  return __component__$1f.exports;
}();
var render$2p = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", _vm._g(_vm._b({ class: _vm.classList }, "div", _vm.$attrs, false), _vm.$listeners));
};
var staticRenderFns$1d = [];
var RadioIndicator_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$1e = defineComponent({
  name: "RadioIndicator",
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    focused: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => Object.values(Form.Sizes).includes(value)
    }
  },
  setup(props2) {
    const classList2 = computed(() => {
      return [
        "radio-indicator",
        `radio-indicator--${props2.size}`,
        props2.checked && "radio-indicator--checked",
        props2.disabled && "radio-indicator--disabled",
        props2.focused && "radio-indicator--focused",
        props2.invalid && "radio-indicator--invalid"
      ];
    });
    return { classList: classList2 };
  }
});
const __cssModules$1e = {};
var __component__$1e = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1e,
  render$2p,
  staticRenderFns$1d,
  false,
  __vue2_injectStyles$1e,
  "ec450012",
  null,
  null
);
function __vue2_injectStyles$1e(context) {
  for (let o in __cssModules$1e) {
    this[o] = __cssModules$1e[o];
  }
}
var RadioIndicator = /* @__PURE__ */ function() {
  return __component__$1e.exports;
}();
var render$2o = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", _vm._g(_vm._b({ class: _vm.classList }, "div", _vm.$attrs, false), _vm.$listeners));
};
var staticRenderFns$1c = [];
var SwitchIndicator_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$1d = defineComponent({
  name: "SwitchIndicator",
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    focused: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => Object.values(Form.Sizes).includes(value)
    }
  },
  setup(props2) {
    const classList2 = computed(() => {
      return [
        "switch-indicator",
        `switch-indicator--${props2.size}`,
        props2.checked && "switch-indicator--checked",
        props2.disabled && "switch-indicator--disabled",
        props2.focused && "switch-indicator--focused",
        props2.invalid && "switch-indicator--invalid"
      ];
    });
    return { classList: classList2 };
  }
});
const __cssModules$1d = {};
var __component__$1d = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1d,
  render$2o,
  staticRenderFns$1c,
  false,
  __vue2_injectStyles$1d,
  "0ba93e30",
  null,
  null
);
function __vue2_injectStyles$1d(context) {
  for (let o in __cssModules$1d) {
    this[o] = __cssModules$1d[o];
  }
}
var SwitchIndicator = /* @__PURE__ */ function() {
  return __component__$1d.exports;
}();
var render$2n = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("label", { staticClass: "toggle-input", class: [
    "toggle-input--" + _vm.size,
    "toggle-input--label-" + _vm.labelPosition,
    {
      "toggle-input--disabled": _vm.disabled
    }
  ], attrs: { "for": _vm.id } }, [_c("input", _vm._g(_vm._b({ staticClass: "toggle-input__input", attrs: { "id": _vm.id, "type": _vm.type, "name": _vm.name || _vm.id, "disabled": _vm.disabled }, domProps: { "checked": _vm.checked }, on: { "focus": function($event) {
    _vm.hasFocus = true;
  }, "blur": function($event) {
    _vm.hasFocus = false;
  } } }, "input", _vm.$attrs, false), _vm.$listeners)), _c(_vm.toggleComponent, { tag: "component", attrs: { "checked": _vm.checked, "disabled": _vm.disabled, "focused": _vm.hasFocus, "invalid": _vm.invalid, "indeterminate": _vm.indeterminate, "size": _vm.size } }), _c("div", { staticClass: "toggle-input__label" }, [_vm._t("default", [_c("span", { domProps: { "innerHTML": _vm._s(_vm.label) } })])], 2)], 1);
};
var staticRenderFns$1b = [];
var ToggleInput_vue_vue_type_style_index_0_scoped_true_lang = "";
const ToggleTypes$1 = Object.freeze({
  CHECKBOX: "checkbox",
  RADIO: "radio"
});
const SWITCH = "switch";
const __vue2_script$1c = defineComponent({
  name: "ToggleInput",
  components: { CheckboxIndicator },
  inheritAttrs: false,
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: shortid.generate
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    labelPosition: {
      type: String,
      default: Form.LabelPositions.RIGHT,
      validator: (value) => Object.values(Form.LabelPositions).includes(value)
    },
    name: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => Object.values(Form.Sizes).includes(value)
    },
    type: {
      type: String,
      default: ToggleTypes$1.CHECKBOX,
      validator: (value) => Object.values(ToggleTypes$1).includes(value)
    },
    variant: {
      type: String,
      default: Form.Variants.STANDARD,
      validator: (value) => [Form.Variants.STANDARD, SWITCH].includes(value)
    }
  },
  setup(props2) {
    const hasFocus = ref(false);
    const toggleComponent = computed(() => {
      if (props2.type === ToggleTypes$1.RADIO) {
        return RadioIndicator;
      }
      return props2.variant === SWITCH ? SwitchIndicator : CheckboxIndicator;
    });
    return {
      hasFocus,
      toggleComponent
    };
  }
});
const __cssModules$1c = {};
var __component__$1c = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1c,
  render$2n,
  staticRenderFns$1b,
  false,
  __vue2_injectStyles$1c,
  "7a34c82f",
  null,
  null
);
function __vue2_injectStyles$1c(context) {
  for (let o in __cssModules$1c) {
    this[o] = __cssModules$1c[o];
  }
}
var ToggleInput = /* @__PURE__ */ function() {
  return __component__$1c.exports;
}();
var render$2m = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ToggleInput", { staticClass: "checkbox-input", attrs: { "id": _vm.id, "type": "checkbox", "checked": _vm.value === _vm.trueValue, "disabled": _vm.disabled, "invalid": _vm.invalid, "label": _vm.label, "label-position": _vm.labelPosition, "name": _vm.name || _vm.id, "size": _vm.size, "indeterminate": _vm.indeterminate }, on: { "click": function($event) {
    return _vm.$emit("input", $event.target.checked ? _vm.trueValue : _vm.falseValue);
  } } }, [_vm._t("default")], 2);
};
var staticRenderFns$1a = [];
const __vue2_script$1b = defineComponent({
  name: "CheckboxInput",
  components: { ToggleInput },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    falseValue: {
      type: [String, Boolean],
      default: false
    },
    id: {
      type: String,
      default: null
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    labelPosition: {
      type: String,
      default: Form.LabelPositions.RIGHT,
      validator: (value) => Object.values(Form.LabelPositions).includes(value)
    },
    name: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => [Form.Sizes.DENSE, Form.Sizes.NORMAL].includes(value)
    },
    trueValue: {
      type: [String, Boolean],
      default: true
    },
    value: {
      type: [String, Boolean],
      default: false
    }
  }
});
const __cssModules$1b = {};
var __component__$1b = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1b,
  render$2m,
  staticRenderFns$1a,
  false,
  __vue2_injectStyles$1b,
  null,
  null,
  null
);
function __vue2_injectStyles$1b(context) {
  for (let o in __cssModules$1b) {
    this[o] = __cssModules$1b[o];
  }
}
var CheckboxInput = /* @__PURE__ */ function() {
  return __component__$1b.exports;
}();
var render$2l = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "field-label", class: [
    "field-label--" + _vm.size,
    {
      "field-label--disabled": _vm.disabled,
      "field-label--invalid": _vm.invalid
    }
  ] }, [_vm._t("default")], 2);
};
var staticRenderFns$19 = [];
var FieldLabel_vue_vue_type_style_index_0_scoped_true_lang = "";
const { Sizes: Sizes$a } = Form;
const __vue2_script$1a = defineComponent({
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Sizes$a.NORMAL,
      validator: (value) => Object.values(Sizes$a).includes(value)
    }
  }
});
const __cssModules$1a = {};
var __component__$1a = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1a,
  render$2l,
  staticRenderFns$19,
  false,
  __vue2_injectStyles$1a,
  "fa02b654",
  null,
  null
);
function __vue2_injectStyles$1a(context) {
  for (let o in __cssModules$1a) {
    this[o] = __cssModules$1a[o];
  }
}
var FieldLabel = /* @__PURE__ */ function() {
  return __component__$1a.exports;
}();
var render$2k = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ToggleInput", { staticClass: "radio-input", attrs: { "id": _vm.id, "type": "radio", "checked": _vm.checked, "disabled": _vm.disabled, "invalid": _vm.invalid, "label": _vm.label, "label-position": _vm.labelPosition, "name": _vm.name, "size": _vm.size, "value": _vm.value, "variant": _vm.variant }, on: { "click": function($event) {
    return _vm.$emit("input", _vm.value);
  } } }, [_vm._t("default")], 2);
};
var staticRenderFns$18 = [];
const __vue2_script$19 = defineComponent({
  name: "RadioInput",
  components: { ToggleInput },
  inheritAttrs: false,
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    labelPosition: {
      type: String,
      default: Form.LabelPositions.RIGHT,
      validator: (value) => Object.values(Form.LabelPositions).includes(value)
    },
    name: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => [Form.Sizes.DENSE, Form.Sizes.NORMAL].includes(value)
    },
    value: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: Form.Variants.STANDARD,
      validator: (value) => [Form.Variants.STANDARD, Form.Variants.RAISED].includes(value)
    }
  }
});
const __cssModules$19 = {};
var __component__$19 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$19,
  render$2k,
  staticRenderFns$18,
  false,
  __vue2_injectStyles$19,
  null,
  null,
  null
);
function __vue2_injectStyles$19(context) {
  for (let o in __cssModules$19) {
    this[o] = __cssModules$19[o];
  }
}
var RadioInput = /* @__PURE__ */ function() {
  return __component__$19.exports;
}();
var render$2j = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ToggleInput", { staticClass: "block-selector", class: [
    {
      "block-selector--selected": _vm.checked,
      "block-selector--focus": _vm.isFocused,
      "block-selector--disabled": _vm.disabled
    },
    "block-selector--" + _vm.labelPosition
  ], attrs: { "id": _vm.id, "type": _vm.type, "checked": _vm.isChecked, "disabled": _vm.disabled, "label-position": _vm.labelPosition, "name": _vm.name || _vm.id }, on: { "focus": function($event) {
    _vm.isFocused = true;
  }, "blur": function($event) {
    _vm.isFocused = false;
  }, "click": function($event) {
    return _vm.$emit("input", $event.target.checked ? _vm.trueValue : _vm.falseValue);
  } } }, [_c("div", { staticClass: "block-selector__text" }, [!!_vm.$slots.label || _vm.label ? _c("div", [_c("div", { staticClass: "block-selector__text__label" }, [_vm._t("label", [_vm._v(" " + _vm._s(_vm.label) + " ")])], 2)]) : _vm._e(), !!_vm.$slots.description || _vm.description ? _c("div", [_c("div", { staticClass: "block-selector__text__description" }, [_vm._t("description", [_vm._v(" " + _vm._s(_vm.description) + " ")])], 2)]) : _vm._e()])]);
};
var staticRenderFns$17 = [];
var BlockSelector_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$18 = defineComponent({
  name: "BlockSelector",
  components: { ToggleInput },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "checkbox"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: shortid.generate
    },
    labelPosition: {
      type: String,
      default: Form.LabelPositions.RIGHT,
      validator: (value) => Object.values(Form.LabelPositions).includes(value)
    },
    name: {
      type: String,
      default: null
    },
    falseValue: {
      type: [String, Boolean],
      default: false
    },
    trueValue: {
      type: [String, Boolean],
      default: true
    },
    value: {
      type: [String, Boolean],
      default: false
    }
  },
  setup(props2) {
    const isFocused = ref(false);
    const isChecked = computed(
      () => props2.type === "radio" ? props2.checked : props2.value === props2.trueValue
    );
    return {
      isFocused,
      isChecked
    };
  }
});
const __cssModules$18 = {};
var __component__$18 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$18,
  render$2j,
  staticRenderFns$17,
  false,
  __vue2_injectStyles$18,
  "28101f70",
  null,
  null
);
function __vue2_injectStyles$18(context) {
  for (let o in __cssModules$18) {
    this[o] = __cssModules$18[o];
  }
}
var BlockSelector = /* @__PURE__ */ function() {
  return __component__$18.exports;
}();
var render$2i = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ToggleInput", { staticClass: "switch-input", attrs: { "id": _vm.id, "type": "checkbox", "checked": _vm.value === _vm.trueValue, "disabled": _vm.disabled, "invalid": _vm.invalid, "label": _vm.label, "label-position": _vm.labelPosition, "name": _vm.name || _vm.id, "size": _vm.size, "variant": "switch" }, on: { "click": function($event) {
    return _vm.$emit("input", $event.target.checked ? _vm.trueValue : _vm.falseValue);
  } } }, [_vm._t("default")], 2);
};
var staticRenderFns$16 = [];
const __vue2_script$17 = defineComponent({
  name: "SwitchInput",
  components: { ToggleInput },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    falseValue: {
      type: [String, Boolean],
      default: false
    },
    id: {
      type: String,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    labelPosition: {
      type: String,
      default: Form.LabelPositions.RIGHT,
      validator: (value) => Object.values(Form.LabelPositions).includes(value)
    },
    name: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => [Form.Sizes.DENSE, Form.Sizes.NORMAL].includes(value)
    },
    trueValue: {
      type: [String, Boolean],
      default: true
    },
    value: {
      type: [String, Boolean],
      default: false
    }
  }
});
const __cssModules$17 = {};
var __component__$17 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$17,
  render$2i,
  staticRenderFns$16,
  false,
  __vue2_injectStyles$17,
  null,
  null,
  null
);
function __vue2_injectStyles$17(context) {
  for (let o in __cssModules$17) {
    this[o] = __cssModules$17[o];
  }
}
var SwitchInput = /* @__PURE__ */ function() {
  return __component__$17.exports;
}();
const mapOptions = (options) => options.map((item) => {
  if (typeof item === "string") {
    return {
      label: item,
      value: item
    };
  }
  const { label, value, ...rest } = item;
  return {
    label: label || value,
    value: value || label,
    ...rest
  };
});
var render$2h = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "toggle-group" }, [_vm.label ? _c("FieldLabel", { attrs: { "disabled": _vm.disabled, "invalid": _vm.invalid } }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(), _c("div", { staticClass: "toggle-group__options", class: [
    _vm.vertical ? "toggle-group--vertical" : "toggle-group--horizontal",
    "toggle-group--" + _vm.size
  ] }, _vm._l(_vm.mappedOptions, function(item, i) {
    return _c(_vm.component, _vm._b({ key: item.value, tag: "component", attrs: { "id": _vm.name + "-" + i, "type": _vm.mappedType }, on: { "input": function($event) {
      return _vm.handleInput(item.value, $event);
    } } }, "component", _vm.getInputProps(item), false));
  }), 1)], 1);
};
var staticRenderFns$15 = [];
var ToggleGroup_vue_vue_type_style_index_0_scoped_true_lang = "";
const ToggleTypes = Object.freeze({
  CHECKBOX: "checkbox",
  RADIO: "radio",
  SWITCH: "switch",
  BLOCK_RADIO: "block-radio",
  BLOCK_CHECK: "block-check"
});
const ToggleComponents = Object.freeze({
  [ToggleTypes.CHECKBOX]: CheckboxInput,
  [ToggleTypes.RADIO]: RadioInput,
  [ToggleTypes.SWITCH]: SwitchInput,
  [ToggleTypes.BLOCK_RADIO]: BlockSelector,
  [ToggleTypes.BLOCK_CHECK]: BlockSelector
});
const __vue2_script$16 = defineComponent({
  name: "ToggleGroup",
  components: { FieldLabel },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    labelPosition: {
      type: String,
      default: Form.LabelPositions.RIGHT,
      validator: (value) => Object.values(Form.LabelPositions).includes(value)
    },
    name: {
      type: String,
      default: shortid.generate
    },
    options: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => [Form.Sizes.DENSE, Form.Sizes.NORMAL].includes(value)
    },
    vertical: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Array],
      default: null
    },
    type: {
      type: String,
      default: ToggleTypes.CHECKBOX,
      validator: (value) => Object.values(ToggleTypes).includes(value)
    }
  },
  setup(props2, { emit }) {
    const component = computed(() => {
      return ToggleComponents[props2.type];
    });
    const isMulti = computed(() => {
      return props2.type !== ToggleTypes.RADIO && props2.type !== ToggleTypes.BLOCK_RADIO;
    });
    const mappedOptions = computed(() => mapOptions(props2.options));
    const mappedType = computed(() => {
      if (props2.type === ToggleTypes.BLOCK_RADIO) {
        return "radio";
      }
      if (props2.type === ToggleTypes.BLOCK_CHECK) {
        return "checkbox";
      }
      return props2.type;
    });
    const getInputProps = (item) => {
      const itemProps = {
        disabled: props2.disabled,
        invalid: props2.invalid,
        label: item.label,
        labelPosition: props2.labelPosition,
        name: props2.name,
        required: props2.required,
        size: props2.size,
        description: item.description
      };
      if (isMulti.value) {
        itemProps.value = (props2.value || []).includes(item.value);
      } else {
        itemProps.checked = props2.value === item.value;
        itemProps.value = item.value;
      }
      return itemProps;
    };
    const handleInput = (val, isChecked) => {
      let emittedValue = val;
      if (isMulti.value) {
        emittedValue = isChecked ? [...props2.value || [], val] : props2.value.filter((item) => item !== val);
      }
      emit("input", emittedValue);
    };
    return {
      component,
      isMulti,
      mappedOptions,
      mappedType,
      getInputProps,
      handleInput
    };
  }
});
const __cssModules$16 = {};
var __component__$16 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$16,
  render$2h,
  staticRenderFns$15,
  false,
  __vue2_injectStyles$16,
  "1c4d3de5",
  null,
  null
);
function __vue2_injectStyles$16(context) {
  for (let o in __cssModules$16) {
    this[o] = __cssModules$16[o];
  }
}
var ToggleGroup = /* @__PURE__ */ function() {
  return __component__$16.exports;
}();
var render$2g = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ToggleGroup", { staticClass: "checkbox-group", attrs: { "options": _vm.options, "disabled": _vm.disabled, "invalid": _vm.invalid, "label": _vm.label, "label-position": _vm.labelPosition, "name": _vm.name, "required": _vm.required, "size": _vm.size, "vertical": _vm.vertical, "value": _vm.value, "type": "checkbox" }, on: { "input": function($event) {
    return _vm.$emit("input", $event);
  } } });
};
var staticRenderFns$14 = [];
const __vue2_script$15 = defineComponent({
  name: "CheckboxGroup",
  components: { ToggleGroup },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    labelPosition: {
      type: String,
      default: Form.LabelPositions.RIGHT,
      validator: (value) => Object.values(Form.LabelPositions).includes(value)
    },
    name: {
      type: String,
      default: void 0
    },
    options: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => [Form.Sizes.DENSE, Form.Sizes.NORMAL].includes(value)
    },
    vertical: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    }
  }
});
const __cssModules$15 = {};
var __component__$15 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$15,
  render$2g,
  staticRenderFns$14,
  false,
  __vue2_injectStyles$15,
  null,
  null,
  null
);
function __vue2_injectStyles$15(context) {
  for (let o in __cssModules$15) {
    this[o] = __cssModules$15[o];
  }
}
var CheckboxGroup = /* @__PURE__ */ function() {
  return __component__$15.exports;
}();
var root$8 = _root;
var nativeIsFinite = root$8.isFinite;
function isFinite(value) {
  return typeof value == "number" && nativeIsFinite(value);
}
var _isFinite = isFinite;
var baseGetTag$5 = _baseGetTag, isArray$9 = isArray_1, isObjectLike$9 = isObjectLike_1;
var stringTag$4 = "[object String]";
function isString$1(value) {
  return typeof value == "string" || !isArray$9(value) && isObjectLike$9(value) && baseGetTag$5(value) == stringTag$4;
}
var isString_1 = isString$1;
var render$2f = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "field-container", class: [
    "field-container--" + _vm.size,
    {
      "field-container--disabled": _vm.disabled,
      "field-container--invalid": _vm.invalid
    }
  ] }, [_vm._t("default")], 2);
};
var staticRenderFns$13 = [];
var FieldContainer_vue_vue_type_style_index_0_scoped_true_lang = "";
const { Sizes: Sizes$9 } = Form;
const __vue2_script$14 = {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    focused: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Sizes$9.NORMAL,
      validator: (value) => Object.values(Sizes$9).includes(value)
    }
  }
};
const __cssModules$14 = {};
var __component__$14 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$14,
  render$2f,
  staticRenderFns$13,
  false,
  __vue2_injectStyles$14,
  "0c163c3f",
  null,
  null
);
function __vue2_injectStyles$14(context) {
  for (let o in __cssModules$14) {
    this[o] = __cssModules$14[o];
  }
}
var FieldContainer = /* @__PURE__ */ function() {
  return __component__$14.exports;
}();
var render$2e = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "field-error", attrs: { "id": _vm.fieldId + "-error", "role": "alert" } }, [_vm._t("default")], 2);
};
var staticRenderFns$12 = [];
var FieldError_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$13 = defineComponent({
  props: {
    fieldId: {
      type: String,
      required: true
    }
  }
});
const __cssModules$13 = {};
var __component__$13 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$13,
  render$2e,
  staticRenderFns$12,
  false,
  __vue2_injectStyles$13,
  "761e8e48",
  null,
  null
);
function __vue2_injectStyles$13(context) {
  for (let o in __cssModules$13) {
    this[o] = __cssModules$13[o];
  }
}
var FieldError = /* @__PURE__ */ function() {
  return __component__$13.exports;
}();
var render$2d = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("label", { staticClass: "form-field", attrs: { "for": _vm.id } }, [_vm.label ? _c("FieldLabel", _vm._b({}, "FieldLabel", _vm.passDownProps, false), [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(), _c("FieldContainer", _vm._b({}, "FieldContainer", _vm.passDownProps, false), [_vm._t("default")], 2), _vm.error ? _c("FieldError", { attrs: { "field-id": _vm.id } }, [_vm._v(" " + _vm._s(_vm.error) + " ")]) : _vm._e()], 1);
};
var staticRenderFns$11 = [];
var FormField_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$12 = defineComponent({
  components: {
    FieldContainer,
    FieldLabel,
    FieldError
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    id: {
      type: String,
      required: true
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    size: {
      type: String,
      required: true
    }
  },
  setup(props2) {
    const passDownProps = computed(() => {
      return {
        disabled: props2.disabled,
        id: props2.id,
        invalid: props2.invalid,
        size: props2.size
      };
    });
    return { passDownProps };
  }
});
const __cssModules$12 = {};
var __component__$12 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$12,
  render$2d,
  staticRenderFns$11,
  false,
  __vue2_injectStyles$12,
  "482d8ed0",
  null,
  null
);
function __vue2_injectStyles$12(context) {
  for (let o in __cssModules$12) {
    this[o] = __cssModules$12[o];
  }
}
var FormField = /* @__PURE__ */ function() {
  return __component__$12.exports;
}();
var render$2c = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("FormField", { staticClass: "date-input", class: [
    "date-input--" + _vm.size,
    {
      "date-input--invalid": _vm.invalid || _vm.error,
      "date-input--disabled": _vm.disabled
    }
  ], attrs: { "id": _vm.id + "-" + (_vm.isPlaceholderVisible ? "placeholder" : "month"), "size": _vm.size, "label": _vm.label, "error": _vm.error, "invalid": _vm.invalid, "disabled": _vm.disabled } }, [_vm.isPlaceholderVisible ? _c("input", { staticClass: "date-input__placeholder date-input__field", attrs: { "id": _vm.id + "-placeholder", "placeholder": _vm.placeholder, "disabled": _vm.disabled, "value": "", "readonly": "" }, on: { "focus": _vm.handlePlaceholderFocus } }) : [_c("input", { ref: "month", staticClass: "date-input__field--short date-input__field", attrs: { "id": _vm.id + "-month", "required": _vm.required, "disabled": _vm.disabled, "type": "text", "name": "month", "placeholder": "MM", "pattern": "[0-9]*", "aria-label": "Month" }, domProps: { "value": _vm.month }, on: { "input": _vm.handleInput, "blur": _vm.handleBlur } }), _c("span", { staticClass: "date-input__divider" }, [_vm._v("/")]), _c("input", { ref: "day", staticClass: "date-input__field--short date-input__field", attrs: { "id": _vm.id + "-day", "required": _vm.required, "disabled": _vm.disabled, "type": "text", "name": "day", "placeholder": "DD", "pattern": "[0-9]*", "aria-label": "Day" }, domProps: { "value": _vm.day }, on: { "input": _vm.handleInput, "blur": _vm.handleBlur } }), _c("span", { staticClass: "date-input__divider" }, [_vm._v("/")]), _c("input", { ref: "year", staticClass: "date-input__field--long date-input__field", attrs: { "id": _vm.id + "-year", "disabled": _vm.disabled, "type": "text", "name": "year", "placeholder": "YYYY", "pattern": "[0-9]*", "aria-label": "Year", "required": _vm.required }, domProps: { "value": _vm.year }, on: { "blur": _vm.handleBlur, "input": _vm.handleInput } })]], 2);
};
var staticRenderFns$10 = [];
var DateInput_vue_vue_type_style_index_0_scoped_true_lang = "";
const { Sizes: Sizes$8 } = Form;
const Fields = Object.freeze({
  MONTH: "month",
  DAY: "day",
  YEAR: "year"
});
const toTwoDigits = (num) => `${num}`.length === 1 ? `0${num}` : `${num}`;
const toFullYear = (num) => {
  let newValue = `${num}`;
  while (newValue.length < 4) {
    const char = newValue.length === 3 ? "2" : "0";
    newValue = char + newValue;
  }
  return newValue;
};
const getNumberSeries = (limit) => Array.from(Array(limit), (_, i) => toTwoDigits(i + 1));
const getDaysInMonth = (month, year) => {
  switch (month) {
    case "02":
      return year && year.length === 4 && parseInt(year, 10) % 4 ? getNumberSeries(28) : getNumberSeries(29);
    case "04":
    case "06":
    case "09":
    case "11":
      return getNumberSeries(30);
    default:
      return getNumberSeries(31);
  }
};
const sanitizeInput = (field, value) => {
  const characterLimit = field === Fields.YEAR ? 4 : 2;
  const finalValue = value.split("").filter((char) => _isFinite(parseInt(char, 10))).slice(0, characterLimit).join("");
  return finalValue;
};
const __vue2_script$11 = {
  components: {
    FormField
  },
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: shortid.generate
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => Object.values(Sizes$8).includes(value)
    },
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      hasFocus: false,
      month: "",
      day: "",
      year: ""
    };
  },
  computed: {
    isPlaceholderVisible() {
      return !!this.placeholder && !this.hasFocus && !this.month && !this.day && !this.year;
    }
  },
  watch: {
    value: {
      handler(newVal) {
        const val = isString_1(newVal) ? newVal : "";
        const [m = "", d = "", y = ""] = val.split("/");
        this.month = sanitizeInput(Fields.MONTH, m);
        this.day = sanitizeInput(Fields.DAY, d);
        this.year = sanitizeInput(Fields.YEAR, y);
      },
      immediate: true
    },
    month() {
      this.validateDay();
    },
    year() {
      this.validateDay();
    }
  },
  created() {
    document.addEventListener("focusin", this.focusChanged);
  },
  beforeDestroy() {
    document.removeEventListener("focusin", this.focusChanged);
  },
  methods: {
    emitValue() {
      this.$emit("input", [this.month, this.day, this.year].join("/"));
    },
    focusChanged(e) {
      this.hasFocus = Object.values(this.$refs).includes(e.target);
    },
    handleBlur(e) {
      const { name, value } = e.target;
      if (value) {
        const newValue = name === Fields.YEAR ? toFullYear(value) : toTwoDigits(value);
        if (value === newValue)
          return;
        e.target.value = newValue;
        this[name] = newValue;
        this.validateDay();
        this.emitValue();
      }
    },
    handleInput(e) {
      const { name, value } = e.target;
      let newValue = sanitizeInput(name, value);
      if (name === Fields.MONTH && parseInt(newValue, 10) > 12 || name === Fields.DAY && !getDaysInMonth(this.month, this.year).includes(
        toTwoDigits(newValue)
      )) {
        newValue = newValue.charAt(0);
      }
      this[name] = newValue;
      this.$refs[name].value = newValue;
      this.emitValue();
      if (name === Fields.MONTH && newValue.length >= 2) {
        this.$refs.day.focus();
      }
      if (name === Fields.DAY && newValue.length >= 2) {
        this.$refs.year.focus();
      }
    },
    async handlePlaceholderFocus() {
      this.hasFocus = true;
      await this.$nextTick();
      this.$refs.month.focus();
    },
    validateDay() {
      if (!this.day) {
        return;
      }
      if (getDaysInMonth(this.month, this.year).includes(this.day)) {
        return;
      }
      this.day = "";
    }
  }
};
const __cssModules$11 = {};
var __component__$11 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$11,
  render$2c,
  staticRenderFns$10,
  false,
  __vue2_injectStyles$11,
  "ac619e6e",
  null,
  null
);
function __vue2_injectStyles$11(context) {
  for (let o in __cssModules$11) {
    this[o] = __cssModules$11[o];
  }
}
var DateInput = /* @__PURE__ */ function() {
  return __component__$11.exports;
}();
var baseGetTag$4 = _baseGetTag, isObjectLike$8 = isObjectLike_1;
var boolTag$4 = "[object Boolean]";
function isBoolean$1(value) {
  return value === true || value === false || isObjectLike$8(value) && baseGetTag$4(value) == boolTag$4;
}
var isBoolean_1 = isBoolean$1;
function isObject$9(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_1 = isObject$9;
var commonjsGlobal = typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var NumeralFormatter = function(numeralDecimalMark, numeralIntegerScale, numeralDecimalScale, numeralThousandsGroupStyle, numeralPositiveOnly, stripLeadingZeroes, prefix, signBeforePrefix, tailPrefix, delimiter) {
  var owner = this;
  owner.numeralDecimalMark = numeralDecimalMark || ".";
  owner.numeralIntegerScale = numeralIntegerScale > 0 ? numeralIntegerScale : 0;
  owner.numeralDecimalScale = numeralDecimalScale >= 0 ? numeralDecimalScale : 2;
  owner.numeralThousandsGroupStyle = numeralThousandsGroupStyle || NumeralFormatter.groupStyle.thousand;
  owner.numeralPositiveOnly = !!numeralPositiveOnly;
  owner.stripLeadingZeroes = stripLeadingZeroes !== false;
  owner.prefix = prefix || prefix === "" ? prefix : "";
  owner.signBeforePrefix = !!signBeforePrefix;
  owner.tailPrefix = !!tailPrefix;
  owner.delimiter = delimiter || delimiter === "" ? delimiter : ",";
  owner.delimiterRE = delimiter ? new RegExp("\\" + delimiter, "g") : "";
};
NumeralFormatter.groupStyle = {
  thousand: "thousand",
  lakh: "lakh",
  wan: "wan",
  none: "none"
};
NumeralFormatter.prototype = {
  getRawValue: function(value) {
    return value.replace(this.delimiterRE, "").replace(this.numeralDecimalMark, ".");
  },
  format: function(value) {
    var owner = this, parts, partSign, partSignAndPrefix, partInteger, partDecimal = "";
    value = value.replace(/[A-Za-z]/g, "").replace(owner.numeralDecimalMark, "M").replace(/[^\dM-]/g, "").replace(/^\-/, "N").replace(/\-/g, "").replace("N", owner.numeralPositiveOnly ? "" : "-").replace("M", owner.numeralDecimalMark);
    if (owner.stripLeadingZeroes) {
      value = value.replace(/^(-)?0+(?=\d)/, "$1");
    }
    partSign = value.slice(0, 1) === "-" ? "-" : "";
    if (typeof owner.prefix != "undefined") {
      if (owner.signBeforePrefix) {
        partSignAndPrefix = partSign + owner.prefix;
      } else {
        partSignAndPrefix = owner.prefix + partSign;
      }
    } else {
      partSignAndPrefix = partSign;
    }
    partInteger = value;
    if (value.indexOf(owner.numeralDecimalMark) >= 0) {
      parts = value.split(owner.numeralDecimalMark);
      partInteger = parts[0];
      partDecimal = owner.numeralDecimalMark + parts[1].slice(0, owner.numeralDecimalScale);
    }
    if (partSign === "-") {
      partInteger = partInteger.slice(1);
    }
    if (owner.numeralIntegerScale > 0) {
      partInteger = partInteger.slice(0, owner.numeralIntegerScale);
    }
    switch (owner.numeralThousandsGroupStyle) {
      case NumeralFormatter.groupStyle.lakh:
        partInteger = partInteger.replace(/(\d)(?=(\d\d)+\d$)/g, "$1" + owner.delimiter);
        break;
      case NumeralFormatter.groupStyle.wan:
        partInteger = partInteger.replace(/(\d)(?=(\d{4})+$)/g, "$1" + owner.delimiter);
        break;
      case NumeralFormatter.groupStyle.thousand:
        partInteger = partInteger.replace(/(\d)(?=(\d{3})+$)/g, "$1" + owner.delimiter);
        break;
    }
    if (owner.tailPrefix) {
      return partSign + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : "") + owner.prefix;
    }
    return partSignAndPrefix + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : "");
  }
};
var NumeralFormatter_1 = NumeralFormatter;
var DateFormatter = function(datePattern, dateMin, dateMax) {
  var owner = this;
  owner.date = [];
  owner.blocks = [];
  owner.datePattern = datePattern;
  owner.dateMin = dateMin.split("-").reverse().map(function(x) {
    return parseInt(x, 10);
  });
  if (owner.dateMin.length === 2)
    owner.dateMin.unshift(0);
  owner.dateMax = dateMax.split("-").reverse().map(function(x) {
    return parseInt(x, 10);
  });
  if (owner.dateMax.length === 2)
    owner.dateMax.unshift(0);
  owner.initBlocks();
};
DateFormatter.prototype = {
  initBlocks: function() {
    var owner = this;
    owner.datePattern.forEach(function(value) {
      if (value === "Y") {
        owner.blocks.push(4);
      } else {
        owner.blocks.push(2);
      }
    });
  },
  getISOFormatDate: function() {
    var owner = this, date = owner.date;
    return date[2] ? date[2] + "-" + owner.addLeadingZero(date[1]) + "-" + owner.addLeadingZero(date[0]) : "";
  },
  getBlocks: function() {
    return this.blocks;
  },
  getValidatedDate: function(value) {
    var owner = this, result = "";
    value = value.replace(/[^\d]/g, "");
    owner.blocks.forEach(function(length, index) {
      if (value.length > 0) {
        var sub = value.slice(0, length), sub0 = sub.slice(0, 1), rest = value.slice(length);
        switch (owner.datePattern[index]) {
          case "d":
            if (sub === "00") {
              sub = "01";
            } else if (parseInt(sub0, 10) > 3) {
              sub = "0" + sub0;
            } else if (parseInt(sub, 10) > 31) {
              sub = "31";
            }
            break;
          case "m":
            if (sub === "00") {
              sub = "01";
            } else if (parseInt(sub0, 10) > 1) {
              sub = "0" + sub0;
            } else if (parseInt(sub, 10) > 12) {
              sub = "12";
            }
            break;
        }
        result += sub;
        value = rest;
      }
    });
    return this.getFixedDateString(result);
  },
  getFixedDateString: function(value) {
    var owner = this, datePattern = owner.datePattern, date = [], dayIndex = 0, monthIndex = 0, yearIndex = 0, dayStartIndex = 0, monthStartIndex = 0, yearStartIndex = 0, day, month, year, fullYearDone = false;
    if (value.length === 4 && datePattern[0].toLowerCase() !== "y" && datePattern[1].toLowerCase() !== "y") {
      dayStartIndex = datePattern[0] === "d" ? 0 : 2;
      monthStartIndex = 2 - dayStartIndex;
      day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
      month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
      date = this.getFixedDate(day, month, 0);
    }
    if (value.length === 8) {
      datePattern.forEach(function(type, index) {
        switch (type) {
          case "d":
            dayIndex = index;
            break;
          case "m":
            monthIndex = index;
            break;
          default:
            yearIndex = index;
            break;
        }
      });
      yearStartIndex = yearIndex * 2;
      dayStartIndex = dayIndex <= yearIndex ? dayIndex * 2 : dayIndex * 2 + 2;
      monthStartIndex = monthIndex <= yearIndex ? monthIndex * 2 : monthIndex * 2 + 2;
      day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
      month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
      year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);
      fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;
      date = this.getFixedDate(day, month, year);
    }
    if (value.length === 4 && (datePattern[0] === "y" || datePattern[1] === "y")) {
      monthStartIndex = datePattern[0] === "m" ? 0 : 2;
      yearStartIndex = 2 - monthStartIndex;
      month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
      year = parseInt(value.slice(yearStartIndex, yearStartIndex + 2), 10);
      fullYearDone = value.slice(yearStartIndex, yearStartIndex + 2).length === 2;
      date = [0, month, year];
    }
    if (value.length === 6 && (datePattern[0] === "Y" || datePattern[1] === "Y")) {
      monthStartIndex = datePattern[0] === "m" ? 0 : 4;
      yearStartIndex = 2 - 0.5 * monthStartIndex;
      month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
      year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);
      fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;
      date = [0, month, year];
    }
    date = owner.getRangeFixedDate(date);
    owner.date = date;
    var result = date.length === 0 ? value : datePattern.reduce(function(previous, current) {
      switch (current) {
        case "d":
          return previous + (date[0] === 0 ? "" : owner.addLeadingZero(date[0]));
        case "m":
          return previous + (date[1] === 0 ? "" : owner.addLeadingZero(date[1]));
        case "y":
          return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], false) : "");
        case "Y":
          return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], true) : "");
      }
    }, "");
    return result;
  },
  getRangeFixedDate: function(date) {
    var owner = this, datePattern = owner.datePattern, dateMin = owner.dateMin || [], dateMax = owner.dateMax || [];
    if (!date.length || dateMin.length < 3 && dateMax.length < 3)
      return date;
    if (datePattern.find(function(x) {
      return x.toLowerCase() === "y";
    }) && date[2] === 0)
      return date;
    if (dateMax.length && (dateMax[2] < date[2] || dateMax[2] === date[2] && (dateMax[1] < date[1] || dateMax[1] === date[1] && dateMax[0] < date[0])))
      return dateMax;
    if (dateMin.length && (dateMin[2] > date[2] || dateMin[2] === date[2] && (dateMin[1] > date[1] || dateMin[1] === date[1] && dateMin[0] > date[0])))
      return dateMin;
    return date;
  },
  getFixedDate: function(day, month, year) {
    day = Math.min(day, 31);
    month = Math.min(month, 12);
    year = parseInt(year || 0, 10);
    if (month < 7 && month % 2 === 0 || month > 8 && month % 2 === 1) {
      day = Math.min(day, month === 2 ? this.isLeapYear(year) ? 29 : 28 : 30);
    }
    return [day, month, year];
  },
  isLeapYear: function(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
  },
  addLeadingZero: function(number) {
    return (number < 10 ? "0" : "") + number;
  },
  addLeadingZeroForYear: function(number, fullYearMode) {
    if (fullYearMode) {
      return (number < 10 ? "000" : number < 100 ? "00" : number < 1e3 ? "0" : "") + number;
    }
    return (number < 10 ? "0" : "") + number;
  }
};
var DateFormatter_1 = DateFormatter;
var TimeFormatter = function(timePattern, timeFormat) {
  var owner = this;
  owner.time = [];
  owner.blocks = [];
  owner.timePattern = timePattern;
  owner.timeFormat = timeFormat;
  owner.initBlocks();
};
TimeFormatter.prototype = {
  initBlocks: function() {
    var owner = this;
    owner.timePattern.forEach(function() {
      owner.blocks.push(2);
    });
  },
  getISOFormatTime: function() {
    var owner = this, time = owner.time;
    return time[2] ? owner.addLeadingZero(time[0]) + ":" + owner.addLeadingZero(time[1]) + ":" + owner.addLeadingZero(time[2]) : "";
  },
  getBlocks: function() {
    return this.blocks;
  },
  getTimeFormatOptions: function() {
    var owner = this;
    if (String(owner.timeFormat) === "12") {
      return {
        maxHourFirstDigit: 1,
        maxHours: 12,
        maxMinutesFirstDigit: 5,
        maxMinutes: 60
      };
    }
    return {
      maxHourFirstDigit: 2,
      maxHours: 23,
      maxMinutesFirstDigit: 5,
      maxMinutes: 60
    };
  },
  getValidatedTime: function(value) {
    var owner = this, result = "";
    value = value.replace(/[^\d]/g, "");
    var timeFormatOptions = owner.getTimeFormatOptions();
    owner.blocks.forEach(function(length, index) {
      if (value.length > 0) {
        var sub = value.slice(0, length), sub0 = sub.slice(0, 1), rest = value.slice(length);
        switch (owner.timePattern[index]) {
          case "h":
            if (parseInt(sub0, 10) > timeFormatOptions.maxHourFirstDigit) {
              sub = "0" + sub0;
            } else if (parseInt(sub, 10) > timeFormatOptions.maxHours) {
              sub = timeFormatOptions.maxHours + "";
            }
            break;
          case "m":
          case "s":
            if (parseInt(sub0, 10) > timeFormatOptions.maxMinutesFirstDigit) {
              sub = "0" + sub0;
            } else if (parseInt(sub, 10) > timeFormatOptions.maxMinutes) {
              sub = timeFormatOptions.maxMinutes + "";
            }
            break;
        }
        result += sub;
        value = rest;
      }
    });
    return this.getFixedTimeString(result);
  },
  getFixedTimeString: function(value) {
    var owner = this, timePattern = owner.timePattern, time = [], secondIndex = 0, minuteIndex = 0, hourIndex = 0, secondStartIndex = 0, minuteStartIndex = 0, hourStartIndex = 0, second, minute, hour;
    if (value.length === 6) {
      timePattern.forEach(function(type, index) {
        switch (type) {
          case "s":
            secondIndex = index * 2;
            break;
          case "m":
            minuteIndex = index * 2;
            break;
          case "h":
            hourIndex = index * 2;
            break;
        }
      });
      hourStartIndex = hourIndex;
      minuteStartIndex = minuteIndex;
      secondStartIndex = secondIndex;
      second = parseInt(value.slice(secondStartIndex, secondStartIndex + 2), 10);
      minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
      hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);
      time = this.getFixedTime(hour, minute, second);
    }
    if (value.length === 4 && owner.timePattern.indexOf("s") < 0) {
      timePattern.forEach(function(type, index) {
        switch (type) {
          case "m":
            minuteIndex = index * 2;
            break;
          case "h":
            hourIndex = index * 2;
            break;
        }
      });
      hourStartIndex = hourIndex;
      minuteStartIndex = minuteIndex;
      second = 0;
      minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
      hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);
      time = this.getFixedTime(hour, minute, second);
    }
    owner.time = time;
    return time.length === 0 ? value : timePattern.reduce(function(previous, current) {
      switch (current) {
        case "s":
          return previous + owner.addLeadingZero(time[2]);
        case "m":
          return previous + owner.addLeadingZero(time[1]);
        case "h":
          return previous + owner.addLeadingZero(time[0]);
      }
    }, "");
  },
  getFixedTime: function(hour, minute, second) {
    second = Math.min(parseInt(second || 0, 10), 60);
    minute = Math.min(minute, 60);
    hour = Math.min(hour, 60);
    return [hour, minute, second];
  },
  addLeadingZero: function(number) {
    return (number < 10 ? "0" : "") + number;
  }
};
var TimeFormatter_1 = TimeFormatter;
var PhoneFormatter = function(formatter, delimiter) {
  var owner = this;
  owner.delimiter = delimiter || delimiter === "" ? delimiter : " ";
  owner.delimiterRE = delimiter ? new RegExp("\\" + delimiter, "g") : "";
  owner.formatter = formatter;
};
PhoneFormatter.prototype = {
  setFormatter: function(formatter) {
    this.formatter = formatter;
  },
  format: function(phoneNumber) {
    var owner = this;
    owner.formatter.clear();
    phoneNumber = phoneNumber.replace(/[^\d+]/g, "");
    phoneNumber = phoneNumber.replace(/^\+/, "B").replace(/\+/g, "").replace("B", "+");
    phoneNumber = phoneNumber.replace(owner.delimiterRE, "");
    var result = "", current, validated = false;
    for (var i = 0, iMax = phoneNumber.length; i < iMax; i++) {
      current = owner.formatter.inputDigit(phoneNumber.charAt(i));
      if (/[\s()-]/g.test(current)) {
        result = current;
        validated = true;
      } else {
        if (!validated) {
          result = current;
        }
      }
    }
    result = result.replace(/[()]/g, "");
    result = result.replace(/[\s-]/g, owner.delimiter);
    return result;
  }
};
var PhoneFormatter_1 = PhoneFormatter;
var CreditCardDetector = {
  blocks: {
    uatp: [4, 5, 6],
    amex: [4, 6, 5],
    diners: [4, 6, 4],
    discover: [4, 4, 4, 4],
    mastercard: [4, 4, 4, 4],
    dankort: [4, 4, 4, 4],
    instapayment: [4, 4, 4, 4],
    jcb15: [4, 6, 5],
    jcb: [4, 4, 4, 4],
    maestro: [4, 4, 4, 4],
    visa: [4, 4, 4, 4],
    mir: [4, 4, 4, 4],
    unionPay: [4, 4, 4, 4],
    general: [4, 4, 4, 4]
  },
  re: {
    uatp: /^(?!1800)1\d{0,14}/,
    amex: /^3[47]\d{0,13}/,
    discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,
    diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,
    mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,
    dankort: /^(5019|4175|4571)\d{0,12}/,
    instapayment: /^63[7-9]\d{0,13}/,
    jcb15: /^(?:2131|1800)\d{0,11}/,
    jcb: /^(?:35\d{0,2})\d{0,12}/,
    maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,
    mir: /^220[0-4]\d{0,12}/,
    visa: /^4\d{0,15}/,
    unionPay: /^(62|81)\d{0,14}/
  },
  getStrictBlocks: function(block) {
    var total = block.reduce(function(prev, current) {
      return prev + current;
    }, 0);
    return block.concat(19 - total);
  },
  getInfo: function(value, strictMode) {
    var blocks = CreditCardDetector.blocks, re = CreditCardDetector.re;
    strictMode = !!strictMode;
    for (var key in re) {
      if (re[key].test(value)) {
        var matchedBlocks = blocks[key];
        return {
          type: key,
          blocks: strictMode ? this.getStrictBlocks(matchedBlocks) : matchedBlocks
        };
      }
    }
    return {
      type: "unknown",
      blocks: strictMode ? this.getStrictBlocks(blocks.general) : blocks.general
    };
  }
};
var CreditCardDetector_1 = CreditCardDetector;
var Util = {
  noop: function() {
  },
  strip: function(value, re) {
    return value.replace(re, "");
  },
  getPostDelimiter: function(value, delimiter, delimiters) {
    if (delimiters.length === 0) {
      return value.slice(-delimiter.length) === delimiter ? delimiter : "";
    }
    var matchedDelimiter = "";
    delimiters.forEach(function(current) {
      if (value.slice(-current.length) === current) {
        matchedDelimiter = current;
      }
    });
    return matchedDelimiter;
  },
  getDelimiterREByDelimiter: function(delimiter) {
    return new RegExp(delimiter.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"), "g");
  },
  getNextCursorPosition: function(prevPos, oldValue, newValue, delimiter, delimiters) {
    if (oldValue.length === prevPos) {
      return newValue.length;
    }
    return prevPos + this.getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters);
  },
  getPositionOffset: function(prevPos, oldValue, newValue, delimiter, delimiters) {
    var oldRawValue, newRawValue, lengthOffset;
    oldRawValue = this.stripDelimiters(oldValue.slice(0, prevPos), delimiter, delimiters);
    newRawValue = this.stripDelimiters(newValue.slice(0, prevPos), delimiter, delimiters);
    lengthOffset = oldRawValue.length - newRawValue.length;
    return lengthOffset !== 0 ? lengthOffset / Math.abs(lengthOffset) : 0;
  },
  stripDelimiters: function(value, delimiter, delimiters) {
    var owner = this;
    if (delimiters.length === 0) {
      var delimiterRE = delimiter ? owner.getDelimiterREByDelimiter(delimiter) : "";
      return value.replace(delimiterRE, "");
    }
    delimiters.forEach(function(current) {
      current.split("").forEach(function(letter) {
        value = value.replace(owner.getDelimiterREByDelimiter(letter), "");
      });
    });
    return value;
  },
  headStr: function(str, length) {
    return str.slice(0, length);
  },
  getMaxLength: function(blocks) {
    return blocks.reduce(function(previous, current) {
      return previous + current;
    }, 0);
  },
  getPrefixStrippedValue: function(value, prefix, prefixLength, prevResult, delimiter, delimiters, noImmediatePrefix, tailPrefix, signBeforePrefix) {
    if (prefixLength === 0) {
      return value;
    }
    if (value === prefix && value !== "") {
      return "";
    }
    if (signBeforePrefix && value.slice(0, 1) == "-") {
      var prev = prevResult.slice(0, 1) == "-" ? prevResult.slice(1) : prevResult;
      return "-" + this.getPrefixStrippedValue(value.slice(1), prefix, prefixLength, prev, delimiter, delimiters, noImmediatePrefix, tailPrefix, signBeforePrefix);
    }
    if (prevResult.slice(0, prefixLength) !== prefix && !tailPrefix) {
      if (noImmediatePrefix && !prevResult && value)
        return value;
      return "";
    } else if (prevResult.slice(-prefixLength) !== prefix && tailPrefix) {
      if (noImmediatePrefix && !prevResult && value)
        return value;
      return "";
    }
    var prevValue = this.stripDelimiters(prevResult, delimiter, delimiters);
    if (value.slice(0, prefixLength) !== prefix && !tailPrefix) {
      return prevValue.slice(prefixLength);
    } else if (value.slice(-prefixLength) !== prefix && tailPrefix) {
      return prevValue.slice(0, -prefixLength - 1);
    }
    return tailPrefix ? value.slice(0, -prefixLength) : value.slice(prefixLength);
  },
  getFirstDiffIndex: function(prev, current) {
    var index = 0;
    while (prev.charAt(index) === current.charAt(index)) {
      if (prev.charAt(index++) === "") {
        return -1;
      }
    }
    return index;
  },
  getFormattedValue: function(value, blocks, blocksLength, delimiter, delimiters, delimiterLazyShow) {
    var result = "", multipleDelimiters = delimiters.length > 0, currentDelimiter = "";
    if (blocksLength === 0) {
      return value;
    }
    blocks.forEach(function(length, index) {
      if (value.length > 0) {
        var sub = value.slice(0, length), rest = value.slice(length);
        if (multipleDelimiters) {
          currentDelimiter = delimiters[delimiterLazyShow ? index - 1 : index] || currentDelimiter;
        } else {
          currentDelimiter = delimiter;
        }
        if (delimiterLazyShow) {
          if (index > 0) {
            result += currentDelimiter;
          }
          result += sub;
        } else {
          result += sub;
          if (sub.length === length && index < blocksLength - 1) {
            result += currentDelimiter;
          }
        }
        value = rest;
      }
    });
    return result;
  },
  fixPrefixCursor: function(el, prefix, delimiter, delimiters) {
    if (!el) {
      return;
    }
    var val = el.value, appendix = delimiter || (delimiters[0] || " ");
    if (!el.setSelectionRange || !prefix || prefix.length + appendix.length <= val.length) {
      return;
    }
    var len = val.length * 2;
    setTimeout(function() {
      el.setSelectionRange(len, len);
    }, 1);
  },
  checkFullSelection: function(value) {
    try {
      var selection = window.getSelection() || document.getSelection() || {};
      return selection.toString().length === value.length;
    } catch (ex) {
    }
    return false;
  },
  setSelection: function(element, position, doc) {
    if (element !== this.getActiveElement(doc)) {
      return;
    }
    if (element && element.value.length <= position) {
      return;
    }
    if (element.createTextRange) {
      var range = element.createTextRange();
      range.move("character", position);
      range.select();
    } else {
      try {
        element.setSelectionRange(position, position);
      } catch (e) {
        console.warn("The input element type does not support selection");
      }
    }
  },
  getActiveElement: function(parent) {
    var activeElement = parent.activeElement;
    if (activeElement && activeElement.shadowRoot) {
      return this.getActiveElement(activeElement.shadowRoot);
    }
    return activeElement;
  },
  isAndroid: function() {
    return navigator && /android/i.test(navigator.userAgent);
  },
  isAndroidBackspaceKeydown: function(lastInputValue, currentInputValue) {
    if (!this.isAndroid() || !lastInputValue || !currentInputValue) {
      return false;
    }
    return currentInputValue === lastInputValue.slice(0, -1);
  }
};
var Util_1 = Util;
var DefaultProperties = {
  assign: function(target, opts) {
    target = target || {};
    opts = opts || {};
    target.creditCard = !!opts.creditCard;
    target.creditCardStrictMode = !!opts.creditCardStrictMode;
    target.creditCardType = "";
    target.onCreditCardTypeChanged = opts.onCreditCardTypeChanged || function() {
    };
    target.phone = !!opts.phone;
    target.phoneRegionCode = opts.phoneRegionCode || "AU";
    target.phoneFormatter = {};
    target.time = !!opts.time;
    target.timePattern = opts.timePattern || ["h", "m", "s"];
    target.timeFormat = opts.timeFormat || "24";
    target.timeFormatter = {};
    target.date = !!opts.date;
    target.datePattern = opts.datePattern || ["d", "m", "Y"];
    target.dateMin = opts.dateMin || "";
    target.dateMax = opts.dateMax || "";
    target.dateFormatter = {};
    target.numeral = !!opts.numeral;
    target.numeralIntegerScale = opts.numeralIntegerScale > 0 ? opts.numeralIntegerScale : 0;
    target.numeralDecimalScale = opts.numeralDecimalScale >= 0 ? opts.numeralDecimalScale : 2;
    target.numeralDecimalMark = opts.numeralDecimalMark || ".";
    target.numeralThousandsGroupStyle = opts.numeralThousandsGroupStyle || "thousand";
    target.numeralPositiveOnly = !!opts.numeralPositiveOnly;
    target.stripLeadingZeroes = opts.stripLeadingZeroes !== false;
    target.signBeforePrefix = !!opts.signBeforePrefix;
    target.tailPrefix = !!opts.tailPrefix;
    target.swapHiddenInput = !!opts.swapHiddenInput;
    target.numericOnly = target.creditCard || target.date || !!opts.numericOnly;
    target.uppercase = !!opts.uppercase;
    target.lowercase = !!opts.lowercase;
    target.prefix = target.creditCard || target.date ? "" : opts.prefix || "";
    target.noImmediatePrefix = !!opts.noImmediatePrefix;
    target.prefixLength = target.prefix.length;
    target.rawValueTrimPrefix = !!opts.rawValueTrimPrefix;
    target.copyDelimiter = !!opts.copyDelimiter;
    target.initValue = opts.initValue !== void 0 && opts.initValue !== null ? opts.initValue.toString() : "";
    target.delimiter = opts.delimiter || opts.delimiter === "" ? opts.delimiter : opts.date ? "/" : opts.time ? ":" : opts.numeral ? "," : opts.phone ? " " : " ";
    target.delimiterLength = target.delimiter.length;
    target.delimiterLazyShow = !!opts.delimiterLazyShow;
    target.delimiters = opts.delimiters || [];
    target.blocks = opts.blocks || [];
    target.blocksLength = target.blocks.length;
    target.root = typeof commonjsGlobal === "object" && commonjsGlobal ? commonjsGlobal : window;
    target.document = opts.document || target.root.document;
    target.maxLength = 0;
    target.backspace = false;
    target.result = "";
    target.onValueChanged = opts.onValueChanged || function() {
    };
    return target;
  }
};
var DefaultProperties_1 = DefaultProperties;
var Cleave = function(element, opts) {
  var owner = this;
  var hasMultipleElements = false;
  if (typeof element === "string") {
    owner.element = document.querySelector(element);
    hasMultipleElements = document.querySelectorAll(element).length > 1;
  } else {
    if (typeof element.length !== "undefined" && element.length > 0) {
      owner.element = element[0];
      hasMultipleElements = element.length > 1;
    } else {
      owner.element = element;
    }
  }
  if (!owner.element) {
    throw new Error("[cleave.js] Please check the element");
  }
  if (hasMultipleElements) {
    try {
      console.warn("[cleave.js] Multiple input fields matched, cleave.js will only take the first one.");
    } catch (e) {
    }
  }
  opts.initValue = owner.element.value;
  owner.properties = Cleave.DefaultProperties.assign({}, opts);
  owner.init();
};
Cleave.prototype = {
  init: function() {
    var owner = this, pps = owner.properties;
    if (!pps.numeral && !pps.phone && !pps.creditCard && !pps.time && !pps.date && (pps.blocksLength === 0 && !pps.prefix)) {
      owner.onInput(pps.initValue);
      return;
    }
    pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
    owner.isAndroid = Cleave.Util.isAndroid();
    owner.lastInputValue = "";
    owner.isBackward = "";
    owner.onChangeListener = owner.onChange.bind(owner);
    owner.onKeyDownListener = owner.onKeyDown.bind(owner);
    owner.onFocusListener = owner.onFocus.bind(owner);
    owner.onCutListener = owner.onCut.bind(owner);
    owner.onCopyListener = owner.onCopy.bind(owner);
    owner.initSwapHiddenInput();
    owner.element.addEventListener("input", owner.onChangeListener);
    owner.element.addEventListener("keydown", owner.onKeyDownListener);
    owner.element.addEventListener("focus", owner.onFocusListener);
    owner.element.addEventListener("cut", owner.onCutListener);
    owner.element.addEventListener("copy", owner.onCopyListener);
    owner.initPhoneFormatter();
    owner.initDateFormatter();
    owner.initTimeFormatter();
    owner.initNumeralFormatter();
    if (pps.initValue || pps.prefix && !pps.noImmediatePrefix) {
      owner.onInput(pps.initValue);
    }
  },
  initSwapHiddenInput: function() {
    var owner = this, pps = owner.properties;
    if (!pps.swapHiddenInput)
      return;
    var inputFormatter = owner.element.cloneNode(true);
    owner.element.parentNode.insertBefore(inputFormatter, owner.element);
    owner.elementSwapHidden = owner.element;
    owner.elementSwapHidden.type = "hidden";
    owner.element = inputFormatter;
    owner.element.id = "";
  },
  initNumeralFormatter: function() {
    var owner = this, pps = owner.properties;
    if (!pps.numeral) {
      return;
    }
    pps.numeralFormatter = new Cleave.NumeralFormatter(
      pps.numeralDecimalMark,
      pps.numeralIntegerScale,
      pps.numeralDecimalScale,
      pps.numeralThousandsGroupStyle,
      pps.numeralPositiveOnly,
      pps.stripLeadingZeroes,
      pps.prefix,
      pps.signBeforePrefix,
      pps.tailPrefix,
      pps.delimiter
    );
  },
  initTimeFormatter: function() {
    var owner = this, pps = owner.properties;
    if (!pps.time) {
      return;
    }
    pps.timeFormatter = new Cleave.TimeFormatter(pps.timePattern, pps.timeFormat);
    pps.blocks = pps.timeFormatter.getBlocks();
    pps.blocksLength = pps.blocks.length;
    pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
  },
  initDateFormatter: function() {
    var owner = this, pps = owner.properties;
    if (!pps.date) {
      return;
    }
    pps.dateFormatter = new Cleave.DateFormatter(pps.datePattern, pps.dateMin, pps.dateMax);
    pps.blocks = pps.dateFormatter.getBlocks();
    pps.blocksLength = pps.blocks.length;
    pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
  },
  initPhoneFormatter: function() {
    var owner = this, pps = owner.properties;
    if (!pps.phone) {
      return;
    }
    try {
      pps.phoneFormatter = new Cleave.PhoneFormatter(
        new pps.root.Cleave.AsYouTypeFormatter(pps.phoneRegionCode),
        pps.delimiter
      );
    } catch (ex) {
      throw new Error("[cleave.js] Please include phone-type-formatter.{country}.js lib");
    }
  },
  onKeyDown: function(event) {
    var owner = this, charCode = event.which || event.keyCode;
    owner.lastInputValue = owner.element.value;
    owner.isBackward = charCode === 8;
  },
  onChange: function(event) {
    var owner = this, pps = owner.properties, Util2 = Cleave.Util;
    owner.isBackward = owner.isBackward || event.inputType === "deleteContentBackward";
    var postDelimiter = Util2.getPostDelimiter(owner.lastInputValue, pps.delimiter, pps.delimiters);
    if (owner.isBackward && postDelimiter) {
      pps.postDelimiterBackspace = postDelimiter;
    } else {
      pps.postDelimiterBackspace = false;
    }
    this.onInput(this.element.value);
  },
  onFocus: function() {
    var owner = this, pps = owner.properties;
    owner.lastInputValue = owner.element.value;
    if (pps.prefix && pps.noImmediatePrefix && !owner.element.value) {
      this.onInput(pps.prefix);
    }
    Cleave.Util.fixPrefixCursor(owner.element, pps.prefix, pps.delimiter, pps.delimiters);
  },
  onCut: function(e) {
    if (!Cleave.Util.checkFullSelection(this.element.value))
      return;
    this.copyClipboardData(e);
    this.onInput("");
  },
  onCopy: function(e) {
    if (!Cleave.Util.checkFullSelection(this.element.value))
      return;
    this.copyClipboardData(e);
  },
  copyClipboardData: function(e) {
    var owner = this, pps = owner.properties, Util2 = Cleave.Util, inputValue = owner.element.value, textToCopy = "";
    if (!pps.copyDelimiter) {
      textToCopy = Util2.stripDelimiters(inputValue, pps.delimiter, pps.delimiters);
    } else {
      textToCopy = inputValue;
    }
    try {
      if (e.clipboardData) {
        e.clipboardData.setData("Text", textToCopy);
      } else {
        window.clipboardData.setData("Text", textToCopy);
      }
      e.preventDefault();
    } catch (ex) {
    }
  },
  onInput: function(value) {
    var owner = this, pps = owner.properties, Util2 = Cleave.Util;
    var postDelimiterAfter = Util2.getPostDelimiter(value, pps.delimiter, pps.delimiters);
    if (!pps.numeral && pps.postDelimiterBackspace && !postDelimiterAfter) {
      value = Util2.headStr(value, value.length - pps.postDelimiterBackspace.length);
    }
    if (pps.phone) {
      if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
        pps.result = pps.prefix + pps.phoneFormatter.format(value).slice(pps.prefix.length);
      } else {
        pps.result = pps.phoneFormatter.format(value);
      }
      owner.updateValueState();
      return;
    }
    if (pps.numeral) {
      if (pps.prefix && pps.noImmediatePrefix && value.length === 0) {
        pps.result = "";
      } else {
        pps.result = pps.numeralFormatter.format(value);
      }
      owner.updateValueState();
      return;
    }
    if (pps.date) {
      value = pps.dateFormatter.getValidatedDate(value);
    }
    if (pps.time) {
      value = pps.timeFormatter.getValidatedTime(value);
    }
    value = Util2.stripDelimiters(value, pps.delimiter, pps.delimiters);
    value = Util2.getPrefixStrippedValue(value, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);
    value = pps.numericOnly ? Util2.strip(value, /[^\d]/g) : value;
    value = pps.uppercase ? value.toUpperCase() : value;
    value = pps.lowercase ? value.toLowerCase() : value;
    if (pps.prefix) {
      if (pps.tailPrefix) {
        value = value + pps.prefix;
      } else {
        value = pps.prefix + value;
      }
      if (pps.blocksLength === 0) {
        pps.result = value;
        owner.updateValueState();
        return;
      }
    }
    if (pps.creditCard) {
      owner.updateCreditCardPropsByValue(value);
    }
    value = Util2.headStr(value, pps.maxLength);
    pps.result = Util2.getFormattedValue(
      value,
      pps.blocks,
      pps.blocksLength,
      pps.delimiter,
      pps.delimiters,
      pps.delimiterLazyShow
    );
    owner.updateValueState();
  },
  updateCreditCardPropsByValue: function(value) {
    var owner = this, pps = owner.properties, Util2 = Cleave.Util, creditCardInfo;
    if (Util2.headStr(pps.result, 4) === Util2.headStr(value, 4)) {
      return;
    }
    creditCardInfo = Cleave.CreditCardDetector.getInfo(value, pps.creditCardStrictMode);
    pps.blocks = creditCardInfo.blocks;
    pps.blocksLength = pps.blocks.length;
    pps.maxLength = Util2.getMaxLength(pps.blocks);
    if (pps.creditCardType !== creditCardInfo.type) {
      pps.creditCardType = creditCardInfo.type;
      pps.onCreditCardTypeChanged.call(owner, pps.creditCardType);
    }
  },
  updateValueState: function() {
    var owner = this, Util2 = Cleave.Util, pps = owner.properties;
    if (!owner.element) {
      return;
    }
    var endPos = owner.element.selectionEnd;
    var oldValue = owner.element.value;
    var newValue = pps.result;
    endPos = Util2.getNextCursorPosition(endPos, oldValue, newValue, pps.delimiter, pps.delimiters);
    if (owner.isAndroid) {
      window.setTimeout(function() {
        owner.element.value = newValue;
        Util2.setSelection(owner.element, endPos, pps.document, false);
        owner.callOnValueChanged();
      }, 1);
      return;
    }
    owner.element.value = newValue;
    if (pps.swapHiddenInput)
      owner.elementSwapHidden.value = owner.getRawValue();
    Util2.setSelection(owner.element, endPos, pps.document, false);
    owner.callOnValueChanged();
  },
  callOnValueChanged: function() {
    var owner = this, pps = owner.properties;
    pps.onValueChanged.call(owner, {
      target: {
        name: owner.element.name,
        value: pps.result,
        rawValue: owner.getRawValue()
      }
    });
  },
  setPhoneRegionCode: function(phoneRegionCode) {
    var owner = this, pps = owner.properties;
    pps.phoneRegionCode = phoneRegionCode;
    owner.initPhoneFormatter();
    owner.onChange();
  },
  setRawValue: function(value) {
    var owner = this, pps = owner.properties;
    value = value !== void 0 && value !== null ? value.toString() : "";
    if (pps.numeral) {
      value = value.replace(".", pps.numeralDecimalMark);
    }
    pps.postDelimiterBackspace = false;
    owner.element.value = value;
    owner.onInput(value);
  },
  getRawValue: function() {
    var owner = this, pps = owner.properties, Util2 = Cleave.Util, rawValue = owner.element.value;
    if (pps.rawValueTrimPrefix) {
      rawValue = Util2.getPrefixStrippedValue(rawValue, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);
    }
    if (pps.numeral) {
      rawValue = pps.numeralFormatter.getRawValue(rawValue);
    } else {
      rawValue = Util2.stripDelimiters(rawValue, pps.delimiter, pps.delimiters);
    }
    return rawValue;
  },
  getISOFormatDate: function() {
    var owner = this, pps = owner.properties;
    return pps.date ? pps.dateFormatter.getISOFormatDate() : "";
  },
  getISOFormatTime: function() {
    var owner = this, pps = owner.properties;
    return pps.time ? pps.timeFormatter.getISOFormatTime() : "";
  },
  getFormattedValue: function() {
    return this.element.value;
  },
  destroy: function() {
    var owner = this;
    owner.element.removeEventListener("input", owner.onChangeListener);
    owner.element.removeEventListener("keydown", owner.onKeyDownListener);
    owner.element.removeEventListener("focus", owner.onFocusListener);
    owner.element.removeEventListener("cut", owner.onCutListener);
    owner.element.removeEventListener("copy", owner.onCopyListener);
  },
  toString: function() {
    return "[Cleave Object]";
  }
};
Cleave.NumeralFormatter = NumeralFormatter_1;
Cleave.DateFormatter = DateFormatter_1;
Cleave.TimeFormatter = TimeFormatter_1;
Cleave.PhoneFormatter = PhoneFormatter_1;
Cleave.CreditCardDetector = CreditCardDetector_1;
Cleave.Util = Util_1;
Cleave.DefaultProperties = DefaultProperties_1;
(typeof commonjsGlobal === "object" && commonjsGlobal ? commonjsGlobal : window)["Cleave"] = Cleave;
var Cleave_1 = Cleave;
!function() {
  function l(l2, n2) {
    var u2 = l2.split("."), t2 = Y;
    u2[0] in t2 || !t2.execScript || t2.execScript("var " + u2[0]);
    for (var e2; u2.length && (e2 = u2.shift()); )
      u2.length || void 0 === n2 ? t2 = t2[e2] ? t2[e2] : t2[e2] = {} : t2[e2] = n2;
  }
  function n(l2, n2) {
    function u2() {
    }
    u2.prototype = n2.prototype, l2.M = n2.prototype, l2.prototype = new u2(), l2.prototype.constructor = l2, l2.N = function(l3, u3, t2) {
      for (var e2 = Array(arguments.length - 2), r2 = 2; r2 < arguments.length; r2++)
        e2[r2 - 2] = arguments[r2];
      return n2.prototype[u3].apply(l3, e2);
    };
  }
  function u(l2, n2) {
    null != l2 && this.a.apply(this, arguments);
  }
  function t(l2) {
    l2.b = "";
  }
  function e(l2, n2) {
    l2.sort(n2 || r);
  }
  function r(l2, n2) {
    return l2 > n2 ? 1 : l2 < n2 ? -1 : 0;
  }
  function i(l2) {
    var n2, u2 = [], t2 = 0;
    for (n2 in l2)
      u2[t2++] = l2[n2];
    return u2;
  }
  function a(l2, n2) {
    this.b = l2, this.a = {};
    for (var u2 = 0; u2 < n2.length; u2++) {
      var t2 = n2[u2];
      this.a[t2.b] = t2;
    }
  }
  function d(l2) {
    return l2 = i(l2.a), e(l2, function(l3, n2) {
      return l3.b - n2.b;
    }), l2;
  }
  function o(l2, n2) {
    switch (this.b = l2, this.g = !!n2.v, this.a = n2.c, this.i = n2.type, this.h = false, this.a) {
      case O:
      case H:
      case q:
      case X:
      case k:
      case L:
      case J:
        this.h = true;
    }
    this.f = n2.defaultValue;
  }
  function s() {
    this.a = {}, this.f = this.j().a, this.b = this.g = null;
  }
  function f(l2, n2) {
    for (var u2 = d(l2.j()), t2 = 0; t2 < u2.length; t2++) {
      var e2 = u2[t2], r2 = e2.b;
      if (null != n2.a[r2]) {
        l2.b && delete l2.b[e2.b];
        var i2 = 11 == e2.a || 10 == e2.a;
        if (e2.g)
          for (var e2 = p(n2, r2) || [], a2 = 0; a2 < e2.length; a2++) {
            var o2 = l2, s2 = r2, c2 = i2 ? e2[a2].clone() : e2[a2];
            o2.a[s2] || (o2.a[s2] = []), o2.a[s2].push(c2), o2.b && delete o2.b[s2];
          }
        else
          e2 = p(n2, r2), i2 ? (i2 = p(l2, r2)) ? f(i2, e2) : m(l2, r2, e2.clone()) : m(l2, r2, e2);
      }
    }
  }
  function p(l2, n2) {
    var u2 = l2.a[n2];
    if (null == u2)
      return null;
    if (l2.g) {
      if (!(n2 in l2.b)) {
        var t2 = l2.g, e2 = l2.f[n2];
        if (null != u2)
          if (e2.g) {
            for (var r2 = [], i2 = 0; i2 < u2.length; i2++)
              r2[i2] = t2.b(e2, u2[i2]);
            u2 = r2;
          } else
            u2 = t2.b(e2, u2);
        return l2.b[n2] = u2;
      }
      return l2.b[n2];
    }
    return u2;
  }
  function c(l2, n2, u2) {
    var t2 = p(l2, n2);
    return l2.f[n2].g ? t2[u2 || 0] : t2;
  }
  function h2(l2, n2) {
    var u2;
    if (null != l2.a[n2])
      u2 = c(l2, n2, void 0);
    else
      l: {
        if (u2 = l2.f[n2], void 0 === u2.f) {
          var t2 = u2.i;
          if (t2 === Boolean)
            u2.f = false;
          else if (t2 === Number)
            u2.f = 0;
          else {
            if (t2 !== String) {
              u2 = new t2();
              break l;
            }
            u2.f = u2.h ? "0" : "";
          }
        }
        u2 = u2.f;
      }
    return u2;
  }
  function g(l2, n2) {
    return l2.f[n2].g ? null != l2.a[n2] ? l2.a[n2].length : 0 : null != l2.a[n2] ? 1 : 0;
  }
  function m(l2, n2, u2) {
    l2.a[n2] = u2, l2.b && (l2.b[n2] = u2);
  }
  function b(l2, n2) {
    var u2, t2 = [];
    for (u2 in n2)
      0 != u2 && t2.push(new o(u2, n2[u2]));
    return new a(l2, t2);
  }
  function y() {
    s.call(this);
  }
  function v() {
    s.call(this);
  }
  function S() {
    s.call(this);
  }
  function _() {
  }
  function w2() {
  }
  function A() {
  }
  function x() {
    this.a = {};
  }
  function B(l2) {
    return 0 == l2.length || rl.test(l2);
  }
  function C(l2, n2) {
    if (null == n2)
      return null;
    n2 = n2.toUpperCase();
    var u2 = l2.a[n2];
    if (null == u2) {
      if (u2 = nl[n2], null == u2)
        return null;
      u2 = new A().a(S.j(), u2), l2.a[n2] = u2;
    }
    return u2;
  }
  function M(l2) {
    return l2 = ll[l2], null == l2 ? "ZZ" : l2[0];
  }
  function N(l2) {
    this.H = RegExp("\u2008"), this.C = "", this.m = new u(), this.w = "", this.i = new u(), this.u = new u(), this.l = true, this.A = this.o = this.F = false, this.G = x.b(), this.s = 0, this.b = new u(), this.B = false, this.h = "", this.a = new u(), this.f = [], this.D = l2, this.J = this.g = D(this, this.D);
  }
  function D(l2, n2) {
    var u2;
    if (null != n2 && isNaN(n2) && n2.toUpperCase() in nl) {
      if (u2 = C(l2.G, n2), null == u2)
        throw Error("Invalid region code: " + n2);
      u2 = h2(u2, 10);
    } else
      u2 = 0;
    return u2 = C(l2.G, M(u2)), null != u2 ? u2 : il;
  }
  function G(l2) {
    for (var n2 = l2.f.length, u2 = 0; u2 < n2; ++u2) {
      var e2 = l2.f[u2], r2 = h2(e2, 1);
      if (l2.w == r2)
        return false;
      var i2;
      i2 = l2;
      var a2 = e2, d2 = h2(a2, 1);
      if (-1 != d2.indexOf("|"))
        i2 = false;
      else {
        d2 = d2.replace(al, "\\d"), d2 = d2.replace(dl, "\\d"), t(i2.m);
        var o2;
        o2 = i2;
        var a2 = h2(a2, 2), s2 = "999999999999999".match(d2)[0];
        s2.length < o2.a.b.length ? o2 = "" : (o2 = s2.replace(new RegExp(d2, "g"), a2), o2 = o2.replace(RegExp("9", "g"), "\u2008")), 0 < o2.length ? (i2.m.a(o2), i2 = true) : i2 = false;
      }
      if (i2)
        return l2.w = r2, l2.B = sl.test(c(e2, 4)), l2.s = 0, true;
    }
    return l2.l = false;
  }
  function j(l2, n2) {
    for (var u2 = [], t2 = n2.length - 3, e2 = l2.f.length, r2 = 0; r2 < e2; ++r2) {
      var i2 = l2.f[r2];
      0 == g(i2, 3) ? u2.push(l2.f[r2]) : (i2 = c(i2, 3, Math.min(t2, g(i2, 3) - 1)), 0 == n2.search(i2) && u2.push(l2.f[r2]));
    }
    l2.f = u2;
  }
  function I(l2, n2) {
    l2.i.a(n2);
    var u2 = n2;
    if (el.test(u2) || 1 == l2.i.b.length && tl.test(u2)) {
      var e2, u2 = n2;
      "+" == u2 ? (e2 = u2, l2.u.a(u2)) : (e2 = ul[u2], l2.u.a(e2), l2.a.a(e2)), n2 = e2;
    } else
      l2.l = false, l2.F = true;
    if (!l2.l) {
      if (!l2.F) {
        if (F(l2)) {
          if (U(l2))
            return V(l2);
        } else if (0 < l2.h.length && (u2 = l2.a.toString(), t(l2.a), l2.a.a(l2.h), l2.a.a(u2), u2 = l2.b.toString(), e2 = u2.lastIndexOf(l2.h), t(l2.b), l2.b.a(u2.substring(0, e2))), l2.h != P2(l2))
          return l2.b.a(" "), V(l2);
      }
      return l2.i.toString();
    }
    switch (l2.u.b.length) {
      case 0:
      case 1:
      case 2:
        return l2.i.toString();
      case 3:
        if (!F(l2))
          return l2.h = P2(l2), E(l2);
        l2.A = true;
      default:
        return l2.A ? (U(l2) && (l2.A = false), l2.b.toString() + l2.a.toString()) : 0 < l2.f.length ? (u2 = K(l2, n2), e2 = $(l2), 0 < e2.length ? e2 : (j(l2, l2.a.toString()), G(l2) ? T(l2) : l2.l ? R(l2, u2) : l2.i.toString())) : E(l2);
    }
  }
  function V(l2) {
    return l2.l = true, l2.A = false, l2.f = [], l2.s = 0, t(l2.m), l2.w = "", E(l2);
  }
  function $(l2) {
    for (var n2 = l2.a.toString(), u2 = l2.f.length, t2 = 0; t2 < u2; ++t2) {
      var e2 = l2.f[t2], r2 = h2(e2, 1);
      if (new RegExp("^(?:" + r2 + ")$").test(n2))
        return l2.B = sl.test(c(e2, 4)), n2 = n2.replace(new RegExp(r2, "g"), c(e2, 2)), R(l2, n2);
    }
    return "";
  }
  function R(l2, n2) {
    var u2 = l2.b.b.length;
    return l2.B && 0 < u2 && " " != l2.b.toString().charAt(u2 - 1) ? l2.b + " " + n2 : l2.b + n2;
  }
  function E(l2) {
    var n2 = l2.a.toString();
    if (3 <= n2.length) {
      for (var u2 = l2.o && 0 == l2.h.length && 0 < g(l2.g, 20) ? p(l2.g, 20) || [] : p(l2.g, 19) || [], t2 = u2.length, e2 = 0; e2 < t2; ++e2) {
        var r2 = u2[e2];
        0 < l2.h.length && B(h2(r2, 4)) && !c(r2, 6) && null == r2.a[5] || (0 != l2.h.length || l2.o || B(h2(r2, 4)) || c(r2, 6)) && ol.test(h2(r2, 2)) && l2.f.push(r2);
      }
      return j(l2, n2), n2 = $(l2), 0 < n2.length ? n2 : G(l2) ? T(l2) : l2.i.toString();
    }
    return R(l2, n2);
  }
  function T(l2) {
    var n2 = l2.a.toString(), u2 = n2.length;
    if (0 < u2) {
      for (var t2 = "", e2 = 0; e2 < u2; e2++)
        t2 = K(l2, n2.charAt(e2));
      return l2.l ? R(l2, t2) : l2.i.toString();
    }
    return l2.b.toString();
  }
  function P2(l2) {
    var n2, u2 = l2.a.toString(), e2 = 0;
    return 1 != c(l2.g, 10) ? n2 = false : (n2 = l2.a.toString(), n2 = "1" == n2.charAt(0) && "0" != n2.charAt(1) && "1" != n2.charAt(1)), n2 ? (e2 = 1, l2.b.a("1").a(" "), l2.o = true) : null != l2.g.a[15] && (n2 = new RegExp("^(?:" + c(l2.g, 15) + ")"), n2 = u2.match(n2), null != n2 && null != n2[0] && 0 < n2[0].length && (l2.o = true, e2 = n2[0].length, l2.b.a(u2.substring(0, e2)))), t(l2.a), l2.a.a(u2.substring(e2)), u2.substring(0, e2);
  }
  function F(l2) {
    var n2 = l2.u.toString(), u2 = new RegExp("^(?:\\+|" + c(l2.g, 11) + ")"), u2 = n2.match(u2);
    return null != u2 && null != u2[0] && 0 < u2[0].length && (l2.o = true, u2 = u2[0].length, t(l2.a), l2.a.a(n2.substring(u2)), t(l2.b), l2.b.a(n2.substring(0, u2)), "+" != n2.charAt(0) && l2.b.a(" "), true);
  }
  function U(l2) {
    if (0 == l2.a.b.length)
      return false;
    var n2, e2 = new u();
    l: {
      if (n2 = l2.a.toString(), 0 != n2.length && "0" != n2.charAt(0)) {
        for (var r2, i2 = n2.length, a2 = 1; 3 >= a2 && a2 <= i2; ++a2)
          if (r2 = parseInt(n2.substring(0, a2), 10), r2 in ll) {
            e2.a(n2.substring(a2)), n2 = r2;
            break l;
          }
      }
      n2 = 0;
    }
    return 0 != n2 && (t(l2.a), l2.a.a(e2.toString()), e2 = M(n2), "001" == e2 ? l2.g = C(l2.G, "" + n2) : e2 != l2.D && (l2.g = D(l2, e2)), l2.b.a("" + n2).a(" "), l2.h = "", true);
  }
  function K(l2, n2) {
    var u2 = l2.m.toString();
    if (0 <= u2.substring(l2.s).search(l2.H)) {
      var e2 = u2.search(l2.H), u2 = u2.replace(l2.H, n2);
      return t(l2.m), l2.m.a(u2), l2.s = e2, u2.substring(0, l2.s + 1);
    }
    return 1 == l2.f.length && (l2.l = false), l2.w = "", l2.i.toString();
  }
  var Y = this;
  u.prototype.b = "", u.prototype.set = function(l2) {
    this.b = "" + l2;
  }, u.prototype.a = function(l2, n2, u2) {
    if (this.b += String(l2), null != n2)
      for (var t2 = 1; t2 < arguments.length; t2++)
        this.b += arguments[t2];
    return this;
  }, u.prototype.toString = function() {
    return this.b;
  };
  var J = 1, L = 2, O = 3, H = 4, q = 6, X = 16, k = 18;
  s.prototype.set = function(l2, n2) {
    m(this, l2.b, n2);
  }, s.prototype.clone = function() {
    var l2 = new this.constructor();
    return l2 != this && (l2.a = {}, l2.b && (l2.b = {}), f(l2, this)), l2;
  }, n(y, s);
  var Z = null;
  n(v, s);
  var z = null;
  n(S, s);
  var Q = null;
  y.prototype.j = function() {
    var l2 = Z;
    return l2 || (Z = l2 = b(y, { 0: { name: "NumberFormat", I: "i18n.phonenumbers.NumberFormat" }, 1: { name: "pattern", required: true, c: 9, type: String }, 2: { name: "format", required: true, c: 9, type: String }, 3: { name: "leading_digits_pattern", v: true, c: 9, type: String }, 4: { name: "national_prefix_formatting_rule", c: 9, type: String }, 6: { name: "national_prefix_optional_when_formatting", c: 8, defaultValue: false, type: Boolean }, 5: { name: "domestic_carrier_code_formatting_rule", c: 9, type: String } })), l2;
  }, y.j = y.prototype.j, v.prototype.j = function() {
    var l2 = z;
    return l2 || (z = l2 = b(v, { 0: { name: "PhoneNumberDesc", I: "i18n.phonenumbers.PhoneNumberDesc" }, 2: { name: "national_number_pattern", c: 9, type: String }, 9: { name: "possible_length", v: true, c: 5, type: Number }, 10: { name: "possible_length_local_only", v: true, c: 5, type: Number }, 6: { name: "example_number", c: 9, type: String } })), l2;
  }, v.j = v.prototype.j, S.prototype.j = function() {
    var l2 = Q;
    return l2 || (Q = l2 = b(S, { 0: { name: "PhoneMetadata", I: "i18n.phonenumbers.PhoneMetadata" }, 1: { name: "general_desc", c: 11, type: v }, 2: { name: "fixed_line", c: 11, type: v }, 3: { name: "mobile", c: 11, type: v }, 4: { name: "toll_free", c: 11, type: v }, 5: { name: "premium_rate", c: 11, type: v }, 6: { name: "shared_cost", c: 11, type: v }, 7: { name: "personal_number", c: 11, type: v }, 8: { name: "voip", c: 11, type: v }, 21: { name: "pager", c: 11, type: v }, 25: { name: "uan", c: 11, type: v }, 27: { name: "emergency", c: 11, type: v }, 28: { name: "voicemail", c: 11, type: v }, 29: { name: "short_code", c: 11, type: v }, 30: { name: "standard_rate", c: 11, type: v }, 31: { name: "carrier_specific", c: 11, type: v }, 33: { name: "sms_services", c: 11, type: v }, 24: { name: "no_international_dialling", c: 11, type: v }, 9: { name: "id", required: true, c: 9, type: String }, 10: { name: "country_code", c: 5, type: Number }, 11: { name: "international_prefix", c: 9, type: String }, 17: { name: "preferred_international_prefix", c: 9, type: String }, 12: { name: "national_prefix", c: 9, type: String }, 13: { name: "preferred_extn_prefix", c: 9, type: String }, 15: { name: "national_prefix_for_parsing", c: 9, type: String }, 16: { name: "national_prefix_transform_rule", c: 9, type: String }, 18: { name: "same_mobile_and_fixed_line_pattern", c: 8, defaultValue: false, type: Boolean }, 19: { name: "number_format", v: true, c: 11, type: y }, 20: { name: "intl_number_format", v: true, c: 11, type: y }, 22: { name: "main_country_for_code", c: 8, defaultValue: false, type: Boolean }, 23: { name: "leading_digits", c: 9, type: String }, 26: { name: "leading_zero_possible", c: 8, defaultValue: false, type: Boolean } })), l2;
  }, S.j = S.prototype.j, _.prototype.a = function(l2) {
    throw new l2.b(), Error("Unimplemented");
  }, _.prototype.b = function(l2, n2) {
    if (11 == l2.a || 10 == l2.a)
      return n2 instanceof s ? n2 : this.a(l2.i.prototype.j(), n2);
    if (14 == l2.a) {
      if ("string" == typeof n2 && W.test(n2)) {
        var u2 = Number(n2);
        if (0 < u2)
          return u2;
      }
      return n2;
    }
    if (!l2.h)
      return n2;
    if (u2 = l2.i, u2 === String) {
      if ("number" == typeof n2)
        return String(n2);
    } else if (u2 === Number && "string" == typeof n2 && ("Infinity" === n2 || "-Infinity" === n2 || "NaN" === n2 || W.test(n2)))
      return Number(n2);
    return n2;
  };
  var W = /^-?[0-9]+$/;
  n(w2, _), w2.prototype.a = function(l2, n2) {
    var u2 = new l2.b();
    return u2.g = this, u2.a = n2, u2.b = {}, u2;
  }, n(A, w2), A.prototype.b = function(l2, n2) {
    return 8 == l2.a ? !!n2 : _.prototype.b.apply(this, arguments);
  }, A.prototype.a = function(l2, n2) {
    return A.M.a.call(this, l2, n2);
  };
  var ll = { 1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" ") }, nl = { AG: [null, [null, null, "(?:268|[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}", null, null, null, "2684601234", null, null, null, [7]], [null, null, "268(?:464|7(?:1[3-9]|2\\d|3[246]|64|[78][0-689]))\\d{4}", null, null, null, "2684641234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, "26848[01]\\d{4}", null, null, null, "2684801234", null, null, null, [7]], "AG", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, "26840[69]\\d{4}", null, null, null, "2684061234", null, null, null, [7]], null, "268", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], AI: [null, [null, null, "(?:264|[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "2644(?:6[12]|9[78])\\d{4}", null, null, null, "2644612345", null, null, null, [7]], [null, null, "264(?:235|476|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}", null, null, null, "2642351234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "AI", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "264", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], AS: [null, [null, null, "(?:[58]\\d\\d|684|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "6846(?:22|33|44|55|77|88|9[19])\\d{4}", null, null, null, "6846221234", null, null, null, [7]], [null, null, "684(?:2(?:5[2468]|72)|7(?:3[13]|70))\\d{4}", null, null, null, "6847331234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "AS", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "684", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], BB: [null, [null, null, "(?:246|[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}", null, null, null, "2464123456", null, null, null, [7]], [null, null, "246(?:2(?:[356]\\d|4[0-57-9]|8[0-79])|45\\d|69[5-7]|8(?:[2-5]\\d|83))\\d{4}", null, null, null, "2462501234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "(?:246976|900[2-9]\\d\\d)\\d{4}", null, null, null, "9002123456", null, null, null, [7]], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, "24631\\d{5}", null, null, null, "2463101234", null, null, null, [7]], "BB", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "246", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "246(?:292|367|4(?:1[7-9]|3[01]|44|67)|7(?:36|53))\\d{4}", null, null, null, "2464301234", null, null, null, [7]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], BM: [null, [null, null, "(?:441|[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "441(?:2(?:02|23|[3479]\\d|61)|[46]\\d\\d|5(?:4\\d|60|89)|824)\\d{4}", null, null, null, "4412345678", null, null, null, [7]], [null, null, "441(?:[37]\\d|5[0-39])\\d{5}", null, null, null, "4413701234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "BM", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "441", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], BS: [null, [null, null, "(?:242|[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-4]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}", null, null, null, "2423456789", null, null, null, [7]], [null, null, "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}", null, null, null, "2423591234", null, null, null, [7]], [null, null, "(?:242300|8(?:00|33|44|55|66|77|88)[2-9]\\d\\d)\\d{4}", null, null, null, "8002123456", null, null, null, [7]], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "BS", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "242", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "242225[0-46-9]\\d{3}", null, null, null, "2422250123"], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], CA: [null, [null, null, "(?:[2-8]\\d|90)\\d{8}", null, null, null, null, null, null, [10], [7]], [null, null, "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", null, null, null, "5062345678", null, null, null, [7]], [null, null, "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", null, null, null, "5062345678", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, "600[2-9]\\d{6}", null, null, null, "6002012345"], "CA", 1, "011", "1", null, null, "1", null, null, 1, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], DM: [null, [null, null, "(?:[58]\\d\\d|767|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4]|70[1-3])\\d{4}", null, null, null, "7674201234", null, null, null, [7]], [null, null, "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-7])\\d{4}", null, null, null, "7672251234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "DM", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "767", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], DO: [null, [null, null, "(?:[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}", null, null, null, "8092345678", null, null, null, [7]], [null, null, "8[024]9[2-9]\\d{6}", null, null, null, "8092345678", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "DO", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "8[024]9", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], GD: [null, [null, null, "(?:473|[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}", null, null, null, "4732691234", null, null, null, [7]], [null, null, "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}", null, null, null, "4734031234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "GD", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "473", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], GU: [null, [null, null, "(?:[58]\\d\\d|671|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", null, null, null, "6713001234", null, null, null, [7]], [null, null, "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", null, null, null, "6713001234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "GU", 1, "011", "1", null, null, "1", null, null, 1, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "671", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], JM: [null, [null, null, "(?:[58]\\d\\d|658|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "(?:658[2-9]\\d\\d|876(?:5(?:0[12]|1[0-468]|2[35]|63)|6(?:0[1-3579]|1[0237-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}", null, null, null, "8765230123", null, null, null, [7]], [null, null, "876(?:(?:2[14-9]|[348]\\d)\\d|5(?:0[3-9]|[2-57-9]\\d|6[0-24-9])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579]))\\d{4}", null, null, null, "8762101234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "JM", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "658|876", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], KN: [null, [null, null, "(?:[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "869(?:2(?:29|36)|302|4(?:6[015-9]|70))\\d{4}", null, null, null, "8692361234", null, null, null, [7]], [null, null, "869(?:5(?:5[6-8]|6[5-7])|66\\d|76[02-7])\\d{4}", null, null, null, "8697652917", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "KN", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "869", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], KY: [null, [null, null, "(?:345|[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "345(?:2(?:22|44)|444|6(?:23|38|40)|7(?:4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}", null, null, null, "3452221234", null, null, null, [7]], [null, null, "345(?:32[1-9]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|9(?:1[67]|2[2-9]|3[689]))\\d{4}", null, null, null, "3453231234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002345678"], [null, null, "(?:345976|900[2-9]\\d\\d)\\d{4}", null, null, null, "9002345678"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "KY", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, "345849\\d{4}", null, null, null, "3458491234"], null, "345", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], LC: [null, [null, null, "(?:[58]\\d\\d|758|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "758(?:4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|638)\\d{4}", null, null, null, "7584305678", null, null, null, [7]], [null, null, "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[01]))\\d{4}", null, null, null, "7582845678", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "LC", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "758", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], MP: [null, [null, null, "(?:[58]\\d\\d|(?:67|90)0)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "670(?:2(?:3[3-7]|56|8[5-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", null, null, null, "6702345678", null, null, null, [7]], [null, null, "670(?:2(?:3[3-7]|56|8[5-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", null, null, null, "6702345678", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "MP", 1, "011", "1", null, null, "1", null, null, 1, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "670", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], MS: [null, [null, null, "(?:(?:[58]\\d\\d|900)\\d\\d|66449)\\d{5}", null, null, null, null, null, null, [10], [7]], [null, null, "664491\\d{4}", null, null, null, "6644912345", null, null, null, [7]], [null, null, "66449[2-6]\\d{4}", null, null, null, "6644923456", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "MS", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "664", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], PR: [null, [null, null, "(?:[589]\\d\\d|787)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "(?:787|939)[2-9]\\d{6}", null, null, null, "7872345678", null, null, null, [7]], [null, null, "(?:787|939)[2-9]\\d{6}", null, null, null, "7872345678", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002345678"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002345678"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "PR", 1, "011", "1", null, null, "1", null, null, 1, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "787|939", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], SX: [null, [null, null, "(?:(?:[58]\\d\\d|900)\\d|7215)\\d{6}", null, null, null, null, null, null, [10], [7]], [null, null, "7215(?:4[2-8]|8[239]|9[056])\\d{4}", null, null, null, "7215425678", null, null, null, [7]], [null, null, "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", null, null, null, "7215205678", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002123456"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002123456"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "SX", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "721", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], TC: [null, [null, null, "(?:[58]\\d\\d|649|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "649(?:712|9(?:4\\d|50))\\d{4}", null, null, null, "6497121234", null, null, null, [7]], [null, null, "649(?:2(?:3[129]|4[1-7])|3(?:3[1-389]|4[1-8])|4[34][1-3])\\d{4}", null, null, null, "6492311234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002345678"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002345678"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, "64971[01]\\d{4}", null, null, null, "6497101234", null, null, null, [7]], "TC", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "649", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], TT: [null, [null, null, "(?:[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "868(?:2(?:01|[23]\\d)|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}", null, null, null, "8682211234", null, null, null, [7]], [null, null, "868(?:2(?:6[6-9]|[7-9]\\d)|[37](?:0[1-9]|1[02-9]|[2-9]\\d)|4[6-9]\\d|6(?:20|78|8\\d))\\d{4}", null, null, null, "8682911234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002345678"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002345678"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "TT", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "868", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, "868619\\d{4}", null, null, null, "8686191234", null, null, null, [7]]], US: [null, [null, null, "[2-9]\\d{9}", null, null, null, null, null, null, [10], [7]], [null, null, "(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[017]|6[0-279]|78|8[0-2])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-28]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}", null, null, null, "2015550123", null, null, null, [7]], [null, null, "(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[017]|6[0-279]|78|8[0-2])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-28]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}", null, null, null, "2015550123", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002345678"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002345678"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "US", 1, "011", "1", null, null, "1", null, null, 1, [[null, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"]], [null, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], null, null, 1]], [[null, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-9]"]]], [null, null, null, null, null, null, null, null, null, [-1]], 1, null, [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "710[2-9]\\d{6}", null, null, null, "7102123456"], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], VC: [null, [null, null, "(?:[58]\\d\\d|784|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "784(?:266|3(?:6[6-9]|7\\d|8[0-24-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}", null, null, null, "7842661234", null, null, null, [7]], [null, null, "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4]))\\d{4}", null, null, null, "7844301234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002345678"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002345678"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "VC", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "784", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], VG: [null, [null, null, "(?:284|[58]\\d\\d|900)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "284(?:(?:229|774|8(?:52|6[459]))\\d|4(?:22\\d|9(?:[45]\\d|6[0-5])))\\d{3}", null, null, null, "2842291234", null, null, null, [7]], [null, null, "284(?:(?:3(?:0[0-3]|4[0-7]|68|9[34])|54[0-57])\\d|4(?:(?:4[0-6]|68)\\d|9(?:6[6-9]|9\\d)))\\d{3}", null, null, null, "2843001234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002345678"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002345678"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "VG", 1, "011", "1", null, null, "1", null, null, null, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "284", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]], VI: [null, [null, null, "(?:(?:34|90)0|[58]\\d\\d)\\d{7}", null, null, null, null, null, null, [10], [7]], [null, null, "340(?:2(?:01|2[06-8]|44|77)|3(?:32|44)|4(?:22|7[34])|5(?:1[34]|55)|6(?:26|4[23]|77|9[023])|7(?:1[2-57-9]|27|7\\d)|884|998)\\d{4}", null, null, null, "3406421234", null, null, null, [7]], [null, null, "340(?:2(?:01|2[06-8]|44|77)|3(?:32|44)|4(?:22|7[34])|5(?:1[34]|55)|6(?:26|4[23]|77|9[023])|7(?:1[2-57-9]|27|7\\d)|884|998)\\d{4}", null, null, null, "3406421234", null, null, null, [7]], [null, null, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", null, null, null, "8002345678"], [null, null, "900[2-9]\\d{6}", null, null, null, "9002345678"], [null, null, null, null, null, null, null, null, null, [-1]], [null, null, "5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}", null, null, null, "5002345678"], [null, null, null, null, null, null, null, null, null, [-1]], "VI", 1, "011", "1", null, null, "1", null, null, 1, null, null, [null, null, null, null, null, null, null, null, null, [-1]], null, "340", [null, null, null, null, null, null, null, null, null, [-1]], [null, null, null, null, null, null, null, null, null, [-1]], null, null, [null, null, null, null, null, null, null, null, null, [-1]]] };
  x.b = function() {
    return x.a ? x.a : x.a = new x();
  };
  var ul = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", "\uFF10": "0", "\uFF11": "1", "\uFF12": "2", "\uFF13": "3", "\uFF14": "4", "\uFF15": "5", "\uFF16": "6", "\uFF17": "7", "\uFF18": "8", "\uFF19": "9", "\u0660": "0", "\u0661": "1", "\u0662": "2", "\u0663": "3", "\u0664": "4", "\u0665": "5", "\u0666": "6", "\u0667": "7", "\u0668": "8", "\u0669": "9", "\u06F0": "0", "\u06F1": "1", "\u06F2": "2", "\u06F3": "3", "\u06F4": "4", "\u06F5": "5", "\u06F6": "6", "\u06F7": "7", "\u06F8": "8", "\u06F9": "9" }, tl = RegExp("[+\uFF0B]+"), el = RegExp("([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9])"), rl = /^\(?\$1\)?$/, il = new S();
  m(il, 11, "NA");
  var al = /\[([^\[\]])*\]/g, dl = /\d(?=[^,}][^,}])/g, ol = RegExp("^[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*(\\$\\d[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*)+$"), sl = /[- ]/;
  N.prototype.K = function() {
    this.C = "", t(this.i), t(this.u), t(this.m), this.s = 0, this.w = "", t(this.b), this.h = "", t(this.a), this.l = true, this.A = this.o = this.F = false, this.f = [], this.B = false, this.g != this.J && (this.g = D(this, this.D));
  }, N.prototype.L = function(l2) {
    return this.C = I(this, l2);
  }, l("Cleave.AsYouTypeFormatter", N), l("Cleave.AsYouTypeFormatter.prototype.inputDigit", N.prototype.L), l("Cleave.AsYouTypeFormatter.prototype.clear", N.prototype.K);
}.call("object" == typeof commonjsGlobal$2 && commonjsGlobal$2 ? commonjsGlobal$2 : window);
const __vue2_script$10 = {
  props: {
    value: {
      default: null,
      required: true,
      validator(value) {
        return value === null || typeof value === "string" || value instanceof String || typeof value === "number";
      }
    },
    options: {
      type: Object,
      default: () => ({})
    },
    raw: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      cleave: null,
      onValueChangedFn: null
    };
  },
  watch: {
    options: {
      deep: true,
      handler(newOptions) {
        this.cleave.destroy();
        this.cleave = new Cleave_1(this.$el, this.getOptions(newOptions));
        this.cleave.setRawValue(this.value);
      }
    },
    value(newValue) {
      if (!this.cleave)
        return;
      if (this.raw && newValue === this.cleave.getRawValue())
        return;
      if (!this.raw && newValue === this.$el.value)
        return;
      this.cleave.setRawValue(newValue);
    }
  },
  mounted() {
    if (this.cleave)
      return;
    this.cleave = new Cleave_1(this.$el, this.getOptions(this.options));
  },
  beforeDestroy() {
    if (!this.cleave)
      return;
    this.cleave.destroy();
    this.cleave = null;
    this.onValueChangedFn = null;
  },
  methods: {
    getOptions(options) {
      this.onValueChangedFn = options.onValueChanged;
      return { ...options, onValueChanged: this.onValueChanged };
    },
    onValueChanged(event) {
      const value = this.raw ? event.target.rawValue : event.target.value;
      this.$emit("input", value);
      if (typeof this.onValueChangedFn === "function") {
        this.onValueChangedFn.call(this, event);
      }
    },
    onBlur() {
      this.$emit("blur", this.value);
    }
  },
  render() {
    return h("input", {
      attrs: {
        value: this.value
      },
      on: {
        blur: this.onBlur
      }
    });
  }
};
let __vue2_render, __vue2_staticRenderFns;
const __cssModules$10 = {};
var __component__$10 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$10,
  __vue2_render,
  __vue2_staticRenderFns,
  false,
  __vue2_injectStyles$10,
  null,
  null,
  null
);
function __vue2_injectStyles$10(context) {
  for (let o in __cssModules$10) {
    this[o] = __cssModules$10[o];
  }
}
var CleaveInput = /* @__PURE__ */ function() {
  return __component__$10.exports;
}();
var render$2b = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("FormField", { staticClass: "text-input", class: [
    "text-input--" + _vm.size,
    {
      "text-input--invalid": _vm.invalid || _vm.error,
      "text-input--disabled": _vm.disabled
    }
  ], attrs: { "id": _vm.id, "size": _vm.size, "label": _vm.label, "error": _vm.error, "invalid": _vm.invalid, "disabled": _vm.disabled } }, [_vm.preIcon ? _c("BaseIcon", { staticClass: "text-input__icon text-input__icon--pre", attrs: { "icon": _vm.preIcon } }) : _vm._e(), _vm.prefix ? _c("span", { staticClass: "text-input__prefix" }, [_vm._v(_vm._s(_vm.prefix))]) : _vm._e(), _c(_vm.inputComponent, _vm._g(_vm._b({ ref: "input", tag: "component", staticClass: "text-input__field", attrs: { "id": _vm.id, "value": _vm.value, "aria-invalid": _vm.invalid, "aria-describedby": _vm.error ? _vm.id + "-error" : false, "disabled": _vm.disabled } }, "component", _vm.passThroughProps, false), _vm.eventListeners)), _vm.postfix ? _c("span", { staticClass: "text-input__postfix" }, [_vm._v(_vm._s(_vm.postfix))]) : _vm._e(), _vm.postIcon ? _c("BaseIcon", { staticClass: "text-input__icon text-input__icon--post", attrs: { "icon": _vm.postIcon } }) : _vm._e(), _vm.showReset ? _c("IconButton", { staticClass: "text-input__reset text-input__icon", attrs: { "variant": _vm.$options.Button.Variants.SECONDARY, "size": _vm.$options.Button.Sizes.SMALL, "type": "button", "icon": _vm.$options.Icons.CLOSE, "title": "Clear", "flat": "", "disabled": _vm.disabled }, on: { "click": function($event) {
    $event.preventDefault();
    return _vm.handleReset($event);
  } } }) : _vm._e(), _vm._t("default")], 2);
};
var staticRenderFns$$ = [];
var TextInput_vue_vue_type_style_index_0_scoped_true_lang = "";
const { Sizes: Sizes$7 } = Form;
const __vue2_script$$ = {
  Button,
  Icons: Icons$1,
  components: {
    BaseIcon,
    FormField,
    IconButton
  },
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: shortid.generate
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    mask: {
      type: Object,
      default: null
    },
    postIcon: {
      type: String,
      default: null,
      validator: (value) => !value || isValidIcon$1(value)
    },
    preIcon: {
      type: String,
      default: null,
      validator: (value) => !value || isValidIcon$1(value)
    },
    prefix: {
      type: String,
      default: null
    },
    postfix: {
      type: String,
      default: null
    },
    showReset: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Sizes$7.NORMAL,
      validator: (value) => Object.values(Sizes$7).includes(value)
    },
    value: {
      type: [Number, String],
      default: ""
    }
  },
  computed: {
    eventListeners() {
      const events = {};
      Object.keys(this.$listeners).forEach((name) => {
        events[name] = (event) => this.handleInput(event, name);
      });
      return events;
    },
    inputComponent() {
      return this.mask ? CleaveInput : "input";
    },
    passThroughProps() {
      if (!isObject_1(this.mask)) {
        return this.$attrs;
      }
      const { raw, ...options } = this.mask;
      return {
        ...this.$attrs,
        options,
        raw: isBoolean_1(raw) ? raw : true
      };
    }
  },
  methods: {
    getInputEl() {
      return this.inputComponent === "input" ? this.$refs.input : this.$refs.input.$el;
    },
    async handleInput(e, eventName) {
      const value = this.inputComponent === "input" ? e.target.value : e;
      const inputEventKey = "input-event";
      this.$emit(eventName, value);
      if (Object.keys(this.$listeners).includes(inputEventKey)) {
        this.$emit(inputEventKey, e);
      }
      await this.$nextTick();
      this.syncInputEl(this.value);
    },
    syncInputEl(targetVal) {
      const inputEl = this.getInputEl();
      if (this.mask) {
        if (!targetVal) {
          inputEl.value = targetVal;
        }
        return;
      }
      if (inputEl && inputEl.value !== targetVal) {
        inputEl.value = targetVal;
      }
    },
    handleReset() {
      const inputEl = this.getInputEl();
      inputEl.value = "";
      this.$emit("input", "");
    }
  }
};
const __cssModules$$ = {};
var __component__$$ = /* @__PURE__ */ normalizeComponent(
  __vue2_script$$,
  render$2b,
  staticRenderFns$$,
  false,
  __vue2_injectStyles$$,
  "75301a38",
  null,
  null
);
function __vue2_injectStyles$$(context) {
  for (let o in __cssModules$$) {
    this[o] = __cssModules$$[o];
  }
}
var TextInput = /* @__PURE__ */ function() {
  return __component__$$.exports;
}();
var render$2a = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("TextInput", _vm._g(_vm._b({ attrs: { "type": "number", "value": _vm.value } }, "TextInput", _vm.$attrs, false), _vm.eventListeners));
};
var staticRenderFns$_ = [];
const __vue2_script$_ = {
  name: "NumberInput",
  components: {
    TextInput
  },
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  computed: {
    eventListeners() {
      const events = {};
      Object.keys(this.$listeners).forEach((name) => {
        events[name] = (event) => this.handleEvent(event, name);
      });
      return events;
    }
  },
  methods: {
    handleEvent(val, eventName) {
      const numericVal = this.enforceNumberAttrs(val);
      this.$emit(eventName, numericVal);
    },
    enforceNumberAttrs(rawVal) {
      let numVal = +rawVal;
      const { min: min2, max: max2 } = this.$attrs;
      if (min2 && +min2 > numVal) {
        numVal = +min2;
      } else if (max2 && +max2 < numVal) {
        numVal = +max2;
      }
      return numVal;
    }
  }
};
const __cssModules$_ = {};
var __component__$_ = /* @__PURE__ */ normalizeComponent(
  __vue2_script$_,
  render$2a,
  staticRenderFns$_,
  false,
  __vue2_injectStyles$_,
  null,
  null,
  null
);
function __vue2_injectStyles$_(context) {
  for (let o in __cssModules$_) {
    this[o] = __cssModules$_[o];
  }
}
var NumberInput = /* @__PURE__ */ function() {
  return __component__$_.exports;
}();
function scorePassword(pwd) {
  let ltr;
  let i;
  let l;
  let variation = 0;
  const letters = {};
  let score = 0;
  if (!pwd) {
    return score;
  }
  const variations = {
    lower: /[a-z]/.test(pwd),
    upper: /[A-Z]/.test(pwd),
    nonWords: /\W/.test(pwd),
    digits: /\d/.test(pwd)
  };
  Object.values(variations).forEach((item) => {
    variation += item ? 1 : 0;
  });
  score += (variation - 1) * 10;
  for (i = 0, l = pwd.length; i < l; i += 1) {
    letters[pwd[i]] = (letters[pwd[i]] || 0) + 1;
    ltr = letters[pwd[i]];
    score += 5 / ltr;
  }
  score -= 16 - pwd.length / 16;
  return parseInt(score, 10);
}
var render$29 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("TextInput", _vm._b({ staticClass: "password-input", attrs: { "id": _vm.id, "type": _vm.isShowingPassword ? "type" : "password", "disabled": _vm.disabled, "value": _vm.value, "size": _vm.size, "maxlength": _vm.maxlength, "minlength": _vm.minlength, "error": _vm.localError, "name": "password" }, on: { "input": function($event) {
    return _vm.$emit("input", $event);
  } } }, "TextInput", _vm.$attrs, false), [_c("IconButton", { staticClass: "password-input__toggle", attrs: { "icon": _vm.passwordIcon, "title": _vm.isShowingPassword ? "Hide password" : "Show password", "size": _vm.toggleSize, "disabled": _vm.disabled, "variant": "secondary", "type": "button", "flat": "" }, on: { "click": _vm.handleToggle } }), _vm.showScore ? _c("div", { staticClass: "password-input__meter", class: "password-input__meter--" + _vm.passwordScore.label, attrs: { "title": _vm.passwordScore.label, "aria-label": _vm.passwordScore.label } }, _vm._l(_vm.passwordScore.value, function(n) {
    return _c("div", { key: n, staticClass: "password-input__meter-indicator" });
  }), 0) : _vm._e()], 1);
};
var staticRenderFns$Z = [];
var PasswordInput_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$Z = defineComponent({
  name: "PasswordInput",
  components: { IconButton, TextInput },
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: shortid.generate
    },
    maxlength: {
      type: Number,
      default: 128
    },
    minlength: {
      type: Number,
      default: 8
    },
    showScore: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => Object.values(Form.Sizes).includes(value)
    },
    validatePassword: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ""
    }
  },
  setup(props2) {
    const isShowingPassword = ref(false);
    const handleToggle = async () => {
      isShowingPassword.value = !isShowingPassword.value;
      await nextTick();
      document.getElementById(props2.id).focus();
    };
    const validationErrors = computed(() => {
      if (!props2.validatePassword || !props2.value)
        return [];
      const errors = [];
      if (props2.value.length < props2.minlength) {
        errors.push(
          `The password must be at least ${props2.minlength} characters long.`
        );
      }
      if (props2.value.length > props2.maxlength) {
        errors.push(
          `The password must be fewer than ${props2.maxlength} characters.`
        );
      }
      if (/(.)\1{2,}/.test(props2.value)) {
        errors.push(
          "The password may not contain sequences of three or more repeated characters."
        );
      }
      return errors;
    });
    const inputType = computed(
      () => isShowingPassword.value ? "type" : "password"
    );
    const localError = computed(
      () => [props2.error, ...validationErrors.value].filter((item) => item).join(" ")
    );
    const passwordIcon = computed(
      () => isShowingPassword.value ? Icons$1.EYE_OPEN : Icons$1.EYE_CLOSED
    );
    const passwordScore = computed(() => {
      const rawScore = scorePassword(props2.value);
      if (rawScore >= 80 && !validationErrors.value.length) {
        return {
          label: "strong",
          value: 4
        };
      }
      if (rawScore >= 60 && !validationErrors.value.length) {
        return {
          label: "ok",
          value: 3
        };
      }
      if (rawScore >= 30 && !validationErrors.value.length) {
        return {
          label: "weak",
          value: 2
        };
      }
      return {
        label: "bad",
        value: 1
      };
    });
    const toggleSize = computed(
      () => props2.size === Form.Sizes.LARGE ? Button.Sizes.MEDIUM : Button.Sizes.SMALL
    );
    return {
      inputType,
      passwordScore,
      passwordIcon,
      localError,
      toggleSize,
      isShowingPassword,
      handleToggle
    };
  }
});
const __cssModules$Z = {};
var __component__$Z = /* @__PURE__ */ normalizeComponent(
  __vue2_script$Z,
  render$29,
  staticRenderFns$Z,
  false,
  __vue2_injectStyles$Z,
  "1a1fa334",
  null,
  null
);
function __vue2_injectStyles$Z(context) {
  for (let o in __cssModules$Z) {
    this[o] = __cssModules$Z[o];
  }
}
var PasswordInput = /* @__PURE__ */ function() {
  return __component__$Z.exports;
}();
var render$28 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("TextInput", _vm._g(_vm._b({ attrs: { "type": "tel", "mask": _vm.mask, "value": _vm.value } }, "TextInput", _vm.$attrs, false), _vm.eventListeners));
};
var staticRenderFns$Y = [];
const removeLeadingZeroOrOne = (val) => {
  let result = val;
  if (["0", "1"].includes(val[0])) {
    result = removeLeadingZeroOrOne(val.substring(1));
  }
  return result;
};
const __vue2_script$Y = defineComponent({
  name: "PhoneInput",
  components: { TextInput },
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  setup(_, { emit, listeners }) {
    const handleEvent = (val, eventName) => {
      const finalVal = removeLeadingZeroOrOne(val);
      emit(eventName, finalVal);
    };
    const eventListeners2 = computed(() => {
      const events = {};
      Object.keys(listeners).forEach((name) => {
        events[name] = (event) => handleEvent(event, name);
      });
      return events;
    });
    const mask = computed(() => InputMasks.PHONE);
    return {
      eventListeners: eventListeners2,
      mask,
      handleEvent
    };
  }
});
const __cssModules$Y = {};
var __component__$Y = /* @__PURE__ */ normalizeComponent(
  __vue2_script$Y,
  render$28,
  staticRenderFns$Y,
  false,
  __vue2_injectStyles$Y,
  null,
  null,
  null
);
function __vue2_injectStyles$Y(context) {
  for (let o in __cssModules$Y) {
    this[o] = __cssModules$Y[o];
  }
}
var PhoneInput = /* @__PURE__ */ function() {
  return __component__$Y.exports;
}();
var render$27 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ToggleGroup", { staticClass: "radio-group", attrs: { "options": _vm.options, "disabled": _vm.disabled, "invalid": _vm.invalid, "label": _vm.label, "label-position": _vm.labelPosition, "name": _vm.name, "required": _vm.required, "size": _vm.size, "vertical": _vm.vertical, "value": _vm.value, "type": "radio" }, on: { "input": function($event) {
    return _vm.$emit("input", $event);
  } } });
};
var staticRenderFns$X = [];
const __vue2_script$X = defineComponent({
  name: "RadioGroup",
  components: { ToggleGroup },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    labelPosition: {
      type: String,
      default: Form.LabelPositions.RIGHT,
      validator: (value) => Object.values(Form.LabelPositions).includes(value)
    },
    name: {
      type: String,
      default: void 0
    },
    options: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => [Form.Sizes.DENSE, Form.Sizes.NORMAL].includes(value)
    },
    vertical: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: null
    }
  }
});
const __cssModules$X = {};
var __component__$X = /* @__PURE__ */ normalizeComponent(
  __vue2_script$X,
  render$27,
  staticRenderFns$X,
  false,
  __vue2_injectStyles$X,
  null,
  null,
  null
);
function __vue2_injectStyles$X(context) {
  for (let o in __cssModules$X) {
    this[o] = __cssModules$X[o];
  }
}
var RadioGroup = /* @__PURE__ */ function() {
  return __component__$X.exports;
}();
var vueSelect$1 = { exports: {} };
(function(module, exports) {
  !function(t, e) {
    module.exports = e();
  }("undefined" != typeof self ? self : commonjsGlobal$2, function() {
    return function(t) {
      var e = {};
      function n(o) {
        if (e[o])
          return e[o].exports;
        var i = e[o] = { i: o, l: false, exports: {} };
        return t[o].call(i.exports, i, i.exports, n), i.l = true, i.exports;
      }
      return n.m = t, n.c = e, n.d = function(t2, e2, o) {
        n.o(t2, e2) || Object.defineProperty(t2, e2, { enumerable: true, get: o });
      }, n.r = function(t2) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t2, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t2, "__esModule", { value: true });
      }, n.t = function(t2, e2) {
        if (1 & e2 && (t2 = n(t2)), 8 & e2)
          return t2;
        if (4 & e2 && "object" == typeof t2 && t2 && t2.__esModule)
          return t2;
        var o = /* @__PURE__ */ Object.create(null);
        if (n.r(o), Object.defineProperty(o, "default", { enumerable: true, value: t2 }), 2 & e2 && "string" != typeof t2)
          for (var i in t2)
            n.d(o, i, function(e3) {
              return t2[e3];
            }.bind(null, i));
        return o;
      }, n.n = function(t2) {
        var e2 = t2 && t2.__esModule ? function() {
          return t2.default;
        } : function() {
          return t2;
        };
        return n.d(e2, "a", e2), e2;
      }, n.o = function(t2, e2) {
        return Object.prototype.hasOwnProperty.call(t2, e2);
      }, n.p = "/", n(n.s = 8);
    }([function(t, e, n) {
      var o = n(4), i = n(5), s = n(6);
      t.exports = function(t2) {
        return o(t2) || i(t2) || s();
      };
    }, function(t, e) {
      function n(e2) {
        return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? t.exports = n = function(t2) {
          return typeof t2;
        } : t.exports = n = function(t2) {
          return t2 && "function" == typeof Symbol && t2.constructor === Symbol && t2 !== Symbol.prototype ? "symbol" : typeof t2;
        }, n(e2);
      }
      t.exports = n;
    }, function(t, e, n) {
    }, function(t, e) {
      t.exports = function(t2, e2, n) {
        return e2 in t2 ? Object.defineProperty(t2, e2, { value: n, enumerable: true, configurable: true, writable: true }) : t2[e2] = n, t2;
      };
    }, function(t, e) {
      t.exports = function(t2) {
        if (Array.isArray(t2)) {
          for (var e2 = 0, n = new Array(t2.length); e2 < t2.length; e2++)
            n[e2] = t2[e2];
          return n;
        }
      };
    }, function(t, e) {
      t.exports = function(t2) {
        if (Symbol.iterator in Object(t2) || "[object Arguments]" === Object.prototype.toString.call(t2))
          return Array.from(t2);
      };
    }, function(t, e) {
      t.exports = function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      };
    }, function(t, e, n) {
      var o = n(2);
      n.n(o).a;
    }, function(t, e, n) {
      n.r(e);
      var o = n(0), i = n.n(o), s = n(1), r = n.n(s), a = n(3), l = n.n(a), c = { props: { autoscroll: { type: Boolean, default: true } }, watch: { typeAheadPointer: function() {
        this.autoscroll && this.maybeAdjustScroll();
      } }, methods: { maybeAdjustScroll: function() {
        var t2, e2 = (null === (t2 = this.$refs.dropdownMenu) || void 0 === t2 ? void 0 : t2.children[this.typeAheadPointer]) || false;
        if (e2) {
          var n2 = this.getDropdownViewport(), o2 = e2.getBoundingClientRect(), i2 = o2.top, s2 = o2.bottom, r2 = o2.height;
          if (i2 < n2.top)
            return this.$refs.dropdownMenu.scrollTop = e2.offsetTop;
          if (s2 > n2.bottom)
            return this.$refs.dropdownMenu.scrollTop = e2.offsetTop - (n2.height - r2);
        }
      }, getDropdownViewport: function() {
        return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : { height: 0, top: 0, bottom: 0 };
      } } }, u = { data: function() {
        return { typeAheadPointer: -1 };
      }, watch: { filteredOptions: function() {
        for (var t2 = 0; t2 < this.filteredOptions.length; t2++)
          if (this.selectable(this.filteredOptions[t2])) {
            this.typeAheadPointer = t2;
            break;
          }
      } }, methods: { typeAheadUp: function() {
        for (var t2 = this.typeAheadPointer - 1; t2 >= 0; t2--)
          if (this.selectable(this.filteredOptions[t2])) {
            this.typeAheadPointer = t2;
            break;
          }
      }, typeAheadDown: function() {
        for (var t2 = this.typeAheadPointer + 1; t2 < this.filteredOptions.length; t2++)
          if (this.selectable(this.filteredOptions[t2])) {
            this.typeAheadPointer = t2;
            break;
          }
      }, typeAheadSelect: function() {
        var t2 = this.filteredOptions[this.typeAheadPointer];
        t2 && this.select(t2);
      } } }, p = { props: { loading: { type: Boolean, default: false } }, data: function() {
        return { mutableLoading: false };
      }, watch: { search: function() {
        this.$emit("search", this.search, this.toggleLoading);
      }, loading: function(t2) {
        this.mutableLoading = t2;
      } }, methods: { toggleLoading: function() {
        var t2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
        return this.mutableLoading = null == t2 ? !this.mutableLoading : t2;
      } } };
      function h2(t2, e2, n2, o2, i2, s2, r2, a2) {
        var l2, c2 = "function" == typeof t2 ? t2.options : t2;
        if (e2 && (c2.render = e2, c2.staticRenderFns = n2, c2._compiled = true), o2 && (c2.functional = true), s2 && (c2._scopeId = "data-v-" + s2), r2 ? (l2 = function(t3) {
          (t3 = t3 || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t3 = __VUE_SSR_CONTEXT__), i2 && i2.call(this, t3), t3 && t3._registeredComponents && t3._registeredComponents.add(r2);
        }, c2._ssrRegister = l2) : i2 && (l2 = a2 ? function() {
          i2.call(this, this.$root.$options.shadowRoot);
        } : i2), l2)
          if (c2.functional) {
            c2._injectStyles = l2;
            var u2 = c2.render;
            c2.render = function(t3, e3) {
              return l2.call(e3), u2(t3, e3);
            };
          } else {
            var p2 = c2.beforeCreate;
            c2.beforeCreate = p2 ? [].concat(p2, l2) : [l2];
          }
        return { exports: t2, options: c2 };
      }
      var d = { Deselect: h2({}, function() {
        var t2 = this.$createElement, e2 = this._self._c || t2;
        return e2("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", width: "10", height: "10" } }, [e2("path", { attrs: { d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z" } })]);
      }, [], false, null, null, null).exports, OpenIndicator: h2({}, function() {
        var t2 = this.$createElement, e2 = this._self._c || t2;
        return e2("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "10" } }, [e2("path", { attrs: { d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z" } })]);
      }, [], false, null, null, null).exports }, f = { inserted: function(t2, e2, n2) {
        var o2 = n2.context;
        if (o2.appendToBody) {
          var i2 = o2.$refs.toggle.getBoundingClientRect(), s2 = i2.height, r2 = i2.top, a2 = i2.left, l2 = i2.width, c2 = window.scrollX || window.pageXOffset, u2 = window.scrollY || window.pageYOffset;
          t2.unbindPosition = o2.calculatePosition(t2, o2, { width: l2 + "px", left: c2 + a2 + "px", top: u2 + r2 + s2 + "px" }), document.body.appendChild(t2);
        }
      }, unbind: function(t2, e2, n2) {
        n2.context.appendToBody && (t2.unbindPosition && "function" == typeof t2.unbindPosition && t2.unbindPosition(), t2.parentNode && t2.parentNode.removeChild(t2));
      } };
      var y = function(t2) {
        var e2 = {};
        return Object.keys(t2).sort().forEach(function(n2) {
          e2[n2] = t2[n2];
        }), JSON.stringify(e2);
      }, b = 0;
      var g = function() {
        return ++b;
      };
      function v(t2, e2) {
        var n2 = Object.keys(t2);
        if (Object.getOwnPropertySymbols) {
          var o2 = Object.getOwnPropertySymbols(t2);
          e2 && (o2 = o2.filter(function(e3) {
            return Object.getOwnPropertyDescriptor(t2, e3).enumerable;
          })), n2.push.apply(n2, o2);
        }
        return n2;
      }
      function m(t2) {
        for (var e2 = 1; e2 < arguments.length; e2++) {
          var n2 = null != arguments[e2] ? arguments[e2] : {};
          e2 % 2 ? v(Object(n2), true).forEach(function(e3) {
            l()(t2, e3, n2[e3]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t2, Object.getOwnPropertyDescriptors(n2)) : v(Object(n2)).forEach(function(e3) {
            Object.defineProperty(t2, e3, Object.getOwnPropertyDescriptor(n2, e3));
          });
        }
        return t2;
      }
      var _ = { components: m({}, d), mixins: [c, u, p], directives: { appendToBody: f }, props: { value: {}, components: { type: Object, default: function() {
        return {};
      } }, options: { type: Array, default: function() {
        return [];
      } }, disabled: { type: Boolean, default: false }, clearable: { type: Boolean, default: true }, searchable: { type: Boolean, default: true }, multiple: { type: Boolean, default: false }, placeholder: { type: String, default: "" }, transition: { type: String, default: "vs__fade" }, clearSearchOnSelect: { type: Boolean, default: true }, closeOnSelect: { type: Boolean, default: true }, label: { type: String, default: "label" }, autocomplete: { type: String, default: "off" }, reduce: { type: Function, default: function(t2) {
        return t2;
      } }, selectable: { type: Function, default: function(t2) {
        return true;
      } }, getOptionLabel: { type: Function, default: function(t2) {
        return "object" === r()(t2) ? t2.hasOwnProperty(this.label) ? t2[this.label] : console.warn('[vue-select warn]: Label key "option.'.concat(this.label, '" does not') + " exist in options object ".concat(JSON.stringify(t2), ".\n") + "https://vue-select.org/api/props.html#getoptionlabel") : t2;
      } }, getOptionKey: { type: Function, default: function(t2) {
        if ("object" !== r()(t2))
          return t2;
        try {
          return t2.hasOwnProperty("id") ? t2.id : y(t2);
        } catch (e2) {
          return console.warn("[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.\nhttps://vue-select.org/api/props.html#getoptionkey", t2, e2);
        }
      } }, onTab: { type: Function, default: function() {
        this.selectOnTab && !this.isComposing && this.typeAheadSelect();
      } }, taggable: { type: Boolean, default: false }, tabindex: { type: Number, default: null }, pushTags: { type: Boolean, default: false }, filterable: { type: Boolean, default: true }, filterBy: { type: Function, default: function(t2, e2, n2) {
        return (e2 || "").toLowerCase().indexOf(n2.toLowerCase()) > -1;
      } }, filter: { type: Function, default: function(t2, e2) {
        var n2 = this;
        return t2.filter(function(t3) {
          var o2 = n2.getOptionLabel(t3);
          return "number" == typeof o2 && (o2 = o2.toString()), n2.filterBy(t3, o2, e2);
        });
      } }, createOption: { type: Function, default: function(t2) {
        return "object" === r()(this.optionList[0]) ? l()({}, this.label, t2) : t2;
      } }, resetOnOptionsChange: { default: false, validator: function(t2) {
        return ["function", "boolean"].includes(r()(t2));
      } }, clearSearchOnBlur: { type: Function, default: function(t2) {
        var e2 = t2.clearSearchOnSelect, n2 = t2.multiple;
        return e2 && !n2;
      } }, noDrop: { type: Boolean, default: false }, inputId: { type: String }, dir: { type: String, default: "auto" }, selectOnTab: { type: Boolean, default: false }, selectOnKeyCodes: { type: Array, default: function() {
        return [13];
      } }, searchInputQuerySelector: { type: String, default: "[type=search]" }, mapKeydown: { type: Function, default: function(t2, e2) {
        return t2;
      } }, appendToBody: { type: Boolean, default: false }, calculatePosition: { type: Function, default: function(t2, e2, n2) {
        var o2 = n2.width, i2 = n2.top, s2 = n2.left;
        t2.style.top = i2, t2.style.left = s2, t2.style.width = o2;
      } } }, data: function() {
        return { uid: g(), search: "", open: false, isComposing: false, pushedTags: [], _value: [] };
      }, watch: { options: function(t2, e2) {
        var n2 = this;
        !this.taggable && ("function" == typeof n2.resetOnOptionsChange ? n2.resetOnOptionsChange(t2, e2, n2.selectedValue) : n2.resetOnOptionsChange) && this.clearSelection(), this.value && this.isTrackingValues && this.setInternalValueFromOptions(this.value);
      }, value: function(t2) {
        this.isTrackingValues && this.setInternalValueFromOptions(t2);
      }, multiple: function() {
        this.clearSelection();
      }, open: function(t2) {
        this.$emit(t2 ? "open" : "close");
      } }, created: function() {
        this.mutableLoading = this.loading, void 0 !== this.value && this.isTrackingValues && this.setInternalValueFromOptions(this.value), this.$on("option:created", this.pushTag);
      }, methods: { setInternalValueFromOptions: function(t2) {
        var e2 = this;
        Array.isArray(t2) ? this.$data._value = t2.map(function(t3) {
          return e2.findOptionFromReducedValue(t3);
        }) : this.$data._value = this.findOptionFromReducedValue(t2);
      }, select: function(t2) {
        this.$emit("option:selecting", t2), this.isOptionSelected(t2) || (this.taggable && !this.optionExists(t2) && this.$emit("option:created", t2), this.multiple && (t2 = this.selectedValue.concat(t2)), this.updateValue(t2), this.$emit("option:selected", t2)), this.onAfterSelect(t2);
      }, deselect: function(t2) {
        var e2 = this;
        this.$emit("option:deselecting", t2), this.updateValue(this.selectedValue.filter(function(n2) {
          return !e2.optionComparator(n2, t2);
        })), this.$emit("option:deselected", t2);
      }, clearSelection: function() {
        this.updateValue(this.multiple ? [] : null);
      }, onAfterSelect: function(t2) {
        this.closeOnSelect && (this.open = !this.open, this.searchEl.blur()), this.clearSearchOnSelect && (this.search = "");
      }, updateValue: function(t2) {
        var e2 = this;
        void 0 === this.value && (this.$data._value = t2), null !== t2 && (t2 = Array.isArray(t2) ? t2.map(function(t3) {
          return e2.reduce(t3);
        }) : this.reduce(t2)), this.$emit("input", t2);
      }, toggleDropdown: function(t2) {
        var e2 = t2.target !== this.searchEl;
        e2 && t2.preventDefault();
        var n2 = [].concat(i()(this.$refs.deselectButtons || []), i()([this.$refs.clearButton]));
        void 0 === this.searchEl || n2.filter(Boolean).some(function(e3) {
          return e3.contains(t2.target) || e3 === t2.target;
        }) ? t2.preventDefault() : this.open && e2 ? this.searchEl.blur() : this.disabled || (this.open = true, this.searchEl.focus());
      }, isOptionSelected: function(t2) {
        var e2 = this;
        return this.selectedValue.some(function(n2) {
          return e2.optionComparator(n2, t2);
        });
      }, optionComparator: function(t2, e2) {
        return this.getOptionKey(t2) === this.getOptionKey(e2);
      }, findOptionFromReducedValue: function(t2) {
        var e2 = this, n2 = [].concat(i()(this.options), i()(this.pushedTags)).filter(function(n3) {
          return JSON.stringify(e2.reduce(n3)) === JSON.stringify(t2);
        });
        return 1 === n2.length ? n2[0] : n2.find(function(t3) {
          return e2.optionComparator(t3, e2.$data._value);
        }) || t2;
      }, closeSearchOptions: function() {
        this.open = false, this.$emit("search:blur");
      }, maybeDeleteValue: function() {
        if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
          var t2 = null;
          this.multiple && (t2 = i()(this.selectedValue.slice(0, this.selectedValue.length - 1))), this.updateValue(t2);
        }
      }, optionExists: function(t2) {
        var e2 = this;
        return this.optionList.some(function(n2) {
          return e2.optionComparator(n2, t2);
        });
      }, normalizeOptionForSlot: function(t2) {
        return "object" === r()(t2) ? t2 : l()({}, this.label, t2);
      }, pushTag: function(t2) {
        this.pushedTags.push(t2);
      }, onEscape: function() {
        this.search.length ? this.search = "" : this.searchEl.blur();
      }, onSearchBlur: function() {
        if (!this.mousedown || this.searching) {
          var t2 = this.clearSearchOnSelect, e2 = this.multiple;
          return this.clearSearchOnBlur({ clearSearchOnSelect: t2, multiple: e2 }) && (this.search = ""), void this.closeSearchOptions();
        }
        this.mousedown = false, 0 !== this.search.length || 0 !== this.options.length || this.closeSearchOptions();
      }, onSearchFocus: function() {
        this.open = true, this.$emit("search:focus");
      }, onMousedown: function() {
        this.mousedown = true;
      }, onMouseUp: function() {
        this.mousedown = false;
      }, onSearchKeyDown: function(t2) {
        var e2 = this, n2 = function(t3) {
          return t3.preventDefault(), !e2.isComposing && e2.typeAheadSelect();
        }, o2 = { 8: function(t3) {
          return e2.maybeDeleteValue();
        }, 9: function(t3) {
          return e2.onTab();
        }, 27: function(t3) {
          return e2.onEscape();
        }, 38: function(t3) {
          return t3.preventDefault(), e2.typeAheadUp();
        }, 40: function(t3) {
          return t3.preventDefault(), e2.typeAheadDown();
        } };
        this.selectOnKeyCodes.forEach(function(t3) {
          return o2[t3] = n2;
        });
        var i2 = this.mapKeydown(o2, this);
        if ("function" == typeof i2[t2.keyCode])
          return i2[t2.keyCode](t2);
      } }, computed: { isTrackingValues: function() {
        return void 0 === this.value || this.$options.propsData.hasOwnProperty("reduce");
      }, selectedValue: function() {
        var t2 = this.value;
        return this.isTrackingValues && (t2 = this.$data._value), t2 ? [].concat(t2) : [];
      }, optionList: function() {
        return this.options.concat(this.pushTags ? this.pushedTags : []);
      }, searchEl: function() {
        return this.$scopedSlots.search ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
      }, scope: function() {
        var t2 = this, e2 = { search: this.search, loading: this.loading, searching: this.searching, filteredOptions: this.filteredOptions };
        return { search: { attributes: m({ disabled: this.disabled, placeholder: this.searchPlaceholder, tabindex: this.tabindex, readonly: !this.searchable, id: this.inputId, "aria-autocomplete": "list", "aria-labelledby": "vs".concat(this.uid, "__combobox"), "aria-controls": "vs".concat(this.uid, "__listbox"), ref: "search", type: "search", autocomplete: this.autocomplete, value: this.search }, this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? { "aria-activedescendant": "vs".concat(this.uid, "__option-").concat(this.typeAheadPointer) } : {}), events: { compositionstart: function() {
          return t2.isComposing = true;
        }, compositionend: function() {
          return t2.isComposing = false;
        }, keydown: this.onSearchKeyDown, blur: this.onSearchBlur, focus: this.onSearchFocus, input: function(e3) {
          return t2.search = e3.target.value;
        } } }, spinner: { loading: this.mutableLoading }, noOptions: { search: this.search, loading: this.loading, searching: this.searching }, openIndicator: { attributes: { ref: "openIndicator", role: "presentation", class: "vs__open-indicator" } }, listHeader: e2, listFooter: e2, header: m({}, e2, { deselect: this.deselect }), footer: m({}, e2, { deselect: this.deselect }) };
      }, childComponents: function() {
        return m({}, d, {}, this.components);
      }, stateClasses: function() {
        return { "vs--open": this.dropdownOpen, "vs--single": !this.multiple, "vs--searching": this.searching && !this.noDrop, "vs--searchable": this.searchable && !this.noDrop, "vs--unsearchable": !this.searchable, "vs--loading": this.mutableLoading, "vs--disabled": this.disabled };
      }, searching: function() {
        return !!this.search;
      }, dropdownOpen: function() {
        return !this.noDrop && (this.open && !this.mutableLoading);
      }, searchPlaceholder: function() {
        if (this.isValueEmpty && this.placeholder)
          return this.placeholder;
      }, filteredOptions: function() {
        var t2 = [].concat(this.optionList);
        if (!this.filterable && !this.taggable)
          return t2;
        var e2 = this.search.length ? this.filter(t2, this.search, this) : t2;
        if (this.taggable && this.search.length) {
          var n2 = this.createOption(this.search);
          this.optionExists(n2) || e2.unshift(n2);
        }
        return e2;
      }, isValueEmpty: function() {
        return 0 === this.selectedValue.length;
      }, showClearButton: function() {
        return !this.multiple && this.clearable && !this.open && !this.isValueEmpty;
      } } }, O = (n(7), h2(_, function() {
        var t2 = this, e2 = t2.$createElement, n2 = t2._self._c || e2;
        return n2("div", { staticClass: "v-select", class: t2.stateClasses, attrs: { dir: t2.dir } }, [t2._t("header", null, null, t2.scope.header), t2._v(" "), n2("div", { ref: "toggle", staticClass: "vs__dropdown-toggle", attrs: { id: "vs" + t2.uid + "__combobox", role: "combobox", "aria-expanded": t2.dropdownOpen.toString(), "aria-owns": "vs" + t2.uid + "__listbox", "aria-label": "Search for option" }, on: { mousedown: function(e3) {
          return t2.toggleDropdown(e3);
        } } }, [n2("div", { ref: "selectedOptions", staticClass: "vs__selected-options" }, [t2._l(t2.selectedValue, function(e3) {
          return t2._t("selected-option-container", [n2("span", { key: t2.getOptionKey(e3), staticClass: "vs__selected" }, [t2._t("selected-option", [t2._v("\n            " + t2._s(t2.getOptionLabel(e3)) + "\n          ")], null, t2.normalizeOptionForSlot(e3)), t2._v(" "), t2.multiple ? n2("button", { ref: "deselectButtons", refInFor: true, staticClass: "vs__deselect", attrs: { disabled: t2.disabled, type: "button", title: "Deselect " + t2.getOptionLabel(e3), "aria-label": "Deselect " + t2.getOptionLabel(e3) }, on: { click: function(n3) {
            return t2.deselect(e3);
          } } }, [n2(t2.childComponents.Deselect, { tag: "component" })], 1) : t2._e()], 2)], { option: t2.normalizeOptionForSlot(e3), deselect: t2.deselect, multiple: t2.multiple, disabled: t2.disabled });
        }), t2._v(" "), t2._t("search", [n2("input", t2._g(t2._b({ staticClass: "vs__search" }, "input", t2.scope.search.attributes, false), t2.scope.search.events))], null, t2.scope.search)], 2), t2._v(" "), n2("div", { ref: "actions", staticClass: "vs__actions" }, [n2("button", { directives: [{ name: "show", rawName: "v-show", value: t2.showClearButton, expression: "showClearButton" }], ref: "clearButton", staticClass: "vs__clear", attrs: { disabled: t2.disabled, type: "button", title: "Clear Selected", "aria-label": "Clear Selected" }, on: { click: t2.clearSelection } }, [n2(t2.childComponents.Deselect, { tag: "component" })], 1), t2._v(" "), t2._t("open-indicator", [t2.noDrop ? t2._e() : n2(t2.childComponents.OpenIndicator, t2._b({ tag: "component" }, "component", t2.scope.openIndicator.attributes, false))], null, t2.scope.openIndicator), t2._v(" "), t2._t("spinner", [n2("div", { directives: [{ name: "show", rawName: "v-show", value: t2.mutableLoading, expression: "mutableLoading" }], staticClass: "vs__spinner" }, [t2._v("Loading...")])], null, t2.scope.spinner)], 2)]), t2._v(" "), n2("transition", { attrs: { name: t2.transition } }, [t2.dropdownOpen ? n2("ul", { directives: [{ name: "append-to-body", rawName: "v-append-to-body" }], key: "vs" + t2.uid + "__listbox", ref: "dropdownMenu", staticClass: "vs__dropdown-menu", attrs: { id: "vs" + t2.uid + "__listbox", role: "listbox", tabindex: "-1" }, on: { mousedown: function(e3) {
          return e3.preventDefault(), t2.onMousedown(e3);
        }, mouseup: t2.onMouseUp } }, [t2._t("list-header", null, null, t2.scope.listHeader), t2._v(" "), t2._l(t2.filteredOptions, function(e3, o2) {
          return n2("li", { key: t2.getOptionKey(e3), staticClass: "vs__dropdown-option", class: { "vs__dropdown-option--selected": t2.isOptionSelected(e3), "vs__dropdown-option--highlight": o2 === t2.typeAheadPointer, "vs__dropdown-option--disabled": !t2.selectable(e3) }, attrs: { role: "option", id: "vs" + t2.uid + "__option-" + o2, "aria-selected": o2 === t2.typeAheadPointer || null }, on: { mouseover: function(n3) {
            t2.selectable(e3) && (t2.typeAheadPointer = o2);
          }, mousedown: function(n3) {
            n3.preventDefault(), n3.stopPropagation(), t2.selectable(e3) && t2.select(e3);
          } } }, [t2._t("option", [t2._v("\n          " + t2._s(t2.getOptionLabel(e3)) + "\n        ")], null, t2.normalizeOptionForSlot(e3))], 2);
        }), t2._v(" "), 0 === t2.filteredOptions.length ? n2("li", { staticClass: "vs__no-options" }, [t2._t("no-options", [t2._v("Sorry, no matching options.")], null, t2.scope.noOptions)], 2) : t2._e(), t2._v(" "), t2._t("list-footer", null, null, t2.scope.listFooter)], 2) : n2("ul", { staticStyle: { display: "none", visibility: "hidden" }, attrs: { id: "vs" + t2.uid + "__listbox", role: "listbox" } })]), t2._v(" "), t2._t("footer", null, null, t2.scope.footer)], 2);
      }, [], false, null, null, null).exports), w2 = { ajax: p, pointer: u, pointerScroll: c };
      n.d(e, "VueSelect", function() {
        return O;
      }), n.d(e, "mixins", function() {
        return w2;
      });
      e.default = O;
    }]);
  });
})(vueSelect$1);
var VSelect = /* @__PURE__ */ getDefaultExportFromCjs(vueSelect$1.exports);
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== "[object Window]") {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}
function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}
function applyStyles(_ref2) {
  var state = _ref2.state;
  Object.keys(state.elements).forEach(function(name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function(name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function(style2, property) {
        style2[property] = "";
        return style2;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
var max = Math.max;
var min = Math.min;
var round = Math.round;
function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function(item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }
  return navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref2 = isElement(element) ? getWindow(element) : window, visualViewport = _ref2.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width,
    height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x,
    y
  };
}
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width,
    height
  };
}
function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      }
      next = next.parentNode || next.host;
    } while (next);
  }
  return false;
}
function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}
function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css2 = getComputedStyle(currentNode);
    if (css2.transform !== "none" || css2.perspective !== "none" || css2.contain === "paint" || ["transform", "perspective"].indexOf(css2.willChange) !== -1 || isFirefox && css2.willChange === "filter" || isFirefox && css2.filter && css2.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min2, value, max2) {
  var v = within(min2, value, max2);
  return v > max2 ? max2 : v;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys2) {
  return keys2.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
var toPaddingObject = function toPaddingObject2(padding, state) {
  padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref2) {
  var _state$modifiersData$;
  var state = _ref2.state, name = _ref2.name, options = _ref2.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state, options = _ref2.options;
  var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
var arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(placement) {
  return placement.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref2) {
  var x = _ref2.x, y = _ref2.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);
      if (getComputedStyle(offsetParent).position !== "static" && position === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};
function effect(_ref2) {
  var state = _ref2.state, instance = _ref2.instance, options = _ref2.options;
  var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$1[matched];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash[matched];
  });
}
function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x + getWindowScrollBarX(element),
    y
  };
}
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle(body || html).direction === "rtl") {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === "fixed");
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function computeOffsets(_ref2) {
  var reference2 = _ref2.reference, element = _ref2.element, placement = _ref2.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a, b) {
    return overflows[a] - overflows[b];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref2) {
  var state = _ref2.state, options = _ref2.options, name = _ref2.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i = 0; i < placements2.length; i++) {
    var placement = placements2[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check2) {
      return check2;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check2) {
            return check2;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break")
        break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
var flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref2) {
  var state = _ref2.state, name = _ref2.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
var hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref2 = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref2[0], distance = _ref2[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state, options = _ref2.options, name = _ref2.name;
  var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
}
var offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(_ref2) {
  var state = _ref2.state, name = _ref2.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
var popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref2) {
  var state = _ref2.state, options = _ref2.options, name = _ref2.name;
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min$1 = offset2 + overflow[mainSide];
    var max$1 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset2, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
}
var preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function order(modifiers) {
  var map = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce$1(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve2) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve2(fn2());
        });
      });
    }
    return pending;
  };
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name,
              instance
            }) || state;
          }
        }
      },
      update: debounce$1(function() {
        return new Promise(function(resolve2) {
          instance.forceUpdate();
          resolve2(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      return instance;
    }
    instance.setOptions(options).then(function(state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref3) {
        var name = _ref3.name, _ref3$options = _ref3.options, options2 = _ref3$options === void 0 ? {} : _ref3$options, effect2 = _ref3.effect;
        if (typeof effect2 === "function") {
          var cleanupFn = effect2({
            state,
            name,
            instance,
            options: options2
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
var render$26 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "base-chip", class: ["base-chip--" + _vm.size, "base-chip--" + _vm.variant] }, [_c("div", { staticClass: "base-chip__inner" }, [_vm._t("default")], 2), _vm.showReset ? _c("button", { staticClass: "base-chip__reset", attrs: { "type": "button" }, on: { "click": function($event) {
    return _vm.$emit("reset");
  } } }, [_c("BaseIcon", { staticClass: "base-chip__reset-icon", attrs: { "icon": "close" } })], 1) : _vm._e()]);
};
var staticRenderFns$W = [];
var BaseChip_vue_vue_type_style_index_0_scoped_true_lang = "";
const Sizes$6 = Object.freeze({
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
});
const Variants$4 = Object.freeze({
  STANDARD: "standard",
  RAISED: "raised",
  FILLED: "filled"
});
const __vue2_script$W = {
  components: { BaseIcon },
  props: {
    showReset: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Sizes$6.MEDIUM,
      validator: (value) => Object.values(Sizes$6).includes(value)
    },
    variant: {
      type: String,
      default: Variants$4.STANDARD,
      validator: (value) => Object.values(Variants$4).includes(value)
    }
  }
};
const __cssModules$W = {};
var __component__$W = /* @__PURE__ */ normalizeComponent(
  __vue2_script$W,
  render$26,
  staticRenderFns$W,
  false,
  __vue2_injectStyles$W,
  "a999022e",
  null,
  null
);
function __vue2_injectStyles$W(context) {
  for (let o in __cssModules$W) {
    this[o] = __cssModules$W[o];
  }
}
var BaseChip = /* @__PURE__ */ function() {
  return __component__$W.exports;
}();
var vueSelect = "";
var render$25 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("FormField", { staticClass: "select-input", class: [
    "select-input--" + _vm.size,
    {
      "select-input--invalid": _vm.invalid || _vm.error,
      "select-input--disabled": _vm.disabled
    }
  ], attrs: { "id": _vm.id, "size": _vm.size, "label": _vm.label, "error": _vm.error, "invalid": _vm.invalid, "disabled": _vm.disabled } }, [_c("VSelect", _vm._b({ attrs: { "options": _vm.mappedOptions, "append-to-body": "", "calculate-position": _vm.withPopper }, on: { "input": _vm.handleInput, "search": function(search2) {
    return _vm.$emit("search", search2);
  } }, scopedSlots: _vm._u([{ key: "selected-option-container", fn: function(ref2) {
    var deselect = ref2.deselect;
    var option = ref2.option;
    return [_vm.multiple ? _c("BaseChip", { staticClass: "select-input__selected", attrs: { "variant": _vm.$options.ChipVariants.FILLED, "show-reset": "" }, on: { "reset": function($event) {
      return deselect(option);
    } } }, [_vm._v(" " + _vm._s(option.label) + " ")]) : _c("div", { staticClass: "select-input__selected" }, [_vm._v(" " + _vm._s(option.label) + " ")])];
  } }, { key: "option", fn: function(option) {
    return [_vm._t("item", [_c("div", { staticClass: "select-input__option", class: { "select-input__callout": option.callout } }, [option.icon ? _c("BaseIcon", { staticClass: "select-input__icon", attrs: { "icon": option.icon } }) : _vm._e(), _vm._v(" " + _vm._s(option.label) + " ")], 1)], null, option)];
  } }, _vm.$slots.empty ? { key: "no-options", fn: function() {
    return [_vm._t("empty")];
  }, proxy: true } : null], null, true) }, "VSelect", _vm.passDownProps, false))], 1);
};
var staticRenderFns$V = [];
var SelectInput_vue_vue_type_style_index_0_scoped_true_lang = "";
const components$1 = {
  Deselect: {
    render: () => h(BaseIcon, { props: { icon: Icons$1.CLOSE } })
  },
  OpenIndicator: {
    render: () => h(BaseIcon, { props: { icon: Icons$1.CARET_DOWN } })
  }
};
const __vue2_script$V = defineComponent({
  ChipVariants: Variants$4,
  components: { BaseChip, FormField, VSelect, BaseIcon },
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: shortid.generate
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    showReset: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => Object.values(Form.Sizes).includes(value)
    },
    value: {
      type: [String, Array],
      default: null
    }
  },
  computed: {
    mappedOptions() {
      return mapOptions(this.options);
    },
    mappedValue() {
      return this.multiple ? (this.value || []).map(
        (val) => this.mappedOptions.find(({ value }) => value === val)
      ) : this.mappedOptions.find(({ value }) => value === this.value);
    },
    passDownProps() {
      return {
        ...this.$attrs,
        clearable: this.showReset,
        components: components$1,
        disabled: this.disabled,
        multiple: this.multiple,
        options: this.mappedOptions,
        value: this.mappedValue
      };
    }
  },
  methods: {
    handleInput(e) {
      let val = "";
      if (this.multiple) {
        val = e.map(({ value }) => value);
      } else if (e && e.value) {
        val = e.value;
      }
      this.$emit("input", val);
    },
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width;
      const popper2 = createPopper(component.$refs.toggle, dropdownList, {
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 16]
            }
          }
        ]
      });
      return () => popper2.destroy();
    }
  }
});
const __cssModules$V = {};
var __component__$V = /* @__PURE__ */ normalizeComponent(
  __vue2_script$V,
  render$25,
  staticRenderFns$V,
  false,
  __vue2_injectStyles$V,
  "a694195e",
  null,
  null
);
function __vue2_injectStyles$V(context) {
  for (let o in __cssModules$V) {
    this[o] = __cssModules$V[o];
  }
}
var SelectInput = /* @__PURE__ */ function() {
  return __component__$V.exports;
}();
var render$24 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("FormField", { staticClass: "textarea-input", class: [
    "textarea-input--" + _vm.size,
    {
      "textarea-input--invalid": _vm.invalid || _vm.error,
      "textarea-input--disabled": _vm.disabled
    }
  ], attrs: { "id": _vm.id, "size": _vm.size, "label": _vm.label, "error": _vm.error, "invalid": _vm.invalid, "disabled": _vm.disabled } }, [_c("textarea", _vm._b({ ref: "input", staticClass: "textarea-input__field", attrs: { "id": _vm.id, "aria-invalid": _vm.invalid, "aria-describedby": _vm.error ? _vm.id + "-error" : false, "disabled": _vm.disabled }, domProps: { "value": _vm.value }, on: { "input": _vm.handleInput } }, "textarea", _vm.$attrs, false))]);
};
var staticRenderFns$U = [];
var TextareaInput_vue_vue_type_style_index_0_scoped_true_lang = "";
const { Sizes: Sizes$5 } = Form;
const __vue2_script$U = defineComponent({
  name: "TextareaInput",
  components: {
    FormField
  },
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: shortid.generate
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: Sizes$5.NORMAL,
      validator: (value) => Object.values(Sizes$5).includes(value)
    },
    value: {
      type: String,
      default: ""
    }
  },
  setup(_, { emit }) {
    const handleInput = (event) => {
      const { value } = event.target;
      emit("input", value);
    };
    return {
      handleInput
    };
  }
});
const __cssModules$U = {};
var __component__$U = /* @__PURE__ */ normalizeComponent(
  __vue2_script$U,
  render$24,
  staticRenderFns$U,
  false,
  __vue2_injectStyles$U,
  "4e7d01e4",
  null,
  null
);
function __vue2_injectStyles$U(context) {
  for (let o in __cssModules$U) {
    this[o] = __cssModules$U[o];
  }
}
var TextareaInput = /* @__PURE__ */ function() {
  return __component__$U.exports;
}();
var render$23 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.renderedComponent, _vm._g(_vm._b({ tag: "component", attrs: { "type": _vm.type } }, "component", _vm.$attrs, false), _vm.$listeners));
};
var staticRenderFns$T = [];
const InputTypes = Object.freeze({
  BUTTON: "button",
  SUBMIT: "submit",
  RESET: "reset",
  CHECKBOX: "checkbox",
  DATE: "date",
  NUMBER: "number",
  PASSWORD: "password",
  RADIO: "radio",
  SELECT: "select",
  TEL: "tel",
  TEXTAREA: "textarea"
});
const getRenderedComponent = ({ type, component, attrs }) => {
  if (component) {
    return component;
  }
  switch (type) {
    case InputTypes.BUTTON:
    case InputTypes.SUBMIT:
    case InputTypes.RESET:
      return BaseButton;
    case InputTypes.CHECKBOX:
      return attrs.options ? CheckboxGroup : CheckboxInput;
    case InputTypes.DATE:
      return DateInput;
    case InputTypes.NUMBER:
      return NumberInput;
    case InputTypes.PASSWORD:
      return PasswordInput;
    case InputTypes.RADIO:
      return RadioGroup;
    case InputTypes.SELECT:
      return SelectInput;
    case InputTypes.TEL:
      return PhoneInput;
    case InputTypes.TEXTAREA:
      return TextareaInput;
    default:
      return TextInput;
  }
};
const __vue2_script$T = defineComponent({
  props: {
    type: {
      type: String,
      default: "text"
    },
    component: {
      type: Object,
      default: null
    }
  },
  setup: ({ type, component }, { attrs }) => ({
    renderedComponent: computed(
      () => getRenderedComponent({ type, component, attrs })
    )
  })
});
const __cssModules$T = {};
var __component__$T = /* @__PURE__ */ normalizeComponent(
  __vue2_script$T,
  render$23,
  staticRenderFns$T,
  false,
  __vue2_injectStyles$T,
  null,
  null,
  null
);
function __vue2_injectStyles$T(context) {
  for (let o in __cssModules$T) {
    this[o] = __cssModules$T[o];
  }
}
var BaseFormField = /* @__PURE__ */ function() {
  return __component__$T.exports;
}();
var render$22 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("form", { staticClass: "base-form", on: { "submit": function($event) {
    $event.preventDefault();
    return _vm.handleSubmit($event);
  } } }, [!!_vm.$slots.header ? _c("header", { staticClass: "base-form__header" }, [_vm._t("header", null, null, { handleSubmit: _vm.handleSubmit, touched: _vm.touched, values: _vm.values })], 2) : _vm._e(), _vm._l(_vm.fields, function(field) {
    return _c("BaseFormField", _vm._b({ key: field.name || field.id, attrs: { "error": _vm.errors[field.name], "value": _vm.values[field.name] }, on: { "input": function($event) {
      return _vm.handleInput(field.name, $event);
    } } }, "BaseFormField", field, false));
  }), !!_vm.$slots.footer ? _c("footer", { staticClass: "base-form__footer" }, [_vm._t("footer", null, null, { handleSubmit: _vm.handleSubmit, touched: _vm.touched, values: _vm.values })], 2) : _vm._e()], 2);
};
var staticRenderFns$S = [];
var BaseForm_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$S = {
  components: { BaseFormField },
  props: {
    errors: {
      type: Object,
      default: () => ({})
    },
    fields: {
      type: Array,
      default: () => []
    },
    initialValues: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      touched: /* @__PURE__ */ new Set(),
      values: this.fields.reduce(
        (obj, { name, defaultValue }) => name ? {
          ...obj,
          [name]: this.initialValues[name] || defaultValue || void 0
        } : obj,
        {}
      )
    };
  },
  watch: {
    initialValues(newValue) {
      this.values = Object.entries(newValue).reduce(
        (obj, [key, value]) => !this.touched.has(key) ? { ...obj, [key]: value } : obj,
        { ...this.values }
      );
    }
  },
  methods: {
    handleInput(name, value) {
      this.values[name] = value;
      this.touched.add(name);
      this.$emit("input", this.values);
    },
    handleSubmit() {
      this.$emit("submit", this.values);
    }
  }
};
const __cssModules$S = {};
var __component__$S = /* @__PURE__ */ normalizeComponent(
  __vue2_script$S,
  render$22,
  staticRenderFns$S,
  false,
  __vue2_injectStyles$S,
  "20fd95da",
  null,
  null
);
function __vue2_injectStyles$S(context) {
  for (let o in __cssModules$S) {
    this[o] = __cssModules$S[o];
  }
}
var BaseForm = /* @__PURE__ */ function() {
  return __component__$S.exports;
}();
var render$21 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tag, _vm._g(_vm._b({ tag: "component", staticClass: "base-card", class: [{ "base-card--full-bleed": _vm.fullBleed }] }, "component", _vm.$attrs, false), _vm.$listeners), [_vm.$slots.header ? [_c("header", { staticClass: "base-card__header" }, [_vm._t("header")], 2)] : _vm._e(), _c("section", { staticClass: "base-card__content" }, [_vm._t("default")], 2), _vm.$slots.footer ? [_c("footer", { staticClass: "base-card__footer" }, [_vm._t("footer")], 2)] : _vm._e()], 2);
};
var staticRenderFns$R = [];
var BaseCard_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$R = {
  props: {
    fullBleed: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: "article"
    }
  }
};
const __cssModules$R = {};
var __component__$R = /* @__PURE__ */ normalizeComponent(
  __vue2_script$R,
  render$21,
  staticRenderFns$R,
  false,
  __vue2_injectStyles$R,
  "3beb62a1",
  null,
  null
);
function __vue2_injectStyles$R(context) {
  for (let o in __cssModules$R) {
    this[o] = __cssModules$R[o];
  }
}
var BaseCard = /* @__PURE__ */ function() {
  return __component__$R.exports;
}();
var render$20 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", _vm._g(_vm._b({ staticClass: "base-divider", class: {
    "base-divider--dashed": _vm.dashed,
    "base-divider--solid": !_vm.dashed,
    "base-divider--horizontal": !_vm.vertical,
    "base-divider--vertical": _vm.vertical,
    "base-divider--dark": _vm.dark,
    "base-divider--large": _vm.size === "large"
  }, attrs: { "role": "separator" } }, "div", _vm.$attrs, false), _vm.$listeners), [_vm.label ? _c("div", { staticClass: "base-divider__label" }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]);
};
var staticRenderFns$Q = [];
var BaseDivider_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$Q = {
  props: {
    dashed: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    vertical: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "small"
    }
  }
};
const __cssModules$Q = {};
var __component__$Q = /* @__PURE__ */ normalizeComponent(
  __vue2_script$Q,
  render$20,
  staticRenderFns$Q,
  false,
  __vue2_injectStyles$Q,
  "f5ca6fc6",
  null,
  null
);
function __vue2_injectStyles$Q(context) {
  for (let o in __cssModules$Q) {
    this[o] = __cssModules$Q[o];
  }
}
var BaseDivider = /* @__PURE__ */ function() {
  return __component__$Q.exports;
}();
var render$1$ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tag, _vm._g(_vm._b({ tag: "component", class: _vm.classList }, "component", _vm.$attrs, false), _vm.$listeners), [_vm._t("default", [_vm._v(" " + _vm._s(_vm.label) + " ")])], 2);
};
var staticRenderFns$P = [];
var BaseLink_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$P = defineComponent({
  name: "BaseLink",
  props: {
    label: {
      type: String,
      default: ""
    },
    tag: {
      type: String,
      default: "button"
    },
    variant: {
      type: String,
      default: "primary"
    }
  },
  setup(props2) {
    const baseClass2 = "base-link";
    const classList2 = computed(() => [
      baseClass2,
      `${baseClass2}--${props2.variant}`
    ]);
    return {
      classList: classList2
    };
  }
});
const __cssModules$P = {};
var __component__$P = /* @__PURE__ */ normalizeComponent(
  __vue2_script$P,
  render$1$,
  staticRenderFns$P,
  false,
  __vue2_injectStyles$P,
  "3dc707ee",
  null,
  null
);
function __vue2_injectStyles$P(context) {
  for (let o in __cssModules$P) {
    this[o] = __cssModules$P[o];
  }
}
var BaseLink = /* @__PURE__ */ function() {
  return __component__$P.exports;
}();
var render$1_ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("table", { staticClass: "base-table", class: {
    "base-table--striped": _vm.striped
  } }, [!!_vm.$slots.header ? _c("thead", { staticClass: "base-table__header" }, [_vm._t("header")], 2) : _vm._e(), _c("tbody", { staticClass: "base-table__body" }, [_vm._t("default")], 2), !!_vm.$slots.footer ? _c("tfoot", { staticClass: "base-table__footer" }, [_vm._t("footer")], 2) : _vm._e()]);
};
var staticRenderFns$O = [];
var BaseTable_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$O = defineComponent({
  props: {
    striped: {
      type: Boolean,
      default: false
    }
  }
});
const __cssModules$O = {};
var __component__$O = /* @__PURE__ */ normalizeComponent(
  __vue2_script$O,
  render$1_,
  staticRenderFns$O,
  false,
  __vue2_injectStyles$O,
  "122ed4a6",
  null,
  null
);
function __vue2_injectStyles$O(context) {
  for (let o in __cssModules$O) {
    this[o] = __cssModules$O[o];
  }
}
var BaseTable = /* @__PURE__ */ function() {
  return __component__$O.exports;
}();
var render$1Z = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "base-tag", class: ["base-tag--" + _vm.color, "base-tag--" + _vm.size, _vm.classes] }, [_vm._t("default", [_vm._v(" " + _vm._s(_vm.label) + " ")]), _vm.closable ? _c("span", { staticClass: "\n      base-tag__close-button\n      rounded-full\n      border-none\n      cursor-pointer\n      flex\n    ", on: { "click": function($event) {
    return _vm.$emit("close");
  } } }, [_c("BaseIcon", { attrs: { "icon": _vm.icon } })], 1) : _vm._e()], 2);
};
var staticRenderFns$N = [];
var BaseTag_vue_vue_type_style_index_0_scoped_true_lang = "";
const Sizes$4 = Object.freeze({
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
});
const colors = ["black", "gray", ...Object.keys(extendedPalette)];
const __vue2_script$N = {
  components: {
    BaseIcon
  },
  props: {
    color: {
      type: String,
      default: colors[0],
      validator: (value) => colors.includes(value)
    },
    outline: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Sizes$4.MEDIUM,
      validator: (value) => Object.values(Sizes$4).includes(value)
    },
    label: {
      type: String,
      default: ""
    },
    closable: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: "close"
    }
  },
  setup(props2) {
    const classes = computed(() => [
      { "base-tag--outline": props2.outline },
      { "base-tag--light base-tag--filled": props2.light },
      { "base-tag--filled": !props2.outline && !props2.light },
      { "base-tag--closable": props2.closable }
    ]);
    return { classes };
  }
};
const __cssModules$N = {};
var __component__$N = /* @__PURE__ */ normalizeComponent(
  __vue2_script$N,
  render$1Z,
  staticRenderFns$N,
  false,
  __vue2_injectStyles$N,
  "bb2e3f9a",
  null,
  null
);
function __vue2_injectStyles$N(context) {
  for (let o in __cssModules$N) {
    this[o] = __cssModules$N[o];
  }
}
var BaseTag = /* @__PURE__ */ function() {
  return __component__$N.exports;
}();
var render$1Y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tag, _vm._g(_vm._b({ tag: "component", staticClass: "type-overline", class: ["type-overline-" + _vm.variant] }, "component", _vm.$attrs, false), _vm.$listeners), [_vm._t("default")], 2);
};
var staticRenderFns$M = [];
var TypeOverline_vue_vue_type_style_index_0_lang = "";
const { Overline } = Typography;
const __vue2_script$M = {
  props: {
    tag: {
      type: String,
      default: "span"
    },
    variant: {
      type: String,
      default: Typography.Overline.X_TINY,
      validator: (value) => Object.values(Overline).includes(value)
    }
  }
};
const __cssModules$M = {};
var __component__$M = /* @__PURE__ */ normalizeComponent(
  __vue2_script$M,
  render$1Y,
  staticRenderFns$M,
  false,
  __vue2_injectStyles$M,
  null,
  null,
  null
);
function __vue2_injectStyles$M(context) {
  for (let o in __cssModules$M) {
    this[o] = __cssModules$M[o];
  }
}
var TypeOverline = /* @__PURE__ */ function() {
  return __component__$M.exports;
}();
var render$1X = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ul", { staticClass: "progress-stepper", class: { "progress-stepper--labeled": _vm.showLabels } }, _vm._l(_vm.mappedSteps, function(step, i) {
    return _c("li", { key: step.value, staticClass: "progress-stepper__step", class: "progress-stepper__step--" + step.state }, [_c("button", { staticClass: "progress-stepper__step-indicator", class: { "cursor-pointer": _vm.stepsClickable }, attrs: { "type": "button", "title": step.label, "disabled": !_vm.stepsClickable }, on: { "click": function($event) {
      return _vm.$emit("input", step.value);
    } } }, [step.state === _vm.states.COMPLETE ? _c("BaseIcon", { attrs: { "icon": _vm.check } }) : _c("span", { staticClass: "progress-stepper__step-ordinal" }, [_vm._v(_vm._s(i + 1))])], 1), _c("TypeOverline", { staticClass: "progress-stepper__step-label", attrs: { "variant": "x-small" } }, [_vm._v(" " + _vm._s(step.label) + " ")])], 1);
  }), 0);
};
var staticRenderFns$L = [];
var ProgressStepper_vue_vue_type_style_index_0_scoped_true_lang = "";
const ProgressStates = Object.freeze({
  COMPLETE: "complete",
  CURRENT: "current",
  UPCOMING: "upcoming"
});
const __vue2_script$L = {
  components: {
    BaseIcon,
    TypeOverline
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    showLabels: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ""
    },
    stepsClickable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    check() {
      return Icons$1.CHECK;
    },
    mappedSteps() {
      const steps = mapOptions(this.options);
      const currentStepIndex2 = steps.findIndex(
        ({ value }) => value === this.value
      );
      return steps.map((step, i) => {
        let state = ProgressStates.UPCOMING;
        if (i === currentStepIndex2) {
          state = ProgressStates.CURRENT;
        }
        if (i < currentStepIndex2) {
          state = ProgressStates.COMPLETE;
        }
        return {
          ...step,
          state
        };
      });
    },
    states() {
      return ProgressStates;
    }
  }
};
const __cssModules$L = {};
var __component__$L = /* @__PURE__ */ normalizeComponent(
  __vue2_script$L,
  render$1X,
  staticRenderFns$L,
  false,
  __vue2_injectStyles$L,
  "53e86832",
  null,
  null
);
function __vue2_injectStyles$L(context) {
  for (let o in __cssModules$L) {
    this[o] = __cssModules$L[o];
  }
}
var ProgressStepper = /* @__PURE__ */ function() {
  return __component__$L.exports;
}();
var render$1W = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { class: ["progress-bar"].concat(_vm.classes) }, [_c("div", { staticClass: "progress-bar__inner", style: { width: _vm.percentComplete + "%" } })]);
};
var staticRenderFns$K = [];
var ProgressBar_vue_vue_type_style_index_0_scoped_true_lang = "";
const { Sizes: Sizes$3, Variants: Variants$3 } = ProgressBar$1;
const __vue2_script$K = {
  props: {
    animated: {
      type: Boolean,
      default: true
    },
    percentComplete: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: ProgressBar$1.Sizes.SMALL,
      validator: (value) => Object.values(Sizes$3).includes(value)
    },
    variant: {
      type: String,
      default: ProgressBar$1.Variants.PRIMARY,
      validator: (value) => Object.values(Variants$3).includes(value)
    }
  },
  setup(props2) {
    const classes = computed(() => [
      `progress-bar--${props2.variant}`,
      `progress-bar--${props2.size}`,
      props2.animated && "progress-bar--animated"
    ]);
    return {
      classes
    };
  }
};
const __cssModules$K = {};
var __component__$K = /* @__PURE__ */ normalizeComponent(
  __vue2_script$K,
  render$1W,
  staticRenderFns$K,
  false,
  __vue2_injectStyles$K,
  "7f5f5b04",
  null,
  null
);
function __vue2_injectStyles$K(context) {
  for (let o in __cssModules$K) {
    this[o] = __cssModules$K[o];
  }
}
var ProgressBar = /* @__PURE__ */ function() {
  return __component__$K.exports;
}();
const BaseWizardEmits = ["next", "previous", "complete"];
const BaseWizardLayouts = Object.freeze({
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical"
});
const installCompositionAPI = () => {
  Vue.use(VueCompositionApi);
};
installCompositionAPI();
const DIRECTION = Object.freeze({
  PREVIOUS: "previous",
  NEXT: "next"
});
const currentDirection = ref(DIRECTION.NEXT);
const useWizardActions = (steps, currentStep2, emit, hasProgressOrder2) => {
  const handlePrevious = () => {
    const previous = steps[steps.indexOf(currentStep2.value) - 1];
    if (!hasProgressOrder2.value) {
      currentDirection.value = DIRECTION.PREVIOUS;
    }
    emit("previous", previous, currentStep2.value);
  };
  const handleNext = () => {
    const next = steps[steps.indexOf(currentStep2.value) + 1];
    if (!hasProgressOrder2.value) {
      currentDirection.value = DIRECTION.NEXT;
    }
    emit("next", next, currentStep2.value);
  };
  const handleComplete = () => {
    emit("complete");
  };
  return {
    handlePrevious,
    handleNext,
    handleComplete,
    currentDirection
  };
};
const getProgressStepperOptions = (steps, hasLabels2) => {
  const hasCorrectObjectShape = steps.every(
    (s) => Object.keys(s).includes("label")
  );
  if (hasCorrectObjectShape) {
    hasLabels2.value = true;
    return {
      hasLabels: hasLabels2,
      stepperOptions: steps.map(({ label }, i) => ({
        label,
        value: `${i}`
      }))
    };
  }
  const hasAllStrings = steps.every((step) => typeof step === "string");
  if (hasAllStrings) {
    hasLabels2.value = true;
    return {
      hasLabels: hasLabels2,
      stepperOptions: steps.map((step, i) => ({ label: step, value: `${i}` }))
    };
  }
  return {
    hasLabels: hasLabels2,
    stepperOptions: [...Array(steps.length).keys()].map((i) => `${i}`)
  };
};
installCompositionAPI();
const props = ref();
const isLoading = computed(() => props.value.isLoading);
const isFirstStep = computed(() => props.value.isFirstStep);
const isLastStep = computed(() => props.value.isLastStep);
const fullScreen = computed(() => props.value.fullScreen);
const showFooter = computed(() => props.value.showFooter);
const showProgress = computed(() => props.value.showProgress);
const title = computed(() => props.value.title);
const isComplete = computed(() => props.value.isComplete);
const compact = computed(() => props.value.compact);
const currentLayout = computed(() => props.value.layout);
const mainContent = ref(null);
const currentStep = computed(() => props.value.currentStep);
const hasLabels = ref(false);
const buttonSize = computed(() => props.value.compact ? "medium" : "large");
const hasProgressOrder = computed(
  () => props.value.steps.every(
    (step) => step.progressOrder && !isNaN(step.progressOrder - 0)
  )
);
const parentSteps = computed(
  () => props.value.steps.filter((step) => !step.parentId)
);
const totalProgressSteps = computed(() => props.value.steps.length);
const currentStepIndex = computed(
  () => props.value.steps.indexOf(currentStep.value)
);
const progressOptions = computed(
  () => getProgressStepperOptions(parentSteps.value, hasLabels)
);
const progressStepperOptions = computed(
  () => progressOptions.value.stepperOptions
);
const currentProgressStep = computed(
  () => `${parentSteps.value.findIndex(
    (step) => step.id === (currentStep.value.parentId || currentStep.value.id)
  )}`
);
const percentComplete = computed(
  () => props.value.isComplete ? 100 : currentStepIndex.value / props.value.steps.length * 100
);
const showIteration = computed(() => props.value.showIteration);
const checkSubComplete = (navItemId) => {
  const allSubComplete = props.value.steps.filter((item) => item.parentId === navItemId).every((item) => item.completed);
  return allSubComplete;
};
const useWizardProps = (value) => {
  if (value) {
    props.value = value;
  }
  return {
    hasProgressOrder,
    steps: props.value.steps,
    buttonSize,
    checkSubComplete,
    currentStep,
    totalProgressSteps,
    currentLayout,
    mainContent,
    currentStepIndex,
    progressOptions,
    currentProgressStep,
    percentComplete,
    hasLabels,
    progressStepperOptions,
    isLoading,
    isFirstStep,
    isLastStep,
    fullScreen,
    showFooter,
    showProgress,
    title,
    isComplete,
    compact,
    showIteration
  };
};
var render$1V = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "horizontal-layout", class: {
    "horizontal-layout--fullscreen": _vm.fullScreen
  } }, [_vm.fullScreen ? _c("header", { staticClass: "horizontal-layout__header" }, [_vm._t("title", [_vm._v(" " + _vm._s(_vm.title) + " ")]), _vm.showProgress ? _c("div", { staticClass: "horizontal-layout__progress-container" }, [_vm.compact ? _c("div", { staticClass: "horizontal-layout__progress-steps" }, [_vm._v(" " + _vm._s(_vm.currentStepIndex + 1) + "/" + _vm._s(_vm.totalProgressSteps) + " ")]) : _vm._e(), _vm.compact ? _c("ProgressBar", { staticClass: "horizontal-layout__progress-bar", attrs: { "size": "small", "variant": _vm.isComplete ? "secondary" : "primary", "percent-complete": _vm.percentComplete } }) : !_vm.compact && !_vm.isComplete ? _c("ProgressStepper", { attrs: { "options": _vm.progressStepperOptions, "show-labels": _vm.hasLabels, "value": _vm.currentProgressStep } }) : _vm._e()], 1) : _vm._e()], 2) : _vm._e(), _vm._t("default"), _vm.showFooter || _vm.$slots.footer ? _c("footer", { staticClass: "horizontal-layout__footer", class: {
    "horizontal-layout__footer--compact": _vm.compact,
    "horizontal-layout__footer--not-compact": !_vm.compact
  } }, [_vm._t("footer", [!_vm.isComplete ? _c("div", { staticClass: "horizontal-layout__actions" }, [!_vm.isFirstStep ? _c("BaseButton", { attrs: { "id": "horizontal-layout__prev-button", "size": _vm.buttonSize, "pre-icon": "arrowLeft" }, on: { "click": _vm.handlePrevious } }, [_vm._v(" Previous ")]) : _vm._e(), _c("div", { staticClass: "horizontal-layout__actions-complete-next-container" }, [_vm.isLastStep ? _c("BaseButton", { attrs: { "id": "horizontal-layout__complete-button", "size": _vm.buttonSize, "variant": "secondary", "pre-icon": "check" }, on: { "click": _vm.handleComplete } }, [_vm._v(" Complete ")]) : _c("BaseButton", { attrs: { "id": "horizontal-layout__next-button", "size": _vm.buttonSize, "post-icon": "arrowRight" }, on: { "click": _vm.handleNext } }, [_vm._v(" Next ")])], 1)], 1) : _vm._e()])], 2) : _vm._e()], 2);
};
var staticRenderFns$J = [];
var HorizontalLayout_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$J = defineComponent({
  name: "HorizontalLayout",
  components: {
    ProgressStepper,
    BaseButton,
    ProgressBar
  },
  emits: [...BaseWizardEmits],
  setup(_, { emit }) {
    const {
      currentProgressStep: currentProgressStep2,
      buttonSize: buttonSize2,
      hasLabels: hasLabels2,
      progressStepperOptions: progressStepperOptions2,
      percentComplete: percentComplete2,
      currentStepIndex: currentStepIndex2,
      steps,
      currentStep: currentStep2,
      totalProgressSteps: totalProgressSteps2,
      fullScreen: fullScreen2,
      showFooter: showFooter2,
      compact: compact2,
      isFirstStep: isFirstStep2,
      isLastStep: isLastStep2,
      isComplete: isComplete2,
      title: title2,
      showProgress: showProgress2,
      hasProgressOrder: hasProgressOrder2
    } = useWizardProps();
    const { handlePrevious, handleNext, handleComplete } = useWizardActions(
      steps,
      currentStep2,
      emit,
      hasProgressOrder2
    );
    return {
      currentProgressStep: currentProgressStep2,
      handlePrevious,
      handleNext,
      buttonSize: buttonSize2,
      hasLabels: hasLabels2,
      compact: compact2,
      handleComplete,
      progressStepperOptions: progressStepperOptions2,
      percentComplete: percentComplete2,
      currentStepIndex: currentStepIndex2,
      totalProgressSteps: totalProgressSteps2,
      fullScreen: fullScreen2,
      isFirstStep: isFirstStep2,
      isLastStep: isLastStep2,
      showFooter: showFooter2,
      isComplete: isComplete2,
      title: title2,
      showProgress: showProgress2
    };
  }
});
const __cssModules$J = {};
var __component__$J = /* @__PURE__ */ normalizeComponent(
  __vue2_script$J,
  render$1V,
  staticRenderFns$J,
  false,
  __vue2_injectStyles$J,
  "7bee22d4",
  null,
  null
);
function __vue2_injectStyles$J(context) {
  for (let o in __cssModules$J) {
    this[o] = __cssModules$J[o];
  }
}
var HorizontalLayout = /* @__PURE__ */ function() {
  return __component__$J.exports;
}();
var render$1U = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tag, _vm._g(_vm._b({ tag: "component", staticClass: "type-display", class: ["type-display-" + _vm.variant, "type-display-" + _vm.variant + "--" + _vm.weight] }, "component", _vm.$attrs, false), _vm.$listeners), [_vm._t("default")], 2);
};
var staticRenderFns$I = [];
var TypeDisplay_vue_vue_type_style_index_0_lang = "";
const { Display, Weights: Weights$3 } = Typography;
const __vue2_script$I = {
  props: {
    tag: {
      type: String,
      default: "span"
    },
    variant: {
      type: String,
      default: Typography.Display.MEDIUM,
      validator: (value) => Object.values(Display).includes(value)
    },
    weight: {
      type: String,
      default: Typography.Weights.STRONG,
      validator: (value) => [Weights$3.REGULAR, Weights$3.STRONG].includes(value)
    }
  }
};
const __cssModules$I = {};
var __component__$I = /* @__PURE__ */ normalizeComponent(
  __vue2_script$I,
  render$1U,
  staticRenderFns$I,
  false,
  __vue2_injectStyles$I,
  null,
  null,
  null
);
function __vue2_injectStyles$I(context) {
  for (let o in __cssModules$I) {
    this[o] = __cssModules$I[o];
  }
}
var TypeDisplay = /* @__PURE__ */ function() {
  return __component__$I.exports;
}();
const getStepOrSubsSteps = (currentStep2, navItems) => {
  if (currentStep2.parentId) {
    const parent = navItems.find((item) => item.id === currentStep2.parentId);
    const subSteps2 = navItems.filter((item) => item.parentId === parent.id);
    return [parent, ...subSteps2];
  }
  const subSteps = navItems.filter((item) => item.parentId === currentStep2.id);
  return [currentStep2, ...subSteps];
};
var render$1T = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tag, _vm._g(_vm._b({ tag: "component", staticClass: "type-body", class: ["type-body-" + _vm.variant, "type-body-" + _vm.variant + "--" + _vm.weight] }, "component", _vm.$attrs, false), _vm.$listeners), [_vm._t("default")], 2);
};
var staticRenderFns$H = [];
var TypeBody_vue_vue_type_style_index_0_lang = "";
const { Body, Weights: Weights$2 } = Typography;
const __vue2_script$H = {
  props: {
    tag: {
      type: String,
      default: "span"
    },
    variant: {
      type: String,
      default: Typography.Body.TEXT_X_SMALL_TIGHT,
      validator: (value) => Object.values(Body).includes(value)
    },
    weight: {
      type: String,
      default: Typography.Weights.REGULAR,
      validator: (value) => Object.values(Weights$2).includes(value)
    }
  }
};
const __cssModules$H = {};
var __component__$H = /* @__PURE__ */ normalizeComponent(
  __vue2_script$H,
  render$1T,
  staticRenderFns$H,
  false,
  __vue2_injectStyles$H,
  null,
  null,
  null
);
function __vue2_injectStyles$H(context) {
  for (let o in __cssModules$H) {
    this[o] = __cssModules$H[o];
  }
}
var TypeBody = /* @__PURE__ */ function() {
  return __component__$H.exports;
}();
var render$1S = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return !_vm.navItem.parentId ? _c("div", { staticClass: "nav-item" }, [_c("div", { staticClass: "nav-item__container", class: {
    "nav-item__container--active": _vm.active,
    "nav-item__container--no-progress": !_vm.showProgress
  } }, [_c("div", { staticClass: "nav-item__body" }, [_c("div", { staticClass: "nav-item__body-label__block", attrs: { "data-qa": "nav-item-label-block" } }, [_vm._t("icon", [_vm.icon ? _c("BaseIcon", { staticClass: "nav-item__body-label__icon", attrs: { "icon": _vm.icon, "data-qa": "nav-item-icon" } }) : _vm._e()]), _c("div", { staticClass: "flex-grow" }, [_vm.showIteration && _vm.iterationLabel && _vm.active ? _c("TypeOverline", { staticClass: "nav-item__body-label__iteration" }, [_vm._v(" " + _vm._s(_vm.iterationLabel) + " ")]) : _vm._e(), _c("TypeBody", { staticClass: "nav-item__body-label", class: { "mb-2": _vm.showProgress }, attrs: { "tag": "div", "data-qa": "nav-item-label" } }, [_vm._v(" " + _vm._s(_vm.label) + " ")]), _vm.showProgress ? _c("div", [_vm.active && !_vm.navItem.parentId ? _c("ProgressBar", { attrs: { "percent-complete": _vm.percentComplete, "variant": "secondary" } }) : _vm._e()], 1) : _vm._e()], 1)], 2)]), _c("div", { staticClass: "nav-item__icon-container" }, [_c("div", { staticClass: "nav-item__icon-inner-container", class: _vm.statusStyles, attrs: { "data-qa": "nav-item-status-icon" } }, [_c("BaseIcon", { staticClass: "nav-item__icon", class: {
    "nav-item__icon--hidden": !_vm.completed || !_vm.checkSubComplete(_vm.id)
  }, attrs: { "icon": "check" } })], 1)])])]) : _vm._e();
};
var staticRenderFns$G = [];
var NavItem_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$G = defineComponent({
  name: "NavItem",
  components: {
    BaseIcon,
    TypeOverline,
    TypeBody,
    ProgressBar
  },
  props: {
    id: {
      type: String,
      required: true
    },
    navItem: {
      type: Object,
      required: true
    },
    completed: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    percentComplete: {
      type: Number,
      default: 0
    },
    iterationLabel: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    }
  },
  setup(props2) {
    const {
      checkSubComplete: checkSubComplete2,
      currentStep: currentStep2,
      steps,
      showProgress: showProgress2,
      showIteration: showIteration2
    } = useWizardProps();
    const active = computed(
      () => props2.navItem.id === currentStep2.value.parentId || props2.navItem.id === currentStep2.value.id
    );
    const statusStyles = computed(() => {
      let styles2 = "";
      if (props2.completed && checkSubComplete2(props2.id)) {
        styles2 += "bg-secondary-default";
      }
      if (active.value && !props2.completed || !checkSubComplete2(props2.id)) {
        styles2 += "bg-base-200";
      }
      if (!props2.completed && !active.value) {
        styles2 += "bg-base-200";
      }
      return styles2;
    });
    return {
      statusStyles,
      active,
      checkSubComplete: checkSubComplete2,
      showIteration: showIteration2,
      showProgress: showProgress2
    };
  }
});
const __cssModules$G = {};
var __component__$G = /* @__PURE__ */ normalizeComponent(
  __vue2_script$G,
  render$1S,
  staticRenderFns$G,
  false,
  __vue2_injectStyles$G,
  "d3c02ea4",
  null,
  null
);
function __vue2_injectStyles$G(context) {
  for (let o in __cssModules$G) {
    this[o] = __cssModules$G[o];
  }
}
var NavItem = /* @__PURE__ */ function() {
  return __component__$G.exports;
}();
var render$1R = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("nav", { staticClass: "nav" }, [_c("div", { staticClass: "nav__content-container" }, [_vm.$slots["nav-header"] ? _c("div", [_vm._t("nav-header")], 2) : _vm._e(), _c("div", { staticClass: "nav__items-container" }, [_c("ul", { staticClass: "nav__items-list" }, [_vm.isLoading ? _vm._l(6, function(item) {
    return _c("li", { key: item, staticClass: "nav__item--loading" }, [_vm._m(0, true)]);
  }) : _vm._l(_vm.steps, function(step) {
    return _c("li", { key: step.id, staticClass: "nav__item-container" }, [!_vm.isLoading ? _c("NavItem", _vm._g(_vm._b({ attrs: { "icon": _vm.iconIsString(step.icon) ? step.icon : "", "percent-complete": _vm.percentComplete, "iteration-label": _vm.iterationLabel, "nav-item": step }, scopedSlots: _vm._u([{ key: "icon", fn: function() {
      return [!_vm.iconIsString(step.icon) ? _c("div", [_c(step.icon, { tag: "component", staticClass: "flex-shrink-0 w-5 h-5 mr-4", attrs: { "data-qa": "nav-item-icon" } })], 1) : _vm._e()];
    }, proxy: true }], null, true) }, "NavItem", step, false), _vm.$listeners)) : _vm._e()], 1);
  })], 2)]), _vm.$slots["nav-footer"] ? _c("div", { staticClass: "nav__content-container__footer" }, [_vm._t("nav-footer")], 2) : _vm._e()])]);
};
var staticRenderFns$F = [function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "nav__item-container--loading" }, [_c("div", { staticClass: "nav__item-icon--loading" }), _c("div", { staticClass: "nav__item-content--loading" })]);
}];
var Nav_vue_vue_type_style_index_0_scoped_true_lang = "";
const iconIsString = (icon2) => typeof icon2 === "string";
const __vue2_script$F = defineComponent({
  name: "Nav",
  components: {
    BaseButton,
    BaseIcon,
    TypeDisplay,
    NavItem,
    BaseLink
  },
  setup() {
    const { currentStep: currentStep2, steps, isLoading: isLoading2, showProgress: showProgress2 } = useWizardProps();
    const stepOrSubsSteps = computed(
      () => getStepOrSubsSteps(currentStep2.value, steps)
    );
    const stepsCompleted = computed(
      () => stepOrSubsSteps.value.filter((item) => item.completed)
    );
    const percentComplete2 = computed(
      () => stepsCompleted.value.length / stepOrSubsSteps.value.length * 100
    );
    const iterationLabel = computed(() => {
      if (!currentStep2.value.parentId) {
        return `1 OF ${stepOrSubsSteps.value.length}`;
      }
      const currentIndex = stepOrSubsSteps.value.findIndex(
        (item) => item.id === currentStep2.value.id
      );
      return `${currentIndex + 1} OF ${stepOrSubsSteps.value.length}`;
    });
    return {
      iconIsString,
      isLoading: isLoading2,
      iterationLabel,
      percentComplete: percentComplete2,
      showProgress: showProgress2,
      steps
    };
  }
});
const __cssModules$F = {};
var __component__$F = /* @__PURE__ */ normalizeComponent(
  __vue2_script$F,
  render$1R,
  staticRenderFns$F,
  false,
  __vue2_injectStyles$F,
  "2ff3aade",
  null,
  null
);
function __vue2_injectStyles$F(context) {
  for (let o in __cssModules$F) {
    this[o] = __cssModules$F[o];
  }
}
var Nav = /* @__PURE__ */ function() {
  return __component__$F.exports;
}();
const getAttributes = (context, options = {}) => {
  const { data, parent } = context;
  return {
    ...parent.$options._scopeId ? { [parent.$options._scopeId]: "" } : {},
    ...data.attrs,
    ...options
  };
};
var render$1Q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("button", _vm._g({ staticClass: "hamburger-button", class: ["hamburger-button--" + _vm.status], attrs: { "title": "Menu" } }, _vm.$listeners), [_c("span", { staticClass: "sr-only" }, [_vm._v("Menu")])]);
};
var staticRenderFns$E = [];
var HamburgerButton_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$E = {
  getAttributes,
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  setup(props2) {
    const status = { status: computed(() => props2.open ? "open" : "closed") };
    return status;
  }
};
const __cssModules$E = {};
var __component__$E = /* @__PURE__ */ normalizeComponent(
  __vue2_script$E,
  render$1Q,
  staticRenderFns$E,
  false,
  __vue2_injectStyles$E,
  "80e61bb2",
  null,
  null
);
function __vue2_injectStyles$E(context) {
  for (let o in __cssModules$E) {
    this[o] = __cssModules$E[o];
  }
}
var HamburgerButton = /* @__PURE__ */ function() {
  return __component__$E.exports;
}();
var render$1P = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "nav-item-mobile" }, [_c("div", { staticClass: "nav-item-mobile__container" }, [_c("div", { staticClass: "nav-item-mobile__inner-container" }, [_c("TypeBody", { attrs: { "variant": _vm.Typography.Body.TEXT, "weight": _vm.Typography.Weights.STRONG } }, [_vm._v(" " + _vm._s(_vm.label) + " ")]), _vm.showProgress ? _c("div", { staticClass: "nav-item-mobile__progress-container" }, [_c("ProgressBar", { attrs: { "percent-complete": _vm.percentComplete, "variant": "secondary" } })], 1) : _vm._e()], 1)])]);
};
var staticRenderFns$D = [];
var NavItemMobile_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$D = defineComponent({
  name: "NavItemMobile",
  components: {
    BaseIcon,
    TypeOverline,
    TypeBody,
    BaseButton,
    ProgressBar
  },
  props: {
    label: {
      type: String,
      required: true
    },
    completed: {
      type: Boolean,
      default: false
    },
    percentComplete: {
      type: Number,
      default: 0
    }
  },
  setup: () => {
    const { showProgress: showProgress2 } = useWizardProps();
    return {
      showProgress: showProgress2,
      Typography
    };
  }
});
const __cssModules$D = {};
var __component__$D = /* @__PURE__ */ normalizeComponent(
  __vue2_script$D,
  render$1P,
  staticRenderFns$D,
  false,
  __vue2_injectStyles$D,
  "4c7e5e34",
  null,
  null
);
function __vue2_injectStyles$D(context) {
  for (let o in __cssModules$D) {
    this[o] = __cssModules$D[o];
  }
}
var NavItemMobile = /* @__PURE__ */ function() {
  return __component__$D.exports;
}();
var render$1O = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("nav", { staticClass: "nav-mobile" }, [_c("div", { staticClass: "nav-mobile__container" }, [_c("div", { staticClass: "view-window nav-mobile__inner-container" }, [_c("ul", { staticClass: "nav-mobile__list", style: _vm.computedStyles }, [_vm._l(_vm.steps, function(step) {
    return _c("li", { key: step.id, staticClass: "nav-mobile__list-item" }, [!_vm.isLoading ? _c("NavItemMobile", _vm._g(_vm._b({ attrs: { "percent-complete": _vm.percentComplete, "is-open": _vm.isOpen }, on: { "toggle-menu": function($event) {
      return _vm.$emit("toggle-menu");
    } } }, "NavItemMobile", step, false), _vm.$listeners)) : _vm._e()], 1);
  })], 2), _c("HamburgerButton", { staticClass: "nav-mobile__hamburger-button", attrs: { "open": _vm.isOpen }, on: { "click": function($event) {
    return _vm.$emit("toggle-menu");
  } } })], 1)])]);
};
var staticRenderFns$C = [];
var NavMobile_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$C = defineComponent({
  name: "NavMobile",
  components: {
    BaseButton,
    BaseIcon,
    TypeDisplay,
    HamburgerButton,
    NavItemMobile
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  setup() {
    const {
      currentStep: currentStep2,
      steps,
      isLoading: isLoading2,
      showProgress: showProgress2,
      currentStepIndex: currentStepIndex2
    } = useWizardProps();
    const stepOrSubsSteps = computed(
      () => getStepOrSubsSteps(currentStep2.value, steps)
    );
    const stepsCompleted = computed(
      () => stepOrSubsSteps.value.filter((item) => item.completed)
    );
    const percentComplete2 = computed(
      () => stepsCompleted.value.length / stepOrSubsSteps.value.length * 100
    );
    const computedStyles = computed(
      () => `transform: translateY(${-6 * currentStepIndex2.value}rem);`
    );
    return {
      steps,
      isLoading: isLoading2,
      showProgress: showProgress2,
      percentComplete: percentComplete2,
      computedStyles
    };
  }
});
const __cssModules$C = {};
var __component__$C = /* @__PURE__ */ normalizeComponent(
  __vue2_script$C,
  render$1O,
  staticRenderFns$C,
  false,
  __vue2_injectStyles$C,
  "e118cc70",
  null,
  null
);
function __vue2_injectStyles$C(context) {
  for (let o in __cssModules$C) {
    this[o] = __cssModules$C[o];
  }
}
var NavMobile = /* @__PURE__ */ function() {
  return __component__$C.exports;
}();
var render$1N = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "vertical-layout" }, [_c("Nav", { staticClass: "vertical-layout__nav", class: { "vertical-layout__nav--hidden": !_vm.menuToggle }, scopedSlots: _vm._u([{ key: "nav-header", fn: function() {
    return [_vm._t("nav-header")];
  }, proxy: true }, { key: "nav-footer", fn: function() {
    return [_vm._t("nav-footer")];
  }, proxy: true }], null, true) }), _c("NavMobile", { staticClass: "vertical-layout__nav--mobile", attrs: { "is-open": _vm.menuToggle }, on: { "toggle-menu": function($event) {
    _vm.menuToggle = !_vm.menuToggle;
  } }, scopedSlots: _vm._u([{ key: "nav-header", fn: function() {
    return [_vm._t("nav-header")];
  }, proxy: true }], null, true) }), _c("header", [_vm._t("title", [_vm.title ? _c("div", { staticClass: "vertical-layout__title" }, [_vm._v(_vm._s(_vm.title))]) : _vm._e()]), _vm._t("header")], 2), _vm._t("default"), _vm.showFooter || _vm.$slots.footer ? _c("footer", { staticClass: "vertical-layout__footer" }, [_vm._t("footer", [!_vm.isComplete ? _c("div", { staticClass: "vertical-layout__actions" }, [!_vm.isFirstStep ? _c("BaseButton", { attrs: { "id": "vertical-layout__prev-button", "pre-icon": "arrowLeft" }, on: { "click": _vm.handlePrevious } }, [_vm._v(" Previous ")]) : _vm._e(), _c("div", { staticClass: "vertical-layout__actions-complete-next-container" }, [_vm.isLastStep ? _c("BaseButton", { attrs: { "id": "vertical-layout__complete-button", "variant": "secondary", "pre-icon": "check" }, on: { "click": _vm.handleComplete } }, [_vm._v(" Complete ")]) : _c("BaseButton", { attrs: { "id": "vertical-layout__next-button", "post-icon": "arrowRight" }, on: { "click": _vm.handleNext } }, [_vm._v(" Next ")])], 1)], 1) : _vm._e()])], 2) : _vm._e()], 2);
};
var staticRenderFns$B = [];
var VerticalLayout_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$B = defineComponent({
  name: "VerticalLayout",
  components: {
    Nav,
    NavMobile,
    BaseButton
  },
  emits: [...BaseWizardEmits],
  setup(_, { emit }) {
    const menuToggle = ref(false);
    const {
      steps,
      currentStep: currentStep2,
      title: title2,
      showFooter: showFooter2,
      isComplete: isComplete2,
      isFirstStep: isFirstStep2,
      isLastStep: isLastStep2,
      hasProgressOrder: hasProgressOrder2
    } = useWizardProps();
    const { handlePrevious, handleNext, handleComplete } = useWizardActions(
      steps,
      currentStep2,
      emit,
      hasProgressOrder2
    );
    return {
      menuToggle,
      handleNext,
      title: title2,
      isFirstStep: isFirstStep2,
      isComplete: isComplete2,
      handlePrevious,
      handleComplete,
      showFooter: showFooter2,
      isLastStep: isLastStep2
    };
  }
});
const __cssModules$B = {};
var __component__$B = /* @__PURE__ */ normalizeComponent(
  __vue2_script$B,
  render$1N,
  staticRenderFns$B,
  false,
  __vue2_injectStyles$B,
  "f671431e",
  null,
  null
);
function __vue2_injectStyles$B(context) {
  for (let o in __cssModules$B) {
    this[o] = __cssModules$B[o];
  }
}
var VerticalLayout = /* @__PURE__ */ function() {
  return __component__$B.exports;
}();
var isArray$8 = isArray_1, isSymbol$2 = isSymbol_1;
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$1(value, object) {
  if (isArray$8(value)) {
    return false;
  }
  var type = typeof value;
  if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol$2(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
var _isKey = isKey$1;
var baseGetTag$3 = _baseGetTag, isObject$8 = isObject_1;
var asyncTag = "[object AsyncFunction]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$2(value) {
  if (!isObject$8(value)) {
    return false;
  }
  var tag = baseGetTag$3(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$2;
var root$7 = _root;
var coreJsData$1 = root$7["__core-js_shared__"];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
var _toSource = toSource$2;
var isFunction$1 = isFunction_1, isMasked = _isMasked, isObject$7 = isObject_1, toSource$1 = _toSource;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$c = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$a = objectProto$c.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$a).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(value) {
  if (!isObject$7(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(object, key) {
  return object == null ? void 0 : object[key];
}
var _getValue = getValue$1;
var baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
var _getNative = getNative$7;
var getNative$6 = _getNative;
var nativeCreate$4 = getNative$6(Object, "create");
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$b = Object.prototype;
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$9.call(data, key) ? data[key] : void 0;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
var objectProto$a = Object.prototype;
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$8.call(data, key);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype["delete"] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$3(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$3;
var eq$2 = eq_1;
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$2(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete$1(key) {
  var data = this.__data__, index = assocIndexOf$3(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key) {
  var data = this.__data__, index = assocIndexOf$2(data, key);
  return index < 0 ? void 0 : data[index][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;
function listCacheSet$1(key, value) {
  var data = this.__data__, index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype["delete"] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;
var getNative$5 = _getNative, root$6 = _root;
var Map$4 = getNative$5(root$6, "Map");
var _Map = Map$4;
var Hash = _Hash, ListCache$3 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$3 || ListCache$3)(),
    "string": new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key), size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype["delete"] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3;
var MapCache$2 = _MapCache;
var FUNC_ERROR_TEXT$1 = "Expected a function";
function memoize$1(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache$2)();
  return memoized;
}
memoize$1.Cache = MapCache$2;
var memoize_1 = memoize$1;
var memoize = memoize_1;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped$1;
var memoizeCapped = _memoizeCapped;
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46) {
    result.push("");
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
  });
  return result;
});
var _stringToPath = stringToPath$1;
var isArray$7 = isArray_1, isKey = _isKey, stringToPath = _stringToPath, toString$1 = toString_1;
function castPath$4(value, object) {
  if (isArray$7(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString$1(value));
}
var _castPath = castPath$4;
var isSymbol$1 = isSymbol_1;
var INFINITY$1 = 1 / 0;
function toKey$3(value) {
  if (typeof value == "string" || isSymbol$1(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$1 ? "-0" : result;
}
var _toKey = toKey$3;
var castPath$3 = _castPath, toKey$2 = _toKey;
function baseGet$1(object, path) {
  path = castPath$3(path, object);
  var index = 0, length = path.length;
  while (object != null && index < length) {
    object = object[toKey$2(path[index++])];
  }
  return index && index == length ? object : void 0;
}
var _baseGet = baseGet$1;
var getNative$4 = _getNative;
var defineProperty$2 = function() {
  try {
    var func = getNative$4(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e) {
  }
}();
var _defineProperty = defineProperty$2;
var defineProperty$1 = _defineProperty;
function baseAssignValue$2(object, key, value) {
  if (key == "__proto__" && defineProperty$1) {
    defineProperty$1(object, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object[key] = value;
  }
}
var _baseAssignValue = baseAssignValue$2;
var baseAssignValue$1 = _baseAssignValue, eq$1 = eq_1;
var objectProto$9 = Object.prototype;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
function assignValue$3(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$7.call(object, key) && eq$1(objValue, value)) || value === void 0 && !(key in object)) {
    baseAssignValue$1(object, key, value);
  }
}
var _assignValue = assignValue$3;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$3(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
var _isIndex = isIndex$3;
var assignValue$2 = _assignValue, castPath$2 = _castPath, isIndex$2 = _isIndex, isObject$6 = isObject_1, toKey$1 = _toKey;
function baseSet$1(object, path, value, customizer) {
  if (!isObject$6(object)) {
    return object;
  }
  path = castPath$2(path, object);
  var index = -1, length = path.length, lastIndex = length - 1, nested = object;
  while (nested != null && ++index < length) {
    var key = toKey$1(path[index]), newValue = value;
    if (key === "__proto__" || key === "constructor" || key === "prototype") {
      return object;
    }
    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : void 0;
      if (newValue === void 0) {
        newValue = isObject$6(objValue) ? objValue : isIndex$2(path[index + 1]) ? [] : {};
      }
    }
    assignValue$2(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}
var _baseSet = baseSet$1;
var baseGet = _baseGet, baseSet = _baseSet, castPath$1 = _castPath;
function basePickBy$1(object, paths, predicate) {
  var index = -1, length = paths.length, result = {};
  while (++index < length) {
    var path = paths[index], value = baseGet(object, path);
    if (predicate(value, path)) {
      baseSet(result, castPath$1(path, object), value);
    }
  }
  return result;
}
var _basePickBy = basePickBy$1;
function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}
var _baseHasIn = baseHasIn$1;
var baseGetTag$2 = _baseGetTag, isObjectLike$7 = isObjectLike_1;
var argsTag$3 = "[object Arguments]";
function baseIsArguments$1(value) {
  return isObjectLike$7(value) && baseGetTag$2(value) == argsTag$3;
}
var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments, isObjectLike$6 = isObjectLike_1;
var objectProto$8 = Object.prototype;
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$8.propertyIsEnumerable;
var isArguments$3 = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$6(value) && hasOwnProperty$6.call(value, "callee") && !propertyIsEnumerable$1.call(value, "callee");
};
var isArguments_1 = isArguments$3;
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength$3(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$3;
var castPath = _castPath, isArguments$2 = isArguments_1, isArray$6 = isArray_1, isIndex$1 = _isIndex, isLength$2 = isLength_1, toKey = _toKey;
function hasPath$1(object, path, hasFunc) {
  path = castPath(path, object);
  var index = -1, length = path.length, result = false;
  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength$2(length) && isIndex$1(key, length) && (isArray$6(object) || isArguments$2(object));
}
var _hasPath = hasPath$1;
var baseHasIn = _baseHasIn, hasPath = _hasPath;
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}
var hasIn_1 = hasIn$1;
var basePickBy = _basePickBy, hasIn = hasIn_1;
function basePick$1(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}
var _basePick = basePick$1;
function arrayPush$3(array, values) {
  var index = -1, length = values.length, offset2 = array.length;
  while (++index < length) {
    array[offset2 + index] = values[index];
  }
  return array;
}
var _arrayPush = arrayPush$3;
var Symbol$3 = _Symbol, isArguments$1 = isArguments_1, isArray$5 = isArray_1;
var spreadableSymbol = Symbol$3 ? Symbol$3.isConcatSpreadable : void 0;
function isFlattenable$1(value) {
  return isArray$5(value) || isArguments$1(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
var _isFlattenable = isFlattenable$1;
var arrayPush$2 = _arrayPush, isFlattenable = _isFlattenable;
function baseFlatten$2(array, depth, predicate, isStrict, result) {
  var index = -1, length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        baseFlatten$2(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$2(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}
var _baseFlatten = baseFlatten$2;
var baseFlatten$1 = _baseFlatten;
function flatten$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten$1(array, 1) : [];
}
var flatten_1 = flatten$1;
function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
var _apply = apply$1;
var apply = _apply;
var nativeMax$1 = Math.max;
function overRest$2(func, start2, transform2) {
  start2 = nativeMax$1(start2 === void 0 ? func.length - 1 : start2, 0);
  return function() {
    var args = arguments, index = -1, length = nativeMax$1(args.length - start2, 0), array = Array(length);
    while (++index < length) {
      array[index] = args[start2 + index];
    }
    index = -1;
    var otherArgs = Array(start2 + 1);
    while (++index < start2) {
      otherArgs[index] = args[index];
    }
    otherArgs[start2] = transform2(array);
    return apply(func, this, otherArgs);
  };
}
var _overRest = overRest$2;
function constant$1(value) {
  return function() {
    return value;
  };
}
var constant_1 = constant$1;
function identity$2(value) {
  return value;
}
var identity_1 = identity$2;
var constant = constant_1, defineProperty = _defineProperty, identity$1 = identity_1;
var baseSetToString$1 = !defineProperty ? identity$1 : function(func, string) {
  return defineProperty(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string),
    "writable": true
  });
};
var _baseSetToString = baseSetToString$1;
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut$1(func) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(void 0, arguments);
  };
}
var _shortOut = shortOut$1;
var baseSetToString = _baseSetToString, shortOut = _shortOut;
var setToString$2 = shortOut(baseSetToString);
var _setToString = setToString$2;
var flatten = flatten_1, overRest$1 = _overRest, setToString$1 = _setToString;
function flatRest$1(func) {
  return setToString$1(overRest$1(func, void 0, flatten), func + "");
}
var _flatRest = flatRest$1;
var basePick = _basePick, flatRest = _flatRest;
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});
var pick_1 = pick;
var ListCache$2 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$2();
  this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(key) {
  var data = this.__data__, result = data["delete"](key);
  this.size = data.size;
  return result;
}
var _stackDelete = stackDelete$1;
function stackGet$1(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$1;
function stackHas$1(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$1;
var ListCache$1 = _ListCache, Map$2 = _Map, MapCache$1 = _MapCache;
var LARGE_ARRAY_SIZE$1 = 200;
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet$1;
var ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$2(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack$2.prototype.clear = stackClear;
Stack$2.prototype["delete"] = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;
var _Stack = Stack$2;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;
var MapCache = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$2(values) {
  var index = -1, length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd;
SetCache$2.prototype.has = setCacheHas;
var _SetCache = SetCache$2;
function arraySome$1(array, predicate) {
  var index = -1, length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;
function cacheHas$2(cache, key) {
  return cache.has(key);
}
var _cacheHas = cacheHas$2;
var SetCache$1 = _SetCache, arraySome = _arraySome, cacheHas$1 = _cacheHas;
var COMPARE_PARTIAL_FLAG$3 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$1 ? new SetCache$1() : void 0;
  stack.set(array, other);
  stack.set(other, array);
  while (++index < arrLength) {
    var arrValue = array[index], othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas$1(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array);
  stack["delete"](other);
  return result;
}
var _equalArrays = equalArrays$2;
var root$5 = _root;
var Uint8Array$3 = root$5.Uint8Array;
var _Uint8Array = Uint8Array$3;
function mapToArray$1(map) {
  var index = -1, result = Array(map.size);
  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}
var _mapToArray = mapToArray$1;
function setToArray$1(set) {
  var index = -1, result = Array(set.size);
  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}
var _setToArray = setToArray$1;
var Symbol$2 = _Symbol, Uint8Array$2 = _Uint8Array, eq = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray = _setToArray;
var COMPARE_PARTIAL_FLAG$2 = 1, COMPARE_UNORDERED_FLAG = 2;
var boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$2 = "[object Error]", mapTag$5 = "[object Map]", numberTag$3 = "[object Number]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$3 = "[object String]", symbolTag$2 = "[object Symbol]";
var arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]";
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$4:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag$3:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other))) {
        return false;
      }
      return true;
    case boolTag$3:
    case dateTag$3:
    case numberTag$3:
      return eq(+object, +other);
    case errorTag$2:
      return object.name == other.name && object.message == other.message;
    case regexpTag$3:
    case stringTag$3:
      return object == other + "";
    case mapTag$5:
      var convert2 = mapToArray;
    case setTag$5:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2;
      convert2 || (convert2 = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;
      stack.set(object, other);
      var result = equalArrays$1(convert2(object), convert2(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object);
      return result;
    case symbolTag$2:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;
var arrayPush$1 = _arrayPush, isArray$4 = isArray_1;
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$4(object) ? result : arrayPush$1(result, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys$2;
function arrayFilter$1(array, predicate) {
  var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter$1;
function stubArray$2() {
  return [];
}
var stubArray_1 = stubArray$2;
var arrayFilter = _arrayFilter, stubArray$1 = stubArray_1;
var objectProto$7 = Object.prototype;
var propertyIsEnumerable = objectProto$7.propertyIsEnumerable;
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
var getSymbols$3 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var _getSymbols = getSymbols$3;
function baseTimes$1(n, iteratee) {
  var index = -1, result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}
var _baseTimes = baseTimes$1;
var isBuffer$3 = { exports: {} };
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;
(function(module, exports) {
  var root2 = _root, stubFalse2 = stubFalse_1;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer = moduleExports ? root2.Buffer : void 0;
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0;
  var isBuffer2 = nativeIsBuffer || stubFalse2;
  module.exports = isBuffer2;
})(isBuffer$3, isBuffer$3.exports);
var baseGetTag$1 = _baseGetTag, isLength$1 = isLength_1, isObjectLike$5 = isObjectLike_1;
var argsTag$2 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", errorTag$1 = "[object Error]", funcTag$1 = "[object Function]", mapTag$4 = "[object Map]", numberTag$2 = "[object Number]", objectTag$3 = "[object Object]", regexpTag$2 = "[object RegExp]", setTag$4 = "[object Set]", stringTag$2 = "[object String]", weakMapTag$2 = "[object WeakMap]";
var arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$3 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] = typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$4] = typedArrayTags[numberTag$2] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$2] = typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] = typedArrayTags[weakMapTag$2] = false;
function baseIsTypedArray$1(value) {
  return isObjectLike$5(value) && isLength$1(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$4(func) {
  return function(value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$4;
var _nodeUtil = { exports: {} };
(function(module, exports) {
  var freeGlobal2 = _freeGlobal;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  module.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);
var baseIsTypedArray = _baseIsTypedArray, baseUnary$3 = _baseUnary, nodeUtil$2 = _nodeUtil.exports;
var nodeIsTypedArray = nodeUtil$2 && nodeUtil$2.isTypedArray;
var isTypedArray$2 = nodeIsTypedArray ? baseUnary$3(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$2;
var baseTimes = _baseTimes, isArguments = isArguments_1, isArray$3 = isArray_1, isBuffer$2 = isBuffer$3.exports, isIndex = _isIndex, isTypedArray$1 = isTypedArray_1;
var objectProto$6 = Object.prototype;
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$3(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer$2(value), isType = !isArr && !isArg && !isBuff && isTypedArray$1(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$5.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys$2;
var objectProto$5 = Object.prototype;
function isPrototype$3(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$5;
  return value === proto;
}
var _isPrototype = isPrototype$3;
function overArg$2(func, transform2) {
  return function(arg) {
    return func(transform2(arg));
  };
}
var _overArg = overArg$2;
var overArg$1 = _overArg;
var nativeKeys$1 = overArg$1(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype$2 = _isPrototype, nativeKeys = _nativeKeys;
var objectProto$4 = Object.prototype;
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;
function baseKeys$1(object) {
  if (!isPrototype$2(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$4.call(object, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys$1;
var isFunction = isFunction_1, isLength = isLength_1;
function isArrayLike$3(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}
var isArrayLike_1 = isArrayLike$3;
var arrayLikeKeys$1 = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike$2 = isArrayLike_1;
function keys$3(object) {
  return isArrayLike$2(object) ? arrayLikeKeys$1(object) : baseKeys(object);
}
var keys_1 = keys$3;
var baseGetAllKeys$1 = _baseGetAllKeys, getSymbols$2 = _getSymbols, keys$2 = keys_1;
function getAllKeys$2(object) {
  return baseGetAllKeys$1(object, keys$2, getSymbols$2);
}
var _getAllKeys = getAllKeys$2;
var getAllKeys$1 = _getAllKeys;
var COMPARE_PARTIAL_FLAG$1 = 1;
var objectProto$3 = Object.prototype;
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1, objProps = getAllKeys$1(object), objLength = objProps.length, othProps = getAllKeys$1(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$3.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object);
  stack["delete"](other);
  return result;
}
var _equalObjects = equalObjects$1;
var getNative$3 = _getNative, root$4 = _root;
var DataView$1 = getNative$3(root$4, "DataView");
var _DataView = DataView$1;
var getNative$2 = _getNative, root$3 = _root;
var Promise$2 = getNative$2(root$3, "Promise");
var _Promise = Promise$2;
var getNative$1 = _getNative, root$2 = _root;
var Set$2 = getNative$1(root$2, "Set");
var _Set = Set$2;
var getNative = _getNative, root$1 = _root;
var WeakMap$1 = getNative(root$1, "WeakMap");
var _WeakMap = WeakMap$1;
var DataView = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$1 = _Set, WeakMap = _WeakMap, baseGetTag = _baseGetTag, toSource = _toSource;
var mapTag$3 = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag$3 = "[object Set]", weakMapTag$1 = "[object WeakMap]";
var dataViewTag$2 = "[object DataView]";
var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap);
var getTag$5 = baseGetTag;
if (DataView && getTag$5(new DataView(new ArrayBuffer(1))) != dataViewTag$2 || Map$1 && getTag$5(new Map$1()) != mapTag$3 || Promise$1 && getTag$5(Promise$1.resolve()) != promiseTag || Set$1 && getTag$5(new Set$1()) != setTag$3 || WeakMap && getTag$5(new WeakMap()) != weakMapTag$1) {
  getTag$5 = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$2 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;
        case mapCtorString:
          return mapTag$3;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$3;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
var _getTag = getTag$5;
var Stack$1 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag$4 = _getTag, isArray$2 = isArray_1, isBuffer$1 = isBuffer$3.exports, isTypedArray = isTypedArray_1;
var COMPARE_PARTIAL_FLAG = 1;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", objectTag$1 = "[object Object]";
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$2(object), othIsArr = isArray$2(other), objTag = objIsArr ? arrayTag$1 : getTag$4(object), othTag = othIsArr ? arrayTag$1 : getTag$4(other);
  objTag = objTag == argsTag$1 ? objectTag$1 : objTag;
  othTag = othTag == argsTag$1 ? objectTag$1 : othTag;
  var objIsObj = objTag == objectTag$1, othIsObj = othTag == objectTag$1, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty$2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$2.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$1());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;
var baseIsEqualDeep = _baseIsEqualDeep, isObjectLike$4 = isObjectLike_1;
function baseIsEqual$1(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike$4(value) && !isObjectLike$4(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$1, stack);
}
var _baseIsEqual = baseIsEqual$1;
var baseIsEqual = _baseIsEqual;
function isEqual(value, other) {
  return baseIsEqual(value, other);
}
var isEqual_1 = isEqual;
const watchCurrentStep = (value, oldValue, shouldRenderSlot, watchChangesOnProps, mainContent2, currentDirection2, hasProgressOrder2) => {
  const propList = watchChangesOnProps.length ? watchChangesOnProps : Object.keys(value);
  if (!isEqual_1(pick_1(value, propList), pick_1(oldValue, propList))) {
    if (hasProgressOrder2.value) {
      if (value.progressOrder > oldValue.progressOrder) {
        currentDirection2.value = DIRECTION.NEXT;
      } else {
        currentDirection2.value = DIRECTION.PREVIOUS;
      }
    }
    shouldRenderSlot.value = false;
    setTimeout(() => {
      shouldRenderSlot.value = true;
      mainContent2.value.scrollTo(0, 0);
    }, 200);
  }
};
var render$1M = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_vm.currentLayout === _vm.BaseWizardLayouts.HORIZONTAL ? _c("HorizontalLayout", { class: _vm.currentDirection, on: { "complete": _vm.handleComplete, "next": _vm.handleNext, "previous": _vm.handlePrevious }, scopedSlots: _vm._u([{ key: "title", fn: function() {
    return [_vm._t("title")];
  }, proxy: true }, { key: "default", fn: function() {
    return [_c("main", { ref: "mainContent" }, [_c("transition", { attrs: { "name": "wizard", "appear": "", "mode": "out-in" } }, [_vm.shouldRenderSlot ? _c("div", [_vm._t("default")], 2) : _vm._e()])], 1)];
  }, proxy: true }, _vm.showFooter ? { key: "footer", fn: function() {
    return [_vm._t("footer")];
  }, proxy: true } : null], null, true) }) : _vm.currentLayout === _vm.BaseWizardLayouts.VERTICAL ? _c("VerticalLayout", { class: _vm.currentDirection, on: { "complete": _vm.handleComplete, "next": _vm.handleNext, "previous": _vm.handlePrevious }, scopedSlots: _vm._u([{ key: "header", fn: function() {
    return [_vm._t("header")];
  }, proxy: true }, { key: "nav-header", fn: function() {
    return [_vm._t("nav-header")];
  }, proxy: true }, { key: "title", fn: function() {
    return [_vm._t("title")];
  }, proxy: true }, { key: "nav-footer", fn: function() {
    return [_vm._t("nav-footer")];
  }, proxy: true }, { key: "default", fn: function() {
    return [_c("main", { ref: "mainContent" }, [_c("transition", { attrs: { "name": "wizard", "appear": "", "mode": "out-in" } }, [_vm.shouldRenderSlot ? _c("div", [_vm._t("default")], 2) : _vm._e()])], 1)];
  }, proxy: true }, _vm.showFooter ? { key: "footer", fn: function() {
    return [_vm._t("footer")];
  }, proxy: true } : null], null, true) }) : _vm._e()], 1);
};
var staticRenderFns$A = [];
var BaseWizard_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$A = defineComponent({
  name: "BaseWizard",
  components: {
    HorizontalLayout,
    VerticalLayout
  },
  emits: [...BaseWizardEmits],
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    isFirstStep: {
      type: Boolean,
      default: true
    },
    isLastStep: {
      type: Boolean,
      default: false
    },
    fullScreen: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showProgress: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ""
    },
    layout: {
      type: String,
      default: "horizontal"
    },
    currentStep: {
      type: [String, Object],
      required: true
    },
    steps: {
      type: Array,
      required: true
    },
    compact: {
      type: Boolean,
      default: false
    },
    isComplete: {
      type: Boolean,
      default: false
    },
    showIteration: {
      type: Boolean,
      default: false
    },
    watchChangesOnProps: {
      type: Array,
      default: () => []
    }
  },
  setup(props2, { emit }) {
    const { currentStep: currentStep2, mainContent: mainContent2, currentLayout: currentLayout2, steps, hasProgressOrder: hasProgressOrder2 } = useWizardProps(props2);
    const { currentDirection: currentDirection2, handlePrevious, handleNext, handleComplete } = useWizardActions(steps, currentStep2, emit, hasProgressOrder2);
    const shouldRenderSlot = ref(false);
    watch(currentStep2, (value, oldValue) => {
      watchCurrentStep(
        value,
        oldValue,
        shouldRenderSlot,
        props2.watchChangesOnProps,
        mainContent2,
        currentDirection2,
        hasProgressOrder2
      );
    });
    onMounted(() => {
      shouldRenderSlot.value = true;
    });
    return {
      currentDirection: currentDirection2,
      handlePrevious,
      handleNext,
      handleComplete,
      shouldRenderSlot,
      mainContent: mainContent2,
      currentLayout: currentLayout2,
      BaseWizardLayouts
    };
  }
});
const __cssModules$A = {};
var __component__$A = /* @__PURE__ */ normalizeComponent(
  __vue2_script$A,
  render$1M,
  staticRenderFns$A,
  false,
  __vue2_injectStyles$A,
  "324365bd",
  null,
  null
);
function __vue2_injectStyles$A(context) {
  for (let o in __cssModules$A) {
    this[o] = __cssModules$A[o];
  }
}
var BaseWizard = /* @__PURE__ */ function() {
  return __component__$A.exports;
}();
var render$1L = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ToggleGroup", { staticClass: "checkbox-group", attrs: { "options": _vm.options, "disabled": _vm.disabled, "invalid": _vm.invalid, "label": _vm.label, "label-position": _vm.labelPosition, "name": _vm.name, "required": _vm.required, "size": _vm.size, "vertical": _vm.vertical, "value": _vm.value, "type": "block-check" }, on: { "input": function($event) {
    return _vm.$emit("input", $event);
  } } });
};
var staticRenderFns$z = [];
const __vue2_script$z = defineComponent({
  name: "BlockCheckGroup",
  components: { ToggleGroup },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    labelPosition: {
      type: String,
      default: Form.LabelPositions.RIGHT,
      validator: (value) => Object.values(Form.LabelPositions).includes(value)
    },
    name: {
      type: String,
      default: void 0
    },
    options: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => [Form.Sizes.DENSE, Form.Sizes.NORMAL].includes(value)
    },
    vertical: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    }
  }
});
const __cssModules$z = {};
var __component__$z = /* @__PURE__ */ normalizeComponent(
  __vue2_script$z,
  render$1L,
  staticRenderFns$z,
  false,
  __vue2_injectStyles$z,
  null,
  null,
  null
);
function __vue2_injectStyles$z(context) {
  for (let o in __cssModules$z) {
    this[o] = __cssModules$z[o];
  }
}
var BlockCheckGroup = /* @__PURE__ */ function() {
  return __component__$z.exports;
}();
var render$1K = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ToggleGroup", { staticClass: "radio-group", attrs: { "options": _vm.options, "disabled": _vm.disabled, "invalid": _vm.invalid, "label": _vm.label, "label-position": _vm.labelPosition, "name": _vm.name, "required": _vm.required, "size": _vm.size, "vertical": _vm.vertical, "value": _vm.value, "type": "block-radio" }, on: { "input": function($event) {
    return _vm.$emit("input", $event);
  } } });
};
var staticRenderFns$y = [];
const __vue2_script$y = defineComponent({
  name: "BlockRadioGroup",
  components: { ToggleGroup },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    labelPosition: {
      type: String,
      default: Form.LabelPositions.RIGHT,
      validator: (value) => Object.values(Form.LabelPositions).includes(value)
    },
    name: {
      type: String,
      default: void 0
    },
    options: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => [Form.Sizes.DENSE, Form.Sizes.NORMAL].includes(value)
    },
    vertical: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: null
    }
  }
});
const __cssModules$y = {};
var __component__$y = /* @__PURE__ */ normalizeComponent(
  __vue2_script$y,
  render$1K,
  staticRenderFns$y,
  false,
  __vue2_injectStyles$y,
  null,
  null,
  null
);
function __vue2_injectStyles$y(context) {
  for (let o in __cssModules$y) {
    this[o] = __cssModules$y[o];
  }
}
var BlockRadioGroup = /* @__PURE__ */ function() {
  return __component__$y.exports;
}();
function abbreviateNumber(num, precision) {
  if (num === null) {
    return null;
  }
  if (num < 1e3) {
    return `${num}`;
  }
  const fixed = !precision || precision < 0 ? 0 : precision;
  const b = num.toPrecision(2).split("e");
  const k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3);
  const c = k < 1 ? num.toFixed(0 + fixed) : (num / 10 ** (k * 3)).toFixed(1 + fixed);
  const d = c < 0 ? c : Math.abs(c);
  const e = d + ["", "K", "M", "B", "T"][k];
  return e;
}
const TINY = "tiny";
const SMALL = "small";
const MEDIUM = "medium";
const LARGE = "large";
var render$1J = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "counter-badge", class: ["counter-badge--" + _vm.size, "counter-badge--" + _vm.variant] }, [_vm._v(" " + _vm._s(_vm.formattedNumber) + " ")]);
};
var staticRenderFns$x = [];
var CounterBadge_vue_vue_type_style_index_0_scoped_true_lang = "";
const Sizes$2 = Object.freeze({ SMALL, MEDIUM, LARGE });
const Variants$2 = Object.freeze({
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary"
});
const __vue2_script$x = {
  props: {
    size: {
      type: String,
      default: Sizes$2.MEDIUM
    },
    value: {
      type: Number,
      default: 0
    },
    variant: {
      type: String,
      default: Variants$2.PRIMARY
    }
  },
  setup(props2) {
    const formattedNumber = computed(() => abbreviateNumber(props2.value));
    return { formattedNumber };
  }
};
const __cssModules$x = {};
var __component__$x = /* @__PURE__ */ normalizeComponent(
  __vue2_script$x,
  render$1J,
  staticRenderFns$x,
  false,
  __vue2_injectStyles$x,
  "5c466b4f",
  null,
  null
);
function __vue2_injectStyles$x(context) {
  for (let o in __cssModules$x) {
    this[o] = __cssModules$x[o];
  }
}
var CounterBadge = /* @__PURE__ */ function() {
  return __component__$x.exports;
}();
var render$1I = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "countersign-icon", style: _vm.style, attrs: { "role": "text", "aria-label": _vm.label, "title": _vm.label } }, [_c("svg", { staticClass: "countersign-icon__checks", attrs: { "viewBox": "0 0 24 24", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { staticClass: "countersign-icon__check", class: { "countersign-icon__check--signed": _vm.signed }, attrs: { "d": "M23.7911 7.23176L22.3237 5.7119C22.1844 5.6069 22.0275 5.55493 21.8523 5.55493C21.6771 5.55493 21.5378 5.60743 21.4333 5.7119L7.65071 19.5465L2.56774 14.4635C2.46273 14.3237 2.32398 14.2541 2.1488 14.2541C1.97362 14.2541 1.81611 14.3237 1.67736 14.4635L0.209469 15.9303C0.0701801 16.0702 0 16.2277 0 16.4018C0 16.5759 0.0701801 16.7163 0.209469 16.8207L7.17927 23.8425C7.31856 23.9475 7.47552 24 7.65071 24C7.82589 24 7.96518 23.9475 8.06964 23.8425L23.7905 8.1216C23.9298 7.98177 24 7.82427 24 7.65016C24.0005 7.47658 23.9304 7.33622 23.7911 7.23176Z", "fill": "currentColor" } }), _c("path", { staticClass: "countersign-icon__check", class: { "countersign-icon__check--signed": _vm.countersigned }, attrs: { "d": "M7.06519 13.556C7.20555 13.6616 7.36412 13.7146 7.54091 13.7146C7.7177 13.7146 7.85806 13.6616 7.9636 13.556L18.9294 2.59024C19.0697 2.4488 19.141 2.29023 19.141 2.11451C19.141 1.93879 19.0697 1.79736 18.9294 1.69182L17.4492 0.158575C17.3088 0.0530369 17.1502 0 16.9734 0C16.7967 0 16.6563 0.0530369 16.5508 0.158575L7.54091 9.22092L4.30459 5.9846C4.19905 5.84317 4.05869 5.77299 3.8819 5.77299C3.70511 5.77299 3.54654 5.84317 3.40618 5.9846L1.92597 7.46481C1.78561 7.60624 1.71436 7.76482 1.71436 7.94053C1.71436 8.11679 1.78561 8.25768 1.92597 8.36322L7.06519 13.556Z", "fill": "currentColor" } })]), _c("span", { staticClass: "countersign-icon__label" }, [_vm._v(_vm._s(_vm.label))])]);
};
var staticRenderFns$w = [];
var CountersignIcon_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$w = {
  props: {
    countersigned: {
      type: Boolean,
      default: false
    },
    signed: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 24
    }
  },
  setup(props2) {
    const style = computed(() => ({
      width: `${props2.size}px`,
      height: `${props2.size}px`,
      fontSize: `${props2.size}px`
    }));
    const label = computed(() => {
      if (props2.signed && props2.countersigned) {
        return "Signatures completed";
      }
      if (props2.signed) {
        return "Awaiting counter signature";
      }
      if (props2.countersigned) {
        return `Awaiting recipient's signature`;
      }
      return "Awaiting signatures";
    });
    return {
      style,
      label
    };
  }
};
const __cssModules$w = {};
var __component__$w = /* @__PURE__ */ normalizeComponent(
  __vue2_script$w,
  render$1I,
  staticRenderFns$w,
  false,
  __vue2_injectStyles$w,
  "5f006f71",
  null,
  null
);
function __vue2_injectStyles$w(context) {
  for (let o in __cssModules$w) {
    this[o] = __cssModules$w[o];
  }
}
var CountersignIcon = /* @__PURE__ */ function() {
  return __component__$w.exports;
}();
function arrayEach$1(array, iteratee) {
  var index = -1, length = array == null ? 0 : array.length;
  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}
var _arrayEach = arrayEach$1;
var assignValue$1 = _assignValue, baseAssignValue = _baseAssignValue;
function copyObject$4(source, props2, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1, length = props2.length;
  while (++index < length) {
    var key = props2[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
    if (newValue === void 0) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}
var _copyObject = copyObject$4;
var copyObject$3 = _copyObject, keys$1 = keys_1;
function baseAssign$1(object, source) {
  return object && copyObject$3(source, keys$1(source), object);
}
var _baseAssign = baseAssign$1;
function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}
var _nativeKeysIn = nativeKeysIn$1;
var isObject$5 = isObject_1, isPrototype$1 = _isPrototype, nativeKeysIn = _nativeKeysIn;
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function baseKeysIn$1(object) {
  if (!isObject$5(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$1(object), result = [];
  for (var key in object) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$1.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}
var _baseKeysIn = baseKeysIn$1;
var arrayLikeKeys = _arrayLikeKeys, baseKeysIn = _baseKeysIn, isArrayLike$1 = isArrayLike_1;
function keysIn$3(object) {
  return isArrayLike$1(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
var keysIn_1 = keysIn$3;
var copyObject$2 = _copyObject, keysIn$2 = keysIn_1;
function baseAssignIn$1(object, source) {
  return object && copyObject$2(source, keysIn$2(source), object);
}
var _baseAssignIn = baseAssignIn$1;
var _cloneBuffer = { exports: {} };
(function(module, exports) {
  var root2 = _root;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer = moduleExports ? root2.Buffer : void 0, allocUnsafe = Buffer ? Buffer.allocUnsafe : void 0;
  function cloneBuffer2(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }
  module.exports = cloneBuffer2;
})(_cloneBuffer, _cloneBuffer.exports);
function copyArray$1(source, array) {
  var index = -1, length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}
var _copyArray = copyArray$1;
var copyObject$1 = _copyObject, getSymbols$1 = _getSymbols;
function copySymbols$1(source, object) {
  return copyObject$1(source, getSymbols$1(source), object);
}
var _copySymbols = copySymbols$1;
var overArg = _overArg;
var getPrototype$2 = overArg(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype$2;
var arrayPush = _arrayPush, getPrototype$1 = _getPrototype, getSymbols = _getSymbols, stubArray = stubArray_1;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype$1(object);
  }
  return result;
};
var _getSymbolsIn = getSymbolsIn$2;
var copyObject = _copyObject, getSymbolsIn$1 = _getSymbolsIn;
function copySymbolsIn$1(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}
var _copySymbolsIn = copySymbolsIn$1;
var baseGetAllKeys = _baseGetAllKeys, getSymbolsIn = _getSymbolsIn, keysIn$1 = keysIn_1;
function getAllKeysIn$1(object) {
  return baseGetAllKeys(object, keysIn$1, getSymbolsIn);
}
var _getAllKeysIn = getAllKeysIn$1;
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function initCloneArray$1(array) {
  var length = array.length, result = new array.constructor(length);
  if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}
var _initCloneArray = initCloneArray$1;
var Uint8Array$1 = _Uint8Array;
function cloneArrayBuffer$3(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}
var _cloneArrayBuffer = cloneArrayBuffer$3;
var cloneArrayBuffer$2 = _cloneArrayBuffer;
function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var _cloneDataView = cloneDataView$1;
var reFlags = /\w*$/;
function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}
var _cloneRegExp = cloneRegExp$1;
var Symbol$1 = _Symbol;
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function cloneSymbol$1(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
var _cloneSymbol = cloneSymbol$1;
var cloneArrayBuffer$1 = _cloneArrayBuffer;
function cloneTypedArray$1(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var _cloneTypedArray = cloneTypedArray$1;
var cloneArrayBuffer = _cloneArrayBuffer, cloneDataView = _cloneDataView, cloneRegExp = _cloneRegExp, cloneSymbol = _cloneSymbol, cloneTypedArray = _cloneTypedArray;
var boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag$1 = "[object Symbol]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);
    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);
    case dataViewTag$1:
      return cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);
    case mapTag$2:
      return new Ctor();
    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);
    case regexpTag$1:
      return cloneRegExp(object);
    case setTag$2:
      return new Ctor();
    case symbolTag$1:
      return cloneSymbol(object);
  }
}
var _initCloneByTag = initCloneByTag$1;
var isObject$4 = isObject_1;
var objectCreate = Object.create;
var baseCreate$1 = function() {
  function object() {
  }
  return function(proto) {
    if (!isObject$4(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = void 0;
    return result;
  };
}();
var _baseCreate = baseCreate$1;
var baseCreate = _baseCreate, getPrototype = _getPrototype, isPrototype = _isPrototype;
function initCloneObject$1(object) {
  return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
var _initCloneObject = initCloneObject$1;
var getTag$3 = _getTag, isObjectLike$3 = isObjectLike_1;
var mapTag$1 = "[object Map]";
function baseIsMap$1(value) {
  return isObjectLike$3(value) && getTag$3(value) == mapTag$1;
}
var _baseIsMap = baseIsMap$1;
var baseIsMap = _baseIsMap, baseUnary$2 = _baseUnary, nodeUtil$1 = _nodeUtil.exports;
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;
var isMap$1 = nodeIsMap ? baseUnary$2(nodeIsMap) : baseIsMap;
var isMap_1 = isMap$1;
var getTag$2 = _getTag, isObjectLike$2 = isObjectLike_1;
var setTag$1 = "[object Set]";
function baseIsSet$1(value) {
  return isObjectLike$2(value) && getTag$2(value) == setTag$1;
}
var _baseIsSet = baseIsSet$1;
var baseIsSet = _baseIsSet, baseUnary$1 = _baseUnary, nodeUtil = _nodeUtil.exports;
var nodeIsSet = nodeUtil && nodeUtil.isSet;
var isSet$1 = nodeIsSet ? baseUnary$1(nodeIsSet) : baseIsSet;
var isSet_1 = isSet$1;
var Stack = _Stack, arrayEach = _arrayEach, assignValue = _assignValue, baseAssign = _baseAssign, baseAssignIn = _baseAssignIn, cloneBuffer = _cloneBuffer.exports, copyArray = _copyArray, copySymbols = _copySymbols, copySymbolsIn = _copySymbolsIn, getAllKeys = _getAllKeys, getAllKeysIn = _getAllKeysIn, getTag$1 = _getTag, initCloneArray = _initCloneArray, initCloneByTag = _initCloneByTag, initCloneObject = _initCloneObject, isArray$1 = isArray_1, isBuffer = isBuffer$3.exports, isMap = isMap_1, isObject$3 = isObject_1, isSet = isSet_1, keys = keys_1, keysIn = keysIn_1;
var CLONE_DEEP_FLAG$1 = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG$1 = 4;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
function baseClone$1(value, bitmask, customizer, key, object, stack) {
  var result, isDeep = bitmask & CLONE_DEEP_FLAG$1, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG$1;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== void 0) {
    return result;
  }
  if (!isObject$3(value)) {
    return value;
  }
  var isArr = isArray$1(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value), isFunc = tag == funcTag || tag == genTag;
    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key2) {
      result.set(key2, baseClone$1(subValue, bitmask, customizer, key2, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
  var props2 = isArr ? void 0 : keysFunc(value);
  arrayEach(props2 || value, function(subValue, key2) {
    if (props2) {
      key2 = subValue;
      subValue = value[key2];
    }
    assignValue(result, key2, baseClone$1(subValue, bitmask, customizer, key2, value, stack));
  });
  return result;
}
var _baseClone = baseClone$1;
var baseClone = _baseClone;
var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
var cloneDeep_1 = cloneDeep;
function isArray(value) {
  return !Array.isArray ? getTag(value) === "[object Array]" : Array.isArray(value);
}
const INFINITY = 1 / 0;
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  let result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
function toString(value) {
  return value == null ? "" : baseToString(value);
}
function isString(value) {
  return typeof value === "string";
}
function isNumber(value) {
  return typeof value === "number";
}
function isBoolean(value) {
  return value === true || value === false || isObjectLike$1(value) && getTag(value) == "[object Boolean]";
}
function isObject$2(value) {
  return typeof value === "object";
}
function isObjectLike$1(value) {
  return isObject$2(value) && value !== null;
}
function isDefined(value) {
  return value !== void 0 && value !== null;
}
function isBlank(value) {
  return !value.trim().length;
}
function getTag(value) {
  return value == null ? value === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
const EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key) => `Invalid value for key ${key}`;
const PATTERN_LENGTH_TOO_LARGE = (max2) => `Pattern length exceeds max of ${max2}.`;
const MISSING_KEY_PROPERTY = (name) => `Missing ${name} property in key`;
const INVALID_KEY_WEIGHT_VALUE = (key) => `Property 'weight' in key '${key}' must be a positive integer`;
const hasOwn = Object.prototype.hasOwnProperty;
class KeyStore {
  constructor(keys2) {
    this._keys = [];
    this._keyMap = {};
    let totalWeight = 0;
    keys2.forEach((key) => {
      let obj = createKey(key);
      totalWeight += obj.weight;
      this._keys.push(obj);
      this._keyMap[obj.id] = obj;
      totalWeight += obj.weight;
    });
    this._keys.forEach((key) => {
      key.weight /= totalWeight;
    });
  }
  get(keyId) {
    return this._keyMap[keyId];
  }
  keys() {
    return this._keys;
  }
  toJSON() {
    return JSON.stringify(this._keys);
  }
}
function createKey(key) {
  let path = null;
  let id = null;
  let src = null;
  let weight = 1;
  let getFn = null;
  if (isString(key) || isArray(key)) {
    src = key;
    path = createKeyPath(key);
    id = createKeyId(key);
  } else {
    if (!hasOwn.call(key, "name")) {
      throw new Error(MISSING_KEY_PROPERTY("name"));
    }
    const name = key.name;
    src = name;
    if (hasOwn.call(key, "weight")) {
      weight = key.weight;
      if (weight <= 0) {
        throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
      }
    }
    path = createKeyPath(name);
    id = createKeyId(name);
    getFn = key.getFn;
  }
  return { path, id, weight, src, getFn };
}
function createKeyPath(key) {
  return isArray(key) ? key : key.split(".");
}
function createKeyId(key) {
  return isArray(key) ? key.join(".") : key;
}
function get(obj, path) {
  let list = [];
  let arr = false;
  const deepGet = (obj2, path2, index) => {
    if (!isDefined(obj2)) {
      return;
    }
    if (!path2[index]) {
      list.push(obj2);
    } else {
      let key = path2[index];
      const value = obj2[key];
      if (!isDefined(value)) {
        return;
      }
      if (index === path2.length - 1 && (isString(value) || isNumber(value) || isBoolean(value))) {
        list.push(toString(value));
      } else if (isArray(value)) {
        arr = true;
        for (let i = 0, len = value.length; i < len; i += 1) {
          deepGet(value[i], path2, index + 1);
        }
      } else if (path2.length) {
        deepGet(value, path2, index + 1);
      }
    }
  };
  deepGet(obj, isString(path) ? path.split(".") : path, 0);
  return arr ? list : list[0];
}
const MatchOptions = {
  includeMatches: false,
  findAllMatches: false,
  minMatchCharLength: 1
};
const BasicOptions = {
  isCaseSensitive: false,
  includeScore: false,
  keys: [],
  shouldSort: true,
  sortFn: (a, b) => a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const FuzzyOptions = {
  location: 0,
  threshold: 0.6,
  distance: 100
};
const AdvancedOptions = {
  useExtendedSearch: false,
  getFn: get,
  ignoreLocation: false,
  ignoreFieldNorm: false,
  fieldNormWeight: 1
};
var Config = {
  ...BasicOptions,
  ...MatchOptions,
  ...FuzzyOptions,
  ...AdvancedOptions
};
const SPACE = /[^ ]+/g;
function norm(weight = 1, mantissa = 3) {
  const cache = /* @__PURE__ */ new Map();
  const m = Math.pow(10, mantissa);
  return {
    get(value) {
      const numTokens = value.match(SPACE).length;
      if (cache.has(numTokens)) {
        return cache.get(numTokens);
      }
      const norm2 = 1 / Math.pow(numTokens, 0.5 * weight);
      const n = parseFloat(Math.round(norm2 * m) / m);
      cache.set(numTokens, n);
      return n;
    },
    clear() {
      cache.clear();
    }
  };
}
class FuseIndex {
  constructor({
    getFn = Config.getFn,
    fieldNormWeight = Config.fieldNormWeight
  } = {}) {
    this.norm = norm(fieldNormWeight, 3);
    this.getFn = getFn;
    this.isCreated = false;
    this.setIndexRecords();
  }
  setSources(docs = []) {
    this.docs = docs;
  }
  setIndexRecords(records = []) {
    this.records = records;
  }
  setKeys(keys2 = []) {
    this.keys = keys2;
    this._keysMap = {};
    keys2.forEach((key, idx) => {
      this._keysMap[key.id] = idx;
    });
  }
  create() {
    if (this.isCreated || !this.docs.length) {
      return;
    }
    this.isCreated = true;
    if (isString(this.docs[0])) {
      this.docs.forEach((doc, docIndex) => {
        this._addString(doc, docIndex);
      });
    } else {
      this.docs.forEach((doc, docIndex) => {
        this._addObject(doc, docIndex);
      });
    }
    this.norm.clear();
  }
  add(doc) {
    const idx = this.size();
    if (isString(doc)) {
      this._addString(doc, idx);
    } else {
      this._addObject(doc, idx);
    }
  }
  removeAt(idx) {
    this.records.splice(idx, 1);
    for (let i = idx, len = this.size(); i < len; i += 1) {
      this.records[i].i -= 1;
    }
  }
  getValueForItemAtKeyId(item, keyId) {
    return item[this._keysMap[keyId]];
  }
  size() {
    return this.records.length;
  }
  _addString(doc, docIndex) {
    if (!isDefined(doc) || isBlank(doc)) {
      return;
    }
    let record = {
      v: doc,
      i: docIndex,
      n: this.norm.get(doc)
    };
    this.records.push(record);
  }
  _addObject(doc, docIndex) {
    let record = { i: docIndex, $: {} };
    this.keys.forEach((key, keyIndex) => {
      let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
      if (!isDefined(value)) {
        return;
      }
      if (isArray(value)) {
        let subRecords = [];
        const stack = [{ nestedArrIndex: -1, value }];
        while (stack.length) {
          const { nestedArrIndex, value: value2 } = stack.pop();
          if (!isDefined(value2)) {
            continue;
          }
          if (isString(value2) && !isBlank(value2)) {
            let subRecord = {
              v: value2,
              i: nestedArrIndex,
              n: this.norm.get(value2)
            };
            subRecords.push(subRecord);
          } else if (isArray(value2)) {
            value2.forEach((item, k) => {
              stack.push({
                nestedArrIndex: k,
                value: item
              });
            });
          } else
            ;
        }
        record.$[keyIndex] = subRecords;
      } else if (isString(value) && !isBlank(value)) {
        let subRecord = {
          v: value,
          n: this.norm.get(value)
        };
        record.$[keyIndex] = subRecord;
      }
    });
    this.records.push(record);
  }
  toJSON() {
    return {
      keys: this.keys,
      records: this.records
    };
  }
}
function createIndex(keys2, docs, { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}) {
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys2.map(createKey));
  myIndex.setSources(docs);
  myIndex.create();
  return myIndex;
}
function parseIndex(data, { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}) {
  const { keys: keys2, records } = data;
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys2);
  myIndex.setIndexRecords(records);
  return myIndex;
}
function computeScore$1(pattern, {
  errors = 0,
  currentLocation = 0,
  expectedLocation = 0,
  distance = Config.distance,
  ignoreLocation = Config.ignoreLocation
} = {}) {
  const accuracy = errors / pattern.length;
  if (ignoreLocation) {
    return accuracy;
  }
  const proximity = Math.abs(expectedLocation - currentLocation);
  if (!distance) {
    return proximity ? 1 : accuracy;
  }
  return accuracy + proximity / distance;
}
function convertMaskToIndices(matchmask = [], minMatchCharLength = Config.minMatchCharLength) {
  let indices = [];
  let start2 = -1;
  let end2 = -1;
  let i = 0;
  for (let len = matchmask.length; i < len; i += 1) {
    let match = matchmask[i];
    if (match && start2 === -1) {
      start2 = i;
    } else if (!match && start2 !== -1) {
      end2 = i - 1;
      if (end2 - start2 + 1 >= minMatchCharLength) {
        indices.push([start2, end2]);
      }
      start2 = -1;
    }
  }
  if (matchmask[i - 1] && i - start2 >= minMatchCharLength) {
    indices.push([start2, i - 1]);
  }
  return indices;
}
const MAX_BITS = 32;
function search(text, pattern, patternAlphabet, {
  location = Config.location,
  distance = Config.distance,
  threshold = Config.threshold,
  findAllMatches = Config.findAllMatches,
  minMatchCharLength = Config.minMatchCharLength,
  includeMatches = Config.includeMatches,
  ignoreLocation = Config.ignoreLocation
} = {}) {
  if (pattern.length > MAX_BITS) {
    throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
  }
  const patternLen = pattern.length;
  const textLen = text.length;
  const expectedLocation = Math.max(0, Math.min(location, textLen));
  let currentThreshold = threshold;
  let bestLocation = expectedLocation;
  const computeMatches = minMatchCharLength > 1 || includeMatches;
  const matchMask = computeMatches ? Array(textLen) : [];
  let index;
  while ((index = text.indexOf(pattern, bestLocation)) > -1) {
    let score = computeScore$1(pattern, {
      currentLocation: index,
      expectedLocation,
      distance,
      ignoreLocation
    });
    currentThreshold = Math.min(score, currentThreshold);
    bestLocation = index + patternLen;
    if (computeMatches) {
      let i = 0;
      while (i < patternLen) {
        matchMask[index + i] = 1;
        i += 1;
      }
    }
  }
  bestLocation = -1;
  let lastBitArr = [];
  let finalScore = 1;
  let binMax = patternLen + textLen;
  const mask = 1 << patternLen - 1;
  for (let i = 0; i < patternLen; i += 1) {
    let binMin = 0;
    let binMid = binMax;
    while (binMin < binMid) {
      const score2 = computeScore$1(pattern, {
        errors: i,
        currentLocation: expectedLocation + binMid,
        expectedLocation,
        distance,
        ignoreLocation
      });
      if (score2 <= currentThreshold) {
        binMin = binMid;
      } else {
        binMax = binMid;
      }
      binMid = Math.floor((binMax - binMin) / 2 + binMin);
    }
    binMax = binMid;
    let start2 = Math.max(1, expectedLocation - binMid + 1);
    let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
    let bitArr = Array(finish + 2);
    bitArr[finish + 1] = (1 << i) - 1;
    for (let j = finish; j >= start2; j -= 1) {
      let currentLocation = j - 1;
      let charMatch = patternAlphabet[text.charAt(currentLocation)];
      if (computeMatches) {
        matchMask[currentLocation] = +!!charMatch;
      }
      bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
      if (i) {
        bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
      }
      if (bitArr[j] & mask) {
        finalScore = computeScore$1(pattern, {
          errors: i,
          currentLocation,
          expectedLocation,
          distance,
          ignoreLocation
        });
        if (finalScore <= currentThreshold) {
          currentThreshold = finalScore;
          bestLocation = currentLocation;
          if (bestLocation <= expectedLocation) {
            break;
          }
          start2 = Math.max(1, 2 * expectedLocation - bestLocation);
        }
      }
    }
    const score = computeScore$1(pattern, {
      errors: i + 1,
      currentLocation: expectedLocation,
      expectedLocation,
      distance,
      ignoreLocation
    });
    if (score > currentThreshold) {
      break;
    }
    lastBitArr = bitArr;
  }
  const result = {
    isMatch: bestLocation >= 0,
    score: Math.max(1e-3, finalScore)
  };
  if (computeMatches) {
    const indices = convertMaskToIndices(matchMask, minMatchCharLength);
    if (!indices.length) {
      result.isMatch = false;
    } else if (includeMatches) {
      result.indices = indices;
    }
  }
  return result;
}
function createPatternAlphabet(pattern) {
  let mask = {};
  for (let i = 0, len = pattern.length; i < len; i += 1) {
    const char = pattern.charAt(i);
    mask[char] = (mask[char] || 0) | 1 << len - i - 1;
  }
  return mask;
}
class BitapSearch {
  constructor(pattern, {
    location = Config.location,
    threshold = Config.threshold,
    distance = Config.distance,
    includeMatches = Config.includeMatches,
    findAllMatches = Config.findAllMatches,
    minMatchCharLength = Config.minMatchCharLength,
    isCaseSensitive = Config.isCaseSensitive,
    ignoreLocation = Config.ignoreLocation
  } = {}) {
    this.options = {
      location,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreLocation
    };
    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    this.chunks = [];
    if (!this.pattern.length) {
      return;
    }
    const addChunk = (pattern2, startIndex) => {
      this.chunks.push({
        pattern: pattern2,
        alphabet: createPatternAlphabet(pattern2),
        startIndex
      });
    };
    const len = this.pattern.length;
    if (len > MAX_BITS) {
      let i = 0;
      const remainder = len % MAX_BITS;
      const end2 = len - remainder;
      while (i < end2) {
        addChunk(this.pattern.substr(i, MAX_BITS), i);
        i += MAX_BITS;
      }
      if (remainder) {
        const startIndex = len - MAX_BITS;
        addChunk(this.pattern.substr(startIndex), startIndex);
      }
    } else {
      addChunk(this.pattern, 0);
    }
  }
  searchIn(text) {
    const { isCaseSensitive, includeMatches } = this.options;
    if (!isCaseSensitive) {
      text = text.toLowerCase();
    }
    if (this.pattern === text) {
      let result2 = {
        isMatch: true,
        score: 0
      };
      if (includeMatches) {
        result2.indices = [[0, text.length - 1]];
      }
      return result2;
    }
    const {
      location,
      distance,
      threshold,
      findAllMatches,
      minMatchCharLength,
      ignoreLocation
    } = this.options;
    let allIndices = [];
    let totalScore = 0;
    let hasMatches = false;
    this.chunks.forEach(({ pattern, alphabet: alphabet2, startIndex }) => {
      const { isMatch, score, indices } = search(text, pattern, alphabet2, {
        location: location + startIndex,
        distance,
        threshold,
        findAllMatches,
        minMatchCharLength,
        includeMatches,
        ignoreLocation
      });
      if (isMatch) {
        hasMatches = true;
      }
      totalScore += score;
      if (isMatch && indices) {
        allIndices = [...allIndices, ...indices];
      }
    });
    let result = {
      isMatch: hasMatches,
      score: hasMatches ? totalScore / this.chunks.length : 1
    };
    if (hasMatches && includeMatches) {
      result.indices = allIndices;
    }
    return result;
  }
}
class BaseMatch {
  constructor(pattern) {
    this.pattern = pattern;
  }
  static isMultiMatch(pattern) {
    return getMatch(pattern, this.multiRegex);
  }
  static isSingleMatch(pattern) {
    return getMatch(pattern, this.singleRegex);
  }
  search() {
  }
}
function getMatch(pattern, exp) {
  const matches = pattern.match(exp);
  return matches ? matches[1] : null;
}
class ExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return "exact";
  }
  static get multiRegex() {
    return /^="(.*)"$/;
  }
  static get singleRegex() {
    return /^=(.*)$/;
  }
  search(text) {
    const isMatch = text === this.pattern;
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    };
  }
}
class InverseExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return "inverse-exact";
  }
  static get multiRegex() {
    return /^!"(.*)"$/;
  }
  static get singleRegex() {
    return /^!(.*)$/;
  }
  search(text) {
    const index = text.indexOf(this.pattern);
    const isMatch = index === -1;
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    };
  }
}
class PrefixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return "prefix-exact";
  }
  static get multiRegex() {
    return /^\^"(.*)"$/;
  }
  static get singleRegex() {
    return /^\^(.*)$/;
  }
  search(text) {
    const isMatch = text.startsWith(this.pattern);
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    };
  }
}
class InversePrefixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return "inverse-prefix-exact";
  }
  static get multiRegex() {
    return /^!\^"(.*)"$/;
  }
  static get singleRegex() {
    return /^!\^(.*)$/;
  }
  search(text) {
    const isMatch = !text.startsWith(this.pattern);
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    };
  }
}
class SuffixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return "suffix-exact";
  }
  static get multiRegex() {
    return /^"(.*)"\$$/;
  }
  static get singleRegex() {
    return /^(.*)\$$/;
  }
  search(text) {
    const isMatch = text.endsWith(this.pattern);
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [text.length - this.pattern.length, text.length - 1]
    };
  }
}
class InverseSuffixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return "inverse-suffix-exact";
  }
  static get multiRegex() {
    return /^!"(.*)"\$$/;
  }
  static get singleRegex() {
    return /^!(.*)\$$/;
  }
  search(text) {
    const isMatch = !text.endsWith(this.pattern);
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    };
  }
}
class FuzzyMatch extends BaseMatch {
  constructor(pattern, {
    location = Config.location,
    threshold = Config.threshold,
    distance = Config.distance,
    includeMatches = Config.includeMatches,
    findAllMatches = Config.findAllMatches,
    minMatchCharLength = Config.minMatchCharLength,
    isCaseSensitive = Config.isCaseSensitive,
    ignoreLocation = Config.ignoreLocation
  } = {}) {
    super(pattern);
    this._bitapSearch = new BitapSearch(pattern, {
      location,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreLocation
    });
  }
  static get type() {
    return "fuzzy";
  }
  static get multiRegex() {
    return /^"(.*)"$/;
  }
  static get singleRegex() {
    return /^(.*)$/;
  }
  search(text) {
    return this._bitapSearch.searchIn(text);
  }
}
class IncludeMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return "include";
  }
  static get multiRegex() {
    return /^'"(.*)"$/;
  }
  static get singleRegex() {
    return /^'(.*)$/;
  }
  search(text) {
    let location = 0;
    let index;
    const indices = [];
    const patternLen = this.pattern.length;
    while ((index = text.indexOf(this.pattern, location)) > -1) {
      location = index + patternLen;
      indices.push([index, location - 1]);
    }
    const isMatch = !!indices.length;
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices
    };
  }
}
const searchers = [
  ExactMatch,
  IncludeMatch,
  PrefixExactMatch,
  InversePrefixExactMatch,
  InverseSuffixExactMatch,
  SuffixExactMatch,
  InverseExactMatch,
  FuzzyMatch
];
const searchersLen = searchers.length;
const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const OR_TOKEN = "|";
function parseQuery(pattern, options = {}) {
  return pattern.split(OR_TOKEN).map((item) => {
    let query = item.trim().split(SPACE_RE).filter((item2) => item2 && !!item2.trim());
    let results = [];
    for (let i = 0, len = query.length; i < len; i += 1) {
      const queryItem = query[i];
      let found = false;
      let idx = -1;
      while (!found && ++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isMultiMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          found = true;
        }
      }
      if (found) {
        continue;
      }
      idx = -1;
      while (++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isSingleMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          break;
        }
      }
    }
    return results;
  });
}
const MultiMatchSet = /* @__PURE__ */ new Set([FuzzyMatch.type, IncludeMatch.type]);
class ExtendedSearch {
  constructor(pattern, {
    isCaseSensitive = Config.isCaseSensitive,
    includeMatches = Config.includeMatches,
    minMatchCharLength = Config.minMatchCharLength,
    ignoreLocation = Config.ignoreLocation,
    findAllMatches = Config.findAllMatches,
    location = Config.location,
    threshold = Config.threshold,
    distance = Config.distance
  } = {}) {
    this.query = null;
    this.options = {
      isCaseSensitive,
      includeMatches,
      minMatchCharLength,
      findAllMatches,
      ignoreLocation,
      location,
      threshold,
      distance
    };
    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    this.query = parseQuery(this.pattern, this.options);
  }
  static condition(_, options) {
    return options.useExtendedSearch;
  }
  searchIn(text) {
    const query = this.query;
    if (!query) {
      return {
        isMatch: false,
        score: 1
      };
    }
    const { includeMatches, isCaseSensitive } = this.options;
    text = isCaseSensitive ? text : text.toLowerCase();
    let numMatches = 0;
    let allIndices = [];
    let totalScore = 0;
    for (let i = 0, qLen = query.length; i < qLen; i += 1) {
      const searchers2 = query[i];
      allIndices.length = 0;
      numMatches = 0;
      for (let j = 0, pLen = searchers2.length; j < pLen; j += 1) {
        const searcher = searchers2[j];
        const { isMatch, indices, score } = searcher.search(text);
        if (isMatch) {
          numMatches += 1;
          totalScore += score;
          if (includeMatches) {
            const type = searcher.constructor.type;
            if (MultiMatchSet.has(type)) {
              allIndices = [...allIndices, ...indices];
            } else {
              allIndices.push(indices);
            }
          }
        } else {
          totalScore = 0;
          numMatches = 0;
          allIndices.length = 0;
          break;
        }
      }
      if (numMatches) {
        let result = {
          isMatch: true,
          score: totalScore / numMatches
        };
        if (includeMatches) {
          result.indices = allIndices;
        }
        return result;
      }
    }
    return {
      isMatch: false,
      score: 1
    };
  }
}
const registeredSearchers = [];
function register(...args) {
  registeredSearchers.push(...args);
}
function createSearcher(pattern, options) {
  for (let i = 0, len = registeredSearchers.length; i < len; i += 1) {
    let searcherClass = registeredSearchers[i];
    if (searcherClass.condition(pattern, options)) {
      return new searcherClass(pattern, options);
    }
  }
  return new BitapSearch(pattern, options);
}
const LogicalOperator = {
  AND: "$and",
  OR: "$or"
};
const KeyType = {
  PATH: "$path",
  PATTERN: "$val"
};
const isExpression = (query) => !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
const isPath = (query) => !!query[KeyType.PATH];
const isLeaf = (query) => !isArray(query) && isObject$2(query) && !isExpression(query);
const convertToExplicit = (query) => ({
  [LogicalOperator.AND]: Object.keys(query).map((key) => ({
    [key]: query[key]
  }))
});
function parse(query, options, { auto: auto2 = true } = {}) {
  const next = (query2) => {
    let keys2 = Object.keys(query2);
    const isQueryPath = isPath(query2);
    if (!isQueryPath && keys2.length > 1 && !isExpression(query2)) {
      return next(convertToExplicit(query2));
    }
    if (isLeaf(query2)) {
      const key = isQueryPath ? query2[KeyType.PATH] : keys2[0];
      const pattern = isQueryPath ? query2[KeyType.PATTERN] : query2[key];
      if (!isString(pattern)) {
        throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
      }
      const obj = {
        keyId: createKeyId(key),
        pattern
      };
      if (auto2) {
        obj.searcher = createSearcher(pattern, options);
      }
      return obj;
    }
    let node = {
      children: [],
      operator: keys2[0]
    };
    keys2.forEach((key) => {
      const value = query2[key];
      if (isArray(value)) {
        value.forEach((item) => {
          node.children.push(next(item));
        });
      }
    });
    return node;
  };
  if (!isExpression(query)) {
    query = convertToExplicit(query);
  }
  return next(query);
}
function computeScore(results, { ignoreFieldNorm = Config.ignoreFieldNorm }) {
  results.forEach((result) => {
    let totalScore = 1;
    result.matches.forEach(({ key, norm: norm2, score }) => {
      const weight = key ? key.weight : null;
      totalScore *= Math.pow(
        score === 0 && weight ? Number.EPSILON : score,
        (weight || 1) * (ignoreFieldNorm ? 1 : norm2)
      );
    });
    result.score = totalScore;
  });
}
function transformMatches(result, data) {
  const matches = result.matches;
  data.matches = [];
  if (!isDefined(matches)) {
    return;
  }
  matches.forEach((match) => {
    if (!isDefined(match.indices) || !match.indices.length) {
      return;
    }
    const { indices, value } = match;
    let obj = {
      indices,
      value
    };
    if (match.key) {
      obj.key = match.key.src;
    }
    if (match.idx > -1) {
      obj.refIndex = match.idx;
    }
    data.matches.push(obj);
  });
}
function transformScore(result, data) {
  data.score = result.score;
}
function format(results, docs, {
  includeMatches = Config.includeMatches,
  includeScore = Config.includeScore
} = {}) {
  const transformers = [];
  if (includeMatches)
    transformers.push(transformMatches);
  if (includeScore)
    transformers.push(transformScore);
  return results.map((result) => {
    const { idx } = result;
    const data = {
      item: docs[idx],
      refIndex: idx
    };
    if (transformers.length) {
      transformers.forEach((transformer) => {
        transformer(result, data);
      });
    }
    return data;
  });
}
class Fuse {
  constructor(docs, options = {}, index) {
    this.options = { ...Config, ...options };
    if (this.options.useExtendedSearch && false) {
      throw new Error(EXTENDED_SEARCH_UNAVAILABLE);
    }
    this._keyStore = new KeyStore(this.options.keys);
    this.setCollection(docs, index);
  }
  setCollection(docs, index) {
    this._docs = docs;
    if (index && !(index instanceof FuseIndex)) {
      throw new Error(INCORRECT_INDEX_TYPE);
    }
    this._myIndex = index || createIndex(this.options.keys, this._docs, {
      getFn: this.options.getFn,
      fieldNormWeight: this.options.fieldNormWeight
    });
  }
  add(doc) {
    if (!isDefined(doc)) {
      return;
    }
    this._docs.push(doc);
    this._myIndex.add(doc);
  }
  remove(predicate = () => false) {
    const results = [];
    for (let i = 0, len = this._docs.length; i < len; i += 1) {
      const doc = this._docs[i];
      if (predicate(doc, i)) {
        this.removeAt(i);
        i -= 1;
        len -= 1;
        results.push(doc);
      }
    }
    return results;
  }
  removeAt(idx) {
    this._docs.splice(idx, 1);
    this._myIndex.removeAt(idx);
  }
  getIndex() {
    return this._myIndex;
  }
  search(query, { limit = -1 } = {}) {
    const {
      includeMatches,
      includeScore,
      shouldSort,
      sortFn,
      ignoreFieldNorm
    } = this.options;
    let results = isString(query) ? isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
    computeScore(results, { ignoreFieldNorm });
    if (shouldSort) {
      results.sort(sortFn);
    }
    if (isNumber(limit) && limit > -1) {
      results = results.slice(0, limit);
    }
    return format(results, this._docs, {
      includeMatches,
      includeScore
    });
  }
  _searchStringList(query) {
    const searcher = createSearcher(query, this.options);
    const { records } = this._myIndex;
    const results = [];
    records.forEach(({ v: text, i: idx, n: norm2 }) => {
      if (!isDefined(text)) {
        return;
      }
      const { isMatch, score, indices } = searcher.searchIn(text);
      if (isMatch) {
        results.push({
          item: text,
          idx,
          matches: [{ score, value: text, norm: norm2, indices }]
        });
      }
    });
    return results;
  }
  _searchLogical(query) {
    const expression = parse(query, this.options);
    const evaluate = (node, item, idx) => {
      if (!node.children) {
        const { keyId, searcher } = node;
        const matches = this._findMatches({
          key: this._keyStore.get(keyId),
          value: this._myIndex.getValueForItemAtKeyId(item, keyId),
          searcher
        });
        if (matches && matches.length) {
          return [
            {
              idx,
              item,
              matches
            }
          ];
        }
        return [];
      }
      const res = [];
      for (let i = 0, len = node.children.length; i < len; i += 1) {
        const child = node.children[i];
        const result = evaluate(child, item, idx);
        if (result.length) {
          res.push(...result);
        } else if (node.operator === LogicalOperator.AND) {
          return [];
        }
      }
      return res;
    };
    const records = this._myIndex.records;
    const resultMap = {};
    const results = [];
    records.forEach(({ $: item, i: idx }) => {
      if (isDefined(item)) {
        let expResults = evaluate(expression, item, idx);
        if (expResults.length) {
          if (!resultMap[idx]) {
            resultMap[idx] = { idx, item, matches: [] };
            results.push(resultMap[idx]);
          }
          expResults.forEach(({ matches }) => {
            resultMap[idx].matches.push(...matches);
          });
        }
      }
    });
    return results;
  }
  _searchObjectList(query) {
    const searcher = createSearcher(query, this.options);
    const { keys: keys2, records } = this._myIndex;
    const results = [];
    records.forEach(({ $: item, i: idx }) => {
      if (!isDefined(item)) {
        return;
      }
      let matches = [];
      keys2.forEach((key, keyIndex) => {
        matches.push(
          ...this._findMatches({
            key,
            value: item[keyIndex],
            searcher
          })
        );
      });
      if (matches.length) {
        results.push({
          idx,
          item,
          matches
        });
      }
    });
    return results;
  }
  _findMatches({ key, value, searcher }) {
    if (!isDefined(value)) {
      return [];
    }
    let matches = [];
    if (isArray(value)) {
      value.forEach(({ v: text, i: idx, n: norm2 }) => {
        if (!isDefined(text)) {
          return;
        }
        const { isMatch, score, indices } = searcher.searchIn(text);
        if (isMatch) {
          matches.push({
            score,
            key,
            value: text,
            idx,
            norm: norm2,
            indices
          });
        }
      });
    } else {
      const { v: text, n: norm2 } = value;
      const { isMatch, score, indices } = searcher.searchIn(text);
      if (isMatch) {
        matches.push({ score, key, value: text, norm: norm2, indices });
      }
    }
    return matches;
  }
}
Fuse.version = "6.6.2";
Fuse.createIndex = createIndex;
Fuse.parseIndex = parseIndex;
Fuse.config = Config;
{
  Fuse.parseQuery = parse;
}
{
  register(ExtendedSearch);
}
function baseFindIndex$1(array, predicate, fromIndex, fromRight) {
  var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}
var _baseFindIndex = baseFindIndex$1;
function baseIsNaN$1(value) {
  return value !== value;
}
var _baseIsNaN = baseIsNaN$1;
function strictIndexOf$1(array, value, fromIndex) {
  var index = fromIndex - 1, length = array.length;
  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}
var _strictIndexOf = strictIndexOf$1;
var baseFindIndex = _baseFindIndex, baseIsNaN = _baseIsNaN, strictIndexOf = _strictIndexOf;
function baseIndexOf$1(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
var _baseIndexOf = baseIndexOf$1;
var baseIndexOf = _baseIndexOf;
function arrayIncludes$1(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}
var _arrayIncludes = arrayIncludes$1;
function arrayIncludesWith$1(array, value, comparator) {
  var index = -1, length = array == null ? 0 : array.length;
  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}
var _arrayIncludesWith = arrayIncludesWith$1;
var SetCache = _SetCache, arrayIncludes = _arrayIncludes, arrayIncludesWith = _arrayIncludesWith, arrayMap = _arrayMap, baseUnary = _baseUnary, cacheHas = _cacheHas;
var LARGE_ARRAY_SIZE = 200;
function baseDifference$1(array, values, iteratee, comparator) {
  var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  } else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
    while (++index < length) {
      var value = array[index], computed2 = iteratee == null ? value : iteratee(value);
      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed2 === computed2) {
        var valuesIndex = valuesLength;
        while (valuesIndex--) {
          if (values[valuesIndex] === computed2) {
            continue outer;
          }
        }
        result.push(value);
      } else if (!includes(values, computed2, comparator)) {
        result.push(value);
      }
    }
  return result;
}
var _baseDifference = baseDifference$1;
var identity = identity_1, overRest = _overRest, setToString = _setToString;
function baseRest$1(func, start2) {
  return setToString(overRest(func, start2, identity), func + "");
}
var _baseRest = baseRest$1;
var isArrayLike = isArrayLike_1, isObjectLike = isObjectLike_1;
function isArrayLikeObject$1(value) {
  return isObjectLike(value) && isArrayLike(value);
}
var isArrayLikeObject_1 = isArrayLikeObject$1;
var baseDifference = _baseDifference, baseFlatten = _baseFlatten, baseRest = _baseRest, isArrayLikeObject = isArrayLikeObject_1;
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
});
var difference_1 = difference;
const Alignment = Object.freeze({
  LEFT: "left",
  RIGHT: "right",
  CENTER: "center"
});
const SortDirection = Object.freeze({
  ASC: "asc",
  DESC: "desc"
});
const Views = Object.freeze({
  COMFORTABLE: "comfortable",
  DENSE: "dense",
  CARD: "card"
});
const { Weights: Weights$1 } = Typography;
const getAlignmentClass = (header, key) => {
  var _a;
  return `data-table__cell--${((_a = header.find((i) => i.key === key)) == null ? void 0 : _a.alignment) || Alignment.LEFT}`;
};
const getOverflowClass = (header, key) => {
  var _a;
  return ((_a = header.find((i) => i.key === key)) == null ? void 0 : _a.allowOverflow) ? "data-table__cell--overflow" : "";
};
const getWeight = (header, key) => {
  var _a;
  return ((_a = header.find((i) => i.key === key)) == null ? void 0 : _a.bold) ? Weights$1.STRONG : Weights$1.REGULAR;
};
const getCheckboxModel = (data, defaultValue = false) => data.reduce((acc, cur) => {
  acc[cur.id] = defaultValue;
  return acc;
}, {});
const getFilteredHeaders = (header, data, shouldRemoveHidden) => Object.entries(header).map(([key, value], index) => {
  var _a, _b;
  return {
    key,
    index,
    ...value,
    sortable: value.sortable && data.every(
      (i) => {
        var _a2;
        return !i[key] || isString_1(i[key]) || isString_1((_a2 = i[key]) == null ? void 0 : _a2.label);
      }
    ),
    searchable: (_a = value.searchable) != null ? _a : true,
    visible: (_b = value.visible) != null ? _b : true
  };
}).filter((i) => !shouldRemoveHidden || i.visible);
const getSearchableData = (headers, item = {}) => Object.entries(item).reduce((acc, [key, val]) => {
  var _a;
  if ((_a = headers.find((h2) => h2.key === key)) == null ? void 0 : _a.searchable) {
    if (isString_1(val)) {
      acc.push(key);
    }
    if (isString_1(val == null ? void 0 : val.label)) {
      acc.push(`${key}.label`);
    }
  }
  return acc;
}, []);
const mapDataRows = (data, headers) => data.map((row) => {
  const removedInvalidKeys = Object.entries(row).map(([key, value]) => ({
    key,
    value
  })).filter(
    (i) => headers.some(
      (j) => j.key === i.key || i.key === "id" || i.key === "meta"
    )
  ).reduce((acc, cur) => {
    acc[cur.key] = cur.value;
    return acc;
  }, {});
  const diff = difference_1(
    headers.map((item) => item.key),
    Object.keys(removedInvalidKeys)
  );
  const fullItem = {
    ...removedInvalidKeys,
    ...diff.reduce((acc, cur) => {
      acc[cur] = " ";
      return acc;
    }, {})
  };
  const sort = Object.entries(fullItem).sort(([keyA], [keyB]) => {
    const a = headers.find((h2) => h2.key === keyA);
    const b = headers.find((h2) => h2.key === keyB);
    return (a == null ? void 0 : a.index) > (b == null ? void 0 : b.index) ? 1 : -1;
  }).reduce((acc, [key, val]) => {
    acc[key] = val;
    return acc;
  }, {});
  return sort;
});
const getSortedFilteredData = (data, headers, sortModel, filter, searchQuery) => {
  const raw = data;
  const mapped = mapDataRows(data, headers);
  const fuse = new Fuse(mapped, {
    keys: getSearchableData(headers, data == null ? void 0 : data[0]),
    threshold: 0.4
  });
  const mappedAndSearched = searchQuery ? fuse.search(searchQuery).map((i) => i.item) : mapped;
  const results = mappedAndSearched.filter(filter || (() => true)).sort((a, b) => {
    var _a, _b;
    const { key, direction } = sortModel;
    const aVal = ((_a = a[key]) == null ? void 0 : _a.label) || a[key];
    const bVal = ((_b = b[key]) == null ? void 0 : _b.label) || b[key];
    if (aVal < bVal) {
      return direction === SortDirection.ASC ? -1 : 1;
    }
    if (aVal > bVal) {
      return direction === SortDirection.ASC ? 1 : -1;
    }
    return 0;
  });
  return {
    raw,
    mapped,
    mappedAndSearched,
    results
  };
};
const getGridColStyle = (header, isSelectable) => {
  const style = header.reduce((acc, cur) => {
    const width = cur.width ? `${cur.width}px` : 0;
    const minWidth = cur.overflowText ? "100px" : "min-content";
    const fraction = `${cur.priority ? 2 : 1}fr`;
    return `${acc} minmax(${minWidth}, ${width || fraction})`;
  }, `grid-template-columns: ${isSelectable ? "minmax(min-content, 50px)" : ""} `);
  return style;
};
const setSortModel = (cell, sortModel = {}) => {
  const currentSortModel = sortModel;
  if (sortModel.key === cell.key) {
    switch (sortModel.direction) {
      case SortDirection.ASC:
        currentSortModel.direction = SortDirection.DESC;
        break;
      case SortDirection.DESC:
        currentSortModel.key = "";
        currentSortModel.direction = "";
        break;
      default:
        currentSortModel.direction = SortDirection.ASC;
        break;
    }
  } else {
    currentSortModel.key = cell.key;
    currentSortModel.direction = SortDirection.ASC;
  }
  return currentSortModel;
};
const allFilter = {
  label: "All",
  method: () => true,
  id: "ALL"
};
const getDataFilters = (filters) => {
  if (!(filters == null ? void 0 : filters.length)) {
    return [];
  }
  return [allFilter, ...filters].map((filter) => {
    var _a;
    return {
      ...filter,
      id: (_a = filter.id) != null ? _a : shortid.generate()
    };
  });
};
var render$1H = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "width": "104", "height": "104", "viewBox": "0 0 104 104", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M10.4 52.0004C10.4 63.0334 14.7828 73.6145 22.5844 81.416C30.3859 89.2175 40.967 93.6004 52 93.6004C63.033 93.6004 73.6141 89.2175 81.4156 81.416C89.2171 73.6145 93.6 63.0334 93.6 52.0004C93.6 40.9674 89.2171 30.3863 81.4156 22.5847C73.6141 14.7832 63.033 10.4004 52 10.4004C40.967 10.4004 30.3859 14.7832 22.5844 22.5847C14.7828 30.3863 10.4 40.9674 10.4 52.0004Z", "fill": "#EAE3F2" } }), _c("path", { attrs: { "d": "M41.0904 82.9109C41.0904 83.3431 42.2349 83.7577 44.272 84.0633C46.3092 84.3689 49.0722 84.5406 51.9532 84.5406C54.8342 84.5406 57.5972 84.3689 59.6344 84.0633C61.6715 83.7577 62.816 83.3431 62.816 82.9109C62.816 82.4787 61.6715 82.0642 59.6344 81.7586C57.5972 81.4529 54.8342 81.2812 51.9532 81.2812C49.0722 81.2812 46.3092 81.4529 44.272 81.7586C42.2349 82.0642 41.0904 82.4787 41.0904 82.9109Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M78.0718 26.9044C78.0718 26.2287 77.8033 25.5806 77.3255 25.1027C76.8476 24.6249 76.1995 24.3564 75.5238 24.3564H30.5562C29.8805 24.3564 29.2324 24.6249 28.7545 25.1027C28.2767 25.5806 28.0082 26.2287 28.0082 26.9044V71.873C28.0082 72.2076 28.0741 72.5389 28.2022 72.8481C28.3302 73.1572 28.5179 73.4381 28.7545 73.6747C28.9911 73.9113 29.272 74.099 29.5812 74.2271C29.8903 74.3551 30.2216 74.421 30.5562 74.421H63.777C71.1474 71.6463 76.1405 66.9829 78.0718 59.9057V26.9044Z", "fill": "white" } }), _c("path", { attrs: { "d": "M39.1841 24.3564H30.5521C29.8763 24.3564 29.2282 24.6249 28.7504 25.1027C28.2725 25.5806 28.0041 26.2287 28.0041 26.9044V71.873C28.0041 72.2076 28.07 72.5389 28.198 72.8481C28.3261 73.1572 28.5138 73.4381 28.7504 73.6747C28.987 73.9113 29.2679 74.099 29.577 74.2271C29.8862 74.3551 30.2175 74.421 30.5521 74.421H39.1841V24.3564Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M78.0718 26.9044C78.0718 26.2287 77.8033 25.5806 77.3255 25.1027C76.8476 24.6249 76.1995 24.3564 75.5238 24.3564H30.5562C29.8805 24.3564 29.2324 24.6249 28.7545 25.1027C28.2767 25.5806 28.0082 26.2287 28.0082 26.9044V71.873C28.0082 72.2076 28.0741 72.5389 28.2022 72.8481C28.3302 73.1572 28.5179 73.4381 28.7545 73.6747C28.9911 73.9113 29.272 74.099 29.5812 74.2271C29.8903 74.3551 30.2216 74.421 30.5562 74.421H63.777C71.1474 71.6463 76.1405 66.9829 78.0718 59.9057V26.9044Z", "stroke": "#260347", "stroke-width": "1.04", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M28.0082 64.4082H66.4706", "stroke": "#260347", "stroke-width": "1.04", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M63.777 74.4213C63.777 74.4213 67.8496 70.1573 66.0483 61.2185C66.0182 61.068 66.0202 60.9128 66.0544 60.7631C66.0885 60.6134 66.1539 60.4726 66.2464 60.35C66.3388 60.2274 66.4562 60.1257 66.5907 60.0517C66.7252 59.9777 66.8739 59.933 67.027 59.9206C75.6319 59.2311 78.0718 59.9061 78.0718 59.9061C76.1405 66.9833 71.1474 71.6466 63.777 74.4213Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": "1.04", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M39.1841 24.3564V74.421", "stroke": "#260347", "stroke-width": "1.04", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M28.0082 34.3701H78.0718", "stroke": "#260347", "stroke-width": "1.04", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M28.0082 44.3828H78.0718", "stroke": "#260347", "stroke-width": "1.04", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M28.0082 54.3955H78.0718", "stroke": "#260347", "stroke-width": "1.04", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var staticRenderFns$v = [];
const __vue2_script$v = {};
const __cssModules$v = {};
var __component__$v = /* @__PURE__ */ normalizeComponent(
  __vue2_script$v,
  render$1H,
  staticRenderFns$v,
  false,
  __vue2_injectStyles$v,
  null,
  null,
  null
);
function __vue2_injectStyles$v(context) {
  for (let o in __cssModules$v) {
    this[o] = __cssModules$v[o];
  }
}
var EmptyListIcon = /* @__PURE__ */ function() {
  return __component__$v.exports;
}();
var render$1G = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("button", _vm._g({ staticClass: "filter", class: { "filter--active": _vm.active, "filter--even": _vm.countIsNull } }, _vm.$listeners), [_c("TypeBody", { staticClass: "filter__label", attrs: { "variant": "text", "weight": "medium" } }, [_vm._t("default", [_vm._v(" " + _vm._s(_vm.label) + " ")])], 2), !_vm.countIsNull ? _c("div", [_c("TypeBody", { staticClass: "filter__count", attrs: { "variant": "legal", "tag": "div", "weight": "strong" } }, [_vm._t("count", [_vm._v(" " + _vm._s(_vm.count) + " ")])], 2)], 1) : _vm._e()], 1);
};
var staticRenderFns$u = [];
var DataTableFilter_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$u = defineComponent({
  components: {
    TypeBody
  },
  props: {
    label: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      default: 0
    },
    active: {
      type: Boolean,
      default: true
    }
  },
  setup(props2) {
    const countIsNull = computed(() => props2.count === null);
    return {
      countIsNull
    };
  }
});
const __cssModules$u = {};
var __component__$u = /* @__PURE__ */ normalizeComponent(
  __vue2_script$u,
  render$1G,
  staticRenderFns$u,
  false,
  __vue2_injectStyles$u,
  "ad93fd3c",
  null,
  null
);
function __vue2_injectStyles$u(context) {
  for (let o in __cssModules$u) {
    this[o] = __cssModules$u[o];
  }
}
var DataTableFilter = /* @__PURE__ */ function() {
  return __component__$u.exports;
}();
var render$1F = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "filters" }, [_c("div", { staticClass: "flex flex-row space-x-2" }, _vm._l(_vm.filters, function(filter) {
    return _c("DataTableFilter", { key: filter.label, attrs: { "label": filter.label, "count": _vm.filterCounts[filter.id], "active": _vm.filterModel[filter.id] }, on: { "click": function($event) {
      return _vm.handleFilterClick(filter);
    } } });
  }), 1)]);
};
var staticRenderFns$t = [];
var DataTableFilters_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$t = defineComponent({
  components: {
    DataTableFilter
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    filterCounts: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: String,
      default: ""
    }
  },
  setup(props2, { emit }) {
    const filterModel = reactive(
      props2.filters.reduce((acc, cur) => {
        acc[cur.id] = cur.id === props2.value;
        return acc;
      }, {})
    );
    const initialFilterId = props2.filters[0].id;
    filterModel[initialFilterId] = true;
    const handleFilterClick = (filter) => {
      Object.keys(filterModel).forEach((key) => {
        filterModel[key] = false;
      });
      filterModel[filter.id] = true;
      emit("input", filter.id);
    };
    emit("input", initialFilterId);
    return {
      filterModel,
      handleFilterClick
    };
  }
});
const __cssModules$t = {};
var __component__$t = /* @__PURE__ */ normalizeComponent(
  __vue2_script$t,
  render$1F,
  staticRenderFns$t,
  false,
  __vue2_injectStyles$t,
  "3bc28820",
  null,
  null
);
function __vue2_injectStyles$t(context) {
  for (let o in __cssModules$t) {
    this[o] = __cssModules$t[o];
  }
}
var DataTableFilters = /* @__PURE__ */ function() {
  return __component__$t.exports;
}();
var root = _root;
var now$1 = function() {
  return root.Date.now();
};
var now_1 = now$1;
var reWhitespace = /\s/;
function trimmedEndIndex$1(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {
  }
  return index;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
var reTrimStart = /^\s+/;
function baseTrim$1(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
var _baseTrim = baseTrim$1;
var baseTrim = _baseTrim, isObject$1 = isObject_1, isSymbol = isSymbol_1;
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber$1(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$1(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$1;
var isObject = isObject_1, now = now_1, toNumber = toNumber_1;
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax = Math.max, nativeMin = Math.min;
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_1 = debounce;
var render$1E = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "controls" }, [_c("TextInput", { staticClass: "controls__search", attrs: { "id": "data-table-search", "pre-icon": "search", "show-reset": true, "placeholder": _vm.searchPlaceholder }, model: { value: _vm.model.search, callback: function($$v) {
    _vm.$set(_vm.model, "search", $$v);
  }, expression: "model.search" } }), _vm.showViewBtns ? _c("div", { staticClass: "controls__views" }, _vm._l(_vm.viewBtns, function(btn) {
    return _c("IconButton", { key: btn.icon, staticClass: "controls__views__btn", class: { "controls__views__btn--active": _vm.isActive(btn.view) }, attrs: { "icon": btn.icon, "flat": "", "variant": _vm.isActive(btn.view) ? "primary" : "secondary" }, on: { "click": function($event) {
      return _vm.handleViewUpdate(btn.view);
    } } });
  }), 1) : _vm._e()], 1);
};
var staticRenderFns$s = [];
var DataTableControls_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$s = defineComponent({
  components: {
    TextInput,
    IconButton,
    BaseButton
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        search: "",
        view: Views.COMFORTABLE
      })
    },
    showDenseView: {
      type: Boolean,
      default: false
    },
    showCardView: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      required: true
    }
  },
  setup(props2, { emit }) {
    const model = reactive(cloneDeep_1(props2.value));
    const isActive = (view) => model.view === view;
    const handleViewUpdate = (view) => {
      model.view = view;
    };
    watch(
      model,
      (updated) => {
        const { search: search2 } = updated;
        debounce_1(() => {
          if (search2 === model.search) {
            emit("input", model);
          }
        }, 400)();
      },
      { deep: true }
    );
    const viewBtns = computed(
      () => [
        props2.showDenseView && {
          icon: "threeStack",
          view: Views.DENSE
        },
        {
          icon: "twoStack",
          view: Views.COMFORTABLE
        },
        props2.showCardView && {
          icon: "cardLayout",
          view: Views.CARD
        }
      ].filter(Boolean)
    );
    const showViewBtns = computed(() => viewBtns.value.length > 1);
    return {
      model,
      viewBtns,
      isActive,
      handleViewUpdate,
      showViewBtns
    };
  }
});
const __cssModules$s = {};
var __component__$s = /* @__PURE__ */ normalizeComponent(
  __vue2_script$s,
  render$1E,
  staticRenderFns$s,
  false,
  __vue2_injectStyles$s,
  "7ef4c7a8",
  null,
  null
);
function __vue2_injectStyles$s(context) {
  for (let o in __cssModules$s) {
    this[o] = __cssModules$s[o];
  }
}
var DataTableControls = /* @__PURE__ */ function() {
  return __component__$s.exports;
}();
function paginate(totalItems, currentPage, pageSize, maxPages) {
  if (currentPage === void 0) {
    currentPage = 1;
  }
  if (pageSize === void 0) {
    pageSize = 10;
  }
  if (maxPages === void 0) {
    maxPages = 10;
  }
  var totalPages = Math.ceil(totalItems / pageSize);
  if (currentPage < 1) {
    currentPage = 1;
  } else if (currentPage > totalPages) {
    currentPage = totalPages;
  }
  var startPage, endPage;
  if (totalPages <= maxPages) {
    startPage = 1;
    endPage = totalPages;
  } else {
    var maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
    var maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
    if (currentPage <= maxPagesBeforeCurrentPage) {
      startPage = 1;
      endPage = maxPages;
    } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
      startPage = totalPages - maxPages + 1;
      endPage = totalPages;
    } else {
      startPage = currentPage - maxPagesBeforeCurrentPage;
      endPage = currentPage + maxPagesAfterCurrentPage;
    }
  }
  var startIndex = (currentPage - 1) * pageSize;
  var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
  var pages = Array.from(Array(endPage + 1 - startPage).keys()).map(function(i) {
    return startPage + i;
  });
  return {
    totalItems,
    currentPage,
    pageSize,
    totalPages,
    startPage,
    endPage,
    startIndex,
    endIndex,
    pages
  };
}
var jwPaginate = paginate;
var render$1D = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("nav", { staticClass: "pagination-navigation", attrs: { "role": "navigation", "aria-label": "Pagination Navigation" } }, [_c("ul", { staticClass: "pagination-navigation__list" }, [_c("li", { staticClass: "pagination-navigation__item" }, [_c("IconButton", _vm._b({ attrs: { "disabled": _vm.isOnFirstPage, "icon": "chevronLeft", "title": "Previous" }, on: { "click": _vm.handlePreviousClick } }, "IconButton", _vm.buttonProps, false))], 1), _vm._l(_vm.pages, function(page) {
    return _c("li", { key: page, staticClass: "pagination-navigation__item" }, [_c("BaseButton", _vm._b({ attrs: { "label": "" + page, "title": "Go to page " + page, "disabled": page === _vm.value }, on: { "click": function($event) {
      return _vm.handlePageClick(page);
    } } }, "BaseButton", _vm.buttonProps, false))], 1);
  }), _c("li", { staticClass: "pagination-navigation__item" }, [_c("IconButton", _vm._b({ attrs: { "disabled": _vm.isOnLastPage, "icon": "chevronRight", "title": "Next" }, on: { "click": _vm.handleNextClick } }, "IconButton", _vm.buttonProps, false))], 1)], 2)]);
};
var staticRenderFns$r = [];
var PaginationNavigation_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$r = defineComponent({
  name: "PaginationNavigation",
  components: { BaseButton, IconButton },
  props: {
    flat: {
      type: Boolean,
      default: false
    },
    maxPages: {
      type: Number,
      default: 6
    },
    pageSize: {
      type: Number,
      default: 1
    },
    size: {
      type: String,
      default: Button.Sizes.MEDIUM,
      validator: (value) => Object.values(Button.Sizes).includes(value)
    },
    totalItems: {
      type: Number,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    variant: {
      type: String,
      default: Button.Variants.PRIMARY,
      validator: (value) => Object.values(Button.Variants).includes(value)
    }
  },
  setup(props2, { emit }) {
    const buttonProps = computed(() => {
      return {
        flat: props2.flat,
        size: props2.size,
        variant: props2.variant,
        type: "button"
      };
    });
    const pagination = computed(() => {
      return jwPaginate(
        props2.totalItems,
        props2.value,
        props2.pageSize,
        props2.maxPages
      );
    });
    const pages = computed(() => pagination.value.pages);
    const totalPages = computed(() => pagination.value.totalPages);
    const isOnFirstPage = computed(() => props2.value === 1);
    const isOnLastPage = computed(() => props2.value === totalPages.value);
    const handleNextClick = () => {
      emit("input", Math.min(totalPages.value, props2.value + 1));
    };
    const handlePreviousClick = () => {
      emit("input", Math.max(1, props2.value - 1));
    };
    const handlePageClick = (page) => {
      emit("input", page);
    };
    return {
      buttonProps,
      isOnFirstPage,
      isOnLastPage,
      pages,
      handleNextClick,
      handlePreviousClick,
      handlePageClick
    };
  }
});
const __cssModules$r = {};
var __component__$r = /* @__PURE__ */ normalizeComponent(
  __vue2_script$r,
  render$1D,
  staticRenderFns$r,
  false,
  __vue2_injectStyles$r,
  "c7b3d690",
  null,
  null
);
function __vue2_injectStyles$r(context) {
  for (let o in __cssModules$r) {
    this[o] = __cssModules$r[o];
  }
}
var PaginationNavigation = /* @__PURE__ */ function() {
  return __component__$r.exports;
}();
var render$1C = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.totalPageCount > 1 || _vm.totalSelectedCount ? _c("div", _vm._b({}, "div", _vm.$attrs, false), [_vm.totalSelectedCount ? _c("div", { staticClass: "data-table__bulk-actions" }, [_c("div", [_c("TypeBody", { attrs: { "variant": "medium", "weight": "strong" } }, [_vm._v(" " + _vm._s(_vm.totalSelectedCount) + " Selected ")])], 1), _vm.actions.length ? _c("div", { staticClass: "data-table__bulk-actions__btns" }, _vm._l(_vm.actions, function(action) {
    return _c("BaseButton", _vm._b({ key: action.id, staticClass: "data-table__bulk-actions__btn", attrs: { "size": "large" }, on: { "click": function($event) {
      return action.handler(_vm.checkModel);
    } } }, "BaseButton", action.attrs, false));
  }), 1) : _vm._e()]) : _vm._e(), _c("div", { staticClass: "data-table__pagination" }, [_vm.totalPageCount > 1 ? _c("PaginationNavigation", { attrs: { "size": "small", "value": _vm.value, "total-items": _vm.isSsPaginated ? _vm.totalPages : _vm.itemCount, "page-size": _vm.isSsPaginated ? 1 : _vm.maxItemsPerPage, "variant": "secondary", "flat": "" }, on: { "input": function($event) {
    return _vm.$emit("input", $event);
  } } }) : _vm._e()], 1)]) : _vm._e();
};
var staticRenderFns$q = [];
var DataTableFooter_vue_vue_type_style_index_0_lang = "";
const __vue2_script$q = defineComponent({
  components: {
    BaseButton,
    PaginationNavigation,
    TypeBody
  },
  props: {
    actions: {
      type: Array,
      default: () => []
    },
    totalPages: {
      type: Number,
      default: 0
    },
    maxItemsPerPage: {
      type: Number,
      default: 0
    },
    checkModel: {
      type: Object
    },
    value: {
      type: Number,
      default: 0
    },
    isSsPaginated: {
      type: Boolean
    },
    itemCount: {
      type: Number
    },
    totalPageCount: {
      type: Number
    },
    totalSelectedCount: {
      type: Number
    }
  }
});
const __cssModules$q = {};
var __component__$q = /* @__PURE__ */ normalizeComponent(
  __vue2_script$q,
  render$1C,
  staticRenderFns$q,
  false,
  __vue2_injectStyles$q,
  null,
  null,
  null
);
function __vue2_injectStyles$q(context) {
  for (let o in __cssModules$q) {
    this[o] = __cssModules$q[o];
  }
}
var DataTableFooter = /* @__PURE__ */ function() {
  return __component__$q.exports;
}();
var render$1B = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "data-table__wrapper" }, [_c("div", { staticClass: "data-table__wrapper__top" }, [_c("div", { staticClass: "data-table__utils" }, [_vm.searchable ? _c("DataTableControls", { staticClass: "mb-4", attrs: { "value": _vm.controlsModel, "show-dense-view": _vm.denseView, "show-card-view": _vm.showCardView, "search-placeholder": _vm.searchPlaceholder }, on: { "input": _vm.handleControlsInput } }) : _vm._e(), _vm.dataFilters && _vm.dataFilters.length ? _c("DataTableFilters", { attrs: { "filters": _vm.dataFilters, "filter-counts": _vm.filterCounts }, model: { value: _vm.selectedFilterId, callback: function($$v) {
    _vm.selectedFilterId = $$v;
  }, expression: "selectedFilterId" } }) : _vm._e()], 1)]), _c("div", { staticClass: "data-table__wrapper__mid" }, [_vm.isCardView ? _c("div", [_vm.paginatedData && _vm.paginatedData.length && !_vm.loading && _vm.checkModel ? _c("div", { staticClass: "data-table__card-wrapper", class: "col-count-" + _vm.cardRowCount }, _vm._l(_vm.paginatedData, function(row) {
    return _c(_vm.cardComponent, _vm._b({ key: row.id, tag: "component", attrs: { "value": _vm.checkModel[row.id] }, on: { "input": function($event) {
      return _vm.updateCheckModel(row.id, $event);
    } } }, "component", row, false));
  }), 1) : _vm._e()]) : _c("table", { staticClass: "data-table", style: _vm.classes }, [_c("thead", { staticClass: "data-table__container" }, [_c("tr", { staticClass: "data-table__row" }, [_vm.selectable ? _c("th", { staticClass: "\n              data-table__cell\n              data-table__cell--header\n              data-table__cell--check\n            " }, [_c("CheckboxInput", { attrs: { "indeterminate": _vm.selectAllIsIndeterminate }, on: { "input": _vm.handleSelectAllInput }, model: { value: _vm.selectAll, callback: function($$v) {
    _vm.selectAll = $$v;
  }, expression: "selectAll" } })], 1) : _vm._e(), _vm._l(_vm.filteredHeaders, function(cell, index) {
    return _c("th", { key: "header:" + cell.label + "-" + index, staticClass: "data-table__cell data-table__cell--header", class: [
      _vm.getAlignmentClass(_vm.filteredHeaders, cell.key),
      {
        "data-table__cell--sortable": cell.sortable
      }
    ], on: { "click": function($event) {
      return _vm.handleSort(cell);
    } } }, [_c("TypeBody", { staticClass: "data-table__cell__text data-table__cell__text--header", attrs: { "variant": "small", "weight": "strong" } }, [_vm._v(" " + _vm._s(cell.label) + " ")]), cell.sortable ? _c("BaseIcon", { staticClass: "data-table__sort", class: [
      {
        "data-table__sort--asc": _vm.colIsSorted(cell.key) && _vm.isSortedAsc,
        "data-table__sort--desc": _vm.colIsSorted(cell.key) && _vm.isSortedDesc
      }
    ], attrs: { "icon": _vm.Icons.UP_DOWN } }) : _vm._e()], 1);
  })], 2)]), _vm.paginatedData && _vm.paginatedData.length && !_vm.loading && _vm.checkModel ? _c("tbody", { staticClass: "data-table__container" }, _vm._l(_vm.paginatedData, function(row) {
    return _c("tr", { key: row.id, staticClass: "data-table__row", class: { "data-table__row--clickable": !!_vm.$listeners["row-click"] }, on: { "click": function($event) {
      return _vm.handleRowClick(row, $event);
    } } }, [_vm.selectable ? _c("td", { staticClass: "data-table__cell data-table__cell--check" }, [_c("CheckboxInput", { attrs: { "value": _vm.checkModel[row.id] }, on: { "input": function($event) {
      return _vm.updateCheckModel(row.id, $event);
    } } })], 1) : _vm._e(), _vm._l(Object.keys(row).filter(
      function(i) {
        return i !== "id" && i !== "meta";
      }
    ), function(cell) {
      return _c("td", { key: row.id + ":" + cell, staticClass: "data-table__cell", class: [
        _vm.getAlignmentClass(_vm.filteredHeaders, cell),
        _vm.getOverflowClass(_vm.filteredHeaders, cell)
      ] }, [_vm.isString(row[cell]) ? _c("TypeBody", { staticClass: "data-table__cell__text", attrs: { "variant": "text", "weight": _vm.getWeight(_vm.filteredHeaders, cell) } }, [_vm._v(" " + _vm._s(row[cell]) + " ")]) : _c("div", { staticClass: "data-table__cell__component" }, [_c(row[cell].component, _vm._g(_vm._b({ tag: "component" }, "component", row[cell].attrs, false), row[cell].handlers))], 1)], 1);
    })], 2);
  }), 0) : _vm._e()]), _vm.loading ? _c("div", { staticClass: "data-table__loading" }, [_c("AnnularThrobber")], 1) : _vm._e(), !(_vm.paginatedData && _vm.paginatedData.length) && !_vm.loading ? _c("div", [_vm._t("empty", [_c("div", { staticClass: "data-table__empty" }, [_c("div", [_c("EmptyListIcon")], 1), _c("TypeBody", { attrs: { "variant": "small", "weight": "strong" } }, [_vm._v(" " + _vm._s(_vm.emptyStateText) + " ")])], 1)])], 2) : _vm._e()]), _vm.checkModel ? _c("DataTableFooter", { staticClass: "data-table__wrapper__bottom", attrs: { "actions": _vm.actions, "total-pages": _vm.totalPages, "max-items-per-page": _vm.maxItemsPerPage, "is-ss-paginated": _vm.isSsPaginated, "item-count": _vm.itemCount, "total-page-count": _vm.totalPageCount, "total-selected-count": _vm.totalSelectedCount, "check-model": _vm.checkModel }, model: { value: _vm.currentViewPage, callback: function($$v) {
    _vm.currentViewPage = $$v;
  }, expression: "currentViewPage" } }) : _vm._e()], 1);
};
var staticRenderFns$p = [];
var DataTable_vue_vue_type_style_index_0_scoped_true_lang = "";
const emptySortModel = {
  key: "",
  direction: ""
};
const __vue2_script$p = defineComponent({
  name: "DataTable",
  components: {
    BaseIcon,
    IconButton,
    CheckboxInput,
    TypeBody,
    DataTableFilters,
    EmptyListIcon,
    DataTableControls,
    BaseButton,
    AnnularThrobber,
    DataTableFooter
  },
  props: {
    searchPlaceholder: {
      type: String,
      default: "Search"
    },
    selectable: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({
        header: {},
        body: []
      })
    },
    actions: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Array,
      default: () => []
    },
    denseView: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    emptyStateText: {
      type: String,
      default: "No results found"
    },
    maxItemsPerPage: {
      type: Number,
      default: 25
    },
    totalPages: {
      type: Number,
      required: false
    },
    currentPage: {
      type: Number,
      required: false
    },
    totalItemCount: {
      type: Number,
      required: false
    },
    cardComponent: {
      type: Object,
      default: () => ({})
    },
    cardRowCount: {
      type: Number,
      default: 4
    },
    defaultView: {
      type: String,
      default: Views.COMFORTABLE
    },
    defaultSearch: {
      type: String,
      default: ""
    }
  },
  setup(props2, { emit }) {
    var _a;
    const selectAll = ref(false);
    const sortModel = reactive(cloneDeep_1(emptySortModel));
    const controlsModel = reactive({
      search: props2.defaultSearch,
      view: props2.defaultView
    });
    const dataFilters = reactive(getDataFilters(props2.filters));
    const selectedFilterId = ref(((_a = dataFilters == null ? void 0 : dataFilters[0]) == null ? void 0 : _a.id) || "");
    const currentFilter = computed(
      () => dataFilters.find((filter) => filter.id === selectedFilterId.value)
    );
    const isSsPaginated = computed(
      () => !!(props2.totalPages && props2.currentPage && props2.totalItemCount)
    );
    const filteredHeaders = computed(
      () => getFilteredHeaders(
        props2.data.header,
        props2.data.body,
        controlsModel.view !== Views.CARD
      )
    );
    const filteredData = computed(
      () => {
        var _a2;
        return getSortedFilteredData(
          props2.data.body,
          filteredHeaders.value,
          isSsPaginated.value ? emptySortModel : sortModel,
          isSsPaginated.value ? () => true : (_a2 = currentFilter.value) == null ? void 0 : _a2.method,
          isSsPaginated.value ? "" : controlsModel.search
        );
      }
    );
    const classes = computed(
      () => getGridColStyle(filteredHeaders.value, props2.selectable)
    );
    const isSortedAsc = computed(
      () => sortModel.direction === SortDirection.ASC
    );
    const isSortedDesc = computed(
      () => sortModel.direction === SortDirection.DESC
    );
    const itemCount = computed(() => {
      var _a2;
      return (_a2 = filteredData.value.results) == null ? void 0 : _a2.length;
    });
    const totalPageCount = computed(
      () => props2.totalPages || Math.ceil(itemCount.value / props2.maxItemsPerPage)
    );
    const currentViewPage = ref(1);
    const paginatedData = computed(() => {
      if (isSsPaginated.value) {
        return filteredData.value.results;
      }
      const start2 = (currentViewPage.value - 1) * props2.maxItemsPerPage;
      const end2 = start2 + props2.maxItemsPerPage;
      return filteredData.value.results.slice(start2, end2);
    });
    const filterCounts = computed(
      () => dataFilters.reduce((acc, filter) => {
        var _a2;
        const isCurrentFilter = filter.id === selectedFilterId.value;
        const isAllFilter = filter.id === "ALL";
        acc[filter.id] = isSsPaginated.value ? null : (_a2 = filteredData.value.mappedAndSearched.filter(filter == null ? void 0 : filter.method)) == null ? void 0 : _a2.length;
        if (isAllFilter && !acc[filter.id]) {
          acc[filter.id] = props2.totalItemCount;
        }
        if (isCurrentFilter && !acc[filter.id]) {
          acc[filter.id] = itemCount.value;
        }
        return acc;
      }, {})
    );
    watch(
      [currentFilter, controlsModel],
      () => {
        if (currentViewPage.value > totalPageCount.value) {
          nextTick(() => {
            currentViewPage.value = totalPageCount.value || 1;
          });
        }
      },
      { deep: true }
    );
    const colIsSorted = (key) => sortModel.key === key;
    const setCheckModel = (isSs, value, data) => {
      if (isSs) {
        return value;
      }
      if (data == null ? void 0 : data.length) {
        return getCheckboxModel(data, props2.defaultValue);
      }
      return null;
    };
    const checkModel = ref(
      setCheckModel(isSsPaginated.value, props2.value, filteredData.value.raw)
    );
    const setCheckModelWatcher = () => {
      watch(checkModel, (model) => {
        const someAreTrue = Object.values(model).some((i) => i);
        selectAll.value = someAreTrue;
        emit("input", model);
      });
    };
    if (checkModel.value) {
      setCheckModelWatcher();
    } else {
      const unwatch = watch(filteredData, (val) => {
        var _a2;
        if ((_a2 = val.raw) == null ? void 0 : _a2.length) {
          checkModel.value = getCheckboxModel(val.raw, props2.defaultValue);
          setCheckModelWatcher();
          if (unwatch) {
            unwatch();
          }
        }
      });
    }
    const totalSelectedCount = computed(
      () => {
        var _a2;
        return (_a2 = Object.values(checkModel.value).filter((i) => i)) == null ? void 0 : _a2.length;
      }
    );
    watch(props2.value, (val) => {
      if (!isEqual_1(val, checkModel.value)) {
        checkModel.value = {
          ...checkModel.value,
          ...val
        };
      }
    });
    const allChecksAreTrue = computed(
      () => checkModel.value && Object.values(checkModel.value).every((i) => i)
    );
    watch(allChecksAreTrue, (val) => {
      if (val) {
        selectAll.value = true;
      }
    });
    const someChecksAreTrue = computed(
      () => checkModel.value && Object.values(checkModel.value).some((i) => i)
    );
    const selectAllIsIndeterminate = computed(
      () => someChecksAreTrue.value && !allChecksAreTrue.value
    );
    const handleSelectAllInput = (isSelected) => {
      if (!checkModel.value) {
        return;
      }
      checkModel.value = {
        ...checkModel.value,
        ...Object.entries(checkModel.value).reduce((acc, [key, val]) => {
          if (isSelected && (filteredData.value.results.some((d) => d.id === key) || isSsPaginated.value)) {
            acc[key] = isSelected;
          } else if (!isSelected) {
            acc[key] = false;
          }
          return acc;
        }, {})
      };
    };
    const handleSort = (cell) => {
      if (!(cell == null ? void 0 : cell.sortable)) {
        return;
      }
      Object.assign(sortModel, setSortModel(cell, sortModel));
    };
    const handleControlsInput = (updated) => {
      Object.assign(controlsModel, updated);
    };
    watch(
      sortModel,
      (newSortModel) => {
        emit("sort-change", newSortModel);
      },
      { immediate: true }
    );
    const isCardView = computed(() => controlsModel.view === Views.CARD);
    watch(
      controlsModel,
      ({ search: search2, view }) => {
        sortModel.key = "";
        sortModel.direction = "";
        emit("view-change", view);
        emit("search-change", search2);
      },
      { immediate: true }
    );
    watch(currentFilter, () => {
      emit("filter-change", currentFilter.id);
    });
    watch(currentViewPage, (newPage) => {
      emit("page-change", newPage);
    });
    const updateCheckModel = (id, value) => {
      checkModel.value = {
        ...checkModel.value,
        [id]: value
      };
    };
    const showCardView = computed(
      () => !!Object.keys(props2.cardComponent).length
    );
    const handleRowClick = (row, event) => {
      const eventIsCheckbox = event.target.classList.contains("checkbox-input") || !!event.target.closest(".checkbox-input");
      if (eventIsCheckbox) {
        return;
      }
      emit("row-click", row);
    };
    return {
      handleRowClick,
      allChecksAreTrue,
      someChecksAreTrue,
      checkModel,
      classes,
      colIsSorted,
      controlsModel,
      currentViewPage,
      dataFilters,
      filterCounts,
      filteredData,
      filteredHeaders,
      getAlignmentClass,
      getOverflowClass,
      getWeight,
      handleControlsInput,
      handleSelectAllInput,
      handleSort,
      Icons: Icons$1,
      isSortedAsc,
      isSortedDesc,
      isSsPaginated,
      isString: isString_1,
      itemCount,
      paginatedData,
      selectAll,
      selectAllIsIndeterminate,
      selectedFilterId,
      sortModel,
      totalPageCount,
      totalSelectedCount,
      currentFilter,
      updateCheckModel,
      isCardView,
      showCardView
    };
  }
});
const __cssModules$p = {};
var __component__$p = /* @__PURE__ */ normalizeComponent(
  __vue2_script$p,
  render$1B,
  staticRenderFns$p,
  false,
  __vue2_injectStyles$p,
  "d0efe2c6",
  null,
  null
);
function __vue2_injectStyles$p(context) {
  for (let o in __cssModules$p) {
    this[o] = __cssModules$p[o];
  }
}
var DataTable = /* @__PURE__ */ function() {
  return __component__$p.exports;
}();
var render$1A = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("FocusLock", { staticClass: "focus-lock", attrs: { "disabled": !_vm.active } }, [_c("div", { staticClass: "drawer-panel", class: [
    "drawer-panel--" + _vm.size,
    { "drawer-panel--active": _vm.active, "drawer-panel--dark": _vm.dark }
  ], attrs: { "aria-hidden": !_vm.active } }, [!!_vm.$slots.header ? _c("header", { staticClass: "drawer-panel__header" }, [_vm._t("header")], 2) : _vm._e(), _vm._t("default"), _vm.showClose && _vm.active ? _c("ModalClose", { attrs: { "variant": "light" }, on: { "click": function($event) {
    return _vm.$emit("close");
  } } }) : _vm._e()], 2), _vm.active ? _c("div", { staticClass: "drawer-panel__overlay", on: { "click": function($event) {
    return _vm.$emit("close");
  } } }) : _vm._e()]);
};
var staticRenderFns$o = [];
var DrawerPanel_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$o = defineComponent({
  components: { FocusLock, ModalClose },
  inheritAttrs: false,
  props: {
    active: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: Modal.Sizes.REGULAR,
      validator: (value) => [...Object.values(Modal.Sizes), "full"].includes(value)
    }
  },
  setup(_, { emit }) {
    const handleKeyup = (e) => {
      if (e.keyCode !== 27) {
        return;
      }
      emit("close");
    };
    onMounted(() => {
      document.addEventListener("keyup", handleKeyup);
    });
    onBeforeUnmount(() => {
      document.removeEventListener("keyup", handleKeyup);
    });
    return {
      handleKeyup
    };
  }
});
const __cssModules$o = {};
var __component__$o = /* @__PURE__ */ normalizeComponent(
  __vue2_script$o,
  render$1A,
  staticRenderFns$o,
  false,
  __vue2_injectStyles$o,
  "114de62b",
  null,
  null
);
function __vue2_injectStyles$o(context) {
  for (let o in __cssModules$o) {
    this[o] = __cssModules$o[o];
  }
}
var DrawerPanel = /* @__PURE__ */ function() {
  return __component__$o.exports;
}();
var render$1z = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("BaseCard", { staticClass: "fancy-card", class: { "fancy-card--ornate": _vm.ornate }, scopedSlots: _vm._u([{ key: "header", fn: function() {
    return [_c("div", { staticClass: "fancy-card__strip", attrs: { "aria-hidden": "" } }, _vm._l(_vm.colors, function(ref2) {
      var name = ref2[0];
      var hex = ref2[1];
      return _c("div", { key: name, staticClass: "fancy-card__strip-tile", style: { background: hex } });
    }), 0)];
  }, proxy: true }, { key: "footer", fn: function() {
    return [_vm._t("footer")];
  }, proxy: true }], null, true) }, [_vm._t("default")], 2);
};
var staticRenderFns$n = [];
var FancyCard_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$n = {
  components: { BaseCard },
  props: {
    ornate: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const colors2 = computed(() => Object.entries(extendedPalette));
    return { colors: colors2 };
  }
};
const __cssModules$n = {};
var __component__$n = /* @__PURE__ */ normalizeComponent(
  __vue2_script$n,
  render$1z,
  staticRenderFns$n,
  false,
  __vue2_injectStyles$n,
  "cd4bd53e",
  null,
  null
);
function __vue2_injectStyles$n(context) {
  for (let o in __cssModules$n) {
    this[o] = __cssModules$n[o];
  }
}
var FancyCard = /* @__PURE__ */ function() {
  return __component__$n.exports;
}();
var render$1y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M61.77 60.503c0 .925-9.74 1.674-21.756 1.674-12.015 0-21.76-.749-21.76-1.674 0-.925 9.746-1.673 21.76-1.673 12.015 0 21.756.75 21.756 1.673Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M64 58.272a1.12 1.12 0 0 1-1.116 1.116H34.53a1.12 1.12 0 0 1-1.12-1.116v-39.05a1.12 1.12 0 0 1 1.12-1.116h23.43a1.113 1.113 0 0 1 .79.327l4.924 4.927a1.115 1.115 0 0 1 .327.789L64 58.272Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M64 58.272a1.12 1.12 0 0 1-1.116 1.116H34.53a1.12 1.12 0 0 1-1.12-1.116v-39.05a1.12 1.12 0 0 1 1.12-1.116h23.43a1.113 1.113 0 0 1 .79.327l4.924 4.927a1.115 1.115 0 0 1 .327.789L64 58.272Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M50.151 49.346a5.578 5.578 0 1 0 11.157 0 5.578 5.578 0 0 0-11.157 0Z", "stroke": "#481D72", "stroke-width": ".75" } }), _c("path", { attrs: { "d": "m52.94 49.346 2.232 2.232 3.627-4.184M40.667 31.494h17.294M42.246 28.147h7.41M40.667 34.842h17.294M40.667 38.189h17.294", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M58.424 22.67a1.012 1.012 0 0 0 1.016 1.014h4.455a1.093 1.093 0 0 0-.218-.326l-4.925-4.925a1.11 1.11 0 0 0-.327-.219l-.001 4.456Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M47.5 56.04H14.677a.88.88 0 0 1-.88-.88v-3.4a3.528 3.528 0 0 1 3.528-3.528h27.53a3.528 3.528 0 0 1 3.528 3.528v3.4a.881.881 0 0 1-.883.88ZM36.312 33.725H25.865a2.03 2.03 0 0 1-.714-.135c.546 1.138 2.032 5.112 2.032 14.64h7.81c0-9.528 1.487-13.502 2.034-14.64-.229.088-.47.134-.715.135Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M45.824 58.694a1.014 1.014 0 0 1-.96.694H17.315a1.015 1.015 0 0 1-.96-.694l-.887-2.654h31.24l-.884 2.654Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M47.5 56.04H14.677a.88.88 0 0 1-.88-.88v-3.4a3.528 3.528 0 0 1 3.528-3.528h27.53a3.528 3.528 0 0 1 3.528 3.528v3.4a.881.881 0 0 1-.883.88ZM36.312 33.725H25.865a2.03 2.03 0 0 1-.714-.135c.546 1.138 2.032 5.112 2.032 14.64h7.81c0-9.528 1.487-13.502 2.034-14.64-.229.088-.47.134-.715.135Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M45.824 58.694a1.015 1.015 0 0 1-.96.694H17.315a1.015 1.015 0 0 1-.96-.694l-.887-2.654h31.24l-.884 2.654ZM27.117 44.883h7.943", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M23.836 24.8H38.34v8.926H23.836V24.8Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M23.836 24.8H38.34v8.926H23.836V24.8Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } })]);
};
var approveDocument = {
  render: render$1y
};
var render$1x = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 72 72", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M51.677 47.985c-.131.055-.263.088-.394.12a2.515 2.515 0 0 1-.307.088c-.23.044-.47.055-.7.044l-3.44-.164c-.428-.033-.833.219-1.03.602l-1.578 3.057a3.233 3.233 0 0 1-.866 1.051 3.27 3.27 0 0 1-1.216.614c-.153.044-.317.055-.47.077-.066.01-.143.033-.209.033a3.329 3.329 0 0 1-1.95-.515l-.055-.033 5.368 9.333 3.44-5.214a2.166 2.166 0 0 1 1.698-.975l6.245-.373-4.47-7.745h-.066ZM31.958 53.276c-.055.022-.098.044-.153.055a3.776 3.776 0 0 1-.504.132c-.033.01-.066.01-.088.022a3.691 3.691 0 0 1-.482.032c-.022 0-.044-.01-.066-.01a3.686 3.686 0 0 1-.777-.1 3.27 3.27 0 0 1-1.107-.547 3.228 3.228 0 0 1-.975-1.128l-1.588-3.057a1.122 1.122 0 0 0-1.041-.602l-3.44.164a3.224 3.224 0 0 1-.723-.055c-.077-.01-.153-.044-.241-.065a1.772 1.772 0 0 1-.471-.132c-.011-.01-.033-.01-.044-.01l-4.47 7.744 6.245.373c.69.044 1.325.405 1.698.986l3.44 5.214 5.379-9.322-.055.033a3.09 3.09 0 0 1-.537.273Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m41.325 29.153-2.334-.34a2.356 2.356 0 0 1-1.786-1.292l-1.04-2.114c-.011-.022-.044-.099-.165-.099-.12 0-.142.077-.164.099l-1.04 2.114a2.338 2.338 0 0 1-1.786 1.293l-2.334.34c-.033 0-.11.01-.142.12-.033.11.022.164.044.186l1.687 1.643c.558.548.81 1.326.679 2.093l-.395 2.322c0 .033-.021.11.077.175.088.066.164.022.186.011l2.093-1.095a2.393 2.393 0 0 1 2.213 0l2.092 1.095a.187.187 0 0 0 .186-.01c.088-.066.077-.143.077-.176l-.394-2.322a2.354 2.354 0 0 1 .679-2.093l1.687-1.643c.022-.022.077-.077.044-.186-.055-.099-.143-.11-.164-.12Z", "fill": "#16A7A7" } }), _c("path", { attrs: { "d": "M36 17.377c-7.252 0-13.145 5.893-13.145 13.146 0 7.252 5.893 13.146 13.146 13.146 7.252 0 13.146-5.894 13.146-13.146 0-7.253-5.894-13.146-13.146-13.146Zm6.946 13.65L41.26 32.67c-.044.044-.066.098-.055.153l.395 2.323a2.365 2.365 0 0 1-.942 2.322 2.343 2.343 0 0 1-2.498.175l-2.093-1.095c-.054-.033-.12-.033-.164 0l-2.092 1.096a2.33 2.33 0 0 1-1.107.273c-.493 0-.975-.153-1.391-.46a2.365 2.365 0 0 1-.942-2.322l.394-2.323a.161.161 0 0 0-.055-.153l-1.687-1.643a2.371 2.371 0 0 1-.602-2.421 2.364 2.364 0 0 1 1.917-1.61l2.333-.34c.055-.011.11-.044.132-.1l1.04-2.113a2.37 2.37 0 0 1 2.126-1.326c.91 0 1.72.504 2.125 1.326l1.04 2.114c.023.055.078.088.132.099l2.334.34a2.364 2.364 0 0 1 1.917 1.61 2.264 2.264 0 0 1-.57 2.432Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M54.778 32.308a3.32 3.32 0 0 1 0-3.56l1.862-2.903c.175-.263.22-.58.131-.888a1.12 1.12 0 0 0-.558-.7l-3.057-1.59a3.32 3.32 0 0 1-1.785-3.078l.164-3.44a1.075 1.075 0 0 0-.329-.832 1.06 1.06 0 0 0-.832-.329l-3.44.165a3.295 3.295 0 0 1-3.09-1.786l-1.577-3.057a1.06 1.06 0 0 0-.701-.558 1.062 1.062 0 0 0-.888.131l-2.903 1.863a3.32 3.32 0 0 1-3.56 0l-2.903-1.863a1.076 1.076 0 0 0-.877-.142 1.156 1.156 0 0 0-.7.559l-1.578 3.056a3.33 3.33 0 0 1-3.079 1.786l-3.45-.154a1.038 1.038 0 0 0-.833.329c-.22.219-.34.515-.329.832l.165 3.44a3.317 3.317 0 0 1-1.786 3.09l-3.057 1.588a1.06 1.06 0 0 0-.558.701c-.088.296-.044.603.131.877l1.862 2.903a3.32 3.32 0 0 1 0 3.56l-1.862 2.903c-.175.263-.22.57-.142.877.087.307.285.548.558.701l3.057 1.578a3.325 3.325 0 0 1 1.785 3.089l-.164 3.44c-.01.296.099.57.296.788l.088.088c.087.077.175.132.274.186a.327.327 0 0 0 .109.044c.12.044.252.066.405.066l3.44-.164h.154c.087 0 .164.01.24.022.045 0 .077 0 .121.01.132.011.252.033.384.066.021.011.043.011.076.011.12.033.241.066.35.11.034.01.067.022.1.033.098.043.197.087.284.142l.132.066c.076.044.142.098.208.142.055.044.12.077.175.12.055.044.11.1.154.143.054.055.12.11.175.164.055.055.098.12.153.176.044.054.099.11.143.175.087.12.175.263.24.394l1.59 3.057a1.06 1.06 0 0 0 1.062.58c.186-.01.361-.054.515-.153l2.903-1.862a3.324 3.324 0 0 1 3.55-.011s.01 0 .01.01l2.903 1.863c.154.099.34.142.515.154.12.01.241.01.362-.022a1.12 1.12 0 0 0 .7-.56l1.59-3.056a3.35 3.35 0 0 1 3.078-1.785l3.44.164c.131 0 .273-.022.394-.066l.099-.033c.098-.043.197-.11.285-.186l.087-.087c.197-.22.307-.493.296-.79l-.164-3.44a3.317 3.317 0 0 1 1.785-3.088l3.057-1.578a1.06 1.06 0 0 0 .558-.701 1.108 1.108 0 0 0-.142-.888l-1.851-2.892ZM36 45.86c-8.458 0-15.338-6.88-15.338-15.337 0-8.458 6.88-15.338 15.338-15.338 8.457 0 15.337 6.88 15.337 15.338 0 8.457-6.88 15.337-15.337 15.337Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M56.618 31.125a1.12 1.12 0 0 1 0-1.194l1.862-2.903a3.274 3.274 0 0 0 .406-2.63 3.352 3.352 0 0 0-1.676-2.08l-3.057-1.59a1.125 1.125 0 0 1-.602-1.029l.164-3.44a3.266 3.266 0 0 0-.953-2.498 3.317 3.317 0 0 0-2.487-.964l-3.44.165c-.427.032-.843-.22-1.04-.603l-1.59-3.056a3.324 3.324 0 0 0-2.08-1.677 3.311 3.311 0 0 0-2.63.406l-2.903 1.862a1.12 1.12 0 0 1-1.194 0l-2.903-1.862a3.274 3.274 0 0 0-2.63-.406 3.324 3.324 0 0 0-2.08 1.677l-1.578 3.056c-.198.383-.614.635-1.041.603l-3.44-.165a3.35 3.35 0 0 0-2.487.964 3.307 3.307 0 0 0-.964 2.487l.164 3.44c.022.427-.219.833-.602 1.04l-3.057 1.578a3.324 3.324 0 0 0-1.676 2.082 3.311 3.311 0 0 0 .406 2.629l1.862 2.903c.23.362.23.833 0 1.194l-1.862 2.903a3.275 3.275 0 0 0-.406 2.63 3.324 3.324 0 0 0 1.676 2.081l3.057 1.578c.383.197.613.602.602 1.04l-.164 3.44c-.022.559.11 1.118.362 1.61l-4.744 8.228a2.181 2.181 0 0 0-.033 2.136 2.178 2.178 0 0 0 1.797 1.15l6.244.373 3.451 5.215a2.159 2.159 0 0 0 1.83.986h.065a2.182 2.182 0 0 0 1.83-1.096L36 51.381l6.923 12.007a2.181 2.181 0 0 0 1.83 1.096h.065c.734 0 1.414-.362 1.83-.986l3.44-5.215 6.244-.373a2.154 2.154 0 0 0 1.797-1.15 2.183 2.183 0 0 0-.033-2.136l-4.744-8.216a3.277 3.277 0 0 0 .362-1.61l-.164-3.44c-.022-.428.219-.844.602-1.041l3.057-1.589a3.324 3.324 0 0 0 1.676-2.081 3.311 3.311 0 0 0-.406-2.63l-1.862-2.892ZM27.171 62.292l-3.44-5.214a2.207 2.207 0 0 0-1.698-.986l-6.245-.373 4.47-7.745c.011.011.033.011.044.011.153.066.307.11.47.142.078.022.154.055.242.066.23.044.471.055.723.055l3.44-.164c.427-.033.832.219 1.04.602l1.59 3.057c.23.449.569.832.974 1.128.329.241.701.438 1.107.548.262.066.514.099.777.099.022 0 .044.01.066.01.164 0 .329-.01.482-.032a.206.206 0 0 0 .088-.022c.175-.033.34-.077.504-.132.055-.022.11-.033.153-.055a3.65 3.65 0 0 0 .548-.273l.055-.033-5.39 9.311Zm29.042-6.573-6.245.373a2.196 2.196 0 0 0-1.698.975l-3.44 5.225-5.379-9.322.055.033a3.33 3.33 0 0 0 1.95.514c.066 0 .143-.022.208-.032.154-.022.318-.033.471-.077a3.27 3.27 0 0 0 1.216-.614c.351-.284.647-.646.866-1.051l1.577-3.057c.198-.383.603-.635 1.03-.602l3.44.164c.241.011.471-.01.701-.044.11-.022.197-.055.307-.087.131-.033.263-.066.394-.12.022-.012.044-.012.055-.023l4.492 7.745Zm.57-19.631a1.156 1.156 0 0 1-.56.701l-3.056 1.578a3.325 3.325 0 0 0-1.785 3.089l.164 3.44c.01.296-.099.57-.296.788l-.088.088a1.156 1.156 0 0 1-.284.186l-.099.033a1.241 1.241 0 0 1-.394.066l-3.44-.164c-1.271-.044-2.498.635-3.079 1.785l-1.588 3.057a1.06 1.06 0 0 1-1.063.58 1.048 1.048 0 0 1-.515-.153L37.797 49.3s-.01 0-.01-.011a3.301 3.301 0 0 0-3.55.01l-2.903 1.863c-.154.099-.34.142-.515.154-.12.01-.241.01-.362-.022a1.12 1.12 0 0 1-.7-.56l-1.59-3.056a3.44 3.44 0 0 0-.24-.394c-.044-.066-.099-.12-.143-.175a2.185 2.185 0 0 0-.153-.176c-.055-.054-.12-.11-.175-.164-.055-.044-.1-.099-.154-.142-.055-.044-.11-.077-.175-.12-.066-.045-.143-.1-.208-.143l-.132-.066a3.47 3.47 0 0 0-.285-.142l-.098-.033c-.12-.044-.23-.088-.35-.11-.023-.01-.045-.01-.077-.01a2.166 2.166 0 0 0-.384-.066c-.033 0-.076 0-.12-.011a1.783 1.783 0 0 0-.241-.022h-.154l-3.44.164a1.017 1.017 0 0 1-.405-.066c-.033-.01-.077-.022-.11-.044a1.1 1.1 0 0 1-.273-.186c-.033-.033-.066-.055-.088-.087a1.108 1.108 0 0 1-.296-.79l.165-3.44a3.317 3.317 0 0 0-1.786-3.088l-3.057-1.578a1.06 1.06 0 0 1-.558-.701 1.062 1.062 0 0 1 .131-.888l1.862-2.903a3.32 3.32 0 0 0 0-3.56l-1.862-2.903a1.076 1.076 0 0 1-.142-.877 1.12 1.12 0 0 1 .558-.7l3.057-1.59a3.325 3.325 0 0 0 1.785-3.089l-.153-3.428c-.01-.318.099-.614.329-.833.219-.22.515-.35.832-.329l3.44.165a3.29 3.29 0 0 0 3.079-1.786l1.577-3.057a1.06 1.06 0 0 1 .701-.558 1.08 1.08 0 0 1 .899.131l2.903 1.863a3.32 3.32 0 0 0 3.56 0l2.903-1.863a1.1 1.1 0 0 1 .888-.142c.306.087.547.285.7.559l1.578 3.056a3.314 3.314 0 0 0 3.09 1.786l3.44-.165c.328-.022.613.099.832.329.22.22.34.515.329.833l-.164 3.44a3.29 3.29 0 0 0 1.785 3.078l3.057 1.588c.285.143.482.395.558.701.088.307.033.614-.131.888l-1.862 2.903a3.32 3.32 0 0 0 0 3.56l1.862 2.904c.153.273.208.58.131.887Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M36 15.185c-8.457 0-15.337 6.88-15.337 15.338 0 8.457 6.88 15.337 15.338 15.337 8.457 0 15.337-6.88 15.337-15.337 0-8.458-6.88-15.338-15.337-15.338Zm0 28.484c-7.252 0-13.146-5.894-13.146-13.146 0-7.253 5.894-13.146 13.147-13.146 7.252 0 13.146 5.893 13.146 13.146 0 7.252-5.894 13.146-13.146 13.146Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "m41.642 26.984-2.333-.34c-.055-.01-.11-.043-.131-.098l-1.041-2.114a2.37 2.37 0 0 0-2.126-1.326c-.909 0-1.72.504-2.125 1.326l-1.04 2.114c-.022.055-.077.088-.132.099l-2.333.34a2.364 2.364 0 0 0-1.918 1.61 2.316 2.316 0 0 0 .603 2.42l1.687 1.644c.044.044.066.099.055.153l-.395 2.323a2.365 2.365 0 0 0 .942 2.322c.417.307.899.46 1.392.46.372 0 .756-.087 1.106-.273l2.093-1.096c.044-.033.11-.033.164 0l2.093 1.096a2.367 2.367 0 0 0 3.44-2.498l-.395-2.323a.16.16 0 0 1 .055-.153l1.687-1.643a2.384 2.384 0 0 0 .602-2.433c-.317-.854-1.051-1.478-1.95-1.61Zm-.219 2.476-1.687 1.643a2.363 2.363 0 0 0-.679 2.093l.394 2.322c0 .033.022.11-.076.175-.088.066-.165.022-.187.011l-2.092-1.095a2.393 2.393 0 0 0-2.213 0l-2.092 1.095a.187.187 0 0 1-.187-.01c-.087-.066-.076-.143-.076-.176l.394-2.322a2.354 2.354 0 0 0-.68-2.093l-1.686-1.643c-.022-.022-.077-.077-.044-.186.033-.11.12-.12.142-.12l2.334-.34a2.357 2.357 0 0 0 1.785-1.293l1.041-2.114c.011-.022.044-.099.165-.099.12 0 .142.077.164.099l1.04 2.114a2.338 2.338 0 0 0 1.786 1.293l2.334.34c.022 0 .11.01.142.12.055.11 0 .164-.022.186Z", "fill": "#481D72" } })]);
};
var award = {
  render: render$1x
};
var render$1w = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M11.723 55.495a30.843 30.843 0 1 1 56.554 0H11.723Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M11.73 55.494a30.845 30.845 0 0 0 56.54 0H11.73Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M9.928 55.494h60.145M6.458 55.494h1.928M71.614 55.494h1.928", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40.099 6.895a.543.543 0 0 1-.807 0c-.507-.564-1.625-1.187-4.037-.746-3.468.634-3.85 4.043-6.14 4.297-2.986.33-4.096-2.458-3.424 1.375.54 3.088 3.349 4.299 7.344 4.299 3.128 0 5.44-1.79 6.297-2.567a.542.542 0 0 1 .727 0c.858.778 3.17 2.567 6.298 2.567 3.996 0 6.802-1.21 7.343-4.297.672-3.833-.438-1.045-3.424-1.375-2.29-.255-2.671-3.664-6.14-4.297-2.411-.443-3.53.18-4.037.744Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M19.51 35.015h39.749v22.71h-39.75v-22.71Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M19.51 35.015h39.749v22.71h-39.75v-22.71Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M22.033 33.123h-5.047l3.785-10.094h3.785l-2.523 10.094Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M27.08 33.123h-5.047l2.523-10.094h4.416L27.08 33.123Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M32.126 33.123H27.08l1.892-10.094h4.416l-1.262 10.094Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M37.173 33.123h-5.047l1.262-10.094h4.415l-.63 10.094Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M42.22 33.123h-5.047l.63-10.094h3.786l.63 10.094ZM57.36 33.123h5.046L58.62 23.029h-3.785l2.523 10.094Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M52.313 33.123h5.046l-2.523-10.094H50.42l1.893 10.094Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M47.266 33.123h5.047L50.42 23.029h-4.416l1.262 10.094Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M42.22 33.123h5.046l-1.261-10.094h-4.416l.63 10.094Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M22.033 33.123h-5.047l3.785-10.094h3.785l-2.523 10.094Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M27.08 33.123h-5.047l2.523-10.094h4.416L27.08 33.123Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M32.126 33.123H27.08l1.892-10.094h4.416l-1.262 10.094ZM37.173 33.123h-5.047l1.262-10.094h4.415l-.63 10.094Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M42.22 33.123h-5.047l.63-10.094h3.786l.63 10.094ZM57.36 33.123h5.046L58.62 23.029h-3.785l2.523 10.094Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.313 33.123h5.046l-2.523-10.094H50.42l1.893 10.094ZM47.266 33.123h5.047L50.42 23.029h-4.416l1.262 10.094Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M42.22 33.123h5.046l-1.261-10.094h-4.416l.63 10.094Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M19.952 37.538h-.884a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.045v2.335a2.081 2.081 0 0 1-2.08 2.081Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M25 37.538h-.886a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.046v2.335A2.08 2.08 0 0 1 25 37.538ZM35.092 37.538h-.885a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.046v2.335a2.077 2.077 0 0 1-2.081 2.081Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M40.138 37.538h-.884a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.047v2.335a2.079 2.079 0 0 1-2.083 2.081Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M45.185 37.538H44.3a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.046v2.335a2.079 2.079 0 0 1-2.082 2.081Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M50.231 37.538h-.884a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.047v2.335a2.08 2.08 0 0 1-2.083 2.081Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M55.28 37.538h-.885a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.045v2.335a2.079 2.079 0 0 1-2.08 2.081Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M60.325 37.538h-.885a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.047v2.335a2.08 2.08 0 0 1-2.082 2.081Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M19.952 37.538h-.884a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.045v2.335a2.081 2.081 0 0 1-2.08 2.081ZM25 37.538h-.886a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.046v2.335A2.08 2.08 0 0 1 25 37.538Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M30.045 37.538h-.885a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.047v2.335a2.081 2.081 0 0 1-2.082 2.081Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M35.092 37.538h-.885a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.046v2.335a2.077 2.077 0 0 1-2.081 2.081Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40.138 37.538h-.884a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.047v2.335a2.079 2.079 0 0 1-2.083 2.081Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M45.185 37.538H44.3a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.046v2.335a2.079 2.079 0 0 1-2.082 2.081ZM50.231 37.538h-.884a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.047v2.335a2.08 2.08 0 0 1-2.083 2.081ZM55.28 37.538h-.885a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.045v2.335a2.079 2.079 0 0 1-2.08 2.081Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M60.325 37.538h-.885a2.08 2.08 0 0 1-2.08-2.08v-2.336h5.047v2.335a2.08 2.08 0 0 1-2.082 2.081Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.005 40.692a4.73 4.73 0 0 0-4.732 4.732v12.3h9.463v-12.3a4.732 4.732 0 0 0-4.731-4.732Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M52.005 40.692a4.73 4.73 0 0 0-4.732 4.732v12.3h9.463v-12.3a4.732 4.732 0 0 0-4.731-4.732Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M23.929 40.692h17.663v14.51H23.929v-14.51Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M23.929 40.692h17.663v14.51H23.929v-14.51ZM28.341 40.692v14.51M32.757 40.692v14.51M37.173 40.692v14.51M41.589 43.531H23.926M41.589 47.947H23.926M41.589 52.363H23.926", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.406 39.746h3.785v8.832h-3.785v-8.832Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M61.775 38.484h5.047v1.262h-5.047v-1.262ZM61.775 48.578h5.047v1.261h-5.047v-1.261Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.406 42.975v-1.41l3.636-1.819h.149v1.337l-3.785 1.892ZM62.406 48.022V46.61l3.785-1.892v1.41l-3.785 1.893ZM62.406 45.498v-1.41l3.785-1.893v1.41l-3.785 1.893Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M62.406 39.746h3.785v8.832h-3.785v-8.832ZM59.259 41.323h3.147M59.259 46.37h3.147", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.004 42.585a2.84 2.84 0 0 1 2.84 2.84v3.022a.447.447 0 0 1-.447.447h-4.784a.448.448 0 0 1-.447-.447v-3.022a2.84 2.84 0 0 1 2.838-2.84Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M48.623 53.94a.544.544 0 0 0 1.044.207.544.544 0 0 0-1.003-.415.544.544 0 0 0-.041.208Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M58.1 20.509H21.292a.52.52 0 0 0-.52.52v2.003h37.85v-2.003a.52.52 0 0 0-.52-.52ZM61.782 60.248H16.986v-.442a2.08 2.08 0 0 1 2.08-2.08h40.635a2.08 2.08 0 0 1 2.08 2.08v.442Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M32.124 16.096h1.892v4.416h-1.892v-4.416ZM45.372 16.096h1.892v4.416h-1.892v-4.416ZM49.159 50.155h5.677v1.892H49.16v-1.892Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.004 42.585a2.84 2.84 0 0 1 2.84 2.84v3.022a.447.447 0 0 1-.447.447h-4.784a.448.448 0 0 1-.447-.447v-3.022a2.84 2.84 0 0 1 2.838-2.84ZM40.099 6.895a.543.543 0 0 1-.807 0c-.507-.564-1.625-1.187-4.037-.746-3.468.634-3.85 4.043-6.14 4.297-2.986.33-4.096-2.458-3.424 1.375.54 3.088 3.349 4.299 7.344 4.299 3.128 0 5.44-1.79 6.297-2.567a.542.542 0 0 1 .727 0c.858.778 3.17 2.567 6.298 2.567 3.996 0 6.802-1.21 7.343-4.297.672-3.833-.438-1.045-3.424-1.375-2.29-.255-2.671-3.664-6.14-4.297-2.411-.443-3.53.18-4.037.744Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m19.428 54 2.115-1.379.617-3.141a.353.353 0 0 0-.649-.251l-2.483 4.105.4.666Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m16.509 52.621 3.443 2.244-3.41-5.636a.353.353 0 0 0-.65.252l.617 3.14Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M22.47 52.326a.354.354 0 0 0-.427-.03l-5.15 3.36h4.255l1.406-2.909a.354.354 0 0 0-.084-.421ZM19.026 53.335l1.068-1.767-.72-3.41a.354.354 0 0 0-.34-.28h-.006a.354.354 0 0 0-.343.268l-.819 3.276 1.16 1.913Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m21.16 55.653-5.15-3.36a.353.353 0 0 0-.512.45l1.406 2.908 4.256.002Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M21.471 58.834h-4.948l-.516-2.32a.707.707 0 0 1 .69-.86h4.6a.708.708 0 0 1 .69.86l-.516 2.32ZM16.523 58.834h4.948v1.414h-4.948v-1.413Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var barberShop = {
  render: render$1w
};
var render$1v = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } })]);
};
var blank = {
  render: render$1v
};
var render$1u = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M4.878 41.566a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M15.668 41.769a21.441 21.441 0 1 0 42.883 0 21.441 21.441 0 0 0-42.883 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M56.547 32.705A21.505 21.505 0 0 0 43.28 21.23h-3.185a2.944 2.944 0 0 0-2.952 2.361 2.838 2.838 0 0 0 2.8 3.315 2.276 2.276 0 0 1 2.198 2.854 2.33 2.33 0 0 1-2.29 1.686h-8.103a5.894 5.894 0 0 0-5.988 5.374 5.68 5.68 0 0 0 5.667 5.98h3.336a1.49 1.49 0 0 1 1.49 1.489v1.207a1.266 1.266 0 0 0 1.26 1.28 1.28 1.28 0 0 1 1.294 1.28v1.56c.02.242-.046.484-.186.681a3.41 3.41 0 0 0 .036 4.363 3.599 3.599 0 0 0 2.774 1.2h1.35c3.69 0 4.825-3.407 4.825-5.11v-5.68a3.085 3.085 0 0 1 1.66-2.74 4.551 4.551 0 0 0 2.174-3.877.197.197 0 0 0-.196-.192h-2.216a1.136 1.136 0 0 1-1.136-1.136v-1.419a1.136 1.136 0 0 1 1.136-1.136h4.852a2.839 2.839 0 0 0 2.667-1.865Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M15.668 41.769a21.441 21.441 0 1 0 42.883 0 21.441 21.441 0 0 0-42.883 0Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M56.547 32.705A21.505 21.505 0 0 0 43.28 21.23h-3.185a2.944 2.944 0 0 0-2.952 2.361 2.838 2.838 0 0 0 2.8 3.315 2.276 2.276 0 0 1 2.198 2.854 2.33 2.33 0 0 1-2.29 1.686h-8.103a5.894 5.894 0 0 0-5.988 5.374 5.68 5.68 0 0 0 5.667 5.98h3.336a1.49 1.49 0 0 1 1.49 1.489v1.207a1.266 1.266 0 0 0 1.26 1.28 1.28 1.28 0 0 1 1.294 1.28v1.56c.02.242-.046.484-.186.681a3.41 3.41 0 0 0 .036 4.363 3.599 3.599 0 0 0 2.774 1.2h1.35c3.69 0 4.825-3.407 4.825-5.11v-5.68a3.085 3.085 0 0 1 1.66-2.74 4.551 4.551 0 0 0 2.174-3.877.197.197 0 0 0-.196-.192h-2.216a1.136 1.136 0 0 1-1.136-1.136v-1.419a1.136 1.136 0 0 1 1.136-1.136h4.852a2.839 2.839 0 0 0 2.667-1.865Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M50.88 19.529a9.9 9.9 0 0 0 1.91 6.231.72.72 0 0 0 .96.176c1.181-.738 3.92-3.054 5.285-9.207.726-3.095.845-6.3.352-9.44a.726.726 0 0 1 1.093-.75A29.96 29.96 0 0 1 75.12 32c.208 9.127-7 16.934-16.13 16.904a16.087 16.087 0 0 1-16.038-16.086c0-6.619 2.995-11.44 6.817-13.92a.729.729 0 0 1 1.111.63Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M50.88 19.529a9.9 9.9 0 0 0 1.91 6.231.72.72 0 0 0 .96.176c1.181-.738 3.92-3.054 5.285-9.207.726-3.095.845-6.3.352-9.44a.726.726 0 0 1 1.093-.75A29.96 29.96 0 0 1 75.12 32c.208 9.127-7 16.934-16.13 16.904a16.087 16.087 0 0 1-16.038-16.086c0-6.619 2.995-11.44 6.817-13.92a.729.729 0 0 1 1.111.63Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M64.098 29.84a.733.733 0 0 0-1.01.765c.081.551.113 1.11.093 1.667-.127 3.645-2.4 5.871-4.953 5.783a4.005 4.005 0 0 1-3.588-2.393.734.734 0 0 0-1.391.177 8.038 8.038 0 0 0 6.991 9.48 8.044 8.044 0 0 0 3.858-15.48Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M64.098 29.84a.733.733 0 0 0-1.01.765c.081.551.113 1.11.093 1.667-.127 3.645-2.4 5.871-4.953 5.783a4.005 4.005 0 0 1-3.588-2.393.734.734 0 0 0-1.391.177 8.038 8.038 0 0 0 6.991 9.48 8.044 8.044 0 0 0 3.858-15.48Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var burningEarth = {
  render: render$1u
};
var render$1t = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M7.826 40.163a32.001 32.001 0 1 0 64.002 0 32.001 32.001 0 0 0-64.002 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "m22.966 33.127 33.25-25.935 16.602 21.285-33.25 25.935-16.602-21.285Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M31.267 36.275a.968.968 0 0 0-.026 1.226l6.099 7.82a.97.97 0 0 0 1.195.273 3.84 3.84 0 0 1 4.183.517.969.969 0 0 0 1.226.026l19.784-15.431A.97.97 0 0 0 64 29.51a3.84 3.84 0 0 1 .517-4.183.968.968 0 0 0 .025-1.226l-6.099-7.82a.97.97 0 0 0-1.194-.272 3.84 3.84 0 0 1-4.184-.517.969.969 0 0 0-1.225-.027L32.057 30.898a.97.97 0 0 0-.272 1.195 3.84 3.84 0 0 1-.518 4.182Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.87 33.16a3.833 3.833 0 1 1 6.045-4.715 3.833 3.833 0 0 1-6.045 4.714ZM34.32 26.593a1.068 1.068 0 0 0-1.385 1.12c.098 1.226.036 2.46-.184 3.67a.509.509 0 0 1-.996.028c-.175-.727-.409-1.44-.698-2.13a18.642 18.642 0 0 0-2.105-3.74 20.803 20.803 0 0 0-5.164-4.583 1.067 1.067 0 0 0-1.589 1.157c2.284 10.487-7.75 14.036-2.736 26a14.276 14.276 0 0 0 19.374 7.299c7.743-3.76 10.08-13.596 5.557-20.918a18.608 18.608 0 0 0-10.074-7.903Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M39.68 40.32a7.97 7.97 0 0 1-.911 9.015 7.726 7.726 0 0 1-10.994.583 7.64 7.64 0 0 1-1.93-2.718c-1.316-3.135-1.09-4.942-.14-7.36a1.078 1.078 0 0 1 1.84-.277 6.514 6.514 0 0 0 10-.128 1.056 1.056 0 0 1 1.697.119c.155.25.3.506.438.766Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M27.198 65.17c0 .385 1.09.756 3.028 1.028 1.94.273 4.57.427 7.312.427s5.372-.154 7.311-.427c1.94-.272 3.029-.642 3.029-1.028s-1.09-.757-3.029-1.03c-1.939-.272-4.569-.426-7.311-.426-2.743 0-5.373.154-7.312.427-1.939.272-3.028.643-3.028 1.029Z", "fill": "#B096CB" } })]);
};
var burningMoney = {
  render: render$1t
};
var render$1s = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M33.156 26.44h-3.055a.8.8 0 0 0-.8.8v11.613h4.655V27.24a.8.8 0 0 0-.8-.8ZM19.191 26.44h-3.054a.8.8 0 0 0-.8.8v11.613h4.654V27.24a.8.8 0 0 0-.8-.8Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M23.846 24.889h-3.055a.8.8 0 0 0-.8.8v13.164h4.655V25.689a.8.8 0 0 0-.8-.8ZM28.5 27.992h-3.053a.8.8 0 0 0-.8.8v10.06H29.3v-10.06a.8.8 0 0 0-.8-.8ZM29.3 38.853l2.135-7.824a1.55 1.55 0 0 1 1.906-1.089l1.497.409a1.552 1.552 0 0 1 1.088 1.905l-1.8 6.599H29.3Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m29.3 38.853 2.135-7.824a1.55 1.55 0 0 1 1.906-1.089l1.497.409a1.552 1.552 0 0 1 1.088 1.905l-1.8 6.599H29.3ZM23.846 24.889h-3.055a.8.8 0 0 0-.8.8v13.164h4.655V25.689a.8.8 0 0 0-.8-.8ZM28.5 27.992h-3.053a.8.8 0 0 0-.8.8v10.06H29.3v-10.06a.8.8 0 0 0-.8-.8Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m20.818 38.853-2.134-7.824a1.552 1.552 0 0 0-1.905-1.09l-1.498.41a1.551 1.551 0 0 0-1.088 1.905l1.8 6.599h4.825Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m29.3 38.853 2.135-7.824a1.55 1.55 0 0 1 1.906-1.089l1.497.409a1.552 1.552 0 0 1 1.088 1.905l-1.8 6.599H29.3ZM23.846 24.889h-3.055a.8.8 0 0 0-.8.8v13.164h4.655V25.689a.8.8 0 0 0-.8-.8Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m20.818 38.853-2.134-7.824a1.552 1.552 0 0 0-1.905-1.09l-1.498.41a1.551 1.551 0 0 0-1.088 1.905l1.8 6.599h4.825Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M28.5 27.992h-3.053a.8.8 0 0 0-.8.8v10.06H29.3v-10.06a.8.8 0 0 0-.8-.8Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m20.818 38.853-2.134-7.824a1.552 1.552 0 0 0-1.905-1.09l-1.498.41a1.551 1.551 0 0 0-1.088 1.905l1.8 6.599h4.825Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M17.053 59.305c0 .444 2.353.87 6.541 1.185 4.188.315 9.87.491 15.792.491 5.924 0 11.604-.176 15.793-.49 4.188-.315 6.54-.742 6.54-1.186 0-.445-2.352-.871-6.54-1.186-4.189-.314-9.87-.491-15.793-.491s-11.604.177-15.792.491c-4.188.315-6.541.741-6.541 1.186Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M46.368 27.992H66.54l-1.397 26.54a3.102 3.102 0 0 1-3.099 2.94H50.864a3.104 3.104 0 0 1-3.099-2.94l-1.397-26.54Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M46.368 27.992H66.54l-1.397 26.54a3.102 3.102 0 0 1-3.099 2.94H50.864a3.104 3.104 0 0 1-3.099-2.94l-1.397-26.54Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M68.09 26.44a1.551 1.551 0 0 0-1.551-1.551H46.368a1.552 1.552 0 0 0 0 3.103h20.171a1.55 1.55 0 0 0 1.551-1.552Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M34.193 54.626a3.103 3.103 0 0 1-3.093 2.846H18.192a3.103 3.103 0 0 1-3.092-2.846l-1.215-14.56a1.122 1.122 0 0 1 1.113-1.21h20.509l-1.314 15.77Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M34.193 54.626a3.103 3.103 0 0 1-3.093 2.846H18.192a3.103 3.103 0 0 1-3.092-2.846l-1.215-14.56a1.122 1.122 0 0 1 1.113-1.21h20.509l-1.314 15.77Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m52.575 24.889-2.92-10.912a1.12 1.12 0 0 0-1.368-.79l-.84.224a1.12 1.12 0 0 0-.79 1.368l2.707 10.116 3.21-.006Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.023 52.818H26.198v3.854a.8.8 0 0 0 .8.8h23.225a.8.8 0 0 0 .8-.8v-3.854Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M24.646 50.49a2.328 2.328 0 0 1 2.328-2.33h23.273a2.328 2.328 0 0 1 0 4.655H26.974a2.327 2.327 0 0 1-2.328-2.325Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M26.198 48.16c0-6.855 5.557-10.86 12.413-10.86 6.855 0 12.412 4.007 12.412 10.86H26.198Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M33.956 41.956v1.552M38.61 40.405v1.551M43.265 41.956v1.552M26.198 48.16c0-6.855 5.557-10.86 12.413-10.86 6.855 0 12.412 4.007 12.412 10.86H26.198ZM51.023 52.818H26.198v3.854a.8.8 0 0 0 .8.8h23.225a.8.8 0 0 0 .8-.8v-3.854ZM24.646 50.49a2.328 2.328 0 0 1 2.328-2.33h23.273a2.328 2.328 0 0 1 0 4.655H26.974a2.327 2.327 0 0 1-2.328-2.325Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var burgerSodaSet = {
  render: render$1s
};
var render$1r = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M1.88 43.943a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "m4.396 30.977 31.84-5.05 5.081 32.035-31.84 5.05-5.08-32.035Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m7.923 36.06-.873-5.503M8.596 40.304l-.168-1.06", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m10.764 29.968 31.84-5.05 5.081 32.035-31.84 5.05-5.08-32.035Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m10.764 29.968 31.84-5.05 5.081 32.035-31.84 5.05-5.08-32.035ZM13.193 62.424 11.51 51.81", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.655 37.849a12.895 12.895 0 0 0 14.756 10.715l-31.84 5.05A12.894 12.894 0 0 1 12.816 42.9l-1.911-12.047a.895.895 0 0 1 .744-1.025l30.07-4.77a.894.894 0 0 1 1.026.745l1.91 12.047Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m44.015 33.81-31.84 5.05-1.27-8.008a.895.895 0 0 1 .743-1.025l30.072-4.77a.894.894 0 0 1 1.025.745l1.27 8.008Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M44.655 37.849a12.895 12.895 0 0 0 14.756 10.715l-31.84 5.05A12.894 12.894 0 0 1 12.816 42.9l-1.911-12.047a.895.895 0 0 1 .744-1.025l30.07-4.77a.894.894 0 0 1 1.026.745l1.91 12.047Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M26.273 25.984c.075.5.21.99.4 1.46l1.84-.292a4.642 4.642 0 0 1-.475-1.449 4.925 4.925 0 1 1 8.81 2.185.911.911 0 0 0-.19.692.9.9 0 0 0 1.612.388 6.675 6.675 0 0 0 1.027-6.1 6.72 6.72 0 0 0-13.024 3.12v-.004Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M16.544 27.527c.076.5.21.99.4 1.46l1.84-.292a4.64 4.64 0 0 1-.474-1.449 4.927 4.927 0 0 1 6.05-5.543 4.924 4.924 0 0 1 2.76 7.728.894.894 0 1 0 1.423 1.08 6.675 6.675 0 0 0 1.027-6.1 6.72 6.72 0 0 0-13.024 3.12l-.002-.004Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M6.815 29.07c.075.501.21.99.4 1.46l1.84-.292a4.64 4.64 0 0 1-.474-1.448 4.924 4.924 0 1 1 8.805 2.184.894.894 0 1 0 1.423 1.08 6.675 6.675 0 0 0 1.03-6.101 6.72 6.72 0 0 0-13.023 3.12l-.001-.003Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m12.175 38.86 31.84-5.05M20.938 37.47l.615 3.879a13.01 13.01 0 0 0 14.756 10.88M28.975 36.195l.586 3.7a13.23 13.23 0 0 0 14.92 11.04M37.326 34.87l.553 3.481c1.112 7.02 7.374 12.1 14.16 11.383M13.494 45.457l31.446-5.813M17.266 50.76l30.808-6.015", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M14.952 68.433c0 .184.368.366 1.084.535.715.17 1.764.325 3.086.455 1.322.13 2.891.233 4.618.303 1.728.07 3.579.107 5.448.107 1.87 0 3.72-.037 5.448-.107a82.566 82.566 0 0 0 4.618-.303c1.323-.13 2.371-.285 3.087-.454.715-.17 1.083-.352 1.083-.536 0-.184-.368-.366-1.084-.536-.715-.17-1.764-.324-3.086-.454a82.558 82.558 0 0 0-4.618-.304c-1.727-.07-3.578-.106-5.448-.106-1.87 0-3.72.036-5.448.106-1.727.07-3.296.174-4.618.304-1.322.13-2.37.284-3.086.454-.716.17-1.084.352-1.084.536Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M59.691 4.131a16.818 16.818 0 0 0-13.817 23.5l-4.057 9.274a.842.842 0 0 0 1.009 1.144l9.654-2.84A16.825 16.825 0 1 0 59.691 4.13Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M59.691 4.131a16.818 16.818 0 0 0-13.817 23.5l-4.057 9.274a.842.842 0 0 0 1.009 1.144l9.654-2.84A16.825 16.825 0 1 0 59.691 4.13Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M61.87 22.04a.674.674 0 0 1-1.306 0c-2.64-10.391-2.526-9.92-2.536-10.027a3.2 3.2 0 1 1 6.377 0c-.01.104.101-.367-2.536 10.027ZM64.42 28.208a3.2 3.2 0 1 1-6.4 0 3.2 3.2 0 0 1 6.4 0Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M59.691 4.131a16.818 16.818 0 0 0-13.817 23.5l-4.057 9.274a.842.842 0 0 0 1.009 1.144l9.654-2.84A16.825 16.825 0 1 0 59.691 4.13Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var calendarDeadline = {
  render: render$1r
};
var render$1q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M51.075 8.58A16.79 16.79 0 0 0 37.28 32.038l-4.047 9.257a.84.84 0 0 0 1.007 1.142l9.64-2.837a16.794 16.794 0 1 0 7.195-31.022v.002Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M51.075 8.58A16.79 16.79 0 0 0 37.28 32.038l-4.047 9.257a.84.84 0 0 0 1.007 1.142l9.64-2.837a16.794 16.794 0 1 0 7.195-31.022v.002Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.715 29.087a1.26 1.26 0 0 1-1.26-1.26v-1.28a3.803 3.803 0 0 1 2.533-3.563 3.788 3.788 0 0 0 2.42-4.389 3.783 3.783 0 0 0-7.474.828 1.26 1.26 0 1 1-2.52 0 6.302 6.302 0 1 1 8.423 5.937 1.28 1.28 0 0 0-.862 1.19v1.28a1.26 1.26 0 0 1-1.26 1.257ZM51.034 33.303a1.679 1.679 0 0 0 2.868 1.188 1.68 1.68 0 1 0-2.868-1.188Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.453 67.537c0-.8-4.812-1.45-10.75-1.45-5.94 0-10.753.65-10.753 1.45 0 .8 4.814 1.45 10.752 1.45 5.939 0 10.751-.65 10.751-1.45ZM15.101 38.817a4.342 4.342 0 0 1 1.35-2.744l2.522-2.438a2.384 2.384 0 0 1 3.56.06c.69.648 1.313 1.36 2 2.07l1.939 2.004a2.341 2.341 0 0 1-.062 3.624c-.84.813-1.617 1.626-2.52 2.374a.493.493 0 0 0-.138.634 16.483 16.483 0 0 0 2.133 3.63 24.837 24.837 0 0 0 6.104 5.73c.503.328 1.104.56 1.607.887a.509.509 0 0 0 .702-.116l2.521-2.438a2.339 2.339 0 0 1 3.56.061l3.94 4.073a2.407 2.407 0 0 1-.06 3.625c-.745.782-1.583 1.467-2.297 2.282a4.56 4.56 0 0 1-3.903 1.397 15.696 15.696 0 0 1-5.98-1.913 33.105 33.105 0 0 1-10.885-8.8 30.423 30.423 0 0 1-5.221-9.025 10.793 10.793 0 0 1-.872-4.977Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m44.32 56.228-3.937-4.073a2.338 2.338 0 0 0-3.561-.06L35.68 53.2l7.474 7.731c.374-.353.751-.704 1.105-1.077a2.407 2.407 0 0 0 .061-3.626Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m44.32 56.228-3.937-4.073a2.338 2.338 0 0 0-3.561-.06L35.68 53.2l7.474 7.731c.374-.353.751-.704 1.105-1.077a2.407 2.407 0 0 0 .061-3.626Z", "stroke": "#481D72", "stroke-width": ".75" } }), _c("path", { attrs: { "d": "M15.101 38.817a4.342 4.342 0 0 1 1.35-2.744l2.522-2.438a2.384 2.384 0 0 1 3.56.06c.69.648 1.313 1.36 2 2.07l1.939 2.004a2.341 2.341 0 0 1-.062 3.624c-.84.813-1.617 1.626-2.52 2.374a.493.493 0 0 0-.138.634 16.483 16.483 0 0 0 2.133 3.63 24.837 24.837 0 0 0 6.104 5.73c.503.328 1.104.56 1.607.887a.509.509 0 0 0 .702-.116l2.521-2.438a2.339 2.339 0 0 1 3.56.061l3.94 4.073a2.407 2.407 0 0 1-.06 3.625c-.745.782-1.583 1.467-2.297 2.282a4.56 4.56 0 0 1-3.903 1.397 15.696 15.696 0 0 1-5.98-1.913 33.105 33.105 0 0 1-10.885-8.8 30.423 30.423 0 0 1-5.221-9.025 10.793 10.793 0 0 1-.872-4.977Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m17.831 34.74 1.142-1.105a2.382 2.382 0 0 1 3.56.06c.69.648 1.313 1.36 2 2.07l1.939 2.004a2.342 2.342 0 0 1-.062 3.624c-.374.361-.736.724-1.102 1.08L17.83 34.74Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75" } })]);
};
var callQuestion = {
  render: render$1q
};
var render$1p = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#6B4392" } }), _c("path", { attrs: { "d": "m32.85 47.779 20.661-20.661a2.75 2.75 0 0 1 3.89 3.889L33.58 54.827a1.028 1.028 0 0 1-1.459 0l-9.521-9.52a2.75 2.75 0 0 1 3.889-3.89l6.361 6.362Z", "fill": "#fff" } })]);
};
var check = {
  render: render$1p
};
var render$1o = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 72 72", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M55.5 12.667h-7v1.166a2.34 2.34 0 0 1-2.333 2.334h-21a2.34 2.34 0 0 1-2.334-2.334v-1.166h-7a3.51 3.51 0 0 0-3.5 3.5v49a3.51 3.51 0 0 0 3.5 3.5H55.5a3.51 3.51 0 0 0 3.5-3.5v-49a3.51 3.51 0 0 0-3.5-3.5ZM25.867 57.933l-4.667 3.5a1.2 1.2 0 0 1-.7.234 1.19 1.19 0 0 1-1.05-.653l-1.166-2.334a1.159 1.159 0 0 1 .524-1.563 1.159 1.159 0 0 1 1.564.525l.537 1.085 3.546-2.66a1.17 1.17 0 0 1 1.634.233 1.158 1.158 0 0 1-.222 1.633Zm0-15.166-4.667 3.5a1.2 1.2 0 0 1-.7.233 1.19 1.19 0 0 1-1.05-.653l-1.166-2.334a1.16 1.16 0 0 1 .524-1.563 1.159 1.159 0 0 1 1.564.525l.537 1.085 3.546-2.66a1.17 1.17 0 0 1 1.634.233 1.158 1.158 0 0 1-.222 1.634Zm0-15.167L21.2 31.1a1.2 1.2 0 0 1-.7.233 1.19 1.19 0 0 1-1.05-.653l-1.166-2.333a1.16 1.16 0 0 1 .524-1.564 1.16 1.16 0 0 1 1.564.525l.537 1.085 3.546-2.66a1.17 1.17 0 0 1 1.634.234 1.158 1.158 0 0 1-.222 1.633Zm24.966 31.733h-21a1.17 1.17 0 0 1-1.166-1.166A1.17 1.17 0 0 1 29.833 57h21A1.17 1.17 0 0 1 52 58.167a1.17 1.17 0 0 1-1.166 1.166Zm0-15.166h-21A1.17 1.17 0 0 1 28.668 43a1.17 1.17 0 0 1 1.166-1.167h21A1.17 1.17 0 0 1 52 43a1.17 1.17 0 0 1-1.166 1.167Zm0-15.167h-21a1.17 1.17 0 0 1-1.166-1.167 1.17 1.17 0 0 1 1.166-1.166h21A1.17 1.17 0 0 1 52 27.833 1.17 1.17 0 0 1 50.834 29Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M46.166 10.333A2.34 2.34 0 0 0 43.834 8h-3.407l-.186-.933a4.683 4.683 0 0 0-4.574-3.734 4.692 4.692 0 0 0-4.573 3.734L30.907 8H27.5a2.34 2.34 0 0 0-2.334 2.333v3.5h21v-3.5Zm-10.5 1.167a3.51 3.51 0 0 1-3.5-3.5 3.51 3.51 0 0 1 3.5-3.5 3.51 3.51 0 0 1 3.5 3.5 3.51 3.51 0 0 1-3.5 3.5Z", "fill": "#16A7A7" } }), _c("path", { attrs: { "d": "M35.666 4.5a3.51 3.51 0 0 0-3.5 3.5 3.51 3.51 0 0 0 3.5 3.5 3.51 3.51 0 0 0 3.5-3.5 3.51 3.51 0 0 0-3.5-3.5Zm0 4.667A1.17 1.17 0 0 1 34.5 8a1.17 1.17 0 0 1 1.166-1.167A1.17 1.17 0 0 1 36.834 8a1.17 1.17 0 0 1-1.166 1.167Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M55.5 10.333h-7a4.665 4.665 0 0 0-4.667-4.666H42.27A7.025 7.025 0 0 0 35.667 1c-2.987 0-5.624 1.913-6.604 4.667H27.5a4.665 4.665 0 0 0-4.667 4.666h-7A5.835 5.835 0 0 0 10 16.167v49A5.835 5.835 0 0 0 15.833 71H55.5a5.835 5.835 0 0 0 5.833-5.833v-49a5.835 5.835 0 0 0-5.833-5.834Zm-30.333 0A2.34 2.34 0 0 1 27.5 8h3.407l.186-.933a4.693 4.693 0 0 1 4.574-3.734 4.683 4.683 0 0 1 4.573 3.734l.187.933h3.406a2.34 2.34 0 0 1 2.334 2.333v3.5h-21v-3.5ZM59 65.167a3.51 3.51 0 0 1-3.5 3.5H15.833a3.51 3.51 0 0 1-3.5-3.5v-49a3.51 3.51 0 0 1 3.5-3.5h7v1.166a2.34 2.34 0 0 0 2.334 2.334h21a2.34 2.34 0 0 0 2.333-2.334v-1.166h7a3.51 3.51 0 0 1 3.5 3.5v49Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M50.833 41.833h-21A1.17 1.17 0 0 0 28.667 43a1.17 1.17 0 0 0 1.166 1.167h21A1.17 1.17 0 0 0 52 43a1.17 1.17 0 0 0-1.167-1.167ZM50.833 26.667h-21a1.17 1.17 0 0 0-1.166 1.166A1.17 1.17 0 0 0 29.832 29h21A1.17 1.17 0 0 0 52 27.833a1.17 1.17 0 0 0-1.167-1.166ZM50.833 57h-21a1.17 1.17 0 0 0-1.166 1.167 1.17 1.17 0 0 0 1.166 1.166h21A1.17 1.17 0 0 0 52 58.167 1.17 1.17 0 0 0 50.833 57ZM24.466 40.9l-3.546 2.66-.537-1.085a1.18 1.18 0 0 0-1.563-.525 1.18 1.18 0 0 0-.525 1.563l1.166 2.334c.152.315.444.536.782.618a.91.91 0 0 0 .257.035 1.2 1.2 0 0 0 .7-.233l4.666-3.5a1.17 1.17 0 0 0 .234-1.634 1.17 1.17 0 0 0-1.634-.233ZM24.466 56.067l-3.546 2.66-.537-1.085c-.292-.572-.992-.817-1.563-.525a1.18 1.18 0 0 0-.525 1.563l1.166 2.333c.152.315.444.537.782.619a.91.91 0 0 0 .257.035 1.2 1.2 0 0 0 .7-.234l4.666-3.5A1.17 1.17 0 0 0 26.1 56.3a1.17 1.17 0 0 0-1.634-.233ZM24.466 25.733l-3.546 2.66-.537-1.085a1.18 1.18 0 0 0-1.563-.525 1.18 1.18 0 0 0-.525 1.564l1.166 2.333c.152.315.444.537.782.618a.907.907 0 0 0 .257.035 1.2 1.2 0 0 0 .7-.233l4.666-3.5a1.17 1.17 0 0 0 .234-1.633 1.17 1.17 0 0 0-1.634-.234Z", "fill": "#481D72" } })]);
};
var clipboard = {
  render: render$1o
};
var render$1n = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 72 72", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M36 9.864a1.136 1.136 0 1 0 0-2.273 1.136 1.136 0 0 0 0 2.273Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M35.875 28.773c-6.898 0-12.5 5.602-12.5 12.5 0 6.897 5.602 12.5 12.5 12.5s12.5-5.603 12.5-12.5c0-6.898-5.602-12.5-12.5-12.5Zm6.489 9.318-7.955 7.954c-.227.228-.511.33-.807.33-.295 0-.58-.114-.806-.33l-3.41-3.409a1.132 1.132 0 0 1 0-1.602 1.132 1.132 0 0 1 1.603 0l2.602 2.602 7.148-7.147a1.132 1.132 0 0 1 1.602 0c.443.443.466 1.159.023 1.602Z", "fill": "#16A7A7" } }), _c("path", { attrs: { "d": "M46.227 11a2.28 2.28 0 0 0-2.272-2.273h-3.318l-.182-.909A4.57 4.57 0 0 0 36 4.182a4.57 4.57 0 0 0-4.454 3.636l-.182.91h-3.318A2.28 2.28 0 0 0 25.773 11v3.41h20.454V11ZM36 12.136a3.42 3.42 0 0 1-3.409-3.409 3.42 3.42 0 0 1 3.41-3.409 3.42 3.42 0 0 1 3.408 3.41A3.42 3.42 0 0 1 36 12.135Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M55.318 13.273H48.5v1.136a2.28 2.28 0 0 1-2.273 2.273H25.773a2.28 2.28 0 0 1-2.273-2.273v-1.136h-6.818a3.42 3.42 0 0 0-3.41 3.409v47.727a3.42 3.42 0 0 0 3.41 3.41h38.636a3.42 3.42 0 0 0 3.41-3.41V16.682a3.42 3.42 0 0 0-3.41-3.41ZM35.875 56.045c-8.148 0-14.773-6.625-14.773-14.772 0-8.148 6.625-14.773 14.773-14.773s14.773 6.625 14.773 14.773c0 8.147-6.625 14.772-14.773 14.772Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M36 5.318a3.42 3.42 0 0 0-3.41 3.41A3.42 3.42 0 0 0 36 12.135a3.42 3.42 0 0 0 3.409-3.409 3.42 3.42 0 0 0-3.41-3.409Zm0 4.546a1.14 1.14 0 0 1-1.136-1.137A1.14 1.14 0 0 1 36 7.591a1.14 1.14 0 0 1 1.136 1.136A1.14 1.14 0 0 1 36 9.864Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M55.318 11H48.5a4.544 4.544 0 0 0-4.545-4.545h-1.523C41.477 3.773 38.909 1.909 36 1.909c-2.91 0-5.477 1.864-6.432 4.546h-1.523A4.544 4.544 0 0 0 23.5 11h-6.818A5.684 5.684 0 0 0 11 16.682v47.727a5.684 5.684 0 0 0 5.682 5.682h38.636A5.684 5.684 0 0 0 61 64.409V16.682A5.684 5.684 0 0 0 55.318 11Zm-29.545 0a2.28 2.28 0 0 1 2.273-2.273h3.318l.181-.909A4.57 4.57 0 0 1 36 4.182a4.57 4.57 0 0 1 4.455 3.636l.181.91h3.319A2.28 2.28 0 0 1 46.227 11v3.41H25.773V11Zm32.954 53.41a3.42 3.42 0 0 1-3.409 3.408H16.682a3.42 3.42 0 0 1-3.41-3.409V16.682a3.42 3.42 0 0 1 3.41-3.41H23.5v1.137a2.28 2.28 0 0 0 2.273 2.273h20.454a2.28 2.28 0 0 0 2.273-2.273v-1.136h6.818a3.42 3.42 0 0 1 3.41 3.409v47.727Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "m40.75 36.489-7.148 7.147L31 41.034a1.132 1.132 0 0 0-1.602 0 1.132 1.132 0 0 0 0 1.602l3.409 3.41c.227.227.511.329.807.329.295 0 .58-.114.806-.33l7.955-7.954a1.132 1.132 0 0 0 0-1.602 1.16 1.16 0 0 0-1.625 0Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M35.875 26.5c-8.148 0-14.773 6.625-14.773 14.773 0 8.147 6.625 14.772 14.773 14.772s14.773-6.625 14.773-14.772c0-8.148-6.625-14.773-14.773-14.773Zm0 27.273c-6.898 0-12.5-5.603-12.5-12.5 0-6.898 5.602-12.5 12.5-12.5s12.5 5.602 12.5 12.5c0 6.897-5.602 12.5-12.5 12.5Z", "fill": "#481D72" } })]);
};
var clipboardCheck = {
  render: render$1n
};
var render$1m = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "m13.31 55.706 6.13-5.977a.8.8 0 0 1 1.131.014l8.216 8.432a.8.8 0 0 1-.014 1.131l-6.32 6.167a31.254 31.254 0 0 1-9.143-9.767Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M45.802 51.48a1.725 1.725 0 0 0-1.703-1.747c-.426-.006-3.631.141-3.965-.24-.716-.822.018-2.847 1.648-4.055l8.506-6.52a1.725 1.725 0 0 0-2.015-2.8l-8.066 6.032 8.298-7.693a1.725 1.725 0 0 0-2.23-2.634l-8.414 7.92 6.977-7.537a1.725 1.725 0 1 0-2.575-2.297l-1.558 1.745a1.72 1.72 0 0 0-3.04-1.341l-7.53 8.993c-3.263 3.18-4.842 7.128-5.089 7.368L23.07 48.6l6.924 7.106c1.474-1.44 4.016-1.372 14.06-2.523a1.724 1.724 0 0 0 1.748-1.702Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m13.31 55.706 6.13-5.978a.8.8 0 0 1 1.131.014l8.216 8.433a.8.8 0 0 1-.014 1.132l-6.32 6.166", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m28.743 58.13 1.28-1.248a.8.8 0 0 0 .015-1.13l-7.012-7.2a.8.8 0 0 0-1.132-.015l-1.28 1.248 8.13 8.345Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M45.802 51.48a1.725 1.725 0 0 0-1.703-1.747c-.426-.006-3.631.141-3.965-.24-.716-.822.018-2.847 1.648-4.055l8.506-6.52a1.725 1.725 0 0 0-2.015-2.8l-8.066 6.032 8.298-7.693a1.725 1.725 0 0 0-2.23-2.634l-8.414 7.92 6.977-7.537a1.725 1.725 0 1 0-2.575-2.297l-1.558 1.745a1.72 1.72 0 0 0-3.04-1.341l-7.53 8.993c-3.263 3.18-4.842 7.128-5.089 7.368L23.07 48.6l6.924 7.106c1.474-1.44 4.016-1.372 14.06-2.523a1.724 1.724 0 0 0 1.748-1.702ZM40.705 31.651l-5.273 6.146", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m24.052 13.627 5.78 6.053a.8.8 0 0 1-.026 1.132l-8.517 8.126a.8.8 0 0 1-1.13-.026l-5.764-6.032a30.39 30.39 0 0 1 9.657-9.253Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M27.809 46.022a1.725 1.725 0 0 0 1.765-1.685c.01-.427-.104-3.632.282-3.962.83-.708 2.847.047 4.039 1.69l6.43 8.575a1.725 1.725 0 1 0 2.822-1.986l-5.947-8.13 7.607 8.375a1.725 1.725 0 1 0 2.656-2.202l-7.832-8.495 7.464 7.054a1.726 1.726 0 0 0 2.324-2.551l-1.73-1.575a1.722 1.722 0 0 0 1.374-3.027l-8.919-7.623c-3.146-3.296-7.077-4.916-7.316-5.166l-1.904-1.995-7.177 6.85c1.42 1.488 1.33 4.03 2.377 14.086a1.725 1.725 0 0 0 1.685 1.767Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m24.052 13.627 5.78 6.053a.8.8 0 0 1-.026 1.13l-8.517 8.128a.8.8 0 0 1-1.13-.026l-5.76-6.033", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m21.335 28.894 1.234 1.294a.8.8 0 0 0 1.132.026l7.268-6.934a.8.8 0 0 0 .026-1.131l-1.235-1.296-8.425 8.041Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M27.809 46.022a1.725 1.725 0 0 0 1.765-1.685c.01-.427-.104-3.632.282-3.962.83-.708 2.847.047 4.039 1.69l6.43 8.575a1.725 1.725 0 1 0 2.822-1.986l-5.947-8.13 7.607 8.375a1.725 1.725 0 1 0 2.656-2.202l-7.832-8.495 7.464 7.054a1.726 1.726 0 0 0 2.324-2.551l-1.73-1.575a1.722 1.722 0 0 0 1.374-3.027l-8.919-7.623c-3.146-3.296-7.077-4.916-7.316-5.166l-1.904-1.995-7.177 6.85c1.42 1.488 1.33 4.03 2.377 14.086a1.725 1.725 0 0 0 1.685 1.767ZM47.69 41.13l-6.092-5.337", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m66.691 24.332-5.315 5.404a.8.8 0 0 1-1.132.009l-8.39-8.26a.8.8 0 0 1-.008-1.13l5.674-5.772a42.453 42.453 0 0 1 9.171 9.75Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M34.982 28.532a1.727 1.727 0 0 0 1.739 1.712c.426 0 3.627-.217 3.969.16.733.806.041 2.847-1.563 4.089l-8.369 6.693a1.726 1.726 0 0 0 2.073 2.759l7.939-6.2-8.136 7.863a1.726 1.726 0 1 0 2.285 2.587l8.247-8.09-6.82 7.68a1.726 1.726 0 0 0 2.623 2.24l1.52-1.778a1.72 1.72 0 0 0 3.067 1.28l7.34-9.15c3.2-3.247 4.694-7.227 4.937-7.473l1.935-1.966-7.07-6.96c-1.44 1.466-3.987 1.456-14.005 2.815a1.725 1.725 0 0 0-1.711 1.74Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m66.691 24.332-5.316 5.404a.8.8 0 0 1-1.131.009l-8.389-8.26a.8.8 0 0 1-.01-1.131l5.675-5.77", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.9 21.529 50.644 22.8a.8.8 0 0 0 .009 1.132l7.16 7.049a.8.8 0 0 0 1.13-.009l1.255-1.274-8.3-8.17Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M34.982 28.532a1.727 1.727 0 0 0 1.739 1.712c.426 0 3.627-.217 3.969.16.733.806.041 2.847-1.563 4.089l-8.369 6.693a1.726 1.726 0 0 0 2.073 2.759l7.939-6.2-8.136 7.863a1.726 1.726 0 1 0 2.285 2.587l8.247-8.09-6.82 7.68a1.726 1.726 0 0 0 2.623 2.24l1.52-1.778a1.72 1.72 0 0 0 3.067 1.28l7.34-9.15c3.2-3.247 4.694-7.227 4.937-7.473l1.935-1.966-7.07-6.96c-1.44 1.466-3.987 1.456-14.005 2.815a1.725 1.725 0 0 0-1.711 1.74ZM40.49 48.251l5.145-6.254", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m56.349 66.17-5.608-5.632a.8.8 0 0 1 0-1.132l8.348-8.303a.8.8 0 0 1 1.131 0l5.647 5.67a27.462 27.462 0 0 1-9.518 9.396Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M52.217 34.16a1.726 1.726 0 0 0-1.73 1.72c0 .428.18 3.63-.2 3.968-.814.725-2.846.013-4.072-1.606l-6.607-8.438a1.726 1.726 0 1 0-2.78 2.045l6.117 8-7.778-8.215a1.726 1.726 0 1 0-2.607 2.257l8 8.33-7.61-6.897a1.726 1.726 0 0 0-2.27 2.596l1.76 1.54a1.721 1.721 0 0 0-1.31 3.053l9.075 7.436c3.214 3.23 7.178 4.768 7.42 5.012l1.946 1.956 7.036-6.997c-1.45-1.459-1.414-4-2.668-14.033a1.724 1.724 0 0 0-1.722-1.727Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m56.349 66.17-5.609-5.632a.8.8 0 0 1 0-1.13l8.346-8.305a.8.8 0 0 1 1.132 0l5.645 5.67", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m59.045 51.147-1.262-1.268a.8.8 0 0 0-1.13 0l-7.12 7.087a.8.8 0 0 0 0 1.13l1.255 1.264 8.257-8.213Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.217 34.16a1.727 1.727 0 0 0-1.73 1.72c0 .428.18 3.63-.2 3.968-.814.725-2.846.013-4.072-1.606l-6.607-8.438a1.726 1.726 0 1 0-2.78 2.045l6.117 8-7.778-8.215a1.726 1.726 0 1 0-2.607 2.257l8 8.33-7.61-6.897a1.726 1.726 0 0 0-2.27 2.596l1.76 1.54a1.721 1.721 0 0 0-1.31 3.053l9.075 7.436c3.214 3.23 7.178 4.768 7.42 5.012l1.946 1.956 7.036-6.997c-1.45-1.459-1.414-4-2.668-14.033a1.724 1.724 0 0 0-1.722-1.727ZM32.442 39.462l6.201 5.21", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var collaboratedEffort = {
  render: render$1m
};
var render$1l = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 39.988a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M52.622 60.426a.886.886 0 0 1-.971.784l-27.16-2.901a.885.885 0 0 1-.784-.971l4.036-37.786 20.144 2.151 7.834 9.707-3.1 29.016Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m36.64 33.968 14.571 1.556M31.172 37.322l19.623 2.095M30.756 41.214l19.623 2.096M30.34 45.107l19.624 2.096M40.89 50.794a1.78 1.78 0 1 0 2.888 1.574l-.038.354a1.424 1.424 0 0 0 2.831.303 1.423 1.423 0 0 0 1.27 1.566l1.06.114", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m40.044 55.767 8.435.9M28.686 54.554l8.436.901", "stroke": "#B096CB", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.742 53.18a1.482 1.482 0 1 1 1.605-1.349M37.299 51.851a1.484 1.484 0 0 1-1.606 1.35M31.305 52.324a1.483 1.483 0 0 1 1.605-1.35M33.767 52.537a1.482 1.482 0 0 1 1.605-1.349", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m47.887 21.703-.843 7.897a.884.884 0 0 0 .783.97l7.894.843-7.834-9.71Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m52.62 60.448-1.213-7.478a1.669 1.669 0 0 0-3.295.533l.514 3.184c.43 2.653-2.554 2.498-1.8 7.165l.733 4.53 9.076-1.467a9.915 9.915 0 0 1-.16-3.875c.436-2.411.832-4.07.395-6.782-.456-2.82-1.28-4.017-3.072-6.833l-1.179 11.023Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m57.857 69.253-.258-1.6a.88.88 0 0 0-1.011-.73l-9.378 1.515a.878.878 0 0 0-.73 1.012l.259 1.6 11.118-1.797Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m52.62 60.448-1.213-7.478a1.669 1.669 0 0 0-3.295.533l.514 3.184c.43 2.653-2.554 2.498-1.8 7.165l.733 4.53 9.076-1.467a9.915 9.915 0 0 1-.16-3.875c.436-2.411.832-4.07.395-6.782-.456-2.82-1.28-4.017-3.072-6.833l-1.179 11.023Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m46.706 76.08-.65-4.024a.88.88 0 0 1 .73-1.011l11.024-1.782a.879.879 0 0 1 1.012.73l.65 4.024", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m46.706 76.08-.65-4.024a.88.88 0 0 1 .73-1.011l11.024-1.782a.879.879 0 0 1 1.012.73l.65 4.024", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m27.743 19.552 1.217 7.478a1.668 1.668 0 1 0 3.295-.533l-.515-3.184c-.429-2.653 2.554-2.498 1.8-7.165l-.74-4.53-9.073 1.467c.457 2.71.381 2.66-.188 5.803a14.377 14.377 0 0 0 .8 7.9c.112.46 2.228 3.787 2.228 3.787l1.176-11.023Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m22.505 10.747.258 1.6a.88.88 0 0 0 1.011.73l9.378-1.52a.88.88 0 0 0 .73-1.01l-.259-1.6-11.118 1.8Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m27.743 19.552 1.217 7.478a1.668 1.668 0 1 0 3.295-.533l-.515-3.184c-.429-2.653 2.554-2.498 1.8-7.165l-.74-4.53-9.073 1.467c.457 2.71.381 2.66-.188 5.803a14.377 14.377 0 0 0 .8 7.9c.112.46 2.228 3.787 2.228 3.787l1.176-11.023Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m33.656 3.92.65 4.024a.878.878 0 0 1-.73 1.016l-11.024 1.78a.879.879 0 0 1-1.012-.73l-.65-4.024", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m33.656 3.92.65 4.024a.878.878 0 0 1-.73 1.016l-11.024 1.78a.879.879 0 0 1-1.012-.73l-.65-4.024", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var contractDocument = {
  render: render$1l
};
var render$1k = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M42.438 15.462h26.931v11.356H42.439V15.462Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M69.37 15.462H42.437v11.355H69.37", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M38.07 15.462h4.368v11.356H38.07V15.462Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M16.232 11.242v26.93h11.356v-26.93", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M16.232 11.242v26.93h11.356v-26.93", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M16.232 38.173h11.356v4.368H16.232v-4.368ZM12.737 51.206a3.45 3.45 0 0 1 1.516-2.88c1.12-.744 1.979-1.21 1.979-2.775v-3.01h11.36v.605l2.994 7.48c.33.825.5 1.706.5 2.596v11.156a1.747 1.747 0 1 1-3.494 0v.872a1.746 1.746 0 0 1-3.372.68 1.746 1.746 0 0 1-.122-.68v.875a1.747 1.747 0 1 1-3.494 0 1.749 1.749 0 0 1-3.497 0l-.01-13.104h-4.36v-1.815ZM68.64 28.633a3.45 3.45 0 0 1-1.514 2.88c-1.12.743-1.979 1.21-1.979 2.774V37.3h-11.36v-.606l-2.987-7.48a6.984 6.984 0 0 1-.5-2.597V15.462a1.747 1.747 0 0 1 3.494 0v-.875a1.747 1.747 0 0 1 3.493 0v-.872a1.747 1.747 0 0 1 3.495 0 1.75 1.75 0 1 1 3.496 0l.01 13.103h4.352v1.815Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M65.15 68.6V41.666H53.793V68.6", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M65.15 68.6V41.666H53.793V68.6", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M53.794 37.3H65.15v4.367H53.793V37.3Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.978 67.871a3.453 3.453 0 0 1-2.88-1.513c-.742-1.12-1.21-1.98-2.774-1.98H43.31V53.023h.609l7.479-2.994a6.959 6.959 0 0 1 2.596-.5H65.15a1.748 1.748 0 1 1 0 3.493h.875a1.748 1.748 0 0 1 0 3.495h.872a1.746 1.746 0 1 1 0 3.493 1.75 1.75 0 0 1 0 3.498l-13.103.012v4.353l-1.816-.002Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M12.282 64.379h4.82l-.025-11.357h-4.795V64.38ZM31.083 53.023h7.862v11.355h-7.862V53.023Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M51.978 67.871a3.453 3.453 0 0 1-2.88-1.513c-.742-1.12-1.21-1.98-2.774-1.98H43.31V53.023h.609l7.479-2.994a6.959 6.959 0 0 1 2.596-.5H65.15a1.748 1.748 0 1 1 0 3.493h.875a1.748 1.748 0 0 1 0 3.495h.872a1.746 1.746 0 1 1 0 3.493 1.75 1.75 0 0 1 0 3.498l-13.103.012v4.353l-1.816-.002Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M38.945 53.023h4.367v11.355h-4.367V53.023Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M12.282 64.379h4.82l-.025-11.357h-4.795M31.083 53.023h7.862v11.355h-7.862V53.023Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.405 11.966a3.456 3.456 0 0 1 2.88 1.514c.743 1.12 1.208 1.98 2.774 1.98h3.01v11.36h-.604l-7.48 2.994c-.825.33-1.707.5-2.596.5H16.233a1.747 1.747 0 1 1 0-3.494h-.873a1.747 1.747 0 1 1 0-3.494h-.874a1.748 1.748 0 1 1 0-3.494 1.748 1.748 0 0 1 0-3.497l13.104-.01v-4.36h1.815Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M29.405 11.966a3.456 3.456 0 0 1 2.88 1.514c.743 1.12 1.208 1.98 2.774 1.98h3.01v11.36h-.604l-7.48 2.994c-.825.33-1.707.5-2.596.5H16.233a1.747 1.747 0 1 1 0-3.494h-.873a1.747 1.747 0 1 1 0-3.494h-.874a1.748 1.748 0 1 1 0-3.494 1.748 1.748 0 0 1 0-3.497l13.104-.01v-4.36h1.815Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M32.943 39.92a7.748 7.748 0 1 0 15.497 0 7.748 7.748 0 0 0-15.497 0Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M32.943 39.92a7.748 7.748 0 1 0 15.497 0 7.748 7.748 0 0 0-15.497 0ZM40.691 34.754v1.29M40.691 43.793v1.29", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M38.754 41.856a1.938 1.938 0 1 0 1.937-1.936 1.938 1.938 0 1 1 1.937-1.937", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var cooperateMoney = {
  render: render$1k
};
var render$1j = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M72 45.29a32 32 0 1 0-61.149 13.2H69.15A31.875 31.875 0 0 0 72 45.29Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M8.8 58.49h62.4m-66 0h2m65.6 0h2", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40.48 3.713a.486.486 0 0 0-.955 0L38.389 9.77h3.227L40.48 3.713ZM36.508 6.14a1.614 1.614 0 0 1-3.226 0 .474.474 0 0 1 .473-.474h2.28a.475.475 0 0 1 .473.474Zm6.984 0a1.614 1.614 0 0 0 3.227 0 .474.474 0 0 0-.474-.474h-2.28a.474.474 0 0 0-.473.474Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M43.184 9.77a1.062 1.062 0 0 0-1.061-1.062h-4.245a1.062 1.062 0 0 0-1.062 1.062v1.59h6.368V9.77Zm9.553 15.39H27.263a1.062 1.062 0 0 0-1.061 1.062v4.245h27.6v-4.245a1.06 1.06 0 0 0-1.065-1.062Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.737 25.16H27.263v-1.062a1.061 1.061 0 0 1 1.062-1.058h23.35a1.061 1.061 0 0 1 1.062 1.062v1.058Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40 10.831a11.675 11.675 0 0 0-11.675 11.675v.534h23.35v-.53A11.677 11.677 0 0 0 40 10.83Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M40 10.831a11.675 11.675 0 0 0-11.675 11.675v.534h23.35v-.53A11.677 11.677 0 0 0 40 10.83Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M11.873 61.247h56.253V70.8H11.873v-9.553Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M12.404 41.08h55.193v17.514H12.404V41.08Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M12.404 41.08h55.193v17.514H12.404V41.08Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M67.978 38.96H12.022a.531.531 0 0 0-.515.66l.165.658a1.06 1.06 0 0 0 1.03.804h54.596a1.061 1.061 0 0 0 1.03-.804l.165-.659a.53.53 0 0 0-.515-.659Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M66.535 36.835h-53.07a1.062 1.062 0 0 0-1.061 1.062v1.063H67.6v-1.063a1.062 1.062 0 0 0-1.065-1.062Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M65.474 36.835H14.526l3.93-5.896a1.061 1.061 0 0 1 .88-.472h41.32a1.06 1.06 0 0 1 .88.472l3.938 5.896Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M65.474 36.835H14.526l3.93-5.896a1.061 1.061 0 0 1 .88-.472h41.32a1.06 1.06 0 0 1 .88.472l3.938 5.896Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M68.127 61.247H11.873l.53-2.654h55.193l.53 2.654Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M61.228 48.51h3.184v6.369h-3.184V48.51Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M64.412 48.868v-.358h-3.184v5.665l3.184-5.307Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M61.228 48.51h3.184v6.369h-3.184V48.51Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M61.228 44.265h3.184v2.122h-3.184v-2.122Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M22.487 44.796h35.557v17.513H22.487V44.796Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M22.487 44.796h35.557v17.513H22.487V44.796Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M58.044 44.796H21.956l-1.061-2.654h38.21l-1.061 2.654Zm-37.149-6.369h38.21v3.715h-38.21v-3.715Zm-.531-2.122h39.272v2.122H20.364v-2.122Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m20.895 42.142 1.06 2.654h36.089l1.06-2.654H20.896Zm0 0h38.21v-3.715h-38.21v3.715Zm-.531-5.837h39.272v2.122H20.364v-2.122Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M20.364 36.305 40 24.63l19.636 11.675H20.364Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M20.364 36.305 40 24.63l19.636 11.675H20.364Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m20.364 36.305-.72-1.808a1.06 1.06 0 0 1 .446-1.308L39.46 21.76a1.063 1.063 0 0 1 1.079 0l19.374 11.429a1.06 1.06 0 0 1 .446 1.308l-.72 1.808-19.64-11.675-19.635 11.675Zm0 26.004h4.245V70.8h-4.245v-8.491Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M19.834 67.616h5.307V70.8h-5.307v-3.184Zm35.556-5.307h4.246V70.8H55.39v-8.491Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M54.86 67.616h5.307V70.8h-5.308v-3.184Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M24.61 66.554 21.956 70.8h36.088l-2.653-4.246H24.61Zm-2.123-21.758h3.184v17.513h-3.184V44.796Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M25.14 46.918h-2.122a1.062 1.062 0 0 1-1.062-1.061 1.061 1.061 0 0 1 1.062-1.057h2.123a1.061 1.061 0 0 1 1.06 1.06 1.062 1.062 0 0 1-1.06 1.058Zm-2.653 0h3.184v3.184h-3.184v-3.184Zm3.715 15.39h-4.246l.531-2.122h3.184l.53 2.123Zm28.657-17.512h3.184v17.513H54.86V44.796Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M57.513 46.918H55.39a1.061 1.061 0 0 1-1.062-1.061A1.062 1.062 0 0 1 55.39 44.8h2.122a1.061 1.061 0 0 1 1.062 1.06 1.061 1.061 0 0 1-1.062 1.058Zm-2.654 0h3.184v3.184H54.86v-3.184Zm3.715 15.39H54.33l.53-2.122h3.185l.53 2.123ZM47.962 44.797h3.184v17.513H47.96V44.796Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M50.613 46.918h-2.122a1.062 1.062 0 0 1-1.062-1.061 1.062 1.062 0 0 1 1.062-1.057h2.122a1.061 1.061 0 0 1 1.062 1.06 1.062 1.062 0 0 1-1.062 1.058Zm-2.652 0h3.184v3.184H47.96v-3.184Zm3.714 15.39h-4.246l.532-2.122h3.184l.53 2.123Zm-22.82-17.512h3.184v17.513h-3.184V44.796Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M31.509 46.918h-2.123a1.062 1.062 0 0 1-1.061-1.061 1.062 1.062 0 0 1 1.061-1.057h2.123a1.061 1.061 0 0 1 1.061 1.06 1.062 1.062 0 0 1-1.061 1.058Zm-2.654 0h3.184v3.184h-3.184v-3.184Zm3.715 15.39h-4.245l.53-2.122h3.184l.531 2.123Zm9.022-17.512h3.184v17.513h-3.184V44.796Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.246 46.918h-2.123a1.062 1.062 0 0 1-1.061-1.061 1.061 1.061 0 0 1 1.06-1.057h2.124a1.061 1.061 0 0 1 1.061 1.06 1.061 1.061 0 0 1-1.061 1.058Zm-2.654 0h3.184v3.184h-3.184v-3.184Zm3.715 15.39h-4.245l.53-2.122h3.184l.531 2.123ZM35.224 44.797h3.184v17.513h-3.184V44.796Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M37.878 46.918h-2.123a1.062 1.062 0 0 1-1.062-1.061 1.06 1.06 0 0 1 1.062-1.057h2.123a1.06 1.06 0 0 1 1.06 1.06 1.062 1.062 0 0 1-1.06 1.058Zm-2.654 0h3.184v3.184h-3.184v-3.184Zm3.715 15.39h-4.246l.531-2.121h3.184l.53 2.122Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M15.588 48.51h3.184v6.369h-3.184V48.51Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M18.772 48.868v-.358h-3.184v5.665l3.184-5.307Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M15.588 48.51h3.184v6.369h-3.184V48.51Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M15.588 44.265h3.184v2.122h-3.184v-2.122Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M23.283 68.678h33.434m-42.19-10.084v-1.526m5.307 1.526v-1.526m-5.308-14.395V41.08m45.64 17.513v-1.526m5.308 1.526v-1.526m0-14.395V41.08m-19.106-2.654v1.592m6.369-1.592v1.592M40 38.427v1.592m-6.368-1.592v1.592m-6.369-1.592v1.592", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M24.61 62.309h30.78v4.245H24.61V62.31Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M24.61 64.432h30.78", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40 34.181a3.184 3.184 0 1 0 0-6.367 3.184 3.184 0 0 0 0 6.367Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var courthouse = {
  render: render$1j
};
var render$1i = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M40 71.582c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32-17.673 0-32 14.327-32 32 0 17.673 14.327 32 32 32Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M60.412 62.173c3.58 0 6.482-.415 6.482-.927 0-.511-2.902-.926-6.482-.926s-6.482.415-6.482.926c0 .512 2.902.927 6.482.927Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m65.986 41.992-1.2 11.147-.619 5.695a2.138 2.138 0 0 1-2.117 1.906h-3.27a2.137 2.137 0 0 1-2.118-1.906l-.618-5.695-1.206-11.147h11.148Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m54.842 41.992 1.82 16.846a2.131 2.131 0 0 0 2.12 1.902h3.267a2.13 2.13 0 0 0 2.12-1.902l1.82-16.846v-3.04H54.842v3.04Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m64.293 57.7-.122 1.134a2.138 2.138 0 0 1-2.117 1.906H58.78a2.138 2.138 0 0 1-2.117-1.906L56.54 57.7h7.752Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M60.415 43.512V60.74", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M60.412 23.245a9.12 9.12 0 0 0-9.12 9.12v12.414a1.773 1.773 0 1 0 3.546 0v-5.32h11.148v5.32a1.773 1.773 0 1 0 3.547 0V32.344a9.146 9.146 0 0 0-9.121-9.1Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M60.412 23.245a9.12 9.12 0 0 0-9.12 9.12v12.414a1.773 1.773 0 1 0 3.546 0v-5.32h11.148v5.32a1.773 1.773 0 1 0 3.547 0V32.344a9.146 9.146 0 0 0-9.121-9.1Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M64.466 32.872a14 14 0 0 1 1.256-5.807l.69-1.52a.075.075 0 0 1-.022-.05 9.1 9.1 0 0 0-11.99.01v.02l.7 1.54a13.987 13.987 0 0 1 1.256 5.807 1.52 1.52 0 0 1-1.52 1.52v9.228c0 1.934.094 3.864.283 5.79l.173 1.753a.512.512 0 0 0 .506.456h5.445a1.012 1.012 0 0 0 .94-.64l1.303-3.256a.24.24 0 0 1 .47.09v3.296a.506.506 0 0 0 .507.507h.555a.507.507 0 0 0 .504-.456l.177-1.76c.189-1.882.284-3.77.284-5.665v-9.343a1.52 1.52 0 0 1-1.517-1.52Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M64.466 32.872a14 14 0 0 1 1.256-5.807l.69-1.52a.075.075 0 0 1-.022-.05 9.1 9.1 0 0 0-11.99.01v.02l.7 1.54a13.987 13.987 0 0 1 1.256 5.807 1.52 1.52 0 0 1-1.52 1.52v9.228c0 1.934.094 3.864.283 5.79l.173 1.753a.512.512 0 0 0 .506.456h5.445a1.012 1.012 0 0 0 .94-.64l1.303-3.256a.24.24 0 0 1 .47.09v3.296a.506.506 0 0 0 .507.507h.555a.507.507 0 0 0 .504-.456l.177-1.76c.189-1.882.284-3.77.284-5.665v-9.343a1.52 1.52 0 0 1-1.517-1.52ZM54.838 34.39v-3.038M65.986 34.392v-3.04", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.913 23.6a.88.88 0 0 1-.647-.851v-2.843h-3.72v2.844a.88.88 0 0 1-.647.85 7.77 7.77 0 0 0-.468.145v.008c.447 1.125 1.551 4.51 2.98 5.573 1.429-1.074 2.584-4.56 2.98-5.573a5.438 5.438 0 0 0-.478-.153Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M60.412 29.325s1.977 3.643 4.706 4.8", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M65.986 38.446s-2.365 0-3.548 1.52c-1.182 1.52-1.73 3.546-3.04 3.546-.44 0-.871-.117-1.25-.34a.347.347 0 0 0-.497.429 2.835 2.835 0 0 0 2.76 1.938c2.787 0 2.998-2.745 4.055-3.547 1.056-.802 1.52 0 1.52 0v-3.546Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.433 32.384v9.627H11.192v-9.627a9.12 9.12 0 0 1 18.24 0Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M29.433 32.384v9.627H11.192v-9.627a9.12 9.12 0 0 1 18.24 0Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M20.82 62.699c3.58 0 6.482-.415 6.482-.927 0-.511-2.902-.926-6.483-.926-3.58 0-6.482.415-6.482.926 0 .512 2.902.927 6.482.927ZM24.353 55.691l1.534-13.68H14.739l1.534 13.68h8.08Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m24.353 55.691 1.534-13.68H14.739l1.534 13.68h8.08ZM20.313 46.064v9.627", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M16.26 60.758h4.053v-7.6H16.4a1.013 1.013 0 0 0-1.005 1.148l.864 6.452ZM24.367 60.758h-4.054v-7.6h3.91a1.012 1.012 0 0 1 1.004 1.148l-.86 6.452Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M20.313 60.758a3.04 3.04 0 0 0-3.04-3.04h-.507a3.04 3.04 0 0 0-2.662 1.57 1.011 1.011 0 0 0 .909 1.47h5.3ZM25.612 60.758a1.011 1.011 0 0 0 .91-1.47 3.04 3.04 0 0 0-2.663-1.57h-.506a3.04 3.04 0 0 0-3.04 3.04h5.3Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M14.74 43.024v-4.56h-3.548V44.8a1.774 1.774 0 0 0 3.547 0v-1.776Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M14.74 43.024v-4.56h-3.548V44.8a1.774 1.774 0 0 0 3.547 0v-1.776Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M25.887 38.464V44.8a1.777 1.777 0 0 0 1.085 1.673 1.773 1.773 0 0 0 2.461-1.673v-6.336h-3.546Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M25.887 38.464V44.8a1.777 1.777 0 0 0 1.085 1.673 1.773 1.773 0 0 0 2.461-1.673v-6.336h-3.546ZM15.245 28.33c-1.27 2.54-2.037 3.33-1.064 4.701.365.514.56 1.13.56 1.76v3.673M25.887 38.464v-3.676c-.001-.63.194-1.246.56-1.76.972-1.372.204-2.16-1.066-4.7", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M22.815 23.62a.88.88 0 0 1-.64-.85v-2.866h-3.718v2.867a.88.88 0 0 1-.64.848 9.007 9.007 0 0 0-3.034 1.52v.01a6.432 6.432 0 0 0 5.534 2.676 6.43 6.43 0 0 0 5.533-2.675v-.01a9.013 9.013 0 0 0-3.035-1.52Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m24.39 24.223-4.077 8.667-4.075-8.66", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M20.313 35.93a1.52 1.52 0 1 0 0-3.04 1.52 1.52 0 0 0 0 3.04Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M23.86 19.847a5.506 5.506 0 0 1 .828 6.727 5.808 5.808 0 0 0-.829 2.99v1.572a.367.367 0 0 1-.684.182l-.765-1.339a6.778 6.778 0 0 1 .4-7.34 4.847 4.847 0 0 0 1.05-2.792Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M27.407 16.3a1.248 1.248 0 0 0-1.014-1.215v-.81a6.08 6.08 0 1 0-12.16 0v.81a1.242 1.242 0 0 0 .128 2.457 6.08 6.08 0 0 0 11.905 0 1.254 1.254 0 0 0 1.14-1.241Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M17.02 17.82a.76.76 0 1 0 0-1.52.76.76 0 0 0 0 1.52ZM23.606 17.82a.76.76 0 1 0 0-1.52.76.76 0 0 0 0 1.52Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M18.793 18.88a2.74 2.74 0 0 0 3.04 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M26.393 15.085a5.002 5.002 0 0 0 .56-4.143 5.473 5.473 0 0 0-2.806-3.364l-2.644-1.323a1.015 1.015 0 0 0-1.454.748c-.21 1.322-.373 3.28.264 4.23 1.014 1.52 5.574 1.32 6.08 3.852Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M26.393 15.085a5.002 5.002 0 0 0 .56-4.143 5.473 5.473 0 0 0-2.806-3.364l-2.644-1.323a1.015 1.015 0 0 0-1.454.748c-.21 1.322-.373 3.28.264 4.23 1.014 1.52 5.574 1.32 6.08 3.852Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M20.049 7.003a1.02 1.02 0 0 1 .112-.328 7.094 7.094 0 0 0-6.942 7.092v2.534c3.8-1.82 3.04-6.07 6.73-6.07a10.573 10.573 0 0 1 .1-3.228Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M20.049 7.003a1.02 1.02 0 0 1 .112-.328 7.094 7.094 0 0 0-6.942 7.092v2.534c3.8-1.82 3.04-6.07 6.73-6.07a10.573 10.573 0 0 1 .1-3.228ZM23.052 15.287a.863.863 0 0 0-1.219 0M18.793 15.287a.864.864 0 0 0-1.22 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M32.644 49.409v16.505a.59.59 0 0 0 .59.59h4.716l.465-9.367a1.894 1.894 0 0 1 3.785 0l.466 9.367h4.716a.59.59 0 0 0 .59-.59V49.41H32.643Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M32.644 49.409v16.505a.59.59 0 0 0 .59.59h4.716l.465-9.367a1.894 1.894 0 0 1 3.785 0l.466 9.367h4.716a.59.59 0 0 0 .59-.59V49.41H32.643Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M30.58 55.893a2.063 2.063 0 0 1-2.062-2.063V40.566h4.126V53.83a2.063 2.063 0 0 1-2.063 2.063ZM50.034 55.893a2.064 2.064 0 0 1-2.063-2.063V40.566h4.127V53.83a2.063 2.063 0 0 1-2.064 2.063ZM37.067 71.81h-2.952a.88.88 0 0 1-.88-.88v-4.426h4.716v4.424a.88.88 0 0 1-.884.882ZM46.499 71.81h-2.952a.88.88 0 0 1-.88-.88v-4.426h4.716v4.424a.882.882 0 0 1-.884.882Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40.307 73.851c5.115 0 9.261-.622 9.261-1.389s-4.146-1.389-9.26-1.389c-5.115 0-9.262.622-9.262 1.39 0 .766 4.147 1.388 9.261 1.388Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M52.097 39.977v12.38h-4.126v-1.18H32.644v1.18h-4.127v-12.38a11.79 11.79 0 1 1 23.58 0Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M32.644 37.618v13.559M47.971 37.618v13.559", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M43.515 28.64a.88.88 0 0 1-.64-.849l.004-3.76h-5.112v3.749a.88.88 0 0 1-.645.849 8.86 8.86 0 0 0-.384.116s.035 3.572 3.572 3.572c3.396 0 3.56-3.29 3.573-3.56a6.587 6.587 0 0 0-.368-.117ZM48.24 71.81a1.177 1.177 0 0 0 1.057-1.71 3.533 3.533 0 0 0-3.096-1.827h-.59a3.538 3.538 0 0 0-3.097 1.826 1.176 1.176 0 0 0 1.058 1.71h4.668ZM37.04 71.81a1.177 1.177 0 0 0 1.058-1.71A3.534 3.534 0 0 0 35 68.272h-.59a3.538 3.538 0 0 0-3.097 1.826 1.175 1.175 0 0 0 1.058 1.71h4.668Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.098 39.977v12.379H47.97v-3.537h-3.537a2.365 2.365 0 0 1-2.354-2.358V32.902l2.228-4.008h.024a11.798 11.798 0 0 1 7.766 11.083Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M52.098 39.977v12.379H47.97v-3.537h-3.537a2.365 2.365 0 0 1-2.354-2.358V32.902l2.228-4.008h.024a11.798 11.798 0 0 1 7.766 11.083Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m46.203 29.778-.83 3.03a1.18 1.18 0 0 1-1.575.783l-1.718-.689 2.228-4.008h.012c.654.234 1.285.53 1.883.884Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M38.54 32.902v13.559a2.366 2.366 0 0 1-2.36 2.358h-3.536v3.537h-4.126v-12.38a11.798 11.798 0 0 1 7.77-11.082h.022l2.23 4.008Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M38.54 32.902v13.559a2.366 2.366 0 0 1-2.36 2.358h-3.536v3.537h-4.126v-12.38a11.798 11.798 0 0 1 7.77-11.082h.022l2.23 4.008Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m38.54 32.902-1.722.69a1.18 1.18 0 0 1-1.575-.784l-.83-3.03v-.012a11.908 11.908 0 0 1 1.886-.872h.011l2.23 4.008Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M47.971 48.82V37.617M32.644 48.82V37.617", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M67.506 16.282a1.249 1.249 0 0 0-1.014-1.216v-.81a6.08 6.08 0 1 0-12.16 0v.81a1.242 1.242 0 0 0 .128 2.458 6.08 6.08 0 0 0 11.905 0 1.255 1.255 0 0 0 1.14-1.242Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M57.118 17.802a.76.76 0 1 0 0-1.52.76.76 0 0 0 0 1.52ZM63.705 17.802a.76.76 0 1 0 0-1.52.76.76 0 0 0 0 1.52Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M58.891 18.862a2.742 2.742 0 0 0 3.04 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M54.331 15.066c1.721-.407 1.815-1.863 3.755-1.863a5.09 5.09 0 0 0 3.746-1.443.504.504 0 0 1 .654-.047.51.51 0 0 1 .153.178c.738 1.45 3.853 3.179 3.853 3.179a1.241 1.241 0 0 1-.128 2.457 6.09 6.09 0 0 1-3.593 4.363c.445.76.679 1.623.679 2.503a4.862 4.862 0 0 1-.316 1.712.609.609 0 0 0 .57.82c2.658 0 4.813-2.406 4.813-9.627 0-7.473-2.155-9.626-4.814-9.626a2.514 2.514 0 0 0-.72.118 7.127 7.127 0 0 0-3.844-1.132c-4.056 0-6.84 2.597-6.84 8.108 0 3.674 2.135 6.348 5.388 6.96a6.09 6.09 0 0 1-3.23-4.197 1.241 1.241 0 0 1-.129-2.458l.003-.005Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M54.331 15.066c1.721-.407 1.815-1.863 3.755-1.863a5.09 5.09 0 0 0 3.746-1.443.504.504 0 0 1 .654-.047.51.51 0 0 1 .153.178c.738 1.45 3.853 3.179 3.853 3.179a1.241 1.241 0 0 1-.128 2.457 6.09 6.09 0 0 1-3.593 4.363c.445.76.679 1.623.679 2.503a4.862 4.862 0 0 1-.316 1.712.609.609 0 0 0 .57.82c2.658 0 4.813-2.406 4.813-9.627 0-7.473-2.155-9.626-4.814-9.626a2.514 2.514 0 0 0-.72.118 7.127 7.127 0 0 0-3.844-1.132c-4.056 0-6.84 2.597-6.84 8.108 0 3.674 2.135 6.348 5.388 6.96a6.09 6.09 0 0 1-3.23-4.197 1.241 1.241 0 0 1-.129-2.458l.003-.005Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M63.151 15.269a.862.862 0 0 0-1.219 0M58.891 15.269a.863.863 0 0 0-1.22 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M48.535 20.235a1.448 1.448 0 0 0-1.175-1.41v-.94a7.053 7.053 0 1 0-14.105 0v.94a1.439 1.439 0 0 0 .148 2.85 7.053 7.053 0 0 0 13.809 0 1.455 1.455 0 0 0 1.323-1.44Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M36.487 21.998a.882.882 0 1 0 0-1.763.882.882 0 0 0 0 1.763ZM44.127 21.998a.882.882 0 1 0 0-1.763.882.882 0 0 0 0 1.763Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M38.545 23.76a3.178 3.178 0 0 0 3.527 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M45.873 11.474a.352.352 0 0 1-.072-.37c.194-.5.316-1.025.364-1.56a.352.352 0 0 0-.42-.376c-1.181.234-2.095.14-4.471-.031a7.544 7.544 0 0 0-.965-.068 7.64 7.64 0 0 0-7.641 7.64v.853a1.261 1.261 0 0 0 .864 1.2.837.837 0 0 0 1.086-.63 5.759 5.759 0 0 1 2.446-3.925.353.353 0 0 1 .423.018c.642.486 1.43.74 2.234.72.404 0 .805-.062 1.19-.185a.354.354 0 0 1 .383.115 1.747 1.747 0 0 0 2.644.102.35.35 0 0 1 .395-.084.357.357 0 0 1 .117.08A5.797 5.797 0 0 1 46 18.13a.838.838 0 0 0 1.085.63 1.263 1.263 0 0 0 .864-1.2v-.851a7.615 7.615 0 0 0-2.076-5.235Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M45.873 11.474a.351.351 0 0 1-.072-.37 5.71 5.71 0 0 0 .364-1.56.352.352 0 0 0-.42-.376c-1.181.234-2.095.14-4.471-.031a7.544 7.544 0 0 0-.965-.068 7.64 7.64 0 0 0-7.641 7.64v.853a1.261 1.261 0 0 0 .864 1.2.837.837 0 0 0 1.086-.63 5.759 5.759 0 0 1 2.446-3.925.353.353 0 0 1 .423.018c.642.486 1.43.74 2.234.72.404 0 .805-.062 1.19-.185a.354.354 0 0 1 .383.115 1.747 1.747 0 0 0 2.644.102.35.35 0 0 1 .395-.084.357.357 0 0 1 .117.08A5.797 5.797 0 0 1 46 18.13a.838.838 0 0 0 1.085.63 1.263 1.263 0 0 0 .864-1.2v-.851a7.615 7.615 0 0 0-2.076-5.235Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M39.133 19.648a1.175 1.175 0 0 1-1.175 1.175h-1.76a1.175 1.175 0 0 1-1.175-1.175V18.24a.352.352 0 0 1 .352-.352h3.41a.352.352 0 0 1 .351.352l-.003 1.408ZM44.422 20.823h-1.76a1.175 1.175 0 0 1-1.175-1.175V18.24a.35.35 0 0 1 .353-.352h3.409a.353.353 0 0 1 .351.352v1.408a1.175 1.175 0 0 1-1.178 1.175Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M44.422 20.823h-1.76a1.175 1.175 0 0 1-1.175-1.175V18.24a.35.35 0 0 1 .353-.352h3.409a.353.353 0 0 1 .351.352v1.408a1.175 1.175 0 0 1-1.178 1.175ZM39.133 18.472h2.351M39.133 19.648a1.175 1.175 0 0 1-1.175 1.175h-1.76a1.175 1.175 0 0 1-1.175-1.175V18.24a.352.352 0 0 1 .352-.352h3.41a.352.352 0 0 1 .351.352l-.003 1.408Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var coworkerFullBody = {
  render: render$1i
};
var render$1h = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M47.165 55.814h4.15c.132 0 .262.034.376.1V50.16a11.691 11.691 0 0 0-23.382 0v5.76a.749.749 0 0 1 .376-.1h4.15v5.06h14.33v-5.066Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M37.36 38.842a2.64 2.64 0 1 0 5.28 0v-2.64h-5.28v2.64Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M37.36 38.842v-2.64h5.28v2.64a2.64 2.64 0 0 1-5.28 0Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.063 58.83h3.771v2.05h-3.771v-2.05ZM47.166 58.83h3.772v2.05h-3.772v-2.05Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M47.166 55.814h4.148c.133 0 .263.034.377.1V50.16a11.695 11.695 0 0 0-7.872-11.053l-1.934 4.261S40.96 54.64 43.813 60.88h3.352v-5.066Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M28.686 58.83h4.148v-3.017h-4.149a.755.755 0 0 0-.754.755v1.512a.754.754 0 0 0 .755.75Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M47.166 49.025v6.789", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.314 58.83h-4.148v-3.017h4.148a.755.755 0 0 1 .755.755v1.512a.754.754 0 0 1-.755.75Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m38.114 43.368-1.933-4.265a11.695 11.695 0 0 0-7.872 11.057v5.76a.749.749 0 0 1 .376-.1h4.15v5.06h3.351c2.854-6.24 1.928-17.512 1.928-17.512Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M47.166 55.814h4.148c.133 0 .263.034.377.1V50.16a11.695 11.695 0 0 0-7.872-11.053l-1.934 4.261S40.96 54.64 43.813 60.88h3.352v-5.066ZM38.114 43.368l-1.933-4.265a11.695 11.695 0 0 0-7.872 11.057v5.76a.749.749 0 0 1 .376-.1h4.15v5.06h3.351c2.854-6.24 1.928-17.512 1.928-17.512ZM32.834 49.025v6.789", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.28 38.087a2.885 2.885 0 0 1 2.886 2.887c0 .754-.233 1.15-1.196 3.797a.754.754 0 0 1-1.097.389l-2.987-1.792 2.394-5.28ZM35.72 38.087a2.885 2.885 0 0 0-2.886 2.887c0 .754.233 1.15 1.197 3.797a.754.754 0 0 0 1.096.389l2.987-1.792-2.394-5.28Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40.731 45.747c.125.454.193.922.202 1.393a.42.42 0 0 0 .687.306c1.011-.81 1.18-2.344 1.093-3.433-.604.64-1.268 1.22-1.982 1.734Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.115 38.414c2.098 3.592-3.206 7.584-5.488 8.581a.542.542 0 0 1-.752-.52c.103-2.257-2.795-3.654-3.101-6.065-.356-2.8 1.027-3.647 4.825-2.296 2.13.757 3.21-1.935 4.516.3Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M44.115 38.414c2.098 3.592-3.206 7.584-5.488 8.581a.542.542 0 0 1-.752-.52c.103-2.257-2.795-3.654-3.101-6.065-.356-2.8 1.027-3.647 4.825-2.296 2.13.757 3.21-1.935 4.516.3Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M47.543 28.282v-1.886a7.543 7.543 0 0 0-15.086 0v1.886a1.508 1.508 0 1 0 0 3.017c.032 0 .062-.008.093-.01a7.533 7.533 0 0 0 14.9 0c.032 0 .061.01.093.01a1.509 1.509 0 0 0 0-3.017Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M34.72 31.487a.943.943 0 1 0 1.887 0 .943.943 0 0 0-1.887 0ZM43.394 31.487a.943.943 0 1 0 1.886 0 .943.943 0 0 0-1.886 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M42.263 33.403a3.262 3.262 0 0 1-4.526 0M38.114 29.04a1.226 1.226 0 0 0-2.263 0M44.149 29.04a1.225 1.225 0 0 0-2.263 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M47.543 26.396a7.543 7.543 0 0 0-15.086 0v1.886a1.208 1.208 0 0 1 1.207 1.294 6.198 6.198 0 0 0 .302-3.18 3.622 3.622 0 0 0 1.885-.754V23.76a11.786 11.786 0 0 0 8.298 0v1.886a3.622 3.622 0 0 0 1.886.754 6.199 6.199 0 0 0 .301 3.18 1.208 1.208 0 0 1 1.207-1.294v-1.89Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M47.543 26.396a7.543 7.543 0 0 0-15.086 0v1.886a1.208 1.208 0 0 1 1.207 1.294 6.198 6.198 0 0 0 .302-3.18 3.622 3.622 0 0 0 1.885-.754V23.76a11.786 11.786 0 0 0 8.298 0v1.886a3.622 3.622 0 0 0 1.886.754 6.199 6.199 0 0 0 .301 3.18 1.208 1.208 0 0 1 1.207-1.294v-1.89Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M31.26 55.178a11.782 11.782 0 0 0-12.35-11.766 12 12 0 0 0-11.21 12.1v1.566h4.56v3.802H26.7v-3.8h3.8a.76.76 0 0 0 .76-.76v-1.142Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M12.26 59.358H26.7M7.7 57.078H30.5M7.72 54.798h23.54M8.069 52.518h22.889M8.885 50.238h21.293M10.286 47.959h18.503M12.606 45.678h13.838M31.26 55.178a11.782 11.782 0 0 0-12.35-11.766 12 12 0 0 0-11.21 12.1v1.566h4.56v3.802H26.7v-3.8h3.8a.76.76 0 0 0 .76-.76v-1.142ZM12.26 54.038v6.84M26.7 54.038v3.04", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M16.82 43.779a2.66 2.66 0 0 0 5.32 0V41.12h-5.32v2.659Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M19.48 46.438a2.66 2.66 0 0 1-2.66-2.66V41.12h5.32v2.66a2.66 2.66 0 0 1-2.66 2.658Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M8.459 57.078h3.8v3.8h-3.8v-3.8ZM26.7 57.078h3.8v3.8h-3.8v-3.8Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M12.26 60.118v.76h3.8c2.688-2.16 9.389-10.263 11.34-14.14a.756.756 0 0 0-.184-.924c-.614-.51-1.277-.959-1.979-1.34a.763.763 0 0 0-1.098.432c-1.011 3.346-4.43 9.313-11.88 15.212Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M72.3 55.178a11.78 11.78 0 0 0-23.56 0v5.702H72.3v-5.702Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M57.86 46.059a2.66 2.66 0 1 0 5.32 0v-6.84h-5.32v6.84Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M57.86 46.059a2.66 2.66 0 1 0 5.32 0v-6.84h-5.32v6.84Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m57.86 43.018 2.66 5.702-3.447 1.254a.76.76 0 0 1-.98-.474l-1.653-4.96 3.42-1.522ZM63.18 43.018l-2.66 5.702 3.446 1.254a.76.76 0 0 0 .981-.474l1.653-4.96-3.42-1.522Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M60.52 48.718v12.16-12.16Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M60.52 48.718v12.16", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M57.86 58.978v1.902h-9.12v-5.702a11.767 11.767 0 0 1 7.41-10.938l1.71 14.738Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M57.86 58.978v1.902h-9.12v-5.702a11.767 11.767 0 0 1 7.41-10.938l1.71 14.738Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M72.3 55.178v5.702h-9.12v-1.902l1.71-14.738a11.767 11.767 0 0 1 7.41 10.938Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m64.595 46.783.295-2.54a11.767 11.767 0 0 1 7.41 10.935v2.662a11.784 11.784 0 0 0-7.705-11.057Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M72.3 55.178v5.702h-9.12v-1.902l1.71-14.738a11.767 11.767 0 0 1 7.41 10.938Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M72.3 55.178v5.702h-9.12v-1.902l1.71-14.738a11.767 11.767 0 0 1 7.41 10.938Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m57.86 43.018-.856.38a1.133 1.133 0 0 0-.64 1.324c.216.82.489 2.026.745 3.631.52 3.518.77 7.07.752 10.625 0 0-1.901-8.36-3.421-9.5a6.098 6.098 0 0 1-2.28-4.94c0-1.846 2.386-3.412 5.7-3.959v2.44ZM63.18 43.018l.855.38a1.132 1.132 0 0 1 .64 1.324c-.216.82-.489 2.026-.745 3.631-.52 3.518-.77 7.07-.752 10.625 0 0 1.9-8.36 3.42-9.5a6.1 6.1 0 0 0 2.28-4.94c0-1.846-2.386-3.412-5.7-3.959l.002 2.44Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M53.3 54.419v6.46M67.74 54.419v6.46", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M68.32 33.04v-1.825a7.775 7.775 0 1 0-15.548 0v1.825a1.371 1.371 0 0 0-1.372 1.376v.457a1.372 1.372 0 0 0 1.371 1.372c.044 0 .085-.009.127-.013a7.765 7.765 0 0 0 15.295 0c.042.004.08.013.126.013a1.372 1.372 0 0 0 1.372-1.372v-.457a1.373 1.373 0 0 0-1.371-1.376Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M66.032 36.245a.915.915 0 1 1-1.83.002.915.915 0 0 1 1.83-.002ZM56.887 36.245a.914.914 0 1 1-1.827 0 .914.914 0 0 1 1.827 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M64.706 33.806a1.238 1.238 0 0 0-2.286 0M58.62 33.806a1.238 1.238 0 0 0-2.286 0M58.227 38.08a3.314 3.314 0 0 0 4.573 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M59.631 22.047c-5.487 0-7.774 4.01-7.851 7.774v3.2c2.364 0 2.364-2.744 2.364-2.744s5.487.914 9.145-1.83c0 0 2.286 4.574 5.97 4.574v-3.2c-.026-4.599-.995-6.4-5.513-6.4 0-.002-.457-1.374-4.115-1.374Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M59.631 22.047c-5.487 0-7.774 4.01-7.851 7.774v3.2c2.364 0 2.364-2.744 2.364-2.744s5.487.914 9.145-1.83c0 0 2.286 4.574 5.97 4.574v-3.2c-.026-4.599-.995-6.4-5.513-6.4 0-.002-.457-1.374-4.115-1.374Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M57.994 35.798h-2.48a1.88 1.88 0 0 1-1.829-1.862V32.41a.76.76 0 0 1 .76-.76h4.62a.914.914 0 0 1 .91 1.015l-.16 1.474a1.884 1.884 0 0 1-1.82 1.66ZM63.097 35.798h2.48a1.812 1.812 0 0 0 1.783-1.862V32.41a.697.697 0 0 0-.715-.76h-4.62a.913.913 0 0 0-.909 1.016l.16 1.473a1.885 1.885 0 0 0 1.82 1.66ZM59.936 33.023h1.22", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m10.743 33.903-.84-.28a.228.228 0 0 1-.11-.353l.95-1.266-.84-.28a.228.228 0 0 1-.11-.353l.95-1.266h1.897v3.798h-1.897ZM28.217 33.903l.839-.28a.228.228 0 0 0 .11-.353l-.95-1.266.84-.28a.228.228 0 0 0 .11-.353l-.95-1.266H26.32v3.798h1.897Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M27.077 33.143v-1.899a7.6 7.6 0 1 0-15.194 0v1.9a1.52 1.52 0 1 0 0 3.04c.032 0 .062-.009.093-.01a7.587 7.587 0 0 0 15.008 0c.031 0 .06.01.093.01a1.52 1.52 0 1 0 0-3.04Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M27.077 33.143v-1.899a7.6 7.6 0 1 0-15.194 0v1.9a1.52 1.52 0 1 0 0 3.04c.032 0 .062-.009.093-.01a7.587 7.587 0 0 0 15.008 0c.031 0 .06.01.093.01a1.52 1.52 0 1 0 0-3.04Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M14.163 36.372a.95.95 0 1 0 1.899 0 .95.95 0 0 0-1.9 0ZM22.898 36.372a.95.95 0 1 0 1.9 0 .95.95 0 0 0-1.9 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M17.194 38.3a3.314 3.314 0 0 0 4.572 0M17.581 33.903a1.235 1.235 0 0 0-2.28 0M21.38 33.903a1.235 1.235 0 0 1 2.279 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M28.217 27.768a6.4 6.4 0 0 0-6.4-6.4h-4.673a6.4 6.4 0 0 0-6.4 6.4v2.337h17.473v-2.337Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M28.217 27.768a6.4 6.4 0 0 0-6.4-6.4h-4.673a6.4 6.4 0 0 0-6.4 6.4v2.337h17.473v-2.337Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M19.48 25.927a1.898 1.898 0 0 0-1.9 1.899.38.38 0 0 0 .38.38h3.419v-.38a1.9 1.9 0 0 0-1.9-1.9Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M21.38 28.206h.189a.95.95 0 1 1 0 1.899h-.19", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M20.847 41.424a.758.758 0 0 0-.607-.304h-1.52a.762.762 0 0 0-.608.304l-.595.794a.38.38 0 0 0 .184.588l.64.213.835 1.115a.38.38 0 0 0 .608 0l.835-1.115.64-.212a.38.38 0 0 0 .184-.59l-.596-.793Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var coworkerHalfBody = {
  render: render$1h
};
var render$1g = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8.2 41.205a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "m32.13 38.309-.91-1.615a1.142 1.142 0 0 1 .433-1.553l1.987-1.12a1.14 1.14 0 0 1 1.553.433l.91 1.616a1.499 1.499 0 0 1-.374 1.933 7.872 7.872 0 0 1-1.752.987 1.501 1.501 0 0 1-1.848-.681Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m32.13 38.309-.91-1.615a1.142 1.142 0 0 1 .433-1.553l1.987-1.12a1.14 1.14 0 0 1 1.553.433l.91 1.616a1.499 1.499 0 0 1-.374 1.933 7.872 7.872 0 0 1-1.752.987 1.501 1.501 0 0 1-1.848-.681Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M7.133 48c0-6.443 5.022-11.962 11.463-12.13A11.78 11.78 0 0 1 30.693 47.6a1.52 1.52 0 0 0 3.04.042v-3.8h4.56v3.598a6.218 6.218 0 0 1-5.676 6.275 6.079 6.079 0 0 1-6.484-6.066v5.164a22.1 22.1 0 0 0 2.093 9.107 9.6 9.6 0 0 1 1.134 4.915H9.793a16.961 16.961 0 0 1 .847-5.702H7.133V48Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M9.793 66.835a16.961 16.961 0 0 1 .847-5.702H7.133V48c0-6.443 5.022-11.962 11.463-12.13A11.78 11.78 0 0 1 30.693 47.6a1.52 1.52 0 0 0 3.04.042v-3.8h4.56v3.598a6.218 6.218 0 0 1-5.676 6.275 6.079 6.079 0 0 1-6.484-6.066v5.164a22.1 22.1 0 0 0 2.093 9.107 9.6 9.6 0 0 1 1.134 4.915M11.693 46.693v14.44", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M21.51 32.649v3.976a3.674 3.674 0 0 1-5.32 0v-3.976h5.32Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M21.51 32.649v3.976a3.674 3.674 0 0 1-5.32 0v-3.976h5.32Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M23.944 36.99 18.85 48.212 13.896 37.02", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M16.95 50.113a1.9 1.9 0 1 0 3.8 0 1.9 1.9 0 0 0-3.8 0Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M18.09 50.113a.76.76 0 1 0 1.52 0 .76.76 0 0 0-1.52 0Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M9.793 64.933a1.9 1.9 0 0 0 1.9-1.9v-1.9h-3.8v1.9a1.9 1.9 0 0 0 1.9 1.9ZM53.873 63.223a1.91 1.91 0 0 1-3.313 1.467 1.908 1.908 0 0 1-.487-1.467v-13.49h3.8v13.49Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M70.213 67.215c0-4.56-1.9-5.702-1.9-5.702v-8.984l.5-1.334c.174-.468.26-.963.254-1.462h3.046a.76.76 0 0 0 .76-.76v-.8c0-6.464-5.08-12.123-11.78-12.123-6.7 0-11.78 5.662-11.78 12.125v.8a.76.76 0 0 0 .76.76h3.047c-.005.499.08.995.255 1.462l.5 1.334v8.984s-1.9 1.142-1.9 5.703l18.238-.003Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M70.213 67.215c0-4.56-1.9-5.702-1.9-5.702v-8.984l.5-1.334c.174-.468.26-.963.254-1.462h3.046a.76.76 0 0 0 .76-.76v-.8c0-6.464-5.08-12.123-11.78-12.123-6.7 0-11.78 5.662-11.78 12.125v.8a.76.76 0 0 0 .76.76h3.047c-.005.499.08.995.255 1.462l.5 1.334v8.984s-1.9 1.142-1.9 5.703", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M53.888 44.589v1.9a4.708 4.708 0 0 1-.448 1.671 4.086 4.086 0 0 0-.329 1.576", "fill": "#fff" } }), _c("path", { attrs: { "d": "M53.888 44.589v1.9a4.708 4.708 0 0 1-.448 1.671 4.086 4.086 0 0 0-.329 1.576", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M58.218 39.71a1.52 1.52 0 0 0 2.16-.51l.712-1.247-2.327-1.665a11.39 11.39 0 0 0-3.58 1.398l3.035 2.024ZM63.968 39.71a1.52 1.52 0 0 1-2.16-.51l-.712-1.247 2.33-1.665a11.39 11.39 0 0 1 3.58 1.398l-3.038 2.024Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M63.753 33.013v3.612a3.673 3.673 0 0 1-5.32 0v-3.612h5.32Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M63.753 33.013v3.612a3.673 3.673 0 0 1-5.32 0v-3.612h5.32Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M69.103 60.672a.759.759 0 0 1-1.103.814c-3.47-1.864-5.064-3.688-6.974-7.662L53.81 38.827a1.14 1.14 0 1 1 2.055-.987l7.212 14.997c1.6 3.324 2.813 4.833 5.468 6.35a.76.76 0 0 1 .368.515l.19.97Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m61.946 51.36-1.37.658a.758.758 0 0 1-.896-1.191.76.76 0 0 1 .237-.178l1.37-.66a.759.759 0 0 1 1.047.937.761.761 0 0 1-.388.434Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M68.298 44.589v1.9a4.71 4.71 0 0 0 .446 1.671c.213.498.325 1.034.33 1.576", "fill": "#fff" } }), _c("path", { attrs: { "d": "M68.298 44.589v1.9a4.71 4.71 0 0 0 .446 1.671c.213.498.325 1.034.33 1.576", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M72.111 49.733v13.49a2 2 0 0 1-1.9 2.09 1.59 1.59 0 0 1-.463-.068 2.055 2.055 0 0 1-1.44-2.022V52.53l.502-1.338c.173-.467.258-.961.25-1.46h3.051ZM32.593 58.473h14.44v2.66h-14.44v-2.66Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M37.533 58.473h4.56v2.66h-4.56v-2.66Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M32.593 61.133h14.44v7.98h-14.44v-7.98Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M32.593 69.113v-7.98h14.44v7.98M39.813 63.413v5.7", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M39.243 35.306a12 12 0 0 0-11.21 12.1v.427a.76.76 0 0 0 .76.76h3.8v9.88h14.44v-9.88h3.8a.76.76 0 0 0 .76-.76v-.76a11.782 11.782 0 0 0-12.35-11.767Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M39.243 35.306a12 12 0 0 0-11.21 12.1v.427a.76.76 0 0 0 .76.76h3.8v9.88h14.44v-9.88h3.8a.76.76 0 0 0 .76-.76v-.76a11.782 11.782 0 0 0-12.35-11.767Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m42.473 37.193-2.66 2.66-2.66-2.66v-4.18h5.32v4.18Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m42.473 37.193-2.66 2.66-2.66-2.66v-4.18h5.32v4.18ZM32.593 45.933v.76M47.033 45.933v.76", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M39.813 39.853c2.666 1.665 1.82 1.145 2.43 1.52a.754.754 0 0 0 1.03-.21 12.793 12.793 0 0 0 1.423-4.64.758.758 0 0 0-.332-.73l-1.891-1.262c-.402 2.039-1.064 3.939-2.66 5.322ZM39.813 39.853c-2.667 1.665-1.82 1.145-2.43 1.52a.755.755 0 0 1-1.03-.21 12.806 12.806 0 0 1-1.424-4.64.757.757 0 0 1 .332-.73l1.892-1.262c.403 2.039 1.064 3.939 2.66 5.322Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M32.593 46.693h14.44v3.42h-14.44v-3.42Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M47.033 48.593v7.205a8.294 8.294 0 0 1-2.69 6.104l2.683 2.682a12.086 12.086 0 0 0 3.807-8.786v-7.205h-3.8ZM32.593 48.593v7.205a8.296 8.296 0 0 0 2.69 6.104L32.6 64.584a12.084 12.084 0 0 1-3.807-8.786v-7.205h3.8Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M26.133 47.645v-1.14", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M15.05 10.593a3.8 3.8 0 1 0 7.6 0 3.8 3.8 0 0 0-7.6 0Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M15.05 10.593a3.8 3.8 0 1 0 7.6 0 3.8 3.8 0 0 0-7.6 0Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M26.45 24.273v-1.9a7.6 7.6 0 0 0-15.2 0v1.9a1.52 1.52 0 1 0 0 3.04c.031 0 .061-.008.092-.01a7.59 7.59 0 0 0 15.014 0c.032 0 .061.01.093.01a1.52 1.52 0 1 0 0-3.04Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M13.529 27.503a.95.95 0 1 0 1.9 0 .95.95 0 0 0-1.9 0ZM22.269 27.503a.95.95 0 1 0 1.902 0 .95.95 0 0 0-1.902 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M16.56 29.433a3.316 3.316 0 0 0 4.573 0M23.03 25.033a1.24 1.24 0 0 0-2.287 0M16.943 25.033a1.238 1.238 0 0 0-2.286 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M27.59 21.613a8.74 8.74 0 0 0-8.74-8.74c-4.828 0-9.12 3.913-9.12 8.74v7.36c0 2.166.79 4.258 2.221 5.883a.38.38 0 0 0 .66-.312c-.526-3.257-1.718-8.69 1.454-11.182a7.543 7.543 0 0 0 2.885-4.41c6.46 0 7.6 5.7 10.64 5.7v-3.04Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M27.59 21.613a8.74 8.74 0 0 0-8.74-8.74c-4.828 0-9.12 3.913-9.12 8.74v7.36c0 2.166.79 4.258 2.221 5.883a.38.38 0 0 0 .66-.312c-.526-3.257-1.718-8.69 1.454-11.182a7.543 7.543 0 0 0 2.885-4.41c6.46 0 7.6 5.7 10.64 5.7v-3.04Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M68.693 24.273v-1.9a7.6 7.6 0 0 0-15.2 0v1.9a1.52 1.52 0 1 0 0 3.04c.032 0 .061-.008.093-.01a7.59 7.59 0 0 0 15.014 0c.031 0 .06.01.093.01a1.52 1.52 0 1 0 0-3.04Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M61.093 17.051a7.902 7.902 0 0 1 7.6 5.754v-.432a7.6 7.6 0 0 0-15.2 0v.432a7.902 7.902 0 0 1 7.6-5.754Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M68.693 24.273v-1.9a7.6 7.6 0 0 0-15.2 0v1.9a1.52 1.52 0 1 0 0 3.04c.032 0 .061-.008.093-.01a7.59 7.59 0 0 0 15.014 0c.031 0 .06.01.093.01a1.52 1.52 0 1 0 0-3.04Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M55.773 27.503a.95.95 0 1 0 1.9 0 .95.95 0 0 0-1.9 0ZM64.514 27.503a.95.95 0 1 0 1.899 0 .95.95 0 0 0-1.9 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M58.807 29.433a3.316 3.316 0 0 0 4.572 0M65.273 25.033a1.238 1.238 0 0 0-2.287 0M59.186 25.033a1.238 1.238 0 0 0-2.286 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M69.543 16.674a5.06 5.06 0 0 0-5.03-2.661l-1.384-.49a9.012 9.012 0 0 0-7.582.735l-.08.048a8.92 8.92 0 0 0-3.964 4.88 18.625 18.625 0 0 0-.786 3.107c-.376 2.8.53 8.497 6.465 10.435l.187.061a7.605 7.605 0 0 1-3.78-5.486c-.032 0-.062.01-.094.01a1.52 1.52 0 1 1 0-3.04h.129a2.021 2.021 0 0 0 1.617-.81 2.021 2.021 0 0 1 1.418-.8l1.273-.125a7.823 7.823 0 0 0 5.44-3.586 7.581 7.581 0 0 0 5.32 5.32 1.522 1.522 0 0 1 1.404 2.102 1.52 1.52 0 0 1-1.404.938c-.032 0-.062-.007-.093-.01a7.612 7.612 0 0 1-4.194 5.71h.107a5.699 5.699 0 0 1 1.14 3.42 11.48 11.48 0 0 1-1.12 4.992.7.7 0 0 0 .84.97 8.473 8.473 0 0 0 5.981-8.098V23.962c0-2.54-.621-5.043-1.81-7.288Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M69.543 16.674a5.06 5.06 0 0 0-5.03-2.661l-1.384-.49a9.012 9.012 0 0 0-7.582.735l-.08.048a8.92 8.92 0 0 0-3.964 4.88 18.625 18.625 0 0 0-.786 3.107c-.376 2.8.53 8.497 6.465 10.435l.187.061a7.605 7.605 0 0 1-3.78-5.486c-.032 0-.062.01-.094.01a1.52 1.52 0 1 1 0-3.04h.129a2.021 2.021 0 0 0 1.617-.81 2.021 2.021 0 0 1 1.418-.8l1.273-.125a7.823 7.823 0 0 0 5.44-3.586 7.581 7.581 0 0 0 5.32 5.32 1.522 1.522 0 0 1 1.404 2.102 1.52 1.52 0 0 1-1.404.938c-.032 0-.062-.007-.093-.01a7.612 7.612 0 0 1-4.194 5.71h.107a5.699 5.699 0 0 1 1.14 3.42 11.48 11.48 0 0 1-1.12 4.992.7.7 0 0 0 .84.97 8.473 8.473 0 0 0 5.981-8.098V23.962c0-2.54-.621-5.043-1.81-7.288Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M47.413 25.033v-1.9a7.6 7.6 0 0 0-15.2 0v1.9a1.52 1.52 0 0 0 0 3.04c.032 0 .062-.008.093-.01a7.59 7.59 0 0 0 15.014 0c.032 0 .061.01.093.01a1.52 1.52 0 1 0 0-3.04Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M47.413 25.033v-1.9a7.6 7.6 0 0 0-15.2 0v1.9a1.52 1.52 0 0 0 0 3.04c.032 0 .062-.008.093-.01a7.59 7.59 0 0 0 15.014 0c.032 0 .061.01.093.01a1.52 1.52 0 1 0 0-3.04Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M34.493 28.263a.95.95 0 1 0 1.901 0 .95.95 0 0 0-1.901 0ZM43.233 28.263a.95.95 0 1 0 1.9 0 .95.95 0 0 0-1.9 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M37.527 30.193a3.316 3.316 0 0 0 4.573 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.728 17.675c.163-.457.267-.934.307-1.417a.38.38 0 0 0-.518-.384c-.32.125-.674.139-1.003.039a4.635 4.635 0 0 1-.83-.325 8.32 8.32 0 0 0-5.55-1.548 8.52 8.52 0 0 0-7.68 8.569v2.8l.42.21a.762.762 0 0 0 1.1-.68v-.29A6.83 6.83 0 0 1 36.29 18.8a4.028 4.028 0 0 0 3.524 1.674c.593 0 1.181-.104 1.739-.308a2.109 2.109 0 0 0 1.87 1.068 2.15 2.15 0 0 0 1.735-.84 6.8 6.8 0 0 1 1.496 4.26v.29a.762.762 0 0 0 1.1.68l.42-.21v-3.04a8.32 8.32 0 0 0-1.446-4.699Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M46.728 17.675c.163-.457.267-.934.307-1.417a.38.38 0 0 0-.518-.384c-.32.125-.674.139-1.003.039a4.635 4.635 0 0 1-.83-.325 8.32 8.32 0 0 0-5.55-1.548 8.52 8.52 0 0 0-7.68 8.569v2.8l.42.21a.762.762 0 0 0 1.1-.68v-.29A6.83 6.83 0 0 1 36.29 18.8a4.028 4.028 0 0 0 3.524 1.674c.593 0 1.181-.104 1.739-.308a2.109 2.109 0 0 0 1.87 1.068 2.15 2.15 0 0 0 1.735-.84 6.8 6.8 0 0 1 1.496 4.26v.29a.762.762 0 0 0 1.1.68l.42-.21v-3.04a8.32 8.32 0 0 0-1.446-4.699ZM39.054 24.653h1.52", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M45.134 27.313h-3.04a1.52 1.52 0 0 1-1.52-1.52v-1.52a.38.38 0 0 1 .38-.38h4.56a.38.38 0 0 1 .38.38v2.28a.76.76 0 0 1-.76.76ZM37.533 27.313h-3.04a.76.76 0 0 1-.76-.76v-2.28a.38.38 0 0 1 .38-.38h4.56a.38.38 0 0 1 .38.38v1.52a1.52 1.52 0 0 1-1.52 1.52Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M37.533 27.313h-3.04a.76.76 0 0 1-.76-.76v-2.28a.38.38 0 0 1 .38-.38h4.56a.38.38 0 0 1 .38.38v1.52a1.52 1.52 0 0 1-1.52 1.52ZM42.094 27.313h3.04a.76.76 0 0 0 .76-.76v-2.28a.38.38 0 0 0-.38-.38h-4.56a.382.382 0 0 0-.38.38v1.52a1.52 1.52 0 0 0 1.52 1.52Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.38 25.793a1.238 1.238 0 0 0-2.286 0M37.533 25.793a1.239 1.239 0 0 0-2.286 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var coworkerThreeQuarter = {
  render: render$1g
};
var render$1f = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M72 41.346a32 32 0 1 0-61.149 13.2H69.15A31.875 31.875 0 0 0 72 41.346Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M8.8 54.546h62.4M5.2 54.546h2M72.8 54.546h2", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.247 50.788h4.056v-9.129a10.651 10.651 0 1 0-21.3 0v9.129h4.058v5.071h3.309a3.68 3.68 0 0 0 3.287-2.029 3.662 3.662 0 0 0 3.28 2.03h3.312l-.002-5.072Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M46.247 50.788h4.056v-9.129a10.651 10.651 0 1 0-21.3 0v9.129h4.058v5.071h3.309a3.68 3.68 0 0 0 3.287-2.029 3.662 3.662 0 0 0 3.28 2.03h3.312l-.002-5.072Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.51 52.56a1.775 1.775 0 1 0 3.55 0v-1.772h-3.55v1.772ZM46.247 52.56a1.775 1.775 0 1 0 3.55 0v-1.772h-3.55v1.772ZM39.654 31.009l-3.217 3.675 3.217 9.004 3.215-9.004-3.215-3.675Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m39.654 43.688 5.578-6.593-1.014-2.029h2.029l-.604-2.212a10.578 10.578 0 0 0-1.772-.974l-4.217 11.808Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m39.654 31.009-1.737 7.816 1.737 4.863 1.737-4.863-1.737-7.816Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M39.654 43.688 35.44 31.88c-.62.267-1.214.594-1.773.974l-.603 2.212h2.028l-1.014 2.03 5.576 6.592Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M43.87 31.88a10.612 10.612 0 0 0-4.216-.871l3.215 3.675 1.002-2.804Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M39.654 31.009c-1.45 0-2.884.296-4.214.871l1 2.8 3.214-3.671Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M39.654 43.688V53.83M33.061 39.123v11.665M46.247 39.123v11.665", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.754 17.316a7.1 7.1 0 1 0-10.65 6.142 2.034 2.034 0 0 1 1.014 1.76v.72a1.014 1.014 0 0 0 1.014 1.014h3.04a1.015 1.015 0 0 0 1.014-1.015v-.72a2.03 2.03 0 0 1 1.014-1.76 7.086 7.086 0 0 0 3.554-6.141Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M46.754 17.316a7.1 7.1 0 1 0-10.65 6.142 2.034 2.034 0 0 1 1.014 1.76v.72a1.014 1.014 0 0 0 1.014 1.014h3.04a1.015 1.015 0 0 0 1.014-1.015v-.72a2.03 2.03 0 0 1 1.014-1.76 7.086 7.086 0 0 0 3.554-6.141Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M41.175 26.952h-3.04v.507a1.52 1.52 0 1 0 3.04 0v-.507ZM37.92 26.952h3.471a.8.8 0 0 0 .8-.8v-1.229h-5.07v1.229a.8.8 0 0 0 .8.8Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M39.654 8.187V6.666M46.109 10.86l1.075-1.075M48.782 17.316h1.521M33.199 10.86l-1.076-1.075M30.525 17.316h-1.522", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M12.774 48.76h52.237v2.535H12.774V48.76Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M12.267 67.27c0 .471 2.939.923 8.17 1.256 5.231.333 12.326.52 19.724.52s14.492-.188 19.723-.52c5.231-.333 8.17-.785 8.17-1.256 0-.47-2.939-.922-8.17-1.255-5.23-.333-12.325-.52-19.723-.52s-14.493.187-19.724.52-8.17.784-8.17 1.255Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M61.168 66.51h-44.55a.8.8 0 0 1-.8-.8V51.295h46.15V65.71a.8.8 0 0 1-.8.8Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M61.168 66.51h-44.55a.8.8 0 0 1-.8-.8V51.295h46.15V65.71a.8.8 0 0 1-.8.8Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M53.132 39.63h11.08a.8.8 0 0 1 .8.8v1.44a.8.8 0 0 1-.8.8h-11.88v-2.24a.8.8 0 0 1 .8-.8Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M53.132 39.63h11.08a.8.8 0 0 1 .8.8v1.44a.8.8 0 0 1-.8.8h-11.88v-2.24a.8.8 0 0 1 .8-.8Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M13.789 45.716h12.678v3.043H13.789v-3.043Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M11.253 42.674H23.93v3.043H11.253v-3.043Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M10.746 39.63h12.678v3.044H10.746V39.63Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M10.746 39.63h12.678v3.044H10.746V39.63Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M61.675 48.76H49.797v-3.04h11.878a.8.8 0 0 1 .8.8v1.44a.8.8 0 0 1-.8.8ZM60.954 45.716H49.075a.8.8 0 0 1-.8-.8v-1.44a.8.8 0 0 1 .8-.8h11.879v3.04Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var creativeIdeaDesk = {
  render: render$1f
};
var render$1e = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M2.28 42.028a32 32 0 1 0 64.001 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M60.66 5.99a16.27 16.27 0 0 0-8.42 29.666 12.24 12.24 0 0 1-3.542 6.213.546.546 0 0 0 .413.938c5.36-.32 8.506-2.087 10.616-4.381a16.273 16.273 0 1 0 .936-32.435h-.003Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M60.66 5.99a16.27 16.27 0 0 0-8.42 29.666 12.24 12.24 0 0 1-3.542 6.213.546.546 0 0 0 .413.938c5.36-.32 8.506-2.087 10.616-4.381a16.273 16.273 0 1 0 .936-32.435h-.003Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M61.427 27.11a1.975 1.975 0 0 1-1.973-1.973v-2.192a1.975 1.975 0 0 1 1.973-1.974 3.509 3.509 0 1 0-3.507-3.508 1.974 1.974 0 0 1-3.946 0 7.454 7.454 0 1 1 9.426 7.19v.485a1.975 1.975 0 0 1-1.973 1.972ZM58.906 31.167a2.521 2.521 0 1 0 5.042 0 2.521 2.521 0 0 0-5.042 0Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m48.214 37.355-5.624 1.87 1.237 5.373a1.66 1.66 0 0 1-1.63 2.037c-4.22-.035-13.44-.124-14.794-.255a15.411 15.411 0 0 0-16.9 15.34l.11 7.84h28.06l-.111-7.84-.002-6.46a1.6 1.6 0 0 1 1.6-1.6h4.734a5.78 5.78 0 0 0 5.607-7.183l-2.287-9.122Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m48.214 37.355-5.624 1.87 1.237 5.373a1.66 1.66 0 0 1-1.63 2.037c-4.22-.035-13.44-.124-14.794-.255a15.411 15.411 0 0 0-16.9 15.34l.11 7.84h28.06l-.111-7.84-.002-6.46a1.6 1.6 0 0 1 1.6-1.6h4.734a5.78 5.78 0 0 0 5.607-7.183l-2.287-9.122Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m50.497 46.475-2.283-9.12-5.624 1.87 1.238 5.374a1.66 1.66 0 0 1-1.63 2.036c-2.427-.02-7.434-.057-10.72-.111l-5.41 15.734-6.46-14.588a15.399 15.399 0 0 0-9.106 14.05l.112 7.84h28.059l-.111-7.84-.002-6.46a1.6 1.6 0 0 1 1.6-1.6h4.734a5.78 5.78 0 0 0 5.603-7.185Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m38.673 69.558-.111-7.84-.002-6.457a1.6 1.6 0 0 1 1.6-1.6h4.734a5.78 5.78 0 0 0 5.607-7.184l-2.283-9.12-5.624 1.87 1.238 5.374a1.66 1.66 0 0 1-1.63 2.036c-2.427-.02-7.434-.058-10.72-.111l-5.413 15.731-6.462-14.587a15.399 15.399 0 0 0-9.105 14.05l.112 7.84", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m38.673 69.558-.111-7.84-.002-6.457a1.6 1.6 0 0 1 1.6-1.6h4.734a5.78 5.78 0 0 0 5.607-7.184l-2.283-9.12-5.624 1.87 1.237 5.374a1.66 1.66 0 0 1-1.63 2.036c-4.22-.035-13.44-.123-14.794-.255A15.411 15.411 0 0 0 10.502 61.72l.112 7.84", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40.432 31.855a1.003 1.003 0 1 1 1.902-.64l.57 1.946a.743.743 0 0 0 .953.497 2.96 2.96 0 0 1 3.752 1.863l.605 1.834-5.624 1.87-2.158-7.37ZM25.913 46.712v5.928l-3.92 1.955-.791.4a.984.984 0 0 1-1.417-.73l-.607-3.959a4.45 4.45 0 0 1 2.08-4.553c.16-.096.333-.171.512-.224.57-.143 1.161.96 1.766.89l2.377.293ZM32.65 50.314l-.605 3.948a.984.984 0 0 1-1.416.73l-.792-.4-3.924-1.952v-5.928l2.383-.296c.604.07 1.2-1.032 1.766-.89.195.059.382.143.555.25a4.467 4.467 0 0 1 2.032 4.538Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m16.54 69.574-.11-9.422", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m29.469 48.918-3.557 3.721-3.555-3.72v-5.335h7.112v5.334Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m29.469 48.918-3.557 3.721-3.555-3.72v-5.335h7.112v5.334Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m36.685 33.314.222-2.463a9.892 9.892 0 0 0-19.703-1.775l-.222 2.463a1.978 1.978 0 1 0-.355 3.941h.122a9.878 9.878 0 0 0 19.461 1.753c.041.006.08.02.12.022a1.98 1.98 0 0 0 2.065-2.56 1.978 1.978 0 0 0-1.71-1.38v-.001Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m36.685 33.314.222-2.463a9.892 9.892 0 0 0-19.703-1.775l-.222 2.463a1.978 1.978 0 1 0-.355 3.941h.122a9.878 9.878 0 0 0 19.461 1.753c.041.006.08.02.12.022a1.98 1.98 0 0 0 2.065-2.56 1.978 1.978 0 0 0-1.71-1.38v-.001Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M23.267 38.848a4.32 4.32 0 0 0 5.928.534M32.16 33.9a1.612 1.612 0 0 0-2.96-.268M24.273 33.189a1.61 1.61 0 0 0-2.96-.267", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m36.978 25.76-.254-.807a7.507 7.507 0 0 0-.826-1.833 7.033 7.033 0 0 0-7.63-3.1.967.967 0 0 1-.631-.056 7.032 7.032 0 0 0-8.06 1.687 7.526 7.526 0 0 0-1.14 1.65l-.393.749A43.616 43.616 0 0 0 13.2 40.455l-.047.521a5.12 5.12 0 0 0 2.44 4.826 5.232 5.232 0 0 0 2.28.715l.932.08a.533.533 0 0 0 .448-.88c-.918-1.055-1.28-3.291-1.133-4.683a45.199 45.199 0 0 1 3.787-13.85l.18-.262a2.69 2.69 0 0 1 4.018-.48l.62.56a.99.99 0 0 0 1.183.106l.71-.44a2.688 2.688 0 0 1 3.868 1.191l.13.29a45.188 45.188 0 0 1 1.253 14.3c-.101 1.397-.86 3.534-1.953 4.41a.532.532 0 0 0 .286.945l.93.08a5.217 5.217 0 0 0 2.372-.296 5.116 5.116 0 0 0 3.262-4.312l.047-.52a43.629 43.629 0 0 0-1.835-16.996Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m36.978 25.76-.254-.807a7.507 7.507 0 0 0-.826-1.833 7.033 7.033 0 0 0-7.63-3.1.967.967 0 0 1-.631-.056 7.032 7.032 0 0 0-8.06 1.687 7.526 7.526 0 0 0-1.14 1.65l-.393.749A43.616 43.616 0 0 0 13.2 40.455l-.047.521a5.12 5.12 0 0 0 2.44 4.826 5.232 5.232 0 0 0 2.28.715l.932.08a.533.533 0 0 0 .448-.88c-.918-1.055-1.28-3.291-1.133-4.683a45.199 45.199 0 0 1 3.787-13.85l.18-.262a2.69 2.69 0 0 1 4.018-.48l.62.56a.99.99 0 0 0 1.183.106l.71-.44a2.688 2.688 0 0 1 3.868 1.191l.13.29a45.188 45.188 0 0 1 1.253 14.3c-.101 1.397-.86 3.534-1.953 4.41a.532.532 0 0 0 .286.945l.93.08a5.217 5.217 0 0 0 2.372-.296 5.116 5.116 0 0 0 3.262-4.312l.047-.52a43.629 43.629 0 0 0-1.835-16.996ZM26.055 61.964v7.606", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M30.145 60.04h6.388v2.49h-6.388v-2.49Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var customerDoubt = {
  render: render$1e
};
var render$1d = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 42.547a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "opacity": ".15", "d": "M29.405 64.962c0 .18.291.36.858.528.567.167 1.397.32 2.444.447 1.047.129 2.29.23 3.658.3 1.367.069 2.834.105 4.314.105s2.947-.036 4.315-.105a52.82 52.82 0 0 0 3.657-.3c1.047-.128 1.878-.28 2.444-.447.567-.168.859-.347.859-.528 0-.182-.292-.361-.859-.529-.566-.167-1.397-.32-2.444-.447a52.759 52.759 0 0 0-3.657-.3 86.065 86.065 0 0 0-4.315-.105c-1.48 0-2.947.036-4.314.106-1.368.069-2.611.17-3.658.299-1.047.128-1.877.28-2.444.447-.567.168-.858.347-.858.528Z", "fill": "#260347" } }), _c("path", { attrs: { "d": "M63.2 25.893a3.663 3.663 0 0 0-3.661-3.663H21.82a3.662 3.662 0 0 0-3.66 3.663v25H63.2v-25ZM46.138 61.812H35.22l.683-5.46h9.554l.682 5.46Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M46.138 61.812H35.22l.683-5.46h9.554l.682 5.46Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M48.497 64.542H32.86a.845.845 0 0 1-.786-1.181 2.73 2.73 0 0 1 2.462-1.549H46.82a2.733 2.733 0 0 1 2.459 1.548.845.845 0 0 1-.783 1.182ZM59.538 56.352A3.66 3.66 0 0 0 63.2 52.69v-1.797H18.16v1.797a3.662 3.662 0 0 0 3.663 3.662h37.715Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M63.2 25.893a3.663 3.663 0 0 0-3.661-3.663H21.82a3.662 3.662 0 0 0-3.66 3.663v25H63.2v-25Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M39.792 53.622a.887.887 0 1 0 1.773 0 .887.887 0 0 0-1.773 0Z", "fill": "#260347" } }), _c("path", { attrs: { "d": "M41.25 30.71a12.666 12.666 0 0 1 12.545 12.662v7.52h-25.09v-7.52A12.667 12.667 0 0 1 41.25 30.71Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m33.614 50.893-.04-8.953M48.886 50.893l.04-8.953M41.25 30.71a12.666 12.666 0 0 1 12.545 12.662v7.52h-25.09v-7.52A12.667 12.667 0 0 1 41.25 30.71Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.017 37.103a.355.355 0 0 0 .498-.373l-.626-4.382a3.778 3.778 0 0 0-1.716-2.534h-5.848a3.777 3.777 0 0 0-1.715 2.534l-.626 4.382a.355.355 0 0 0 .498.373l4.767-2.167 4.768 2.167Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M38.417 28.598v3.97a.787.787 0 0 0 .35.654l2.48 1.637 2.48-1.637a.788.788 0 0 0 .35-.655v-3.969h-5.66Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M38.417 28.598v3.97a.787.787 0 0 0 .35.654l2.48 1.637 2.48-1.637a.788.788 0 0 0 .35-.655v-3.969h-5.66Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M49.324 20.14v-2.018a8.074 8.074 0 0 0-16.149 0v2.018a1.615 1.615 0 0 0 0 3.23c.034 0 .066-.009.1-.01a8.064 8.064 0 0 0 15.95 0c.033 0 .065.01.099.01a1.615 1.615 0 1 0 0-3.23Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M35.598 23.571a1.01 1.01 0 1 0 2.018 0 1.01 1.01 0 0 0-2.018 0ZM44.883 23.571a1.01 1.01 0 1 0 2.02 0 1.01 1.01 0 0 0-2.02 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M39.634 26.031a2.599 2.599 0 0 0 3.244 0M45.69 20.947a1.316 1.316 0 0 0-2.428 0M39.224 20.947a1.315 1.315 0 0 0-2.429 0", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M48.747 12.552a.387.387 0 0 1-.034-.351c.137-.366.207-.754.207-1.145a3.331 3.331 0 0 0-1.235-2.566.407.407 0 0 0-.524.03c-.29.245-.61.449-.953.608a3.526 3.526 0 0 0-.281-1.39.4.4 0 0 0-.601-.19 2.571 2.571 0 0 1-1.654.48 32.754 32.754 0 0 0-4.845-.4c-2.36 0-3.981 1.452-3.568 2.84a.4.4 0 0 1-.11.407 8.845 8.845 0 0 0-2.78 6.442v2.419a.807.807 0 1 0 1.614 0 7.253 7.253 0 0 1 3.093-5.946.81.81 0 0 1 1.02.075 2.56 2.56 0 0 0 1.741.623c.394.002.784-.078 1.145-.235a.388.388 0 0 1 .507.177 3.53 3.53 0 0 0 3.193 1.672 4.123 4.123 0 0 0 2.042-.52.411.411 0 0 1 .55.104 7.211 7.211 0 0 1 1.243 4.05.807.807 0 1 0 1.614 0v-2.422a8.839 8.839 0 0 0-1.384-4.762Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M48.747 12.552a.387.387 0 0 1-.034-.351c.137-.366.207-.754.207-1.145a3.331 3.331 0 0 0-1.235-2.566.407.407 0 0 0-.524.03c-.29.245-.61.449-.953.608a3.526 3.526 0 0 0-.281-1.39.4.4 0 0 0-.601-.19 2.571 2.571 0 0 1-1.654.48 32.754 32.754 0 0 0-4.845-.4c-2.36 0-3.981 1.452-3.568 2.84a.4.4 0 0 1-.11.407 8.845 8.845 0 0 0-2.78 6.442v2.419a.807.807 0 1 0 1.614 0 7.253 7.253 0 0 1 3.093-5.946.81.81 0 0 1 1.02.075 2.56 2.56 0 0 0 1.741.623c.394.002.784-.078 1.145-.235a.388.388 0 0 1 .507.177 3.53 3.53 0 0 0 3.193 1.672 4.123 4.123 0 0 0 2.042-.52.411.411 0 0 1 .55.104 7.211 7.211 0 0 1 1.243 4.05.807.807 0 1 0 1.614 0v-2.422a8.839 8.839 0 0 0-1.384-4.762Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.207 9.128c-1.19.751-3.746.515-3.746.515", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M33.56 23.26a.81.81 0 0 1-.809.81h-1.214a.405.405 0 0 1-.405-.405V18a.404.404 0 0 1 .405-.405h1.214a.81.81 0 0 1 .809.81v4.855Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.514 23.26h1.618v-4.856h-1.618a.807.807 0 0 0-.81.809v3.238a.81.81 0 0 0 .81.81Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M49.749 24.07h1.21a.405.405 0 0 0 .406-.405V18a.404.404 0 0 0-.405-.405h-1.211a.81.81 0 0 0-.81.81v4.856a.81.81 0 0 0 .81.809Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M53.795 22.45a.81.81 0 0 1-.809.81h-1.619v-4.856h1.62a.81.81 0 0 1 .808.809v3.238Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.177 18.404a10.927 10.927 0 0 0-21.855 0V16.38a10.927 10.927 0 1 1 21.855 0v2.024Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M37.607 28.925H35.99a.81.81 0 0 1 0-1.618h1.618a.81.81 0 0 1 0 1.619Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M35.179 28.117h-1.62a3.238 3.238 0 0 1-3.24-3.237v-1.62", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M38.4 42.475h5.7v6.542h-5.7v-6.542Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40 44.075h2.5v3.342H40v-3.342Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m38.258 36.336 2.992 6.14 3.08-6.14", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var customerServerImac = {
  render: render$1d
};
var render$1c = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M69.159 52.842a32 32 0 1 0-58.32 0h58.32Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M8.8 52.842h62.4M5.2 52.842h2M72.8 52.842h2M70.265 52.842H9.887", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.76 62.638h6.011M48.254 62.638h1.502M45.749 62.638h.5M26.691 59.697h6.012M23.185 59.697h1.503M20.68 59.697h.5M36.089 68.938H42.1M32.582 68.938h1.503M30.077 68.938h.5", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round" } }), _c("path", { attrs: { "d": "M28.365 39.605a3.123 3.123 0 1 1-.816-6.193l.086-.011a3.123 3.123 0 1 1 .816 6.193l-.086.01ZM27.38 30.543a2.283 2.283 0 0 1-2.529-2l-.202-1.714a5.722 5.722 0 0 1 3.156-5.77 4.543 4.543 0 0 0-2.56-8.579l-.118.015a4.568 4.568 0 0 0-3.847 5.025 2.278 2.278 0 0 1-3.68 2.058 2.267 2.267 0 0 1-.851-1.52A9.055 9.055 0 0 1 24.488 7.99l.24-.032a9.097 9.097 0 0 1 5.102 17.186 1.157 1.157 0 0 0-.654 1.155l.202 1.715a2.296 2.296 0 0 1-1.938 2.521l-.06.008Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M31.49 66.06c0 .253.385.504 1.134.737.749.234 1.847.447 3.23.626 1.385.179 3.028.32 4.836.418 1.809.096 3.747.146 5.704.146 1.957 0 3.895-.05 5.704-.146a66.054 66.054 0 0 0 4.835-.418c1.384-.18 2.482-.392 3.231-.626.75-.233 1.135-.484 1.135-.737s-.386-.504-1.135-.737c-.749-.234-1.847-.447-3.23-.626a66.11 66.11 0 0 0-4.836-.418 107.852 107.852 0 0 0-5.704-.146c-1.957 0-3.895.05-5.704.147a66.11 66.11 0 0 0-4.835.417c-1.384.18-2.482.392-3.231.626-.75.233-1.135.484-1.135.737Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m56.098 50.232 1.858-.273a2.413 2.413 0 0 1 2.748 1.995l.027.17c.04.261.037.528-.012.788l-2.106 9.296a3.576 3.576 0 0 1 1.045 2.738h-5.112l1.552-14.714ZM36.692 50.232l-1.86-.273a2.413 2.413 0 0 0-2.747 1.995l-.027.17c-.04.261-.037.528.011.788l2.107 9.296a3.578 3.578 0 0 0-1.045 2.738h5.109l-1.548-14.714Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.395 38.574c-9.552 0-15.125 13.056-6.045 23.253 1.08 1.214 0 3.12 0 3.12h11.932a1.93 1.93 0 0 1 0-2.944c9.302-10.13 3.718-23.43-5.887-23.43Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M40.35 64.945h11.932a44.728 44.728 0 0 1 2.041-4.807C53.471 51 50.243 44.2 46.395 44.2c-3.85 0-7.077 6.8-7.93 15.938a40.943 40.943 0 0 1 1.885 4.806Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M46.395 38.574c-9.552 0-15.125 13.056-6.045 23.253 1.08 1.214 0 3.12 0 3.12h11.932a1.93 1.93 0 0 1 0-2.944c9.302-10.13 3.718-23.43-5.887-23.43Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.264 45.711a2.131 2.131 0 1 0 4.262 0 2.131 2.131 0 0 0-4.262 0Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M35.745 50.916c-.004 3.47 1.544 8.468 1.544 8.468a2.374 2.374 0 0 1-.628 1.954 2.337 2.337 0 0 0-.646 1.646 1.834 1.834 0 0 0 1.67 1.962h3.74a1.732 1.732 0 0 0 1.578-1.854 2.56 2.56 0 0 0-.72-1.818c-.143-.14-2.8-4.968-2.25-9.285", "fill": "#fff" } }), _c("path", { attrs: { "d": "M35.745 50.916c-.004 3.47 1.544 8.468 1.544 8.468a2.374 2.374 0 0 1-.628 1.954 2.337 2.337 0 0 0-.646 1.646 1.834 1.834 0 0 0 1.67 1.962h3.74a1.732 1.732 0 0 0 1.578-1.854 2.56 2.56 0 0 0-.72-1.818c-.143-.14-2.8-4.968-2.25-9.285", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M57.04 50.916c0 3.47-1.544 8.468-1.544 8.468a2.377 2.377 0 0 0 .628 1.954c.423.443.655 1.034.646 1.646a1.833 1.833 0 0 1-1.669 1.962H51.36a1.732 1.732 0 0 1-1.577-1.854 2.56 2.56 0 0 1 .72-1.818c.142-.14 2.8-4.968 2.25-9.285", "fill": "#fff" } }), _c("path", { attrs: { "d": "M57.04 50.916c0 3.47-1.544 8.468-1.544 8.468a2.377 2.377 0 0 0 .628 1.954c.423.443.655 1.034.646 1.646a1.833 1.833 0 0 1-1.669 1.962H51.36a1.732 1.732 0 0 1-1.577-1.854 2.56 2.56 0 0 1 .72-1.818c.142-.14 2.8-4.968 2.25-9.285", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.64 22.514a3.695 3.695 0 0 1-7.364.617c-.126-1.506 1.613-4.986 2.526-6.693a.734.734 0 0 1 1.233-.103c1.188 1.532 3.482 4.674 3.605 6.178ZM54.221 24.966a3.695 3.695 0 0 0 5.607 4.816c.984-1.142 1.612-4.982 1.874-6.902a.736.736 0 0 0-.94-.807c-1.857.546-5.556 1.748-6.54 2.893Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.127 43.22c-7.03-2.275-9.214-23.694 6.068-18.748 15.283 4.946.963 21.024-6.068 18.749Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M43.074 29.76a1.458 1.458 0 1 0 2.917 0 1.458 1.458 0 0 0-2.917 0ZM46.627 41.943c-.338 1.04-2.5 1.28-2.5 1.28s-1.616-1.463-1.278-2.503a1.986 1.986 0 1 1 3.779 1.223Z", "fill": "#260347" } }), _c("path", { attrs: { "d": "M52.48 40.24c4.806-4.304 7.484-11.822-1.026-15.31a9.703 9.703 0 0 0 1.026 15.31Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M44.127 43.22c-7.03-2.275-9.214-23.694 6.068-18.748 15.283 4.946.963 21.024-6.068 18.749Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M50.227 32.074a1.458 1.458 0 1 0 2.917 0 1.458 1.458 0 0 0-2.916 0Z", "fill": "#260347" } })]);
};
var curiousDog = {
  render: render$1c
};
var render$1b = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8.306 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M38.749 58.727a.845.845 0 0 1-.68 1.018L24.145 62.26a.886.886 0 0 1-1.024-.711L15.89 21.512a.885.885 0 0 1 .71-1.025l14.687-2.652a2.091 2.091 0 0 1 1.534.422l.982.856a1.033 1.033 0 0 1 .177 1.313l-.895 1.345a1.184 1.184 0 0 0 .108 1.383l1.135 1.233a1.194 1.194 0 0 1 .112 1.386l-.873 1.325a1.242 1.242 0 0 0 .09 1.405l1.796 2.08a1.588 1.588 0 0 1 .244 1.485l-1.487 3.675a3.337 3.337 0 0 0-.141 1.68l4.68 21.303Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m24.782 38.207 9.253-1.671M25.541 42.413l9.256-1.671M26.3 46.62l9.415-1.7", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m27.468 57.024 6.454-1.166", "stroke": "#B096CB", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M56.139 63.086a.871.871 0 0 1-1 .736l-15.166-2.4a1.08 1.08 0 0 1-.88-1.02l-.15-17.425a1.85 1.85 0 0 1 .72-1.378l1.618-1.102a1.084 1.084 0 0 0 .364-1.297l-1.25-2.72a1.419 1.419 0 0 1 .235-1.44l1.36-1.45a1.532 1.532 0 0 0 .286-1.465l-.941-2.43a1.175 1.175 0 0 1 .408-1.323l.824-.567a1.397 1.397 0 0 0 .526-1.36l-.54-2.32a.59.59 0 0 1 .677-.766l17.565 1.865a.844.844 0 0 1 .749.966l-5.405 36.896Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m42.492 36.213 13.21 1.936M41.68 39.95l13.454 2.072M38.938 43.606l15.63 2.29M38.986 47.823 54 49.77", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m43.753 57.94 8.394 1.23", "stroke": "#B096CB", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m65.296 47.372 8.049-3.557-.007-.016c-2.49-12.88-5.9-21.933-21.376-24.341a1.661 1.661 0 0 0-.51 3.28c4.647.72 7.626 1.73 9.689 5.378 2.973 5.144-.709 4.24-2.112 2.549l-3.143-3.497a1.663 1.663 0 0 0-2.738.362 1.662 1.662 0 0 0 .242 1.83c4.666 7.486 4.652 9.238 7.559 11.28 2.171 1.52 2.726 3.066 4.347 6.732Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m65.296 47.372 8.049-3.557-.007-.016c-2.49-12.88-5.9-21.933-21.376-24.341a1.661 1.661 0 0 0-.51 3.28c4.647.72 7.626 1.73 9.689 5.378 2.973 5.144-.709 4.24-2.112 2.549l-3.143-3.497a1.663 1.663 0 0 0-2.738.362 1.662 1.662 0 0 0 .242 1.83c4.666 7.486 4.652 9.238 7.559 11.28 2.171 1.52 2.726 3.066 4.347 6.732Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m74.58 43.306-.586-1.323a1.044 1.044 0 0 0-1.376-.533l-8.34 3.688a1.038 1.038 0 0 0-.533 1.376l.584 1.324 10.25-4.532Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m66.266 54.203-2.274-5.075a1.045 1.045 0 0 1 .533-1.378l9.86-4.357a1.041 1.041 0 0 1 1.376.533L78.035 49", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m66.266 54.203-2.274-5.075a1.045 1.045 0 0 1 .533-1.378l9.86-4.357a1.041 1.041 0 0 1 1.376.533L78.035 49", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m54.24 24.526 6.553.698a.844.844 0 0 1 .749.966l-.691 4.72", "fill": "#fff" } }), _c("path", { attrs: { "d": "m54.24 24.526 6.553.698a.844.844 0 0 1 .749.966l-.691 4.72", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m14.08 44.496-8.48-2.34v-.017c.664-13.105 2.776-22.542 17.76-27.09a1.66 1.66 0 0 1 .964 3.177c-4.5 1.366-7.309 2.78-8.842 6.681-2.224 5.509 1.295 4.095 2.448 2.228l2.63-3.903a1.66 1.66 0 0 1 2.78 1.818c-3.58 8.064-3.318 9.796-5.911 12.223-1.935 1.811-2.255 3.367-3.349 7.223Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m14.08 44.496-8.48-2.34v-.017c.664-13.105 2.776-22.542 17.76-27.09a1.66 1.66 0 0 1 .964 3.177c-4.5 1.366-7.309 2.78-8.842 6.681-2.224 5.509 1.295 4.095 2.448 2.228l2.63-3.903a1.66 1.66 0 0 1 2.78 1.818c-3.58 8.064-3.318 9.796-5.911 12.223-1.935 1.811-2.255 3.367-3.349 7.223Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m4.306 41.825.393-1.392a1.045 1.045 0 0 1 1.29-.72l8.773 2.485a1.045 1.045 0 0 1 .72 1.29l-.394 1.392-10.782-3.055Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m14.347 50.57 1.256-4.46a1.046 1.046 0 0 0-.72-1.29L4.51 41.883a1.04 1.04 0 0 0-1.29.72l-1.255 4.461", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m14.347 50.57 1.256-4.46a1.046 1.046 0 0 0-.72-1.29L4.51 41.883a1.04 1.04 0 0 0-1.29.72l-1.255 4.461", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m16.76 26.333-.87-4.821a.885.885 0 0 1 .71-1.025l7.304-1.319", "fill": "#fff" } }), _c("path", { attrs: { "d": "m16.76 26.333-.87-4.821a.885.885 0 0 1 .71-1.025l7.304-1.319M44.74 52.596a1.78 1.78 0 1 0 2.887 1.573l-.038.354a1.424 1.424 0 0 0 2.832.302 1.422 1.422 0 0 0 1.264 1.567l1.062.113M26.48 55.221a1.483 1.483 0 0 1-.48-2.926 1.596 1.596 0 0 1 1.785 1.71M33.474 52.066a1.483 1.483 0 0 1-1.222 1.704", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M27.782 54.005a1.48 1.48 0 0 1 1.223-1.704M30.22 53.604a1.484 1.484 0 0 1 1.22-1.705", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var deniedContract = {
  render: render$1b
};
var render$1a = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M72.4 42.993a31.996 31.996 0 0 0-24.602-31.137 32 32 0 0 0-36.546 44.338h58.297a31.874 31.874 0 0 0 2.851-13.2Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M8.8 56.194h62.4M5.2 56.194h2M72.8 56.194h2", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M64.08 55.97v-7.376a15.13 15.13 0 0 0-20.948-14.08 15.133 15.133 0 0 0-9.315 14.08v7.377H64.08Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M64.08 55.97v-7.376a15.13 15.13 0 0 0-20.948-14.08 15.133 15.133 0 0 0-9.315 14.08v7.377H64.08ZM39.64 55.97v-8.918M58.263 55.97v-8.918", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.443 35.994h-6.985l-1 2a.97.97 0 0 0-.07.681l4.56 17.295 4.56-17.295a.976.976 0 0 0-.07-.681l-.995-2Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m52.442 35.995-3.492 9.5-3.492-9.5v-5.239h6.984v5.239Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m52.442 35.995-3.492 9.5-3.492-9.5v-5.239h6.984v5.239Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M45.459 33.274v2.72l-1 2a.969.969 0 0 0-.07.68l4.56 17.295h-2.328l-4.4-7.876a.969.969 0 0 1-.011-.927l1.137-2.151a.97.97 0 0 0-.226-1.19l-2.983-2.56a.97.97 0 0 1-.286-1.054l1-2.88a6.235 6.235 0 0 1 4.607-4.057ZM52.443 33.274v2.72l1 2c.105.21.13.453.07.68l-4.56 17.295h2.327l4.4-7.876a.972.972 0 0 0 .01-.927l-1.137-2.151a.971.971 0 0 1 .226-1.19l2.984-2.56a.97.97 0 0 0 .286-1.054l-1-2.88a6.232 6.232 0 0 0-4.606-4.057Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M65.246 24.22a3.612 3.612 0 0 0-2.652-3.474 2.71 2.71 0 0 0-1.874-4.673h-.045a11.76 11.76 0 0 0-23.447 0h-.046a2.71 2.71 0 0 0-1.874 4.673 3.606 3.606 0 0 0 .325 7.03 4.526 4.526 0 1 0 8.847.064h9.24a4.525 4.525 0 1 0 8.96.906c-.004-.351-.048-.7-.132-1.04a3.612 3.612 0 0 0 2.698-3.486Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M65.246 24.22a3.612 3.612 0 0 0-2.652-3.474 2.71 2.71 0 0 0-1.874-4.673h-.045a11.76 11.76 0 0 0-23.447 0h-.046a2.71 2.71 0 0 0-1.874 4.673 3.606 3.606 0 0 0 .325 7.03 4.526 4.526 0 1 0 8.847.064h9.24a4.525 4.525 0 1 0 8.96.906c-.004-.351-.048-.7-.132-1.04a3.612 3.612 0 0 0 2.698-3.486Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M58.65 20.567v-2.425c0-.373-.021-.746-.063-1.116a17.047 17.047 0 0 1-3.752.534 13.126 13.126 0 0 1-10.768-5.607 5.575 5.575 0 0 1-4.791 5.503 9.735 9.735 0 0 0-.025.686v2.425a1.94 1.94 0 0 0 0 3.88c.04 0 .08-.01.119-.012a9.688 9.688 0 0 0 19.162 0c.04 0 .08.012.119.012a1.94 1.94 0 1 0 0-3.88Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M54.528 25.902a1.213 1.213 0 1 0 0-2.426 1.213 1.213 0 0 0 0 2.426ZM43.374 25.902a1.213 1.213 0 1 0 0-2.426 1.213 1.213 0 0 0 0 2.426Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M51.868 27.152a4.232 4.232 0 0 1-5.84 0M43.616 21.537a1.58 1.58 0 0 1 2.918 0M51.384 21.537a1.58 1.58 0 0 1 2.917 0", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M25.671 68.391c9 0 16.295-.781 16.295-1.746 0-.964-7.295-1.745-16.295-1.745-9 0-16.295.781-16.295 1.745 0 .965 7.296 1.746 16.295 1.746Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M37.698 45.112H13.643a1.94 1.94 0 0 0-1.94 1.94v17.071a1.94 1.94 0 0 0 1.94 1.94h24.055a1.94 1.94 0 0 0 1.94-1.94v-17.07a1.94 1.94 0 0 0-1.94-1.94Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M38.038 45.112H13.303a1.6 1.6 0 0 0-1.6 1.6v17.751a1.6 1.6 0 0 0 1.6 1.6h24.735a1.6 1.6 0 0 0 1.6-1.6v-17.75a1.6 1.6 0 0 0-1.6-1.6Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.36 53.84h-1.943V51.9a.968.968 0 0 0-.97-.97h-1.551a.97.97 0 0 0-.97.97v1.939h-1.94a.97.97 0 0 0-.97.97v1.551a.97.97 0 0 0 .97.97h1.94v1.94a.97.97 0 0 0 .97.969h1.552a.97.97 0 0 0 .97-.97v-1.937h1.942a.97.97 0 0 0 .97-.97v-1.552a.97.97 0 0 0-.97-.971Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M29.36 53.84h-1.943V51.9a.968.968 0 0 0-.97-.97h-1.551a.97.97 0 0 0-.97.97v1.939h-1.94a.97.97 0 0 0-.97.97v1.551a.97.97 0 0 0 .97.97h1.94v1.94a.97.97 0 0 0 .97.969h1.552a.97.97 0 0 0 .97-.97v-1.937h1.942a.97.97 0 0 0 .97-.97v-1.552a.97.97 0 0 0-.97-.971Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m21.7 45.112 1.247-2.91h5.45l1.246 2.91h2.43c0-.158-.032-.314-.095-.459l-1.745-4.073a1.163 1.163 0 0 0-1.07-.706H22.18a1.164 1.164 0 0 0-1.07.706l-1.745 4.074c-.062.144-.094.3-.094.458h2.43Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M20.434 42.202h10.475", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var doctorFirstAid = {
  render: render$1a
};
var render$19 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M40 72c17.673 0 32-14.327 32-32C72 22.327 57.673 8 40 8 22.327 8 8 22.327 8 40c0 17.673 14.327 32 32 32Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M40.01 67.836c5.364 0 9.712-.652 9.712-1.457s-4.348-1.457-9.712-1.457c-5.363 0-9.712.653-9.712 1.457 0 .805 4.349 1.457 9.712 1.457Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M23.857 57.2a1.04 1.04 0 0 0 1.04 1.04h30.204a1.04 1.04 0 0 0 1.04-1.04V23.35l-8.85-8.852H24.898a1.04 1.04 0 0 0-1.04 1.04L23.857 57.2Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M56.142 23.35h-7.88a.974.974 0 0 1-.971-.972v-7.88l8.852 8.852Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m29.814 39.698 1.321 1.253 3.51-4.235M36.26 40l.633.613a1.065 1.065 0 0 0 1.507-.03l.613-.632a1.062 1.062 0 0 1 1.505-.025l.633.612a1.062 1.062 0 0 0 1.504-.024l.612-.633a1.062 1.062 0 0 1 1.505-.025l.756.686a1.063 1.063 0 0 0 1.504-.025l.614-.632a1.062 1.062 0 0 1 1.504-.025l.805.749M29.814 28.922l1.321 1.253 3.51-4.235M36.26 29.22l.633.613a1.062 1.062 0 0 0 1.507-.025l.613-.633a1.064 1.064 0 0 1 1.505-.025l.633.612a1.064 1.064 0 0 0 1.504-.024l.612-.633a1.064 1.064 0 0 1 1.505-.025l.756.687a1.064 1.064 0 0 0 1.504-.025l.614-.633a1.062 1.062 0 0 1 1.504-.025l.805.749M29.814 49.178l1.321 1.253 3.51-4.236M36.26 48.99l.633.612a1.065 1.065 0 0 0 1.507-.024l.613-.634a1.064 1.064 0 0 1 1.505-.025l.633.613c.422.409.427-.8.836-1.22l1.28.56a1.066 1.066 0 0 1 1.505-.024", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var documentChecklist = {
  render: render$19
};
var render$18 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M38.508 72c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32-17.673 0-32 14.327-32 32 0 17.673 14.327 32 32 32Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M53.6 60.245H23.76a2.014 2.014 0 0 1-2.014-2.015V19.6a2.1 2.1 0 0 1 2.1-2.1H53.51a2.1 2.1 0 0 1 2.1 2.1v38.63a2.014 2.014 0 0 1-2.01 2.015Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M53.6 60.245H23.76a2.014 2.014 0 0 1-2.014-2.015V19.6a2.1 2.1 0 0 1 2.1-2.1H53.51a2.1 2.1 0 0 1 2.1 2.1v38.63a2.014 2.014 0 0 1-2.01 2.015Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.272 20.83H26.085c-.556 0-1.007.45-1.007 1.007v34.07c0 .556.45 1.007 1.007 1.007h25.187c.556 0 1.007-.451 1.007-1.008v-34.07c0-.555-.45-1.006-1.007-1.006Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m52.28 33.191-7.9 8.56a2.776 2.776 0 0 0 .16 3.92c.34.313.752.535 1.2.645l-2.568 2.569.393.393-3.469 3.468a1.112 1.112 0 0 0 1.013 1.875c3.04-.647 4.586-1.58 4.604-2.779l.21-.21.785.786 1.932-1.938a2.776 2.776 0 0 0 3.638-.134l.001-17.155Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M51.272 20.83H26.085c-.556 0-1.007.45-1.007 1.007v34.07c0 .556.45 1.007 1.007 1.007h25.187c.556 0 1.007-.451 1.007-1.008v-34.07c0-.555-.45-1.006-1.007-1.006ZM28.955 29.712h16.962M28.955 34.708h16.962M28.955 40.26h11.823", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M31.08 15.834h15.196a1.008 1.008 0 0 1 1.004 1.007v5.2a1.007 1.007 0 0 1-1.008 1.008h-15.19a1.008 1.008 0 0 1-1.008-1.008v-5.2a1.007 1.007 0 0 1 1.007-1.008Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M31.08 15.834h15.196a1.008 1.008 0 0 1 1.004 1.007v5.2a1.008 1.008 0 0 1-1.008 1.008h-15.19a1.008 1.008 0 0 1-1.008-1.008v-5.2a1.007 1.007 0 0 1 1.007-1.008ZM33.959 20.83h9.438", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M38.956 18.054a2.776 2.776 0 1 0 0-5.552 2.776 2.776 0 0 0 0 5.552Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M38.956 18.054a2.776 2.776 0 1 0 0-5.552 2.776 2.776 0 0 0 0 5.552Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m50.366 39.914 9.724 3.628 4.09-6.56-10.573-2.855-3.241 5.787Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "m65.868 50.983 7.531-7.53c.03-.03.06-.056.093-.08-2.52-2.188-3.142-6.822-7.99-9.353-6.382-3.333-14.275-2.538-21.207 6.12a1.85 1.85 0 0 0 .252 2.634 1.852 1.852 0 0 0 2.628-.306c.46-.568.921-1.098 1.385-1.588.163.174.358.315.575.414 7.254 5.492 8.72 6.19 10.495 6.88 2.744 1.067 3.955 1.582 5.973 3.409a.922.922 0 0 1 .265-.6Zm-4.97-11.722a4.114 4.114 0 0 1-5.161.98l-4.29-1.962c2.503-1.833 5.03-2.597 7.544-2.27 2.14.276 2.636 2.169 1.907 3.252Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M38.5 68.06c6.65 0 12.04-.621 12.04-1.388 0-.767-5.39-1.389-12.04-1.389-6.649 0-12.04.622-12.04 1.389s5.391 1.389 12.04 1.389Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M30.65 46.029a2.467 2.467 0 1 0 4.21 1.745v.492a1.973 1.973 0 0 0 2.74 1.86 1.975 1.975 0 0 0 1.209-1.86 1.974 1.974 0 0 0 1.973 1.974h1.48", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M55.129 40.671a1.855 1.855 0 0 1 1.751 1.95l-.326 6.01a1.853 1.853 0 0 1-3.699-.2l.326-6.01a1.852 1.852 0 0 1 1.948-1.75Z", "fill": "#F5F2F7", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M53.215 40.093a1.852 1.852 0 0 1 .764 2.506l-2.21 4.303a1.852 1.852 0 1 1-3.27-1.742l2.21-4.302a1.853 1.853 0 0 1 2.506-.764Z", "fill": "#F5F2F7", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M73.492 43.372c-2.52-2.187-3.142-6.82-7.99-9.352-6.382-3.333-14.275-2.538-21.207 6.12a1.85 1.85 0 0 0 .252 2.634 1.852 1.852 0 0 0 2.628-.306c.46-.568.921-1.098 1.385-1.588.163.174.358.315.575.414 7.254 5.492 8.72 6.19 10.495 6.88 2.744 1.067 3.955 1.582 5.973 3.409m-4.701-12.32a4.114 4.114 0 0 1-5.165.977l-4.29-1.962c2.503-1.831 5.03-2.596 7.544-2.268 2.14.275 2.636 2.168 1.907 3.25l.004.003Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M59.294 39.629 56.88 36.23l7.52-5.341a1.889 1.889 0 0 1 2.635.446l.225.316a1.89 1.89 0 0 1-.447 2.635l-7.519 5.342Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M59.294 39.629 56.88 36.23l7.52-5.341a1.889 1.889 0 0 1 2.635.446l.225.316a1.89 1.89 0 0 1-.447 2.635l-7.519 5.342Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m57.209 34.294 5.286-3.754a1.36 1.36 0 0 1 1.936.328", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m45.057 45.766-3.713 2.64a.462.462 0 0 0 .281.842c1.557-.064 3.782-.346 3.75-1.433l.754-.536-1.072-1.513Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m46.4 47.654-1.341-1.888a.463.463 0 0 1 .11-.645l1.887-1.341 1.877 2.64-1.893 1.34a.463.463 0 0 1-.64-.106Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m46.4 47.654-1.341-1.888a.463.463 0 0 1 .11-.645l1.887-1.341 1.877 2.64-1.893 1.34a.463.463 0 0 1-.64-.106Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m48.663 46.045-1.34-1.885a.924.924 0 0 1 .218-1.291l9.339-6.638 2.413 3.398-9.339 6.635a.926.926 0 0 1-1.291-.22Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m48.663 46.045-1.34-1.885a.924.924 0 0 1 .218-1.291l9.339-6.638 2.413 3.398-9.339 6.635a.926.926 0 0 1-1.291-.22Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M60.898 39.26a4.114 4.114 0 0 1-5.161.98l-5.064-2.32a1.852 1.852 0 1 0-1.54 3.37c7.253 5.492 8.72 6.19 10.493 6.88", "fill": "#fff" } }), _c("path", { attrs: { "d": "M60.898 39.26a4.114 4.114 0 0 1-5.161.98l-5.064-2.32a1.852 1.852 0 1 0-1.54 3.37c7.253 5.492 8.72 6.19 10.493 6.88", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M60.898 39.26a4.114 4.114 0 0 1-5.161.98l-5.064-2.32a1.852 1.852 0 1 0-1.54 3.37c7.253 5.492 8.72 6.19 10.493 6.88", "fill": "#fff" } }), _c("path", { attrs: { "d": "M60.898 39.26a4.114 4.114 0 0 1-5.161.98l-5.064-2.32a1.852 1.852 0 1 0-1.54 3.37c7.253 5.492 8.72 6.19 10.493 6.88", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var documentSign = {
  render: render$18
};
var render$17 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M9.041 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M55.026 28.794a1.374 1.374 0 0 0-1.238-1.497l-15.04-1.416-1.724-5.212a1.372 1.372 0 0 0-1.735-.873L7.9 28.852a1.373 1.373 0 0 0-.873 1.735l12.506 37.82a1.373 1.373 0 0 0 1.735.873l5.353-1.77 23.177 2.181a1.373 1.373 0 0 0 1.496-1.24l3.731-39.657Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m12.702 21.979 31.59-.35.473 42.578-31.59.35-.473-42.578Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m19.259 64.394 3.843-41.028 30.086 2.818-3.843 41.028-30.086-2.818Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m26.82 27.853 5.47.512M26.436 31.955l12.308 1.154M26.052 36.058l8.205.768M25.667 40.16l9.573.898M25.283 44.264l4.103.384M24.898 48.367l15.044 1.408M24.514 52.469l9.573.897M24.13 56.572l17.779 1.665M23.746 60.674l8.205.77M35.025 28.622l6.838.64M32.12 44.904l6.838.64M34.687 61.7l6.838.64", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m7.645 27.61 28.82-9.082 12.386 39.301-28.82 9.083L7.644 27.61Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m12.813 30.302 5.24-1.652M14.052 34.232l11.79-3.716M15.291 38.162l7.86-2.477M16.53 42.092l9.17-2.89M17.768 46.022l3.93-1.238M19.006 49.953l14.41-4.542M20.245 53.882l9.17-2.89M21.484 57.813l17.03-5.367M22.722 61.743l7.86-2.477M20.674 27.825l6.55-2.064M24.318 43.958l6.55-2.064M33.203 58.44l6.55-2.064", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M14.513 21.274H44.73v41.208H14.513V21.274Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.826 20.775a9.021 9.021 0 1 0 18.042 0 9.021 9.021 0 0 0-18.042 0ZM65.991 32.498a.42.42 0 0 0-.64-.117c-.676.568-2.013 1.78-2.16 2.582a1.985 1.985 0 0 0 1.596 2.309l-.65-.12a1.324 1.324 0 0 0-1.54 1.065L58.795 59.04a1.323 1.323 0 0 0 1.064 1.54l1.301.24a1.324 1.324 0 0 0 1.54-1.065l3.803-20.823a1.323 1.323 0 0 0-1.063-1.54l-.65-.12a1.986 1.986 0 0 0 2.309-1.6c.146-.798-.676-2.404-1.108-3.174Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M61.04 59.626a1.323 1.323 0 0 1-1.54 1.064l-1.3-.24a1.321 1.321 0 0 1-1.064-1.539l3.804-20.823a1.323 1.323 0 0 1 1.54-1.062l1.3.24a1.323 1.323 0 0 1 1.065 1.54l-3.805 20.82Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m58.327 52.406 3.904.713M57.139 58.913a2.645 2.645 0 0 1-2.128-3.079l1.427-7.808", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M65.44 35.55a1.985 1.985 0 0 1-3.904-.714c.197-1.078 2.546-2.897 2.546-2.897s1.556 2.532 1.358 3.61Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M26.671 53.3a2.514 2.514 0 1 0 5.028 0 2.514 2.514 0 0 0-5.028 0ZM29.244 48.851a1.834 1.834 0 0 1-1.832-1.832v-1.668a5.155 5.155 0 0 1 3.434-4.83 4.77 4.77 0 0 0 3.044-5.523 4.76 4.76 0 0 0-9.401 1.04 1.831 1.831 0 1 1-3.663 0 8.41 8.41 0 0 1 8.427-8.413c5.785 0 7.868 4.922 8.222 6.626a8.4 8.4 0 0 1-5.395 9.72 1.486 1.486 0 0 0-1.004 1.38v1.668a1.833 1.833 0 0 1-1.832 1.832Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M68.031 26.48a1.933 1.933 0 0 0 2.734-2.734l-3.19-3.192-2.733 2.734 3.19 3.192Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M67.12 22.832a8.377 8.377 0 1 1-11.847-11.846A8.377 8.377 0 0 1 67.12 22.832Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M55.398 16.909a5.8 5.8 0 1 0 11.598 0 5.8 5.8 0 0 0-11.598 0Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var documentsQuestion = {
  render: render$17
};
var render$16 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M40 72c17.673 0 32-14.327 32-32C72 22.327 57.673 8 40 8 22.327 8 8 22.327 8 40c0 17.673 14.327 32 32 32Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M53.462 59.401c7.845 0 14.204-6.36 14.204-14.204 0-7.845-6.36-14.205-14.204-14.205-7.846 0-14.205 6.36-14.205 14.205S45.617 59.4 53.462 59.4Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M53.462 59.401c7.845 0 14.204-6.36 14.204-14.204 0-7.845-6.36-14.205-14.204-14.205-7.846 0-14.205 6.36-14.205 14.205S45.617 59.4 53.462 59.4Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M47.04 49.264a7.618 7.618 0 0 1 11.81 0M59.27 38.658a1.582 1.582 0 1 1-3.164 0M49.78 38.658a1.581 1.581 0 1 1-3.164 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M61.385 45.925a2.086 2.086 0 1 1-4.174 0c0-1.391 2.087-4.174 2.087-4.174s2.087 2.783 2.087 4.174Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M61.385 45.925a2.086 2.086 0 1 1-4.174 0c0-1.391 2.087-4.174 2.087-4.174s2.087 2.783 2.087 4.174Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M42.41 63.82c0-.662-3.94-1.2-8.8-1.2-4.86 0-8.8.538-8.8 1.2 0 .663 3.94 1.2 8.8 1.2 4.86 0 8.8-.54 8.8-1.2Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M33.61 56.022c11.203 0 20.285-9.082 20.285-20.286 0-11.203-9.082-20.286-20.285-20.286-11.204 0-20.286 9.083-20.286 20.286 0 11.204 9.082 20.286 20.286 20.286Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M33.61 56.022c11.203 0 20.285-9.082 20.285-20.286 0-11.203-9.082-20.286-20.285-20.286-11.204 0-20.286 9.083-20.286 20.286 0 11.204 9.082 20.286 20.286 20.286Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.152 37.514a11.414 11.414 0 0 1-21.086 0M24.18 28.246a2.357 2.357 0 0 1 4.715 0M38.324 28.246a2.358 2.358 0 0 1 4.715 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var emojiHappySadFrown = {
  render: render$16
};
var render$15 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M40 72c17.673 0 32-14.327 32-32C72 22.327 57.673 8 40 8 22.327 8 8 22.327 8 40c0 17.673 14.327 32 32 32Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M42.509 63.82c0-.662-3.94-1.2-8.8-1.2-4.86 0-8.8.538-8.8 1.2 0 .663 3.94 1.2 8.8 1.2 4.86 0 8.8-.54 8.8-1.2Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M53.251 59.402c7.953 0 14.4-6.447 14.4-14.4s-6.447-14.4-14.4-14.4-14.4 6.447-14.4 14.4 6.447 14.4 14.4 14.4Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M53.251 59.402c7.953 0 14.4-6.447 14.4-14.4s-6.447-14.4-14.4-14.4-14.4 6.447-14.4 14.4 6.447 14.4 14.4 14.4Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M60.735 46.264a8.103 8.103 0 0 1-14.968 0M46.56 39.685a1.673 1.673 0 0 1 3.346 0M56.598 39.685a1.673 1.673 0 0 1 3.346 0", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M34.08 55.993c11.203 0 20.286-9.083 20.286-20.287 0-11.204-9.083-20.286-20.287-20.286-11.204 0-20.286 9.083-20.286 20.286 0 11.204 9.082 20.287 20.286 20.287Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M34.08 55.993c11.203 0 20.286-9.083 20.286-20.287 0-11.204-9.083-20.286-20.287-20.286-11.204 0-20.286 9.083-20.286 20.286 0 11.204 9.082 20.287 20.286 20.287Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M24.906 41.514a10.88 10.88 0 0 1 16.867 0M42.374 26.368a2.26 2.26 0 0 1-4.518 0M28.821 26.368a2.259 2.259 0 1 1-4.517 0", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M45.394 36.746a2.98 2.98 0 0 1-4.132 2.798 2.984 2.984 0 0 1-1.828-2.798c0-1.987 2.98-5.96 2.98-5.96s2.98 3.973 2.98 5.96Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M45.394 36.746a2.98 2.98 0 0 1-4.132 2.798 2.984 2.984 0 0 1-1.828-2.798c0-1.987 2.98-5.96 2.98-5.96s2.98 3.973 2.98 5.96Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var emojiHappySadSmile = {
  render: render$15
};
var render$14 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M72 42a32 32 0 1 0-61.149 13.2H69.15A31.875 31.875 0 0 0 72 42Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M8.8 55.2h62.4M5.2 55.2h2M72.8 55.2h2", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M34.16 22.008h1.69a1.104 1.104 0 0 1 1.103 1.087l.534 34.793H32.52l.536-34.793a1.104 1.104 0 0 1 1.105-1.087Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M32.935 30.84h4.136l-.06-3.864h-4.016l-.06 3.864ZM32.8 39.672h4.407l-.058-3.864h-4.29l-.06 3.864Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M18.72 38.016h34.224v19.872H18.72V38.016Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M18.72 38.016h34.224v19.872H18.72V38.016Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M53.744 31.392h4.472a.8.8 0 0 1 .8.8v11.896h-6.072V32.192a.8.8 0 0 1 .8-.8ZM48.28 35.256h-7.784a.8.8 0 0 0-.8.8v8.032h9.384v-8.032a.8.8 0 0 0-.8-.8Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M63.432 44.088h-4.416V33.6h4.016a.4.4 0 0 1 .4.4v10.088Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m59.016 33.6 4.416 4.416h-4.416l4.416 4.416h-4.416M33.072 57.888h-5.52V40.224h5.12a.4.4 0 0 1 .4.4v17.264Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m27.552 40.224 5.52 5.52h-5.52l5.52 5.52h-5.52l5.52 5.52", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M31.416 57.888h33.671v-13a.8.8 0 0 0-.8-.8H32.216a.8.8 0 0 0-.8.8v13Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M31.416 57.888h33.671v-13a.8.8 0 0 0-.8-.8H32.216a.8.8 0 0 0-.8.8v13Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M39.696 47.952h23.499a4.652 4.652 0 0 1 4.652 4.654v5.28", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M23.672 19.8h2.792a1.105 1.105 0 0 1 1.104 1.088l.536 37h-6.072l.536-37a1.105 1.105 0 0 1 1.104-1.088ZM15.392 19.8h2.792a1.105 1.105 0 0 1 1.104 1.088l.536 37h-6.072l.536-37a1.105 1.105 0 0 1 1.104-1.088Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M23.672 19.8h2.792a1.105 1.105 0 0 1 1.104 1.088l.536 37h-6.072l.536-37a1.105 1.105 0 0 1 1.104-1.088Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M56.81 57.889h3.863V43.393a.96.96 0 0 0-.96-.96H57.77a.96.96 0 0 0-.96.96v14.496Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M54.6 57.888h8.28v-3.6a1.921 1.921 0 0 0-1.92-1.92h-4.44a1.92 1.92 0 0 0-1.92 1.92v3.6ZM46.32 57.889h3.865V43.393a.96.96 0 0 0-.96-.96H47.28a.96.96 0 0 0-.96.96v14.496Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.113 57.888h8.28v-3.6a1.92 1.92 0 0 0-1.92-1.92h-4.44a1.92 1.92 0 0 0-1.92 1.92v3.6ZM35.834 57.889h3.864V43.393a.96.96 0 0 0-.96-.96h-1.944a.96.96 0 0 0-.96.96v14.496Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M33.624 57.888h8.28v-3.6a1.92 1.92 0 0 0-1.92-1.92h-4.44a1.92 1.92 0 0 0-1.92 1.92v3.6Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M42.456 35.256v3.312M46.32 35.256v3.312M42.456 37.464h3.864M55.152 33.6h1.655M15.392 19.8h2.792a1.105 1.105 0 0 1 1.104 1.088l.536 37h-6.072l.536-37a1.105 1.105 0 0 1 1.104-1.088ZM13.752 23.112h6.072M22.032 23.112h6.072", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M35.831 7.656a1.656 1.656 0 1 1-3.31 0 1.656 1.656 0 0 1 3.31 0ZM20.927 13.176a1.656 1.656 0 1 1-3.311 0 1.656 1.656 0 0 1 3.311 0Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75" } }), _c("path", { attrs: { "d": "M31.711 11.225a2.759 2.759 0 0 0-4.652 2.51c-.019 0-.038-.007-.059-.007a1.656 1.656 0 1 0 1.626 1.956 2.754 2.754 0 0 0 3.085-4.46Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linejoin": "round" } })]);
};
var factory = {
  render: render$14
};
var render$13 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M7.946 42.87a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M19.15 64.222c0 .425 2.253.833 6.265 1.134 4.012.301 9.453.47 15.127.47 5.674 0 11.115-.169 15.127-.47 4.012-.3 6.266-.709 6.266-1.134 0-.426-2.254-.834-6.266-1.135-4.012-.301-9.453-.47-15.127-.47-5.674 0-11.115.169-15.127.47-4.012.3-6.266.709-6.266 1.135Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M48.391 15.132a1.07 1.07 0 0 0-1.713.495 14.256 14.256 0 0 1-1.591 3.322.51.51 0 0 1-.933-.36c.12-.74.18-1.49.18-2.24 0-1.438-.167-2.871-.496-4.271a20.848 20.848 0 0 0-2.997-6.24 1.069 1.069 0 0 0-1.92.453c-1.95 10.58-12.601 9.972-12.601 22.974A14.31 14.31 0 0 0 41.399 43.52c8.614-.474 14.588-8.662 13.24-17.182a18.646 18.646 0 0 0-6.248-11.206Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M43.686 37.874a7.743 7.743 0 0 1-10.388-3.724 7.65 7.65 0 0 1-.73-3.253c0-3.407.91-4.99 2.72-6.855a1.08 1.08 0 0 1 1.808.456 6.53 6.53 0 0 0 9.296 3.76 1.056 1.056 0 0 1 1.52.768c.046.288.081.577.106.868a7.989 7.989 0 0 1-4.332 7.98Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M18.775 37.204h43.642v25.671H18.775v-25.67Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M18.775 37.204h43.642v25.671H18.775v-25.67Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.417 47.473v-3.851h-9.734a.535.535 0 0 1-.535-.535v-5.883h-3.851v5.883a.535.535 0 0 1-.534.535H33.429a.535.535 0 0 1-.534-.535v-5.883H29.04v5.883a.535.535 0 0 1-.534.535h-9.73v3.85h20a.535.535 0 0 1 .534.535v4.065a.535.535 0 0 1-.535.535h-20v3.85h9.734a.535.535 0 0 1 .534.536v5.882h3.852v-5.882a.535.535 0 0 1 .534-.535H47.76a.535.535 0 0 1 .535.535v5.882h3.85v-5.882a.535.535 0 0 1 .535-.535h9.737v-3.85h-18.72a.535.535 0 0 1-.534-.536v-4.065a.535.535 0 0 1 .534-.534h18.72Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var firewallSecure = {
  render: render$13
};
var render$12 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M7.38 43.173a32 32 0 1 0 64.002 0 32 32 0 0 0-64.001 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "m12.058 64.841 17.074-2.676c3.496-.566 18.837 13.741 27.04-.83l4.622-.749a2.831 2.831 0 1 0-.904-5.59l-1.76.285a2.83 2.83 0 1 0-.905-5.59l-1.397.226a2.83 2.83 0 0 0-.905-5.59l-1.397.227a2.832 2.832 0 1 0-.901-5.594L42.493 40.6c-7.2 1.165-8.01 4.164-12.125 4.83L6.223 49.242l5.835 15.598Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m12.058 64.841 17.074-2.676c3.496-.566 18.837 13.741 27.04-.83l4.622-.749a2.831 2.831 0 1 0-.904-5.59l-1.76.285a2.83 2.83 0 1 0-.905-5.59l-1.397.226a2.83 2.83 0 0 0-.905-5.59l-1.397.227a2.832 2.832 0 1 0-.901-5.594L42.493 40.6c-7.2 1.165-8.01 4.164-12.125 4.83L6.223 49.242", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m52.803 50.407 3.028-.49-3.028.49Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m52.803 50.407 3.028-.49", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m53.94 55.96 4.193-.68-4.192.68Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m53.94 55.96 4.193-.68", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m51.9 44.818 1.63-.264-1.63.264Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m51.9 44.818 1.63-.264M45.423 63.074l10.75-1.74", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m18.63 45.615 7.563-1.24 3.248 19.816-7.563 1.24-3.247-19.816Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m19.56 51.28 7.562-1.24 1.38 8.423-7.562 1.24-1.38-8.423Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m20.936 59.678 6.323-8.801-.137-.836-7.563 1.239 1.377 8.398Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m19.56 51.28 7.562-1.24 1.38 8.423-7.562 1.24-1.38-8.423Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M24.58 19.422a14.594 14.594 0 1 0 29.189 0 14.594 14.594 0 0 0-29.189 0Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M24.58 19.422a14.594 14.594 0 1 0 29.189 0 14.594 14.594 0 0 0-29.189 0Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M38.666 12.698a2.397 2.397 0 1 0 4.795 0 2.397 2.397 0 0 0-4.794 0Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75" } }), _c("path", { attrs: { "d": "M46.792 14.102a1.158 1.158 0 0 0-1.58.416l-1.606 2.752a.115.115 0 0 1-.148.045L39.772 15.6h-.01l-3.087-1.433a2.422 2.422 0 0 0-3.09.935l-1.6 2.616a1.156 1.156 0 0 0 1.258 1.748 1.154 1.154 0 0 0 .714-.548l1.6-2.615a.113.113 0 0 1 .147-.045l2.16 1.004-2 5.065-2.43 2.299-.091-.08-1.902-2.09a1.153 1.153 0 1 0-1.707 1.554l1.9 2.088a2.432 2.432 0 0 0 1.698.792h.095a2.436 2.436 0 0 0 1.662-.66l2.12-2 2.64.48a.115.115 0 0 1 .095.098l.437 3.752a1.156 1.156 0 0 0 2.294-.266l-.434-3.75a2.412 2.412 0 0 0-1.974-2.102l-1.832-.333 1.53-3.869 2.523 1.171a2.414 2.414 0 0 0 3.113-.977l1.606-2.752a1.155 1.155 0 0 0-.414-1.58Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M56.264 33.569a9.558 9.558 0 1 0 19.115 0 9.558 9.558 0 0 0-19.115 0Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M56.264 33.569a9.558 9.558 0 1 0 19.115 0 9.558 9.558 0 0 0-19.115 0Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M60.14 33.569a5.905 5.905 0 1 0 11.81 0 5.905 5.905 0 0 0-11.81 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M71.95 33.569a5.904 5.904 0 1 1-11.81 0 5.975 5.975 0 0 1 9.025-5.099M66.046 33.569l-2.026-2.027", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m67.865 26.302 1.3 2.168-2.433 1.325", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M4.62 32.905a9.558 9.558 0 1 0 19.116 0 9.558 9.558 0 0 0-19.115 0Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M4.62 32.905a9.558 9.558 0 1 0 19.116 0 9.558 9.558 0 0 0-19.115 0Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M14.178 26.931a4.758 4.758 0 0 0-4.757 4.757c0 2.189 3.307 6.013 4.405 7.23a.48.48 0 0 0 .709 0c1.1-1.217 4.4-5.04 4.4-7.23a4.756 4.756 0 0 0-4.757-4.757Zm-.104 6.184a1.428 1.428 0 1 1 0-2.855 1.428 1.428 0 0 1 0 2.855Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M14.178 26.931a4.758 4.758 0 0 0-4.757 4.757c0 2.189 3.307 6.013 4.405 7.23a.48.48 0 0 0 .709 0c1.1-1.217 4.4-5.04 4.4-7.23a4.756 4.756 0 0 0-4.757-4.757Zm-.104 6.184a1.428 1.428 0 1 1 0-2.855 1.428 1.428 0 0 1 0 2.855Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } })]);
};
var fitnessTracker = {
  render: render$12
};
var render$11 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M29.857 30.82a.801.801 0 0 1 1.217.693 10.837 10.837 0 0 0 2.088 6.82.793.793 0 0 0 1.055.193c1.293-.808 4.287-3.342 5.783-10.075.794-3.386.924-6.895.383-10.33a.796.796 0 0 1 1.188-.822 32.78 32.78 0 0 1 16.02 27.86c.228 9.987-7.66 18.528-17.649 18.496a17.6 17.6 0 0 1-17.544-17.6c.002-7.243 3.277-12.518 7.459-15.234Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75" } }), _c("path", { attrs: { "d": "M45.534 42.8a.8.8 0 0 0-1.105.837c.09.603.123 1.214.102 1.824-.138 3.988-2.627 6.425-5.42 6.328a4.385 4.385 0 0 1-3.926-2.62.8.8 0 0 0-1.52.193 8.8 8.8 0 1 0 17.45 1.627 8.8 8.8 0 0 0-5.58-8.189Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75" } })]);
};
var flame = {
  render: render$11
};
var render$10 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40.706a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M19.157 62.107c0 .213.534.424 1.571.621 1.038.197 2.559.376 4.476.526 1.917.151 4.193.27 6.698.352 2.505.082 5.19.124 7.901.124 2.712 0 5.396-.042 7.901-.124a149.76 149.76 0 0 0 6.698-.352c1.917-.15 3.438-.329 4.476-.526 1.038-.197 1.572-.408 1.572-.62 0-.214-.535-.425-1.572-.622-1.038-.196-2.559-.375-4.476-.526a149.46 149.46 0 0 0-6.698-.352c-2.505-.081-5.19-.123-7.9-.123-2.712 0-5.397.042-7.902.123-2.505.082-4.78.201-6.698.352-1.917.15-3.438.33-4.476.526-1.037.197-1.571.408-1.571.621Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m58.869 27.569-.87-3.474a1.07 1.07 0 0 0-1.04-.811h-9.04a1.07 1.07 0 0 0-1.04.811l-.868 3.474H18.16a1.072 1.072 0 0 0-1.07 1.07v31.067a2.142 2.142 0 0 0 2.143 2.143H59.94a2.142 2.142 0 0 0 2.14-2.143V28.64a1.071 1.071 0 0 0-1.071-1.071h-2.14Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M60.267 61.849h-41.36a2.143 2.143 0 0 1-2.113-1.79l-3.779-22.673a1.072 1.072 0 0 1 1.056-1.248h51.032a1.071 1.071 0 0 1 1.056 1.248l-3.778 22.672a2.143 2.143 0 0 1-2.114 1.79Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M53.946 7.294H29.491l-6.585 6.586V36.14h31.981V8.233a.939.939 0 0 0-.94-.94Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M22.906 13.88h5.644a.942.942 0 0 0 .941-.94V7.293l-6.585 6.586Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M26.434 31.044h6.584M26.434 28.222h4.703M26.434 25.4h2.822M26.434 22.578h3.762", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M33.959 21.638a9.406 9.406 0 1 0 18.812 0 9.406 9.406 0 0 0-18.813 0Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M43.365 31.044a9.367 9.367 0 0 0 5.938-2.112 6.84 6.84 0 0 0-11.877 0 9.37 9.37 0 0 0 5.939 2.112Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M43.365 28.907v2.137", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M45.409 25.797a.8.8 0 0 1-.56-.763v-1.293H41.88v1.293a.8.8 0 0 1-.56.764 6.827 6.827 0 0 0-1.548.708 3.887 3.887 0 0 0 7.184 0 6.824 6.824 0 0 0-1.548-.709Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M43.365 13.73a4.873 4.873 0 0 0-4.857 4.864v6.09a.318.318 0 0 0 .34.326 1.98 1.98 0 0 0 2-1.936V20.43a1.558 1.558 0 0 1 1.558-1.559h1.92a1.558 1.558 0 0 1 1.558 1.559v2.645a1.979 1.979 0 0 0 2 1.935.323.323 0 0 0 .314-.197.32.32 0 0 0 .025-.128v-6.09a4.873 4.873 0 0 0-4.858-4.864Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M47.25 20.025v-.519a3.868 3.868 0 0 0-.648-2.148v.865a.648.648 0 0 1-.648.648h-5.18a.648.648 0 0 1-.647-.648v-.863a3.862 3.862 0 0 0-.648 2.148v.518a.793.793 0 0 0 .08 1.57 3.885 3.885 0 0 0 7.607 0 .793.793 0 0 0 .08-1.57l.003-.001Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M41.422 19.992a.485.485 0 1 0 .971 0 .485.485 0 0 0-.97 0ZM44.336 19.992a.485.485 0 1 0 .97 0 .485.485 0 0 0-.97 0Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M40.774 21.287a.486.486 0 1 0 .972 0 .486.486 0 0 0-.972 0ZM44.983 21.287a.485.485 0 1 0 .971 0 .485.485 0 0 0-.97 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M44.336 22.42a1.618 1.618 0 0 1-1.942 0M41.746 18.871v-1.513M43.365 18.871v-1.513M44.983 18.871v-1.513", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var folderDocument = {
  render: render$10
};
var render$$ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 72 72", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M37.94 39.16c1.63-.01 2.55-.35 2.76-.56.32-.32 1.98-2.14 2.81-5.99 0-.01.01-.03.02-.04v-.04c0-.01.18-.61.36-1.62.03-.3.03-.49.02-.58-.1-.01-.24-.02-.36-.03-.69-.04-1.79-.11-2.96-1.05-1.01.37-3.25 1.04-5.52.71-.65-.1-1.47-.44-2.13-.73-.37.79-.64 1.27-.89 1.58.17 1.07.38 1.69.38 1.7.01.02 0 .04.01.06.01.02.02.03.02.05.83 3.85 2.49 5.67 2.81 5.99.22.2 1.13.54 2.67.55ZM22.16 23.64c-1.4 1.21-4.12 3.18-7.93 2.71.33 3.28 2.1 6.29 5.17 6.29 1.57 0 2.68-.63 3.6-2.05.46-.72 1.02-2.38 1.31-3.89-1-.63-1.71-1.97-2.15-3.06ZM33.6 27.54c.51.22 1.29.56 1.73.62 2.48.37 5.05-.78 5.07-.79.34-.16.74-.08 1.01.18.85.84 1.56.89 2.25.93.16.01.34.03.51.05l.03-.47.02-.35c.14-2.88.11-4.3-2.01-5.22a.8.8 0 0 1-.27-.18c-1.76-1.69-4.17-2.18-6.29-1.26-2.34 1-3.74 3.38-3.82 6.39.15-.16.35-.26.57-.28.32 0 .57.11 1.2.38ZM54.37 32.72c1.47 0 2.95-.28 3.25-.51.79-.79 1.92-2.23 2.53-5.36.01-.71-.89-3-1.49-3.93-.92.62-2.77 1.5-5.47 1.1-1.15-.17-2.05-.53-2.69-1.07-.02-.01-.03-.02-.05-.03-.22.94-.34 2.85-.29 3.9.6 3.15 1.74 4.59 2.55 5.4.29.3.57.5 1.66.5Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M12.52 34.93c1.04-.68 2.05-1.17 2.62-1.42.03-.5-.05-.75-.05-.75-.01-.03-.01-.07-.02-.11-1.77-1.76-2.7-4.58-2.71-7.38 0-.06.02-.11.03-.17v-.05c0-.01.01-.02.01-.03.03-.09.07-.18.12-.25.01-.02.03-.04.04-.06.05-.07.12-.12.19-.17.03-.02.05-.04.08-.06.06-.03.13-.05.2-.07.05-.01.1-.03.15-.03.02 0 .04-.01.07-.01.04 0 .07.02.11.02h.12c4.06 1 6.71-1.39 7.98-2.54.26-.23.46-.41.6-.5.24-.16.54-.2.81-.11.27.1.48.32.56.59.5 1.7 1.46 3.36 1.97 3.42.01 0 .01.01.02.01h.02c.05.01.1.04.15.05.06.02.12.03.17.06.05.03.09.07.13.11.04.04.09.07.13.12.03.04.05.1.08.15.03.05.06.1.08.16.02.06.01.11.02.17 0 .05.02.11.02.16 0 .01 0 .01-.01.02v.02c-.24 1.67-.92 4.09-1.7 5.29-.31.47-.64.89-1 1.24.01.16.02.35.04.62.7.18 1.91.52 3.23 1-.38-1.55-.5-3.48-.27-5.3.72-5.7-.54-8.55-1.73-9.94-.98-1.15-2.02-1.42-2.24-1.42a.889.889 0 0 1-.63-.29c-.46-.5-1.89-1.14-3.94-.88-2.12.27-3.82 1.34-5.05 3.2-1.71 2.58-2.26 6.46-1.37 9.66.67 2.38.9 4.28.97 5.47ZM51.42 21.41c.07.04.14.08.2.14.36.33.99.57 1.82.69 2.99.44 4.54-1.06 4.6-1.12.17-.17.4-.27.64-.27h.07c.75.06 1.46 1.04 2.02 2.21l.03-.47.02-.32c.12-2.62.1-3.91-1.81-4.73a.8.8 0 0 1-.27-.18c-1.6-1.54-3.78-1.98-5.71-1.15-1.85.79-3.07 2.53-3.39 4.77.13-.07.28-.12.43-.13.47-.04.84.21 1.07.37.08.06.17.13.28.19ZM43.19 41.91h-.02c-.01 0-.02.01-.04.01-.03 0-.06-.02-.09-.02a.76.76 0 0 1-.26-.06c-.04-.02-.07-.04-.11-.06a.82.82 0 0 1-.2-.17c-.02-.02-.04-.03-.06-.05-.23-.32-.49-.87-.68-1.48-1.05.78-2.88.89-3.68.89h-.16c-.75 0-2.58-.11-3.63-.88-.22.7-.47 1.24-.51 1.33 0 .01-.01.01-.01.02-.01.02-.02.03-.03.05a1.004 1.004 0 0 1-.23.26c-.08.06-.16.1-.25.13-.01 0-.02.01-.03.02-.04.01-3.6 1.1-5.12 1.72l3.6 11.33c.31-.91 1.09-1.89 2.6-2.53h.01c1.11-.47 2.5-.71 4.13-.71 1.82 0 5.03.02 6.39.02.16-.81.33-2.6.41-4.11.03-.5.46-.87.94-.85.5.03.88.45.85.94-.11 2.1-.34 4.74-.84 5.44-.17.24-.44.38-.73.38 0 0-4.66-.03-7.01-.03-1.39 0-2.54.19-3.42.56-1.36.58-1.6 1.37-1.65 1.67h13.1c3.72 0 3.91-.98 4.12-2.02.35-1.76 1.02-6.77-.05-8.78-1.81-3.37-7.28-3.02-7.34-3.02Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M60.09 35.24c-.47-.23-.73-.45-.88-.63-.19-.2-.46-.48-.67-.86-1.24.76-3.96.78-4.08.78h-.11c-1.19-.01-1.94-.23-2.6-.76-.16.3-.34.53-.45.67-.05.08-.12.15-.19.21-.04.04-.09.07-.14.1-.01 0-.02.01-.02.01-.15.09-.31.15-.48.15-.16-.01-3.76-.03-5.63 5.23 2.15.17 5.66.93 7.26 3.94 1.56 2.93.36 9.26.22 9.97-.12.63-.32 1.19-.64 1.67h12.73V41.27c0-2.69-1.38-4.61-4.32-6.03Zm.69 17.47c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-7.49c0-.5.4-.9.9-.9s.9.4.9.9v7.49Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m7.19 39.19 5.25 16.53h17.61L24.8 39.19H7.19Z", "fill": "#16A7A7" } }), _c("path", { attrs: { "d": "M66.21 55.88V41.27c0-3.36-1.79-5.94-5.33-7.65a1.07 1.07 0 0 1-.28-.17c-.01-.02-.03-.02-.04-.04-.01-.01-.02-.03-.03-.04-.38-.38-.57-.6-.42-1.11.03-.1.03-.2.03-.3.69-1.06 1.37-2.57 1.8-4.81.09-.3.56-1.98.68-4.47l.01-.31c.12-2.48.24-5.04-2.75-6.4-2.13-1.97-5-2.51-7.56-1.41-2.84 1.22-4.6 4.19-4.57 7.75 0 2.78.54 4.54.65 4.86.44 2.28 1.14 3.8 1.84 4.86 0 .07 0 .15.02.22.1.33-.03.61-.22.87-1.3.12-4.76.93-6.73 5.94-.04-.18-.07-.37-.08-.54a.727.727 0 0 0-.06-.21c.72-1.12 1.55-2.83 2.08-5.27.05-.15.61-2.02.75-4.89l.02-.34c.13-2.67.26-5.42-2.95-6.89-2.28-2.11-5.38-2.69-8.13-1.51-3.06 1.31-4.95 4.51-4.92 8.35 0 3.12.63 5.05.71 5.29.53 2.41 1.35 4.11 2.06 5.23 0 .01-.01.02-.01.03-.02.64-.28 1.44-.5 1.96-.96.3-3.41 1.07-4.74 1.6l-1.22-3.85a.904.904 0 0 0-.86-.63H12.17c.06-.03.13-.06.18-.11 1.59-1.36 3.8-2.26 3.89-2.29.3-.1.54-.35.6-.69.03-.14.04-.26.06-.38.74.33 1.57.52 2.48.52.88 0 1.67-.16 2.39-.47l.03.28c.04.39.33.68.69.77.01 0 .01.01.02.01.03.01 2.96.7 5.45 1.81.03.01.05.01.08.02.07.02.13.04.2.04.03 0 .06.02.09.02s.06-.01.09-.01.06-.01.09-.01c.1-.02.2-.06.29-.11.09-.06.16-.13.23-.22.02-.03.03-.05.05-.08l.06-.09c.01-.03.01-.06.02-.08.02-.06.03-.11.04-.18.01-.06.01-.11.01-.17 0-.06-.01-.11-.03-.16-.02-.06-.04-.12-.07-.17-.01-.03-.01-.05-.03-.08-.64-1.02-1.15-3.53-.81-6.19.8-6.35-.73-9.67-2.15-11.33-1.13-1.33-2.4-1.86-3.18-2.01-.98-.84-2.88-1.49-5.23-1.2-2.62.33-4.81 1.71-6.33 3.99-2.02 3.04-2.64 7.41-1.6 11.14 1.06 3.77.93 6.23.93 6.25-.01.2.05.37.15.53.02.17.07.34.19.47.08.09.17.15.27.21h-5.4a.91.91 0 0 0-.73.37c-.17.23-.22.53-.13.8l5.44 17.16H5.9c-.5 0-.9.4-.9.9s.4.9.9.9H64.83c.14.09.3.16.48.16.2 0 .37-.08.51-.18.45-.05.8-.42.8-.88a.91.91 0 0 0-.41-.77ZM49.63 20.99c.33-2.24 1.54-3.98 3.39-4.77 1.93-.83 4.12-.39 5.71 1.15a.8.8 0 0 0 .27.18c1.91.82 1.93 2.12 1.81 4.73l-.01.31-.03.47c-.56-1.17-1.27-2.15-2.02-2.21h-.07c-.24 0-.47.1-.64.27-.06.06-1.62 1.56-4.6 1.12-.83-.12-1.46-.36-1.82-.69-.06-.05-.13-.1-.2-.14-.12-.06-.21-.13-.29-.18-.23-.16-.59-.41-1.07-.37-.15.01-.29.06-.43.13Zm.53 5.84c-.05-1.05.07-2.97.29-3.9.02.01.03.02.05.03.64.54 1.54.9 2.69 1.07 2.71.4 4.55-.48 5.47-1.1.6.93 1.5 3.23 1.49 3.93-.6 3.13-1.74 4.56-2.53 5.36-.3.23-1.78.51-3.25.51-1.09 0-1.37-.2-1.66-.5-.81-.81-1.95-2.25-2.55-5.4Zm-14.51-5.76c2.12-.91 4.53-.43 6.29 1.26a.8.8 0 0 0 .27.18c2.12.91 2.15 2.34 2.01 5.22l-.02.35-.03.47c-.17-.02-.34-.04-.51-.05-.69-.04-1.41-.09-2.25-.93a.904.904 0 0 0-1.01-.18c-.02.01-2.59 1.16-5.07.79-.44-.06-1.21-.4-1.73-.62-.63-.27-.89-.38-1.2-.36-.22.02-.42.12-.57.28.07-3.03 1.48-5.41 3.82-6.41ZM32.46 32.6c0-.02-.02-.03-.02-.05-.01-.02 0-.04-.01-.06 0-.01-.21-.63-.38-1.7.25-.3.52-.79.89-1.58.66.29 1.48.63 2.13.73 2.28.33 4.51-.33 5.52-.71 1.17.94 2.27 1.01 2.96 1.05l.36.03c.01.1.01.29-.02.58-.18 1.01-.36 1.61-.36 1.62v.04c0 .01-.01.02-.02.04-.83 3.85-2.49 5.67-2.81 5.99-.21.21-1.13.56-2.76.56-1.54-.01-2.45-.35-2.67-.56-.32-.31-1.98-2.13-2.81-5.98Zm-13.07.04c-3.08 0-4.84-3.01-5.17-6.29 3.81.47 6.54-1.5 7.93-2.71.44 1.09 1.16 2.44 2.15 3.06-.3 1.51-.85 3.17-1.31 3.89-.92 1.41-2.03 2.05-3.6 2.05Zm-6.48-12.86c1.23-1.86 2.93-2.93 5.05-3.2 2.05-.26 3.48.39 3.94.88.16.18.39.28.63.29.22.01 1.26.27 2.24 1.42 1.19 1.39 2.45 4.24 1.73 9.94-.23 1.82-.11 3.75.27 5.3a44.31 44.31 0 0 0-3.23-1c-.02-.27-.03-.46-.04-.62.36-.36.69-.77 1-1.24.78-1.2 1.46-3.62 1.7-5.29v-.02c0-.01.01-.01.01-.02.01-.06-.01-.11-.02-.16 0-.06 0-.12-.02-.17a.797.797 0 0 0-.08-.16c-.03-.05-.04-.1-.08-.15-.04-.05-.08-.08-.13-.12-.04-.04-.08-.08-.13-.11s-.11-.04-.17-.06c-.05-.02-.09-.04-.15-.05h-.02c-.01 0-.01-.01-.02-.01-.51-.05-1.47-1.71-1.97-3.42a.871.871 0 0 0-.56-.59.871.871 0 0 0-.81.11c-.14.1-.34.27-.6.5-1.27 1.15-3.92 3.54-7.98 2.54-.04-.01-.08 0-.12 0-.04 0-.07-.02-.11-.02-.02 0-.04.01-.07.01l-.15.03c-.07.02-.14.04-.2.07-.03.02-.05.04-.08.06-.07.05-.13.1-.19.17-.02.02-.03.04-.04.06-.05.08-.09.16-.12.25 0 .01-.01.02-.01.03v.05c-.01.06-.03.11-.03.17.01 2.8.94 5.62 2.71 7.38.01.04.01.07.02.11 0 0 .09.25.05.75-.57.25-1.59.74-2.62 1.42-.07-1.18-.3-3.08-.97-5.48-.89-3.19-.34-7.07 1.37-9.65Zm-.48 35.94L7.19 39.19H24.8l5.25 16.53H12.43Zm38.12-2.03c-.21 1.04-.4 2.02-4.12 2.02h-13.1c.04-.3.29-1.09 1.65-1.67.88-.38 2.04-.56 3.42-.56 2.36 0 7.01.03 7.01.03.29 0 .56-.14.73-.38.5-.7.73-3.34.84-5.44a.89.89 0 0 0-.85-.94c-.48-.02-.92.36-.94.85-.08 1.51-.25 3.3-.41 4.11-1.36-.01-4.56-.02-6.39-.02-1.63 0-3.02.24-4.13.71h-.01c-1.5.64-2.29 1.62-2.6 2.53l-3.6-11.33c1.51-.62 5.08-1.71 5.12-1.72.01 0 .02-.01.03-.02.09-.03.17-.08.25-.13.02-.02.05-.04.07-.06.06-.06.11-.12.16-.2.01-.02.03-.03.03-.05 0-.01.01-.01.01-.02.05-.1.3-.64.51-1.33 1.05.78 2.88.88 3.63.88h.16c.79 0 2.63-.11 3.68-.89.19.61.45 1.16.68 1.48.02.02.04.03.06.05.06.07.13.12.2.17.04.02.07.05.11.06.08.04.17.05.26.06.03 0 .06.02.09.02.01 0 .02-.01.04-.01h.02c.05 0 5.53-.34 7.32 3.01 1.09 2.02.42 7.03.07 8.79Zm13.86 2.03H51.68c.32-.48.52-1.04.64-1.67.14-.71 1.33-7.04-.22-9.97-1.6-3.01-5.11-3.76-7.26-3.94 1.87-5.26 5.47-5.24 5.63-5.23.17 0 .33-.06.48-.15.01 0 .02-.01.02-.01.05-.03.1-.06.14-.1.07-.06.14-.13.19-.21.11-.14.29-.37.45-.67.66.53 1.41.75 2.6.76h.11c.13 0 2.84-.02 4.08-.78.21.38.47.67.67.86.15.18.41.4.88.63 2.95 1.43 4.32 3.34 4.32 6.03v14.45Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M59.88 44.32c-.5 0-.9.4-.9.9v7.49c0 .5.4.9.9.9s.9-.4.9-.9v-7.49c0-.5-.4-.9-.9-.9Z", "fill": "#481D72" } })]);
};
var groupLearn = {
  render: render$$
};
var render$_ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8.502 40a32 32 0 1 0 64.001 0 32 32 0 0 0-64.001 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M10.58 57.591c0 .247.707.483 1.967.657 1.26.175 2.97.273 4.752.273 1.782 0 3.492-.098 4.752-.273 1.26-.174 1.968-.41 1.968-.657 0-.246-.708-.483-1.968-.657-1.26-.174-2.97-.272-4.752-.272-1.782 0-3.491.098-4.752.272-1.26.174-1.968.41-1.968.657ZM29.11 57.591c0 .245.5.486 1.47.712.97.226 2.394.43 4.188.603 1.794.173 3.924.31 6.268.404 2.344.093 4.856.141 7.393.141 2.538 0 5.05-.048 7.394-.141 2.344-.094 4.474-.23 6.268-.404 1.794-.172 3.217-.377 4.188-.603.97-.226 1.47-.467 1.47-.712 0-.244-.5-.486-1.47-.712-.971-.225-2.394-.43-4.188-.603-1.794-.173-3.924-.31-6.268-.403a187.51 187.51 0 0 0-7.394-.142c-2.537 0-5.05.048-7.393.142-2.344.093-4.474.23-6.268.403-1.794.173-3.217.378-4.188.603-.97.226-1.47.468-1.47.712Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M31.226 52.011a2.79 2.79 0 0 1 2.79-2.79h31.617a1.395 1.395 0 0 0 0-2.79H34.016a5.58 5.58 0 0 0 0 11.16h31.618a1.395 1.395 0 1 0 0-2.79H34.016a2.79 2.79 0 0 1-2.79-2.79Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M31.226 52.011a2.79 2.79 0 0 1 2.79-2.79h31.617a1.395 1.395 0 0 0 0-2.79H34.016a5.58 5.58 0 0 0 0 11.16h31.618a1.395 1.395 0 1 0 0-2.79H34.016a2.79 2.79 0 0 1-2.79-2.79Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.844 52.011a2.79 2.79 0 0 1 2.79-2.79H34.015a2.79 2.79 0 0 0 0 5.58h31.619a2.79 2.79 0 0 1-2.79-2.79Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M62.844 52.011a2.79 2.79 0 0 1 2.79-2.79H34.015a2.79 2.79 0 0 0 0 5.58h31.619a2.79 2.79 0 0 1-2.79-2.79ZM36.806 51.081h21.853M36.806 52.942h21.853", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.378 40.852a2.79 2.79 0 0 0-2.79-2.79H27.97a1.395 1.395 0 0 1 0-2.79H59.59a5.58 5.58 0 0 1 0 11.16H27.97a1.395 1.395 0 0 1 0-2.79H59.59a2.79 2.79 0 0 0 2.79-2.79Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M62.378 40.852a2.79 2.79 0 0 0-2.79-2.79H27.97a1.395 1.395 0 0 1 0-2.79H59.59a5.58 5.58 0 0 1 0 11.16H27.97a1.395 1.395 0 0 1 0-2.79H59.59a2.79 2.79 0 0 0 2.79-2.79Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M30.761 40.852a2.79 2.79 0 0 0-2.79-2.79h31.618a2.79 2.79 0 1 1 0 5.58H27.971a2.79 2.79 0 0 0 2.79-2.79Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M30.761 40.852a2.79 2.79 0 0 0-2.79-2.79h31.618a2.79 2.79 0 1 1 0 5.58H27.971a2.79 2.79 0 0 0 2.79-2.79ZM56.799 39.922H34.945M56.799 41.782H34.945", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M45.755 20.994a2.075 2.075 0 1 0 4.15 0 2.075 2.075 0 0 0-4.15 0Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M59.244 24.107H36.416l-1.038 11.165h24.904l-1.038-11.165Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M59.244 24.107H36.416l-1.038 11.165h24.904l-1.038-11.165Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M67.546 20.994H28.115a1.557 1.557 0 1 0 0 3.113h39.43a1.557 1.557 0 1 0 0-3.113Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M67.546 20.994H28.115a1.557 1.557 0 1 0 0 3.113h39.43a1.557 1.557 0 1 0 0-3.113ZM69.103 22.551v6.226", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M70.14 29.814a1.041 1.041 0 1 0-2.075 0v2.076h2.075v-2.076Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M70.895 32.39a1.814 1.814 0 0 0-3.587 0l-.652 4.24a.84.84 0 0 0 .83.97h3.234a.838.838 0 0 0 .83-.967l-.655-4.243Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M70.895 32.39a1.814 1.814 0 0 0-3.587 0l-.652 4.24a.84.84 0 0 0 .83.97h3.234a.838.838 0 0 0 .83-.967l-.655-4.243Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.704 25.494s-9.272 6.228-16.035 13.907S18.9 57.063 18.9 57.063c-1.04 1.179-4.361-.053-7.424-2.751-3.062-2.698-4.704-5.84-3.667-7.017 0 0 9.271-6.227 16.035-13.906 6.763-7.68 11.768-17.663 11.768-17.663l11.092 9.768Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M23.844 33.389C17.081 41.069 7.81 47.295 7.81 47.295c-.716.812-.16 2.56 1.263 4.449l2.15-1.44s9.271-6.227 16.034-13.906c6.763-7.68 11.768-17.663 11.768-17.663l-3.413-3.006s-5.005 9.981-11.768 17.66Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.704 25.494s-9.272 6.228-16.035 13.907S18.9 57.063 18.9 57.063c-1.04 1.179-4.361-.053-7.424-2.751-3.062-2.698-4.704-5.84-3.667-7.017 0 0 9.271-6.227 16.035-13.906 6.763-7.68 11.768-17.663 11.768-17.663l11.092 9.768Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M39.28 22.743a18.146 18.146 0 0 0 2.266 1.707c.767.486 1.517.867 2.206 1.122.69.256 1.305.38 1.812.367.507-.013.895-.164 1.141-.444.247-.28.348-.684.297-1.188-.05-.505-.252-1.1-.593-1.751-.34-.652-.813-1.348-1.392-2.047a18.12 18.12 0 0 0-1.98-2.032 18.126 18.126 0 0 0-2.265-1.707c-.767-.485-1.517-.867-2.206-1.122-.69-.256-1.305-.38-1.812-.367-.506.013-.894.164-1.141.445-.247.28-.347.683-.297 1.188.051.504.252 1.099.593 1.75.34.652.814 1.348 1.392 2.048s1.251 1.39 1.98 2.031Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M28.384 35.115a9.993 9.993 0 0 1-2.807-3.787 57.547 57.547 0 0 1-3.377 3.851 10.005 10.005 0 0 0 2.8 3.775 10.008 10.008 0 0 0 4.1 2.303 59.942 59.942 0 0 1 3.393-3.836 9.994 9.994 0 0 1-4.109-2.306Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M28.384 35.115a9.993 9.993 0 0 1-2.807-3.787 57.547 57.547 0 0 1-3.377 3.851 10.005 10.005 0 0 0 2.8 3.775 10.008 10.008 0 0 0 4.1 2.303 59.942 59.942 0 0 1 3.393-3.836 9.994 9.994 0 0 1-4.109-2.306Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var graduation = {
  render: render$_
};
var render$Z = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M40 75.689c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32-17.673 0-32 14.327-32 32 0 17.673 14.327 32 32 32Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M69.6 56.889H10.4a32.413 32.413 0 0 0 59.195 0h.005Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M8.8 56.889h62.4M5.2 56.889h2M72.8 56.889h2", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M17.617 62.942c5.211 0 9.436-.847 9.436-1.892 0-1.044-4.225-1.892-9.436-1.892-5.212 0-9.436.848-9.436 1.892 0 1.045 4.225 1.892 9.436 1.892ZM62.456 62.942c5.211 0 9.436-.847 9.436-1.892 0-1.044-4.225-1.892-9.436-1.892s-9.436.848-9.436 1.892c0 1.045 4.225 1.892 9.436 1.892Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M25.106 38.51H9.981a.687.687 0 0 0-.688.687v20.625c0 .38.308.688.688.688h15.125c.38 0 .688-.308.688-.688V39.197a.687.687 0 0 0-.688-.688Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M25.106 38.51H9.981a.687.687 0 0 0-.688.687v20.625c0 .38.308.688.688.688h15.125c.38 0 .688-.308.688-.688V39.197a.687.687 0 0 0-.688-.688Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M15.751 47.495a1.865 1.865 0 1 0 3.731 0v-.935a1.866 1.866 0 1 0-3.731 0v.935Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M19.141 45.486a3.1 3.1 0 0 1-3.376.848", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M13.42 55.346v-.234a4.198 4.198 0 0 1 8.394 0v.234H13.42Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M70.02 38.51H54.893a.687.687 0 0 0-.688.687v20.625c0 .38.308.688.688.688h15.125c.38 0 .687-.308.687-.688V39.197a.687.687 0 0 0-.687-.688Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M70.02 38.51H54.893a.687.687 0 0 0-.688.687v20.625c0 .38.308.688.688.688h15.125c.38 0 .687-.308.687-.688V39.197a.687.687 0 0 0-.687-.688Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M60.664 47.495a1.865 1.865 0 1 0 3.731 0v-.935a1.866 1.866 0 0 0-3.73 0v.935Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M64.053 45.486a3.1 3.1 0 0 1-3.375.848", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M58.332 55.346v-.234a4.198 4.198 0 0 1 8.394 0v.234h-8.394Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M45.066 20.703a1.748 1.748 0 0 1 2.439-.405l4.624 3.304a1.749 1.749 0 0 1-2.034 2.845l-4.624-3.305a1.747 1.747 0 0 1-.405-2.439ZM45.793 15.392A3.885 3.885 0 0 1 43.954 20l-3.736 2.423a9.76 9.76 0 0 1 2.015-7.16c1.306-1.564 3.065-1 3.56.129Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.246 20.92c2.27-1.666 3.29-2.367 5.835-3.058l2.254-.654-2.36-10.604-2.154.711c-3.059 1.19-7.212-.933-11.872 1.755-5.888 3.396-9.254 10.085-5.87 19.995a1.75 1.75 0 0 0 3.315-1.12c-.22-.654-.41-1.29-.568-1.907a23.152 23.152 0 0 1-.608-3.62 9.76 9.76 0 0 1 2.015-7.16c1.306-1.563 3.065-.999 3.56.13A3.885 3.885 0 0 1 43.953 20l-3.735 2.423c.107 1.221.31 2.432.608 3.62.221-.042.432-.127.621-.25 8.051-2.993 9.347-3.807 10.8-4.873Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M52.246 20.92c2.27-1.666 3.29-2.367 5.835-3.058l2.254-.654-2.36-10.604-2.154.711c-3.059 1.19-7.212-.933-11.872 1.755-5.888 3.396-9.254 10.085-5.87 19.995a1.75 1.75 0 0 0 3.315-1.12c-.22-.654-.41-1.29-.568-1.907a23.152 23.152 0 0 1-.608-3.62 9.76 9.76 0 0 1 2.015-7.16c1.306-1.563 3.065-.999 3.56.13A3.885 3.885 0 0 1 43.953 20l-3.735 2.423c.107 1.221.31 2.432.608 3.62.221-.042.432-.127.621-.25 8.051-2.993 9.347-3.807 10.8-4.873Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M45.793 15.392A3.885 3.885 0 0 1 43.954 20l-4.41 2.86a1.75 1.75 0 0 0 1.904 2.934c8.05-2.995 9.346-3.808 10.8-4.874", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m64.576 3.937-5.846 1.3a1.033 1.033 0 0 0-.784 1.233l2.495 11.212c.124.557.676.908 1.233.784l5.846-1.301c.556-.124.907-.676.784-1.233L65.808 4.72a1.033 1.033 0 0 0-1.232-.783Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m60.475 17.84-1.552.346a1.03 1.03 0 0 1-1.232-.784l-2.116-9.51a1.033 1.033 0 0 1 .784-1.231l1.553-.346 2.563 11.525Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m64.576 3.937-5.846 1.3a1.033 1.033 0 0 0-.784 1.233l2.495 11.212c.124.557.676.908 1.233.784l5.846-1.301c.556-.124.907-.676.784-1.233L65.808 4.72a1.033 1.033 0 0 0-1.232-.783Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M50.4 24.689H31.2a.8.8 0 0 0-.8.8v26.4a.8.8 0 0 0 .8.8h19.2a.8.8 0 0 0 .8-.8v-26.4a.8.8 0 0 0-.8-.8Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M48 22.289H28.8a.8.8 0 0 0-.8.8v26.4a.8.8 0 0 0 .8.8H48a.8.8 0 0 0 .8-.8v-26.4a.8.8 0 0 0-.8-.8Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M48 22.289H28.8a.8.8 0 0 0-.8.8v26.4a.8.8 0 0 0 .8.8H48a.8.8 0 0 0 .8-.8v-26.4a.8.8 0 0 0-.8-.8Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M36.034 32.365a2.451 2.451 0 1 0 4.902 0v-1.226a2.451 2.451 0 0 0-4.902 0v1.226Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40.488 29.726a4.075 4.075 0 0 1-4.435 1.114", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M32.97 42.68v-.307a5.515 5.515 0 0 1 11.03 0v.306H32.97Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M34.4 22.289v-1.2a2 2 0 0 0-4 0v6.4a1.2 1.2 0 0 0 2.4 0v-2.8", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M45.793 15.392A3.885 3.885 0 0 1 43.954 20l-4.41 2.86a1.75 1.75 0 0 0 1.904 2.934c8.05-2.995 9.346-3.808 10.8-4.874", "fill": "#fff" } }), _c("path", { attrs: { "d": "M45.793 15.392A3.885 3.885 0 0 1 43.954 20l-4.41 2.86a1.75 1.75 0 0 0 1.904 2.934c8.05-2.995 9.346-3.808 10.8-4.874", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var handpickResume = {
  render: render$Z
};
var render$Y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "m20.431 52.502-.005-.008 3.459-2.606 6.226-7.542 4.736.987a1.819 1.819 0 0 1 2.859.997 1.82 1.82 0 0 1-.666 1.91l-.727.548a1.82 1.82 0 1 1 2.19 2.906l-.725.548a1.819 1.819 0 1 1 2.19 2.905l-2.88 2.17c-3.743 2.82-5.495 1.862-7.635 3.475l-2.73 2.06-6.292-8.35Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m25.097 63.226 1.28-.96a1.127 1.127 0 0 0 .221-1.58l-6.038-8.01a1.128 1.128 0 0 0-1.58-.222l-1.28.964 7.397 9.808Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m25.84 53.38-2.952 2.38-2.457-3.26v-.004l.16-.123c2.97-2.24.253-5.128.864-6.933.368-1.086 2.302-5.447 2.302-5.447a1.82 1.82 0 1 1 3.352 1.417L25.7 44.744l.446.593a6.37 6.37 0 0 1-.306 8.044Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m22.888 55.76-2.457-3.26v-.004l.16-.123c2.97-2.24.253-5.128.864-6.933.368-1.086 2.302-5.447 2.302-5.447a1.82 1.82 0 1 1 3.352 1.417L25.7 44.744l.446.593a6.37 6.37 0 0 1-.306 8.044", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m43.848 52.532 2.672-2.24-.765-.912a1.291 1.291 0 0 0-1.818-.16l-1.483 1.245a1.936 1.936 0 0 0-.24 2.727l.986 1.167a1.928 1.928 0 0 1 .648-1.827Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M22.985 30.846a4.894 4.894 0 0 1 2.099-2.733l3.326-2.136a2.687 2.687 0 0 1 3.92.854c.618.87 1.15 1.791 1.753 2.73l1.698 2.644a2.64 2.64 0 0 1-.87 3.992c-1.109.712-2.148 1.44-3.311 2.066a.555.555 0 0 0-.293.67 18.54 18.54 0 0 0 1.554 4.48 27.976 27.976 0 0 0 5.477 7.685c.48.473 1.096.862 1.58 1.335a.573.573 0 0 0 .8.027l3.326-2.136a2.636 2.636 0 0 1 3.92.855l3.45 5.374a2.714 2.714 0 0 1-.87 3.991c-.995.7-2.074 1.272-3.04 2.015a5.144 5.144 0 0 1-4.622.68 17.675 17.675 0 0 1-6.183-3.44 37.299 37.299 0 0 1-10.08-12.137 34.282 34.282 0 0 1-3.773-11.13 12.159 12.159 0 0 1 .139-5.685Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m51.418 56.556-3.45-5.374a2.635 2.635 0 0 0-3.92-.855l-1.507.968 6.547 10.199c.492-.308.986-.613 1.46-.947a2.713 2.713 0 0 0 .87-3.991ZM33.454 37.146c.48-.312.964-.632 1.458-.95a2.639 2.639 0 0 0 .87-3.991l-1.697-2.64c-.603-.939-1.135-1.861-1.753-2.73a2.687 2.687 0 0 0-3.92-.854l-1.507.968 6.55 10.197Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M33.454 37.146c.48-.312.964-.632 1.458-.95a2.639 2.639 0 0 0 .87-3.991l-1.697-2.64c-.603-.939-1.135-1.861-1.753-2.73a2.687 2.687 0 0 0-3.92-.854l-1.507.968 6.55 10.197ZM51.418 56.556l-3.45-5.374a2.635 2.635 0 0 0-3.92-.855l-1.507.968 6.547 10.199c.492-.308.986-.613 1.46-.947a2.713 2.713 0 0 0 .87-3.991Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M22.985 30.846a4.894 4.894 0 0 1 2.099-2.733l3.326-2.136a2.687 2.687 0 0 1 3.92.854c.618.87 1.15 1.791 1.753 2.73l1.698 2.644a2.64 2.64 0 0 1-.87 3.992c-1.109.712-2.148 1.44-3.311 2.066a.555.555 0 0 0-.293.67 18.54 18.54 0 0 0 1.554 4.48 27.976 27.976 0 0 0 5.477 7.685c.48.473 1.096.862 1.58 1.335a.573.573 0 0 0 .8.027l3.326-2.136a2.635 2.635 0 0 1 3.92.855l3.45 5.374a2.714 2.714 0 0 1-.87 3.991c-.995.7-2.074 1.272-3.04 2.015a5.144 5.144 0 0 1-4.622.68 17.675 17.675 0 0 1-6.183-3.44 37.299 37.299 0 0 1-10.08-12.137 34.282 34.282 0 0 1-3.773-11.13 12.159 12.159 0 0 1 .139-5.685Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M30.888 48.496a1.821 1.821 0 0 0 2.549.358l4.796-3.615a1.82 1.82 0 0 0-2.19-2.906l-4.796 3.615a1.819 1.819 0 0 0-.359 2.548Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M33.083 51.398a1.82 1.82 0 0 0 2.549.358l3.643-2.746a1.82 1.82 0 1 0-2.19-2.907L33.44 48.85a1.82 1.82 0 0 0-.357 2.548ZM29.221 45.163a1.82 1.82 0 0 0 2.549.358l4.033-3.04a1.818 1.818 0 0 0-.15-3.049 1.82 1.82 0 0 0-2.042.143l-4.032 3.04a1.82 1.82 0 0 0-.358 2.548Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M35.871 53.854a1.818 1.818 0 0 0 2.548.358l2.141-1.614a1.82 1.82 0 0 0-2.19-2.906l-2.142 1.614a1.82 1.82 0 0 0-.357 2.548Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m25.424 64.968-.944.712a30.12 30.12 0 0 1-10.376-10.528l2.503-1.888a.782.782 0 0 1 1.097.152l7.88 10.456a.78.78 0 0 1-.16 1.096Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m24.606 65.586.821-.62a.784.784 0 0 0 .154-1.097l-7.877-10.451a.783.783 0 0 0-1.098-.154l-2.503 1.887", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M66.338 21.334H60.44V15.44a2.949 2.949 0 0 0-2.949-2.949h-4.72a2.949 2.949 0 0 0-2.946 2.949v5.897h-5.897a2.949 2.949 0 0 0-2.949 2.949v4.72a2.948 2.948 0 0 0 2.949 2.948h5.897v5.897a2.948 2.948 0 0 0 2.948 2.948h4.72a2.949 2.949 0 0 0 2.95-2.948V31.95h5.896A2.948 2.948 0 0 0 69.288 29v-4.72a2.948 2.948 0 0 0-2.95-2.947Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M66.338 21.334H60.44V15.44a2.949 2.949 0 0 0-2.949-2.949h-4.72a2.949 2.949 0 0 0-2.946 2.949v5.897h-5.897a2.949 2.949 0 0 0-2.949 2.949v4.72a2.948 2.948 0 0 0 2.949 2.948h5.897v5.897a2.948 2.948 0 0 0 2.948 2.948h4.72a2.949 2.949 0 0 0 2.95-2.948V31.95h5.896A2.948 2.948 0 0 0 69.288 29v-4.72a2.948 2.948 0 0 0-2.95-2.947Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var healthCall = {
  render: render$Y
};
var render$X = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M72.107 41.072a32 32 0 1 0-61.147 13.2h58.296a31.859 31.859 0 0 0 2.851-13.2Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M8.507 54.272h62.4M4.907 54.272h2M72.507 54.272h2", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.686 66.48c0 .97-5.242 1.76-11.707 1.76-6.465 0-11.705-.786-11.705-1.76s5.241-1.76 11.705-1.76 11.707.789 11.707 1.76ZM7.686 56.203c0 .405 2.683.794 7.459 1.08 4.776.287 11.254.448 18.009.448 6.754 0 13.232-.16 18.008-.447 4.776-.287 7.46-.675 7.46-1.08 0-.406-2.684-.795-7.46-1.081-4.776-.287-11.254-.448-18.008-.448-6.755 0-13.233.161-18.01.448-4.775.286-7.458.675-7.458 1.08Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M24.088 49.798a1.834 1.834 0 0 0-1.834-1.833h-7.335a1.834 1.834 0 1 0 0 3.666h7.335a1.833 1.833 0 0 0 1.834-1.833Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M24.088 49.798a1.834 1.834 0 0 0-1.834-1.833h-7.335a1.834 1.834 0 1 0 0 3.666h7.335a1.833 1.833 0 0 0 1.834-1.833Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M28.978 46.13a1.834 1.834 0 0 0-1.834-1.833h-7.335a1.834 1.834 0 0 0 0 3.668h7.335a1.834 1.834 0 0 0 1.834-1.835Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M28.978 46.13a1.834 1.834 0 0 0-1.834-1.833h-7.335a1.834 1.834 0 0 0 0 3.668h7.335a1.834 1.834 0 0 0 1.834-1.835Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M35.76 42.463a1.834 1.834 0 0 0-1.835-1.833h-7.332a1.834 1.834 0 0 0 0 3.667h7.334a1.834 1.834 0 0 0 1.833-1.834Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M35.76 42.463a1.834 1.834 0 0 0-1.835-1.833h-7.332a1.834 1.834 0 0 0 0 3.667h7.334a1.834 1.834 0 0 0 1.833-1.834Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M39.98 46.13a1.834 1.834 0 0 0-1.834-1.833H30.81a1.834 1.834 0 0 0 0 3.668h7.335a1.834 1.834 0 0 0 1.834-1.835Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M39.98 46.13a1.834 1.834 0 0 0-1.834-1.833H30.81a1.834 1.834 0 0 0 0 3.668h7.335a1.834 1.834 0 0 0 1.834-1.835Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M35.09 49.798a1.831 1.831 0 0 0-1.834-1.833H25.92a1.834 1.834 0 0 0 0 3.666h7.336a1.833 1.833 0 0 0 1.834-1.833Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M35.09 49.798a1.831 1.831 0 0 0-1.834-1.833H25.92a1.834 1.834 0 0 0 0 3.666h7.336a1.833 1.833 0 0 0 1.834-1.833Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.092 49.798a1.834 1.834 0 0 0-1.834-1.833h-7.334a1.834 1.834 0 1 0 0 3.666h7.334a1.834 1.834 0 0 0 1.834-1.833Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M46.092 49.798a1.834 1.834 0 0 0-1.834-1.833h-7.334a1.834 1.834 0 1 0 0 3.666h7.334a1.834 1.834 0 0 0 1.834-1.833Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.078 53.452a1.833 1.833 0 0 0-1.833-1.834H19.91a1.834 1.834 0 0 0 0 3.668h7.335a1.835 1.835 0 0 0 1.833-1.834Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M29.078 53.452a1.833 1.833 0 0 0-1.833-1.834H19.91a1.834 1.834 0 0 0 0 3.668h7.335a1.835 1.835 0 0 0 1.833-1.834Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M18.509 52.052a1.834 1.834 0 0 0-2.16-1.436l-7.19 1.446a1.836 1.836 0 0 0 .72 3.6l7.19-1.447a1.834 1.834 0 0 0 1.44-2.163Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M18.509 52.052a1.834 1.834 0 0 0-2.16-1.436l-7.19 1.446a1.836 1.836 0 0 0 .72 3.6l7.19-1.447a1.834 1.834 0 0 0 1.44-2.163Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40.08 53.452a1.834 1.834 0 0 0-1.834-1.834h-7.333a1.834 1.834 0 1 0 0 3.668h7.334a1.834 1.834 0 0 0 1.833-1.834Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M40.08 53.452a1.834 1.834 0 0 0-1.834-1.834h-7.333a1.834 1.834 0 1 0 0 3.668h7.334a1.834 1.834 0 0 0 1.833-1.834Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.084 53.452a1.835 1.835 0 0 0-1.835-1.834h-7.33a1.834 1.834 0 1 0 0 3.668h7.334a1.835 1.835 0 0 0 1.831-1.834Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M51.084 53.452a1.835 1.835 0 0 0-1.835-1.834h-7.33a1.834 1.834 0 1 0 0 3.668h7.334a1.835 1.835 0 0 0 1.831-1.834Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.958 52.752h25.67v2.445h-25.67v-2.445ZM46.958 50.307h25.67v2.445h-25.67v-2.445Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.958 47.862h25.67v2.446h-25.67v-2.446ZM46.958 45.417h25.67v2.444h-25.67v-2.444Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M55.515 45.417h8.557v9.78h-8.557v-9.78Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M55.515 45.417h8.557v9.78h-8.557v-9.78Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M53.052 13.768a39.08 39.08 0 0 1-2.416 5.862c-2.071-3.565-5.942-5.343-10.385-5.343-4.442 0-8.313 1.778-10.383 5.343a39.018 39.018 0 0 1-2.416-5.862 15.445 15.445 0 0 1 25.6 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m55.434 52.967-1.61 8.422a1.176 1.176 0 0 1-2.062.528l-11.516-13.94-5.806-7.017-4.608-5.578a19.742 19.742 0 0 1-2.38-21.614 39.266 39.266 0 0 0 2.44 5.934 41.16 41.16 0 0 0 5.12 7.883l5.237 6.336 2.754 3.332.044.06 3.004 3.647L55.185 52a1.172 1.172 0 0 1 .249.967Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m55.434 52.967-1.61 8.422a1.176 1.176 0 0 1-2.062.528l-11.516-13.94-5.806-7.017-4.608-5.578a19.742 19.742 0 0 1-2.38-21.614 39.266 39.266 0 0 0 2.44 5.934 41.16 41.16 0 0 0 5.12 7.883l5.237 6.336 2.754 3.332.044.06 3.004 3.647L55.185 52a1.172 1.172 0 0 1 .249.967Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M54.566 27.779a19.72 19.72 0 0 1-3.906 7.6l-4.609 5.581-5.805 7.016L28.73 61.92a1.178 1.178 0 0 1-2.062-.529l-1.61-8.424a1.172 1.172 0 0 1 .248-.967l9.134-11.04 3.007-3.644.045-.06 2.754-3.336 5.237-6.336a41.208 41.208 0 0 0 5.12-7.882 39.056 39.056 0 0 0 2.437-5.934 19.846 19.846 0 0 1 1.526 14.01Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M53.052 13.768a39.08 39.08 0 0 1-2.416 5.862c-2.071-3.565-5.942-5.343-10.385-5.343-4.442 0-8.313 1.778-10.383 5.343a39.018 39.018 0 0 1-2.416-5.862 15.445 15.445 0 0 1 25.6 0Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M54.566 27.779a19.72 19.72 0 0 1-3.906 7.6l-4.609 5.581-5.805 7.016L28.73 61.92a1.178 1.178 0 0 1-2.062-.529l-1.61-8.424a1.172 1.172 0 0 1 .248-.967l9.134-11.04 3.007-3.644.045-.06 2.754-3.336 5.237-6.336a41.208 41.208 0 0 0 5.12-7.882 39.151 39.151 0 0 0 2.437-5.934 19.846 19.846 0 0 1 1.526 14.01Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M74.69 55.737a1.834 1.834 0 0 0-.282-2.578l-5.721-4.59a1.834 1.834 0 1 0-2.296 2.86l5.72 4.59a1.833 1.833 0 0 0 2.578-.282Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M74.69 55.737a1.834 1.834 0 0 0-.282-2.578l-5.721-4.59a1.834 1.834 0 1 0-2.296 2.86l5.72 4.59a1.833 1.833 0 0 0 2.578-.282Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M69.24 54.586a1.834 1.834 0 0 0-1.834-1.834h-7.334a1.834 1.834 0 1 0 0 3.668h7.334a1.834 1.834 0 0 0 1.834-1.834Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M69.24 54.586a1.834 1.834 0 0 0-1.834-1.834h-7.334a1.834 1.834 0 1 0 0 3.668h7.334a1.834 1.834 0 0 0 1.834-1.834Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m61.112 37.407 2.88-.96a.271.271 0 0 0 0-.513l-2.366-.79a1.078 1.078 0 0 1-.683-.682l-.789-2.365a.27.27 0 0 0-.512 0l-.789 2.365a1.078 1.078 0 0 1-.683.683l-2.366.789a.27.27 0 0 0 0 .513l2.366.787a1.082 1.082 0 0 1 .683.684l.79 2.367a.27.27 0 0 0 .511 0l.958-2.878ZM15.59 32.06a2.442 2.442 0 0 1 1.832-1.832l3.68-.849a.306.306 0 0 0 0-.595l-3.68-.849a2.444 2.444 0 0 1-1.832-1.832l-.848-3.676a.305.305 0 0 0-.596 0l-.848 3.676a2.446 2.446 0 0 1-1.833 1.833l-3.676.848a.306.306 0 0 0 0 .595l3.676.849a2.445 2.445 0 0 1 1.833 1.833l.848 3.68a.306.306 0 0 0 .596 0l.848-3.68Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var healthCharityDonation = {
  render: render$X
};
var render$W = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40.223a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M56.044 20.737h-8.64v-8.64a4.32 4.32 0 0 0-4.32-4.32h-6.912a4.32 4.32 0 0 0-4.32 4.32v8.64h-8.64a4.32 4.32 0 0 0-4.32 4.32v6.912a4.32 4.32 0 0 0 4.32 4.32h8.64v8.64a4.32 4.32 0 0 0 4.32 4.32h6.912a4.32 4.32 0 0 0 4.32-4.32v-8.64h8.64a4.32 4.32 0 0 0 4.32-4.32v-6.912a4.32 4.32 0 0 0-4.32-4.32Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M56.044 20.737h-8.64v-8.64a4.32 4.32 0 0 0-4.32-4.32h-6.912a4.32 4.32 0 0 0-4.32 4.32v8.64h-8.64a4.32 4.32 0 0 0-4.32 4.32v6.912a4.32 4.32 0 0 0 4.32 4.32h8.64v8.64a4.32 4.32 0 0 0 4.32 4.32h6.912a4.32 4.32 0 0 0 4.32-4.32v-8.64h8.64a4.32 4.32 0 0 0 4.32-4.32v-6.912a4.32 4.32 0 0 0-4.32-4.32Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M17.701 58.108a1.84 1.84 0 0 1-1.829-1.65c-.408-3.941 1.084-9.399 3.628-13.275a1.84 1.84 0 0 1 3.076 2.017c-2.053 3.127-3.36 7.802-3.04 10.875a1.84 1.84 0 0 1-1.64 2.02 1.73 1.73 0 0 1-.195.013Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M30.534 72.223v-1.4a14.51 14.51 0 0 1 .264-3.68c1.96-7.457-.128-12.46-1.44-16.064a1.84 1.84 0 0 0-3.459 1.259c4.52 14.32-8 8.424-8.16-3.6.032-1.508.018-3.788.008-5.453-.005-.655-.008-1.223-.008-1.624a1.84 1.84 0 0 0-3.68 0c0 .407 0 .982.008 1.646.01 1.644.024 3.895-.008 5.35-.202 9.17 5.415 15.379 5.472 22.164v1.4l11.003.002Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M30.534 72.223v-1.4a14.51 14.51 0 0 1 .264-3.68c1.96-7.457-.128-12.46-1.44-16.064a1.84 1.84 0 0 0-3.459 1.259c4.52 14.32-8 8.424-8.16-3.6.032-1.508.018-3.788.008-5.453-.005-.655-.008-1.223-.008-1.624a1.84 1.84 0 0 0-3.68 0c0 .407 0 .982.008 1.646.01 1.644.024 3.895-.008 5.35-.202 9.17 5.415 15.379 5.472 22.164v1.4", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M61.499 58.108a1.84 1.84 0 0 0 1.829-1.65c.408-3.941-1.084-9.399-3.628-13.275a1.84 1.84 0 1 0-3.076 2.017c2.053 3.127 3.36 7.802 3.04 10.875a1.84 1.84 0 0 0 1.835 2.033Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M48.666 72.223v-1.4a14.51 14.51 0 0 0-.265-3.68c-1.96-7.457.128-12.46 1.44-16.064a1.84 1.84 0 0 1 3.46 1.259c-4.52 14.32 8 8.424 8.16-3.6-.033-1.508-.018-3.788-.009-5.453.005-.655.008-1.223.008-1.624a1.84 1.84 0 0 1 3.68 0c0 .407 0 .982-.008 1.646-.01 1.644-.024 3.895.008 5.35.203 9.17-5.414 15.379-5.472 22.164v1.4l-11.002.002Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M48.666 72.223v-1.4a14.51 14.51 0 0 0-.265-3.68c-1.96-7.457.128-12.46 1.44-16.064a1.84 1.84 0 0 1 3.46 1.259c-4.52 14.32 8 8.424 8.16-3.6-.033-1.508-.018-3.788-.009-5.453.005-.655.008-1.223.008-1.624a1.84 1.84 0 0 1 3.68 0c0 .407 0 .982-.008 1.646-.01 1.644-.024 3.895.008 5.35.203 9.17-5.414 15.379-5.472 22.164v1.4", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var healthInsuranceCross = {
  render: render$W
};
var render$V = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M30.403 63.782c0 .492 1.013.963 2.815 1.31 1.802.347 4.247.542 6.796.542 2.549 0 4.993-.195 6.795-.542 1.803-.347 2.815-.818 2.815-1.31 0-.49-1.012-.962-2.815-1.31-1.802-.346-4.246-.542-6.795-.542-2.55 0-4.994.196-6.796.543-1.802.347-2.815.818-2.815 1.31Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M35.37 58.763a6.04 6.04 0 0 1-6.033-6.033 1.39 1.39 0 0 1 2.778 0 3.256 3.256 0 0 0 5.556 2.3 3.256 3.256 0 0 0 .953-2.3V28.31a1.39 1.39 0 0 1 2.779 0v24.42a6.04 6.04 0 0 1-6.033 6.033Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.566 34.08c0-2.491-2.525-4.51-5.639-4.51-3.114 0-5.638 2.019-5.638 4.51 0-2.491-2.523-4.51-5.637-4.51-3.114 0-5.639 2.019-5.639 4.51 0-2.491-2.523-4.51-5.637-4.51-3.114 0-5.638 2.019-5.638 4.51 0-2.491-2.524-4.51-5.638-4.51s-5.638 2.019-5.638 4.51v-1.129a22.554 22.554 0 0 1 38.546-16.033 22.551 22.551 0 0 1 6.557 16.033v1.129Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M51.29 34.08s1.6-14.611-11.276-23.68a22.552 22.552 0 0 1 22.552 22.552v1.128M40.014 10.4v24.806", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40.014 34.08V10.4C28.531 18.488 28.56 30.978 28.703 33.584c.023.164.035.329.035.494", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.29 34.08s1.6-14.611-11.276-23.68", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.566 34.08c0-2.491-2.525-4.51-5.639-4.51-3.114 0-5.638 2.019-5.638 4.51 0-2.491-2.523-4.51-5.637-4.51-3.114 0-5.639 2.019-5.639 4.51 0-2.491-2.523-4.51-5.637-4.51-3.114 0-5.638 2.019-5.638 4.51 0-2.491-2.524-4.51-5.638-4.51s-5.638 2.019-5.638 4.51v-1.129a22.554 22.554 0 0 1 38.546-16.033 22.551 22.551 0 0 1 6.557 16.033v1.129Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M49.846 61.167a.942.942 0 0 0 1.065 0C61.68 53.79 63.743 50 63.739 44.947a7.67 7.67 0 0 0-3.2-5.966c-4.956-3.705-8.665 1.577-10.16 3.28-1.05-1.192-5.03-7.113-10.16-3.28a7.67 7.67 0 0 0-3.2 5.966C37.01 50 39.078 53.79 49.846 61.167Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M49.846 61.167a.941.941 0 0 0 1.065 0C61.68 53.79 63.743 50 63.739 44.947a7.67 7.67 0 0 0-3.2-5.966c-4.956-3.705-8.665 1.577-10.16 3.28-1.05-1.192-5.03-7.113-10.16-3.28a7.67 7.67 0 0 0-3.2 5.966C37.01 50 39.078 53.79 49.846 61.167Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var healthInsuranceUmbrella = {
  render: render$V
};
var render$U = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M72 39.92a32 32 0 1 0-61.149 13.2H69.15A31.864 31.864 0 0 0 72 39.92Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M8.8 53.12h62.4M5.2 53.12h2M72.8 53.12h2", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M65.8 14.074a2.144 2.144 0 0 0-.78.15 3.594 3.594 0 0 0-7.1 0 2.14 2.14 0 0 0-2.31.484 2.165 2.165 0 0 0 1.53 3.695h8.66a2.165 2.165 0 0 0 0-4.33Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M50.785 53.191H20.481V23.68a.8.8 0 0 1 .8-.8h28.704a.8.8 0 0 1 .8.8V53.19Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M32.383 44.442h6.494V53.1h-6.494v-8.66Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M50.785 53.191H20.481V23.68a.8.8 0 0 1 .8-.8h28.704a.8.8 0 0 1 .8.8V53.19Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.136 30.37h-4.33v-2.164a2.165 2.165 0 1 1 4.33 0v2.164Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M29.136 30.46h-4.33v-2.165a2.165 2.165 0 1 1 4.33 0v2.166Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M37.795 30.37h-4.33v-2.164a2.165 2.165 0 1 1 4.33 0v2.164Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M37.795 30.46h-4.33v-2.165a2.165 2.165 0 1 1 4.33 0v2.166Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.456 30.37h-4.33v-2.164a2.165 2.165 0 0 1 4.33 0v2.164Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M46.456 30.46h-4.33v-2.165a2.165 2.165 0 0 1 4.33 0v2.166Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.136 37.947h-4.33v-2.165a2.165 2.165 0 1 1 4.33 0v2.165Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M29.136 38.038h-4.33v-2.165a2.165 2.165 0 1 1 4.33 0v2.165Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M37.795 37.947h-4.33v-2.165a2.165 2.165 0 1 1 4.33 0v2.165Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M37.795 38.038h-4.33v-2.165a2.165 2.165 0 1 1 4.33 0v2.165Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.456 37.947h-4.33v-2.165a2.165 2.165 0 0 1 4.33 0v2.165Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M46.456 38.038h-4.33v-2.165a2.165 2.165 0 0 1 4.33 0v2.165Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.136 45.524h-4.33V43.36a2.165 2.165 0 1 1 4.33 0v2.164Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M29.136 45.614h-4.33V43.45a2.165 2.165 0 1 1 4.33 0v2.164Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.136 53.102h-4.33v-2.165a2.165 2.165 0 1 1 4.33 0v2.165Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M29.136 53.191h-4.33v-2.165a2.165 2.165 0 1 1 4.33 0v2.165Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.456 45.524h-4.33V43.36a2.165 2.165 0 0 1 4.33 0v2.164Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M46.456 45.614h-4.33V43.45a2.165 2.165 0 0 1 4.33 0v2.164Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.455 22.88v-2.16a1.082 1.082 0 0 0-1.082-1.082h-3.247a7.04 7.04 0 0 0-12.99 0H25.89a1.082 1.082 0 0 0-1.082 1.082v2.16h21.648Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M46.455 22.88v-2.16a1.082 1.082 0 0 0-1.082-1.082h-3.247a7.04 7.04 0 0 0-12.99 0H25.89a1.082 1.082 0 0 0-1.082 1.082v2.16h21.648ZM32.383 44.532h6.494v8.66h-6.494v-8.66Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M39.96 43.45a1.083 1.083 0 0 1-1.08 1.082h-6.497a1.083 1.083 0 0 1 0-2.165h6.497a1.083 1.083 0 0 1 1.08 1.083Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M35.202 64.058c0 .43 1.71.843 4.756 1.148 3.045.304 7.175.476 11.481.476s8.436-.172 11.481-.476c3.045-.305 4.756-.718 4.756-1.148 0-.431-1.71-.844-4.756-1.149-3.045-.304-7.175-.475-11.481-.475s-8.436.17-11.481.475c-3.045.305-4.756.718-4.756 1.149Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M62.685 43.99a1.938 1.938 0 0 1-3.658 0h-22.85a1.299 1.299 0 0 0-1.297 1.3v15.59a1.3 1.3 0 0 0 1.3 1.3h22.847a1.937 1.937 0 0 1 3.658 0h4.666a1.299 1.299 0 0 0 1.299-1.3V45.29a1.299 1.299 0 0 0-1.299-1.3h-4.666Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M60.856 49.84a.65.65 0 1 0 0 1.299.65.65 0 0 0 0-1.299ZM60.856 52.434a.65.65 0 1 0 0 1.298.65.65 0 0 0 0-1.298ZM60.856 55.031a.65.65 0 1 0 0 1.3.65.65 0 0 0 0-1.3ZM60.856 57.63a.65.65 0 1 0 0 1.298.65.65 0 0 0 0-1.298Z", "fill": "#260347" } }), _c("path", { attrs: { "d": "M38.126 58.28h5.845M51.764 58.28h4.546M38.126 51.784h5.845M38.126 54.382h12.34", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M67.351 43.9h-4.666a1.938 1.938 0 0 1-3.658 0h-22.85a1.299 1.299 0 0 0-1.297 1.3v2.598h33.77V45.2a1.298 1.298 0 0 0-1.299-1.3Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.685 43.99a1.938 1.938 0 0 1-3.658 0h-22.85a1.299 1.299 0 0 0-1.297 1.3v15.59a1.3 1.3 0 0 0 1.3 1.3h22.847a1.937 1.937 0 0 1 3.658 0h4.666a1.299 1.299 0 0 0 1.299-1.3V45.29a1.299 1.299 0 0 0-1.299-1.3h-4.666Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M14.193 39.66h-1.082l-1.083 13.531h3.247l-1.082-13.53Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M13.622 39.806c.814-1.566 3.12-1.976 5.159-.918 2.038 1.058 3.024 3.186 2.21 4.751l-7.369-3.834ZM13.621 39.806c-.85-1.546-3.17-1.902-5.179-.796-2.008 1.107-2.948 3.256-2.097 4.8l7.276-4.005Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M13.622 39.806c-1.704-.552-2.504-2.793-1.788-5.008.716-2.214 2.677-3.562 4.38-3.012l-2.592 8.02Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var hotelTicket = {
  render: render$U
};
var render$T = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M40 72.4c17.894 0 32.4-14.506 32.4-32.4S57.894 7.6 40 7.6 7.6 22.106 7.6 40 22.106 72.4 40 72.4Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "m16.96 49.536-.89-2.7a.694.694 0 0 1 .41-.866l6.2-2.378 3.271-.458a.695.695 0 0 1 .756.47l.725 2.197a.695.695 0 0 1-.327.828l-2.901 1.58-6.396 1.778a.695.695 0 0 1-.848-.451ZM50.272 49.834l-.97-4.052a.693.693 0 0 0-.838-.514l-16.886 4.047a.696.696 0 0 0-.514.838l-.675.16a.693.693 0 0 0-.514.837l.81 3.378a.695.695 0 0 0 .837.513l.675-.162 1.62 6.755a.69.69 0 0 0 .566.524c.09.014.182.01.27-.01L51.54 58.1a.696.696 0 0 0 .513-.837l-.647-2.702.674-.16a.69.69 0 0 0 .524-.567.694.694 0 0 0-.01-.271l-.81-3.377a.695.695 0 0 0-.837-.514l-.675.163ZM25.685 35.288a.695.695 0 0 0-.309-.932l-4.965-2.495a.697.697 0 0 0-.932.309l-.157.311h-3.454a.695.695 0 0 0-.695.695v5.556a.695.695 0 0 0 .695.695H20l2.259 1.135a.692.692 0 0 0 .932-.309l2.494-4.965Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M21.077 32.134h-4.862a.694.694 0 0 0-.694.694v4.863c0 .383.31.694.694.694h4.862c.384 0 .695-.31.695-.694v-4.863a.694.694 0 0 0-.695-.694Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m17.209 36.106 2.095-4.387a.695.695 0 0 1 .926-.328l4.387 2.096a.695.695 0 0 1 .328.926L22.85 38.8a.695.695 0 0 1-.927.328l-4.386-2.095a.694.694 0 0 1-.328-.927Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m58.665 48.564-1.01 2.812a2.616 2.616 0 0 0 4.92 1.768l1.01-2.813a2.614 2.614 0 0 0-4.92-1.767ZM47.988 43.414H32.012a2.082 2.082 0 0 1-2.083-2.084V36.47H50.07v4.861a2.083 2.083 0 0 1-2.083 2.084ZM58.407 26.744c0-.594-4.944-1.1-11.894-1.299l-.01-.09H33.497l-.01.09c-6.95.2-11.893.705-11.893 1.3 0 .585 4.8 1.085 11.588 1.29l-.109.925a2.926 2.926 0 0 0 2.905 3.266h8.045a2.921 2.921 0 0 0 2.79-2.046c.123-.394.162-.81.114-1.22l-.109-.927c6.789-.203 11.589-.703 11.589-1.289Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M48.335 41.678h-16.67a1.39 1.39 0 0 1-1.39-1.39v-6.25a.692.692 0 0 1 .695-.695h18.06a.693.693 0 0 1 .694.694v6.251a1.39 1.39 0 0 1-1.39 1.39Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M48.335 41.678h-16.67a1.39 1.39 0 0 1-1.39-1.39v-6.25a.692.692 0 0 1 .695-.695h18.06a.693.693 0 0 1 .694.694v6.251a1.39 1.39 0 0 1-1.39 1.39ZM32.36 39.594h1.389M32.36 37.51h1.389M32.36 35.426h1.389M35.138 37.51h1.39M35.138 35.426h1.39M37.916 37.51h1.39M37.916 35.426h1.39M40.694 37.51h1.39M40.694 35.426h1.39M43.473 37.51h1.389M43.473 35.426h1.389M46.251 39.594h1.39M46.251 37.51h1.39M46.251 35.426h1.39M35.138 39.594h9.724", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M65.674 13.2H14.326a2.46 2.46 0 0 0-2.456 2.293c-.028.412.047.825.22 1.2h55.82a2.464 2.464 0 0 0-2.236-3.493Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M65.674 13.2H14.326a2.46 2.46 0 0 0-2.456 2.293c-.028.412.047.825.22 1.2h55.82a2.464 2.464 0 0 0-2.236-3.493Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M43.086 18.757h-6.172a2.778 2.778 0 0 0-2.76 2.453l-.735 6.252a2.778 2.778 0 0 0 2.76 3.102h7.644a2.778 2.778 0 0 0 2.76-3.102l-.736-6.252a2.78 2.78 0 0 0-2.76-2.453Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M43.086 18.757h-6.172a2.778 2.778 0 0 0-2.76 2.453l-.735 6.252a2.778 2.778 0 0 0 2.76 3.102h7.644a2.778 2.778 0 0 0 2.76-3.102l-.736-6.252a2.78 2.78 0 0 0-2.76-2.453Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M66.72 14.59H13.28a1.39 1.39 0 0 0-1.191 2.103l4.383 7.303a2.084 2.084 0 0 0 1.787 1.012H61.74a2.082 2.082 0 0 0 1.787-1.012l4.382-7.303a1.39 1.39 0 0 0-1.19-2.104Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M66.72 14.59H13.28a1.39 1.39 0 0 0-1.191 2.103l4.383 7.303a2.084 2.084 0 0 0 1.787 1.012H61.74a2.082 2.082 0 0 0 1.787-1.012l4.382-7.303a1.39 1.39 0 0 0-1.19-2.104Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m15.829 22.924.643 1.073a2.083 2.083 0 0 0 1.787 1.011H61.74a2.084 2.084 0 0 0 1.787-1.011l.643-1.073H15.829Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m15.829 22.924.643 1.073a2.083 2.083 0 0 0 1.787 1.011H61.74a2.085 2.085 0 0 0 1.787-1.011l.643-1.073H15.829Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M61.555 46.5a2.43 2.43 0 0 0-3.11 1.466l-.94 2.614a2.439 2.439 0 0 0 .058 1.886 2.435 2.435 0 0 0 2.34 1.416 2.433 2.433 0 0 0 2.177-1.658l.94-2.614a2.43 2.43 0 0 0-1.465-3.11Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M61.555 46.5a2.43 2.43 0 0 0-3.11 1.466l-.94 2.614a2.439 2.439 0 0 0 .058 1.886 2.435 2.435 0 0 0 2.34 1.416 2.433 2.433 0 0 0 2.177-1.658l.94-2.614a2.43 2.43 0 0 0-1.465-3.11Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M60.85 48.113a.349.349 0 1 0-.001.698.349.349 0 0 0 .001-.698Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "m51.484 63.564.39.966a.697.697 0 0 1-.383.904l-8.2 3.314a.346.346 0 0 1-.452-.192l-.023-.056-.49.195a1.382 1.382 0 0 1-.862 1.09c-.52.204-1.583-.172-2.12-.392a.348.348 0 0 1-.192-.193.344.344 0 0 1 .009-.273c.245-.526.768-1.524 1.29-1.729a1.385 1.385 0 0 1 1.362.206l.483-.192-.108-.266a.346.346 0 0 1 .192-.452l8.2-3.314a.696.696 0 0 1 .904.384Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m31.444 48.786 6.755-1.62a.694.694 0 0 1 .837.514l2.59 10.807a.695.695 0 0 1-.513.838l-6.755 1.619a.696.696 0 0 1-.837-.514l-2.59-10.807a.695.695 0 0 1 .513-.837ZM47.654 44.9 40.9 46.52a.694.694 0 0 0-.514.837l2.59 10.807c.09.373.465.603.838.514l6.754-1.62a.694.694 0 0 0 .513-.837l-2.59-10.807a.694.694 0 0 0-.837-.513Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m38.522 48.518 2.702-.648M38.846 49.869l2.701-.648M39.17 51.22l2.701-.648M39.493 52.57l2.702-.647M39.817 53.922l2.702-.648M40.14 55.272l2.702-.647M40.464 56.623l2.702-.647M40.789 57.974l2.701-.648", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m31.416 51.65-1.351.324-.324-1.351a.696.696 0 0 1 .513-.838l.676-.16.486 2.025Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m31.901 53.676-.675.162a.695.695 0 0 1-.837-.514l-.324-1.35 1.35-.324.486 2.026ZM51.3 51.17l-1.351.323-.486-2.026.675-.162a.694.694 0 0 1 .838.513l.324 1.351Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.623 52.52a.694.694 0 0 1-.514.837l-.675.162-.485-2.026 1.35-.324.324 1.35Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M35.388 50.34a.347.347 0 0 1-.257.42l-2.027.485a.343.343 0 0 1-.262-.042.35.35 0 0 1-.157-.215l-.162-.675a.348.348 0 0 1 .257-.419l2.027-.486a.351.351 0 0 1 .262.042.344.344 0 0 1 .156.215l.163.676ZM38.115 55.758l-2.702.648a.694.694 0 0 0-.514.837l.324 1.35c.09.374.464.604.837.514l2.702-.648a.694.694 0 0 0 .514-.837l-.324-1.35a.695.695 0 0 0-.837-.514ZM34.441 52.353l3.378-.81M33.414 54.028l4.728-1.134M33.738 55.378l4.728-1.133M44.924 48.412a1.39 1.39 0 0 0 2.536.402 1.391 1.391 0 0 0-.703-2.029 1.39 1.39 0 0 0-1.833 1.627ZM44.517 55.652a1.39 1.39 0 0 0 2.535.402 1.391 1.391 0 0 0-.702-2.029 1.39 1.39 0 0 0-1.833 1.627Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m44.924 48.412-.675.162 1.295 5.403M45.059 51.95l1.35-.323M48.517 51.48a.349.349 0 0 1-.257.419l-1.35.323a.344.344 0 0 1-.363-.133.343.343 0 0 1-.056-.123l-.163-.676a.347.347 0 0 1 .257-.419l1.352-.324a.347.347 0 0 1 .418.257l.162.676Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m24.12 47.3-1.177-3.96-5.936 2.093a.695.695 0 0 0-.435.853l.603 2.026a.695.695 0 0 0 .83.477l6.115-1.488Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m27.09 45.1-.456-1.536a.695.695 0 0 0-.73-.494l-2.96.272 1.177 3.96 2.628-1.39a.694.694 0 0 0 .341-.812Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m24.12 47.3-1.177-3.96-5.936 2.093a.695.695 0 0 0-.435.853l.603 2.026a.695.695 0 0 0 .83.477l6.115-1.488ZM27.09 45.1l-.456-1.536a.695.695 0 0 0-.73-.494l-2.96.272 1.177 3.96 2.628-1.39a.694.694 0 0 0 .341-.812ZM18.212 46.922l2.663-.791", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m49.935 62.917-7.768 3.026a.694.694 0 0 0-.395.899l.252.648c.14.357.542.534.9.395l7.768-3.026a.695.695 0 0 0 .395-.9l-.253-.647a.694.694 0 0 0-.899-.395Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m47.322 63.934.755 1.942M49.911 62.927a1.395 1.395 0 0 0-.736-.769 1.39 1.39 0 0 0-1.064-.022l-2.589 1.008", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M41.28 68.52a1.044 1.044 0 0 0 .593-1.349 1.04 1.04 0 0 0-1.349-.593c-.536.209-1.24 1.6-1.24 1.6s1.46.552 1.996.342Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M41.28 68.52a1.044 1.044 0 0 0 .593-1.349 1.04 1.04 0 0 0-1.349-.593c-.536.209-1.24 1.6-1.24 1.6s1.46.552 1.996.342ZM49.935 62.917l-7.768 3.026a.694.694 0 0 0-.395.899l.252.648c.14.357.542.534.9.395l7.768-3.026a.695.695 0 0 0 .395-.9l-.253-.647a.694.694 0 0 0-.899-.395Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m59.69 31.236-4.16 9.03a.662.662 0 0 0 .325.879l4.816 2.219a.663.663 0 0 0 .879-.325l4.16-9.03a.663.663 0 0 0-.324-.88l-4.816-2.218a.663.663 0 0 0-.88.325Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m59.519 30.735-3.85 8.357a.4.4 0 0 0 .195.531l4.573 2.107a.4.4 0 0 0 .53-.196l3.851-8.358a.4.4 0 0 0-.196-.53l-4.572-2.107a.4.4 0 0 0-.531.196Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m58.989 31.885-2.79 6.056 5.298 2.442 2.79-6.056-5.298-2.442Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m56.722 36.806 7.187-2.653-4.92-2.267-2.267 4.92Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m58.989 31.885-2.79 6.056 5.298 2.442 2.79-6.056-5.298-2.442Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var imacWorkspace = {
  render: render$T
};
var render$S = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M72 40A31.997 31.997 0 0 0 47.397 8.863 32 32 0 0 0 10.851 53.2H69.15A31.874 31.874 0 0 0 72 40Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M8.8 53.2h62.4M5.2 53.2h2M72.8 53.2h2", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.886 34.583A12.604 12.604 0 0 0 40.4 47.2h4.8v6h15.6v-6h3.746a.791.791 0 0 0 .8-.827 12.599 12.599 0 0 0-12.46-11.79Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M52.886 34.583A12.604 12.604 0 0 0 40.4 47.2h4.8v6h15.6v-6h3.746a.791.791 0 0 0 .8-.827 12.599 12.599 0 0 0-12.46-11.79Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M56.8 45.2A1.48 1.48 0 0 0 56 44a1.3 1.3 0 0 0 0-2.4L52.8 40l-3.2 1.6a1.3 1.3 0 0 0 0 2.4 1.3 1.3 0 0 0 0 2.4 1.3 1.3 0 0 0 0 2.4 1.3 1.3 0 0 0 0 2.4 1.481 1.481 0 0 0-.8 1.2.783.783 0 0 0 .8.8H56a.783.783 0 0 0 .8-.8 1.48 1.48 0 0 0-.8-1.2 1.3 1.3 0 0 0 0-2.4 1.3 1.3 0 0 0 0-2.4 1.48 1.48 0 0 0 .8-1.2Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M54 40h-2.4v13.2H54V40Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M60.8 47.2v-1.6", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.8 35.187V40l-3.186 1.588-.64.324a.802.802 0 0 1-1.15-.593l-.493-3.215a3.614 3.614 0 0 1 1.688-3.698c.13-.078.27-.139.415-.182.462-.115.944.78 1.434.72l1.932.242ZM58.271 38.112l-.491 3.206a.8.8 0 0 1-1.15.594l-.64-.324L52.8 40v-4.813l1.935-.24c.49.057.972-.838 1.435-.72.158.047.31.115.45.202a3.627 3.627 0 0 1 1.651 3.683Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M45.2 47.2v-1.6", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M45.2 47.2h-4v6h4v-6ZM64.8 47.2h-4v6h4v-6Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M41.094 67.586c7.42 0 13.435-.593 13.435-1.324 0-.73-6.015-1.323-13.435-1.323-7.42 0-13.436.593-13.436 1.323 0 .731 6.016 1.324 13.436 1.324Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m55.7 36.502-2.889 3.021-2.888-3.02V32.8H55.7v3.702Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m55.7 36.502-2.889 3.021-2.888-3.02V32.8H55.7v3.702Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M60.96 24v-2a8 8 0 0 0-16 0v2a1.6 1.6 0 1 0 0 3.2c.034 0 .065-.008.099-.01a7.99 7.99 0 0 0 15.803 0c.033 0 .064.01.098.01a1.6 1.6 0 0 0 0-3.2Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M58.674 27.218a.96.96 0 1 1-1.921-.001.96.96 0 0 1 1.921 0ZM49.047 27.218a.96.96 0 1 1-1.92 0 .96.96 0 0 1 1.92 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M57.23 24.65a1.303 1.303 0 0 0-2.406 0M50.974 24.65a1.305 1.305 0 0 0-2.408 0M50.491 29.12a3.489 3.489 0 0 0 4.815 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M54.217 10.4a10.515 10.515 0 0 0-5.94 1.828 6.4 6.4 0 0 0-5.84 6.372v14.223a3.781 3.781 0 0 0 3.52 3.776 3.551 3.551 0 0 0 2.283-.76.473.473 0 0 0-.293-.84 1.613 1.613 0 0 1-1.51-1.611v-11.84a1.6 1.6 0 0 1 .83-1.398A8.9 8.9 0 0 0 50.8 16.8a12 12 0 0 0 7.065 4.423A1.619 1.619 0 0 1 59.2 22.8v10.587a1.615 1.615 0 0 1-1.51 1.61.474.474 0 0 0-.292.842c.648.51 1.455.78 2.28.76a3.782 3.782 0 0 0 3.52-3.776V18.6c.002-4.529-4.452-8.2-8.981-8.2Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M54.217 10.4a10.515 10.515 0 0 0-5.94 1.828 6.4 6.4 0 0 0-5.84 6.372v14.223a3.781 3.781 0 0 0 3.52 3.776 3.551 3.551 0 0 0 2.283-.76.473.473 0 0 0-.293-.84 1.613 1.613 0 0 1-1.51-1.611v-11.84a1.6 1.6 0 0 1 .83-1.398A8.9 8.9 0 0 0 50.8 16.8a12 12 0 0 0 7.065 4.423A1.619 1.619 0 0 1 59.2 22.8v10.587a1.615 1.615 0 0 1-1.51 1.61.474.474 0 0 0-.292.842c.648.51 1.455.78 2.28.76a3.782 3.782 0 0 0 3.52-3.776V18.6c.002-4.529-4.452-8.2-8.981-8.2Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.914 63.92a1.324 1.324 0 0 1-1.324 1.323H32.95l-3.528-1.323 3.528-1.323h17.64a1.318 1.318 0 0 1 1.223.816c.067.16.1.333.1.507Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M51.914 63.92a1.324 1.324 0 0 1-1.324 1.323H32.95l-3.528-1.323 3.528-1.323h17.64a1.318 1.318 0 0 1 1.223.816c.067.16.1.333.1.507Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M47.503 62.598H32.95v2.645h14.553v-2.645Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M47.503 62.598H32.95v2.645h14.553v-2.645Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M49.267 62.598h-1.764v2.645h1.764v-2.645Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M49.267 62.598h-1.764v2.645h1.764v-2.645Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.914 63.92a1.318 1.318 0 0 1-.817 1.223c-.16.066-.333.1-.507.1h-1.323v-2.645h1.323a1.319 1.319 0 0 1 1.324 1.322Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M51.914 63.92a1.318 1.318 0 0 1-.817 1.223c-.16.066-.333.1-.507.1h-1.323v-2.645h1.323a1.319 1.319 0 0 1 1.324 1.322ZM28.54 63.92h1.764", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m28.13 49.04-3.864-3.66a3.228 3.228 0 0 0-.931-.574l-4.47-1.787c-.547-.533-.593.28-1.127.829-.533.548-2.014 2.876-1.466 3.41l4.853 4.598.06 1.22a1.384 1.384 0 1 0 2.766-.107 1.384 1.384 0 0 0 1.935-1.6l-.221-.85.532.503a1.385 1.385 0 1 0 1.933-1.984v.002Z", "fill": "#F5F2F7", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m22.762 50.362.442 1.707a1.387 1.387 0 0 0 1.691 1.006 1.385 1.385 0 0 0 .99-1.7M23.38 48.358l2.817 2.67M20.595 46.375l-1.164-.493", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m17.925 62-7.19-1.478v-.012c-.204-9.04.228-18.693 12.428-23.353l.695-.268a1.385 1.385 0 1 1 .996 2.585l-.695.268c-3.075 1.184-5.28 2.695-6.253 5.828-1.514 4.72 1.327 3.328 2.172 1.704l1.944-3.406a1.385 1.385 0 1 1 2.422 1.342c-2.48 6.927-2.16 8.352-4.169 10.53-1.496 1.627-1.677 2.989-2.35 6.26Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m17.925 62-7.19-1.478v-.012c-.204-9.04.228-18.693 12.428-23.353l.695-.268a1.385 1.385 0 1 1 .996 2.585l-.695.268c-3.075 1.184-5.28 2.695-6.253 5.828-1.514 4.72 1.327 3.328 2.172 1.704l1.944-3.406a1.385 1.385 0 1 1 2.422 1.342c-2.48 6.927-2.16 8.352-4.169 10.53-1.496 1.627-1.677 2.989-2.35 6.26Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m40.103 29.617-17.932 1.131a1.6 1.6 0 0 0-1.496 1.698l1.52 24.094a1.6 1.6 0 0 0 1.697 1.496l17.932-1.131a1.6 1.6 0 0 0 1.497-1.698L41.8 31.113a1.6 1.6 0 0 0-1.698-1.496Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m38.686 54.894-14.33.904-1.392-22.088a.8.8 0 0 1 .748-.85l15.128-.954a.8.8 0 0 1 .849.748l1.242 19.693a2.4 2.4 0 0 1-2.245 2.547Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M32.843 29.191a1.764 1.764 0 0 0-3.52.223l-1.76.11a1.761 1.761 0 0 0-1.65 1.872l.055.88a.88.88 0 0 0 .936.825l8.8-.556a.879.879 0 0 0 .825-.935l-.055-.88a1.761 1.761 0 0 0-1.871-1.649l-1.76.11Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M32.843 29.191a1.764 1.764 0 0 0-3.52.223l-1.76.11a1.761 1.761 0 0 0-1.65 1.872l.055.88a.88.88 0 0 0 .936.825l8.8-.556a.879.879 0 0 0 .825-.935l-.055-.88a1.761 1.761 0 0 0-1.871-1.649l-1.76.11ZM26.002 46.856l11.884-.75M25.392 37.173l3.96-.25M25.53 39.374l3.962-.25M25.67 41.574l3.96-.25M26.142 49.057l11.883-.75", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M37.246 34.658 31.801 35a.8.8 0 0 0-.748.849l.399 6.325a.8.8 0 0 0 .849.748l5.445-.343a.8.8 0 0 0 .748-.85l-.4-6.324a.8.8 0 0 0-.848-.748Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M33.591 38.265a1.15 1.15 0 0 0 2.289-.145l-.034-.533a1.15 1.15 0 0 0-2.288.143l.033.535ZM32.325 42.48l-.009-.14a2.68 2.68 0 0 1 5.34-.338l.01.141-5.341.337Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M24.357 55.798a2.647 2.647 0 0 1-2.807-2.475l13.318-.843a.908.908 0 0 1 .904.648 2.648 2.648 0 0 0 2.669 1.778l-14.084.892Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M17.794 48.694c.58.43 1.784-.452 2.287-1.416l1.943-3.407a1.385 1.385 0 1 1 2.422 1.343c-2.48 6.926-2.16 8.352-4.168 10.528-1.5 1.625-1.68 2.987-2.353 6.261l-3.513-.72", "fill": "#fff" } }), _c("path", { attrs: { "d": "M17.794 48.694c.58.43 1.784-.452 2.287-1.416l1.943-3.407a1.385 1.385 0 1 1 2.422 1.343c-2.48 6.926-2.16 8.352-4.168 10.528-1.5 1.625-1.68 2.987-2.353 6.261l-3.513-.72", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m8.8 60.94-.654 3.182 10.513 2.16.654-3.181a.799.799 0 0 0-.623-.945L9.742 60.32a.8.8 0 0 0-.942.62Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m18.657 66.282.653-3.18a.801.801 0 0 0-.623-.945L9.742 60.32a.8.8 0 0 0-.944.622l-.654 3.181", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m9.637 60.297.257-1.251a.8.8 0 0 1 .944-.623l7.59 1.56a.799.799 0 0 1 .622.944l-.257 1.251-9.156-1.881Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var interview = {
  render: render$S
};
var render$R = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M31.184 65.835c0 .351.93.688 2.583.936 1.654.248 3.898.387 6.237.387 2.34 0 4.583-.139 6.237-.387s2.583-.585 2.583-.936c0-.35-.93-.687-2.583-.935-1.654-.249-3.898-.388-6.237-.388-2.34 0-4.582.14-6.237.388-1.654.248-2.583.584-2.583.935Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M22.82 57.903a1.106 1.106 0 0 0 1.106 1.106H56a1.107 1.107 0 0 0 1.106-1.106V21.958l-9.4-9.398h-23.78a1.107 1.107 0 0 0-1.105 1.106v44.236Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M57.106 21.958h-8.368a1.033 1.033 0 0 1-1.032-1.033V12.56l9.4 9.398Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.887 39.249h6.9M40.531 45.272h11.255M28.14 51.295h23.646", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M41.607 34.598a5.799 5.799 0 0 0-5.42-5.768v-5.355a3.11 3.11 0 0 1 1.91 1.445 1.547 1.547 0 1 0 2.678-1.551 6.215 6.215 0 0 0-4.588-3.04v-.83a1.549 1.549 0 0 0-3.096 0v.815a5.78 5.78 0 0 0 0 11.535v5.46a2.305 2.305 0 0 1-1.86-.931 1.55 1.55 0 0 0-2.48 1.86 5.45 5.45 0 0 0 4.337 2.168v1.141a1.55 1.55 0 1 0 3.097 0v-1.18a5.799 5.799 0 0 0 5.422-5.769Zm-10.84-8.518a2.707 2.707 0 0 1 2.32-2.671v5.342a2.707 2.707 0 0 1-2.32-2.671Zm5.42 11.188v-5.34a2.697 2.697 0 0 1 0 5.341v-.001Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var invoice = {
  render: render$R
};
var render$Q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M61.327 61.494a1.234 1.234 0 0 1-1.447.974l-30.977-6.05a1.231 1.231 0 0 1-.974-1.447l8.036-41.14a1.233 1.233 0 0 1 1.446-.973l30.977 6.049a1.233 1.233 0 0 1 .972 1.446l-8.033 41.14Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": "1.25", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M58.811 63.575a1.233 1.233 0 0 1-1.59.72L27.71 53.104a1.235 1.235 0 0 1-.72-1.59l14.857-39.2a1.23 1.23 0 0 1 1.594-.714l29.512 11.188a1.232 1.232 0 0 1 .716 1.59L58.81 63.575Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": "1.25", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M67.247 28.8a1.234 1.234 0 0 1-1.59.715l-21.213-8.04a1.233 1.233 0 0 1-.716-1.59l.7-1.844a1.233 1.233 0 0 1 1.59-.716l21.212 8.042a1.232 1.232 0 0 1 .72 1.59l-.703 1.843Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": "1.25", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m65.238 34.103-.525 1.384M62.472 33.056l-.525 1.383M59.705 32.007l-.525 1.383M56.939 30.958l-.525 1.384M63.664 38.255l-.523 1.383M60.899 37.206l-.524 1.383", "stroke": "#481D72", "stroke-width": "1.25", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m58.13 36.157-.523 1.383M62.092 42.404l-.524 1.384M59.325 41.355 58.8 42.74M56.558 40.307l-.523 1.384M53.792 39.259l-.524 1.383M41.195 26.573l11.068 4.195M39.623 30.724l8.3 3.145M38.05 34.874l9.684 3.67M60.519 46.555l-.525 1.383M57.751 45.506l-.524 1.384M54.986 44.457l-.525 1.383M52.218 43.408l-.525 1.384M49.453 42.36l-.525 1.384M36.477 39.023l5.533 2.098M58.946 50.705l-.524 1.384M56.178 49.656l-.524 1.384M34.902 43.174l13.835 5.245M44.9 56.456a2.219 2.219 0 1 1 2.86-1.288M56.325 57.622a2.22 2.22 0 0 1-2.862 1.29M47.5 55.86a2.218 2.218 0 0 1 2.862-1.29M50.96 57.17a2.22 2.22 0 0 1 2.862-1.289", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M35.739 47.45 17.744 52.68a2.466 2.466 0 0 1-3.057-1.68l-7.71-26.517a2.466 2.466 0 0 1 1.68-3.057l17.995-5.232a2.466 2.466 0 0 1 3.056 1.68l7.71 26.518a2.466 2.466 0 0 1-1.68 3.056Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M35.739 47.45 17.744 52.68a2.466 2.466 0 0 1-3.057-1.68l-7.71-26.517a2.466 2.466 0 0 1 1.68-3.057l17.995-5.232a2.466 2.466 0 0 1 3.056 1.68l7.71 26.518a2.466 2.466 0 0 1-1.68 3.056Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m33.256 45.09-14.68 4.27a1.232 1.232 0 0 1-1.528-.839l-4.269-14.68a1.234 1.234 0 0 1 .84-1.529l14.68-4.268a1.232 1.232 0 0 1 1.527.84l4.27 14.68a1.232 1.232 0 0 1-.84 1.525Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m16.697 31.415 4.957 17.047M20.959 30.177l4.958 17.047M25.22 28.936l4.96 17.047M13.674 36.916l17.047-4.957M14.912 41.178l17.049-4.957M16.152 45.44l12.786-3.717", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m27.473 25.2-14.68 4.27a1.233 1.233 0 0 1-1.528-.84l-.96-3.315a1.232 1.232 0 0 1 .84-1.528L25.82 19.52a1.236 1.236 0 0 1 1.529.84l.96 3.316a1.231 1.231 0 0 1-.836 1.524Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m27.473 25.2-14.68 4.27a1.233 1.233 0 0 1-1.528-.84l-.96-3.315a1.232 1.232 0 0 1 .84-1.528L25.82 19.52a1.236 1.236 0 0 1 1.529.84l.96 3.316a1.231 1.231 0 0 1-.836 1.524Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M41.402 68.655a1.483 1.483 0 0 1-1.616-.298 1.48 1.48 0 0 1-.328-.476l-.585-1.36a1.478 1.478 0 0 1 .773-1.943l20.608-8.88a1.233 1.233 0 0 1 1.62.645l.78 1.812a1.23 1.23 0 0 1-.645 1.62l-20.607 8.88Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m46.44 61.651 1.756 4.076M39.646 64.58a2.96 2.96 0 0 1 1.546-3.89l8.153-3.511", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M65.193 58.435a2.221 2.221 0 0 1-1.756-4.08c1.125-.484 4.275.576 4.275.576s-1.392 3.02-2.52 3.505Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M65.193 58.435a2.221 2.221 0 0 1-1.756-4.08c1.125-.484 4.275.576 4.275.576s-1.392 3.02-2.52 3.505Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M41.402 68.655a1.483 1.483 0 0 1-1.616-.298 1.48 1.48 0 0 1-.328-.476l-.585-1.36a1.478 1.478 0 0 1 .773-1.943l20.608-8.88a1.233 1.233 0 0 1 1.62.645l.78 1.812a1.23 1.23 0 0 1-.645 1.62l-20.607 8.88Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var invoiceCalculating = {
  render: render$Q
};
var render$P = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M40 72c17.673 0 32-14.327 32-32C72 22.327 57.673 8 40 8 22.327 8 8 22.327 8 40c0 17.673 14.327 32 32 32Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M48.903 63.76a16.641 16.641 0 0 1 2.937-10.48 2.095 2.095 0 1 1 3.408 2.435 12.345 12.345 0 0 0-2.178 7.63 2.095 2.095 0 1 1-4.169.416l.002-.001Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.993 62.21a16.64 16.64 0 0 1 2.939-10.48 2.094 2.094 0 1 1 3.408 2.436 12.35 12.35 0 0 0-2.18 7.63 2.097 2.097 0 0 1-1.874 2.305 2.093 2.093 0 0 1-2.293-1.89Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M41.286 60.835a16.64 16.64 0 0 1 2.939-10.48 2.096 2.096 0 0 1 3.408 2.436 12.348 12.348 0 0 0-2.18 7.629 2.094 2.094 0 1 1-4.167.417v-.002Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M66.727 60.067c-1.92-6.392-5.306-12.438-10.85-14.807-3.687-1.576-7.752-2-11.47-.495l-2.262.915a2.09 2.09 0 0 0 1.05 4.011c.56-.11.572.164.919 1.127 4.08 6.974 5.323 9.021 8.569 14.16 1.241 1.76 2.8 2.56 3.76 4.154a64.157 64.157 0 0 0 10.284-9.065Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M66.727 60.066c-1.92-6.392-5.306-12.437-10.85-14.806-3.687-1.576-7.752-2-11.47-.495l-2.262.915a2.09 2.09 0 0 0 1.05 4.011c.56-.11.572.164.919 1.127 4.08 6.974 5.323 9.021 8.569 14.16 1.241 1.76 2.8 2.56 3.76 4.154l10.284-9.066Zm-10.347-3.17a13.443 13.443 0 0 1-3.9-2.94c-.511-.556 1.192 1.391-5.033-5.752 10.415-1.817 10.793 9.636 8.933 8.691v.002Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M54.242 16.018H25.269c-.596 0-1.079.482-1.079 1.078v40.032c0 .596.483 1.078 1.079 1.078h28.973c.595 0 1.078-.482 1.078-1.078V17.096c0-.596-.483-1.078-1.078-1.078Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M55.32 23.193v-6.097a1.08 1.08 0 0 0-1.08-1.078H25.269a1.078 1.078 0 0 0-1.079 1.078v6.097h31.13Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M54.242 16.018H25.269c-.596 0-1.079.482-1.079 1.078v40.032c0 .596.483 1.078 1.079 1.078h28.973c.595 0 1.078-.482 1.078-1.078V17.096c0-.596-.483-1.078-1.078-1.078ZM36.166 30.935h5.742M36.166 33.805h12.919M36.166 36.677h9.341M36.166 45.289h7.177M36.166 48.16h3.795M36.166 51.03h3.56", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M28.808 35.424a1.618 1.618 0 1 0 1.618-1.618 1.617 1.617 0 1 1 1.617-1.617M30.426 30.571v-1.078M30.426 38.12V37.04M28.808 49.777a1.619 1.619 0 1 0 1.618-1.617 1.617 1.617 0 1 1 1.617-1.617M30.426 44.924v-1.078M30.426 52.473v-1.078M24.19 23.193h31.13", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.54 64.753c-3.175-5.028-4.425-7.087-8.54-14.122a2.417 2.417 0 0 1-.296-2.337 2.094 2.094 0 0 1 3.44-.432l.298.342c6.253 7.174 4.527 5.2 5.034 5.752a13.445 13.445 0 0 0 3.902 2.94", "fill": "#fff" } }), _c("path", { attrs: { "d": "M52.54 64.753c-3.175-5.028-4.425-7.087-8.54-14.122a2.417 2.417 0 0 1-.296-2.337 2.094 2.094 0 0 1 3.44-.432l.298.342c6.253 7.174 4.527 5.2 5.034 5.752a13.445 13.445 0 0 0 3.902 2.94", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var invoiceHand = {
  render: render$P
};
var render$O = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M40 72c17.673 0 32-14.327 32-32C72 22.327 57.673 8 40 8 22.327 8 8 22.327 8 40c0 17.673 14.327 32 32 32Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M16.232 59.163a4.85 4.85 0 0 0 4.849-4.85v-31.52a4.85 4.85 0 0 1 4.849-4.848h24.245a4.85 4.85 0 0 0-4.85 4.849v31.52a4.849 4.849 0 0 1-4.845 4.85H16.232Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M45.326 22.795a4.85 4.85 0 0 1 5.325-4.826 4.99 4.99 0 0 1 4.373 5.035v2.418a1.01 1.01 0 0 1-1.01 1.01h-8.688v-3.637Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.892 64.315c5.858 0 10.607-.678 10.607-1.515 0-.837-4.749-1.515-10.607-1.515s-10.607.678-10.607 1.515c0 .837 4.749 1.515 10.607 1.515Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M58.587 62.194H45.804a.88.88 0 0 1-.88-.88v-1.247a2.117 2.117 0 0 1 2.116-2.117h10.312a2.117 2.117 0 0 1 2.117 2.117v1.245a.881.881 0 0 1-.882.882Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M16.232 59.163a4.85 4.85 0 0 0 4.849-4.85v-31.52a4.85 4.85 0 0 1 4.849-4.848h24.245a4.85 4.85 0 0 0-4.85 4.849v31.52a4.849 4.849 0 0 1-4.845 4.85H16.232Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M31.385 27.644h10.304m-10.304 4.85h10.304", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m20.137 27.677-1.346 10.776 4.714-2.693 4.715 2.694-1.347-10.777h-6.736Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M31.385 37.342h6.062m-12.73 4.85h10.911m-10.91 4.849h8.485m-8.485 4.849h8.485", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m20.137 27.677-1.346 10.776 4.714-2.693 4.715 2.694-1.347-10.777h-6.736Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M30.913 23.637c0 .913-1.477 1.526-1.807 2.32-.34.822.258 2.297-.363 2.918-.62.621-2.095.022-2.918.363-.794.33-1.407 1.807-2.32 1.807-.914 0-1.527-1.478-2.32-1.807-.823-.341-2.298.257-2.919-.364-.62-.62-.021-2.095-.363-2.918-.329-.794-1.806-1.406-1.806-2.32 0-.914 1.477-1.526 1.806-2.32.342-.823-.257-2.298.364-2.918.62-.621 2.095-.022 2.918-.364.794-.328 1.407-1.806 2.32-1.806.913 0 1.525 1.478 2.32 1.806.823.342 2.297-.256 2.918.364.62.621.022 2.095.363 2.918.334.795 1.807 1.408 1.807 2.32Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M26.873 23.637a3.367 3.367 0 1 1-6.735.002 3.367 3.367 0 0 1 6.735-.002Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M63.106 40.98a1.212 1.212 0 0 1-1.212-1.213c0-1.314-1.666-2.425-3.637-2.425s-4.24 1.11-4.24 2.425a1.212 1.212 0 0 1-2.424 0c0-2.674 3.325-4.85 6.667-4.85 3.342 0 6.06 2.176 6.06 4.85a1.212 1.212 0 0 1-1.214 1.212Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.59 40.98a1.214 1.214 0 0 1-1.213-1.213c0-1.314-2.272-2.425-4.24-2.425-1.968 0-3.637 1.11-3.637 2.425a1.213 1.213 0 0 1-2.425 0c0-2.674 2.72-4.85 6.062-4.85 3.341 0 6.663 2.176 6.663 4.85a1.212 1.212 0 0 1-1.21 1.212Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M50.377 39.16h3.637v16.367h-3.637V39.16Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M50.377 39.16h3.637v16.367h-3.637V39.16Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m52.195 34.917-3.03 3.032a1.213 1.213 0 0 0 1.212 1.212h3.637a1.213 1.213 0 0 0 1.213-1.212l-3.032-3.032Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M58.587 62.194H45.804a.88.88 0 0 1-.88-.88v-1.247a2.117 2.117 0 0 1 2.116-2.117h10.312a2.117 2.117 0 0 1 2.117 2.117v1.245a.881.881 0 0 1-.882.882Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M55.832 57.95H48.56a1.818 1.818 0 1 1 0-3.636h7.272a1.818 1.818 0 1 1 0 3.636Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m63.106 40.98 4.848 7.88h-9.697l4.849-7.88Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.134 48.86a4.85 4.85 0 0 1-9.698 0h9.698Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m36.436 48.86 4.849-7.88 4.85 7.88m-9.699 0h9.698m-9.698 0a4.85 4.85 0 0 0 9.698 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M67.954 48.86a4.849 4.849 0 1 1-9.697 0h9.697Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M67.954 48.86a4.849 4.849 0 1 1-9.697 0h9.697Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var judicialDocument = {
  render: render$O
};
var render$N = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40.067a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M21.483 62.636c0 .278.516.554 1.518.811s2.471.49 4.323.688c1.852.196 4.05.352 6.47.459 2.42.106 5.012.161 7.631.161 2.619 0 5.212-.055 7.631-.161 2.42-.107 4.618-.263 6.47-.46 1.852-.196 3.32-.43 4.323-.687 1.002-.257 1.518-.533 1.518-.811s-.516-.554-1.518-.81c-1.002-.258-2.471-.492-4.323-.688-1.852-.197-4.05-.353-6.47-.46-2.42-.106-5.012-.161-7.631-.161-2.619 0-5.212.055-7.631.161-2.42.107-4.618.263-6.47.46-1.852.196-3.32.43-4.323.687-1.002.257-1.518.533-1.518.811Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m28.468 31.013-5.04-9.66-5.04 9.66", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.188 31.013a.84.84 0 0 1 .807 1.073c-.656 2.268-3.347 3.967-6.567 3.967s-5.911-1.699-6.567-3.967a.84.84 0 0 1 .807-1.073h11.52Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M29.188 31.013a.84.84 0 0 1 .807 1.073c-.656 2.268-3.347 3.967-6.567 3.967s-5.911-1.699-6.567-3.967a.84.84 0 0 1 .807-1.073h11.52ZM50.308 31.013l5.04-9.66 5.04 9.66", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M49.588 31.013a.84.84 0 0 0-.807 1.073c.656 2.268 3.347 3.967 6.567 3.967s5.911-1.699 6.567-3.967a.84.84 0 0 0-.807-1.073h-11.52Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M49.588 31.013a.84.84 0 0 0-.807 1.073c.656 2.268 3.347 3.967 6.567 3.967s5.911-1.699 6.567-3.967a.84.84 0 0 0-.807-1.073h-11.52Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40.06 8.27a.839.839 0 0 0-1.345 0 7.17 7.17 0 0 0-1.427 4.29v1.65h4.2v-1.65a7.17 7.17 0 0 0-1.427-4.29Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M40.06 8.27a.839.839 0 0 0-1.345 0 7.17 7.17 0 0 0-1.427 4.29v1.65h4.2v-1.65a7.17 7.17 0 0 0-1.427-4.29Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m41.908 41.933-1.26-26.04h-2.52l-1.26 26.04h5.04Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m41.908 41.933-1.26-26.04h-2.52l-1.26 26.04h5.04Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m49.7 45.76-1.215-2.431a2.522 2.522 0 0 0-2.255-1.394H32.545a2.522 2.522 0 0 0-2.254 1.394l-1.215 2.431a.839.839 0 0 0 .751 1.215h19.12a.84.84 0 0 0 .751-1.215h.002Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m49.7 45.76-1.215-2.431a2.522 2.522 0 0 0-2.255-1.394H32.545a2.522 2.522 0 0 0-2.254 1.394l-1.215 2.431a.839.839 0 0 0 .751 1.215h19.12a.84.84 0 0 0 .751-1.215h.002Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M58.536 18.32a1.12 1.12 0 0 0-1.487.178l-.115.133a2.464 2.464 0 0 1-.573.486 2.16 2.16 0 0 1-.757.28 4 4 0 0 1-1.92-.344 48.315 48.315 0 0 1-4.417-2.24c-2.328-1.247-5.674-3.44-9.874-3.44s-7.548 2.191-9.875 3.44a48.35 48.35 0 0 1-4.416 2.244 4 4 0 0 1-1.92.345 2.16 2.16 0 0 1-1.09-.527 2.344 2.344 0 0 1-.24-.24l-.115-.133a1.12 1.12 0 0 0-1.753 1.378c.177.254.384.485.616.689.647.573 1.46.927 2.32 1.013a5.872 5.872 0 0 0 2.982-.676 48.483 48.483 0 0 0 4.444-2.678c4.753-3.02 7.37-3.17 9.05-3.17 1.68 0 4.284.142 9.041 3.165a48.48 48.48 0 0 0 4.443 2.679 5.872 5.872 0 0 0 2.982.675 4.113 4.113 0 0 0 2.32-1.013c.232-.204.44-.436.616-.689a1.12 1.12 0 0 0-.262-1.555Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M58.536 18.32a1.12 1.12 0 0 0-1.487.178l-.115.133a2.464 2.464 0 0 1-.573.486 2.16 2.16 0 0 1-.757.28 4 4 0 0 1-1.92-.344 48.315 48.315 0 0 1-4.417-2.24c-2.328-1.247-5.674-3.44-9.874-3.44s-7.548 2.191-9.875 3.44a48.35 48.35 0 0 1-4.416 2.244 4 4 0 0 1-1.92.345 2.16 2.16 0 0 1-1.09-.527 2.344 2.344 0 0 1-.24-.24l-.115-.133a1.12 1.12 0 0 0-1.753 1.378c.177.254.384.485.616.689.647.573 1.46.927 2.32 1.013a5.872 5.872 0 0 0 2.982-.676 48.483 48.483 0 0 0 4.444-2.678c4.753-3.02 7.37-3.17 9.05-3.17 1.68 0 4.284.142 9.041 3.165a48.48 48.48 0 0 0 4.443 2.679 5.872 5.872 0 0 0 2.982.675 4.113 4.113 0 0 0 2.32-1.013c.232-.204.44-.436.616-.689a1.12 1.12 0 0 0-.262-1.555Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M36.868 14.213a2.52 2.52 0 1 0 5.04 0 2.52 2.52 0 0 0-5.04 0Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M19.578 54.618a5.65 5.65 0 0 1 5.65-5.65h36.227a.997.997 0 1 0 0-1.995H25.228a7.646 7.646 0 1 0 0 15.289h36.227a.997.997 0 1 0 0-1.994H25.228a5.65 5.65 0 0 1-5.65-5.65Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M19.578 54.618a5.65 5.65 0 0 1 5.65-5.65h36.227a.997.997 0 1 0 0-1.995H25.228a7.646 7.646 0 1 0 0 15.289h36.227a.997.997 0 1 0 0-1.994H25.228a5.65 5.65 0 0 1-5.65-5.65Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M61.455 48.967a5.65 5.65 0 0 0 0 11.301H25.228a5.65 5.65 0 0 1 0-11.3h36.227Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M61.455 48.967a5.65 5.65 0 0 0 0 11.301H25.228a5.65 5.65 0 0 1 0-11.3h36.227ZM22.237 53.62h30.91M23.898 51.294h30.91M22.237 55.614h30.91M23.898 57.94h30.91", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var lawBook = {
  render: render$N
};
var render$M = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40.62a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M16.806 60.682c0 .426 2.651.834 7.37 1.135 4.72.301 11.12.47 17.795.47 6.675 0 13.076-.169 17.795-.47 4.72-.3 7.37-.709 7.37-1.135 0-.425-2.65-.833-7.37-1.134-4.72-.301-11.12-.47-17.795-.47-6.674 0-13.075.169-17.794.47-4.72.3-7.371.709-7.371 1.134Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M39.909 51.717h-21.76a4.44 4.44 0 0 1 0-8.88h21.76v8.88Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M39.909 51.717h-21.76a4.44 4.44 0 0 1 0-8.88h21.76v8.88Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M24.406 51.718h-2.917a4.44 4.44 0 1 1 0-8.88h2.917a4.44 4.44 0 0 0 0 8.88Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M34.624 44.666a2.465 2.465 0 1 0 0 4.93h21.76a.986.986 0 1 1 0 1.974h-21.76a4.44 4.44 0 0 1 0-8.88h21.76a.986.986 0 1 1 0 1.973l-21.76.003Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M34.624 44.666a2.465 2.465 0 1 0 0 4.93h21.76a.986.986 0 1 1 0 1.974h-21.76a4.44 4.44 0 0 1 0-8.88h21.76a.986.986 0 1 1 0 1.973l-21.76.003Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M56.385 49.6v-4.934h-21.76a2.466 2.466 0 0 0 0 4.93l21.76.004Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.72 60.469H24.96a4.44 4.44 0 0 1 0-8.88h21.76v8.88Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M46.72 60.469H24.96a4.44 4.44 0 0 1 0-8.88h21.76v8.88Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M31.213 60.469h-2.918a4.44 4.44 0 0 1 0-8.88h2.918a4.44 4.44 0 0 0 0 8.88Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40.458 53.542a2.466 2.466 0 0 0 0 4.932h21.76a.986.986 0 1 1 0 1.972h-21.76a4.44 4.44 0 0 1 0-8.88h21.76a.986.986 0 1 1 0 1.973l-21.76.003Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M40.458 53.542a2.466 2.466 0 0 0 0 4.932h21.76a.986.986 0 1 1 0 1.972h-21.76a4.44 4.44 0 0 1 0-8.88h21.76a.986.986 0 1 1 0 1.973l-21.76.003Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.219 58.474v-4.931h-21.76a2.466 2.466 0 1 0 0 4.93h21.76Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M42.77 42.693H21.01a4.44 4.44 0 1 1 0-8.88h21.76v8.88Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M42.77 42.693H21.01a4.44 4.44 0 1 1 0-8.88h21.76v8.88Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M36.783 35.789a2.466 2.466 0 0 0 0 4.93h21.76a.986.986 0 0 1 0 1.974h-21.76a4.44 4.44 0 1 1 0-8.88h21.76a.986.986 0 0 1 0 1.972l-21.76.004Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M36.783 35.789a2.466 2.466 0 0 0 0 4.93h21.76a.986.986 0 0 1 0 1.974h-21.76a4.44 4.44 0 1 1 0-8.88h21.76a.986.986 0 0 1 0 1.972l-21.76.004Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M58.545 40.72v-4.931h-21.76a2.466 2.466 0 0 0 0 4.931h21.76ZM27.268 42.693H24.35a4.44 4.44 0 1 1 0-8.88h2.918a4.44 4.44 0 0 0 0 8.88Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.52 33.02a6.265 6.265 0 0 1-5.71.055 6.264 6.264 0 0 1-5.707-.054c-2.976-1.56-4.051-4.026-4.795-9.227-.355-2.49 1.46-4.967 3.532-6.393a6.624 6.624 0 0 1 6.97-.334 6.625 6.625 0 0 1 6.973.334c2.072 1.426 3.886 3.902 3.53 6.393-.734 5.141-1.798 7.657-4.793 9.227Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m38.939 13.986.76.16a6.225 6.225 0 0 0 7.39-4.782l.16-.76a.777.777 0 0 0-.595-.924l-.76-.16a6.223 6.223 0 0 0-7.39 4.78l-.16.762a.78.78 0 0 0 .595.924Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m38.939 13.986.76.16a6.225 6.225 0 0 0 7.39-4.782l.16-.76a.777.777 0 0 0-.595-.924l-.76-.16a6.223 6.223 0 0 0-7.39 4.78l-.16.762a.78.78 0 0 0 .595.924ZM37.259 7.889l1.553 9.317M44.52 33.02a6.265 6.265 0 0 1-5.71.055 6.264 6.264 0 0 1-5.707-.054c-2.976-1.56-4.051-4.026-4.795-9.227-.355-2.49 1.46-4.967 3.532-6.393a6.624 6.624 0 0 1 6.97-.334 6.625 6.625 0 0 1 6.973.334c2.072 1.426 3.886 3.902 3.53 6.393-.734 5.141-1.798 7.657-4.793 9.227Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var learning = {
  render: render$M
};
var render$L = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M71.957 40.92a32 32 0 1 0-61.149 13.2h58.298a31.859 31.859 0 0 0 2.851-13.2Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M8.757 54.12h62.4M5.157 54.12h2M72.757 54.12h2", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.983 40.65a7.759 7.759 0 0 0-6.493 3.51 3.696 3.696 0 0 0-6 2.906c0 .48.234.338-.675.338a4.72 4.72 0 0 0-4.57 3.574c-1.085-1.35-3.537-2.45-3.537-8.978h-2.702c0 6.506-2.453 7.626-3.535 8.978a4.72 4.72 0 0 0-4.57-3.575c-.908 0-.675.146-.675-.337a3.695 3.695 0 0 0-6-2.907A7.76 7.76 0 1 0 12.511 54.16h55.69a7.76 7.76 0 0 0-5.219-13.51Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M62.983 40.65a7.759 7.759 0 0 0-6.493 3.51 3.696 3.696 0 0 0-6 2.906c0 .48.234.338-.675.338a4.72 4.72 0 0 0-4.57 3.574c-1.085-1.35-3.537-2.45-3.537-8.978h-2.702c0 6.506-2.453 7.626-3.535 8.978a4.72 4.72 0 0 0-4.57-3.575c-.908 0-.675.146-.675-.337a3.695 3.695 0 0 0-6-2.907A7.76 7.76 0 1 0 12.511 54.16h55.69a7.76 7.76 0 0 0-5.219-13.51Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M45.76 22.414c1.959 12.407 5.813 10.925 6.065 16.307a.56.56 0 0 1-.56.579H45.76V22.414ZM34.954 22.414c-1.96 12.407-5.812 10.925-6.066 16.306a.56.56 0 0 0 .56.578h5.502l.004-16.884ZM34.954 36.598H45.76V39.3H34.954v-2.702ZM42.49 43.352h-4.265a1.92 1.92 0 0 1-1.92-1.92V39.3h8.105v2.132a1.92 1.92 0 0 1-1.92 1.92Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M26.628 50.107a4.73 4.73 0 0 1 4.273-2.702M22.8 47.067a3.715 3.715 0 0 1 3.714-3.715M54.087 50.107a4.73 4.73 0 0 0-4.274-2.702M57.92 47.067a3.715 3.715 0 0 0-3.714-3.715", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.164 17.686a10.807 10.807 0 1 0-19.884 5.858A25.067 25.067 0 0 1 34.954 36.6H45.76a24.94 24.94 0 0 1 3.674-13.055 10.72 10.72 0 0 0 1.73-5.858Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M51.164 17.686a10.807 10.807 0 1 0-19.884 5.858A25.067 25.067 0 0 1 34.954 36.6H45.76a24.94 24.94 0 0 1 3.674-13.055 10.72 10.72 0 0 0 1.73-5.858ZM45.085 15.66 42.383 36.6M38.331 36.599 35.629 15.66", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m36.32 21.04 1.618-2.16a.56.56 0 0 1 .848-.06l1.17 1.169a.56.56 0 0 0 .8 0l1.169-1.17a.56.56 0 0 1 .848.061l1.619 2.16", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var lightbulbStartup = {
  render: render$L
};
var render$K = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M40 72c17.673 0 32-14.327 32-32C72 22.327 57.673 8 40 8 22.327 8 8 22.327 8 40c0 17.673 14.327 32 32 32Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M66.955 14.102s0-2.954-2.364-2.954H14.37c-2.363 0-2.363 2.954-2.363 2.954h54.949Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M66.86 15.284s-4.136 10.636-4.727 11.817c-.591 1.18-1.182 1.181-1.182 1.181H17.323s-.59 0-1.181-1.181c-.59-1.182-4.136-11.817-4.136-11.817s-.591-1.773 1.181-1.773H65.68c1.771 0 1.18 1.773 1.18 1.773Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-miterlimit": "10" } }), _c("path", { attrs: { "d": "M59.592 28.282H18.778c-1.13 0-2.046.916-2.046 2.046v27.224c0 1.13.916 2.046 2.046 2.046h40.814c1.13 0 2.045-.916 2.045-2.046V30.328c0-1.13-.916-2.046-2.045-2.046Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M55.887 34.782H22.482c-.565 0-1.023.459-1.023 1.024v9.77c0 .565.458 1.023 1.023 1.023h33.405c.565 0 1.023-.458 1.023-1.023v-9.77c0-.565-.458-1.023-1.023-1.023ZM43.48 48.962h-8.59c-.565 0-1.023.458-1.023 1.024v3.862c0 .565.458 1.023 1.023 1.023h8.59c.564 0 1.022-.458 1.022-1.023v-3.862c0-.566-.458-1.024-1.023-1.024ZM22.64 28.282H55.73v3.545H22.64v-3.545Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M23.823 37.146h1.772m2.364 0h1.772m2.364 0h1.772m2.364 0h1.772m2.364 0h1.772m2.364 0h1.772m2.364 0h1.772m2.364 0h1.772m-30.724 2.363h1.772m2.364 0h1.772m2.364 0h1.772m2.364 0h1.772m2.364 0h1.772m2.364 0h1.772m2.364 0h1.772m2.364 0h1.772m-30.724 2.363h1.772m2.364 0h1.772m2.364 0h1.772m2.364 0h1.772m2.364 0h1.772m2.364 0h1.772m2.364 0h1.772m2.364 0h1.772m-30.724 2.364h1.772m2.364 0h1.772m2.364 0h14.18m2.364 0h1.772m2.364 0h1.772M66.86 15.284s-4.136 10.636-4.727 11.817c-.591 1.18-1.182 1.181-1.182 1.181H17.323s-.59 0-1.181-1.181c-.59-1.182-4.136-11.817-4.136-11.817s-.591-1.773 1.181-1.773H65.68c1.771 0 1.18 1.773 1.18 1.773Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M28.99 57.204a1.545 1.545 0 0 0-1.688-1.389c-.38.037-3.22.48-3.555.175-.72-.662-.264-2.537 1.07-3.774l6.933-6.64a1.546 1.546 0 0 0-2.07-2.296l-6.59 6.16 6.633-7.665a1.546 1.546 0 1 0-2.24-2.126l-6.716 7.876 5.473-7.393a1.546 1.546 0 0 0-2.518-1.794l-1.216 1.708a1.542 1.542 0 0 0-2.839-.896L13.84 47.9a26.149 26.149 0 0 0-3.806 7.06l-1.57 1.91 6.864 5.65c1.171-1.424 3.44-1.618 12.273-3.628a1.545 1.545 0 0 0 1.389-1.688Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M15.328 62.52c1.171-1.424 3.44-1.618 12.273-3.628a1.546 1.546 0 1 0-.3-3.077c-.38.037-3.219.48-3.554.175-.72-.662-.264-2.537 1.07-3.774l6.933-6.64a1.546 1.546 0 0 0-2.07-2.296l-6.59 6.16 6.633-7.665a1.546 1.546 0 1 0-2.24-2.126l-6.716 7.876 5.473-7.393a1.546 1.546 0 0 0-2.518-1.794l-1.216 1.708a1.542 1.542 0 0 0-2.839-.896L13.84 47.9a26.149 26.149 0 0 0-3.806 7.06l-1.57 1.91m14.04-16.824-4.093 5.992", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M49.952 57.204a1.545 1.545 0 0 1 1.688-1.389c.38.037 3.219.48 3.554.175.72-.662.264-2.537-1.07-3.774l-6.933-6.64a1.545 1.545 0 0 1 2.07-2.296l6.589 6.16-6.634-7.665a1.545 1.545 0 1 1 2.245-2.126l6.715 7.876-5.473-7.397a1.547 1.547 0 0 1 2.519-1.794l1.215 1.708a1.543 1.543 0 0 1 2.84-.896l5.82 8.75a26.148 26.148 0 0 1 3.81 7.064l1.573 1.91-6.865 5.65c-1.17-1.424-3.44-1.618-12.272-3.628a1.545 1.545 0 0 1-1.392-1.688Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M63.613 62.52c-1.171-1.424-3.44-1.618-12.273-3.628a1.546 1.546 0 1 1 .3-3.077c.38.037 3.219.48 3.554.175.72-.662.264-2.537-1.07-3.774l-6.933-6.64a1.545 1.545 0 0 1 2.07-2.296l6.589 6.16-6.634-7.665a1.545 1.545 0 1 1 2.245-2.126l6.715 7.876-5.473-7.397a1.547 1.547 0 0 1 2.519-1.794l1.215 1.708a1.543 1.543 0 0 1 2.84-.896l5.82 8.75a26.148 26.148 0 0 1 3.81 7.064l1.573 1.91M56.437 40.046l4.093 5.992", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var macbookTyping = {
  render: render$K
};
var render$J = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M1.249 42.626a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "m33.849 60.004-3.384-17.711A3.162 3.162 0 0 0 26.7 39.88l-3.992.874a6.967 6.967 0 0 0-4.701 3.894l-1.57 3.333a3.21 3.21 0 0 1-2.216 1.767l2.59 11.83 4.114-.901c3.03-.664 4.409 1.19 9.708.03l3.215-.704Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m3.625 49.615 5.788-1.52a1.083 1.083 0 0 1 1.291.827l3.136 14.302a1.085 1.085 0 0 1-.828 1.292l-5.788 1.52", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m3.625 49.615 5.788-1.52a1.083 1.083 0 0 1 1.291.827l3.136 14.302a1.085 1.085 0 0 1-.828 1.292l-5.788 1.52", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m13.84 63.224 2.119-.463a1.085 1.085 0 0 0 .827-1.292l-2.672-12.183a1.084 1.084 0 0 0-1.29-.828l-2.12.464 3.136 14.302Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m19.709 24.081 15.528-2.924 2.804 14.893-15.528 2.924-2.805-14.893Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m19.709 24.081 15.528-2.924 2.804 14.893-15.528 2.924-2.805-14.893Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.016 38.353a.974.974 0 0 1-1.365 1.068c-6.474-3.057-11.21-4.923-18.38-4.556l-4.41.225-2.442-12.97 4.19-1.395c6.812-2.265 10.545-5.727 15.465-10.928a.974.974 0 0 1 1.66.497l5.282 28.06Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M62.016 38.353a.974.974 0 0 1-1.365 1.068c-6.474-3.057-11.21-4.923-18.38-4.556l-4.41.225-2.442-12.97 4.19-1.395c6.812-2.265 10.545-5.727 15.465-10.928a.974.974 0 0 1 1.66.497l5.282 28.06Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M19.89 25.04a6.6 6.6 0 0 0 2.442 12.971L19.89 25.04Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M19.89 25.04a6.6 6.6 0 0 0 2.442 12.971L19.89 25.04Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m33.051 41.367-5.12 2.848c.355-1.234-.931-.449-1.775-4.932l8.647-1.628.19 1.011c.08.414-.113.83-1.942 2.7Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m33.051 41.367-5.12 2.848c-1.654-1.134-1.23-2.037-1.775-4.932l8.647-1.628.19 1.011c.08.414-.113.83-1.942 2.7Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m33.067 41.382 2.624 2.595a1.394 1.394 0 0 1-.231 1.833c4.183 10.595-3.593 8.515-4.009 7.911l-3.52-9.506 5.136-2.833ZM25.44 36.458l8.968-1.69a.978.978 0 0 1 1.142.78l.267 1.42a.49.49 0 0 1-.39.571l-9.933 1.869a.487.487 0 0 1-.57-.39l-.268-1.418a.977.977 0 0 1 .784-1.142ZM60.112 28.238l2.944-2.316-.833-4.424-3.585-1.088 1.474 7.828Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M68.014 31.315a.787.787 0 0 1 .952-1.196l6.934 3.236a.786.786 0 0 1 .284 1.2l-2.22 2.805a.785.785 0 0 1-1.235 0l-4.715-6.045ZM64.72 13.713a.787.787 0 0 1-1.2-.951l3.235-6.934a.786.786 0 0 1 1.2-.284l2.808 2.216a.786.786 0 0 1 0 1.236l-6.043 4.717ZM67.187 22.618a.787.787 0 0 1-.172-1.52l10.1-3.672a.785.785 0 0 1 1.05.647l.582 4.99a.786.786 0 0 1-.88.87l-10.68-1.315Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M28.13 46.17a2.106 2.106 0 0 0 2.51 1.606l5.272-1.154a2.106 2.106 0 0 0-.9-4.115l-5.273 1.155a2.103 2.103 0 0 0-1.609 2.508Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m19.238 52.96 1.542-.339a7.177 7.177 0 0 0 5.26-8.444l.755 3.449a2.366 2.366 0 0 0 4.616-1.01l-.96-4.334a3.155 3.155 0 0 0-3.754-2.4l-3.992.875", "fill": "#fff" } }), _c("path", { attrs: { "d": "m30.72 43.44-.252-1.15a3.16 3.16 0 0 0-3.764-2.412l-3.992.874a6.968 6.968 0 0 0-4.7 3.894l-1.57 3.333a3.211 3.211 0 0 1-2.216 1.767l2.59 11.83 4.114-.902c3.03-.663 4.408 1.19 9.708.03l5.522-1.206", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m19.238 52.96 1.542-.339a7.177 7.177 0 0 0 5.26-8.444l.755 3.449a2.366 2.366 0 0 0 4.616-1.01l-.96-4.334a3.155 3.155 0 0 0-3.754-2.4l-3.992.875", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M28.26 49.183c.417.168.875.211 1.316.124a2.56 2.56 0 0 0 1.774-1.69l3.654-.8a2.106 2.106 0 1 1 .9 4.114l-5.271 1.154a2.106 2.106 0 0 1-2.507-1.605 2.08 2.08 0 0 1 .134-1.297ZM29.927 58.707a2.103 2.103 0 0 0 2.507 1.607l3.73-.816a2.104 2.104 0 0 0 1.606-2.508 2.108 2.108 0 0 0-2.508-1.607l-3.728.816a2.106 2.106 0 0 0-1.607 2.508Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M28.31 54.749a2.107 2.107 0 0 0 2.509 1.607l5.27-1.156a2.107 2.107 0 0 0-.9-4.114L29.92 52.24a2.107 2.107 0 0 0-1.61 2.509Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var megaphoneHand = {
  render: render$J
};
var render$I = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M40 71.683c17.498 0 31.683-14.185 31.683-31.683C71.683 22.502 57.498 8.317 40 8.317 22.502 8.317 8.317 22.502 8.317 40c0 17.498 14.185 31.683 31.683 31.683Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M49.334 24.065H22.811c-.875 0-1.584.71-1.584 1.584v24.776c0 .875.71 1.585 1.584 1.585h26.523c.875 0 1.584-.71 1.584-1.585V25.65c0-.875-.71-1.584-1.584-1.584Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M49.334 24.065H22.811c-.875 0-1.584.71-1.584 1.584v24.776c0 .875.71 1.585 1.584 1.585h26.523c.875 0 1.584-.71 1.584-1.585V25.65c0-.875-.71-1.584-1.584-1.584Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M28.65 27.122a1.31 1.31 0 0 1-2.62 0v-6.55a1.31 1.31 0 1 1 2.62 0v6.55Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M28.65 27.122a1.31 1.31 0 0 1-2.62 0v-6.55a1.31 1.31 0 1 1 2.62 0v6.55Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M37.386 27.122a1.31 1.31 0 1 1-2.62 0v-6.55a1.31 1.31 0 0 1 2.62 0v6.55Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M37.386 27.122a1.31 1.31 0 1 1-2.62 0v-6.55a1.31 1.31 0 0 1 2.62 0v6.55Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.115 27.122a1.31 1.31 0 1 1-2.62 0v-6.55a1.31 1.31 0 0 1 2.62 0v6.55Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M46.115 27.122a1.31 1.31 0 1 1-2.62 0v-6.55a1.31 1.31 0 0 1 2.62 0v6.55Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M36.229 60.774c7.958 0 14.409-.782 14.409-1.747 0-.964-6.451-1.746-14.409-1.746-7.958 0-14.409.782-14.409 1.746 0 .965 6.451 1.747 14.409 1.747Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M66.5 53.149c1.064-6.553-3.386-12.727-9.94-13.79-6.553-1.064-12.727 3.386-13.79 9.94-1.064 6.552 3.387 12.727 9.94 13.79 6.553 1.063 12.727-3.387 13.79-9.94Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M66.5 53.149c1.064-6.553-3.386-12.727-9.94-13.79-6.553-1.064-12.727 3.386-13.79 9.94-1.064 6.552 3.387 12.727 9.94 13.79 6.553 1.063 12.727-3.387 13.79-9.94Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M63.364 52.637a8.857 8.857 0 1 0-17.485-2.835 8.857 8.857 0 0 0 17.485 2.835Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m54.636 47.428.023 3.773h1.77M54.636 58v-1.13M54.636 44.448v1.13M59.427 46.433l-.798.798M61.412 51.224h-1.13M59.427 56.015l-.798-.798M49.845 56.015l.798-.798M47.86 51.224h1.13M49.845 46.433l.798.798", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M63.364 52.637a8.857 8.857 0 1 0-17.485-2.835 8.857 8.857 0 0 0 17.485 2.835Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var noteTime = {
  render: render$I
};
var render$H = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M40 72c17.673 0 32-14.327 32-32C72 22.327 57.673 8 40 8 22.327 8 8 22.327 8 40c0 17.673 14.327 32 32 32Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M49.267 59.589c10.94 0 19.81-8.87 19.81-19.81 0-10.942-8.87-19.811-19.81-19.811-10.942 0-19.81 8.87-19.81 19.81 0 10.941 8.868 19.81 19.81 19.81Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M49.266 56.287c9.118 0 16.509-7.391 16.509-16.509 0-9.117-7.391-16.508-16.509-16.508-9.117 0-16.509 7.39-16.509 16.508 0 9.118 7.392 16.51 16.51 16.51Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M49.266 56.287c9.118 0 16.509-7.391 16.509-16.509 0-9.117-7.391-16.508-16.509-16.508-9.117 0-16.509 7.39-16.509 16.508 0 9.118 7.392 16.51 16.51 16.51Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M49.266 56.287c9.118 0 16.509-7.391 16.509-16.509 0-9.117-7.391-16.508-16.509-16.508-9.117 0-16.509 7.39-16.509 16.508 0 9.118 7.392 16.51 16.51 16.51ZM63.573 39.779h-2.2M59.383 49.895l-1.557-1.557M49.267 54.086v-2.201M39.149 49.895l1.557-1.557M34.959 39.779h2.2M39.149 29.66l1.557 1.558M59.383 29.66l-1.557 1.558", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M50.79 39.474h-3.048v-11.28a1.522 1.522 0 1 1 3.047 0v11.28Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m48.352 40.978 1.728-1.724 5.452 5.453a1.219 1.219 0 0 1-1.724 1.724l-5.456-5.453Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M49.266 41.607a1.829 1.829 0 1 0 0-3.657 1.829 1.829 0 0 0 0 3.657Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M30.76 70.852c5.881 0 10.65-.715 10.65-1.597 0-.883-4.769-1.598-10.65-1.598-5.883 0-10.651.715-10.651 1.598 0 .882 4.768 1.597 10.65 1.597Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M23.453 51.382a1.992 1.992 0 0 1-3.983 0v-2.655h3.983v2.655ZM42.033 51.382a1.993 1.993 0 0 1-3.983 0v-2.655h3.983v2.655Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M31.419 47.464h-7.966v21.244h5.31l.606-13.943a1.388 1.388 0 0 1 2.772 0l.606 13.943h5.31V47.464H31.42Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M31.419 47.464h-7.966v21.244h5.31l.606-13.943a1.388 1.388 0 0 1 2.772 0l.606 13.943h5.31V47.464H31.42Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M22.617 67.665a1.102 1.102 0 0 0 .924 1.706h4.539a1.103 1.103 0 0 0 .983-1.61c-1.206-2.327-5.07-2.198-6.446-.096ZM38.894 67.665a1.101 1.101 0 0 1-.925 1.706h-4.541a1.104 1.104 0 0 1-.98-1.61c1.206-2.327 5.072-2.198 6.446-.096Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M30.755 28.213h-.012A11.948 11.948 0 0 0 18.806 40.16v7.895a1.103 1.103 0 0 0 1.104 1.103h3.543v5.938h3.582a4.473 4.473 0 0 0 3.715-1.983 4.468 4.468 0 0 0 3.714 1.983h3.58V49.16h3.545a1.1 1.1 0 0 0 1.103-1.103V40.16a11.948 11.948 0 0 0-11.937-11.947Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m35.467 29.183-4.712 16.29-4.712-16.295a11.919 11.919 0 0 1 4.7-.965h.012c1.62 0 3.224.33 4.712.97Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M30.755 28.213h-.012A11.948 11.948 0 0 0 18.806 40.16v7.895a1.103 1.103 0 0 0 1.104 1.103h3.543v5.938h3.582a4.473 4.473 0 0 0 3.715-1.983 4.468 4.468 0 0 0 3.714 1.983h3.58V49.16h3.545a1.1 1.1 0 0 0 1.103-1.103V40.16a11.948 11.948 0 0 0-11.937-11.947ZM38.05 50.146V38.861M23.453 50.12V38.833", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m30.755 45.472-4.712-16.294c-1.396.6-2.664 1.46-3.737 2.534l3.138 3.138v3.32l5.311 7.302Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M30.755 53.107v-7.635M34.349 33.135l-3.582-2.193-3.565 2.245", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M35.467 29.183c1.394.6 2.661 1.461 3.733 2.535l-3.132 3.132v3.32l-5.313 7.302 4.712-16.289Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m30.755 28.212-1.973 10.44 1.973 6.82 1.973-6.82-1.973-10.44Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m33.214 28.466-2.448 2.476-2.452-2.476.005-5.236h4.9l-.005 5.236Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M30.755 27.205a6.616 6.616 0 0 0 6.3-4.645h.006c2.1 0 2.227-3.319.332-3.319v-1.33a6.64 6.64 0 1 0-13.28 0v1.328c-1.894 0-1.767 3.319.332 3.319h.006a6.615 6.615 0 0 0 6.304 4.647Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.425 19.404a.83.83 0 1 1-1.66.002.83.83 0 0 1 1.66-.002ZM33.74 19.404a.83.83 0 1 1-1.659 0 .83.83 0 0 1 1.659 0Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M29.096 23.28a2.99 2.99 0 0 0 3.32 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M27.114 15.239c2.91 2.823 7.931 2.357 10.955 1.335a7.303 7.303 0 0 0-14.605.01v2.306s3.65-.913 3.65-3.651Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M27.114 15.239c2.91 2.823 7.931 2.357 10.955 1.335a7.303 7.303 0 0 0-14.605.01v2.306s3.65-.913 3.65-3.651Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M27.114 15.239c2.91 2.823 7.931 2.357 10.955 1.335a7.303 7.303 0 0 0-14.605.01v2.306s3.65-.913 3.65-3.651Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M27.114 15.239c-.335-.327-.384-.276-.658-.693", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var overtimeStand = {
  render: render$H
};
var render$G = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M7.959 40a32.001 32.001 0 1 0 64.002 0A32.001 32.001 0 0 0 7.96 40Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M64.948 13.887 63.12 15.2a4.233 4.233 0 0 1-2.633.79L48.26 14.302a2.117 2.117 0 0 0-.689 4.176l4.767.786a.53.53 0 0 1 .405.326c.07.172-.024.335-.068.515a5.489 5.489 0 0 1-2.536 3.095l-1.72 1.234.617.86L58.287 38.2l2.15-1.542a26.24 26.24 0 0 0 7.584-8.467l.74-1.317a6.427 6.427 0 0 1 1.86-2.073l1.42-1.018", "fill": "#fff" } }), _c("path", { attrs: { "d": "M64.948 13.887 63.12 15.2a4.233 4.233 0 0 1-2.633.79L48.26 14.302a2.117 2.117 0 0 0-.689 4.176l4.767.786a.53.53 0 0 1 .405.326c.07.172-.024.335-.068.515a5.489 5.489 0 0 1-2.536 3.095l-1.72 1.234.617.86L58.287 38.2l2.15-1.542a26.24 26.24 0 0 0 7.584-8.467l.74-1.317a6.427 6.427 0 0 1 1.86-2.073l1.42-1.018", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m60.007 36.966-7.74 5.55a2.117 2.117 0 0 1-2.468-3.44l7.742-5.551", "fill": "#fff" } }), _c("path", { attrs: { "d": "m60.007 36.966-7.74 5.55a2.117 2.117 0 0 1-2.468-3.44l7.742-5.551", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round" } }), _c("path", { attrs: { "d": "m52.51 26.713-9.795 7.024a2.119 2.119 0 0 1-3.317-1.23 2.117 2.117 0 0 1 .85-2.21l9.891-7.097", "fill": "#fff" } }), _c("path", { attrs: { "d": "m52.51 26.713-9.795 7.024a2.119 2.119 0 0 1-3.317-1.23 2.117 2.117 0 0 1 .85-2.21l9.891-7.097", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round" } }), _c("path", { attrs: { "d": "m57.738 33.383-11.379 8.16a2.116 2.116 0 1 1-2.467-3.44l10.748-7.71", "fill": "#fff" } }), _c("path", { attrs: { "d": "m57.738 33.383-11.379 8.16a2.116 2.116 0 1 1-2.467-3.44l10.748-7.71", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round" } }), _c("path", { attrs: { "d": "m54.64 30.393-12.038 8.634a2.117 2.117 0 0 1-2.467-3.44l12.345-8.853", "fill": "#fff" } }), _c("path", { attrs: { "d": "m54.64 30.393-12.038 8.634a2.117 2.117 0 0 1-2.467-3.44l12.345-8.853", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round" } }), _c("path", { attrs: { "d": "M58.691 34a13.36 13.36 0 0 1-4.356-4.04 14.07 14.07 0 0 1-2.316-4.84", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M33.2 52.64c.982-.633.199-3.535-.435-4.518l-6.672-4.653c-.634-.983-.982.214-1.964.848-.983.633-3.988 3.593-3.355 4.576l4.5 6.777c.631.979 6.941-2.4 7.926-3.03Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75" } }), _c("path", { attrs: { "d": "M27.803 61.698a2.117 2.117 0 0 0 2.458-1.708l1.219-6.772a2.117 2.117 0 1 0-4.167-.75l-1.218 6.771a2.117 2.117 0 0 0 1.708 2.459Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75" } }), _c("path", { attrs: { "d": "M31.624 60.487a2.117 2.117 0 0 0 2.056-2.173l-.188-6.88a2.116 2.116 0 1 0-4.232.115l.188 6.88a2.117 2.117 0 0 0 2.176 2.058Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75" } }), _c("path", { attrs: { "d": "M37.191 58.537a2.117 2.117 0 0 0 .634-2.927l-4.5-6.777a2.117 2.117 0 1 0-3.56 2.293l4.5 6.777a2.118 2.118 0 0 0 2.926.634Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75" } }), _c("path", { attrs: { "d": "m27.39 48.96-1.438-1.04 1.438 1.04Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m27.39 48.96-1.438-1.04", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M23.128 45.943 38.961 26.08a2.54 2.54 0 0 1 3.567-.405l8.94 7.127a2.54 2.54 0 0 1 .403 3.57L36.04 56.234a2.54 2.54 0 0 1-3.569.403l-8.94-7.127a2.54 2.54 0 0 1-.402-3.567Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M23.128 45.943 38.961 26.08a2.54 2.54 0 0 1 3.567-.405l8.94 7.127a2.54 2.54 0 0 1 .403 3.57L36.04 56.234a2.54 2.54 0 0 1-3.569.403l-8.94-7.127a2.54 2.54 0 0 1-.402-3.567Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m31.965 52.177-3.973-3.166a2.54 2.54 0 0 0-.4-3.57l11.872-14.898a2.54 2.54 0 0 0 3.57-.4l3.972 3.167a2.54 2.54 0 0 0 .4 3.57L35.534 51.773a2.541 2.541 0 0 0-3.57.403Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M35.92 43.145a2.54 2.54 0 1 0 3.17-3.97 2.54 2.54 0 0 0-3.17 3.97Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M18.18 71.416 7.975 66.75l.009-.018c2.795-13.53 6.75-27.767 26.52-30.524l1.128-.16a2.117 2.117 0 1 1 .596 4.192l-1.127.16c-4.986.71-8.787 2.204-11.312 6.538-3.874 6.51.835 5.412 2.65 3.28l4.063-4.408a2.117 2.117 0 1 1 3.15 2.831c-6.073 9.467-6.08 11.7-9.822 14.254-2.79 1.906-3.526 3.875-5.652 8.522Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M7.985 66.73c2.795-13.53 6.75-27.766 26.52-30.524l1.128-.16a2.116 2.116 0 1 1 .596 4.193l-1.127.16c-4.986.71-8.787 2.204-11.312 6.538-3.874 6.51.835 5.412 2.65 3.28l4.063-4.408a2.117 2.117 0 1 1 3.15 2.831c-6.073 9.467-6.08 11.7-9.822 14.254-2.79 1.906-3.526 3.875-5.652 8.522", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var paymentReceive = {
  render: render$G
};
var render$F = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M72 39.693a32 32 0 1 0-61.149 13.2H69.15A31.88 31.88 0 0 0 72 39.693Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M8.8 52.894h62.4M5.2 52.894h2M72.8 52.894h2", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M17.954 32.64a1.84 1.84 0 1 0 0 3.674h4.286V32.64h-4.286Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M27.14 25.289h9.798v-3.675h-6.735a1.984 1.984 0 0 0-1.775 1.097L27.14 25.29Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M43.063 25.289h-6.125v-3.672s.612-.615 3.062-.615c2.45 0 3.063.615 3.063.615v3.672Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M27.14 25.289h9.798v-3.675h-6.735a1.984 1.984 0 0 0-1.775 1.097L27.14 25.29Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.86 25.289h-9.797v-3.675h6.734a1.984 1.984 0 0 1 1.774 1.098l1.29 2.577Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M52.86 25.289h-9.797v-3.675h6.734a1.984 1.984 0 0 1 1.774 1.098l1.29 2.577ZM43.063 25.289h-6.125v-3.672s.612-.615 3.062-.615c2.45 0 3.063.615 3.063.615v3.672ZM17.954 32.64a1.84 1.84 0 1 0 0 3.674h4.286V32.64h-4.286Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.045 32.64a1.84 1.84 0 1 1 0 3.674H57.76V32.64h4.285Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M62.045 32.64a1.84 1.84 0 1 1 0 3.674H57.76V32.64h4.285Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M58.372 39.374a1.225 1.225 0 0 1-1.224-1.225v-2.143l-3.906-7.321a2.39 2.39 0 0 0-1.773-1.253A83.483 83.483 0 0 0 40 26.514c-3.84.042-7.671.349-11.468.918a2.393 2.393 0 0 0-1.774 1.253l-3.904 7.32v2.144a1.225 1.225 0 1 1-2.45 0v-2.45c0-.2.05-.398.143-.576l4.05-7.591a4.88 4.88 0 0 1 3.578-2.523A86.017 86.017 0 0 1 40 24.064c3.96.042 7.91.358 11.826.945a4.88 4.88 0 0 1 3.578 2.523l4.05 7.588c.093.177.142.375.142.576v2.45a1.224 1.224 0 0 1-1.224 1.228Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75" } }), _c("path", { attrs: { "d": "M55.92 35.7H24.08c-4.899 0-7.349 2.449-7.349 5.511v6.123h46.54v-6.123c0-3.062-2.45-5.512-7.35-5.512Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M55.92 35.7H24.08c-4.899 0-7.349 2.449-7.349 5.511v6.123h46.54v-6.123c0-3.062-2.45-5.512-7.35-5.512Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M24.08 35.7h31.84c.373 0 .734.014 1.084.042l-3.765-7.057a2.39 2.39 0 0 0-1.773-1.253A83.48 83.48 0 0 0 40 26.514c-3.84.042-7.672.349-11.47.918a2.393 2.393 0 0 0-1.773 1.253l-3.764 7.058c.347-.03.71-.044 1.087-.044Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M24.08 35.7h31.84c.373 0 .734.014 1.084.042l-3.765-7.057a2.39 2.39 0 0 0-1.773-1.253A83.48 83.48 0 0 0 40 26.514c-3.84.042-7.672.349-11.47.918a2.393 2.393 0 0 0-1.773 1.253l-3.764 7.058c.347-.03.71-.044 1.087-.044Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M17.342 55.908a3.674 3.674 0 1 0 7.349 0v-4.286h-7.35v4.286Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M17.342 55.908a3.674 3.674 0 1 0 7.349 0v-4.286h-7.35v4.286Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.658 55.908a3.675 3.675 0 0 1-7.348 0v-4.286h7.348v4.286Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M62.658 55.908a3.675 3.675 0 0 1-7.348 0v-4.286h7.348v4.286Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M24.08 47.334h-7.35v-4.898h6.124a1.224 1.224 0 0 1 1.224 1.223l.002 3.675Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M24.08 47.334h-7.35v-4.898h6.124a1.224 1.224 0 0 1 1.224 1.223l.002 3.675Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M55.92 47.334h7.348v-4.898h-6.123a1.224 1.224 0 0 0-1.225 1.223v3.675Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M55.92 47.334h7.348v-4.898h-6.123a1.224 1.224 0 0 0-1.225 1.223v3.675Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.023 41.211c.008-.063.02-.125.038-.185a86.196 86.196 0 0 0-11.06-1.04c-3.706.109-7.4.456-11.061 1.04a1.1 1.1 0 0 1 .038.186v2.257A86.1 86.1 0 0 1 40 42.436c3.693.107 7.375.452 11.023 1.033V41.21Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M51.023 41.211c.008-.063.02-.125.038-.185a86.196 86.196 0 0 0-11.06-1.04c-3.706.109-7.4.456-11.061 1.04a1.1 1.1 0 0 1 .038.186v2.257A86.1 86.1 0 0 1 40 42.436c3.693.107 7.375.452 11.023 1.033V41.21Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M63.272 47.334H16.728a1.84 1.84 0 0 0-1.84 1.84v1.84a3.68 3.68 0 0 0 3.68 3.68H61.43a3.68 3.68 0 0 0 3.68-3.68v-1.84a1.84 1.84 0 0 0-1.84-1.84Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M63.272 47.334H16.728a1.84 1.84 0 0 0-1.84 1.84v1.84a3.68 3.68 0 0 0 3.68 3.68H61.43a3.68 3.68 0 0 0 3.68-3.68v-1.84a1.84 1.84 0 0 0-1.84-1.84Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M27.753 39.986a1.224 1.224 0 0 0-1.225 1.225v13.472h2.45V41.211a1.225 1.225 0 0 0-1.225-1.225Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M27.753 39.986a1.224 1.224 0 0 0-1.225 1.225v13.472h2.45V41.211a1.225 1.225 0 0 0-1.225-1.225Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.248 39.986a1.225 1.225 0 0 1 1.225 1.225v13.472h-2.45V41.211a1.223 1.223 0 0 1 1.225-1.225Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M52.248 39.986a1.225 1.225 0 0 1 1.225 1.225v13.472h-2.45V41.211a1.223 1.223 0 0 1 1.225-1.225Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40 47.334h11.023V43.47A86.13 86.13 0 0 0 40 42.436a86.121 86.121 0 0 0-11.023 1.033v3.865H40Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M40 47.334h11.023V43.47A86.13 86.13 0 0 0 40 42.436a86.121 86.121 0 0 0-11.023 1.033v3.865H40Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M28.977 51.009h22.046v3.674H28.977V51.01Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M28.977 51.009h22.046v3.674H28.977V51.01ZM31.427 43.127v4.207M33.876 42.834v4.5M36.325 42.602v4.732M38.775 42.459v4.875M48.573 43.127v4.207M46.124 42.834v4.5M43.675 42.602v4.732M41.225 42.459v4.875", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var policeCar = {
  render: render$F
};
var render$E = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 72 72", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M42.45 44.603a3.053 3.053 0 0 1 1.034 2.297 3.078 3.078 0 0 1-3.072 3.072A3.078 3.078 0 0 1 37.34 46.9c0-.846.338-1.63.943-2.217.099-.116.17-.258.17-.374 0-.027 0-.08-.054-.143H27.812a1.01 1.01 0 0 1-.277-.053l-.07-.027c-.018-.009-.045-.017-.063-.026-.614-.366-.962-.962-.962-1.63 0-.508.205-1.024.58-1.452.017-.017.061-.07.08-.089a1.47 1.47 0 0 0-1.015-2.529c-.811 0-1.47.66-1.47 1.47 0 .445.196.855.534 1.14.107.089.196.196.267.32.205.374.312.757.312 1.122 0 .677-.347 1.265-.97 1.639-.018.009-.036.009-.054.017-.045.027-.098.036-.152.054a1.039 1.039 0 0 1-.16.035c-.018 0-.035.01-.053.01h-4.55v14.122h12.404v-3.027c0-.446.356-.802.801-.802.445 0 .801.356.801.802v3.027h13.607V44.166h-4.969c-.071.09-.098.205.018.437ZM21.106 36.081a1.382 1.382 0 0 0-.56-1.87l-5.949-3.589a.8.8 0 0 1-.374-.534l-.686-3.606a.8.8 0 1 1 1.576-.294l.624 3.259 2.44 1.47v-1.3l-1.683-1.657a.793.793 0 0 1-.205-.33l-.757-2.43c-.32-.784-.962-1.523-1.603-1.826h-.009a4.908 4.908 0 0 1-.792-.196 4.753 4.753 0 0 1-1.888-1.211c-.517.24-1.514.802-1.924 1.781-1.406 5.44-3.66 14.3-3.722 15.067l-.418 8.994c0 .035-.01.07-.01.097l-1.54 8.763c-.053.338.045.703.259.997.213.294.543.49.908.543.81.134 1.46-.427 1.567-1.158l1.558-8.895c0-.027.01-.08.01-.125l.302-7.266a.815.815 0 0 1 .365-.641.806.806 0 0 1 .74-.063c.453.187.453.187 2.617 8.006a.617.617 0 0 1 .027.178l.383 8.655a1.378 1.378 0 0 0 1.38 1.336c.81-.027 1.407-.668 1.38-1.434l-.391-8.869c0-.098-.018-.187-.036-.285l-2.422-9.688s-.054-.151-.063-.151a.874.874 0 0 1-.035-.455l.605-2.689-1.148-.685a2.97 2.97 0 0 1-1.479-2.013l-.56-3.758a.803.803 0 0 1 .676-.908.79.79 0 0 1 .909.677l.552 3.713c.07.365.33.703.685.9l6.84 4.078c.106.053.257.107.409.133.587.072 1.166-.213 1.442-.721ZM13.635 21.646c.178.063.348.098.526.125a3.146 3.146 0 0 0 3.473-2.12 3.116 3.116 0 0 0-.17-2.412 3.163 3.163 0 0 0-1.825-1.594 3.411 3.411 0 0 0-.989-.152 3.176 3.176 0 0 0-3 2.155 3.116 3.116 0 0 0 .169 2.413 3.102 3.102 0 0 0 1.816 1.585ZM62.255 21.174a3.295 3.295 0 0 0 3.286-3.285 3.295 3.295 0 0 0-3.286-3.286 3.295 3.295 0 0 0-3.286 3.286 3.29 3.29 0 0 0 3.286 3.285Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M22.513 36.838a2.992 2.992 0 0 1-2.627 1.567c-.035 0-.08-.009-.115-.009v4.176h4.274c.053-.07.062-.124.062-.15a.662.662 0 0 0-.08-.277 3.053 3.053 0 0 1-1.033-2.297 3.078 3.078 0 0 1 3.072-3.072 3.078 3.078 0 0 1 3.072 3.072c0 .837-.33 1.62-.926 2.2-.142.186-.187.31-.187.4 0 .027.01.08.054.133h4.096v-4.995c0-.196.053-.383.151-.552.365-.615.962-.97 1.63-.97.507 0 1.024.204 1.451.578.01.009.063.053.072.071.293.303.667.463 1.068.463.81 0 1.47-.659 1.47-1.469s-.66-1.47-1.47-1.47c-.445 0-.855.197-1.14.535a.987.987 0 0 1-.311.258c-1.096.597-2.191.312-2.779-.659a1.051 1.051 0 0 1-.16-.56v-4.73H19.771v2.512a.839.839 0 0 1-.054.267l1.62.98c1.417.739 1.96 2.546 1.176 3.998Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "m55.87 23.9-1.433-.125a.906.906 0 0 1-.294-.08l-2.93-1.479v1.977l2.556 1.087 2.101-1.38Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M67.046 48.476c-.01-.044-.01-.089-.01-.133l.08-8.985c.019-.757-.987-10.018-1.62-15.69-.115-.748-.819-1.158-1.21-1.336a4.884 4.884 0 0 1-2.04.454 4.78 4.78 0 0 1-1.398-.205l-6.563 4.275a.798.798 0 0 1-.748.062l-5.2-2.208c-.615-.24-1.443-.107-1.79.632a1.326 1.326 0 0 0 .641 1.763L53.6 29.83c.258.107.543.107.792 0 1.576-.695 4.417-2.476 4.444-2.493 0 0 .008 0 .008-.01 0 0 0-.008.01-.008.836-.49 1.424-.864 1.424-.864a.803.803 0 0 1 1.104.25.803.803 0 0 1-.249 1.104s-.428.267-1.069.65l-.044 9.323c.044.579-.445 2.075-2.396 7.96a200.532 200.532 0 0 0-.748 2.289l-1.29 8.629c-.134.748.338 1.442 1.059 1.567.116.018.223.027.338.018a1.325 1.325 0 0 0 1.203-1.078l1.21-8.174c.01-.054.018-.107.036-.152l2.948-8.236a.815.815 0 0 1 .872-.526.798.798 0 0 1 .686.748c.16 2.948.41 7.453.445 7.756l1.38 8.584c.098.588.57 1.042 1.158 1.104.267.036.534-.017.784-.151.49-.25.757-.855.659-1.47l-1.318-8.174Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m48.942 23.223.677.285v-8.264H37.206v4.114c.134.133.151.08.338-.009a2.882 2.882 0 0 1 2.155-.962 2.9 2.9 0 0 1 2.894 2.894 2.9 2.9 0 0 1-2.894 2.894c-.792 0-1.531-.32-2.083-.89a.508.508 0 0 0-.303-.134c-.018 0-.053 0-.098.036v4.363h4.247c.134 0 .481.018.74.196.507.365.792.89.792 1.478 0 .481-.196.971-.552 1.372-.018.026-.071.08-.098.107a1.292 1.292 0 1 0 2.208.908c0-.383-.169-.748-.471-.998a1.167 1.167 0 0 1-.268-.32c-.525-.97-.338-1.915.499-2.538.258-.187.597-.205.695-.205h.338a2.922 2.922 0 0 1-.25-2.903c.66-1.407 2.316-2.021 3.847-1.424Z", "fill": "#16A7A7" } }), _c("path", { attrs: { "d": "M67.072 59.456c-.089 0-.187-.01-.276-.018a2.494 2.494 0 0 1-2.172-2.075l-1.39-8.61c-.009-.099-.062-.855-.231-3.9l-.125-2.192-2.324 6.492-1.22 8.21a2.497 2.497 0 0 1-2.262 2.04c-.062.008-.115.008-.178.008a2.486 2.486 0 0 1-2.44-2.939l1.3-8.681c.018-.125.17-.57.784-2.422 1.13-3.42 2.2-6.679 2.324-7.365l.01-.053.035-9.323-.677.4c-.997.597-2.386 1.39-3.366 1.826a2.205 2.205 0 0 1-.864.178c-.294 0-.579-.062-.846-.17l-5.12-2.172h-.17l-.026.009H44.9l-.134.214c-.187.302-.036.614.009.721l.036.08.07.062a2.447 2.447 0 0 1-1.63 4.274 2.447 2.447 0 0 1-2.448-2.448c0-.668.268-1.3.757-1.763.107-.116.267-.348.267-.615v-.115l-.07-.17-.125-.231h-4.96a.62.62 0 0 1-.624-.623v-5.076c0-.116.027-.223.09-.32.267-.446.694-.695 1.166-.695.374 0 .766.151 1.086.436.392.4.837.588 1.31.588.961 0 1.736-.784 1.736-1.737a1.739 1.739 0 0 0-3.081-1.104.735.735 0 0 1-.178.152c-.285.16-.57.24-.855.24-.481 0-.909-.25-1.185-.712a.581.581 0 0 1-.089-.32V14.71a.62.62 0 0 1 .624-.624h13.473a.62.62 0 0 1 .623.624v5.895l.258.258h.08l3.5 1.763 3.553.312 1.816-1.185-.48-.383a4.417 4.417 0 0 1-1.692-3.481 4.45 4.45 0 0 1 4.443-4.444 4.45 4.45 0 0 1 4.443 4.444 4.4 4.4 0 0 1-1.282 3.116l-.356.374.418.303c.677.49 1.078 1.113 1.185 1.843 1.042 9.288 1.665 15.379 1.63 15.886l-.08 8.878 1.317 8.201c.178 1.122-.33 2.2-1.273 2.68a2.628 2.628 0 0 1-1.176.286ZM63.2 40.533a.36.36 0 0 1 .303.33c.017.303.4 7.364.445 7.782l1.389 8.602c.124.784.766 1.39 1.55 1.479.062.008.133.008.204.008.285 0 .57-.07.837-.213.66-.339 1.024-1.131.89-1.941L67.5 48.387l.08-9.047c.018-.828-1.05-10.659-1.62-15.743-.143-.962-.98-1.479-1.47-1.692l-.187-.08-.187.089a4.319 4.319 0 0 1-1.852.41c-.428 0-.855-.063-1.274-.188l-.213-.053-6.732 4.39a.391.391 0 0 1-.196.062.404.404 0 0 1-.143-.027l-5.2-2.208a2.07 2.07 0 0 0-.757-.142c-.721 0-1.318.374-1.612.997a1.76 1.76 0 0 0 .25 1.888c.16.196.365.356.605.463l6.42 2.725a1.42 1.42 0 0 0 1.15-.01c1.495-.658 4.069-2.252 4.452-2.493l.097-.062c.757-.445 1.318-.801 1.39-.837a.347.347 0 0 1 .499.107.351.351 0 0 1-.117.49s-.427.267-1.06.65l-.213.124-.044 9.573c.044.534-.615 2.52-2.369 7.827l-.027.09a136.332 136.332 0 0 0-.73 2.225l-1.3 8.674a1.78 1.78 0 0 0 1.416 2.074c.107.018.223.027.338.027h.107a1.78 1.78 0 0 0 1.62-1.443l1.212-8.192 2.965-8.3a.357.357 0 0 1 .338-.23l.063.008ZM37.313 22.715a.584.584 0 0 0-.392.151L36.77 23v5.004h4.692c.143 0 .357.027.481.116.392.285.606.668.606 1.113 0 .374-.152.757-.437 1.078l-.062.071a1.739 1.739 0 0 0 1.22 2.974c.953 0 1.737-.784 1.737-1.736a1.76 1.76 0 0 0-.633-1.345.61.61 0 0 1-.151-.187c-.428-.784-.294-1.478.374-1.968.124-.089.311-.116.436-.116h1.184l-.48-.694a2.505 2.505 0 0 1-.214-2.458c.4-.864 1.264-1.407 2.253-1.407.347 0 .685.063 1.024.196l1.282.543V14.8H36.761v4.746l.133.133a.646.646 0 0 0 .446.205c.133 0 .24-.053.32-.089l.09-.035.133-.107a2.447 2.447 0 0 1 4.274 1.63 2.447 2.447 0 0 1-2.449 2.448c-.668 0-1.3-.267-1.763-.757-.214-.169-.436-.258-.632-.258Zm13.455 1.772 3.045 1.291 3.384-2.208-2.716-.232c-.044 0-.089-.018-.134-.035l-3.58-1.808v2.992Zm11.487-10.33a3.736 3.736 0 0 0-3.731 3.732 3.736 3.736 0 0 0 3.73 3.73 3.736 3.736 0 0 0 3.732-3.73 3.736 3.736 0 0 0-3.731-3.731Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M46.583 27.782c.08.053.169.098.258.142l.837.356h-.757l-.338-.498ZM62.255 13a4.891 4.891 0 0 0-4.889 4.889c0 1.55.73 2.93 1.861 3.829l-1.166.765-3.313-.285-3.517-1.771V14.71c0-.588-.481-1.069-1.069-1.069h-13.49c-.588 0-1.069.481-1.069 1.069v4.826c0 .196.054.383.151.552.366.597.936.926 1.568.926.347 0 .712-.098 1.077-.294.116-.07.223-.151.303-.258a1.292 1.292 0 1 1 .997 2.11c-.356 0-.685-.142-.935-.4-.018-.018-.07-.063-.08-.08-.4-.357-.89-.552-1.38-.552-.641 0-1.202.338-1.55.917-.097.169-.15.356-.15.552v5.075c0 .588.48 1.07 1.068 1.07h4.693a.12.12 0 0 1 .017.07c0 .09-.053.205-.133.294a2.883 2.883 0 0 0-.89 2.084 2.9 2.9 0 0 0 2.893 2.894 2.9 2.9 0 0 0 2.894-2.894c0-.828-.356-1.612-.97-2.155-.072-.151-.072-.24-.036-.294h2.743c.017 0 .026-.009.044-.009l5.04 2.137c.33.143.677.205 1.024.205.356 0 .713-.071 1.042-.223.998-.445 2.413-1.246 3.41-1.852l-.035 8.469v.035c-.142.757-1.603 5.165-2.315 7.311-.677 2.03-.766 2.333-.802 2.493l-1.3 8.665a2.93 2.93 0 0 0 2.342 3.41c.178.036.357.054.544.054.07 0 .142 0 .204-.01a2.94 2.94 0 0 0 2.672-2.413l1.202-8.13 1.603-4.407c.115 2.11.213 3.81.24 3.945l1.39 8.61a2.93 2.93 0 0 0 2.893 2.458c.472 0 .944-.116 1.372-.338 1.113-.58 1.718-1.844 1.504-3.153l-1.308-8.12.08-8.834c.08-.66-1.114-11.39-1.63-16.002-.151-1.024-.766-1.71-1.362-2.137a4.854 4.854 0 0 0 1.407-3.428c0-2.698-2.2-4.889-4.89-4.889Zm0 8.174a3.295 3.295 0 0 1-3.286-3.285 3.295 3.295 0 0 1 3.286-3.286 3.295 3.295 0 0 1 3.286 3.286 3.295 3.295 0 0 1-3.286 3.285ZM37.34 19.438c-.036 0-.072-.018-.134-.08v-4.114H49.61v8.264l-.676-.285A3.28 3.28 0 0 0 47.748 23c-1.13 0-2.164.614-2.653 1.656a2.922 2.922 0 0 0 .249 2.903h-.338c-.098 0-.437.018-.695.205-.846.614-1.024 1.567-.499 2.538a.921.921 0 0 0 .267.32 1.292 1.292 0 1 1-2.11.997c0-.355.142-.685.374-.908a.563.563 0 0 0 .098-.106c.356-.401.552-.89.552-1.372 0-.588-.276-1.113-.792-1.478-.25-.178-.597-.196-.74-.196h-4.247v-4.363c.044-.036.08-.036.098-.036.071 0 .196.036.303.134.552.57 1.29.89 2.083.89a2.9 2.9 0 0 0 2.894-2.894 2.9 2.9 0 0 0-2.894-2.894c-.828 0-1.602.348-2.155.962-.106.044-.151.08-.204.08Zm16.429 5.833-2.556-1.087v-1.977l2.93 1.479c.089.044.187.07.294.08l1.433.124-2.101 1.38Zm8.486-2.494c.73 0 1.416-.169 2.04-.454.39.178 1.094.597 1.21 1.336.632 5.672 1.639 14.933 1.62 15.69l-.08 8.985c0 .044 0 .089.01.133l1.317 8.193c.098.614-.169 1.22-.659 1.469-.195.107-.418.16-.632.16-.053 0-.107 0-.151-.009a1.342 1.342 0 0 1-1.158-1.104l-1.38-8.584c-.036-.312-.285-4.809-.445-7.756a.79.79 0 0 0-.686-.748c-.036-.009-.071-.009-.107-.009a.794.794 0 0 0-.757.534L59.45 48.85a.93.93 0 0 0-.036.152l-1.21 8.174A1.306 1.306 0 0 1 57 58.254h-.089c-.089 0-.17-.01-.25-.027a1.335 1.335 0 0 1-1.059-1.567l1.291-8.629c.036-.151.383-1.193.748-2.288 1.95-5.886 2.44-7.391 2.396-7.961l.044-9.323c.641-.383 1.069-.65 1.069-.65a.795.795 0 0 0 .249-1.105.798.798 0 0 0-1.104-.249s-.597.374-1.425.864c0 0 0 .009-.009.009 0 0-.009 0-.009.009-.026.017-2.867 1.79-4.443 2.493a1.007 1.007 0 0 1-.793 0l-6.411-2.725a1.24 1.24 0 0 1-.454-.347c-.33-.392-.4-.953-.187-1.416.24-.517.721-.74 1.202-.74.205 0 .4.036.579.108l5.2 2.208a.785.785 0 0 0 .748-.071l6.563-4.274a4.78 4.78 0 0 0 1.398.204Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M18.97 59.456a.357.357 0 0 1-.357-.356V37.613l-4.684-2.788-.597 2.672.036.116 2.44 9.76c.036.16.062.338.071.507l.392 8.878a2.544 2.544 0 0 1-2.44 2.635h-.098a2.533 2.533 0 0 1-2.529-2.44l-.383-8.62L9.3 42.876l-.223 5.21c0 .088-.009.178-.027.267L7.491 57.23a2.53 2.53 0 0 1-2.876 2.128 2.516 2.516 0 0 1-1.665-.997 2.53 2.53 0 0 1-.472-1.88l1.531-8.717.428-8.994c.009-.231.294-1.932 3.775-15.36.481-1.238 1.523-1.968 2.307-2.378l.383-.196-.178-.383a4.325 4.325 0 0 1-.179-3.179 4.328 4.328 0 0 1 4.097-2.947c.463 0 .926.071 1.362.222a4.291 4.291 0 0 1 2.493 2.173 4.303 4.303 0 0 1 .232 3.304 4.274 4.274 0 0 1-2.716 2.716l-.606.204.401.5c.338.418.623.899.81 1.362l.74 2.368 1.077 1.069.312-.258a.324.324 0 0 1 .222-.09h14.007a.36.36 0 0 1 .357.339v5.556l.106.125c.223.25.455.25.535.25.142 0 .302-.036.472-.116l.08-.036.062-.071a2.649 2.649 0 0 1 1.968-.89 2.626 2.626 0 1 1-1.879 4.461c-.276-.223-.508-.321-.721-.321a.638.638 0 0 0-.499.223l-.124.124V43h5.129c.151 0 .382.035.507.125.41.293.641.712.641 1.184 0 .4-.169.81-.472 1.149l-.062.07a1.891 1.891 0 0 0-.579 1.372c0 1.06.864 1.915 1.915 1.915a1.917 1.917 0 0 0 1.22-3.393.64.64 0 0 1-.16-.187c-.455-.837-.312-1.585.391-2.102.17-.124.428-.124.454-.124h5.842l.098-.027c.124.009.285.17.285.365V59.1c0 .195-.16.356-.357.356H18.97Zm14.015-4.542c.196 0 .356.16.356.357v3.472h14.497V43.721h-5.6l-.134.152c-.205.24-.223.552-.045.917l.036.08.07.062c.562.49.883 1.211.883 1.968a2.626 2.626 0 1 1-5.254 0c0-.721.285-1.389.81-1.897.205-.24.303-.471.303-.694 0-.053 0-.232-.143-.419l-.133-.178H27.81a.447.447 0 0 1-.124-.026l-.098-.045c-.436-.267-.712-.721-.712-1.229 0-.4.169-.81.463-1.157.436-.428.64-.918.64-1.443 0-1.06-.863-1.914-1.914-1.914a1.917 1.917 0 0 0-1.22 3.392.81.81 0 0 1 .16.187c.17.312.259.615.259.909 0 .507-.25.934-.721 1.237l-.072.027-.142.044-.063.01h-4.942v15.013H32.62v-3.473c.009-.17.17-.33.365-.33ZM11.053 21.557c-.606.276-1.683.909-2.146 2.013C7.883 27.54 5.238 37.88 5.149 38.76l-.418 9.02-1.55 8.808c-.071.471.054.961.339 1.344.293.392.712.641 1.202.721.098.018.205.027.302.027.89 0 1.639-.659 1.772-1.558l1.559-8.887c.009-.054.018-.116.018-.187l.302-7.266a.363.363 0 0 1 .16-.285.36.36 0 0 1 .197-.054c.044 0 .098.01.142.027.285.214.801 2.102 2.35 7.711l.402 8.736a1.814 1.814 0 0 0 1.825 1.754 1.886 1.886 0 0 0 1.327-.579 1.79 1.79 0 0 0 .498-1.309l-.391-8.878a2.402 2.402 0 0 0-.054-.365l-2.44-9.715-.044-.107a.497.497 0 0 1-.045-.276l.677-3.01-1.425-.845a2.544 2.544 0 0 1-1.273-1.719l-.543-3.731a.356.356 0 0 1 .294-.41h.009c.222 0 .365.134.391.303l.553 3.713c.106.526.445.971.917 1.23l6.82 4.06c.179.098.375.16.57.187.099.018.188.018.286.018.667 0 1.29-.365 1.602-.962a1.8 1.8 0 0 0 .143-1.39 1.82 1.82 0 0 0-.882-1.086l-5.93-3.58a.36.36 0 0 1-.17-.24l-.685-3.606a.359.359 0 0 1 .053-.267.347.347 0 0 1 .232-.152h.018c.231 0 .365.116.4.285l.66 3.455 3.285 1.986v-2.27l-1.816-1.79a.326.326 0 0 1-.09-.152l-.756-2.43c-.374-.918-1.105-1.746-1.835-2.093l-.089-.045h-.107a5.924 5.924 0 0 1-.65-.17 4.263 4.263 0 0 1-1.71-1.095l-.222-.222-.276.142Zm15.022 15.646a2.632 2.632 0 0 1 2.627 2.627 2.62 2.62 0 0 1-.793 1.879c-.222.276-.32.507-.32.712 0 .143.053.285.142.41l.134.178h4.755v-5.441c0-.116.027-.231.09-.33.284-.48.73-.747 1.246-.747.4 0 .81.169 1.157.471.419.428.918.642 1.443.642 1.06 0 1.915-.864 1.915-1.915 0-1.06-.864-1.914-1.915-1.914-.579 0-1.113.258-1.478.703a.61.61 0 0 1-.187.151c-.312.17-.615.259-.917.259-.517 0-.962-.267-1.265-.757a.611.611 0 0 1-.089-.33v-5.173H19.325v2.956a.402.402 0 0 1-.026.116l-.125.347 1.932 1.167c.597.32 1.024.855 1.211 1.496a2.52 2.52 0 0 1-.195 1.932 2.547 2.547 0 0 1-2.236 1.336l-.463-.045-.098.454v4.622h4.925l.133-.16a.712.712 0 0 0 .17-.446 1.11 1.11 0 0 0-.116-.472l-.036-.08-.071-.062a2.624 2.624 0 0 1 1.745-4.586ZM14.65 15.048c-1.549 0-2.93.989-3.419 2.458a3.6 3.6 0 0 0 .187 2.751 3.59 3.59 0 0 0 2.68 1.96c.187.026.374.044.552.044a3.608 3.608 0 0 0 3.224-5.21 3.59 3.59 0 0 0-2.084-1.816 3.595 3.595 0 0 0-1.14-.187Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m14.74 22.706-.08.027.035.044a.82.82 0 0 0-.116-.07H14.74Zm4.14 5.753v.596l-.089-.089-.24-.231.33-.276ZM14.65 13.89a4.768 4.768 0 0 0-4.523 3.25 4.691 4.691 0 0 0 .196 3.491c-.784.401-1.968 1.203-2.511 2.574-.01.027-.018.062-.027.089-1.745 6.732-3.82 14.897-3.793 15.45l-.419 8.94-1.54 8.735c-.116.784.08 1.576.552 2.218a2.944 2.944 0 0 0 1.95 1.175c.151.027.294.036.445.036 1.47 0 2.734-1.096 2.947-2.53l1.559-8.895c.018-.107.026-.214.026-.32l.098-2.405c.268.953.535 1.906.757 2.716l.383 8.557a2.972 2.972 0 0 0 2.983 2.868h.116a2.991 2.991 0 0 0 2.867-3.1l-.392-8.877a2.684 2.684 0 0 0-.089-.597l-2.422-9.688-.026-.107.436-1.95 3.936 2.35V59.11c0 .445.356.8.801.8h29.217a.798.798 0 0 0 .801-.8V43.346a.798.798 0 0 0-.801-.801c-.036 0-.063.018-.09.018h-5.779c-.098 0-.445.017-.72.213-.882.65-1.078 1.648-.517 2.672.062.116.151.222.267.32.338.285.534.695.534 1.14a1.47 1.47 0 0 1-2.939 0c0-.4.16-.783.437-1.042a.559.559 0 0 0 .098-.107c.374-.427.579-.935.579-1.442 0-.615-.294-1.167-.82-1.54-.258-.188-.623-.214-.765-.214h-4.684v-4.836c.08-.08.151-.08.178-.08.08 0 .213.036.4.187a3.057 3.057 0 0 0 2.2.926 3.078 3.078 0 0 0 3.072-3.072 3.078 3.078 0 0 0-3.072-3.072c-.882 0-1.719.374-2.297 1.033a.631.631 0 0 1-.276.071c-.045 0-.107 0-.196-.098v-5.37a.798.798 0 0 0-.802-.8H18.97a.8.8 0 0 0-.507.195l-.713-.703-.721-2.298a5.999 5.999 0 0 0-.873-1.478 4.747 4.747 0 0 0 3.001-3 4.707 4.707 0 0 0-.25-3.643 4.717 4.717 0 0 0-4.256-2.636Zm0 7.926c-.16 0-.32-.01-.49-.036a3.104 3.104 0 0 1-2.35-1.719 3.156 3.156 0 0 1-.17-2.413 3.176 3.176 0 0 1 3.999-1.994 3.104 3.104 0 0 1 1.825 1.594c.374.756.437 1.611.17 2.413a3.152 3.152 0 0 1-2.984 2.155Zm-9.626 36.42c-.08 0-.15-.01-.231-.018a1.388 1.388 0 0 1-.908-.543 1.323 1.323 0 0 1-.259-.997l1.54-8.763c.01-.035.01-.07.01-.098l.418-9.002c.072-.766 2.316-9.617 3.723-15.067.41-.98 1.398-1.54 1.923-1.781a4.85 4.85 0 0 0 1.888 1.211c.258.09.525.151.792.196h.01c.64.303 1.281 1.042 1.602 1.825l.757 2.431c.035.125.107.24.205.33l1.683 1.656v1.3l-2.44-1.469-.623-3.26a.8.8 0 0 0-.784-.65c-.054 0-.098.01-.152.019a.8.8 0 0 0-.64.935l.685 3.606a.8.8 0 0 0 .374.534l5.948 3.589a1.39 1.39 0 0 1 .561 1.87 1.366 1.366 0 0 1-1.424.703 1.305 1.305 0 0 1-.41-.133l-6.839-4.079a1.33 1.33 0 0 1-.685-.899l-.553-3.713a.81.81 0 0 0-.783-.686.803.803 0 0 0-.801.917l.56 3.758c.179.873.73 1.612 1.479 2.013l1.148.685-.605 2.69a.722.722 0 0 0 .035.454s.054.151.063.151l2.422 9.688a1 1 0 0 1 .035.285l.392 8.87c.027.756-.57 1.397-1.38 1.433a1.372 1.372 0 0 1-1.38-1.336l-.383-8.655a.617.617 0 0 0-.027-.178c-2.164-7.81-2.164-7.81-2.618-8.005a.799.799 0 0 0-.74.062.825.825 0 0 0-.373.64l-.303 7.267c0 .045-.009.098-.009.125L6.37 57.043c-.116.676-.65 1.193-1.345 1.193Zm14.862-19.83a2.993 2.993 0 0 0 2.627-1.568c.784-1.443.24-3.26-1.175-4.025l-1.62-.98c.026-.089.053-.169.053-.267v-2.51h12.404v4.728c0 .196.053.391.16.56.383.633.97.971 1.639.971.365 0 .748-.098 1.13-.311.125-.072.223-.152.312-.259a1.48 1.48 0 0 1 1.14-.534 1.47 1.47 0 0 1 0 2.939c-.4 0-.775-.16-1.069-.463-.009-.01-.062-.054-.07-.072-.428-.374-.936-.579-1.452-.579-.668 0-1.265.348-1.63.971-.098.17-.151.356-.151.552v4.996h-4.096a.258.258 0 0 1-.054-.134c0-.08.036-.214.187-.4a3.057 3.057 0 0 0 .926-2.2 3.078 3.078 0 0 0-3.072-3.072 3.078 3.078 0 0 0-3.072 3.072c0 .882.374 1.719 1.033 2.297.053.107.08.205.08.276 0 .036-.009.09-.062.152H19.78V38.37a.171.171 0 0 0 .106.035Zm-.115 19.892V44.166h4.55c.018 0 .035-.008.053-.008.054 0 .107-.018.16-.036.054-.018.099-.027.152-.053.018-.01.036-.01.053-.018.633-.383.971-.962.971-1.639 0-.365-.107-.748-.312-1.122a.921.921 0 0 0-.267-.32 1.481 1.481 0 0 1-.534-1.14 1.47 1.47 0 0 1 2.938 0c0 .4-.16.784-.454 1.06-.017.017-.062.07-.08.089-.374.427-.579.935-.579 1.451 0 .668.348 1.264.962 1.63.018.008.045.017.063.026l.07.027c.09.036.179.053.277.053H38.382a.2.2 0 0 1 .053.143c0 .116-.063.25-.17.374a3.03 3.03 0 0 0-.943 2.217 3.078 3.078 0 0 0 3.072 3.072 3.078 3.078 0 0 0 3.072-3.072c0-.89-.383-1.727-1.033-2.297-.116-.24-.089-.356-.018-.437h4.96V58.29H33.787v-3.027a.798.798 0 0 0-.802-.802.798.798 0 0 0-.801.802v3.027H19.77v.01Z", "fill": "#481D72" } })]);
};
var puzzlePeople = {
  render: render$E
};
var render$D = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M39.04 71.54c17.598 0 31.865-14.267 31.865-31.865 0-17.6-14.267-31.866-31.866-31.866S7.174 22.076 7.174 39.675c0 17.598 14.267 31.865 31.865 31.865Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M19.255 21.177 8.274 45.945M29.328 62.297 8.274 45.945M19.255 21.177l28.56-6.08M62.18 37.808 47.815 15.097M62.18 37.808l-23.37 5.226-30.536 2.911M19.255 21.177l10.073 41.12M47.815 15.097 38.81 43.034M19.255 21.177l32.013 35.779M51.268 56.956l-21.94 5.34M8.274 45.945l39.541-30.848", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M9.18 53.25a8.78 8.78 0 1 0 0-17.561 8.78 8.78 0 0 0 0 17.561Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M13.869 46.706a.826.826 0 0 0-.67-.804v-.536a4.022 4.022 0 1 0-8.042 0v.536a.82.82 0 0 0 .084 1.624 4.021 4.021 0 0 0 7.873 0 .828.828 0 0 0 .755-.82Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M7.003 47.71a.503.503 0 1 0 0-1.004.503.503 0 0 0 0 1.005ZM11.359 47.71a.503.503 0 1 0 0-1.004.503.503 0 0 0 0 1.005Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M8.176 48.411a1.81 1.81 0 0 0 2.01 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M13.537 44.36a4.353 4.353 0 0 0-4.356-4.414 4.356 4.356 0 0 0-4.355 4.415v1.005a.334.334 0 0 0 .334.334h.67a.334.334 0 0 0 .336-.334 2.978 2.978 0 0 1 .907-2.138.667.667 0 0 1 .562-.185 1.9 1.9 0 0 1 1.116.549 2.527 2.527 0 0 0 3.107.412c.168.326.276.68.318 1.045a.358.358 0 0 0 .354.319h.67a.336.336 0 0 0 .335-.336l.002-.671Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M13.537 44.36a4.353 4.353 0 0 0-4.356-4.414 4.356 4.356 0 0 0-4.355 4.415v1.005a.334.334 0 0 0 .334.334h.67a.334.334 0 0 0 .336-.334 2.978 2.978 0 0 1 .907-2.138.667.667 0 0 1 .562-.185 1.9 1.9 0 0 1 1.116.549 2.527 2.527 0 0 0 3.107.412c.168.326.276.68.318 1.045a.358.358 0 0 0 .354.319h.67a.336.336 0 0 0 .335-.336l.002-.671Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M11.857 44.004a.21.21 0 0 0-.051-.383 2.28 2.28 0 0 1-1.283-.936", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M7.674 46.37a.503.503 0 1 0 0-1.005.503.503 0 0 0 0 1.005ZM10.689 46.37a.503.503 0 1 0 0-1.005.503.503 0 0 0 0 1.005Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M9.18 40.004a4.343 4.343 0 0 1 3.075 1.269c.178-.28.273-.604.276-.935 0-1.295-1.5-2.346-3.35-2.346-1.851 0-3.347 1.05-3.347 2.346.002.331.096.655.273.935a4.344 4.344 0 0 1 3.073-1.269ZM47.376 23.715a8.78 8.78 0 1 0 0-17.56 8.78 8.78 0 0 0 0 17.56Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M53.071 17.214a.936.936 0 0 0-.76-.91v-.608a4.556 4.556 0 0 0-9.112 0v.607a.93.93 0 0 0 .096 1.841 4.557 4.557 0 0 0 8.922 0 .94.94 0 0 0 .854-.93Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M53.071 17.214a.936.936 0 0 0-.76-.91v-.608a4.556 4.556 0 0 0-9.112 0v.607a.93.93 0 0 0 .096 1.841 4.557 4.557 0 0 0 8.922 0 .94.94 0 0 0 .854-.93Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M46.047 16.833a.57.57 0 1 0 0-1.139.57.57 0 0 0 0 1.14ZM49.464 16.833a.57.57 0 1 0 0-1.139.57.57 0 0 0 0 1.14Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M45.288 18.352a.57.57 0 1 0 0-1.14.57.57 0 0 0 0 1.14ZM50.223 18.352a.57.57 0 1 0 0-1.14.57.57 0 0 0 0 1.14Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M46.617 19.146a2.053 2.053 0 0 0 2.278 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M42.82 12.275v3.417a.38.38 0 0 0 .38.38h.383l1.514-3.797H42.82Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.691 12.657a3.038 3.038 0 0 0-3.037-3.037h-3.417a.758.758 0 0 1-.69-.442.545.545 0 0 0-.45-.318h-.644a2.356 2.356 0 0 0-2.383 2.06 2.279 2.279 0 0 0 2.019 2.482 2.084 2.084 0 0 0 1.767 1.532h.76a.138.138 0 0 0 .07-.255 1.545 1.545 0 0 1-.7-.927.261.261 0 0 1 .25-.337h3.102a.759.759 0 0 1 .537.223l2.056 2.055h.38a.38.38 0 0 0 .38-.38v-2.656Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M52.691 12.657a3.038 3.038 0 0 0-3.037-3.037h-3.417a.758.758 0 0 1-.69-.442.545.545 0 0 0-.45-.318h-.644a2.356 2.356 0 0 0-2.383 2.06 2.279 2.279 0 0 0 2.019 2.482 2.084 2.084 0 0 0 1.767 1.532h.76a.138.138 0 0 0 .07-.255 1.545 1.545 0 0 1-.7-.927.261.261 0 0 1 .25-.337h3.102a.759.759 0 0 1 .537.223l2.056 2.055h.38a.38.38 0 0 0 .38-.38v-2.656Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m62.22 53.284-3.188 3.188 5.579 5.578 3.187-3.188-5.578-5.578Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m78.636 72.74-.152.152a3.288 3.288 0 0 1-4.631 0l-10.066-10.07a1.096 1.096 0 0 1 0-1.543l3.24-3.24a1.095 1.095 0 0 1 1.542 0l10.067 10.066a3.267 3.267 0 0 1 0 4.635Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m78.636 72.74-.152.152a3.288 3.288 0 0 1-4.631 0l-10.066-10.07a1.096 1.096 0 0 1 0-1.543l3.24-3.24a1.095 1.095 0 0 1 1.542 0l10.067 10.066a3.267 3.267 0 0 1 0 4.635Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M58.294 58.937c7.964-4.873 10.47-15.28 5.596-23.245-4.874-7.964-15.281-10.47-23.245-5.596-7.964 4.874-10.47 15.28-5.596 23.245 4.873 7.964 15.28 10.47 23.245 5.596Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M59.032 34.954a13.523 13.523 0 0 1-17.077 20.808 13.524 13.524 0 1 1 17.078-20.808Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M49.143 51a9.017 9.017 0 0 0-7.699 4.406 13.538 13.538 0 0 0 15.581.331A8.997 8.997 0 0 0 49.143 51Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M49.143 51a9.017 9.017 0 0 0-7.699 4.406 13.538 13.538 0 0 0 15.581.331A8.997 8.997 0 0 0 49.143 51Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.815 51.434a6.873 6.873 0 0 0-.434-.123.78.78 0 0 1-.59-.758v-2.691h-3.168v2.66a.78.78 0 0 1-.597.759 8.603 8.603 0 0 0-.545.15l-.019.024a2.69 2.69 0 0 0 5.368 0l-.015-.021Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M56.276 41.193a7.17 7.17 0 0 1-14.34 0c0-3.964 2.024-7.074 4.083-7.665a.995.995 0 0 1 .981.255c2.229 2.242 9.276-.552 9.276 7.41Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M56.276 41.193a7.17 7.17 0 0 1-14.34 0c0-3.964 2.024-7.074 4.083-7.665a.995.995 0 0 1 .981.255c2.229 2.242 9.276-.552 9.276 7.41Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m55.088 42.986-1.204.597-.868-3.038a1.186 1.186 0 0 0-1.395-.842 10.858 10.858 0 0 1-5.033 0 1.187 1.187 0 0 0-1.395.842l-.868 3.038-1.185-.597c-1.706 0-1.593 2.987.298 2.987h.005a5.934 5.934 0 0 0 11.341 0c1.894 0 2.009-2.987.304-2.987Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M47.254 43.841a.706.706 0 1 0 0-1.412.706.706 0 0 0 0 1.412ZM50.985 43.841a.706.706 0 1 0 0-1.412.706.706 0 0 0 0 1.412Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M46.133 44.778a.597.597 0 1 1-1.195 0 .597.597 0 0 1 1.194 0ZM53.302 44.778a.597.597 0 1 1-1.194 0 .597.597 0 0 1 1.194 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M47.628 46.716a2.695 2.695 0 0 0 2.986 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M59.032 34.954a13.523 13.523 0 0 1-17.077 20.808 13.524 13.524 0 1 1 17.078-20.808Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.07 66.567a5.586 5.586 0 1 0 0-11.173 5.586 5.586 0 0 0 0 11.173Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M27.274 60.85a1.798 1.798 0 0 0 3.594 0v-.898a1.797 1.797 0 1 0-3.594 0v.899Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M32.805 65.134a5.585 5.585 0 0 1-7.466 0 4.043 4.043 0 0 1 7.462-.006", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M32.805 65.134a5.585 5.585 0 0 1-7.466 0 4.043 4.043 0 0 1 7.462-.006", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M27.29 59.72a1.797 1.797 0 0 1 3.274-.768 3.275 3.275 0 0 1-3.275.768Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M19.475 26.269a5.586 5.586 0 1 0 0-11.172 5.586 5.586 0 0 0 0 11.172Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M17.677 20.553a1.798 1.798 0 0 0 3.595 0v-.899a1.798 1.798 0 0 0-3.595 0v.899Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M23.209 24.837a5.588 5.588 0 0 1-7.466 0 4.042 4.042 0 0 1 7.461-.006", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M23.209 24.837a5.588 5.588 0 0 1-7.466 0 4.042 4.042 0 0 1 7.461-.006", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M17.693 19.422a1.796 1.796 0 0 1 3.275-.768 3.275 3.275 0 0 1-3.275.768Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var searchingNetwork = {
  render: render$D
};
var render$C = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 72 72", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "m24.66 15.45-.09-.03a1.21 1.21 0 0 0-1.11.13c-.29.2-.46.51-.46.85v38.91c0 .34.17.65.46.85.33.22.74.27 1.11.13a.47.47 0 0 1 .16-.04l12.72-2.26c.04-.01.08 0 .12 0V18.75c-.06 0-.12.01-.19-.01l-12.72-3.29Zm1.08 16.49v-1.63c0-1.38.69-2.64 1.79-3.28a3.4 3.4 0 0 1 1.05-.38c-.41-.73-.65-1.6-.61-2.52.05-1.19.57-2.21 1.41-2.77.72-.49 1.63-.59 2.49-.29.47.17.71.68.55 1.15-.16.47-.68.71-1.15.55-.32-.12-.63-.09-.88.09-.36.25-.59.74-.62 1.36-.06 1.34.83 2.45 1.66 2.56.01 0 .01 0 .02.01l.25.03c.49.06.84.51.78 1-.06.49-.51.84-1 .78-1.57-.2-2.27-.19-2.27-.19-.29 0-.54.06-.77.19-.55.32-.89.98-.89 1.72v1.63c0 .5-.4.9-.9.9-.5-.01-.9-.41-.91-.91Zm1.32 5.19 6.5-.45c.49-.05.93.34.96.84.03.5-.34.92-.84.96l-6.5.45h-.06c-.47 0-.86-.36-.9-.84a.91.91 0 0 1 .84-.96Zm6.82 8.35-6.57 1.41a.898.898 0 0 1-1.07-.69.91.91 0 0 1 .69-1.07l6.57-1.41c.49-.1.96.21 1.07.69.11.48-.2.96-.69 1.07ZM63.22 18.36 40.94 9.88c-.14-.05-.29-.08-.44-.08-.24 0-.48.07-.68.21-.29.2-.46.51-.46.85v50c0 .34.17.65.46.85.33.22.74.27 1.11.13l22.28-8.48c.43-.16.71-.55.71-.98V19.34c.01-.43-.27-.81-.7-.98ZM43.76 31.88c-.5 0-.9-.4-.9-.9v-2.03c0-1.65.86-3.15 2.24-3.9.52-.28 1.09-.44 1.68-.48a5.46 5.46 0 0 1-.97-3.3c.07-1.37.67-2.55 1.66-3.23.89-.61 2.01-.75 3.09-.39 1.97.66 3.38 2.85 3.27 5.11-.04.92-.35 1.78-.86 2.45.13.03.2.05.22.05.49.1.99.37 1.42.77.81.75 1.29 1.92 1.3 3.13l.01 2.06c0 .5-.31.65-1.31.65l-10.85.01Zm16.69 14.16-15.53 3.34a.898.898 0 0 1-1.07-.69.91.91 0 0 1 .69-1.07l15.53-3.34c.49-.1.96.21 1.07.69.1.49-.2.97-.69 1.07Zm-.13-7.65-15.53 1.07h-.06c-.47 0-.86-.36-.9-.84-.03-.5.34-.92.84-.96L60.2 36.6a.898.898 0 1 1 .12 1.79ZM10.37 19.92c-.37-.14-.79-.09-1.11.13-.29.2-.46.51-.46.85v29.89c0 .34.17.65.46.85.32.22.74.27 1.11.13l.1-.03 10.72-2.69V22.69l-10.72-2.74c-.03-.01-.06-.02-.1-.03Zm7.06 23.63-5.13 1.1a.898.898 0 0 1-1.07-.69c-.1-.48.21-.96.69-1.06l5.13-1.1c.49-.1.96.21 1.07.69.11.48-.2.96-.69 1.06Zm.71-6.26c.03.5-.34.92-.84.96l-5.13.35h-.06c-.47 0-.86-.36-.9-.84-.03-.5.34-.92.84-.96l5.13-.35c.49-.04.93.34.96.84Zm-5.85-8.58c.19-.12.4-.21.61-.27-.26-.56-.4-1.21-.37-1.88.04-1.04.48-1.91 1.2-2.39.59-.39 1.33-.47 2.01-.21.46.18.7.7.52 1.16-.18.46-.7.7-1.16.52-.19-.07-.31-.02-.38.03-.18.12-.37.43-.39.96-.04.95.52 1.77 1.03 1.84.01 0 .01 0 .02.01.06.01.12.01.18.02a.9.9 0 0 1 .77 1.01.9.9 0 0 1-1.01.77c-1.15-.16-1.63-.15-1.64-.15-.18 0-.31.03-.43.11-.35.21-.57.69-.57 1.22v1.29c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-1.29c-.01-1.15.54-2.2 1.41-2.75Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M63.86 16.68 41.58 8.2c-.93-.35-1.96-.23-2.78.33-.79.54-1.24 1.39-1.24 2.33v6.07l-12.4-3.21a2.99 2.99 0 0 0-2.72.35c-.79.54-1.24 1.39-1.24 2.33v4.43l-10.24-2.61a2.99 2.99 0 0 0-2.72.35C7.45 19.11 7 19.96 7 20.9v29.89c0 .94.45 1.79 1.24 2.33a2.996 2.996 0 0 0 2.72.35l10.23-2.56v4.41c0 .94.45 1.79 1.24 2.33a2.996 2.996 0 0 0 2.69.36l12.44-2.22v5.07c0 .94.45 1.79 1.24 2.33a2.996 2.996 0 0 0 2.78.33l22.28-8.48c1.13-.43 1.87-1.48 1.87-2.66V19.34c0-1.18-.73-2.23-1.87-2.66ZM21.19 49.05l-10.71 2.68-.1.03c-.38.15-.8.1-1.12-.13-.29-.2-.46-.51-.46-.85V20.9c0-.34.17-.65.46-.85.33-.22.74-.27 1.12-.13.03.01.06.02.1.03l10.72 2.74v26.36h-.01Zm16.37 4.94c-.04 0-.08-.01-.12 0l-12.72 2.26c-.05.01-.11.02-.16.04-.37.14-.79.09-1.11-.13-.29-.2-.46-.51-.46-.85V16.4c0-.34.17-.65.46-.85.32-.22.74-.27 1.11-.13l.09.03 12.72 3.29c.06.02.12.01.19.01v35.24Zm26.37-1.61c0 .43-.28.81-.71.98l-22.28 8.48c-.37.14-.79.09-1.11-.13-.29-.2-.46-.51-.46-.85v-50c0-.34.17-.65.46-.85.2-.14.44-.21.68-.21.15 0 .29.03.44.08l22.28 8.48c.43.16.71.55.71.98v33.04h-.01Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "m55.91 31.22-.01-2.06c0-1.21-.49-2.38-1.3-3.13-.43-.39-.93-.66-1.42-.77-.02-.01-.1-.02-.22-.05.51-.67.82-1.52.86-2.45.1-2.25-1.3-4.45-3.27-5.11-1.08-.36-2.2-.21-3.09.39-.99.68-1.59 1.85-1.66 3.23-.06 1.21.32 2.36.97 3.3-.58.04-1.16.2-1.68.48-1.38.75-2.24 2.25-2.24 3.9v2.03c0 .5.4.9.9.9l10.85-.01c1 0 1.31-.15 1.31-.65Z", "fill": "#16A7A7" } }), _c("path", { attrs: { "d": "m60.2 36.6-15.53 1.07c-.5.03-.87.46-.84.96.03.48.43.84.9.84h.06l15.53-1.07c.5-.03.87-.46.84-.96-.04-.5-.47-.88-.96-.84ZM60.07 44.28l-15.53 3.34c-.49.1-.79.58-.69 1.07a.898.898 0 0 0 1.07.69l15.53-3.34c.49-.1.79-.58.69-1.07a.904.904 0 0 0-1.07-.69ZM26.65 32.84c.5 0 .9-.4.9-.9v-1.63c0-.74.34-1.4.89-1.72.22-.13.47-.19.77-.19 0 0 .69 0 2.27.19.5.06.94-.29 1-.78a.899.899 0 0 0-.78-1l-.25-.03c-.01 0-.01 0-.02-.01-.83-.11-1.72-1.22-1.66-2.56.03-.62.25-1.11.62-1.36.25-.17.56-.2.88-.09.47.17.98-.08 1.15-.55a.899.899 0 0 0-.55-1.15c-.86-.3-1.76-.2-2.49.29-.84.57-1.36 1.58-1.41 2.77-.04.92.2 1.79.61 2.52-.37.06-.72.18-1.05.38-1.11.64-1.79 1.89-1.79 3.28v1.63c.01.51.41.91.91.91ZM27.12 38.93h.06l6.5-.45c.5-.03.87-.46.84-.96a.898.898 0 0 0-.96-.84l-6.5.45c-.5.03-.87.46-.84.96.03.48.43.84.9.84ZM33.5 43.72l-6.57 1.41c-.49.1-.79.58-.69 1.07a.898.898 0 0 0 1.07.69l6.57-1.41c.49-.1.79-.58.69-1.07a.89.89 0 0 0-1.07-.69ZM11.78 33.65c.5 0 .9-.4.9-.9v-1.29c0-.52.22-1 .57-1.22.12-.08.25-.11.43-.11 0 0 .49 0 1.64.15.5.07.95-.28 1.01-.77a.894.894 0 0 0-.77-1.01c-.07-.01-.12-.02-.18-.02-.01 0-.01 0-.02-.01-.51-.07-1.07-.89-1.03-1.84.02-.53.22-.84.39-.96.07-.05.19-.1.38-.03a.898.898 0 1 0 .64-1.68c-.69-.26-1.42-.19-2.01.21-.72.47-1.16 1.35-1.2 2.39-.03.67.11 1.32.37 1.88-.21.06-.42.15-.61.27-.88.54-1.42 1.6-1.42 2.75v1.29c.01.5.41.9.91.9ZM11.21 37.77c.03.48.43.84.9.84h.06l5.13-.35c.5-.03.87-.46.84-.96a.898.898 0 0 0-.96-.84l-5.13.35c-.5.03-.87.46-.84.96ZM17.06 41.79l-5.13 1.1c-.49.1-.8.58-.69 1.07a.898.898 0 0 0 1.07.69l5.13-1.1c.49-.1.8-.58.69-1.07a.914.914 0 0 0-1.07-.69Z", "fill": "#481D72" } })]);
};
var services = {
  render: render$C
};
var render$B = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "viewBox": "0 0 72 72", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M42.93 11.55 28.62 44.493l5.505 2.39 14.31-32.942-5.505-2.391Z", "fill": "#16A7A7" } }), _c("path", { attrs: { "d": "m54.815 22.373-2.365 2.365 2.365 2.366 2.366-2.366-2.366-2.365Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M28.333 52.134c0 .128.076.191.14.217a.25.25 0 0 0 .268-.051l4.163-3.869-4.584-1.992.013 5.695Z", "fill": "#16A7A7" } }), _c("path", { attrs: { "d": "m14.867 17.96-4.171 4.171 4.171 4.171 4.171-4.17-4.17-4.172Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M50.537 9.118c.319-.74.331-1.545.038-2.298a2.97 2.97 0 0 0-1.596-1.648 2.988 2.988 0 0 0-2.298-.038 2.97 2.97 0 0 0-1.648 1.596l-1.327 3.065 5.503 2.387 1.328-3.064Z", "fill": "#16A7A7" } }), _c("path", { attrs: { "d": "M4.341 63.242h52.86l-9.04-26.52H40.63L35.432 48.7l-5.376 5.005a2.136 2.136 0 0 1-1.455.588c-.294 0-.587-.064-.868-.179-.805-.345-1.29-1.11-1.303-1.98l-.012-7.34 3.498-8.057H17.773c-1.57 0-3.026.855-3.804 2.208L2.235 59.63a2.399 2.399 0 0 0 .012 2.413 2.396 2.396 0 0 0 2.094 1.2Zm32.278-13.24h6.96v1.915h-6.96v-1.915Zm-25.69 0h12.692v1.915H10.93v-1.915Zm0 4.915h32.023v1.916H10.93v-1.916ZM67.659 65.157H4.34c-.88 0-1.71-.268-2.413-.727v.37a2.47 2.47 0 0 0 .702 1.762c.447.46 1.06.715 1.724.715H67.67c.652 0 1.265-.255 1.724-.715a2.49 2.49 0 0 0 .703-1.762l-.013-.37a4.368 4.368 0 0 1-2.426.727ZM58.044 38.944a4.382 4.382 0 0 0-3.804-2.209h-4.06l9.04 26.52h8.426c.868 0 1.647-.447 2.094-1.2a2.399 2.399 0 0 0 .013-2.413L58.044 38.944Zm.498 10.304c-1.608 0-2.873-.957-2.873-2.196 0-1.238 1.265-2.196 2.873-2.196 1.61 0 2.873.958 2.873 2.196 0 1.239-1.264 2.196-2.873 2.196Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M57.572 47.116c.051 0 .409.23.97.23.486 0 .818-.166.932-.281-.114-.102-.446-.28-.932-.28-.574 0-.919.229-.97.331Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M71.987 60.562a4.307 4.307 0 0 0-.549-1.877L59.704 38a6.277 6.277 0 0 0-5.465-3.18H41.46l9.499-21.871 1.328-3.065a4.879 4.879 0 0 0 .064-3.766 4.863 4.863 0 0 0-2.618-2.707 4.878 4.878 0 0 0-3.766-.064 4.863 4.863 0 0 0-2.707 2.618L41.548 9.91 30.733 34.82H17.761A6.304 6.304 0 0 0 12.296 38L.562 58.685a4.308 4.308 0 0 0-.55 1.877c0 .025-.012.05-.012.076v.23l.013 4.865h.09c.165.804.56 1.57 1.148 2.17a4.305 4.305 0 0 0 3.09 1.29H67.66c1.174 0 2.272-.46 3.09-1.29.587-.6.983-1.366 1.149-2.17H72V60.638c0-.026-.013-.038-.013-.076ZM45.021 6.73a2.97 2.97 0 0 1 1.647-1.596 2.989 2.989 0 0 1 2.298.038 2.97 2.97 0 0 1 1.596 1.647c.294.74.281 1.558-.038 2.298l-1.328 3.065-5.503-2.388 1.328-3.064Zm-2.094 4.813 5.503 2.388-14.313 32.942-5.503-2.388 14.313-32.942Zm-10.023 36.9-4.163 3.87c-.102.089-.191.076-.268.05a.221.221 0 0 1-.14-.217l-.013-5.682 4.584 1.98ZM2.234 59.63l11.734-20.684a4.383 4.383 0 0 1 3.805-2.209h12.143l-3.499 8.057.013 7.342c0 .868.498 1.621 1.303 1.979.28.127.574.178.868.178.536 0 1.047-.204 1.455-.587l5.376-5.005 5.197-11.977h7.533l9.04 26.52H4.342a2.412 2.412 0 0 1-2.095-1.2c-.447-.754-.434-1.648-.013-2.414Zm67.148 6.946a2.38 2.38 0 0 1-1.723.715H4.34a2.424 2.424 0 0 1-1.724-.715 2.49 2.49 0 0 1-.702-1.762l.013-.37c.702.472 1.52.728 2.413.728H67.66c.88 0 1.71-.268 2.413-.728l.013.37a2.49 2.49 0 0 1-.703 1.762Zm.37-4.532a2.396 2.396 0 0 1-2.093 1.2h-8.427l-9.053-26.507h4.06c1.57 0 3.027.855 3.805 2.209l11.734 20.684a2.43 2.43 0 0 1-.025 2.414Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M58.542 44.869c-1.608 0-2.873.957-2.873 2.196 0 1.239 1.265 2.196 2.873 2.196 1.61 0 2.873-.958 2.873-2.196 0-1.239-1.264-2.196-2.873-2.196Zm0 2.464c-.562 0-.906-.23-.97-.23.051-.102.396-.332.97-.332.486 0 .817.166.932.281-.114.115-.446.281-.932.281ZM13.739 27.874a1.575 1.575 0 0 0 2.247 0l4.622-4.622a1.595 1.595 0 0 0 0-2.26l-4.622-4.622a1.607 1.607 0 0 0-2.26 0l-4.622 4.622a1.595 1.595 0 0 0 0 2.26l4.635 4.622Zm1.123-9.92 4.175 4.175-4.175 4.175-4.175-4.175 4.175-4.176ZM50.868 25.857l2.822 2.822c.307.306.715.472 1.124.472.408 0 .817-.153 1.123-.472l2.822-2.822a1.595 1.595 0 0 0 0-2.26l-2.822-2.822a1.595 1.595 0 0 0-2.26 0l-2.821 2.822c-.6.626-.6 1.647.012 2.26Zm3.959-3.486 2.362 2.362-2.362 2.375-2.375-2.375 2.375-2.362ZM42.952 54.917H10.93v1.916h32.022v-1.916ZM23.621 50.002H10.93v1.915H23.62v-1.915ZM43.578 50.002h-6.959v1.915h6.959v-1.915Z", "fill": "#481D72" } })]);
};
var signTablet = {
  render: render$B
};
var render$A = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 46.857a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M36.806 70.023a.84.84 0 0 1-.84.84h-6.72a.84.84 0 0 1-.84-.84v-15.96a2.519 2.519 0 0 1 2.52-2.52h3.36a2.52 2.52 0 0 1 2.52 2.52v15.96Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M36.806 70.023a.84.84 0 0 1-.84.84h-6.72a.84.84 0 0 1-.84-.84v-15.96a2.519 2.519 0 0 1 2.52-2.52h3.36a2.52 2.52 0 0 1 2.52 2.52v15.96Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.452 70.023a.84.84 0 0 1-.84.84h-6.72a.84.84 0 0 1-.84-.84V47.76a2.52 2.52 0 0 1 2.52-2.52h3.36a2.52 2.52 0 0 1 2.52 2.52v22.263Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M44.052 51.12a2.515 2.515 0 0 1 2.52-2.52h3.36a2.517 2.517 0 0 1 2.52 2.52v-3.36a2.52 2.52 0 0 0-2.52-2.52h-3.36a2.52 2.52 0 0 0-2.52 2.52v3.36Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M52.452 70.023a.84.84 0 0 1-.84.84h-6.72a.84.84 0 0 1-.84-.84V47.76a2.52 2.52 0 0 1 2.52-2.52h3.36a2.52 2.52 0 0 1 2.52 2.52v22.263Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.502 69.023v-.018a4.646 4.646 0 0 0-4.645-4.647 4.595 4.595 0 0 0-1.275.2 9.292 9.292 0 0 0-6.16-4.4V45.243h-3.715v14.912a9.291 9.291 0 0 0-6.16 4.4 4.583 4.583 0 0 0-5.92 4.447v.019c-2.885.491-4.649 1.133-4.649 1.84H67.15c0-.701-1.763-1.347-4.648-1.838Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M15.045 71.976c0 .151.63.301 1.854.44 1.224.14 3.019.268 5.28.375 2.263.106 4.948.191 7.904.25 2.955.057 6.123.087 9.322.087 3.199 0 6.367-.03 9.322-.088 2.956-.058 5.641-.143 7.903-.25 2.262-.106 4.056-.233 5.28-.373 1.225-.14 1.855-.29 1.855-.441 0-.151-.63-.301-1.854-.44-1.225-.14-3.019-.268-5.281-.375a292.36 292.36 0 0 0-7.903-.25 481.158 481.158 0 0 0-9.322-.087c-3.2 0-6.367.03-9.322.088-2.956.058-5.641.142-7.903.25-2.262.106-4.057.233-5.28.373-1.225.14-1.855.29-1.855.441Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M62.502 69.023v-.018a4.646 4.646 0 0 0-4.645-4.647 4.595 4.595 0 0 0-1.275.2 9.292 9.292 0 0 0-6.16-4.4V45.243h-3.715v14.912a9.291 9.291 0 0 0-6.16 4.4 4.583 4.583 0 0 0-5.92 4.447v.019c-2.885.491-4.649 1.133-4.649 1.84H67.15c0-.701-1.763-1.347-4.648-1.838Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M23.366 70.023a.84.84 0 0 1-.84.84h-6.72a.84.84 0 0 1-.84-.84v-5.88a2.52 2.52 0 0 1 2.52-2.52h3.36a2.52 2.52 0 0 1 2.52 2.52v5.88Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M23.366 70.023a.84.84 0 0 1-.84.84h-6.72a.84.84 0 0 1-.84-.84v-5.88a2.52 2.52 0 0 1 2.52-2.52h3.36a2.52 2.52 0 0 1 2.52 2.52v5.88Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M57.624 15.929c.769-7.41-8.633-14.786-9.232-14.786-.6 0-10.011 7.286-9.232 14.786l3.64 23.46h11.187l3.637-23.46Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M51.54 39.138h-6.292a17.68 17.68 0 0 0-1.574 6.592c0 2.49 2.689 7.61 4.005 9.97a.855.855 0 0 0 1.421 0c1.318-2.358 4.01-7.478 4.01-9.967a17.678 17.678 0 0 0-1.57-6.595Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M49.179 39.138s1.964 4.393-.08 7.665a.88.88 0 0 1-1.408 0c-2.046-3.274-.08-7.665-.08-7.665h1.568Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M57.624 15.929c.769-7.41-8.633-14.786-9.232-14.786-.6 0-10.011 7.286-9.232 14.786l3.64 23.46h11.187l3.637-23.46Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m42.048 34.566.748 4.824h11.191l.748-4.824H42.048Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.3 14.623a4.092 4.092 0 1 0 8.184 0 4.092 4.092 0 0 0-8.184 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M44.3 14.623a4.092 4.092 0 1 0 8.184 0 4.092 4.092 0 0 0-8.184 0ZM48.392 29.742v9.648", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m55.444 29.994-1.457 9.396 4.973 5.396s6.273-9.167-3.516-14.792ZM37.827 44.786 42.8 39.39l-1.456-9.396c-9.794 5.625-3.517 14.792-3.517 14.792Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M13.204 70.863h16.042", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var startupBarChart = {
  render: render$A
};
var render$z = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M71.908 41.942a32 32 0 1 0-61.149 13.2h58.298a31.86 31.86 0 0 0 2.851-13.2Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M8.708 55.142h62.4M5.108 55.142h2M72.708 55.142h2", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M60.666 43.835a3.21 3.21 0 0 1-3.21-3.209 3.209 3.209 0 0 1-6.418 0 3.209 3.209 0 0 1-6.417 0 3.21 3.21 0 0 1-6.419 0 3.209 3.209 0 0 1-6.417 0 3.208 3.208 0 1 1-6.418 0 3.209 3.209 0 0 1-3.847 3.145v18.035h39.787V43.77a3.267 3.267 0 0 1-.641.064Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M35.636 51.537a5.135 5.135 0 0 0-10.269 0v3.85h10.269v-3.85ZM21.516 27h39.791v5.283h-39.79v-5.282Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M63.874 38.7H18.95l2.567-6.417h39.791l2.567 6.418ZM18.949 38.7v1.926a3.21 3.21 0 0 0 6.418 0v-1.925H18.95Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M25.367 38.7v1.926a3.209 3.209 0 0 0 6.418 0v-1.925h-6.418Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M31.785 38.7v1.926a3.208 3.208 0 1 0 6.417 0v-1.925h-6.417ZM38.203 38.7v1.926a3.21 3.21 0 0 0 6.418 0v-1.925h-6.418Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M44.62 38.7v1.926a3.209 3.209 0 0 0 6.418 0v-1.925h-6.417ZM51.04 38.7v1.926a3.209 3.209 0 0 0 6.418 0v-1.925H51.04Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M57.456 38.7v1.926a3.21 3.21 0 0 0 6.418 0v-1.925h-6.418ZM25.367 55.387h10.269v6.418H25.367v-6.418Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M54.247 43.835a3.21 3.21 0 0 1-3.144-2.567h-.13a3.209 3.209 0 0 1-6.288 0h-.125a3.194 3.194 0 0 1-5.07 1.911v13.706a1.07 1.07 0 0 0 1.07 1.07h15.826a1.07 1.07 0 0 0 1.07-1.07V41.268h-.064a3.21 3.21 0 0 1-3.145 2.567ZM14.856 50.348c0 3.394-1.095 6.145-2.446 6.145-1.35 0-2.446-2.75-2.446-6.145 0-3.394 2.446-12.371 2.446-12.371s2.446 8.977 2.446 12.371Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M21.516 27h39.791v5.283h-39.79v-5.282ZM60.666 43.835a3.21 3.21 0 0 1-3.21-3.209 3.209 3.209 0 0 1-6.418 0 3.209 3.209 0 0 1-6.417 0 3.21 3.21 0 0 1-6.419 0 3.209 3.209 0 0 1-6.417 0 3.208 3.208 0 1 1-6.418 0 3.209 3.209 0 0 1-3.847 3.145v18.035h39.787V43.77a3.267 3.267 0 0 1-.641.064ZM14.856 50.348c0 3.394-1.095 6.145-2.446 6.145-1.35 0-2.446-2.75-2.446-6.145 0-3.394 2.446-12.371 2.446-12.371s2.446 8.977 2.446 12.371Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M30.502 46.402v15.404M25.367 51.537h10.269", "stroke": "#260347", "stroke-width": ".75" } }), _c("path", { attrs: { "d": "M63.874 38.7H18.95l2.567-6.417h39.791l2.567 6.418ZM35.636 51.537a5.135 5.135 0 0 0-10.269 0v3.85h10.269v-3.85ZM30.502 46.402v15.404", "stroke": "#260347", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M25.367 55.387h10.269v6.418H25.367v-6.418ZM25.367 51.537h10.269M18.949 38.7v1.926a3.21 3.21 0 0 0 6.418 0v-1.925H18.95ZM25.367 38.7v1.926a3.209 3.209 0 0 0 6.418 0v-1.925h-6.418Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M31.785 38.7v1.926a3.208 3.208 0 1 0 6.417 0v-1.925h-6.417ZM38.203 38.7v1.926a3.21 3.21 0 0 0 6.418 0v-1.925h-6.418Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.62 38.7v1.926a3.209 3.209 0 0 0 6.418 0v-1.925h-6.417ZM51.04 38.7v1.926a3.209 3.209 0 0 0 6.418 0v-1.925H51.04Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M57.456 38.7v1.926a3.21 3.21 0 0 0 6.418 0v-1.925h-6.418ZM54.247 43.835a3.21 3.21 0 0 1-3.144-2.567h-.13a3.209 3.209 0 0 1-6.288 0h-.125a3.194 3.194 0 0 1-5.07 1.911v13.706a1.07 1.07 0 0 0 1.07 1.07h15.826a1.07 1.07 0 0 0 1.07-1.07V41.268h-.064a3.21 3.21 0 0 1-3.145 2.567Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M72.324 10.142c-.316.001-.63.062-.924.178a4.262 4.262 0 0 0-8.42 0 2.567 2.567 0 0 0-3.439 1.925 2.565 2.565 0 0 0 2.515 3.035h10.268a2.567 2.567 0 1 0 0-5.134v-.005Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75" } }), _c("path", { attrs: { "d": "M72.324 10.142c-.316.001-.63.062-.924.178a4.262 4.262 0 0 0-8.42 0 2.567 2.567 0 0 0-3.439 1.925 2.565 2.565 0 0 0 2.515 3.035h10.268a2.567 2.567 0 1 0 0-5.134v-.005Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M12.41 56.493v5.313", "stroke": "#260347", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M20.233 23.398H62.59v3.604H20.233v-3.604Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linejoin": "round" } })]);
};
var storeFront = {
  render: render$z
};
var render$y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M43.2 22.4h2.4v15.2h-2.4V22.4Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M43.2 22.4h2.4v15.2h-2.4V22.4Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.488 13.207h-2.841a20.514 20.514 0 0 1-6.57-1.066 20.516 20.516 0 0 0-6.57-1.066h-2.842a.421.421 0 0 0-.465.356v11.66a.422.422 0 0 0 .465.355h2.842a20.516 20.516 0 0 1 6.57 1.066c2.117.71 4.336 1.07 6.57 1.065h2.841a.42.42 0 0 0 .465-.355l-5.348-5.83 5.348-5.831a.42.42 0 0 0-.465-.354Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m25.004 68.27 30.531-.294a32.07 32.07 0 0 0 4.25-2.835L50.03 38.388a2.4 2.4 0 0 0-1.731-1.563l-6.762-1.56a2.4 2.4 0 0 0-2.88 1.799l-3.829 16.6a2.4 2.4 0 0 1-2.339 1.861h-3.228a2.402 2.402 0 0 0-1.977 1.04l-6.304 9.169a32.008 32.008 0 0 0 4.023 2.535Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M39.28 58.734a.597.597 0 0 1-.469.47.598.598 0 0 0 .043 1.178l2 .25a.8.8 0 0 0 .886-.644l3.02-15.858c.041-.217-.06-1.12-.82-1.155a.8.8 0 0 0-.77.48l-1.538 3.59a.774.774 0 0 0-.049.16l-2.303 11.53Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M57.28 45.458a1.909 1.909 0 0 1 2.611-1.787 3.187 3.187 0 0 1 6.298 0 1.92 1.92 0 1 1 .69 3.707H59.2a1.92 1.92 0 0 1-1.92-1.92Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M57.28 45.458a1.909 1.909 0 0 1 2.611-1.787 3.187 3.187 0 0 1 6.298 0 1.92 1.92 0 1 1 .69 3.707H59.2a1.92 1.92 0 0 1-1.92-1.92ZM17.334 36.071c.301.002.6.06.88.17a4.072 4.072 0 0 1 8.046 0 2.45 2.45 0 1 1 .88 4.737h-9.806a2.454 2.454 0 1 1 0-4.907Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M17.334 36.071c.301.002.6.06.88.17a4.072 4.072 0 0 1 8.046 0 2.45 2.45 0 1 1 .88 4.737h-9.806a2.454 2.454 0 1 1 0-4.907Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m51.656 42.846-1.15 9.776a.801.801 0 0 1-.988.683l-1.492-.374a.801.801 0 0 0-.981.63l-2.693 14.525 11.182-.11c1.49-.83 2.912-1.778 4.25-2.835l-8.128-22.295Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m21.65 64.762 5.635-8.197a2.4 2.4 0 0 1 1.977-1.04h3.228a2.4 2.4 0 0 0 2.34-1.86l3.83-16.601a2.4 2.4 0 0 1 2.88-1.8l6.761 1.56a2.4 2.4 0 0 1 1.732 1.564L59.36 63.98", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M58.117 63.2a2.72 2.72 0 0 0-3.291-.297c.01-.105.016-.212.016-.32a3.207 3.207 0 0 0-6.414 0c0 .11.006.215.016.32a2.742 2.742 0 0 0-1.991-.364 5.016 5.016 0 0 0-8.806.661 2.72 2.72 0 0 0-3.291-.297c.01-.105.016-.212.016-.32a3.207 3.207 0 0 0-6.414 0c0 .11.006.215.016.32a2.72 2.72 0 0 0-3.29.297 5.017 5.017 0 0 0-8.166-1.466A31.984 31.984 0 0 0 64.51 60.57a5.005 5.005 0 0 0-6.393 2.63Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M63.49 60.285a5.02 5.02 0 0 0-5.374 2.915 2.72 2.72 0 0 0-3.29-.298c.01-.105.016-.212.016-.32a3.207 3.207 0 0 0-6.414 0c0 .11.006.215.016.32a2.742 2.742 0 0 0-1.991-.364 5.017 5.017 0 0 0-8.806.662 2.72 2.72 0 0 0-3.29-.298c.01-.105.015-.212.015-.32a3.207 3.207 0 0 0-6.413 0c0 .11.005.215.015.32a2.72 2.72 0 0 0-3.29.298 5.02 5.02 0 0 0-7.593-1.972", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var summitFlag = {
  render: render$y
};
var render$x = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8.099 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M25.31 62.854c0 .467 1.609.915 4.471 1.245 2.863.33 6.745.516 10.794.516 4.048 0 7.93-.185 10.793-.516 2.862-.33 4.47-.778 4.47-1.245 0-.468-1.608-.916-4.47-1.246-2.863-.33-6.745-.516-10.794-.516-4.048 0-7.93.186-10.793.516-2.862.33-4.47.778-4.47 1.246Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M21.175 35.006a19.399 19.399 0 1 0 38.798 0 19.399 19.399 0 0 0-38.798 0Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M21.175 35.006a19.399 19.399 0 1 0 38.798 0 19.399 19.399 0 0 0-38.798 0Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M30.364 35.006a10.21 10.21 0 1 0 20.42 0 10.21 10.21 0 0 0-20.42 0Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M30.364 35.006a10.21 10.21 0 1 0 20.42 0 10.21 10.21 0 0 0-20.42 0Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M70.39 54.42a2.771 2.771 0 1 1-5.52 0l1.636-16.357a1.13 1.13 0 0 1 2.245 0l1.64 16.357Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M70.39 54.42a2.771 2.771 0 1 1-5.52 0l1.636-16.357a1.13 1.13 0 0 1 2.245 0l1.64 16.357Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M67.632 37.047a3.063 3.063 0 0 1-3.063-3.063V20.71a6.128 6.128 0 0 1 4.901-6 1.021 1.021 0 0 1 1.224 1.002v18.27a3.062 3.062 0 0 1-3.062 3.064Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M67.632 37.047a3.063 3.063 0 0 1-3.063-3.063V20.71a6.128 6.128 0 0 1 4.901-6 1.021 1.021 0 0 1 1.224 1.002v18.27a3.062 3.062 0 0 1-3.062 3.064Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M15.801 56.462a2.771 2.771 0 1 1-5.52 0l1.64-24.524a1.129 1.129 0 0 1 2.245 0L15.8 56.462Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M15.801 56.462a2.771 2.771 0 1 1-5.52 0l1.64-24.524a1.129 1.129 0 0 1 2.245 0L15.8 56.462Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M18.112 15.606v11.23c0 2.258-1.6 4.086-3.574 4.086h-3.063c-1.97 0-3.574-1.828-3.574-4.085V15.606a1.022 1.022 0 0 1 2.043 0v9.19a1.02 1.02 0 0 0 2.041 0v-9.19a1.022 1.022 0 0 1 2.043 0v9.19a1.02 1.02 0 1 0 2.041 0v-9.19a1.022 1.022 0 0 1 2.043 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M18.112 15.606v11.23c0 2.258-1.6 4.086-3.574 4.086h-3.063c-1.97 0-3.574-1.828-3.574-4.085V15.606a1.022 1.022 0 0 1 2.043 0v9.19a1.02 1.02 0 0 0 2.041 0v-9.19a1.022 1.022 0 0 1 2.043 0v9.19a1.02 1.02 0 1 0 2.041 0v-9.19a1.022 1.022 0 0 1 2.043 0Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var tableware = {
  render: render$x
};
var render$w = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M40 72.914c17.673 0 32-14.327 32-32 0-17.674-14.327-32-32-32-17.673 0-32 14.327-32 32 0 17.673 14.327 32 32 32Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M39.497 67.529c14.116 0 25.56-.716 25.56-1.598 0-.882-11.444-1.597-25.56-1.597-14.116 0-25.56.715-25.56 1.597s11.444 1.598 25.56 1.598Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M35.237 35.578a10.118 10.118 0 0 0-20.236 0v1.6h2.663v7.988h13.84l.005-7.988h3.723l.005-1.6Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M35.237 35.578a10.118 10.118 0 0 0-20.236 0v1.6h2.663v7.988h13.84l.005-7.988h3.723l.005-1.6Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M27.538 25.76a.8.8 0 0 1-.61-.779v-2.856h-4.632v3.153a.8.8 0 0 1-.536.754c-.146.053-.29.107-.432.16l3.26 5.12 3.375-5.304.075-.118c-.165-.046-.332-.09-.5-.13Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M24.586 9.75a6.391 6.391 0 0 1 6.39 6.39v.853a1.305 1.305 0 0 1-.134 2.582 6.39 6.39 0 0 1-12.645-1.305v-2.13a6.39 6.39 0 0 1 6.39-6.39Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M17.664 45.163v16.553c.176-.03.354-.045.533-.045h4.26l.423-10.06a1.71 1.71 0 0 1 3.42 0l.32 10.123a3.23 3.23 0 0 1 .631-.063h4.26V45.163H17.664Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M17.664 45.163v16.553c.176-.03.354-.045.533-.045h4.26l.423-10.06a1.71 1.71 0 0 1 3.42 0l.32 10.123a3.23 3.23 0 0 1 .631-.063h4.26V45.163H17.664Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M25.385 16.14a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6ZM21.126 16.14a.8.8 0 1 0 0 1.602.8.8 0 0 0 0-1.601Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M27.515 19.868a.798.798 0 1 0 0-1.597.798.798 0 0 0 0 1.597Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M25.12 20.982a2.88 2.88 0 0 1-3.195 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M17.664 14.543a6.922 6.922 0 1 1 13.845 0v2.13a5.496 5.496 0 0 1-3.727-3.195c-2.982 2.008-6.923 1.598-10.118 1.065Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M17.664 14.543a6.922 6.922 0 1 1 13.845 0v2.13a5.496 5.496 0 0 1-3.727-3.195c-2.982 2.008-6.923 1.598-10.118 1.065Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M28.846 12.413c-.27.43-.634.794-1.064 1.065M31.509 37.176V33.98M17.664 37.176V33.98", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M15.002 64.866a3.193 3.193 0 0 1 3.195-3.195h4.26v2.13a1.066 1.066 0 0 1-1.066 1.065h-6.39ZM24.055 64.866a3.196 3.196 0 0 1 3.194-3.195h4.26v2.13a1.066 1.066 0 0 1-1.065 1.065h-6.39Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.23 26.32a6.024 6.024 0 0 1 1.214 2.865 9.938 9.938 0 0 0-5.858 2.13M24.587 31.318a9.94 9.94 0 0 0-5.858-2.13c.09-.674.3-1.326.618-1.927M24.586 31.318v13.845", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m25.212 43.218-7.389 1.292a1.064 1.064 0 0 1-1.204-.747l-2.794-9.418a1.065 1.065 0 0 1 .613-1.286l6.925-2.88a1.067 1.067 0 0 1 1.43.682L26.05 41.87a1.065 1.065 0 0 1-.838 1.348Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m25.212 43.218-7.389 1.292a1.064 1.064 0 0 1-1.204-.747l-2.794-9.418a1.065 1.065 0 0 1 .613-1.286l6.925-2.88a1.067 1.067 0 0 1 1.43.682L26.05 41.87a1.065 1.065 0 0 1-.838 1.348Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M31.509 37.176v.852a3.407 3.407 0 0 1-5.818 2.41l-.852-.852a1.864 1.864 0 0 0-2.635 2.635l.852.852a7.135 7.135 0 0 0 12.18-5.045v-.852H31.51ZM16.287 40.852a1.862 1.862 0 0 0 1.077-2.924 1.863 1.863 0 0 0-1.966-.696l-.776.19a1.065 1.065 0 0 0-.78 1.288l.38 1.552a1.066 1.066 0 0 0 1.29.78l.775-.19Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M16.599 33.98a.533.533 0 1 0-.001 1.066.533.533 0 0 0 .001-1.065Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M63.992 34.514a9.053 9.053 0 1 0-18.105 0v1.863h3.73v8.786H61.33v-7.455h2.662v-3.194Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M63.992 34.514a9.053 9.053 0 1 0-18.105 0v1.863h3.73v8.786H61.33v-7.455h2.662v-3.194Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m59.387 61.671.345-5.858h-8.52l.345 5.858h7.83Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m59.387 61.671.345-5.858h-8.52l.345 5.858h7.83ZM55.472 55.813v5.858", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M59.745 55.813a1.064 1.064 0 0 0 1.063-1.008l.522-9.642H49.614l.521 9.643a1.065 1.065 0 0 0 1.065 1.008h8.545Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M59.745 55.813a1.064 1.064 0 0 0 1.063-1.008l.522-9.642H49.614l.521 9.643a1.065 1.065 0 0 0 1.065 1.008h8.545Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.927 64.866a3.195 3.195 0 0 0-3.195-3.195h-4.26v3.195h7.455Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M59 64.866a3.195 3.195 0 0 0-3.196-3.195h-4.26v2.13a1.066 1.066 0 0 0 1.065 1.065h6.39Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M49.614 33.98v2.663", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m59.732 29.188.533 1.6-4.793 3.728 3.057-8.308a9.014 9.014 0 0 1 2.78 1.872l.02.043-1.597 1.065ZM50.68 30.786l.532-1.6-1.6-1.065.842-1.47a9.057 9.057 0 0 1 1.831-.8l3.187 8.663-4.793-3.728Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m53.514 29.188 1.958 5.326 1.96-5.326h-3.918Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M55.472 34.514v10.65", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m58.094 43.424-3.516-1.894a.8.8 0 0 1-.324-1.083l6.56-12.188a.8.8 0 0 1 1.083-.325l3.515 1.893-7.318 13.597ZM62.819 44.758a1.064 1.064 0 0 1-1.44.433l-3.28-1.767 7.321-13.6 3.28 1.766a1.065 1.065 0 0 1 .433 1.44l-6.314 11.728Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M61.92 30.47a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6ZM66.138 32.742a.8.8 0 1 0-.004 1.6.8.8 0 0 0 .004-1.6Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "m55.389 38.338 4.22 2.272M59.609 40.61l4.22 2.272", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M66.064 35.787a1.864 1.864 0 0 0-1.712 3.31l.71.368a1.065 1.065 0 0 0 1.434-.457l.735-1.418a1.066 1.066 0 0 0-.457-1.436l-.71-.367ZM49.615 36.377v1.6a1.332 1.332 0 0 0 1.33 1.33h6.923a1.864 1.864 0 0 1 0 3.729h-6.922a5.066 5.066 0 0 1-5.06-5.06v-1.6h3.729ZM57.93 25.976a.8.8 0 0 1-.545-.76V23.33h-3.911v1.596a.8.8 0 0 1-.62.778c-.19.044-.378.095-.565.151l1.227 3.333h3.92l1.097-2.982c-.2-.085-.4-.161-.604-.23Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M48.55 13.477a3.195 3.195 0 1 0 0-6.39 3.195 3.195 0 0 0 0 6.39Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M48.55 13.477a3.195 3.195 0 1 0 0-6.39 3.195 3.195 0 0 0 0 6.39Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M55.472 9.75a6.39 6.39 0 0 0-6.39 6.39v.852a1.304 1.304 0 0 0 .134 2.582 6.39 6.39 0 0 0 12.646-1.305v-2.13a6.388 6.388 0 0 0-6.39-6.39Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M52.544 19.866a.798.798 0 1 0 0-1.596.798.798 0 0 0 0 1.596Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M54.94 20.98a2.88 2.88 0 0 0 3.195 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M49.082 16.992c1.6-1.385 2.13-4.58 2.13-4.58s3.727 2.662 10.65 3.727v1.69a7.452 7.452 0 1 0-13.792.146 1.312 1.312 0 0 1 1.012-.983Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M49.082 16.992c1.6-1.385 2.13-4.58 2.13-4.58s3.727 2.662 10.65 3.727v1.69a7.452 7.452 0 1 0-13.792.146 1.312 1.312 0 0 1 1.012-.983Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M49.34 24.332c-1.266-1.753-1.403-3.66-1.403-5.52H33.051c0 1.876-.138 3.769-1.404 5.52a1.067 1.067 0 0 0 .898 1.664c2.098 0 6.127.06 7.95-1.337 1.82 1.397 5.85 1.337 7.949 1.337a1.068 1.068 0 0 0 .896-1.664ZM34.618 45.154l2.13 19.712h7.455l2.13-19.712H34.618Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40.475 49.423v15.443M34.618 45.154l2.13 19.712h7.455l2.13-19.712H34.618Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40.495 64.866a3.195 3.195 0 0 0-3.196-3.195h-.532a3.193 3.193 0 0 0-2.768 1.6 1.064 1.064 0 0 0 .923 1.6l5.573-.005Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M40.494 64.866a3.195 3.195 0 0 1 3.195-3.195h.532a3.194 3.194 0 0 1 2.768 1.6 1.065 1.065 0 0 1-.922 1.6l-5.573-.005ZM34.618 45.154l.55 9.595H45.82l.514-9.595.02-1.588H34.636l-.02 1.588Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M50.08 35.046a9.586 9.586 0 0 0-19.17 0v2.662h3.73v5.858h11.712v-5.858h3.728v-2.662Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m42.47 25.765-1.975 2.8-1.981-2.8.004-3.059h3.957l-.005 3.059Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m40.495 28.565-1.875 1.874a.8.8 0 0 1-1.303-.256l-1.478-3.52", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m40.494 28.565 1.874 1.874a.8.8 0 0 0 1.304-.256l1.477-3.52M34.613 35.049a3.184 3.184 0 0 0-.564-1.463 3.2 3.2 0 0 1-.48-1.745M40.494 28.565v10.498M46.356 35.046a3.184 3.184 0 0 1 .56-1.46c.325-.523.491-1.13.48-1.745", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M37.033 43.565h-1.331a4.784 4.784 0 0 1-4.793-4.792v-3.728h3.73v3.728a1.068 1.068 0 0 0 1.063 1.067h1.33v3.725ZM45.68 39.04c.002.269-.056.534-.17.777-.074.013-.149.02-.224.022h-5.92l3.397-2.332a1.864 1.864 0 0 1 2.917 1.533Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M35.169 41.702a1.86 1.86 0 0 0 1.864 1.863h8.254a4.784 4.784 0 0 0 4.792-4.792v-3.728h-3.727v3.728a1.068 1.068 0 0 1-1.065 1.067h-8.254a1.86 1.86 0 0 0-1.864 1.862ZM47.937 18.28a1.31 1.31 0 0 0-1.063-1.276v-.851a6.38 6.38 0 1 0-12.76 0v.85a1.302 1.302 0 0 0 .134 2.58 6.381 6.381 0 0 0 12.492 0 1.316 1.316 0 0 0 1.197-1.304Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M37.038 19.874a.798.798 0 1 0 0-1.595.798.798 0 0 0 0 1.595ZM43.95 19.874a.798.798 0 1 0 0-1.595.798.798 0 0 0 0 1.595Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M42.09 20.938a2.657 2.657 0 0 1-3.19 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M38.102 16.153a.8.8 0 1 0 0 1.601.8.8 0 0 0 0-1.601ZM42.886 16.153a.8.8 0 1 0 0 1.601.8.8 0 0 0 0-1.601Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M33.051 18.28c1.25-.503 2.11-2.76 2.62-3.86.255 1.003 1.468 1.44 1.864 1.54a4.773 4.773 0 0 1 1.92-1.92 3.61 3.61 0 0 0 2.56 1.92 2.367 2.367 0 0 1 1.28-1.92s2 4.431 4.645 4.24v-2.925a7.71 7.71 0 0 0-7.44-7.704 7.71 7.71 0 0 0-7.44 7.704l-.009 2.924Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M33.051 18.28c1.25-.503 2.11-2.76 2.62-3.86.255 1.003 1.468 1.44 1.864 1.54a4.773 4.773 0 0 1 1.92-1.92 3.61 3.61 0 0 0 2.56 1.92 2.367 2.367 0 0 1 1.28-1.92s2 4.431 4.645 4.24v-2.925a7.71 7.71 0 0 0-7.44-7.704 7.71 7.71 0 0 0-7.44 7.704l-.009 2.924ZM59.605 17.071a.912.912 0 0 0-1.288 0M53.818 17.071a.912.912 0 0 1 1.288 0", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var teamLeader = {
  render: render$w
};
var render$v = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M40 72c17.673 0 32-14.327 32-32C72 22.327 57.673 8 40 8 22.327 8 8 22.327 8 40c0 17.673 14.327 32 32 32Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M62.425 16.544a.576.576 0 0 1 .414.816l-2.311 4.759a.574.574 0 0 1-1.091-.23l-.196-5.218a.574.574 0 0 1 .677-.586l2.507.46ZM50.681 16.88a.574.574 0 0 0-.366.838l2.577 4.62a.575.575 0 0 0 1.076-.29l-.1-5.22a.575.575 0 0 0-.709-.548l-2.477.6ZM29.98 19.262a.574.574 0 0 0-.89.214l-2.126 4.844a.574.574 0 0 0 .88.681l4.1-3.232a.574.574 0 0 0 .009-.896l-1.973-1.61ZM20.194 15.806a.573.573 0 0 0-.578.71l1.238 5.143a.574.574 0 0 0 1.114.01l1.312-5.055a.574.574 0 0 0-.536-.72l-2.55-.088Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M24.64 33.245c-.118-2.587-.58-8.103-2.707-7.792a1.551 1.551 0 0 0-1.31 1.76l.074.512c.548 3.752-.506 7.913-3.654 8.373l1.144 7.847.4-.059c1.968-.288 3.098.941 6.622.426l5.975-.872a1.379 1.379 0 1 0-.4-2.73l.682-.099a1.379 1.379 0 1 0-.4-2.73l.683-.099a1.379 1.379 0 1 0-.4-2.73l.681-.098a1.379 1.379 0 1 0-.4-2.73l-6.99 1.02Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m23.277 33.444 1.365-.2M30.785 40.709l-.683.1M31.068 37.88l-.682.1M31.352 35.051l-.683.1", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M16.204 44.665a.95.95 0 0 1-.8 1.076l-5.955 1.065a36.696 36.696 0 0 1-.56-6.435 38.1 38.1 0 0 1 .247-4.32l4.96-.913a.712.712 0 0 1 .81.6l1.298 8.927Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M9.134 36.06v-.01l4.96-.913a.712.712 0 0 1 .81.599l1.304 8.929a.949.949 0 0 1-.8 1.076l-5.955 1.065", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m16.245 44.925 1.105-.16a.953.953 0 0 0 .8-1.08l-1.072-7.327a.951.951 0 0 0-1.079-.8l-1.104.16 1.35 9.207Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M24.64 33.245c-.118-2.587-.58-8.103-2.707-7.792a1.551 1.551 0 0 0-1.31 1.76l.074.512c.548 3.752-.506 7.913-3.654 8.373l1.144 7.847.4-.059c1.968-.288 3.098.941 6.622.426l5.975-.872a1.379 1.379 0 1 0-.4-2.73l.682-.099a1.379 1.379 0 1 0-.4-2.73l.683-.099a1.379 1.379 0 1 0-.4-2.73l.681-.098a1.379 1.379 0 1 0-.4-2.73l-6.99 1.02Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M55.157 33.245c.118-2.587.58-8.103 2.707-7.792a1.55 1.55 0 0 1 1.31 1.76l-.074.512c-.549 3.752.506 7.913 3.654 8.373l-1.144 7.847-.4-.059c-1.968-.288-3.099.941-6.623.426l-5.973-.872a1.379 1.379 0 1 1 .4-2.73l-.682-.099a1.379 1.379 0 1 1 .4-2.73l-.682-.099a1.379 1.379 0 1 1 .4-2.73l-.683-.098a1.379 1.379 0 1 1 .4-2.73l6.99 1.02Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m56.522 33.444-1.365-.2M49.014 40.709l.682.1M48.73 37.88l.683.1M48.447 35.051l.683.1", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M70.921 40.16c0 2.147-.184 4.29-.552 6.406l-5.969-.825a.947.947 0 0 1-.81-1.076l1.303-8.93a.72.72 0 0 1 .818-.598l4.953.675a36.48 36.48 0 0 1 .257 4.348Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M70.369 46.568 64.4 45.74a.947.947 0 0 1-.81-1.076l1.303-8.93a.72.72 0 0 1 .818-.598l4.953.675", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m63.554 44.925-1.105-.16a.953.953 0 0 1-.804-1.08l1.075-7.328a.952.952 0 0 1 1.08-.8l1.105.16-1.35 9.208Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M55.157 33.245c.118-2.587.58-8.103 2.707-7.792a1.55 1.55 0 0 1 1.31 1.76l-.074.512c-.549 3.752.506 7.913 3.654 8.373l-1.144 7.847-.4-.059c-1.968-.288-3.099.941-6.623.426l-5.973-.872a1.379 1.379 0 1 1 .4-2.73l-.682-.099a1.379 1.379 0 1 1 .4-2.73l-.682-.099a1.379 1.379 0 1 1 .4-2.73l-.683-.098a1.379 1.379 0 1 1 .4-2.73l6.99 1.02Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M37.655 52.9c.268-3.474 1.12-10.876 3.972-10.368a2.088 2.088 0 0 1 1.69 2.422l-.123.686c-.898 5.025.344 10.667 4.56 11.42l-1.871 10.506-.54-.096c-2.634-.47-4.208 1.135-8.927.292l-7.993-1.426a1.856 1.856 0 0 1 .652-3.654l-.914-.16a1.856 1.856 0 0 1 .653-3.655l-.914-.16a1.856 1.856 0 1 1 .652-3.654l-.913-.16a1.856 1.856 0 0 1 .652-3.655l9.364 1.662Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m39.483 53.226-1.828-.326M29.074 62.682l.914.162M28.814 58.864l.913.162M28.552 55.046l.913.164", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M65.658 58.37A36.338 36.338 0 0 1 49.24 70.054l-.037-.008a.926.926 0 0 1-.742-1.077l2.199-12.334a.924.924 0 0 1 1.077-.752l13.92 2.487Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M49.25 70.054h-.01l-.037-.008a.926.926 0 0 1-.742-1.077l2.199-12.334a.924.924 0 0 1 1.077-.752l13.92 2.487", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m48.456 68.969-1.827-.329a.928.928 0 0 1-.75-1.076l1.875-10.507a.93.93 0 0 1 1.077-.75l1.827.326-2.202 12.336Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M37.655 52.9c.268-3.474 1.12-10.876 3.972-10.368a2.088 2.088 0 0 1 1.69 2.422l-.123.686c-.898 5.025.344 10.667 4.56 11.42l-1.871 10.506-.54-.096c-2.634-.47-4.208 1.135-8.927.292l-7.993-1.426a1.856 1.856 0 0 1 .652-3.654l-.914-.16a1.856 1.856 0 0 1 .653-3.655l-.914-.16a1.856 1.856 0 1 1 .652-3.654l-.913-.16a1.856 1.856 0 0 1 .652-3.655l9.364 1.662Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linejoin": "round" } })]);
};
var teamSuccess = {
  render: render$v
};
var render$u = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M31.308 66.043c0 .175.284.348.836.51.552.162 1.36.31 2.38.434 1.02.124 2.23.222 3.562.289 1.332.067 2.76.102 4.201.102 1.442 0 2.87-.035 4.202-.102a51.702 51.702 0 0 0 3.562-.29c1.02-.123 1.828-.27 2.38-.433.552-.162.836-.335.836-.51 0-.176-.285-.35-.836-.512-.552-.162-1.36-.309-2.38-.433a51.765 51.765 0 0 0-3.562-.29 84.418 84.418 0 0 0-4.202-.1c-1.441 0-2.87.034-4.201.1a51.77 51.77 0 0 0-3.562.29c-1.02.124-1.828.272-2.38.433-.552.162-.836.336-.836.511Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M26.911 57.254a.675.675 0 0 1-.884-.007 4.056 4.056 0 0 0-4.626-.513.678.678 0 0 1-.965-.377l-.661-1.957a1.44 1.44 0 0 0-.865-.826l-1.045-.299a1.098 1.098 0 0 1-.728-.856l-.126-1.074a1.098 1.098 0 0 0-.728-.856l-1.04-.297a1.099 1.099 0 0 1-.728-.856l-.127-1.077a1.098 1.098 0 0 0-.729-.855l-1.04-.298a1.098 1.098 0 0 1-.728-.856l-.131-1.08a1.44 1.44 0 0 0-.677-.985l-1.83-.96a.676.676 0 0 1-.218-1.014 4.056 4.056 0 0 0 .23-4.648.673.673 0 0 1 .134-.874l28.868-24.587a.674.674 0 0 1 .88.008 4.057 4.057 0 0 0 4.626.513.675.675 0 0 1 .965.377l.661 1.96a1.44 1.44 0 0 0 .865.826l1.04.296a1.102 1.102 0 0 1 .729.856l.126 1.077a1.1 1.1 0 0 0 .729.856l1.04.297a1.1 1.1 0 0 1 .729.855l.126 1.078a1.099 1.099 0 0 0 .729.855l1.04.295a1.1 1.1 0 0 1 .73.855l.127 1.08a1.44 1.44 0 0 0 .677.986l1.842.964a.675.675 0 0 1 .217 1.014 4.054 4.054 0 0 0-.23 4.648.674.674 0 0 1-.134.874l-28.87 24.582Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M26.911 57.254a.675.675 0 0 1-.884-.007 4.055 4.055 0 0 0-4.626-.513.677.677 0 0 1-.965-.377l-.661-1.957a1.44 1.44 0 0 0-.865-.826l-1.045-.299a1.098 1.098 0 0 1-.728-.856l-.126-1.074a1.098 1.098 0 0 0-.728-.856l-1.04-.297a1.099 1.099 0 0 1-.728-.856l-.127-1.077a1.098 1.098 0 0 0-.729-.855l-1.04-.298a1.098 1.098 0 0 1-.728-.856l-.131-1.08a1.44 1.44 0 0 0-.677-.985l-1.83-.96a.677.677 0 0 1-.218-1.014 4.056 4.056 0 0 0 .23-4.648.673.673 0 0 1 .134-.874l28.868-24.587a.675.675 0 0 1 .88.008 4.058 4.058 0 0 0 4.626.513.676.676 0 0 1 .965.377l.661 1.96a1.44 1.44 0 0 0 .865.826l1.04.296a1.101 1.101 0 0 1 .729.856l.126 1.077a1.101 1.101 0 0 0 .729.856l1.04.297a1.1 1.1 0 0 1 .729.855l.126 1.078a1.099 1.099 0 0 0 .729.855l1.04.295a1.1 1.1 0 0 1 .73.855l.127 1.08a1.44 1.44 0 0 0 .677.986l1.842.964a.675.675 0 0 1 .217 1.014 4.055 4.055 0 0 0-.23 4.648.674.674 0 0 1-.134.874l-28.87 24.582Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m15.158 37.101 22.603-19.246a2.042 2.042 0 0 1 2.878.231l9.613 11.29a2.042 2.042 0 0 1-.231 2.88L27.419 51.5a2.042 2.042 0 0 1-2.88-.23l-9.612-11.29a2.043 2.043 0 0 1 .231-2.879Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M24.914 39.847a.505.505 0 0 0-.261.09l-.385.24a1.383 1.383 0 0 1-.71.18 1.23 1.23 0 0 1-.48-.088l-.419-.18a.571.571 0 0 0-.22-.052c-.202 0-.304.166-.235.44l.111.44a1.44 1.44 0 0 1-.28 1.163l-.301.342c-.245.279-.143.528.228.552l.454.03a1.448 1.448 0 0 1 1.018.627l.233.392a.384.384 0 0 0 .301.227c.114 0 .223-.092.295-.273l.17-.423a1.44 1.44 0 0 1 .91-.775l.444-.1c.362-.08.425-.343.14-.58l-.35-.293a1.442 1.442 0 0 1-.455-1.104l.042-.454c.024-.256-.08-.4-.249-.4h-.001Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M39.966 25.348c-.341-.147-.545.027-.455.388l.111.44a1.445 1.445 0 0 1-.28 1.163l-.302.34c-.245.28-.142.529.228.554l.454.03a1.447 1.447 0 0 1 1.019.627l.232.392c.19.32.457.298.596-.047l.17-.422a1.442 1.442 0 0 1 .91-.775l.444-.1c.362-.08.425-.344.14-.581l-.35-.292a1.44 1.44 0 0 1-.455-1.106l.042-.453c.035-.37-.195-.51-.51-.313l-.384.24a1.444 1.444 0 0 1-1.193.093l-.417-.178Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75" } }), _c("path", { attrs: { "d": "m23.944 34.943 10.285-8.757M28.114 36.715l7.2-6.13M28.893 44.922l14.399-12.26", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M25.51 57.193a.674.674 0 0 1-.668-.58 4.058 4.058 0 0 0-3.188-3.389.676.676 0 0 1-.491-.913l.767-1.92a1.44 1.44 0 0 0-.123-1.19l-.602-.904a1.099 1.099 0 0 1 0-1.12l.6-.9a1.098 1.098 0 0 0 0-1.123l-.6-.903a1.097 1.097 0 0 1 0-1.124l.6-.902a1.1 1.1 0 0 0 0-1.12l-.6-.902a1.097 1.097 0 0 1 0-1.125l.6-.902a1.44 1.44 0 0 0 .124-1.189l-.768-1.92a.674.674 0 0 1 .491-.912 4.057 4.057 0 0 0 3.189-3.39.674.674 0 0 1 .668-.579h37.92a.674.674 0 0 1 .668.579 4.058 4.058 0 0 0 3.189 3.39.676.676 0 0 1 .49.912l-.767 1.92a1.439 1.439 0 0 0 .123 1.19l.602.901a1.098 1.098 0 0 1 0 1.124l-.602.903a1.1 1.1 0 0 0 0 1.12l.602.902a1.098 1.098 0 0 1 0 1.124l-.602.903a1.1 1.1 0 0 0 0 1.124l.6.899a1.1 1.1 0 0 1 0 1.12l-.6.903a1.439 1.439 0 0 0-.122 1.19l.768 1.92a.676.676 0 0 1-.492.912 4.058 4.058 0 0 0-3.188 3.39.674.674 0 0 1-.668.58H25.51Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M25.51 57.193a.674.674 0 0 1-.668-.58 4.058 4.058 0 0 0-3.188-3.389.676.676 0 0 1-.491-.913l.767-1.92a1.44 1.44 0 0 0-.123-1.19l-.602-.904a1.099 1.099 0 0 1 0-1.12l.6-.9a1.098 1.098 0 0 0 0-1.123l-.6-.903a1.097 1.097 0 0 1 0-1.124l.6-.902a1.1 1.1 0 0 0 0-1.12l-.6-.902a1.097 1.097 0 0 1 0-1.125l.6-.902a1.44 1.44 0 0 0 .124-1.189l-.768-1.92a.674.674 0 0 1 .491-.912 4.057 4.057 0 0 0 3.189-3.39.674.674 0 0 1 .668-.579h37.92a.674.674 0 0 1 .668.579 4.058 4.058 0 0 0 3.189 3.39.676.676 0 0 1 .49.912l-.767 1.92a1.439 1.439 0 0 0 .123 1.19l.602.901a1.098 1.098 0 0 1 0 1.124l-.602.903a1.1 1.1 0 0 0 0 1.12l.602.902a1.098 1.098 0 0 1 0 1.124l-.602.903a1.1 1.1 0 0 0 0 1.124l.6.899a1.1 1.1 0 0 1 0 1.12l-.6.903a1.439 1.439 0 0 0-.122 1.19l.768 1.92a.676.676 0 0 1-.492.912 4.058 4.058 0 0 0-3.188 3.39.674.674 0 0 1-.668.58H25.51Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M27.585 34.229h33.77V53.14h-33.77V34.229Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M32.804 41.364c.165-.334.434-.334.598 0l.202.408a1.44 1.44 0 0 0 .967.702l.45.066c.368.054.451.31.185.569l-.326.32a1.44 1.44 0 0 0-.37 1.137l.08.448c.064.367-.154.524-.48.352l-.4-.212a1.44 1.44 0 0 0-1.195 0l-.4.212c-.329.172-.546.015-.48-.352l.08-.448a1.443 1.443 0 0 0-.37-1.137l-.326-.32c-.265-.26-.182-.515.185-.569l.45-.066a1.44 1.44 0 0 0 .968-.702l.182-.408ZM56.136 41.36c-.165-.333-.434-.333-.598 0l-.202.408a1.44 1.44 0 0 1-.967.703l-.45.066c-.368.053-.451.309-.185.568l.326.32a1.446 1.446 0 0 1 .37 1.137l-.08.45c-.063.365.155.523.484.35l.4-.212a1.44 1.44 0 0 1 1.195 0l.4.212c.329.173.546.015.48-.35l-.08-.45a1.44 1.44 0 0 1 .37-1.137l.325-.32c.266-.26.183-.515-.185-.568l-.45-.066a1.446 1.446 0 0 1-.967-.703l-.186-.408Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75" } }), _c("path", { attrs: { "d": "M37.716 38.282h13.508M39.742 42.334h9.455M35.014 49.088h18.911", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var ticket = {
  render: render$u
};
var render$t = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M7.95 39.047a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M27.64 27.43a2.195 2.195 0 1 0-3.105 3.106l5.044 5.045a2.195 2.195 0 1 0-3.104 3.105l1.164 1.164a2.195 2.195 0 1 0-3.104 3.106l1.939 1.94A2.196 2.196 0 0 0 23.37 48l5.046 5.048c4 4 6.252 3.147 8.539 5.434l5.434 5.438 8.927-8.928-2.693-2.696c-3.174-3.174.56-6.17.13-8.429-.257-1.36-1.84-6.896-1.84-6.896a2.193 2.193 0 0 0-3.486-1.236 2.195 2.195 0 0 0-.753 2.367l1.124 4.218-.633.633L27.639 27.43Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M27.64 27.43a2.195 2.195 0 1 0-3.105 3.106l5.044 5.045a2.195 2.195 0 1 0-3.104 3.105l1.164 1.164a2.195 2.195 0 1 0-3.104 3.106l1.939 1.94A2.196 2.196 0 0 0 23.37 48l5.046 5.048c4 4 6.252 3.147 8.539 5.434l5.434 5.438 8.927-8.928-2.693-2.696c-3.174-3.174.56-6.17.13-8.429-.257-1.36-1.84-6.896-1.84-6.896a2.193 2.193 0 0 0-3.486-1.236 2.195 2.195 0 0 0-.753 2.367l1.124 4.218-.633.633L27.639 27.43Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m23.401 48.59 12.212-29.683L51.03 25.25 38.82 54.933 23.4 48.59Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "m25.293 43.992 8.427-20.485 15.418 6.342-8.427 20.485-15.418-6.343Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m23.401 48.59 12.212-29.683L51.03 25.25 38.82 54.933 23.4 48.59Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m25.293 43.992 8.427-20.485 15.418 6.342-8.427 20.485-15.418-6.343Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m41.605 24.061 3.847 1.583", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M39.68 22.856a.416.416 0 1 0 .004.831.416.416 0 0 0-.004-.831Z", "fill": "#260347" } }), _c("path", { attrs: { "d": "M31.909 41.015a2.196 2.196 0 0 1-3.105 0l-2.329-2.329a2.195 2.195 0 1 1 3.105-3.105l2.329 2.33a2.197 2.197 0 0 1 0 3.104ZM29.968 45.285a2.195 2.195 0 0 1-3.105 0l-2.328-2.325a2.196 2.196 0 0 1 3.104-3.105l2.33 2.329a2.195 2.195 0 0 1 0 3.1Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75" } }), _c("path", { attrs: { "d": "M27.639 49.166a2.196 2.196 0 0 1-3.105 0L23.37 48a2.195 2.195 0 1 1 3.106-3.105l1.164 1.164a2.195 2.195 0 0 1 0 3.108Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75" } }), _c("path", { attrs: { "d": "M42.18 52.618a7.688 7.688 0 0 1 .985-9.658l.633-.633-1.124-4.221a2.194 2.194 0 1 1 4.24-1.13s1.579 5.535 1.84 6.895c.427 2.26-3.305 5.255-.13 8.43l2.692 2.691-4.394 4.395", "fill": "#fff" } }), _c("path", { attrs: { "d": "M42.18 52.618a7.688 7.688 0 0 1 .985-9.658l.633-.633-1.124-4.221a2.194 2.194 0 1 1 4.24-1.13s1.579 5.535 1.84 6.895c.427 2.26-3.305 5.255-.13 8.43l2.692 2.691-4.394 4.395", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M61.395 61.692 53.78 54.08a1.099 1.099 0 0 0-1.553 0l-10.48 10.48a1.099 1.099 0 0 0 0 1.553l6.8 6.837", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m61.44 61.736-7.66-7.656a1.099 1.099 0 0 0-1.553 0l-10.48 10.48a1.099 1.099 0 0 0 0 1.553l6.8 6.837", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m41.747 64.56-1.552-1.552a1.097 1.097 0 0 1 0-1.553l8.925-8.93a1.1 1.1 0 0 1 1.553 0l1.552 1.553L41.747 64.56Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M69.01 26.491V12.772a3.167 3.167 0 0 1-3.166-3.166H42.627a3.166 3.166 0 0 1-3.166 3.166v13.72a3.167 3.167 0 0 1 3.166 3.165h23.217a3.166 3.166 0 0 1 3.165-3.166Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M69.01 26.491V12.772a3.167 3.167 0 0 1-3.166-3.166H42.627a3.166 3.166 0 0 1-3.166 3.166v13.72a3.167 3.167 0 0 1 3.166 3.165h23.217a3.166 3.166 0 0 1 3.165-3.166Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M45.34 25.778a7.086 7.086 0 0 0-2-2v-8.295a7.089 7.089 0 0 0 2-2h17.792a7.097 7.097 0 0 0 2 2v8.295a7.097 7.097 0 0 0-2 2H45.34Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M53.706 16.245c.292-.59.769-.59 1.06 0l.357.72a2.56 2.56 0 0 0 1.716 1.246l.8.116c.652.095.8.548.327 1.008l-.578.56a2.563 2.563 0 0 0-.655 2.016l.136.795c.112.65-.274.93-.857.624l-.716-.37a2.56 2.56 0 0 0-2.12 0l-.714.375c-.583.307-.969.027-.858-.623l.136-.795a2.554 2.554 0 0 0-.655-2.016l-.578-.56c-.47-.46-.324-.914.328-1.008l.8-.116a2.56 2.56 0 0 0 1.715-1.247l.356-.725Z", "fill": "#B096CB", "stroke": "#260347", "stroke-width": ".75" } })]);
};
var ticketReserved = {
  render: render$t
};
var render$s = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M72 40a32 32 0 1 0-61.149 13.2H69.15A31.875 31.875 0 0 0 72 40Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M8.8 53.2h62.4M5.2 53.2h2M72.8 53.2h2", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M32.42 14.56a2.104 2.104 0 0 0-.766.148 3.536 3.536 0 0 0-6.986 0 2.127 2.127 0 1 0-.767 4.112h8.52a2.13 2.13 0 0 0 0-4.26ZM67.567 30a2.121 2.121 0 0 0-2.897-1.983 3.536 3.536 0 0 0-6.986 0 2.128 2.128 0 1 0-.768 4.113h8.524A2.13 2.13 0 0 0 67.567 30Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m51.446 47.006.145-1.743h-1.6l-3.045 3.046a1.72 1.72 0 0 0 0 2.43l.915.915h3.195L49.503 50.1a.816.816 0 0 1 0-1.154l1.943-1.94ZM29.055 46.075l8.734-9.33 1.554 1.455-8.734 9.33-1.554-1.456Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M24.113 56.034a1.066 1.066 0 0 1-1.507.05l-1.554-1.454a1.063 1.063 0 0 1-.05-1.506l6.547-6.998a1.065 1.065 0 0 1 1.507-.046l1.555 1.454a1.066 1.066 0 0 1 .05 1.506l-6.549 6.994Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M24.113 56.035a1.066 1.066 0 0 1-1.507.05l-1.554-1.455a1.063 1.063 0 0 1-.05-1.506l6.549-6.998a1.062 1.062 0 0 1 1.505-.046l1.555 1.455a1.066 1.066 0 0 1 .05 1.505l-6.549 6.995Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M23.9 51.654h43.133v6.922H23.9v-6.922Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M23.9 51.654h43.133v6.922H23.9v-6.922Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M23.9 50.056H7.925a1.6 1.6 0 0 0-1.6 1.6v3.2H23.9v-4.8Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M23.9 50.056H7.925a1.6 1.6 0 0 0-1.6 1.6v3.2H23.9v-4.8Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M18.309 58.576H8.99a2.661 2.661 0 0 1-2.663-2.662v-1.065h11.98v3.727Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M18.309 58.576H8.99a2.661 2.661 0 0 1-2.663-2.662v-1.065h11.98v3.727Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M18.31 58.842a5.591 5.591 0 1 0 11.182 0 5.591 5.591 0 0 0-11.182 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M18.31 58.842a5.591 5.591 0 1 0 11.182 0 5.591 5.591 0 0 0-11.182 0Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M21.505 58.842a2.396 2.396 0 1 0 4.791 0 2.396 2.396 0 0 0-4.791 0Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M21.505 58.842a2.396 2.396 0 1 0 4.791 0 2.396 2.396 0 0 0-4.791 0Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.669 58.842a5.591 5.591 0 1 0 11.182 0 5.591 5.591 0 0 0-11.182 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M44.669 58.842a5.591 5.591 0 1 0 11.182 0 5.591 5.591 0 0 0-11.182 0Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M47.864 58.842a2.396 2.396 0 1 0 4.792 0 2.396 2.396 0 0 0-4.792 0Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M47.864 58.842a2.396 2.396 0 1 0 4.792 0 2.396 2.396 0 0 0-4.792 0Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M55.852 58.842a5.591 5.591 0 1 0 11.182 0 5.591 5.591 0 0 0-11.182 0Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M55.852 58.842a5.591 5.591 0 1 0 11.182 0 5.591 5.591 0 0 0-11.182 0Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M59.047 58.842a2.394 2.394 0 0 0 4.09 1.694 2.396 2.396 0 1 0-4.09-1.694Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M59.047 58.842a2.394 2.394 0 0 0 4.09 1.694 2.396 2.396 0 1 0-4.09-1.694Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M18.336 58.576a5.57 5.57 0 0 1 11.13 0h3.207a8.777 8.777 0 0 0-17.545 0h3.208Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M18.336 58.576a5.57 5.57 0 0 1 11.13 0h3.207a8.777 8.777 0 0 0-17.545 0h3.208Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M35.083 50.056h6.922v5.325h-6.922v-5.325Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M35.083 50.056h6.922v5.325h-6.922v-5.325Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M23.901 36.473a2.392 2.392 0 0 0-2.392-2.392h-5.6a7.987 7.987 0 0 0-7.987 7.987v7.988h15.98V36.473Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M11.12 42.07a1.6 1.6 0 0 0 1.6 1.596h6.394a1.6 1.6 0 0 0 1.6-1.596v-3.2a1.6 1.6 0 0 0-1.6-1.6h-3.2a4.795 4.795 0 0 0-4.794 4.8Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M23.901 36.473a2.392 2.392 0 0 0-2.392-2.392h-5.6a7.987 7.987 0 0 0-7.987 7.987v7.988h15.98V36.473ZM18.309 46.86h2.396", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M11.12 42.07a1.6 1.6 0 0 0 1.6 1.596h6.394a1.6 1.6 0 0 0 1.6-1.596v-3.2a1.6 1.6 0 0 0-1.6-1.6h-3.2a4.795 4.795 0 0 0-4.794 4.8Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M37.67 34.008a1.064 1.064 0 0 1-.772-.812l-.757-3.62a2.586 2.586 0 0 0-1.872-1.97l-7.21-1.898a1.065 1.065 0 0 0-.54 2.06l2.831.745.35.092a1.064 1.064 0 0 1 .79.946l.886 11.152a2.254 2.254 0 0 0 1.672 2l32.956 8.68a1.065 1.065 0 0 0 1.3-.76l1.9-7.209a1.066 1.066 0 0 0-.76-1.3l-30.381-8-.394-.106Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M37.67 34.008a1.064 1.064 0 0 1-.772-.812l-.757-3.62a2.586 2.586 0 0 0-1.872-1.97l-7.21-1.898a1.065 1.065 0 0 0-.54 2.06l2.831.745a1.576 1.576 0 0 1 1.17 1.4l.856 10.79a2.252 2.252 0 0 0 1.672 2l32.956 8.68a1.065 1.065 0 0 0 1.3-.76l1.9-7.209a1.066 1.066 0 0 0-.76-1.3l-30.381-8-.394-.106Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M39.146 40.455a1.065 1.065 0 0 1 .543-2.06l23.172 6.103a1.066 1.066 0 1 1-.541 2.062l-23.174-6.105ZM69.475 42.385a1.066 1.066 0 0 1 2.06.542l-2.441 9.269a1.065 1.065 0 1 1-2.06-.542l2.44-9.27Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var tipperTruck = {
  render: render$s
};
var render$r = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M8 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M13.553 52.409a12.14 12.14 0 1 0 24.282 0 12.14 12.14 0 0 0-24.282 0Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M34.8 52.409a9.106 9.106 0 1 1-18.21 0 9.106 9.106 0 0 1 18.21 0Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M34.8 52.409a9.106 9.106 0 1 1-18.21 0 9.106 9.106 0 0 1 18.21 0Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m25.67 48.575.023 3.81-.037 2.463M25.67 59.253v-1.14M25.67 45.565v1.14M30.509 47.57l-.806.806M32.514 52.409h-1.141M30.509 57.248l-.806-.806M20.83 57.248l.807-.806M18.826 52.409h1.14M20.83 47.57l.807.806", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M42.436 52.409a12.142 12.142 0 1 0 24.284 0 12.142 12.142 0 0 0-24.284 0Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M63.68 52.409a9.107 9.107 0 1 1-18.213.001 9.107 9.107 0 0 1 18.213-.001Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M63.68 52.409a9.107 9.107 0 1 1-18.214.001 9.107 9.107 0 0 1 18.214-.001Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m54.577 48.575.024 3.81 2.145 1.58M54.577 59.253v-1.14M54.577 45.565v1.14M59.417 47.57l-.808.806M61.42 52.409h-1.14M59.417 57.248l-.808-.806M49.738 57.248l.807-.806M47.733 52.409h1.14M49.738 47.57l.807.806", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M25.435 24.666a14.97 14.97 0 1 0 29.94 0 14.97 14.97 0 0 0-29.94 0Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M51.634 24.666a11.228 11.228 0 1 1-22.455.004 11.228 11.228 0 0 1 22.455-.004Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M51.634 24.666a11.228 11.228 0 1 1-22.455.004 11.228 11.228 0 0 1 22.455-.004Z", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M44.897 24.666h-4.491v-8.233M46.757 18.315l-1.059 1.059M49.388 24.666H47.89M46.757 31.018l-1.059-1.059M40.406 33.649v-1.497M34.054 31.018l1.06-1.059M31.424 24.666h1.497M34.054 18.315l1.06 1.059", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var travelClock = {
  render: render$r
};
var render$q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M40 73.754c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32-17.673 0-32 14.327-32 32 0 17.674 14.327 32 32 32Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M39.836 22.938a19.455 19.455 0 0 0-19.448 19.448 3.89 3.89 0 0 1 7.779 0 3.89 3.89 0 1 1 7.78 0 3.893 3.893 0 0 1 3.889-3.886 3.892 3.892 0 0 1 3.89 3.89 3.89 3.89 0 0 1 7.779 0 3.89 3.89 0 0 1 7.779 0 19.456 19.456 0 0 0-19.448-19.453Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M39.836 22.938a19.455 19.455 0 0 0-19.448 19.448 3.89 3.89 0 0 1 7.779 0 3.89 3.89 0 1 1 7.78 0 3.893 3.893 0 0 1 3.889-3.886 3.892 3.892 0 0 1 3.89 3.89 3.89 3.89 0 0 1 7.779 0 3.89 3.89 0 0 1 7.779 0 19.456 19.456 0 0 0-19.448-19.453Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M41.013 38.676a3.92 3.92 0 0 0-2.288-.02V56.99a4.96 4.96 0 0 0 9.693 1.497 1.146 1.146 0 0 0-1.089-1.5 1.105 1.105 0 0 0-1.078.767 2.675 2.675 0 0 1-5.234-.767l-.004-18.31Zm-1.177-15.739c.373 0 .744.01 1.111.031v-3.362a1.111 1.111 0 1 0-2.222 0v3.36c.368-.02.738-.029 1.11-.029Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var umbrella = {
  render: render$q
};
var render$p = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M34.74 14.14 24.988 50.93c-.15.564.187 1.143.75 1.293l27.084 7.18a1.057 1.057 0 0 0 1.292-.751l9.754-36.792a1.057 1.057 0 0 0-.75-1.292l-27.084-7.18a1.057 1.057 0 0 0-1.292.75Z", "fill": "#fff", "stroke": "#481D72", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m39.98 16.782-26.827 8.085a1.057 1.057 0 0 0-.707 1.317l10.983 36.443c.169.559.758.875 1.317.707l26.826-8.085c.56-.169.876-.758.707-1.317L41.296 17.49a1.057 1.057 0 0 0-1.317-.707Z", "fill": "#fff", "stroke": "#481D72", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m24.377 24.885-2.353 37.99a1.057 1.057 0 0 0 .99 1.12l27.964 1.731a1.057 1.057 0 0 0 1.12-.99l2.353-37.989a1.057 1.057 0 0 0-.99-1.12l-27.964-1.732a1.057 1.057 0 0 0-1.12.99Z", "fill": "#fff", "stroke": "#481D72", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m29.282 42.002 1.104 1.257 3.564-3.579M35.15 42.815l.528.614a.978.978 0 0 0 1.378.103l.614-.527a.977.977 0 0 1 1.377.103l.528.614a.978.978 0 0 0 1.378.103l.613-.527a.977.977 0 0 1 1.378.102l.634.692a.98.98 0 0 0 1.045.295.977.977 0 0 0 .332-.187l.614-.527a.977.977 0 0 1 1.377.103l.673.753M30.029 33.869l1.103 1.256 3.566-3.579M35.898 34.68l.527.614a.974.974 0 0 0 1.377.106l.614-.527a.977.977 0 0 1 1.378.103l.528.614a.975.975 0 0 0 1.377.103l.614-.527a.976.976 0 0 1 1.377.103l.634.692a.972.972 0 0 0 1.046.291.976.976 0 0 0 .332-.187l.613-.528a.976.976 0 0 1 1.378.104l.673.752M28.486 50.67l1.104 1.256 3.565-3.578M34.4 51.04l.528.612a.978.978 0 0 0 1.377.104l.613-.528a.975.975 0 0 1 1.379.104l.527.613a.976.976 0 0 0 1.378.104l.613-.528a.976.976 0 0 1 1.378.104", "stroke": "#481D72", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var white = {
  render: render$p
};
var render$o = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M72 43.822a32 32 0 1 0-61.149 13.2H69.15A31.876 31.876 0 0 0 72 43.822Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M8.8 57.022h62.4M5.2 57.022h2M72.8 57.022h2", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m27.263 57.058 18.965-9.384a2.072 2.072 0 0 1 1.84 0l18.965 9.384h-39.77Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M10.484 57.057 21.418 45.67a2.071 2.071 0 0 1 2.989 0L35.34 57.058H10.484Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "m27.263 57.058 18.965-9.384a2.072 2.072 0 0 1 1.84 0l18.965 9.384h-39.77Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M10.484 57.057 21.418 45.67a2.071 2.071 0 0 1 2.989 0L35.34 57.058H10.484Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M35.696 25.983a2.891 2.891 0 0 1-5.782 0l-2.168 31.075h10.118l-2.168-31.075Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M35.696 25.983a2.891 2.891 0 0 1-5.782 0l-2.168 31.075h10.118l-2.168-31.075Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M32.804 23.093a2.89 2.89 0 0 1 2.436 1.334c.192-.415.274-.87.24-1.326L34.358 7.913a1.556 1.556 0 0 0-3.104 0L30.128 23.1c-.035.455.048.912.24 1.326a2.888 2.888 0 0 1 2.436-1.334Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M50.038 31.638 36.506 24.65a2.674 2.674 0 0 0-1.314-.297 2.89 2.89 0 0 1-1.91 4.48c.306.34.693.595 1.126.742l14.413 4.918a1.556 1.556 0 0 0 1.217-2.855ZM29.915 25.983c0-.582.175-1.15.504-1.63a2.678 2.678 0 0 0-1.315.297l-13.532 6.988a1.556 1.556 0 0 0 1.217 2.855L31.2 29.576a2.68 2.68 0 0 0 1.126-.742 2.89 2.89 0 0 1-2.411-2.85Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M29.914 25.983a2.89 2.89 0 1 0 5.781 0 2.89 2.89 0 0 0-5.78 0Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M29.914 25.983a2.89 2.89 0 1 0 5.781 0 2.89 2.89 0 0 0-5.78 0Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M58.796 39.882a1.6 1.6 0 0 1-3.2 0L54.4 57.058h5.593l-1.197-17.176Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M58.796 39.882a1.6 1.6 0 0 1-3.2 0L54.4 57.058h5.593l-1.197-17.176Z", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M57.2 38.283a1.6 1.6 0 0 1 1.346.738c.107-.23.153-.481.134-.733l-.622-8.395a.86.86 0 0 0-1.716 0l-.624 8.395c-.019.252.027.504.134.733a1.6 1.6 0 0 1 1.349-.738Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m66.72 43.007-7.48-3.863a1.483 1.483 0 0 0-.727-.16 1.599 1.599 0 0 1-1.055 2.48c.17.187.383.329.622.41l7.968 2.72a.86.86 0 0 0 .672-1.578v-.009ZM55.6 39.882c0-.322.096-.636.278-.902a1.482 1.482 0 0 0-.727.16l-7.48 3.863a.86.86 0 0 0 .673 1.579l7.968-2.72c.239-.082.453-.223.622-.41a1.6 1.6 0 0 1-1.334-1.57Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M58.795 39.882a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0Z", "fill": "#fff", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "m47.068 21.04.8-.8a1.242 1.242 0 0 1 1.76 0l.728.728a1.244 1.244 0 0 0 1.76 0l.728-.728a1.242 1.242 0 0 1 1.76 0l.728.728a1.244 1.244 0 0 0 1.76 0l.728-.728a1.242 1.242 0 0 1 1.76 0l.728.728a1.244 1.244 0 0 0 1.76 0l.728-.728M44.997 15.862l.8-.8a1.241 1.241 0 0 1 1.76 0l.728.728a1.241 1.241 0 0 0 1.76 0l.728-.728a1.241 1.241 0 0 1 1.76 0l.728.728a1.241 1.241 0 0 0 1.76 0l.728-.728a1.241 1.241 0 0 1 1.76 0l.728.728a1.241 1.241 0 0 0 1.76 0l.728-.728M42.926 10.684l.8-.804a1.244 1.244 0 0 1 1.76 0l.728.728a1.241 1.241 0 0 0 1.76 0l.728-.728a1.244 1.244 0 0 1 1.76 0l.728.728a1.243 1.243 0 0 0 1.76 0l.728-.728a1.244 1.244 0 0 1 1.76 0l.728.728a1.241 1.241 0 0 0 1.76 0l.728-.728", "stroke": "#260347", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var windTurbine = {
  render: render$o
};
var render$n = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({ attrs: { "width": "80", "height": "80", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, _vm.$listeners), [_c("path", { attrs: { "d": "M7.42 40a32 32 0 1 0 64 0 32 32 0 0 0-64 0Z", "fill": "#F5F2F7" } }), _c("path", { attrs: { "d": "M10.428 63.282c0 .356 3.116.698 8.662.95 5.546.252 13.067.394 20.91.394s15.365-.142 20.91-.394c5.547-.252 8.662-.594 8.662-.95 0-.357-3.115-.699-8.661-.95-5.546-.253-13.068-.395-20.91-.395-7.844 0-15.365.142-20.911.394-5.546.252-8.662.594-8.662.95Z", "fill": "#B096CB" } }), _c("path", { attrs: { "d": "M14.283 62.573h-2.217a1.127 1.127 0 0 1-1.128-1.127V31.974h4.472v29.472a1.127 1.127 0 0 1-1.127 1.127ZM15.41 31.974h49.18v5.364H15.41v-5.364Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M6.019 27.593h67.962v4.38H6.019v-4.38Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M14.283 62.573h-2.217a1.127 1.127 0 0 1-1.128-1.127v-1.653h4.472v1.653a1.127 1.127 0 0 1-1.127 1.127Z", "fill": "#481D72", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M69.061 61.446a1.127 1.127 0 0 1-1.127 1.127h-2.216a1.126 1.126 0 0 1-1.128-1.127V31.974h4.471v29.472Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M67.934 62.573h-2.216a1.126 1.126 0 0 1-1.128-1.127v-1.653h4.471v1.653a1.127 1.127 0 0 1-1.127 1.127Z", "fill": "#481D72", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M48.698 54.113a.8.8 0 0 0 .8.8H64.59V37.338H48.698v16.775Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M48.698 46.126H64.59 48.698Z", "fill": "#fff" } }), _c("path", { attrs: { "d": "M48.698 46.126H64.59", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M55.068 41.732a1.577 1.577 0 1 0 3.153 0 1.577 1.577 0 0 0-3.153 0ZM55.068 50.52a1.577 1.577 0 1 0 3.153 0 1.577 1.577 0 0 0-3.153 0Z", "fill": "#481D72" } }), _c("path", { attrs: { "d": "M20.122 45.032h21.83v4.62h-21.83v-4.62Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M26.425 45.766a1.623 1.623 0 1 1-3.248 0V30.97h3.248v14.796ZM38.896 45.766a1.624 1.624 0 1 1-3.247 0V30.97h3.247v14.796Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M41.952 28.804a10.915 10.915 0 0 0-21.83 0v4.868a1.223 1.223 0 0 0 1.222 1.223H40.73a1.222 1.222 0 0 0 1.222-1.223v-4.868Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M24.695 56.442h12.683", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M23.453 62.853a1.223 1.223 0 0 1-1.2.99h-1.168a1.223 1.223 0 0 1-1.2-1.456l2.468-12.736h3.658l-2.558 13.202ZM38.62 62.853a1.223 1.223 0 0 0 1.2.99h1.169a1.222 1.222 0 0 0 1.2-1.456L39.72 49.651h-3.657l2.558 13.202ZM60.174 27.593h-6.16a.938.938 0 0 1-.936-.86l-.865-9.276h9.76l-.864 9.276a.938.938 0 0 1-.935.86Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M62.445 17.457H51.743a.468.468 0 0 1-.469-.47v-1.313a.938.938 0 0 1 .939-.939h9.76a.938.938 0 0 1 .938.939v1.314a.47.47 0 0 1-.466.47Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M61.976 14.735h-9.76l.679-1.64a.94.94 0 0 1 .84-.52h6.726a.94.94 0 0 1 .839.52l.676 1.64Z", "fill": "#fff", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M55.218 21.962a1.877 1.877 0 1 0 3.753 0 1.877 1.877 0 0 0-3.753 0Z", "fill": "#B096CB", "stroke": "#481D72", "stroke-width": ".75", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
};
var workspaceDesk = {
  render: render$n
};
var render$m = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.getComponent(_vm.icon), _vm._g(_vm._b({ tag: "component", staticClass: "fancy-icon" }, "component", _vm.$attrs, false), _vm.$listeners));
};
var staticRenderFns$m = [];
var FancyIcon_vue_vue_type_style_index_0_lang = "";
const IconComponents = Object.freeze({
  approveDocument,
  award,
  barberShop,
  blank,
  burgerSodaSet,
  burningEarth,
  burningMoney,
  calendarDeadline,
  callQuestion,
  check,
  clipboard,
  clipboardCheck,
  collaboratedEffort,
  contractDocument,
  cooperateMoney,
  courthouse,
  coworkerFullBody,
  coworkerHalfBody,
  coworkerThreeQuarter,
  creativeIdeaDesk,
  curiousDog,
  customerDoubt,
  customerServerImac,
  deniedContract,
  doctorFirstAid,
  documentChecklist,
  documentSign,
  documentsQuestion,
  emojiHappySadFrown,
  emojiHappySadSmile,
  factory,
  firewallSecure,
  fitnessTracker,
  flame,
  folderDocument,
  groupLearn,
  graduation,
  handpickResume,
  healthCall,
  healthCharityDonation,
  healthInsuranceCross,
  healthInsuranceUmbrella,
  hotelTicket,
  imacWorkspace,
  interview,
  invoice,
  invoiceCalculating,
  invoiceHand,
  judicialDocument,
  lawBook,
  learning,
  lightbulbStartup,
  macbookTyping,
  megaphoneHand,
  noteTime,
  overtimeStand,
  paymentReceive,
  policeCar,
  puzzlePeople,
  searchingNetwork,
  services,
  signTablet,
  startupBarChart,
  storeFront,
  summitFlag,
  tableware,
  teamLeader,
  teamSuccess,
  ticketReserved,
  ticket,
  tipperTruck,
  travelClock,
  umbrella,
  white,
  windTurbine,
  workspaceDesk
});
const Icons = Object.freeze(
  Object.keys(IconComponents).reduce(
    (obj, val) => ({
      ...obj,
      [snakeCase_1(val).toUpperCase()]: val
    }),
    {}
  )
);
const isValidIcon = (value) => Object.values(Icons).includes(camelCase_1(value));
const getComponent = (iconName) => IconComponents[iconName];
const __vue2_script$m = {
  props: {
    icon: {
      type: String,
      required: true,
      validator: isValidIcon
    }
  },
  setup() {
    return {
      getComponent
    };
  }
};
const __cssModules$m = {};
var __component__$m = /* @__PURE__ */ normalizeComponent(
  __vue2_script$m,
  render$m,
  staticRenderFns$m,
  false,
  __vue2_injectStyles$m,
  null,
  null,
  null
);
function __vue2_injectStyles$m(context) {
  for (let o in __cssModules$m) {
    this[o] = __cssModules$m[o];
  }
}
var FancyIcon = /* @__PURE__ */ function() {
  return __component__$m.exports;
}();
var render$l = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", _vm._b({ class: _vm.classList }, "div", _vm.$attrs, false), [_c("BaseIcon", { staticClass: "icon-button__icon", attrs: { "icon": _vm.icon } })], 1);
};
var staticRenderFns$l = [];
var HighlightedIcon_vue_vue_type_style_index_0_scoped_true_lang = "";
const Sizes$1 = Object.freeze({ TINY, SMALL, MEDIUM, LARGE });
const Variants$1 = Object.freeze({
  PRIMARY: "primary",
  SECONDARY: "secondary",
  GRAY: "gray"
});
const __vue2_script$l = defineComponent({
  name: "HighlightedIcon",
  components: {
    BaseIcon
  },
  props: {
    icon: {
      type: String,
      required: true,
      validator: isValidIcon$1
    },
    size: {
      type: String,
      default: Sizes$1.MEDIUM,
      validator: (val) => Object.values(Sizes$1).includes(val)
    },
    variant: {
      type: String,
      default: Variants$1.PRIMARY,
      required: false
    }
  },
  setup(props2) {
    const classList2 = computed(() => [
      "highlighted-icon",
      `highlighted-icon--${props2.variant}`,
      `highlighted-icon--${props2.size}`
    ]);
    return {
      classList: classList2
    };
  }
});
const __cssModules$l = {};
var __component__$l = /* @__PURE__ */ normalizeComponent(
  __vue2_script$l,
  render$l,
  staticRenderFns$l,
  false,
  __vue2_injectStyles$l,
  "5f34fad6",
  null,
  null
);
function __vue2_injectStyles$l(context) {
  for (let o in __cssModules$l) {
    this[o] = __cssModules$l[o];
  }
}
var HighlightedIcon = /* @__PURE__ */ function() {
  return __component__$l.exports;
}();
const Grid = Object.freeze({
  Widths: {
    NARROW: "narrow",
    WIDE: "wide",
    AUTO: "auto",
    FULL_BLEED: "full-bleed"
  }
});
var render$k = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", _vm._g(_vm._b({ staticClass: "loose-grid", class: "loose-grid--" + _vm.width }, "div", _vm.$attrs, false), _vm.$listeners), [_vm._t("default")], 2);
};
var staticRenderFns$k = [];
var LooseGrid_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$k = {
  props: {
    width: {
      type: String,
      default: Grid.Widths.AUTO,
      validator: (value) => Object.values(Grid.Widths).includes(value)
    }
  }
};
const __cssModules$k = {};
var __component__$k = /* @__PURE__ */ normalizeComponent(
  __vue2_script$k,
  render$k,
  staticRenderFns$k,
  false,
  __vue2_injectStyles$k,
  "5fbc6f78",
  null,
  null
);
function __vue2_injectStyles$k(context) {
  for (let o in __cssModules$k) {
    this[o] = __cssModules$k[o];
  }
}
var LooseGrid = /* @__PURE__ */ function() {
  return __component__$k.exports;
}();
var render$j = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "meerkat-notification", class: [
    "meerkat-notification--" + _vm.variant,
    { "meerkat-notification--with-avatar": !!_vm.avatar }
  ], attrs: { "role": _vm.showActions ? "alertdialog" : "alert" } }, [_c("div", { staticClass: "meerkat-notification__content" }, [_vm.avatar ? _c("div", { staticClass: "meerkat-notification__avatar-container" }, [_c("AvatarImage", _vm._b({ staticClass: "meerkat-notification__avatar" }, "AvatarImage", _vm.avatar, false))], 1) : _vm._e(), _c("div", { staticClass: "meerkat-notification__message" }, [_vm._t("default", [_vm._v(_vm._s(_vm.message))])], 2), _vm.showActions ? _c("div", { staticClass: "meerkat-notification__actions" }, [_vm._t("actions", [_c("IconButton", _vm._b({ staticClass: "meerkat-notification__close", attrs: { "title": "Close" }, on: { "click": function($event) {
    return _vm.$emit("close");
  } } }, "IconButton", _vm.actionProps, false))])], 2) : _vm._e()])]);
};
var staticRenderFns$j = [];
var MeerkatNotification_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$j = defineComponent({
  name: "MeerkatNotification",
  components: { AvatarImage, IconButton },
  props: {
    image: {
      type: String,
      default: null
    },
    initials: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    },
    showActions: {
      type: Boolean,
      default: true
    },
    timer: {
      type: Number,
      default: 0,
      validator: (val) => val >= 0
    },
    variant: {
      type: String,
      default: Notification.Variants.DEFAULT,
      validator: (value) => Object.values(Notification.Variants).includes(value)
    }
  },
  setup(props2, { emit }) {
    const actionProps = computed(() => ({
      size: Button.Sizes.MEDIUM,
      icon: Icons$1.CLOSE,
      variant: Button.Variants.INVERTED_PRIMARY,
      title: "Close",
      flat: true
    }));
    const avatar = computed(() => {
      const { image, initials } = props2;
      if (image || initials) {
        return {
          image,
          initials
        };
      }
      return null;
    });
    onMounted(() => {
      if (props2.timer) {
        setTimeout(() => {
          emit("close");
        }, props2.timer);
      }
    });
    onBeforeUnmount(() => {
      clearTimeout(props2.timer);
    });
    return {
      actionProps,
      avatar
    };
  }
});
const __cssModules$j = {};
var __component__$j = /* @__PURE__ */ normalizeComponent(
  __vue2_script$j,
  render$j,
  staticRenderFns$j,
  false,
  __vue2_injectStyles$j,
  "46ec6e20",
  null,
  null
);
function __vue2_injectStyles$j(context) {
  for (let o in __cssModules$j) {
    this[o] = __cssModules$j[o];
  }
}
var MeerkatNotification = /* @__PURE__ */ function() {
  return __component__$j.exports;
}();
function objectWithoutProperties$1(obj, exclude) {
  var target = {};
  for (var k in obj)
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1)
      target[k] = obj[k];
  return target;
}
var render$i = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.notifications.length ? _c("transition-group", { staticClass: "meerkat-notifications", class: "meerkat-notifications--" + _vm.position, attrs: { "tag": "div", "name": "meerkat" }, on: { "before-leave": _vm.beforeLeave } }, _vm._l(_vm.notifications, function(ref2) {
    var message = ref2.message;
    var actions = ref2.actions;
    if (actions === void 0)
      actions = [];
    var id = ref2.id;
    var rest$1 = objectWithoutProperties$1(ref2, ["message", "actions", "id"]);
    var rest = rest$1;
    return _c("MeerkatNotification", _vm._b({ key: id, on: { "close": function($event) {
      return _vm.$emit("close", id);
    } }, scopedSlots: _vm._u([actions.length ? { key: "actions", fn: function() {
      return _vm._l(actions, function(ref3) {
        var label = ref3.label;
        var handler = ref3.handler;
        return _c("BaseButton", { key: label, staticClass: "text-white bg-transparent border-none", attrs: { "size": _vm.$options.Button.Sizes.SMALL, "variant": _vm.$options.Button.Variants.INVERTED_PRIMARY, "flat": "" }, on: { "click": handler } }, [_vm._v(" " + _vm._s(label) + " ")]);
      });
    }, proxy: true } : null], null, true) }, "MeerkatNotification", rest, false), [_vm._v(" " + _vm._s(message) + " ")]);
  }), 1) : _vm._e();
};
var staticRenderFns$i = [];
var MeerkatNotifications_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$i = defineComponent({
  name: "MeerkatNotifications",
  Button,
  components: { BaseButton, MeerkatNotification },
  props: {
    notifications: {
      type: Array,
      default: () => []
    },
    position: {
      type: String,
      default: Notification.Positions.BOTTOM_CENTER,
      validator: (value) => Object.values(Notification.Positions).includes(value)
    }
  },
  setup() {
    const beforeLeave = (el) => {
      el.setAttribute("style", `top: ${el.offsetTop || 0}px`);
    };
    return { beforeLeave };
  }
});
const __cssModules$i = {};
var __component__$i = /* @__PURE__ */ normalizeComponent(
  __vue2_script$i,
  render$i,
  staticRenderFns$i,
  false,
  __vue2_injectStyles$i,
  "05632b0c",
  null,
  null
);
function __vue2_injectStyles$i(context) {
  for (let o in __cssModules$i) {
    this[o] = __cssModules$i[o];
  }
}
var MeerkatNotifications = /* @__PURE__ */ function() {
  return __component__$i.exports;
}();
const currentId = ref("");
const usePopover = (initialId) => {
  currentId.value = initialId;
  return {
    currentId,
    toggle: (id) => {
      if (currentId.value === id || !id) {
        currentId.value = "";
      } else {
        currentId.value = id;
      }
    }
  };
};
var render$h = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "popover-menu" }, [_c("button", { staticClass: "popover-menu__trigger", attrs: { "type": "button" }, on: { "click": function($event) {
    $event.stopPropagation();
    _vm.onlyAllowOneOpen ? _vm.toggle(_vm.id) : _vm.isActive = !_vm.isActive;
  } } }, [_vm._t("default")], 2), _vm.onlyAllowOneOpen && _vm.currentId === _vm.id || _vm.isActive ? _c("div", { staticClass: "popover-menu__items", class: "popover-menu__items--" + _vm.alignment, style: { width: _vm.width } }, [_vm._l(_vm.items, function(ref2) {
    var handler = ref2.handler;
    if (handler === void 0)
      handler = function() {
      };
    var icon2 = ref2.icon;
    var label = ref2.label;
    return [_vm._t(label, [_c("button", { key: label, staticClass: "popover-menu__item", on: { "click": handler } }, [icon2 ? _c("BaseIcon", { staticClass: "popover-menu__icon", attrs: { "icon": icon2 } }) : _vm._e(), _c("span", [_vm._v(_vm._s(label))])], 1)])];
  })], 2) : _vm._e()]);
};
var staticRenderFns$h = [];
var PopoverMenu_vue_vue_type_style_index_0_scoped_true_lang = "";
const Alignments = Object.freeze({
  LEFT: "left",
  RIGHT: "right"
});
const __vue2_script$h = defineComponent({
  name: "PopoverMenu",
  components: { BaseIcon },
  props: {
    alignment: {
      type: String,
      default: Alignments.LEFT
    },
    initiallyOpen: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    width: {
      type: String,
      default: "auto"
    },
    onlyAllowOneOpen: {
      type: Boolean,
      default: false
    }
  },
  setup(props2) {
    const isActive = ref(props2.initiallyOpen);
    const id = ref(shortid.generate());
    const { toggle, currentId: currentId2 } = usePopover(props2.initiallyOpen ? id : null);
    const close = () => {
      isActive.value = false;
    };
    const handleClose = () => {
      if (props2.onlyAllowOneOpen) {
        toggle();
      } else {
        close();
      }
    };
    const handleKeyup = (e) => {
      if (e.keyCode !== 27) {
        return;
      }
      handleClose();
    };
    const addListeners = () => {
      document.addEventListener("keyup", handleKeyup);
      document.body.addEventListener("click", handleClose);
    };
    const removeListeners = () => {
      document.removeEventListener("keyup", handleKeyup);
      document.body.addEventListener("click", handleClose);
    };
    onMounted(() => {
      addListeners();
    });
    onBeforeUnmount(() => {
      removeListeners();
    });
    watch(isActive, (newVal) => {
      if (newVal) {
        addListeners();
      } else {
        removeListeners();
      }
    });
    return {
      isActive,
      toggle,
      id,
      currentId: currentId2
    };
  }
});
const __cssModules$h = {};
var __component__$h = /* @__PURE__ */ normalizeComponent(
  __vue2_script$h,
  render$h,
  staticRenderFns$h,
  false,
  __vue2_injectStyles$h,
  "25f5c55a",
  null,
  null
);
function __vue2_injectStyles$h(context) {
  for (let o in __cssModules$h) {
    this[o] = __cssModules$h[o];
  }
}
var PopoverMenu = /* @__PURE__ */ function() {
  return __component__$h.exports;
}();
var render$g = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("BaseIcon", { class: "progress-icon progress-icon--" + _vm.isCompleteClass + (_vm.isDisabled && " progress-icon--disabled"), attrs: { "icon": _vm.isCompleteIcon } });
};
var staticRenderFns$g = [];
var ProgressIcon_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$g = defineComponent({
  name: "ProgressIcon",
  components: { BaseIcon },
  props: {
    complete: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props2) {
    const isCompleteIcon = computed(() => {
      return props2.complete ? `${Icons$1.CHECK_CIRCLE_SOLID}` : `${Icons$1.CIRCLE}`;
    });
    const isCompleteClass = computed(() => {
      return props2.complete ? "complete" : "incomplete";
    });
    const isDisabled = computed(() => {
      return props2.disabled && " progress-icon--disabled";
    });
    return { isCompleteIcon, isDisabled, Icons: Icons$1, isCompleteClass };
  }
});
const __cssModules$g = {};
var __component__$g = /* @__PURE__ */ normalizeComponent(
  __vue2_script$g,
  render$g,
  staticRenderFns$g,
  false,
  __vue2_injectStyles$g,
  "51f8c239",
  null,
  null
);
function __vue2_injectStyles$g(context) {
  for (let o in __cssModules$g) {
    this[o] = __cssModules$g[o];
  }
}
var ProgressIcon = /* @__PURE__ */ function() {
  return __component__$g.exports;
}();
var render$f = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "radio-toggle", class: { focused: _vm.isFocused }, on: { "click": function($event) {
    _vm.isFocused = false;
  } } }, [_vm._l(_vm.mappedOptions, function(item, i) {
    return _c("label", { key: item.value, ref: "labelRefs", refInFor: true, staticClass: "radio-toggle__container", class: { active: _vm.value === item.value }, attrs: { "value": item.value, "for": _vm.name + "-" + i } }, [_c("input", { staticClass: "radio-toggle__input", attrs: { "id": _vm.name + "-" + i, "name": _vm.name, "type": "radio" }, domProps: { "value": item.value, "checked": _vm.value === item.value }, on: { "blur": function($event) {
      _vm.isFocused = false;
    }, "focus": function($event) {
      _vm.isFocused = true;
    }, "click": _vm.handleInput } }), _c("span", { staticClass: "radio-toggle__label", domProps: { "innerHTML": _vm._s(item.label) } })]);
  }), _vm.value ? _c("div", { staticClass: "radio-toggle__indicator", style: _vm.bgStyle }) : _vm._e()], 2);
};
var staticRenderFns$f = [];
var RadioToggle_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$f = defineComponent({
  name: "RadioToggle",
  props: {
    name: {
      type: String,
      default: shortid.generate
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: null
    }
  },
  setup(props2, { emit }) {
    const bgStyle = ref({});
    const isFocused = ref(false);
    const currentOption = computed(() => props2.value);
    const handleInput = (event) => {
      emit("input", event.target.value);
    };
    const labelRefs = ref([]);
    const positionIndicator = () => {
      const activeLabel = labelRefs.value.find(
        (label) => label.attributes.value.nodeValue === currentOption.value
      );
      if (activeLabel) {
        bgStyle.value = {
          left: `${activeLabel.offsetLeft}px`,
          height: `${activeLabel.offsetHeight}px`,
          width: `${activeLabel.offsetWidth}px`
        };
      }
    };
    onMounted(() => {
      positionIndicator();
    });
    watch(currentOption, () => {
      positionIndicator();
    });
    const mappedOptions = computed(() => mapOptions(props2.options));
    return {
      mappedOptions,
      isFocused,
      bgStyle,
      labelRefs,
      handleInput,
      positionIndicator
    };
  }
});
const __cssModules$f = {};
var __component__$f = /* @__PURE__ */ normalizeComponent(
  __vue2_script$f,
  render$f,
  staticRenderFns$f,
  false,
  __vue2_injectStyles$f,
  "1796e41d",
  null,
  null
);
function __vue2_injectStyles$f(context) {
  for (let o in __cssModules$f) {
    this[o] = __cssModules$f[o];
  }
}
var RadioToggle = /* @__PURE__ */ function() {
  return __component__$f.exports;
}();
var __vue2_script$e = defineComponent({
  name: "SurveyCard",
  components: {
    BaseCard,
    TypeBody,
    BlockCheckGroup,
    BaseButton,
    BaseIcon,
    IconButton
  },
  props: {
    primaryButtonLabel: {
      type: String,
      default: "continue"
    },
    secondaryButtonLabel: {
      type: String,
      default: "back"
    },
    defaultOptionValues: {
      type: [Array],
      default: () => []
    },
    pageIndex: {
      type: Number,
      default: 0
    },
    pages: {
      type: Array,
      default: () => []
    },
    showFooter: {
      type: Boolean,
      default: true
    }
  },
  setup(props2, { emit }) {
    const currentPageIndex = ref(props2.pageIndex);
    const history = ref([]);
    const selectedOptions = ref([...props2.defaultOptionValues]);
    const currentPage = computed(() => props2.pages[currentPageIndex.value]);
    const isFirstPage = computed(() => currentPageIndex.value === 0);
    const isLastPage = computed(
      () => currentPageIndex.value === props2.pages.length - 1
    );
    const componentValues = computed(
      () => props2.pages.filter((page) => page.component).map((page) => ({ [page.id]: page.attrs.value })).reduce((acc, curr) => ({ ...acc, ...curr }), {})
    );
    const optionsWithoutTo = computed(
      () => {
        var _a, _b;
        return ((_b = (_a = currentPage.value) == null ? void 0 : _a.options) == null ? void 0 : _b.filter((option) => !option.to)) || [];
      }
    );
    const handleBack = () => {
      const previousPageIndex = history.value.pop();
      currentPageIndex.value = previousPageIndex;
      emit("back", previousPageIndex);
      if (currentPage.value.shouldResetOnBack) {
        selectedOptions.value = [];
      }
    };
    const goToPage = (pageId) => {
      const pageIndex = props2.pages.findIndex((page) => page.id === pageId);
      history.value.push(currentPageIndex.value);
      currentPageIndex.value = pageIndex;
    };
    const handleTo = (option) => {
      emit("to", option);
      goToPage(option.to);
    };
    const handleSubmit = () => {
      emit("submit", {
        selectedOptions: [...selectedOptions.value],
        componentValues: componentValues.value
      });
    };
    const reset2 = () => {
      goToPage(props2.pages[0].id);
      history.value = [];
      selectedOptions.value = [];
    };
    const handleNext = () => {
      if (isLastPage.value) {
        handleSubmit();
      } else {
        if (currentPage.value.to) {
          goToPage(currentPage.value.to);
          return;
        }
        const nextPageIndex = currentPageIndex.value + 1;
        history.value.push(currentPageIndex.value);
        currentPageIndex.value = nextPageIndex;
        emit("next", nextPageIndex);
      }
    };
    watch(
      currentPage,
      (page) => {
        if (page) {
          emit("current-page", page);
        }
      },
      {
        immediate: true
      }
    );
    watch(selectedOptions, (vals) => {
      if (vals) {
        emit("input", vals);
      }
    });
    watch(componentValues, (vals) => {
      if (vals) {
        emit("component-input", vals);
      }
    });
    const handleKeyup = (e) => {
      if (e.keyCode !== 27) {
        return;
      }
      emit("close");
    };
    onMounted(() => {
      document.addEventListener("keyup", handleKeyup);
    });
    onBeforeUnmount(() => {
      document.removeEventListener("keyup", handleKeyup);
    });
    return {
      isFirstPage,
      isLastPage,
      selectedOptions,
      optionsWithoutTo,
      currentPage,
      componentValues,
      handleKeyup,
      goToPage,
      reset: reset2,
      handleBack,
      handleSubmit,
      handleNext,
      handleTo
    };
  }
});
var render$e = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("BaseCard", { staticClass: "survey-card", attrs: { "full-bleed": "" } }, [_c("div", { staticClass: "survey-card-body" }, [_c("IconButton", { staticClass: "survey-card-close-button", attrs: { "variant": "secondary", "icon": "close", "flat": "" }, on: { "click": function($event) {
    return _vm.$emit("close");
  } } }), _c("div", { staticClass: "survey-card-title-container" }, [_c("TypeBody", { attrs: { "variant": "medium", "weight": "strong" } }, [_vm._v(" " + _vm._s(_vm.currentPage.title) + " ")]), _c("TypeBody", { attrs: { "variant": "text" } }, [_vm._v(" " + _vm._s(_vm.currentPage.subtitle) + " ")])], 1), [_c("div", { staticClass: "survey-card-options" }, [_vm._l(_vm.currentPage.options, function(option) {
    return [option.to ? _c("a", { key: option.label, staticClass: "survey-card-to-option-link", attrs: { "role": "button" }, on: { "click": function($event) {
      return _vm.handleTo(option);
    } } }, [_c("div", { staticClass: "survey-card-to-option" }, [_c("TypeBody", { staticClass: "survey-card-option-label", attrs: { "variant": "text" } }, [_vm._v(" " + _vm._s(option.label) + " ")]), _c("BaseIcon", { staticClass: "survey-card-option-icon", attrs: { "icon": "chevronRight" } })], 1)]) : _vm._e()];
  }), _vm.currentPage.component ? _c(_vm.currentPage.component, _vm._b({ tag: "component", model: { value: _vm.currentPage.attrs.value, callback: function($$v) {
    _vm.$set(_vm.currentPage.attrs, "value", $$v);
  }, expression: "currentPage.attrs.value" } }, "component", _vm.currentPage.attrs, false)) : _vm._e(), _vm.optionsWithoutTo.length ? _c("BlockCheckGroup", { staticClass: "survey-card-check-group", attrs: { "label-position": "left", "options": _vm.optionsWithoutTo, "vertical": "" }, on: { "input": function($event) {
    return _vm.$emit("input", $event);
  } }, model: { value: _vm.selectedOptions, callback: function($$v) {
    _vm.selectedOptions = $$v;
  }, expression: "selectedOptions" } }) : _vm._e()], 2)]], 2), _vm.showFooter && _vm.currentPage.hasFooter ? _c("div", { staticClass: "survey-card-footer" }, [_vm.$slots.footer ? _vm._t("footer") : [_c("BaseButton", { attrs: { "disabled": _vm.isFirstPage, "variant": "primary", "flat": "" }, on: { "click": _vm.handleBack } }, [_vm._v(" " + _vm._s(_vm.secondaryButtonLabel) + " ")]), _c("BaseButton", { attrs: { "disabled": !_vm.selectedOptions.length && !_vm.componentValues[_vm.currentPage.id], "variant": "primary" }, on: { "click": _vm.handleNext } }, [_vm._v(" " + _vm._s(_vm.primaryButtonLabel) + " ")])]], 2) : _vm._e()]);
};
var staticRenderFns$e = [];
var SurveyCard_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$e = {};
var __component__$e = /* @__PURE__ */ normalizeComponent(
  __vue2_script$e,
  render$e,
  staticRenderFns$e,
  false,
  __vue2_injectStyles$e,
  "7a5808e7",
  null,
  null
);
function __vue2_injectStyles$e(context) {
  for (let o in __cssModules$e) {
    this[o] = __cssModules$e[o];
  }
}
var SurveyCard = /* @__PURE__ */ function() {
  return __component__$e.exports;
}();
var render$d = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ToggleGroup", { staticClass: "switch-group", attrs: { "options": _vm.options, "disabled": _vm.disabled, "invalid": _vm.invalid, "label": _vm.label, "label-position": _vm.labelPosition, "name": _vm.name, "required": _vm.required, "size": _vm.size, "vertical": _vm.vertical, "value": _vm.value, "type": "switch" }, on: { "input": function($event) {
    return _vm.$emit("input", $event);
  } } });
};
var staticRenderFns$d = [];
const __vue2_script$d = defineComponent({
  name: "SwitchGroup",
  components: { ToggleGroup },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    labelPosition: {
      type: String,
      default: Form.LabelPositions.RIGHT,
      validator: (value) => Object.values(Form.LabelPositions).includes(value)
    },
    name: {
      type: String,
      default: void 0
    },
    options: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => [Form.Sizes.DENSE, Form.Sizes.NORMAL].includes(value)
    },
    vertical: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    }
  }
});
const __cssModules$d = {};
var __component__$d = /* @__PURE__ */ normalizeComponent(
  __vue2_script$d,
  render$d,
  staticRenderFns$d,
  false,
  __vue2_injectStyles$d,
  null,
  null,
  null
);
function __vue2_injectStyles$d(context) {
  for (let o in __cssModules$d) {
    this[o] = __cssModules$d[o];
  }
}
var SwitchGroup = /* @__PURE__ */ function() {
  return __component__$d.exports;
}();
var createCompounder = _createCompounder;
var kebabCase = createCompounder(function(result, word, index) {
  return result + (index ? "-" : "") + word.toLowerCase();
});
var kebabCase_1 = kebabCase;
var render$c = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "tab-controls" }, [_c("div", { staticClass: "tab-controls__container--desktop" }, [_c("ul", { staticClass: "tab-controls__tabs", class: { "tab-controls--full-width": _vm.fullWidth }, attrs: { "role": "tablist" } }, _vm._l(_vm.mappedOptions, function(item) {
    return _c("li", { key: item.value, ref: "itemRefs", refInFor: true, staticClass: "tab-controls__tab", class: { "tab-controls__tab--active": item.selected }, attrs: { "value": item.value } }, [_c("a", { staticClass: "tab-controls__link", attrs: { "id": item.id, "role": "tab", "href": "#" + item.target, "aria-selected": item.selected, "aria-controls": item.target }, on: { "click": function($event) {
      $event.preventDefault();
      return _vm.$emit("input", item.value);
    } } }, [typeof item.label === "object" ? _c(item.label, { tag: "component" }) : [_vm._v(_vm._s(item.label))]], 2)]);
  }), 0), _c("div", { staticClass: "tab-controls__indicator", style: _vm.indicatorStyle, attrs: { "role": "presentation" } })]), _c("div", { staticClass: "tab-controls__container--mobile" }, [_c("SelectInput", { attrs: { "id": "tab-control-mobile", "show-reset": false, "options": _vm.mappedOptions, "value": _vm.currentOption }, on: { "input": function($event) {
    return _vm.$emit("input", $event);
  } } })], 1)]);
};
var staticRenderFns$c = [];
var TabControls_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$c = defineComponent({
  name: "TabControls",
  components: { SelectInput },
  props: {
    fullWidth: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    tabsetId: {
      type: String,
      default: shortid.generate
    },
    value: {
      type: String,
      default: null
    }
  },
  setup(props2) {
    const indicatorStyle = ref({});
    const itemRefs = ref([]);
    const currentOption = computed(() => props2.value);
    const positionIndicator = () => {
      const activeLabel = itemRefs.value.find(
        (item) => item.attributes.value.nodeValue === currentOption.value
      );
      if (activeLabel) {
        indicatorStyle.value = {
          left: `${activeLabel.offsetLeft}px`,
          top: `${activeLabel.offsetTop + activeLabel.offsetHeight}px`,
          width: `${activeLabel.offsetWidth}px`
        };
      }
    };
    const mappedOptions = computed(
      () => mapOptions(props2.options).map((item) => ({
        ...item,
        target: `${props2.tabsetId}-${kebabCase_1(
          item.value
        ).toLowerCase()}-panel`,
        id: `${props2.tabsetId}-${kebabCase_1(item.value).toLowerCase()}-tab`,
        selected: item.value === currentOption.value
      }))
    );
    const checkPosition = debounce_1(positionIndicator, 100);
    onMounted(() => {
      positionIndicator();
      window.addEventListener("resize", checkPosition);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("resize", checkPosition);
    });
    watch(currentOption, () => {
      positionIndicator();
    });
    return {
      currentOption,
      indicatorStyle,
      itemRefs,
      mappedOptions,
      positionIndicator
    };
  }
});
const __cssModules$c = {};
var __component__$c = /* @__PURE__ */ normalizeComponent(
  __vue2_script$c,
  render$c,
  staticRenderFns$c,
  false,
  __vue2_injectStyles$c,
  "33f03f49",
  null,
  null
);
function __vue2_injectStyles$c(context) {
  for (let o in __cssModules$c) {
    this[o] = __cssModules$c[o];
  }
}
var TabControls = /* @__PURE__ */ function() {
  return __component__$c.exports;
}();
var render$b = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "tab-panel", class: { "tab-panel--active": _vm.active }, attrs: { "id": _vm.value, "role": "tabpanel", "aria-hidden": !_vm.active, "hidden": !_vm.active } }, [_vm._t("default")], 2);
};
var staticRenderFns$b = [];
var TabPanel_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$b = defineComponent({
  name: "TabPanel",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    tabsetId: {
      type: String,
      default: shortid.generate
    },
    value: {
      type: String,
      default: shortid.generate
    }
  },
  setup(props2) {
    const id = ref(
      `${props2.tabsetId}-${kebabCase_1(props2.value).toLowerCase()}-panel`
    );
    return { id };
  }
});
const __cssModules$b = {};
var __component__$b = /* @__PURE__ */ normalizeComponent(
  __vue2_script$b,
  render$b,
  staticRenderFns$b,
  false,
  __vue2_injectStyles$b,
  "4d668692",
  null,
  null
);
function __vue2_injectStyles$b(context) {
  for (let o in __cssModules$b) {
    this[o] = __cssModules$b[o];
  }
}
var TabPanel = /* @__PURE__ */ function() {
  return __component__$b.exports;
}();
var render$a = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "tab-set", attrs: { "id": _vm.id } }, [_c("TabControls", { attrs: { "full-width": _vm.fullWidth, "tabset-id": _vm.id, "options": _vm.mappedOptions }, model: { value: _vm.activeTab, callback: function($$v) {
    _vm.activeTab = $$v;
  }, expression: "activeTab" } }), _vm._l(_vm.mappedOptions, function(ref2) {
    var value = ref2.value;
    var content = ref2.content;
    return _c("TabPanel", { key: value, attrs: { "active": value === _vm.activeTab, "tabset-id": _vm.id, "value": value } }, [_vm._t(value, [_c("div", { staticClass: "tab-set__simple-content" }, [_vm._v(_vm._s(content))])], { "activeTab": _vm.activeTab })], 2);
  })], 2);
};
var staticRenderFns$a = [];
var TabSet_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$a = defineComponent({
  components: { TabControls, TabPanel },
  props: {
    fullWidth: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: shortid.generate
    },
    initialValue: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  setup(props2, { emit }) {
    const activeTab = ref(props2.initialValue);
    const mappedOptions = computed(() => mapOptions(props2.options));
    watch(activeTab, (newValue) => {
      emit("tab-change", newValue);
    });
    onBeforeMount(() => {
      if (activeTab.value || !mappedOptions.value.length)
        return;
      activeTab.value = mappedOptions.value[0].value;
    });
    return {
      activeTab,
      mappedOptions
    };
  }
});
const __cssModules$a = {};
var __component__$a = /* @__PURE__ */ normalizeComponent(
  __vue2_script$a,
  render$a,
  staticRenderFns$a,
  false,
  __vue2_injectStyles$a,
  "424968d4",
  null,
  null
);
function __vue2_injectStyles$a(context) {
  for (let o in __cssModules$a) {
    this[o] = __cssModules$a[o];
  }
}
var TabSet = /* @__PURE__ */ function() {
  return __component__$a.exports;
}();
var render$9 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "user-avatar", class: [
    "user-avatar--" + _vm.size,
    {
      "user-avatar--vertical": _vm.vertical,
      "user-avatar--horizontal": !_vm.vertical
    }
  ] }, [_c("AvatarImage", { attrs: { "image": _vm.image, "name": _vm.name, "size": _vm.avatarSize } }), _vm.name || _vm.title ? _c("div", { staticClass: "user-avatar__details" }, [_vm.name ? _c("div", { staticClass: "user-avatar__name" }, [_vm._v(_vm._s(_vm.name))]) : _vm._e(), _vm.title ? _c("div", { staticClass: "user-avatar__title" }, [_vm._v(_vm._s(_vm.title))]) : _vm._e()]) : _vm._e()], 1);
};
var staticRenderFns$9 = [];
var UserAvatar_vue_vue_type_style_index_0_scoped_true_lang = "";
const Sizes = Object.freeze({
  TINY: "tiny",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
});
const __vue2_script$9 = {
  components: { AvatarImage },
  props: {
    image: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: Sizes.MEDIUM,
      validator: (value) => Object.values(Sizes).includes(value)
    },
    title: {
      type: String,
      default: null
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  setup(props2) {
    const avatarSize = computed(() => {
      switch (props2.size) {
        case Sizes.TINY:
          return props2.vertical ? 48 : 16;
        case Sizes.SMALL:
          return props2.vertical ? 48 : 24;
        case Sizes.LARGE:
          return props2.vertical ? 104 : 40;
        case Sizes.MEDIUM:
        default:
          return props2.vertical ? 64 : 32;
      }
    });
    return { avatarSize };
  }
};
const __cssModules$9 = {};
var __component__$9 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$9,
  render$9,
  staticRenderFns$9,
  false,
  __vue2_injectStyles$9,
  "0a9c686a",
  null,
  null
);
function __vue2_injectStyles$9(context) {
  for (let o in __cssModules$9) {
    this[o] = __cssModules$9[o];
  }
}
var UserAvatar = /* @__PURE__ */ function() {
  return __component__$9.exports;
}();
function objectWithoutProperties(obj, exclude) {
  var target = {};
  for (var k in obj)
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1)
      target[k] = obj[k];
  return target;
}
var render$8 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "task-card-item" }, [_vm.progressIcon ? _c("div", { staticClass: "task-card-item__status" }, [_c("ProgressIcon", _vm._b({}, "ProgressIcon", _vm.progressIcon, false))], 1) : _vm._e(), _c("div", { staticClass: "task-card-item__content" }, [_c("div", { staticClass: "task-card-item__title" }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _vm.description ? _c("div", { staticClass: "task-card-item__description" }, [_vm._v(" " + _vm._s(_vm.description) + " "), _vm.attribution ? [_vm._v(" By "), _c("UserAvatar", _vm._b({ staticClass: "task-card-item__avatar", attrs: { "size": _vm.$options.Sizes.TINY } }, "UserAvatar", _vm.attribution, false))] : _vm._e()], 2) : _vm._e()]), _vm.actions ? _c("div", { staticClass: "task-card-item__actions" }, _vm._l(_vm.actions, function(ref2) {
    var handler = ref2.handler;
    var rest$1 = objectWithoutProperties(ref2, ["handler"]);
    var rest = rest$1;
    return _c("BaseButton", _vm._b({ key: rest.label, staticClass: "task-card-item__action", attrs: { "size": _vm.$options.Button.Sizes.SMALL }, on: { "click": function() {
      return handler ? handler() : function() {
      };
    } } }, "BaseButton", rest, false));
  }), 1) : _vm._e()]);
};
var staticRenderFns$8 = [];
var TaskCardItem_vue_vue_type_style_index_0_scoped_true_lang = "";
const TaskStatuses = Object.freeze({
  COMPLETE: "complete",
  INCOMPLETE: "incomplete",
  DISABLED: "disabled"
});
const __vue2_script$8 = {
  Button,
  Sizes,
  components: { BaseButton, ProgressIcon, UserAvatar },
  props: {
    actions: {
      type: Array,
      default: null
    },
    attribution: {
      type: Object,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    status: {
      type: String,
      default: null,
      validator: (value) => !value || Object.values(TaskStatuses).includes(value)
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    progressIcon() {
      return this.status ? {
        complete: this.status === TaskStatuses.COMPLETE,
        disabled: this.status === TaskStatuses.DISABLED
      } : null;
    }
  }
};
const __cssModules$8 = {};
var __component__$8 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$8,
  render$8,
  staticRenderFns$8,
  false,
  __vue2_injectStyles$8,
  "f59fee94",
  null,
  null
);
function __vue2_injectStyles$8(context) {
  for (let o in __cssModules$8) {
    this[o] = __cssModules$8[o];
  }
}
var TaskCardItem = /* @__PURE__ */ function() {
  return __component__$8.exports;
}();
var render$7 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("article", { staticClass: "task-card" }, [_c("header", { staticClass: "task-card__header" }, [_vm.icon || !!_vm.$slots["header-icon"] ? _c("div", { staticClass: "task-card__icon" }, [_vm._t("header-icon", [_vm.icon ? _c("FancyIcon", { attrs: { "icon": _vm.icon } }) : _vm._e()])], 2) : _vm._e(), _c("div", [_vm._t("header-content", [_c(_vm.titleTag, { tag: "component", staticClass: "task-card__title" }, [_vm._v(" " + _vm._s(_vm.title) + " "), _vm.count !== null ? _c("CounterBadge", { attrs: { "value": _vm.count } }) : _vm._e()], 1), _vm.description ? _c("div", { staticClass: "task-card__description" }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e()])], 2)]), !!_vm.$slots["primary-action"] || _vm.primaryAction ? _c("div", { staticClass: "task-card__primary-action" }, [_vm._t("primary-action", [_vm.primaryAction ? _c("BaseButton", _vm._b({ attrs: { "type": "button" }, on: { "click": _vm.primaryAction.handler } }, "BaseButton", _vm.primaryAction, false)) : _vm._e()])], 2) : _vm._e(), !!_vm.$slots["item-list"] || _vm.items.length ? _c("div", { staticClass: "task-card__items" }, [_vm._t("item-list", _vm._l(_vm.items, function(item) {
    return _c("TaskCardItem", _vm._b({ key: item.id || item.title }, "TaskCardItem", item, false));
  }))], 2) : _vm._e()]);
};
var staticRenderFns$7 = [];
var TaskCard_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$7 = {
  components: { BaseButton, CounterBadge, FancyIcon, TaskCardItem },
  props: {
    count: {
      type: Number,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null,
      validator: (value) => !value || isValidIcon(value)
    },
    items: {
      type: Array,
      default: () => []
    },
    primaryAction: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    titleTag: {
      type: String,
      default: "h2"
    }
  }
};
const __cssModules$7 = {};
var __component__$7 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$7,
  render$7,
  staticRenderFns$7,
  false,
  __vue2_injectStyles$7,
  "37900be4",
  null,
  null
);
function __vue2_injectStyles$7(context) {
  for (let o in __cssModules$7) {
    this[o] = __cssModules$7[o];
  }
}
var TaskCard = /* @__PURE__ */ function() {
  return __component__$7.exports;
}();
var render$6 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", _vm._g(_vm._b({ staticClass: "tight-grid", class: ["tight-grid--" + _vm.width] }, "div", _vm.$attrs, false), _vm.$listeners), [_vm._t("default")], 2);
};
var staticRenderFns$6 = [];
var TightGrid_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$6 = {
  props: {
    width: {
      type: String,
      default: Grid.Widths.AUTO,
      validator: (value) => Object.values(Grid.Widths).includes(value)
    }
  }
};
const __cssModules$6 = {};
var __component__$6 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$6,
  render$6,
  staticRenderFns$6,
  false,
  __vue2_injectStyles$6,
  "14d73c78",
  null,
  null
);
function __vue2_injectStyles$6(context) {
  for (let o in __cssModules$6) {
    this[o] = __cssModules$6[o];
  }
}
var TightGrid = /* @__PURE__ */ function() {
  return __component__$6.exports;
}();
var render$5 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "tool-tip" }, [_c("button", { ref: "trigger", staticClass: "tool-tip__trigger", attrs: { "type": "button", "aria-describedby": "id", "title": _vm.alt }, on: { "click": _vm.toggleTip } }, [_vm._t("trigger", [_c("BaseIcon", { staticClass: "tool-tip__default-icon", attrs: { "icon": _vm.$options.Icons.QUESTION_CIRCLE } })])], 2), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.isTipActive, expression: "isTipActive" }], ref: "content", staticClass: "tool-tip__content", class: "tool-tip__content--" + _vm.variant, attrs: { "id": _vm.id, "role": "tooltip", "tabindex": "-1" }, on: { "focusout": _vm.handleFocusOut, "click": function($event) {
    return _vm.$emit("close");
  } } }, [_vm._t("default", [_vm.title ? _c("div", { staticClass: "tool-tip__title" }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm.message ? _c("div", { staticClass: "tool-tip__message" }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()]), _c("div", { staticClass: "tool-tip__arrow", attrs: { "data-popper-arrow": "" } })], 2)]);
};
var staticRenderFns$5 = [];
var ToolTip_vue_vue_type_style_index_0_scoped_true_lang = "";
const Variants = Object.freeze({
  DARK: "dark",
  LIGHT: "light"
});
const __vue2_script$5 = defineComponent({
  Icons: Icons$1,
  components: { BaseIcon },
  props: {
    alt: {
      type: String,
      default: "Learn more"
    },
    id: {
      type: String,
      default: shortid.generate
    },
    initiallyOpen: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: Variants.DARK,
      validator: (value) => Object.values(Variants).includes(value)
    }
  },
  setup(props2, { emit, refs }) {
    const isTipActive = ref(props2.initiallyOpen);
    const trigger = ref();
    const content = ref();
    const popper2 = ref();
    const handleKeyup = (e) => {
      if (e.keyCode !== 27) {
        return;
      }
      isTipActive.value = false;
    };
    const toggleTip = () => {
      emit("toggleTip");
      isTipActive.value = !isTipActive.value;
      if (isTipActive.value) {
        nextTick(() => {
          const element = document.getElementById(`${props2.id}`);
          element.focus();
        });
      }
    };
    const handlePopper = () => {
      popper2.value = createPopper(trigger.value, content.value, {
        modifiers: [
          {
            name: "arrow",
            options: {
              padding: 4
            }
          },
          {
            name: "offset",
            options: {
              offset: [0, 16]
            }
          }
        ]
      });
    };
    const handleFocusOut = () => {
      setTimeout(() => {
        isTipActive.value = false;
      }, 150);
    };
    onMounted(() => {
      document.addEventListener("keyup", handleKeyup);
      if (!trigger.value && (refs == null ? void 0 : refs.trigger)) {
        trigger.value = refs.trigger;
      }
      if (!content.value && (refs == null ? void 0 : refs.content)) {
        content.value = refs.content;
      }
      if (isTipActive.value) {
        handlePopper();
      }
    });
    onBeforeUnmount(() => {
      document.removeEventListener("keyup", handleKeyup);
      if (popper2.value) {
        popper2.value.destroy();
      }
    });
    watch(isTipActive, () => {
      if (popper2.value)
        return;
      handlePopper();
    });
    return {
      handleFocusOut,
      handleKeyup,
      isTipActive,
      onMounted,
      onBeforeUnmount,
      toggleTip
    };
  }
});
const __cssModules$5 = {};
var __component__$5 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$5,
  render$5,
  staticRenderFns$5,
  false,
  __vue2_injectStyles$5,
  "8fb5ca68",
  null,
  null
);
function __vue2_injectStyles$5(context) {
  for (let o in __cssModules$5) {
    this[o] = __cssModules$5[o];
  }
}
var ToolTip = /* @__PURE__ */ function() {
  return __component__$5.exports;
}();
var render$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("label", { staticClass: "multi-select-item", class: { focused: _vm.isFocused }, on: { "mouseover": function($event) {
    _vm.isHovering = true;
  }, "mouseleave": function($event) {
    _vm.isHovering = false;
  } } }, [_c("input", { staticClass: "multi-select-item__input", attrs: { "type": "checkbox", "name": _vm.name }, domProps: { "value": _vm.value, "checked": _vm.checked }, on: { "blur": function($event) {
    _vm.isFocused = false;
  }, "focus": function($event) {
    _vm.isFocused = true;
  }, "click": function($event) {
    return _vm.$emit("input", $event);
  } } }), _vm.icon ? _c("BaseIcon", { staticClass: "multi-select-item__pre-icon", attrs: { "icon": _vm.icon } }) : _vm._e(), _c("span", { staticClass: "multi-select-item__label" }, [_vm._v(_vm._s(_vm.label))]), _vm.isHovering || _vm.isFocused ? _c("BaseIcon", { staticClass: "multi-select-item__post-icon", attrs: { "icon": _vm.checked ? "close" : "plus" } }) : _vm._e()], 1);
};
var staticRenderFns$4 = [];
var MultiSelectItem_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$4 = {
  components: { BaseIcon },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isFocused: false,
      isHovering: false
    };
  }
};
const __cssModules$4 = {};
var __component__$4 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$4,
  render$4,
  staticRenderFns$4,
  false,
  __vue2_injectStyles$4,
  "497ea81a",
  null,
  null
);
function __vue2_injectStyles$4(context) {
  for (let o in __cssModules$4) {
    this[o] = __cssModules$4[o];
  }
}
var MultiSelectItem = /* @__PURE__ */ function() {
  return __component__$4.exports;
}();
var render$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "two-column-multi-select" }, [_c("div", { staticClass: "two-column-multi-select__unselected-items" }, [_c("div", { staticClass: "two-column-multi-select__column-header" }, [_vm._t("unselected-header", [_vm._v(_vm._s(_vm.unselectedHeader))])], 2), _c("ul", { staticClass: "two-column-multi-select__item-list" }, [_vm.filterable ? _c("li", [_c("TextInput", { staticClass: "search-field", attrs: { "pre-icon": "search", "show-reset": "" }, model: { value: _vm.filter, callback: function($$v) {
    _vm.filter = typeof $$v === "string" ? $$v.trim() : $$v;
  }, expression: "filter" } })], 1) : _vm._e(), _vm._l(_vm.unselectedOptions, function(item) {
    return _c("li", { key: item.value }, [_c("MultiSelectItem", _vm._b({ attrs: { "name": _vm.name, "data-qa": "test-input" }, on: { "input": _vm.handleInput } }, "MultiSelectItem", item, false))], 1);
  })], 2)]), _c("div", { staticClass: "two-column-multi-select__selected-items" }, [_c("div", { staticClass: "two-column-multi-select__column-header" }, [_vm._t("selected-header", [_vm._v(_vm._s(_vm.selectedHeader))])], 2), _c("ul", { staticClass: "two-column-multi-select__item-list" }, _vm._l(_vm.selectedOptions, function(item) {
    return _c("li", { key: item.value }, [_c("MultiSelectItem", _vm._b({ attrs: { "data-qa": "test-input", "name": _vm.name, "checked": "" }, on: { "input": _vm.handleInput } }, "MultiSelectItem", item, false))], 1);
  }), 0)])]);
};
var staticRenderFns$3 = [];
var TwoColumnMultiSelect_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$3 = defineComponent({
  components: { MultiSelectItem, TextInput },
  props: {
    filterable: {
      type: Boolean,
      default: false
    },
    initialFilter: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: shortid.generate
    },
    options: {
      type: Array,
      default: () => []
    },
    selectedHeader: {
      type: String,
      default: "Selected"
    },
    unselectedHeader: {
      type: String,
      default: "Options"
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  setup(props2, { emit }) {
    const filter = ref(props2.initialFilter);
    const selectedOptions = computed(() => {
      return props2.value.map(
        (value) => props2.options.find((item) => item.value === value)
      );
    });
    const unselectedOptions = computed(() => {
      return props2.options.filter(
        (item) => !props2.value.includes(item.value) && (!props2.filterable || props2.filterable && item.label.toLowerCase().includes(filter.value.toLowerCase().trim()))
      );
    });
    const handleInput = (e) => {
      const { checked, value } = e.target;
      const newValue = checked ? [...props2.value, value] : props2.value.filter((item) => item !== value);
      emit("input", newValue);
    };
    return {
      filter,
      selectedOptions,
      unselectedOptions,
      handleInput
    };
  }
});
const __cssModules$3 = {};
var __component__$3 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$3,
  render$3,
  staticRenderFns$3,
  false,
  __vue2_injectStyles$3,
  "63614594",
  null,
  null
);
function __vue2_injectStyles$3(context) {
  for (let o in __cssModules$3) {
    this[o] = __cssModules$3[o];
  }
}
var TwoColumnMultiSelect = /* @__PURE__ */ function() {
  return __component__$3.exports;
}();
var render$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tag, _vm._g(_vm._b({ tag: "component", staticClass: "type-heading", class: ["type-heading-" + _vm.variant, "type-heading-" + _vm.variant + "--" + _vm.weight] }, "component", _vm.$attrs, false), _vm.$listeners), [_vm._t("default")], 2);
};
var staticRenderFns$2 = [];
var TypeHeading_vue_vue_type_style_index_0_lang = "";
const { Heading, Weights } = Typography;
const __vue2_script$2 = {
  props: {
    tag: {
      type: String,
      default: "span"
    },
    variant: {
      type: String,
      default: Typography.Heading.HEADLINE,
      validator: (value) => Object.values(Heading).includes(value)
    },
    weight: {
      type: String,
      default: Typography.Weights.STRONG,
      validator: (value) => [Weights.REGULAR, Weights.STRONG].includes(value)
    }
  }
};
const __cssModules$2 = {};
var __component__$2 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$2,
  render$2,
  staticRenderFns$2,
  false,
  __vue2_injectStyles$2,
  null,
  null,
  null
);
function __vue2_injectStyles$2(context) {
  for (let o in __cssModules$2) {
    this[o] = __cssModules$2[o];
  }
}
var TypeHeading = /* @__PURE__ */ function() {
  return __component__$2.exports;
}();
var __vue2_script$1 = defineComponent({
  name: "UserSelectInputOptionItem",
  components: {
    AvatarImage,
    TypeBody
  },
  props: {
    image: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    }
  }
});
var render$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "user-select-option-item flex items-center" }, [_c("AvatarImage", { staticClass: "flex-shrink-0 mr-3", attrs: { "image": _vm.image, "name": _vm.label, "data-qa": "user-select-input-item-avatar" } }), _c("div", [_c("TypeBody", { attrs: { "variant": "text", "weight": "strong", "tag": "div" } }, [_vm._v(" " + _vm._s(_vm.label) + " ")]), _c("TypeBody", { staticClass: "text-base-600", attrs: { "variant": "text", "weight": "regular", "tag": "div" } }, [_vm._v(" " + _vm._s(_vm.title) + " ")])], 1)], 1);
};
var staticRenderFns$1 = [];
const __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1,
  render$1,
  staticRenderFns$1,
  false,
  __vue2_injectStyles$1,
  null,
  null,
  null
);
function __vue2_injectStyles$1(context) {
  for (let o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
var UserSelectInputOptionItem = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var render2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("FormField", { staticClass: "user-select-input", class: [
    "user-select-input--" + _vm.size,
    {
      "user-select-input--invalid": _vm.invalid || _vm.error,
      "user-select-input--disabled": _vm.disabled
    }
  ], attrs: { "id": _vm.id, "size": _vm.size, "label": _vm.label, "error": _vm.error, "invalid": _vm.invalid, "disabled": _vm.disabled } }, [_c("VSelect", _vm._b({ staticClass: "v-select", attrs: { "append-to-body": "", "calculate-position": _vm.withPopper, "data-qa": "select-dropdown-input" }, on: { "input": _vm.handleInput }, scopedSlots: _vm._u([{ key: "selected-option-container", fn: function(ref2) {
    var deselect = ref2.deselect;
    var option = ref2.option;
    return [_vm.multiple ? _c("BaseChip", { staticClass: "select-input__selected", attrs: { "variant": _vm.$options.ChipVariants.FILLED, "show-reset": "" }, on: { "reset": function($event) {
      return deselect(option);
    } } }, [_vm._v(" " + _vm._s(option.label) + " ")]) : _c("div", { staticClass: "select-input__selected" }, [_vm._v(" " + _vm._s(option.label) + " ")])];
  } }, { key: "option", fn: function(ref2) {
    var label = ref2.label;
    var title2 = ref2.title;
    var image = ref2.image;
    return [_c("UserSelectInputOptionItem", { attrs: { "image": image, "label": label, "title": title2 } })];
  } }, { key: "no-options", fn: function(ref2) {
    var searching = ref2.searching;
    return [searching ? [_c("div", { staticClass: "px-8 py-4" }, [_c("TypeBody", { attrs: { "variant": "text", "tag": "div" } }, [_vm._v(" We couldn\u2019t find any options that match your search. Try checking your spelling or clear the search and scroll through all options. ")])], 1)] : _vm._e()];
  } }]) }, "VSelect", _vm.passDownProps, false))], 1);
};
var staticRenderFns = [];
var UserSelectInput_vue_vue_type_style_index_0_scoped_true_lang = "";
var UserSelectInput_vue_vue_type_style_index_1_lang = "";
const components = {
  Deselect: {
    render: () => h(BaseIcon, { props: { icon: Icons$1.CLOSE } })
  },
  OpenIndicator: {
    render: () => h(BaseIcon, { props: { icon: Icons$1.CARET_DOWN } })
  }
};
const __vue2_script = defineComponent({
  ChipVariants: Variants$4,
  components: {
    BaseChip,
    FormField,
    TypeBody,
    UserSelectInputOptionItem,
    VSelect
  },
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: shortid.generate
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    showReset: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: Form.Sizes.NORMAL,
      validator: (value) => Object.values(Form.Sizes).includes(value)
    },
    value: {
      type: [String, Array],
      default: null
    }
  },
  computed: {
    mappedOptions() {
      return mapOptions(this.options);
    },
    mappedValue() {
      return this.multiple ? (this.value || []).map(
        (val) => this.mappedOptions.find(({ value }) => value === val)
      ) : this.mappedOptions.find(({ value }) => value === this.value);
    },
    passDownProps() {
      return {
        ...this.$attrs,
        clearable: this.showReset,
        components,
        disabled: this.disabled,
        multiple: this.multiple,
        options: this.mappedOptions,
        value: this.mappedValue
      };
    }
  },
  methods: {
    handleInput(e) {
      let val = "";
      if (this.multiple) {
        val = e.map(({ value }) => value);
      } else if (e && e.value) {
        val = e.value;
      }
      this.$emit("input", val);
    },
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width;
      dropdownList.classList.add("style-list-item");
      const popper2 = createPopper(component.$refs.toggle, dropdownList, {
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 16]
            }
          }
        ]
      });
      return () => popper2.destroy();
    }
  }
});
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(
  __vue2_script,
  render2,
  staticRenderFns,
  false,
  __vue2_injectStyles,
  "585984e3",
  null,
  null
);
function __vue2_injectStyles(context) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var UserSelectInput = /* @__PURE__ */ function() {
  return __component__.exports;
}();
function getComponentProps(Component) {
  return (props2) => props2;
}
const constants = {
  Alert,
  Button,
  Form,
  InputMasks,
  Modal,
  Notification,
  ProgressBar: ProgressBar$1,
  Typography,
  theme: {
    default: {
      ...theme
    }
  }
};
export { AlertModal, AnnularThrobber, AvatarImage, BaseBanner, BaseButton, BaseCard, BaseChip, BaseDivider, BaseForm, BaseIcon, BaseLink, BaseTable, BaseTag, BaseWizard, BlockCheckGroup, BlockRadioGroup, BlockSelector, CheckboxGroup, CheckboxInput, CounterBadge, CountersignIcon, DataTable, DateInput, DrawerPanel, FancyCard, FancyIcon, HamburgerButton, HighlightedIcon, IconButton, LooseGrid, MeerkatNotification, MeerkatNotifications, ModalDialog, NumberInput, PaginationNavigation, PasswordInput, PhoneInput, PopoverMenu, ProgressBar, ProgressIcon, ProgressStepper, RadioGroup, RadioInput, RadioToggle, SelectInput, SurveyCard, SwitchGroup, SwitchInput, TabControls, TabSet, TaskCard, TextInput, TextareaInput, TightGrid, ToolTip, TwoColumnMultiSelect, TypeBody, TypeDisplay, TypeHeading, TypeOverline, UserAvatar, UserSelectInput, constants, getComponentProps };
